/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(242);
	module.exports = __webpack_require__(595);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(708);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.acos = acos;
	exports.asin = asin;
	exports.haversin = haversin;
	var epsilon = exports.epsilon = 1e-6;
	var epsilon2 = exports.epsilon2 = 1e-12;
	var pi = exports.pi = Math.PI;
	var halfPi = exports.halfPi = pi / 2;
	var quarterPi = exports.quarterPi = pi / 4;
	var tau = exports.tau = pi * 2;
	
	var degrees = exports.degrees = 180 / pi;
	var radians = exports.radians = pi / 180;
	
	var abs = exports.abs = Math.abs;
	var atan = exports.atan = Math.atan;
	var atan2 = exports.atan2 = Math.atan2;
	var cos = exports.cos = Math.cos;
	var ceil = exports.ceil = Math.ceil;
	var exp = exports.exp = Math.exp;
	var floor = exports.floor = Math.floor;
	var log = exports.log = Math.log;
	var pow = exports.pow = Math.pow;
	var sin = exports.sin = Math.sin;
	var sign = exports.sign = Math.sign || function (x) {
	  return x > 0 ? 1 : x < 0 ? -1 : 0;
	};
	var sqrt = exports.sqrt = Math.sqrt;
	var tan = exports.tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin(x / 2)) * x;
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (specifier) {
	  var n = specifier.length / 6 | 0,
	      colors = new Array(n),
	      i = 0;
	  while (i < n) {
	    colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
	  }return colors;
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormattedHTMLMessage = exports.FormattedMessage = exports.FormattedPlural = exports.FormattedNumber = exports.FormattedRelative = exports.FormattedTime = exports.FormattedDate = exports.IntlProvider = exports.defineMessages = exports.injectIntl = exports.intlShape = exports.addLocaleData = undefined;
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                                * Copyright 2017, Yahoo Inc.
	                                                                                                                                                                                                                                                                                * Copyrights licensed under the New BSD License.
	                                                                                                                                                                                                                                                                                * See the accompanying LICENSE file for terms.
	                                                                                                                                                                                                                                                                                */
	
	var _index = __webpack_require__(736);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _intlMessageformat = __webpack_require__(223);
	
	var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);
	
	var _intlRelativeformat = __webpack_require__(645);
	
	var _intlRelativeformat2 = _interopRequireDefault(_intlRelativeformat);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _intlFormatCache = __webpack_require__(635);
	
	var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var locales = Array.isArray(data) ? data : [data];
	
	  locales.forEach(function (localeData) {
	    if (localeData && localeData.locale) {
	      _intlMessageformat2.default.__addLocaleData(localeData);
	      _intlRelativeformat2.default.__addLocaleData(localeData);
	    }
	  });
	}
	
	function hasLocaleData(locale) {
	  var localeParts = (locale || '').split('-');
	
	  while (localeParts.length > 0) {
	    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	      return true;
	    }
	
	    localeParts.pop();
	  }
	
	  return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	  var normalizedLocale = locale && locale.toLowerCase();
	
	  return !!(_intlMessageformat2.default.__localeData__[normalizedLocale] && _intlRelativeformat2.default.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	};
	
	var classCallCheck = function classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineProperty = function defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	var toConsumableArray = function toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = _propTypes2.default.bool;
	var number = _propTypes2.default.number;
	var string = _propTypes2.default.string;
	var func = _propTypes2.default.func;
	var object = _propTypes2.default.object;
	var oneOf = _propTypes2.default.oneOf;
	var shape = _propTypes2.default.shape;
	var any = _propTypes2.default.any;
	var oneOfType = _propTypes2.default.oneOfType;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	  locale: string,
	  formats: object,
	  messages: object,
	  textComponent: any,
	
	  defaultLocale: string,
	  defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	  formatDate: funcReq,
	  formatTime: funcReq,
	  formatRelative: funcReq,
	  formatNumber: funcReq,
	  formatPlural: funcReq,
	  formatMessage: funcReq,
	  formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	  formatters: object,
	  now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	  id: string.isRequired,
	  description: oneOfType([string, object]),
	  defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	  localeMatcher: localeMatcher,
	  formatMatcher: oneOf(['basic', 'best fit']),
	
	  timeZone: string,
	  hour12: bool,
	
	  weekday: narrowShortLong,
	  era: narrowShortLong,
	  year: numeric2digit,
	  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	  day: numeric2digit,
	  hour: numeric2digit,
	  minute: numeric2digit,
	  second: numeric2digit,
	  timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	  localeMatcher: localeMatcher,
	
	  style: oneOf(['decimal', 'currency', 'percent']),
	  currency: string,
	  currencyDisplay: oneOf(['symbol', 'code', 'name']),
	  useGrouping: bool,
	
	  minimumIntegerDigits: number,
	  minimumFractionDigits: number,
	  maximumFractionDigits: number,
	  minimumSignificantDigits: number,
	  maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	  style: oneOf(['best fit', 'numeric']),
	  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	  style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  "'": '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	    return ESCAPED_CHARS[match];
	  });
	}
	
	function filterProps(props, whitelist) {
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return whitelist.reduce(function (filtered, name) {
	    if (props.hasOwnProperty(name)) {
	      filtered[name] = props[name];
	    } else if (defaults$$1.hasOwnProperty(name)) {
	      filtered[name] = defaults$$1[name];
	    }
	
	    return filtered;
	  }, {});
	}
	
	function invariantIntlContext() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      intl = _ref.intl;
	
	  (0, _invariant2.default)(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	  var props = _ref2.props,
	      state = _ref2.state,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === undefined ? {} : _ref2$context;
	  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var _context$intl = context.intl,
	      intl = _context$intl === undefined ? {} : _context$intl;
	  var _nextContext$intl = nextContext.intl,
	      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	  return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$intlPropName = options.intlPropName,
	      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var InjectIntl = function (_Component) {
	    inherits(InjectIntl, _Component);
	
	    function InjectIntl(props, context) {
	      classCallCheck(this, InjectIntl);
	
	      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	      invariantIntlContext(context);
	      return _this;
	    }
	
	    createClass(InjectIntl, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	          ref: withRef ? 'wrappedInstance' : null
	        }));
	      }
	    }]);
	    return InjectIntl;
	  }(_react.Component);
	
	  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	  InjectIntl.contextTypes = {
	    intl: intlShape
	  };
	  InjectIntl.WrappedComponent = WrappedComponent;
	
	  return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	  return _intlMessageformat2.default.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	  return _intlMessageformat2.default.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, IntlPluralFormat);
	
	  var useOrdinal = options.style === 'ordinal';
	  var pluralFn = findPluralFunction(resolveLocale(locales));
	
	  this.format = function (value) {
	    return pluralFn(value, useOrdinal);
	  };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	  second: 60, // seconds to minute
	  minute: 60, // minutes to hour
	  hour: 24, // hours to day
	  day: 30, // days to month
	  month: 12 // months to year
	};
	
	function updateRelativeFormatThresholds(newThresholds) {
	  var thresholds = _intlRelativeformat2.default.thresholds;
	  thresholds.second = newThresholds.second;
	  thresholds.minute = newThresholds.minute;
	  thresholds.hour = newThresholds.hour;
	  thresholds.day = newThresholds.day;
	  thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	  var format = formats && formats[type] && formats[type][name];
	  if (format) {
	    return format;
	  }
	
	  if (false) {
	    console.error('[React Intl] No ' + type + ' format named: ' + name);
	  }
	}
	
	function formatDate(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	  var date = new Date(value);
	  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting date.\n' + e);
	    }
	  }
	
	  return String(date);
	}
	
	function formatTime(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	  var date = new Date(value);
	  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	    // Add default formatting options if hour, minute, or second isn't defined.
	    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	  }
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting time.\n' + e);
	    }
	  }
	
	  return String(date);
	}
	
	function formatRelative(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	  var date = new Date(value);
	  var now = new Date(options.now);
	  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
	  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	  // Capture the current threshold values, then temporarily override them with
	  // specific values just for this render.
	  var oldThresholds = _extends({}, _intlRelativeformat2.default.thresholds);
	  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	  try {
	    return state.getRelativeFormat(locale, filteredOptions).format(date, {
	      now: isFinite(now) ? now : state.now()
	    });
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting relative time.\n' + e);
	    }
	  } finally {
	    updateRelativeFormatThresholds(oldThresholds);
	  }
	
	  return String(date);
	}
	
	function formatNumber(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
	  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getNumberFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting number.\n' + e);
	    }
	  }
	
	  return String(value);
	}
	
	function formatPlural(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale;
	
	  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	  try {
	    return state.getPluralFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting plural.\n' + e);
	    }
	  }
	
	  return 'other';
	}
	
	function formatMessage(config, state) {
	  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      messages = config.messages,
	      defaultLocale = config.defaultLocale,
	      defaultFormats = config.defaultFormats;
	  var id = messageDescriptor.id,
	      defaultMessage = messageDescriptor.defaultMessage;
	
	  // `id` is a required field of a Message Descriptor.
	
	  (0, _invariant2.default)(id, '[React Intl] An `id` must be provided to format a message.');
	
	  var message = messages && messages[id];
	  var hasValues = Object.keys(values).length > 0;
	
	  // Avoid expensive message formatting for simple messages without values. In
	  // development messages will always be formatted in case of missing values.
	  if (!hasValues && ("production") === 'production') {
	    return message || defaultMessage || id;
	  }
	
	  var formattedMessage = void 0;
	
	  if (message) {
	    try {
	      var formatter = state.getMessageFormat(message, locale, formats);
	
	      formattedMessage = formatter.format(values);
	    } catch (e) {
	      if (false) {
	        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	      }
	    }
	  } else {
	    if (false) {
	      // This prevents warnings from littering the console in development
	      // when no `messages` are passed into the <IntlProvider> for the
	      // default locale, and a default message is in the source.
	      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	      }
	    }
	  }
	
	  if (!formattedMessage && defaultMessage) {
	    try {
	      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	      formattedMessage = _formatter.format(values);
	    } catch (e) {
	      if (false) {
	        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	      }
	    }
	  }
	
	  if (!formattedMessage) {
	    if (false) {
	      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	    }
	  }
	
	  return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  // Process all the values before they are used when formatting the ICU
	  // Message string. Since the formatted message might be injected via
	  // `innerHTML`, all String-based values need to be HTML-escaped.
	  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	    var value = rawValues[name];
	    escaped[name] = typeof value === 'string' ? escape(value) : value;
	    return escaped;
	  }, {});
	
	  return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	var format = Object.freeze({
	  formatDate: formatDate,
	  formatTime: formatTime,
	  formatRelative: formatRelative,
	  formatNumber: formatNumber,
	  formatPlural: formatPlural,
	  formatMessage: formatMessage,
	  formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	  formats: {},
	  messages: {},
	  textComponent: 'span',
	
	  defaultLocale: 'en',
	  defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	  inherits(IntlProvider, _Component);
	
	  function IntlProvider(props) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlProvider);
	
	    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	    (0, _invariant2.default)(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	    var intlContext = context.intl;
	
	    // Used to stabilize time when performing an initial rendering so that
	    // all relative times use the same reference "now" time.
	
	    var initialNow = void 0;
	    if (isFinite(props.initialNow)) {
	      initialNow = Number(props.initialNow);
	    } else {
	      // When an `initialNow` isn't provided via `props`, look to see an
	      // <IntlProvider> exists in the ancestry and call its `now()`
	      // function to propagate its value for "now".
	      initialNow = intlContext ? intlContext.now() : Date.now();
	    }
	
	    // Creating `Intl*` formatters is expensive. If there's a parent
	    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	    // memoize the `Intl*` constructors and cache them for the lifecycle of
	    // this IntlProvider instance.
	
	    var _ref = intlContext || {},
	        _ref$formatters = _ref.formatters,
	        formatters = _ref$formatters === undefined ? {
	      getDateTimeFormat: (0, _intlFormatCache2.default)(Intl.DateTimeFormat),
	      getNumberFormat: (0, _intlFormatCache2.default)(Intl.NumberFormat),
	      getMessageFormat: (0, _intlFormatCache2.default)(_intlMessageformat2.default),
	      getRelativeFormat: (0, _intlFormatCache2.default)(_intlRelativeformat2.default),
	      getPluralFormat: (0, _intlFormatCache2.default)(IntlPluralFormat)
	    } : _ref$formatters;
	
	    _this.state = _extends({}, formatters, {
	
	      // Wrapper to provide stable "now" time for initial render.
	      now: function now() {
	        return _this._didDisplay ? Date.now() : initialNow;
	      }
	    });
	    return _this;
	  }
	
	  createClass(IntlProvider, [{
	    key: 'getConfig',
	    value: function getConfig() {
	      var intlContext = this.context.intl;
	
	      // Build a whitelisted config object from `props`, defaults, and
	      // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	      // Apply default props. This must be applied last after the props have
	      // been resolved and inherited from any <IntlProvider> in the ancestry.
	      // This matches how React resolves `defaultProps`.
	      for (var propName in defaultProps) {
	        if (config[propName] === undefined) {
	          config[propName] = defaultProps[propName];
	        }
	      }
	
	      if (!hasLocaleData(config.locale)) {
	        var _config = config,
	            locale = _config.locale,
	            defaultLocale = _config.defaultLocale,
	            defaultFormats = _config.defaultFormats;
	
	        if (false) {
	          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	        }
	
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        config = _extends({}, config, {
	          locale: defaultLocale,
	          formats: defaultFormats,
	          messages: defaultProps.messages
	        });
	      }
	
	      return config;
	    }
	  }, {
	    key: 'getBoundFormatFns',
	    value: function getBoundFormatFns(config, state) {
	      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	        boundFormatFns[name] = format[name].bind(null, config, state);
	        return boundFormatFns;
	      }, {});
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var config = this.getConfig();
	
	      // Bind intl factories and current config to the format functions.
	      var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	      var _state = this.state,
	          now = _state.now,
	          formatters = objectWithoutProperties(_state, ['now']);
	
	      return {
	        intl: _extends({}, config, boundFormatFns, {
	          formatters: formatters,
	          now: now
	        })
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._didDisplay = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	  return IntlProvider;
	}(_react.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	  intl: intlShape
	};
	IntlProvider.childContextTypes = {
	  intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	  children: _propTypes2.default.element.isRequired,
	  initialNow: _propTypes2.default.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	  inherits(FormattedDate, _Component);
	
	  function FormattedDate(props, context) {
	    classCallCheck(this, FormattedDate);
	
	    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedDate, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatDate = _context$intl.formatDate,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	      var formattedDate = formatDate(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedDate);
	      }
	
	      return _react2.default.createElement(Text, null, formattedDate);
	    }
	  }]);
	  return FormattedDate;
	}(_react.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: _propTypes2.default.any.isRequired,
	  format: _propTypes2.default.string,
	  children: _propTypes2.default.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	  inherits(FormattedTime, _Component);
	
	  function FormattedTime(props, context) {
	    classCallCheck(this, FormattedTime);
	
	    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedTime, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatTime = _context$intl.formatTime,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	      var formattedTime = formatTime(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedTime);
	      }
	
	      return _react2.default.createElement(Text, null, formattedTime);
	    }
	  }]);
	  return FormattedTime;
	}(_react.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: _propTypes2.default.any.isRequired,
	  format: _propTypes2.default.string,
	  children: _propTypes2.default.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	  var absDelta = Math.abs(delta);
	
	  if (absDelta < MINUTE) {
	    return 'second';
	  }
	
	  if (absDelta < HOUR) {
	    return 'minute';
	  }
	
	  if (absDelta < DAY) {
	    return 'hour';
	  }
	
	  // The maximum scheduled delay will be measured in days since the maximum
	  // timer delay is less than the number of milliseconds in 25 days.
	  return 'day';
	}
	
	function getUnitDelay(units) {
	  switch (units) {
	    case 'second':
	      return SECOND;
	    case 'minute':
	      return MINUTE;
	    case 'hour':
	      return HOUR;
	    case 'day':
	      return DAY;
	    default:
	      return MAX_TIMER_DELAY;
	  }
	}
	
	function isSameDate(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  var aTime = new Date(a).getTime();
	  var bTime = new Date(b).getTime();
	
	  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	  inherits(FormattedRelative, _Component);
	
	  function FormattedRelative(props, context) {
	    classCallCheck(this, FormattedRelative);
	
	    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	    invariantIntlContext(context);
	
	    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	    // `now` is stored as state so that `render()` remains a function of
	    // props + state, instead of accessing `Date.now()` inside `render()`.
	    _this.state = { now: now };
	    return _this;
	  }
	
	  createClass(FormattedRelative, [{
	    key: 'scheduleNextUpdate',
	    value: function scheduleNextUpdate(props, state) {
	      var _this2 = this;
	
	      // Cancel and pending update because we're scheduling a new update.
	      clearTimeout(this._timer);
	
	      var value = props.value,
	          units = props.units,
	          updateInterval = props.updateInterval;
	
	      var time = new Date(value).getTime();
	
	      // If the `updateInterval` is falsy, including `0` or we don't have a
	      // valid date, then auto updates have been turned off, so we bail and
	      // skip scheduling an update.
	      if (!updateInterval || !isFinite(time)) {
	        return;
	      }
	
	      var delta = time - state.now;
	      var unitDelay = getUnitDelay(units || selectUnits(delta));
	      var unitRemainder = Math.abs(delta % unitDelay);
	
	      // We want the largest possible timer delay which will still display
	      // accurate information while reducing unnecessary re-renders. The delay
	      // should be until the next "interesting" moment, like a tick from
	      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	      this._timer = setTimeout(function () {
	        _this2.setState({ now: _this2.context.intl.now() });
	      }, delay);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleNextUpdate(this.props, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var nextValue = _ref.value;
	
	      // When the `props.value` date changes, `state.now` needs to be updated,
	      // and the next update can be rescheduled.
	      if (!isSameDate(nextValue, this.props.value)) {
	        this.setState({ now: this.context.intl.now() });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.scheduleNextUpdate(nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatRelative = _context$intl.formatRelative,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	      if (typeof children === 'function') {
	        return children(formattedRelative);
	      }
	
	      return _react2.default.createElement(Text, null, formattedRelative);
	    }
	  }]);
	  return FormattedRelative;
	}(_react.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	  intl: intlShape
	};
	FormattedRelative.defaultProps = {
	  updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	  value: _propTypes2.default.any.isRequired,
	  format: _propTypes2.default.string,
	  updateInterval: _propTypes2.default.number,
	  initialNow: _propTypes2.default.any,
	  children: _propTypes2.default.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	  inherits(FormattedNumber, _Component);
	
	  function FormattedNumber(props, context) {
	    classCallCheck(this, FormattedNumber);
	
	    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedNumber, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatNumber = _context$intl.formatNumber,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	      var formattedNumber = formatNumber(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedNumber);
	      }
	
	      return _react2.default.createElement(Text, null, formattedNumber);
	    }
	  }]);
	  return FormattedNumber;
	}(_react.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	  value: _propTypes2.default.any.isRequired,
	  format: _propTypes2.default.string,
	  children: _propTypes2.default.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	  inherits(FormattedPlural, _Component);
	
	  function FormattedPlural(props, context) {
	    classCallCheck(this, FormattedPlural);
	
	    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedPlural, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatPlural = _context$intl.formatPlural,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          other = _props.other,
	          children = _props.children;
	
	      var pluralCategory = formatPlural(value, this.props);
	      var formattedPlural = this.props[pluralCategory] || other;
	
	      if (typeof children === 'function') {
	        return children(formattedPlural);
	      }
	
	      return _react2.default.createElement(Text, null, formattedPlural);
	    }
	  }]);
	  return FormattedPlural;
	}(_react.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	  intl: intlShape
	};
	FormattedPlural.defaultProps = {
	  style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	  value: _propTypes2.default.any.isRequired,
	
	  other: _propTypes2.default.node.isRequired,
	  zero: _propTypes2.default.node,
	  one: _propTypes2.default.node,
	  two: _propTypes2.default.node,
	  few: _propTypes2.default.node,
	  many: _propTypes2.default.node,
	
	  children: _propTypes2.default.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedMessage = function (_Component) {
	  inherits(FormattedMessage, _Component);
	
	  function FormattedMessage(props, context) {
	    classCallCheck(this, FormattedMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatMessage = _context$intl.formatMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          values = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	      var tokenDelimiter = void 0;
	      var tokenizedValues = void 0;
	      var elements = void 0;
	
	      var hasValues = values && Object.keys(values).length > 0;
	      if (hasValues) {
	        // Creates a token with a random UID that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	        var generateToken = function () {
	          var counter = 0;
	          return function () {
	            return 'ELEMENT-' + uid + '-' + (counter += 1);
	          };
	        }();
	
	        // Splitting with a delimiter to support IE8. When using a regex
	        // with a capture group IE8 does not include the capture group in
	        // the resulting array.
	        tokenDelimiter = '@__' + uid + '__@';
	        tokenizedValues = {};
	        elements = {};
	
	        // Iterates over the `props` to keep track of any React Element
	        // values so they can be represented by the `token` as a placeholder
	        // when the `message` is formatted. This allows the formatted
	        // message to then be broken-up into parts with references to the
	        // React Elements inserted back in.
	        Object.keys(values).forEach(function (name) {
	          var value = values[name];
	
	          if ((0, _react.isValidElement)(value)) {
	            var token = generateToken();
	            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	            elements[token] = value;
	          } else {
	            tokenizedValues[name] = value;
	          }
	        });
	      }
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	      var nodes = void 0;
	
	      var hasElements = elements && Object.keys(elements).length > 0;
	      if (hasElements) {
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while
	        // keeping React's virtual diffing working properly.
	        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	          return !!part;
	        }).map(function (part) {
	          return elements[part] || part;
	        });
	      } else {
	        nodes = [formattedMessage];
	      }
	
	      if (typeof children === 'function') {
	        return children.apply(undefined, toConsumableArray(nodes));
	      }
	
	      // Needs to use `createElement()` instead of JSX, otherwise React will
	      // warn about a missing `key` prop with rich-text message formatting.
	      return _react.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	    }
	  }]);
	  return FormattedMessage;
	}(_react.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: _propTypes2.default.object,
	  tagName: _propTypes2.default.string,
	  children: _propTypes2.default.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	  inherits(FormattedHTMLMessage, _Component);
	
	  function FormattedHTMLMessage(props, context) {
	    classCallCheck(this, FormattedHTMLMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedHTMLMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatHTMLMessage = _context$intl.formatHTMLMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          rawValues = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	      if (typeof children === 'function') {
	        return children(formattedHTMLMessage);
	      }
	
	      // Since the message presumably has HTML in it, we need to set
	      // `innerHTML` in order for it to be rendered and not escaped by React.
	      // To be safe, all string prop values were escaped when formatting the
	      // message. It is assumed that the message is not UGC, and came from the
	      // developer making it more like a template.
	      //
	      // Note: There's a perf impact of using this component since there's no
	      // way for React to do its virtual DOM diffing.
	      var html = { __html: formattedHTMLMessage };
	      return _react2.default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	    }
	  }]);
	  return FormattedHTMLMessage;
	}(_react.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: _propTypes2.default.object,
	  tagName: _propTypes2.default.string,
	  children: _propTypes2.default.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(_index2.default);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (scheme) {
	  return (0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);
	};
	
	var _d3Interpolate = __webpack_require__(14);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Api = __webpack_require__(31);
	
	var helpers = {
	
	    eventLog: function eventLog(this1) {
	        var vals = this1.split(/ *\- */g); // " - " split
	        var key = vals.shift();
	        var key2 = encodeURIComponent("webapp:" + key);
	        var vals2 = encodeURIComponent(JSON.stringify(vals));
	
	        var url = "https://ikids-admin.reportback.org/report/survey?key=" + key2 + "&value=" + vals2 + "&useapi=1"; //+"&access_code="+access_code;
	
	        //d3.text(url); // old
	        var thepromise = _Api.Api.getURL(url); // new
	        // console.log("PROMISE")
	        // console.log(thepromise);
	        // console.log("eventLog('"+key+"')=>" + JSON.stringify(vals));
	    },
	
	    convertGroupName: function convertGroupName(name) {
	        return name === "Sunscreen Chemicals" ? "sunscreen" : name.toLowerCase().replace(' ', '_');
	    },
	
	    findGetParameter: function findGetParameter(parameterName) {
	        var result = null,
	            tmp = [];
	        var items = location.search.substr(1).split("&");
	        for (var index = 0; index < items.length; index++) {
	            tmp = items[index].split("=");
	            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	        }
	        return result;
	    },
	
	    localstorage2querystring: function localstorage2querystring() {
	        var params = JSON.parse(JSON.stringify(window.localStorage));
	        var queryString = Object.keys(params).map(function (key) {
	            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	        }).join('&');
	        return queryString;
	    },
	
	    houseORavatar: function houseORavatar(avatar, group) {
	        return this.avatarName(avatar, group);
	    },
	
	    benchmarkName: function benchmarkName(chemicalGroup) {
	        var bm = "us_median"; //default -- us.svg
	        if (chemicalGroup === 'Water CVOCs') bm = "max_level"; // graph-blue-star.png
	        if (chemicalGroup === 'Water Phthalates') bm = ""; // there is no benchmark
	        return bm;
	    },
	
	    showVisitBadges: function showVisitBadges(chemicalGroup) {
	        return chemicalGroup !== 'Water CVOCs' && chemicalGroup !== 'Water Phthalates';
	    },
	
	    avatarName: function avatarName(avatar, group) {
	        return !this.showVisitBadges(group) ? 'house' : avatar;
	    },
	
	    getIconColor: function getIconColor(group, intl) {
	        var colors = {
	            blue: "#39A9DB",
	            yellow: "#F0C414",
	            purple: "#801A86",
	            green: "#618B25",
	            red: "#D63230",
	            orange: "#E9724C",
	            pink: "#F14196",
	            gray: "#949B96",
	            brown: "#843B0B",
	            black: "#000000"
	        };
	
	        var colorName = intl.messages['chemicals.' + group + '.color'];
	        var hexColor = intl.messages['chemicals.' + group + '.colorHex'];
	
	        if (!hexColor) {
	            // the researcher didn't define a hex color
	            if (colorName) {
	                // the researcher defined a color name instead
	                hexColor = colors[colorName];
	            } else {
	                // no color defined
	                // need to get a unique index for this chemical;
	                var allPages = Object.keys(intl.messages);
	                var allGroups = [];
	                for (var i = 0; i < allPages.length; i++) {
	                    var page = allPages[i];
	                    if (page.includes("chemicals.") && page.includes(".title")) {
	                        allGroups.push(page);
	                    }
	                }
	                var index = 0;
	                for (var _i = 0; _i < allGroups.length; _i++) {
	                    if (allGroups[_i].includes(group)) {
	                        index = _i;
	                    }
	                }
	
	                // now get the color with the key
	                var autoColor = Object.keys(colors)[index];
	                hexColor = colors[autoColor];
	            }
	        }
	        return hexColor;
	    }
	
	}; // helpers.js
	
	//import * as d3 from 'd3';
	
	if (typeof window !== 'undefined') {
	    window.helpers = helpers;
	}
	
	exports.default = helpers;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var YAMLException = __webpack_require__(54);
	
	var TYPE_CONSTRUCTOR_OPTIONS = ['kind', 'resolve', 'construct', 'instanceOf', 'predicate', 'represent', 'defaultStyle', 'styleAliases'];
	
	var YAML_NODE_KINDS = ['scalar', 'sequence', 'mapping'];
	
	function compileStyleAliases(map) {
	  var result = {};
	
	  if (map !== null) {
	    Object.keys(map).forEach(function (style) {
	      map[style].forEach(function (alias) {
	        result[String(alias)] = style;
	      });
	    });
	  }
	
	  return result;
	}
	
	function Type(tag, options) {
	  options = options || {};
	
	  Object.keys(options).forEach(function (name) {
	    if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) {
	      throw new YAMLException('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
	    }
	  });
	
	  // TODO: Add tag format check.
	  this.tag = tag;
	  this.kind = options['kind'] || null;
	  this.resolve = options['resolve'] || function () {
	    return true;
	  };
	  this.construct = options['construct'] || function (data) {
	    return data;
	  };
	  this.instanceOf = options['instanceOf'] || null;
	  this.predicate = options['predicate'] || null;
	  this.represent = options['represent'] || null;
	  this.defaultStyle = options['defaultStyle'] || null;
	  this.styleAliases = compileStyleAliases(options['styleAliases'] || null);
	
	  if (YAML_NODE_KINDS.indexOf(this.kind) === -1) {
	    throw new YAMLException('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
	  }
	}
	
	module.exports = Type;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _create = __webpack_require__(470);
	
	Object.defineProperty(exports, "create", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_create).default;
	  }
	});
	
	var _creator = __webpack_require__(67);
	
	Object.defineProperty(exports, "creator", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_creator).default;
	  }
	});
	
	var _local = __webpack_require__(471);
	
	Object.defineProperty(exports, "local", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_local).default;
	  }
	});
	
	var _matcher = __webpack_require__(188);
	
	Object.defineProperty(exports, "matcher", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_matcher).default;
	  }
	});
	
	var _mouse = __webpack_require__(472);
	
	Object.defineProperty(exports, "mouse", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mouse).default;
	  }
	});
	
	var _namespace = __webpack_require__(108);
	
	Object.defineProperty(exports, "namespace", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_namespace).default;
	  }
	});
	
	var _namespaces = __webpack_require__(109);
	
	Object.defineProperty(exports, "namespaces", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_namespaces).default;
	  }
	});
	
	var _point = __webpack_require__(68);
	
	Object.defineProperty(exports, "clientPoint", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_point).default;
	  }
	});
	
	var _select = __webpack_require__(189);
	
	Object.defineProperty(exports, "select", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_select).default;
	  }
	});
	
	var _selectAll = __webpack_require__(473);
	
	Object.defineProperty(exports, "selectAll", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_selectAll).default;
	  }
	});
	
	var _index = __webpack_require__(16);
	
	Object.defineProperty(exports, "selection", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index).default;
	  }
	});
	
	var _selector = __webpack_require__(111);
	
	Object.defineProperty(exports, "selector", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_selector).default;
	  }
	});
	
	var _selectorAll = __webpack_require__(193);
	
	Object.defineProperty(exports, "selectorAll", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_selectorAll).default;
	  }
	});
	
	var _style = __webpack_require__(192);
	
	Object.defineProperty(exports, "style", {
	  enumerable: true,
	  get: function get() {
	    return _style.styleValue;
	  }
	});
	
	var _touch = __webpack_require__(501);
	
	Object.defineProperty(exports, "touch", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_touch).default;
	  }
	});
	
	var _touches = __webpack_require__(502);
	
	Object.defineProperty(exports, "touches", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_touches).default;
	  }
	});
	
	var _window = __webpack_require__(113);
	
	Object.defineProperty(exports, "window", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_window).default;
	  }
	});
	
	var _on = __webpack_require__(110);
	
	Object.defineProperty(exports, "event", {
	  enumerable: true,
	  get: function get() {
	    return _on.event;
	  }
	});
	Object.defineProperty(exports, "customEvent", {
	  enumerable: true,
	  get: function get() {
	    return _on.customEvent;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bisect = __webpack_require__(132);
	
	Object.defineProperty(exports, "bisect", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bisect).default;
	  }
	});
	Object.defineProperty(exports, "bisectRight", {
	  enumerable: true,
	  get: function get() {
	    return _bisect.bisectRight;
	  }
	});
	Object.defineProperty(exports, "bisectLeft", {
	  enumerable: true,
	  get: function get() {
	    return _bisect.bisectLeft;
	  }
	});
	
	var _ascending = __webpack_require__(33);
	
	Object.defineProperty(exports, "ascending", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ascending).default;
	  }
	});
	
	var _bisector = __webpack_require__(133);
	
	Object.defineProperty(exports, "bisector", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bisector).default;
	  }
	});
	
	var _cross = __webpack_require__(247);
	
	Object.defineProperty(exports, "cross", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cross).default;
	  }
	});
	
	var _descending = __webpack_require__(248);
	
	Object.defineProperty(exports, "descending", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_descending).default;
	  }
	});
	
	var _deviation = __webpack_require__(134);
	
	Object.defineProperty(exports, "deviation", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_deviation).default;
	  }
	});
	
	var _extent = __webpack_require__(135);
	
	Object.defineProperty(exports, "extent", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_extent).default;
	  }
	});
	
	var _histogram = __webpack_require__(249);
	
	Object.defineProperty(exports, "histogram", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_histogram).default;
	  }
	});
	
	var _freedmanDiaconis = __webpack_require__(259);
	
	Object.defineProperty(exports, "thresholdFreedmanDiaconis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_freedmanDiaconis).default;
	  }
	});
	
	var _scott = __webpack_require__(260);
	
	Object.defineProperty(exports, "thresholdScott", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scott).default;
	  }
	});
	
	var _sturges = __webpack_require__(139);
	
	Object.defineProperty(exports, "thresholdSturges", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sturges).default;
	  }
	});
	
	var _max = __webpack_require__(251);
	
	Object.defineProperty(exports, "max", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_max).default;
	  }
	});
	
	var _mean = __webpack_require__(252);
	
	Object.defineProperty(exports, "mean", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mean).default;
	  }
	});
	
	var _median = __webpack_require__(253);
	
	Object.defineProperty(exports, "median", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_median).default;
	  }
	});
	
	var _merge = __webpack_require__(254);
	
	Object.defineProperty(exports, "merge", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_merge).default;
	  }
	});
	
	var _min = __webpack_require__(136);
	
	Object.defineProperty(exports, "min", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_min).default;
	  }
	});
	
	var _pairs = __webpack_require__(137);
	
	Object.defineProperty(exports, "pairs", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pairs).default;
	  }
	});
	
	var _permute = __webpack_require__(255);
	
	Object.defineProperty(exports, "permute", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_permute).default;
	  }
	});
	
	var _quantile = __webpack_require__(85);
	
	Object.defineProperty(exports, "quantile", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantile).default;
	  }
	});
	
	var _range = __webpack_require__(138);
	
	Object.defineProperty(exports, "range", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_range).default;
	  }
	});
	
	var _scan = __webpack_require__(256);
	
	Object.defineProperty(exports, "scan", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scan).default;
	  }
	});
	
	var _shuffle = __webpack_require__(257);
	
	Object.defineProperty(exports, "shuffle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shuffle).default;
	  }
	});
	
	var _sum = __webpack_require__(258);
	
	Object.defineProperty(exports, "sum", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sum).default;
	  }
	});
	
	var _ticks = __webpack_require__(140);
	
	Object.defineProperty(exports, "ticks", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ticks).default;
	  }
	});
	Object.defineProperty(exports, "tickIncrement", {
	  enumerable: true,
	  get: function get() {
	    return _ticks.tickIncrement;
	  }
	});
	Object.defineProperty(exports, "tickStep", {
	  enumerable: true,
	  get: function get() {
	    return _ticks.tickStep;
	  }
	});
	
	var _transpose = __webpack_require__(141);
	
	Object.defineProperty(exports, "transpose", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transpose).default;
	  }
	});
	
	var _variance = __webpack_require__(142);
	
	Object.defineProperty(exports, "variance", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_variance).default;
	  }
	});
	
	var _zip = __webpack_require__(261);
	
	Object.defineProperty(exports, "zip", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_zip).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function warning() {};
	
	if (false) {
	  warning = function warning(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = newInterval;
	var t0 = new Date(),
	    t1 = new Date();
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function (date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function (date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function (date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function (start, stop, step) {
	    var range = [],
	        previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do {
	      range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    } while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function (test) {
	    return newInterval(function (date) {
	      if (date >= date) while (floori(date), !test(date)) {
	        date.setTime(date - 1);
	      }
	    }, function (date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function (start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function (step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function (d) {
	        return field(d) % step === 0;
	      } : function (d) {
	        return interval.count(0, d) % step === 0;
	      });
	    };
	  }
	
	  return interval;
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.inject = exports.Provider = exports.useStaticRendering = exports.trackComponents = exports.componentByNodeRegistery = exports.renderReporter = exports.Observer = exports.observer = exports.onError = exports.PropTypes = exports.propTypes = undefined;
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _mobx = __webpack_require__(80);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// These functions can be stubbed out in specific environments
	var unstable_batchedUpdates$1 = undefined;
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	};
	
	var asyncGenerator = function () {
	    function AwaitValue(value) {
	        this.value = value;
	    }
	
	    function AsyncGenerator(gen) {
	        var front, back;
	
	        function send(key, arg) {
	            return new Promise(function (resolve, reject) {
	                var request = {
	                    key: key,
	                    arg: arg,
	                    resolve: resolve,
	                    reject: reject,
	                    next: null
	                };
	
	                if (back) {
	                    back = back.next = request;
	                } else {
	                    front = back = request;
	                    resume(key, arg);
	                }
	            });
	        }
	
	        function resume(key, arg) {
	            try {
	                var result = gen[key](arg);
	                var value = result.value;
	
	                if (value instanceof AwaitValue) {
	                    Promise.resolve(value.value).then(function (arg) {
	                        resume("next", arg);
	                    }, function (arg) {
	                        resume("throw", arg);
	                    });
	                } else {
	                    settle(result.done ? "return" : "normal", result.value);
	                }
	            } catch (err) {
	                settle("throw", err);
	            }
	        }
	
	        function settle(type, value) {
	            switch (type) {
	                case "return":
	                    front.resolve({
	                        value: value,
	                        done: true
	                    });
	                    break;
	
	                case "throw":
	                    front.reject(value);
	                    break;
	
	                default:
	                    front.resolve({
	                        value: value,
	                        done: false
	                    });
	                    break;
	            }
	
	            front = front.next;
	
	            if (front) {
	                resume(front.key, front.arg);
	            } else {
	                back = null;
	            }
	        }
	
	        this._invoke = send;
	
	        if (typeof gen.return !== "function") {
	            this.return = undefined;
	        }
	    }
	
	    if (typeof Symbol === "function" && Symbol.asyncIterator) {
	        AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	            return this;
	        };
	    }
	
	    AsyncGenerator.prototype.next = function (arg) {
	        return this._invoke("next", arg);
	    };
	
	    AsyncGenerator.prototype.throw = function (arg) {
	        return this._invoke("throw", arg);
	    };
	
	    AsyncGenerator.prototype.return = function (arg) {
	        return this._invoke("return", arg);
	    };
	
	    return {
	        wrap: function wrap(fn) {
	            return function () {
	                return new AsyncGenerator(fn.apply(this, arguments));
	            };
	        },
	        await: function _await(value) {
	            return new AwaitValue(value);
	        }
	    };
	}();
	
	var classCallCheck = function classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	};
	
	var createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];
	            descriptor.enumerable = descriptor.enumerable || false;
	            descriptor.configurable = true;
	            if ("value" in descriptor) descriptor.writable = true;
	            Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);
	        if (staticProps) defineProperties(Constructor, staticProps);
	        return Constructor;
	    };
	}();
	
	var inherits = function inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	        constructor: {
	            value: subClass,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	    if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	var EventEmitter = function () {
	    function EventEmitter() {
	        classCallCheck(this, EventEmitter);
	        this.listeners = [];
	    }
	
	    createClass(EventEmitter, [{
	        key: "on",
	        value: function on(cb) {
	            var _this = this;
	
	            this.listeners.push(cb);
	            return function () {
	                var index = _this.listeners.indexOf(cb);
	                if (index !== -1) _this.listeners.splice(index, 1);
	            };
	        }
	    }, {
	        key: "emit",
	        value: function emit(data) {
	            this.listeners.forEach(function (fn) {
	                return fn(data);
	            });
	        }
	    }]);
	    return EventEmitter;
	}();
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty$1 = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty$1(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};
	
	// Copied from React.PropTypes
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	            rest[_key - 6] = arguments[_key];
	        }
	
	        return (0, _mobx.untracked)(function () {
	            componentName = componentName || "<<anonymous>>";
	            propFullName = propFullName || propName;
	            if (props[propName] == null) {
	                if (isRequired) {
	                    var actual = props[propName] === null ? "null" : "undefined";
	                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	                }
	                return null;
	            } else {
	                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	            }
	        });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	
	// Copied from React.PropTypes
	function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	        return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue["@@toStringTag"] === "Symbol") {
	        return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	        return true;
	    }
	
	    return false;
	}
	
	// Copied from React.PropTypes
	function getPropType(propValue) {
	    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	        return "array";
	    }
	    if (propValue instanceof RegExp) {
	        // Old webkits (at least until Android 4.0) return 'function' rather than
	        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	        // passes PropTypes.object.
	        return "object";
	    }
	    if (isSymbol(propType, propValue)) {
	        return "symbol";
	    }
	    return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// Copied from React.PropTypes
	function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === "object") {
	        if (propValue instanceof Date) {
	            return "date";
	        } else if (propValue instanceof RegExp) {
	            return "regexp";
	        }
	    }
	    return propType;
	}
	
	function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        return (0, _mobx.untracked)(function () {
	            if (allowNativeType) {
	                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	            }
	            var mobxChecker = void 0;
	            switch (mobxType) {
	                case "Array":
	                    mobxChecker = _mobx.isObservableArray;
	                    break;
	                case "Object":
	                    mobxChecker = _mobx.isObservableObject;
	                    break;
	                case "Map":
	                    mobxChecker = _mobx.isObservableMap;
	                    break;
	                default:
	                    throw new Error("Unexpected mobxType: " + mobxType);
	            }
	            var propValue = props[propName];
	            if (!mobxChecker(propValue)) {
	                var preciseType = getPreciseType(propValue);
	                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	            }
	            return null;
	        });
	    });
	}
	
	function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	            rest[_key2 - 5] = arguments[_key2];
	        }
	
	        return (0, _mobx.untracked)(function () {
	            if (typeof typeChecker !== "function") {
	                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	            }
	            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	            if (error instanceof Error) return error;
	            var propValue = props[propName];
	            for (var i = 0; i < propValue.length; i++) {
	                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	                if (error instanceof Error) return error;
	            }
	            return null;
	        });
	    });
	}
	
	var observableArray = createObservableTypeCheckerCreator(false, "Array");
	var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	var observableMap = createObservableTypeCheckerCreator(false, "Map");
	var observableObject = createObservableTypeCheckerCreator(false, "Object");
	var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	var propTypes = Object.freeze({
	    observableArray: observableArray,
	    observableArrayOf: observableArrayOf,
	    observableMap: observableMap,
	    observableObject: observableObject,
	    arrayOrObservableArray: arrayOrObservableArray,
	    arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	    objectOrObservableObject: objectOrObservableObject
	});
	
	function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	}
	
	var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	};
	Object.seal(injectorContextTypes);
	
	var proxiedInjectorProps = {
	    contextTypes: {
	        get: function get$$1() {
	            return injectorContextTypes;
	        },
	        set: function set$$1(_) {
	            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	        },
	        configurable: true,
	        enumerable: false
	    },
	    isMobxInjector: {
	        value: true,
	        writable: true,
	        configurable: true,
	        enumerable: true
	
	        /**
	         * Store Injection
	         */
	    } };function createStoreInjector(grabStoresFn, component, injectNames) {
	    var _class, _temp2;
	
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector = (_temp2 = _class = function (_Component) {
	        inherits(Injector, _Component);
	
	        function Injector() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            classCallCheck(this, Injector);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
	                _this.wrappedInstance = instance;
	            }, _temp), possibleConstructorReturn(_this, _ret);
	        }
	
	        createClass(Injector, [{
	            key: "render",
	            value: function render() {
	                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	                // See this test: 'using a custom injector is not too reactive' in inject.js
	                var newProps = {};
	                for (var key in this.props) {
	                    if (this.props.hasOwnProperty(key)) {
	                        newProps[key] = this.props[key];
	                    }
	                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	                for (var _key2 in additionalProps) {
	                    newProps[_key2] = additionalProps[_key2];
	                }
	
	                if (!isStateless(component)) {
	                    newProps.ref = this.storeRef;
	                }
	
	                return (0, _react.createElement)(component, newProps);
	            }
	        }]);
	        return Injector;
	    }(_react.Component), _class.displayName = displayName, _temp2);
	
	    // Static fields from component should be visible on the generated Injector
	
	    hoistNonReactStatics(Injector, component);
	
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	
	    return Injector;
	}
	
	function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	        storeNames.forEach(function (storeName) {
	            if (storeName in nextProps // prefer props over stores
	            ) return;
	            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	            nextProps[storeName] = baseStores[storeName];
	        });
	        return nextProps;
	    };
	}
	
	/**
	 * higher order component that injects stores to a child.
	 * takes either a varargs list of strings, which are stores read from the context,
	 * or a function that manually maps the available stores from the context to props:
	 * storesToProps(mobxStores, props, context) => newProps
	 */
	function inject() /* fn(stores, nextProps) or ...storeNames */{
	    var grabStoresFn = void 0;
	    if (typeof arguments[0] === "function") {
	        grabStoresFn = arguments[0];
	        return function (componentClass) {
	            var injected = createStoreInjector(grabStoresFn, componentClass);
	            injected.isMobxInjector = false; // supress warning
	            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	            // see #111
	            injected = observer(injected);
	            injected.isMobxInjector = true; // restore warning
	            return injected;
	        };
	    } else {
	        var storeNames = [];
	        for (var i = 0; i < arguments.length; i++) {
	            storeNames[i] = arguments[i];
	        }grabStoresFn = grabStoresByName(storeNames);
	        return function (componentClass) {
	            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	        };
	    }
	}
	
	/**
	 * dev tool support
	 */
	var isDevtoolsEnabled = false;
	
	var isUsingStaticRendering = false;
	
	var warnedAboutObserverInjectDeprecation = false;
	
	// WeakMap<Node, Object>;
	var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	var renderReporter = new EventEmitter();
	
	function findDOMNode$2(component) {
	    if (_reactDom.findDOMNode) {
	        try {
	            return (0, _reactDom.findDOMNode)(component);
	        } catch (e) {
	            // findDOMNode will throw in react-test-renderer, see:
	            // See https://github.com/mobxjs/mobx-react/issues/216
	            // Is there a better heuristic?
	            return null;
	        }
	    }
	    return null;
	}
	
	function reportRendering(component) {
	    var node = findDOMNode$2(component);
	    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);
	
	    renderReporter.emit({
	        event: "render",
	        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	        totalTime: Date.now() - component.__$mobRenderStart,
	        component: component,
	        node: node
	    });
	}
	
	function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	}
	
	function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	}
	
	/**
	 * Errors reporter
	 */
	
	var errorsReporter = new EventEmitter();
	
	/**
	 * Utilities
	 */
	
	function patch(target, funcName) {
	    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var base = target[funcName];
	    var mixinFunc = reactiveMixin[funcName];
	    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
	        mixinFunc.apply(this, arguments);
	        base.apply(this, arguments);
	    } : function () {
	        base.apply(this, arguments);
	        mixinFunc.apply(this, arguments);
	    };
	
	    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
	    // ...but that breaks react-hot-loader, see #231...
	    target[funcName] = f;
	}
	
	function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
	        return false;
	    }
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	    for (var i = 0; i < keysA.length; i++) {
	        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	        return x !== 0 || 1 / x === 1 / y;
	    } else {
	        return x !== x && y !== y;
	    }
	}
	
	/**
	 * ReactiveMixin
	 */
	var reactiveMixin = {
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        if (isUsingStaticRendering === true) return;
	        // Generate friendly name for debugging
	        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	
	        /**
	         * If props are shallowly modified, react will render anyway,
	         * so atom.reportChanged() should not result in yet another re-render
	         */
	        var skipRender = false;
	        /**
	         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	         * so detect these changes
	         */
	        var isForcingUpdate = false;
	
	        function makePropertyObservableReference(propName) {
	            var valueHolder = this[propName];
	            var atom = (0, _mobx.createAtom)("reactive " + propName);
	            Object.defineProperty(this, propName, {
	                configurable: true,
	                enumerable: true,
	                get: function get$$1() {
	                    atom.reportObserved();
	                    return valueHolder;
	                },
	                set: function set$$1(v) {
	                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
	                        valueHolder = v;
	                        skipRender = true;
	                        atom.reportChanged();
	                        skipRender = false;
	                    } else {
	                        valueHolder = v;
	                    }
	                }
	            });
	        }
	
	        // make this.props an observable reference, see #124
	        makePropertyObservableReference.call(this, "props");
	        // make state an observable reference
	        makePropertyObservableReference.call(this, "state");
	
	        // wire up reactive render
	        var baseRender = this.render.bind(this);
	        var reaction = null;
	        var isRenderingPending = false;
	
	        var initialRender = function initialRender() {
	            reaction = new _mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
	                if (!isRenderingPending) {
	                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	                    // See #85 / Pull #44
	                    isRenderingPending = true;
	                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
	                    if (_this.__$mobxIsUnmounted !== true) {
	                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	                        // However, people also claim this migth happen during unit tests..
	                        var hasError = true;
	                        try {
	                            isForcingUpdate = true;
	                            if (!skipRender) _react.Component.prototype.forceUpdate.call(_this);
	                            hasError = false;
	                        } finally {
	                            isForcingUpdate = false;
	                            if (hasError) reaction.dispose();
	                        }
	                    }
	                }
	            });
	            reaction.reactComponent = _this;
	            reactiveRender.$mobx = reaction;
	            _this.render = reactiveRender;
	            return reactiveRender();
	        };
	
	        var reactiveRender = function reactiveRender() {
	            isRenderingPending = false;
	            var exception = undefined;
	            var rendering = undefined;
	            reaction.track(function () {
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderStart = Date.now();
	                }
	                try {
	                    rendering = (0, _mobx._allowStateChanges)(false, baseRender);
	                } catch (e) {
	                    exception = e;
	                }
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderEnd = Date.now();
	                }
	            });
	            if (exception) {
	                errorsReporter.emit(exception);
	                throw exception;
	            }
	            return rendering;
	        };
	
	        this.render = initialRender;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (isUsingStaticRendering === true) return;
	        this.render.$mobx && this.render.$mobx.dispose();
	        this.__$mobxIsUnmounted = true;
	        if (isDevtoolsEnabled) {
	            var node = findDOMNode$2(this);
	            if (node && componentByNodeRegistery) {
	                componentByNodeRegistery.delete(node);
	            }
	            renderReporter.emit({
	                event: "destroy",
	                component: this,
	                node: node
	            });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (isUsingStaticRendering) {
	            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	        }
	        // update on any state changes (as is the default)
	        if (this.state !== nextState) {
	            return true;
	        }
	        // update if props are shallowly not equal, inspired by PureRenderMixin
	        // we could return just 'false' here, and avoid the `skipRender` checks etc
	        // however, it is nicer if lifecycle events are triggered like usually,
	        // so we return true here if props are shallowly modified.
	        return !shallowEqual(this.props, nextProps);
	    }
	
	    /**
	     * Observer function / decorator
	     */
	};function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	        throw new Error("Store names should be provided as array");
	    }
	    if (Array.isArray(arg1)) {
	        // component needs stores
	        if (!warnedAboutObserverInjectDeprecation) {
	            warnedAboutObserverInjectDeprecation = true;
	            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	        }
	        if (!arg2) {
	            // invoked as decorator
	            return function (componentClass) {
	                return observer(arg1, componentClass);
	            };
	        } else {
	            return inject.apply(null, arg1)(observer(arg2));
	        }
	    }
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	
	    // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !_react.Component.isPrototypeOf(componentClass)) {
	        var _class, _temp;
	
	        return observer((_temp = _class = function (_Component) {
	            inherits(_class, _Component);
	
	            function _class() {
	                classCallCheck(this, _class);
	                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            createClass(_class, [{
	                key: "render",
	                value: function render() {
	                    return componentClass.call(this, this.props, this.context);
	                }
	            }]);
	            return _class;
	        }(_react.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	    }
	
	    if (!componentClass) {
	        throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    return componentClass;
	}
	
	function mixinLifecycleEvents(target) {
	    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	        patch(target, funcName);
	    });
	    if (!target.shouldComponentUpdate) {
	        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    }
	}
	
	// TODO: support injection somehow as well?
	var Observer = observer(function (_ref) {
	    var children = _ref.children,
	        observerInject = _ref.inject,
	        render = _ref.render;
	
	    var component = children || render;
	    if (typeof component === "undefined") {
	        return null;
	    }
	    if (!observerInject) {
	        return component();
	    }
	    var InjectComponent = inject(observerInject)(component);
	    return _react2.default.createElement(InjectComponent, null);
	});
	
	Observer.displayName = "Observer";
	
	var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	        return;
	    }
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	};
	
	Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	};
	
	var _class;
	var _temp;
	
	var specialReactKeys = { children: true, key: true, ref: true };
	
	var Provider = (_temp = _class = function (_Component) {
	    inherits(Provider, _Component);
	
	    function Provider() {
	        classCallCheck(this, Provider);
	        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	    }
	
	    createClass(Provider, [{
	        key: "render",
	        value: function render() {
	            return _react.Children.only(this.props.children);
	        }
	    }, {
	        key: "getChildContext",
	        value: function getChildContext() {
	            var stores = {};
	            // inherit stores
	            var baseStores = this.context.mobxStores;
	            if (baseStores) for (var key in baseStores) {
	                stores[key] = baseStores[key];
	            }
	            // add own stores
	            for (var _key in this.props) {
	                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
	            }return {
	                mobxStores: stores
	            };
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            // Maybe this warning is too aggressive?
	            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	            }
	        }
	    }]);
	    return Provider;
	}(_react.Component), _class.contextTypes = {
	    mobxStores: objectOrObservableObject
	}, _class.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	}, _temp);
	
	if (!_react.Component) throw new Error("mobx-react requires React to be available");
	if (!_mobx.spy) throw new Error("mobx-react requires mobx to be available");
	
	if (typeof _reactDom.unstable_batchedUpdates === "function") (0, _mobx.configure)({ reactionScheduler: _reactDom.unstable_batchedUpdates });else if (typeof unstable_batchedUpdates$1 === "function") (0, _mobx.configure)({ reactionScheduler: unstable_batchedUpdates$1 });
	
	var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	};
	
	/* DevTool support */
	// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js
	
	if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = { spy: _mobx.spy, extras: { getDebugName: _mobx.getDebugName } };
	    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	}
	
	exports.propTypes = propTypes;
	exports.PropTypes = propTypes;
	exports.onError = onError;
	exports.observer = observer;
	exports.Observer = Observer;
	exports.renderReporter = renderReporter;
	exports.componentByNodeRegistery = componentByNodeRegistery;
	exports.trackComponents = trackComponents;
	exports.useStaticRendering = useStaticRendering;
	exports.Provider = Provider;
	exports.inject = inject;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;
	
	  var isValidElement = function isValidElement(object) {
	    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(676)();
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _value = __webpack_require__(104);
	
	Object.defineProperty(exports, "interpolate", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_value).default;
	  }
	});
	
	var _array = __webpack_require__(175);
	
	Object.defineProperty(exports, "interpolateArray", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_array).default;
	  }
	});
	
	var _basis = __webpack_require__(103);
	
	Object.defineProperty(exports, "interpolateBasis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_basis).default;
	  }
	});
	
	var _basisClosed = __webpack_require__(176);
	
	Object.defineProperty(exports, "interpolateBasisClosed", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_basisClosed).default;
	  }
	});
	
	var _date = __webpack_require__(178);
	
	Object.defineProperty(exports, "interpolateDate", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_date).default;
	  }
	});
	
	var _number = __webpack_require__(65);
	
	Object.defineProperty(exports, "interpolateNumber", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_number).default;
	  }
	});
	
	var _object = __webpack_require__(179);
	
	Object.defineProperty(exports, "interpolateObject", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_object).default;
	  }
	});
	
	var _round = __webpack_require__(387);
	
	Object.defineProperty(exports, "interpolateRound", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_round).default;
	  }
	});
	
	var _string = __webpack_require__(181);
	
	Object.defineProperty(exports, "interpolateString", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_string).default;
	  }
	});
	
	var _index = __webpack_require__(389);
	
	Object.defineProperty(exports, "interpolateTransformCss", {
	  enumerable: true,
	  get: function get() {
	    return _index.interpolateTransformCss;
	  }
	});
	Object.defineProperty(exports, "interpolateTransformSvg", {
	  enumerable: true,
	  get: function get() {
	    return _index.interpolateTransformSvg;
	  }
	});
	
	var _zoom = __webpack_require__(391);
	
	Object.defineProperty(exports, "interpolateZoom", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_zoom).default;
	  }
	});
	
	var _rgb = __webpack_require__(180);
	
	Object.defineProperty(exports, "interpolateRgb", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_rgb).default;
	  }
	});
	Object.defineProperty(exports, "interpolateRgbBasis", {
	  enumerable: true,
	  get: function get() {
	    return _rgb.rgbBasis;
	  }
	});
	Object.defineProperty(exports, "interpolateRgbBasisClosed", {
	  enumerable: true,
	  get: function get() {
	    return _rgb.rgbBasisClosed;
	  }
	});
	
	var _hsl = __webpack_require__(383);
	
	Object.defineProperty(exports, "interpolateHsl", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hsl).default;
	  }
	});
	Object.defineProperty(exports, "interpolateHslLong", {
	  enumerable: true,
	  get: function get() {
	    return _hsl.hslLong;
	  }
	});
	
	var _lab = __webpack_require__(384);
	
	Object.defineProperty(exports, "interpolateLab", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lab).default;
	  }
	});
	
	var _hcl = __webpack_require__(382);
	
	Object.defineProperty(exports, "interpolateHcl", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hcl).default;
	  }
	});
	Object.defineProperty(exports, "interpolateHclLong", {
	  enumerable: true,
	  get: function get() {
	    return _hcl.hclLong;
	  }
	});
	
	var _cubehelix = __webpack_require__(381);
	
	Object.defineProperty(exports, "interpolateCubehelix", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cubehelix).default;
	  }
	});
	Object.defineProperty(exports, "interpolateCubehelixLong", {
	  enumerable: true,
	  get: function get() {
	    return _cubehelix.cubehelixLong;
	  }
	});
	
	var _piecewise = __webpack_require__(385);
	
	Object.defineProperty(exports, "piecewise", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_piecewise).default;
	  }
	});
	
	var _quantize = __webpack_require__(386);
	
	Object.defineProperty(exports, "quantize", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantize).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.root = undefined;
	exports.Selection = Selection;
	
	var _select = __webpack_require__(496);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _selectAll = __webpack_require__(497);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _filter = __webpack_require__(485);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _data = __webpack_require__(479);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _enter = __webpack_require__(190);
	
	var _enter2 = _interopRequireDefault(_enter);
	
	var _exit = __webpack_require__(484);
	
	var _exit2 = _interopRequireDefault(_exit);
	
	var _merge = __webpack_require__(489);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _order = __webpack_require__(492);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _sort = __webpack_require__(499);
	
	var _sort2 = _interopRequireDefault(_sort);
	
	var _call = __webpack_require__(476);
	
	var _call2 = _interopRequireDefault(_call);
	
	var _nodes = __webpack_require__(491);
	
	var _nodes2 = _interopRequireDefault(_nodes);
	
	var _node = __webpack_require__(490);
	
	var _node2 = _interopRequireDefault(_node);
	
	var _size = __webpack_require__(498);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _empty = __webpack_require__(483);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	var _each = __webpack_require__(482);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _attr = __webpack_require__(475);
	
	var _attr2 = _interopRequireDefault(_attr);
	
	var _style = __webpack_require__(192);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _property = __webpack_require__(493);
	
	var _property2 = _interopRequireDefault(_property);
	
	var _classed = __webpack_require__(477);
	
	var _classed2 = _interopRequireDefault(_classed);
	
	var _text = __webpack_require__(500);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _html = __webpack_require__(486);
	
	var _html2 = _interopRequireDefault(_html);
	
	var _raise = __webpack_require__(494);
	
	var _raise2 = _interopRequireDefault(_raise);
	
	var _lower = __webpack_require__(488);
	
	var _lower2 = _interopRequireDefault(_lower);
	
	var _append = __webpack_require__(474);
	
	var _append2 = _interopRequireDefault(_append);
	
	var _insert = __webpack_require__(487);
	
	var _insert2 = _interopRequireDefault(_insert);
	
	var _remove = __webpack_require__(495);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _clone = __webpack_require__(478);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _datum = __webpack_require__(480);
	
	var _datum2 = _interopRequireDefault(_datum);
	
	var _on = __webpack_require__(110);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _dispatch = __webpack_require__(481);
	
	var _dispatch2 = _interopRequireDefault(_dispatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var root = exports.root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: _select2.default,
	  selectAll: _selectAll2.default,
	  filter: _filter2.default,
	  data: _data2.default,
	  enter: _enter2.default,
	  exit: _exit2.default,
	  merge: _merge2.default,
	  order: _order2.default,
	  sort: _sort2.default,
	  call: _call2.default,
	  nodes: _nodes2.default,
	  node: _node2.default,
	  size: _size2.default,
	  empty: _empty2.default,
	  each: _each2.default,
	  attr: _attr2.default,
	  style: _style2.default,
	  property: _property2.default,
	  classed: _classed2.default,
	  text: _text2.default,
	  html: _html2.default,
	  raise: _raise2.default,
	  lower: _lower2.default,
	  append: _append2.default,
	  insert: _insert2.default,
	  remove: _remove2.default,
	  clone: _clone2.default,
	  datum: _datum2.default,
	  on: _on2.default,
	  dispatch: _dispatch2.default
	};
	
	exports.default = selection;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENDED = exports.ENDING = exports.RUNNING = exports.STARTED = exports.STARTING = exports.SCHEDULED = exports.CREATED = undefined;
	
	exports.default = function (node, name, id, index, group, timing) {
	  var schedules = node.__transition;
	  if (!schedules) node.__transition = {};else if (id in schedules) return;
	  create(node, id, {
	    name: name,
	    index: index, // For context during callback.
	    group: group, // For context during callback.
	    on: emptyOn,
	    tween: emptyTween,
	    time: timing.time,
	    delay: timing.delay,
	    duration: timing.duration,
	    ease: timing.ease,
	    timer: null,
	    state: CREATED
	  });
	};
	
	exports.init = init;
	exports.set = set;
	exports.get = get;
	
	var _d3Dispatch = __webpack_require__(34);
	
	var _d3Timer = __webpack_require__(74);
	
	var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "interrupt");
	var emptyTween = [];
	
	var CREATED = exports.CREATED = 0;
	var SCHEDULED = exports.SCHEDULED = 1;
	var STARTING = exports.STARTING = 2;
	var STARTED = exports.STARTED = 3;
	var RUNNING = exports.RUNNING = 4;
	var ENDING = exports.ENDING = 5;
	var ENDED = exports.ENDED = 6;
	
	function init(node, id) {
	  var schedule = get(node, id);
	  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
	  return schedule;
	}
	
	function set(node, id) {
	  var schedule = get(node, id);
	  if (schedule.state > STARTING) throw new Error("too late; already started");
	  return schedule;
	}
	
	function get(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
	  return schedule;
	}
	
	function create(node, id, self) {
	  var schedules = node.__transition,
	      tween;
	
	  // Initialize the self timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  schedules[id] = self;
	  self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
	
	  function schedule(elapsed) {
	    self.state = SCHEDULED;
	    self.timer.restart(start, self.delay, self.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (self.delay <= elapsed) start(elapsed - self.delay);
	  }
	
	  function start(elapsed) {
	    var i, j, n, o;
	
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (self.state !== SCHEDULED) return stop();
	
	    for (i in schedules) {
	      o = schedules[i];
	      if (o.name !== self.name) continue;
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
	
	      // Interrupt the active transition, if any.
	      // Dispatch the interrupt event.
	      if (o.state === RUNNING) {
	        o.state = ENDED;
	        o.timer.stop();
	        o.on.call("interrupt", node, node.__data__, o.index, o.group);
	        delete schedules[i];
	      }
	
	      // Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	      else if (+i < id) {
	          o.state = ENDED;
	          o.timer.stop();
	          delete schedules[i];
	        }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    (0, _d3Timer.timeout)(function () {
	      if (self.state === STARTED) {
	        self.state = RUNNING;
	        self.timer.restart(tick, self.delay, self.time);
	        tick(elapsed);
	      }
	    });
	
	    // Dispatch the start event.
	    // Note this must be done before the tween are initialized.
	    self.state = STARTING;
	    self.on.call("start", node, node.__data__, self.index, self.group);
	    if (self.state !== STARTING) return; // interrupted
	    self.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    tween = new Array(n = self.tween.length);
	    for (i = 0, j = -1; i < n; ++i) {
	      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
	        tween[++j] = o;
	      }
	    }
	    tween.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
	        i = -1,
	        n = tween.length;
	
	    while (++i < n) {
	      tween[i].call(null, t);
	    }
	
	    // Dispatch the end event.
	    if (self.state === ENDING) {
	      self.on.call("end", node, node.__data__, self.index, self.group);
	      stop();
	    }
	  }
	
	  function stop() {
	    self.state = ENDED;
	    self.timer.stop();
	    delete schedules[id];
	    for (var i in schedules) {
	      return;
	    } // eslint-disable-line no-unused-vars
	    delete node.__transition;
	  }
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(87);
	
	Object.defineProperty(exports, "color", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_color).default;
	  }
	});
	Object.defineProperty(exports, "rgb", {
	  enumerable: true,
	  get: function get() {
	    return _color.rgb;
	  }
	});
	Object.defineProperty(exports, "hsl", {
	  enumerable: true,
	  get: function get() {
	    return _color.hsl;
	  }
	});
	
	var _lab = __webpack_require__(282);
	
	Object.defineProperty(exports, "lab", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lab).default;
	  }
	});
	Object.defineProperty(exports, "hcl", {
	  enumerable: true,
	  get: function get() {
	    return _lab.hcl;
	  }
	});
	Object.defineProperty(exports, "lch", {
	  enumerable: true,
	  get: function get() {
	    return _lab.lch;
	  }
	});
	Object.defineProperty(exports, "gray", {
	  enumerable: true,
	  get: function get() {
	    return _lab.gray;
	  }
	});
	
	var _cubehelix = __webpack_require__(281);
	
	Object.defineProperty(exports, "cubehelix", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cubehelix).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = projection;
	exports.projectionMutator = projectionMutator;
	
	var _antimeridian = __webpack_require__(158);
	
	var _antimeridian2 = _interopRequireDefault(_antimeridian);
	
	var _circle = __webpack_require__(160);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _rectangle = __webpack_require__(61);
	
	var _rectangle2 = _interopRequireDefault(_rectangle);
	
	var _compose = __webpack_require__(163);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _identity = __webpack_require__(95);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _math = __webpack_require__(2);
	
	var _rotation = __webpack_require__(62);
	
	var _transform = __webpack_require__(63);
	
	var _fit = __webpack_require__(98);
	
	var _resample = __webpack_require__(356);
	
	var _resample2 = _interopRequireDefault(_resample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transformRadians = (0, _transform.transformer)({
	  point: function point(x, y) {
	    this.stream.point(x * _math.radians, y * _math.radians);
	  }
	});
	
	function transformRotate(rotate) {
	  return (0, _transform.transformer)({
	    point: function point(x, y) {
	      var r = rotate(x, y);
	      return this.stream.point(r[0], r[1]);
	    }
	  });
	}
	
	function scaleTranslate(k, dx, dy) {
	  function transform(x, y) {
	    return [dx + k * x, dy - k * y];
	  }
	  transform.invert = function (x, y) {
	    return [(x - dx) / k, (dy - y) / k];
	  };
	  return transform;
	}
	
	function scaleTranslateRotate(k, dx, dy, alpha) {
	  var cosAlpha = (0, _math.cos)(alpha),
	      sinAlpha = (0, _math.sin)(alpha),
	      a = cosAlpha * k,
	      b = sinAlpha * k,
	      ai = cosAlpha / k,
	      bi = sinAlpha / k,
	      ci = (sinAlpha * dy - cosAlpha * dx) / k,
	      fi = (sinAlpha * dx + cosAlpha * dy) / k;
	  function transform(x, y) {
	    return [a * x - b * y + dx, dy - b * x - a * y];
	  }
	  transform.invert = function (x, y) {
	    return [ai * x - bi * y + ci, fi - bi * x - ai * y];
	  };
	  return transform;
	}
	
	function projection(project) {
	  return projectionMutator(function () {
	    return project;
	  })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150,
	      // scale
	  x = 480,
	      y = 250,
	      // translate
	  lambda = 0,
	      phi = 0,
	      // center
	  deltaLambda = 0,
	      deltaPhi = 0,
	      deltaGamma = 0,
	      rotate,
	      // pre-rotate
	  alpha = 0,
	      // post-rotate
	  theta = null,
	      preclip = _antimeridian2.default,
	      // pre-clip angle
	  x0 = null,
	      y0,
	      x1,
	      y1,
	      postclip = _identity2.default,
	      // post-clip extent
	  delta2 = 0.5,
	      // precision
	  projectResample,
	      projectTransform,
	      projectRotateTransform,
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    return projectRotateTransform(point[0] * _math.radians, point[1] * _math.radians);
	  }
	
	  function invert(point) {
	    point = projectRotateTransform.invert(point[0], point[1]);
	    return point && [point[0] * _math.degrees, point[1] * _math.degrees];
	  }
	
	  projection.stream = function (stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
	  };
	
	  projection.preclip = function (_) {
	    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
	  };
	
	  projection.postclip = function (_) {
	    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
	  };
	
	  projection.clipAngle = function (_) {
	    return arguments.length ? (preclip = +_ ? (0, _circle2.default)(theta = _ * _math.radians) : (theta = null, _antimeridian2.default), reset()) : theta * _math.degrees;
	  };
	
	  projection.clipExtent = function (_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identity2.default) : (0, _rectangle2.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function (_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function (_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function (_) {
	    return arguments.length ? (lambda = _[0] % 360 * _math.radians, phi = _[1] % 360 * _math.radians, recenter()) : [lambda * _math.degrees, phi * _math.degrees];
	  };
	
	  projection.rotate = function (_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * _math.radians, deltaPhi = _[1] % 360 * _math.radians, deltaGamma = _.length > 2 ? _[2] % 360 * _math.radians : 0, recenter()) : [deltaLambda * _math.degrees, deltaPhi * _math.degrees, deltaGamma * _math.degrees];
	  };
	
	  projection.angle = function (_) {
	    return arguments.length ? (alpha = _ % 360 * _math.radians, recenter()) : alpha * _math.degrees;
	  };
	
	  projection.precision = function (_) {
	    return arguments.length ? (projectResample = (0, _resample2.default)(projectTransform, delta2 = _ * _), reset()) : (0, _math.sqrt)(delta2);
	  };
	
	  projection.fitExtent = function (extent, object) {
	    return (0, _fit.fitExtent)(projection, extent, object);
	  };
	
	  projection.fitSize = function (size, object) {
	    return (0, _fit.fitSize)(projection, size, object);
	  };
	
	  projection.fitWidth = function (width, object) {
	    return (0, _fit.fitWidth)(projection, width, object);
	  };
	
	  projection.fitHeight = function (height, object) {
	    return (0, _fit.fitHeight)(projection, height, object);
	  };
	
	  function recenter() {
	    var center = scaleTranslateRotate(k, 0, 0, alpha).apply(null, project(lambda, phi)),
	        transform = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], alpha);
	    rotate = (0, _rotation.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
	    projectTransform = (0, _compose2.default)(project, transform);
	    projectRotateTransform = (0, _compose2.default)(rotate, projectTransform);
	    projectResample = (0, _resample2.default)(projectTransform, delta2);
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function () {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var durationSecond = exports.durationSecond = 1e3;
	var durationMinute = exports.durationMinute = 6e4;
	var durationHour = exports.durationHour = 36e5;
	var durationDay = exports.durationDay = 864e5;
	var durationWeek = exports.durationWeek = 6048e5;

/***/ },
/* 21 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = noop;
	function noop() {}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Transition = Transition;
	exports.default = transition;
	exports.newId = newId;
	
	var _d3Selection = __webpack_require__(8);
	
	var _attr = __webpack_require__(549);
	
	var _attr2 = _interopRequireDefault(_attr);
	
	var _attrTween = __webpack_require__(550);
	
	var _attrTween2 = _interopRequireDefault(_attrTween);
	
	var _delay = __webpack_require__(551);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	var _duration = __webpack_require__(552);
	
	var _duration2 = _interopRequireDefault(_duration);
	
	var _ease = __webpack_require__(553);
	
	var _ease2 = _interopRequireDefault(_ease);
	
	var _filter = __webpack_require__(554);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _merge = __webpack_require__(555);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _on = __webpack_require__(556);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _remove = __webpack_require__(557);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _select = __webpack_require__(558);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _selectAll = __webpack_require__(559);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _selection = __webpack_require__(560);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _style = __webpack_require__(561);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _styleTween = __webpack_require__(562);
	
	var _styleTween2 = _interopRequireDefault(_styleTween);
	
	var _text = __webpack_require__(563);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _transition = __webpack_require__(564);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _tween = __webpack_require__(75);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var id = 0;
	
	function Transition(groups, parents, name, id) {
	  this._groups = groups;
	  this._parents = parents;
	  this._name = name;
	  this._id = id;
	}
	
	function transition(name) {
	  return (0, _d3Selection.selection)().transition(name);
	}
	
	function newId() {
	  return ++id;
	}
	
	var selection_prototype = _d3Selection.selection.prototype;
	
	Transition.prototype = transition.prototype = {
	  constructor: Transition,
	  select: _select2.default,
	  selectAll: _selectAll2.default,
	  filter: _filter2.default,
	  merge: _merge2.default,
	  selection: _selection2.default,
	  transition: _transition2.default,
	  call: selection_prototype.call,
	  nodes: selection_prototype.nodes,
	  node: selection_prototype.node,
	  size: selection_prototype.size,
	  empty: selection_prototype.empty,
	  each: selection_prototype.each,
	  on: _on2.default,
	  attr: _attr2.default,
	  attrTween: _attrTween2.default,
	  style: _style2.default,
	  styleTween: _styleTween2.default,
	  text: _text2.default,
	  remove: _remove2.default,
	  tween: _tween2.default,
	  delay: _delay2.default,
	  duration: _duration2.default,
	  ease: _ease2.default
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var structure = {};
	
	structure["/"] = {
	  showButtons: false
	};
	
	structure["/login"] = {
	  showButtons: false
	};
	
	structure["/consent"] = {
	  showNext: true
	};
	
	structure["/avatar"] = {
	  showButtons: false
	};
	
	structure["/langset"] = {
	  showButtons: false
	};
	
	structure["/about"] = {
	  showNext: true,
	  menu: true,
	  menuSection: "overview",
	  id: 'page.about'
	};
	
	structure["/overallstudyresults"] = {
	  showButtons: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "overview",
	  id: 'page.overallstudyresults'
	};
	
	structure["/health"] = {
	  showButtons: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "overview",
	  id: 'page.healthandchemicals'
	};
	
	structure["/readinggraphs"] = {
	  showButtons: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "personal_results",
	  id: 'page.graphreading'
	};
	
	structure["/summary"] = {
	  showNext: true,
	  showPrevious: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "personal_results",
	  id: 'app.pages.summary'
	};
	
	structure["/chemicals/bisphenols"] = {
	  group: 'bisphenols',
	  showNext: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "personal_results",
	  id: 'chemicals.bisphenols',
	  summary: true
	};
	
	structure["/chemicals/antimicrobials"] = {
	  group: 'antimicrobials',
	  showNext: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "personal_results",
	  id: 'chemicals.antimicrobials',
	  summary: true
	};
	
	structure["/chemicals/chlorinated_phenols"] = {
	  group: 'chlorinated_phenols',
	  showNext: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "personal_results",
	  id: 'chemicals.chlorinated_phenols',
	  summary: true
	};
	
	structure["/chemicals/parabens"] = {
	  group: 'parabens',
	  showNext: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "personal_results",
	  id: 'chemicals.parabens',
	  summary: true
	};
	
	structure["/chemicals/uv_filters"] = {
	  group: 'uv_filters',
	  showNext: true,
	  FAQ: true,
	  menu: true,
	  menuSection: "personal_results",
	  id: 'chemicals.uv_filters',
	  summary: true
	};
	
	structure["/community_action"] = {
	  showButtons: true,
	  FAQ: true,
	  menu: true,
	  menuSection: null,
	  id: 'page.community_action'
	};
	
	// structure["/survey"] = {
	//   showButtons: true,
	//   FAQ: false,
	//   menu: true,
	//   menuSection: null,
	//   id: 'page.survey',
	// };
	
	structure["/conclusion"] = {
	  showButtons: true,
	  // showPrevious: true,
	  FAQ: true,
	  menu: true,
	  menuSection: null,
	  id: 'page.conclusion'
	};
	
	structure["/faqpage"] = {
	  // showButtons: true,
	  showPrevious: true,
	  FAQ: false,
	  menu: true,
	  menuSection: null,
	  id: 'common_questions' // for content_en.yaml mapping of title
	  // hideinmenu: false
	};
	
	structure["/printpage"] = {
	  showButtons: false,
	  FAQ: false,
	  menu: true,
	  id: 'page.print_page', // for content_en.yaml mapping of title
	  buttoncolorclass: 'lowpriority',
	  hideinmenu: true
	};
	
	structure["/appendix"] = {
	  showPrevious: true,
	  FAQ: false,
	  menu: true,
	  id: 'page.appendix_page', // for content_en.yaml mapping of title
	  hideinmenu: true
	};
	
	exports.default = structure;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	__webpack_require__(726);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    _classCallCheck(this, Modal);
	
	    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	  }
	
	  _createClass(Modal, [{
	    key: 'onClose',
	    value: function onClose(e) {
	      // console.log("close modal");
	      e.stopPropagation();
	      e.preventDefault();
	      if (this.props.onClose !== undefined) {
	        this.props.onClose();
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = "modal " + (this.props.fullScreen ? 'full-screen ' : '') + (this.props.className === undefined ? "" : this.props.className);
	      return React.createElement(
	        'div',
	        { className: className },
	        React.createElement(
	          'div',
	          { className: 'contents-wrapper' },
	          React.createElement(
	            'div',
	            { className: 'contents' },
	            this.props.children
	          ),
	          React.createElement(
	            'div',
	            { className: 'modal-buttons' },
	            React.createElement(
	              'a',
	              { href: '#', className: 'button right', onClick: this.onClose.bind(this) },
	              React.createElement(_reactIntl.FormattedMessage, { id: 'close', defaultMessage: 'Cerrar' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	Modal.defaultProps = {
	  fullScreen: true,
	  className: ''
	};
	exports.default = Modal;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = safeUrl;
	function safeUrl(url) {
	  return ("") === undefined ? url : "" + ("") + url;
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.5';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading and trailing whitespace. */var reTrim=/^\s+|\s+$/g,reTrimStart=/^\s+/,reTrimEnd=/\s+$/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos='[\'\u2019]',rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
	'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
	'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010A':'C','\u010C':'C','\u0107':'c','\u0109':'c','\u010B':'c','\u010D':'c','\u010E':'D','\u0110':'D','\u010F':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011A':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011B':'e','\u011C':'G','\u011E':'G','\u0120':'G','\u0122':'G','\u011D':'g','\u011F':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012A':'I','\u012C':'I','\u012E':'I','\u0130':'I','\u0129':'i','\u012B':'i','\u012D':'i','\u012F':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013B':'L','\u013D':'L','\u013F':'L','\u0141':'L','\u013A':'l','\u013C':'l','\u013E':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014A':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014B':'n','\u014C':'O','\u014E':'O','\u0150':'O','\u014D':'o','\u014F':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015A':'S','\u015C':'S','\u015E':'S','\u0160':'S','\u015B':'s','\u015D':'s','\u015F':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016A':'U','\u016C':'U','\u016E':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016B':'u','\u016D':'u','\u016F':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017B':'Z','\u017D':'Z','\u017A':'z','\u017C':'z','\u017E':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017F':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof global==='undefined'?'undefined':_typeof(global))=='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=(typeof self==='undefined'?'undefined':_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?'undefined':_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?'undefined':_typeof(module))=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*//**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */var asciiSize=baseProperty('length');/**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function asciiToArray(string){return string.split('');}/**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */function baseIsNaN(value){return value!==value;}/**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */function baseUnary(func){return function(value){return func(value);};}/**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */function cacheHas(cache,key){return cache.has(key);}/**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */var deburrLetter=basePropertyOf(deburredLetters);/**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function getValue(object,key){return object==null?undefined:object[key];}/**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */function hasUnicode(string){return reHasUnicode.test(string);}/**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function safeGet(object,key){return key=='__proto__'?undefined:object[key];}/**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*//**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined,symIterator=_Symbol?_Symbol.iterator:undefined,symToStringTag=_Symbol?_Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */function baseLodash(){}// No operation performed.
	/**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */lodash.templateSettings={/**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'escape':reEscape,/**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'evaluate':reEvaluate,/**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'interpolate':reInterpolate,/**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */'variable':'',/**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */'imports':{/**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*//**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */function listCacheClear(){this.__data__=[];this.size=0;}/**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*//**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*//**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
	SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*//**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function stackGet(key){return this.__data__.get(key);}/**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function stackHas(key){return this.__data__.has(key);}/**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*//**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}/**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});return result;}if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEach=createBaseEach(baseForOwn);/**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
	baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseFor=createBaseFor();/**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseForRight=createBaseFor(true);/**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */function baseGt(value,other){return value>other;}/**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	if(typeof value=='function'){return value;}if(value==null){return identity;}if((typeof value==='undefined'?'undefined':_typeof(value))=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */function baseLt(value,other){return value<other;}/**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){if(isObject(srcValue)){stack||(stack=new Stack());baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||srcIndex&&isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */function baseOrderBy(collection,iteratees,orders){var index=-1;iteratees=arrayMap(iteratees.length?iteratees:[identity],baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
	// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */function baseSample(collection){return arraySample(values(collection));}/**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndexBy(array,value,iteratee,retHighest){value=iteratee(value);var low=0,high=array==null?0:array.length,valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */function castFunction(value){return typeof value=='function'?value:identity;}/**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */var castRest=baseRest;/**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	// that causes it, under certain circumstances, to provide the same value for
	// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	// for more details.
	//
	// This also ensures a stable sort in V8 and other engines.
	// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	return object.index-other.index;}/**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
	// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	// for more details.
	var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
	// See https://es5.github.io/#x13.2.2 for more details.
	return isObject(result)?result:thisBinding;};}/**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
	start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision){// Shift with exponential notation to avoid floating-point issues.
	// See [MDN](https://mdn.io/round#Examples) for more details.
	var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(array);if(stacked&&stack.get(other)){return stacked==other;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
	while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
	if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
	// Invalid dates are coerced to `NaN`.
	return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
	// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	// for more details.
	return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
	stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked&&stack.get(other)){return stacked==other;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
	if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
	if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */function isIndex(value,length){var type=typeof value==='undefined'?'undefined':_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index==='undefined'?'undefined':_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value==='undefined'?'undefined':_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */function isKeyable(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */var isMaskable=coreJsData?isFunction:stubFalse;/**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
	if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
	if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
	newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
	var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
	value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
	value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
	if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
	if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
	data[0]=source[0];data[1]=newBitmask;return data;}/**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */function objectToString(value){return nativeObjectToString.call(value);}/**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var setData=shortOut(baseSetData);/**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var setToString=shortOut(baseSetToString);/**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*//**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */function head(array){return array&&array.length?array[0]:undefined;}/**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */var pull=baseRest(pullAll);/**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */var zip=baseRest(unzip);/**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */function tap(value,interceptor){interceptor(value);return value;}/**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */function thru(value,interceptor){return interceptor(value);}/**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */function wrapperChain(){return chain(this);}/**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */function wrapperToIterator(){return this;}/**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*//**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */var find=createFind(findIndex);/**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */var findLast=createFind(findLastIndex);/**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*//**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*//**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
	lastInvokeTime=time;// Start the timer for the trailing edge.
	timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
	return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
	// trailing edge, the system time has gone backwards and we're treating
	// it as the trailing edge, or we've hit the `maxWait` limit.
	return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
	timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
	// debounced at least once.
	if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
	timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
	memoize.Cache=MapCache;/**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */function once(func){return before(2,func);}/**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */function unary(func){return ary(func,1);}/**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*//**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */var gt=createRelationalOperation(baseGt);/**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */var isArray=Array.isArray;/**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */var isBuffer=nativeIsBuffer||stubFalse;/**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */function isEqual(value,other){return baseIsEqual(value,other);}/**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed arrays and other constructors.
	var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */function isObject(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */function isObjectLike(value){return value!=null&&(typeof value==='undefined'?'undefined':_typeof(value))=='object';}/**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
	// Perform the `toStringTag` check first to avoid errors with some
	// ActiveX objects in IE.
	return isNumber(value)&&value!=+value;}/**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */function isNull(value){return value===null;}/**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */function isNil(value){return value==null;}/**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */function isSymbol(value){return(typeof value==='undefined'?'undefined':_typeof(value))=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */function isUndefined(value){return value===undefined;}/**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */var lt=createRelationalOperation(baseLt);/**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=value.replace(reTrim,'');var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*//**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */var at=flatRest(baseAt);/**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */var invoke=baseRest(baseInvoke);/**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
	if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */var toPairs=createToPairs(keys);/**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */var toPairsIn=createToPairs(keysIn);/**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*//**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*//**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */var lowerFirst=createCaseFirst('toLowerCase');/**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
	// (http://ejohn.org/blog/javascript-micro-templating/)
	// and Laura Doktorova's doT.js (https://github.com/olado/doT).
	var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
	var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
	var sourceURL='//# sourceURL='+('sourceURL'in options?options.sourceURL:'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
	source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
	if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
	// order to produce the correct `offset` value.
	return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
	// code to add the data object to the top of the scope chain.
	var variable=options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Cleanup code by stripping empty strings.
	source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
	source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
	// the `source` property as a convenience for inlining compiled templates.
	result.source=source;if(isError(result)){throw result;}return result;}/**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */function toLower(value){return toString(value).toLowerCase();}/**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */function toUpper(value){return toString(value).toUpperCase();}/**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrim,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimEnd,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */var upperFirst=createCaseFirst('toUpperCase');/**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*//**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */function constant(value){return function(){return value;};}/**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flow=createFlow();/**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flowRight=createFlow(true);/**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */function identity(value){return value;}/**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */function noop(){}// No operation performed.
	/**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */var over=createOver(arrayMap);/**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */var overEvery=createOver(arrayEvery);/**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */var overSome=createOver(arraySome);/**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */var range=createRange();/**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */var rangeRight=createRange(true);/**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */function stubArray(){return[];}/**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */function stubFalse(){return false;}/**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */function stubObject(){return{};}/**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */function stubString(){return'';}/**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */function stubTrue(){return true;}/**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*//**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */var ceil=createRound('ceil');/**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */var floor=createRound('floor');/**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */function mean(array){return baseMean(array,identity);}/**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */var round=createRound('round');/**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
	lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
	lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
	mixin(lodash,lodash);/*------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
	lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
	lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*//**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */lodash.VERSION=VERSION;// Assign default placeholders.
	arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
	arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
	arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
	isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
	arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'',names=realNames[key]||(realNames[key]=[]);names.push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
	LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
	lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
	lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/// Export lodash.
	var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
	if("function"=='function'&&_typeof(__webpack_require__(40))=='object'&&__webpack_require__(40)){// Expose Lodash on the global object to prevent errors when Lodash is
	// loaded by a script tag in the presence of an AMD loader.
	// See http://requirejs.org/docs/errors.html#mismatch for more details.
	// Use `_.noConflict` to remove Lodash from the global object.
	root._=_;// Define as an anonymous module so, through path mapping, it can be
	// referenced as the "underscore" module.
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return _;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
	else if(freeModule){// Export for Node.js.
	(freeModule.exports=_)._=_;// Export for CommonJS support.
	freeExports._=_;}else{// Export to the global object.
	root._=_;}}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(240)(module)))

/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function Feature(object, stream) {
	    streamGeometry(object.geometry, stream);
	  },
	  FeatureCollection: function FeatureCollection(object, stream) {
	    var features = object.features,
	        i = -1,
	        n = features.length;
	    while (++i < n) {
	      streamGeometry(features[i].geometry, stream);
	    }
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function Sphere(object, stream) {
	    stream.sphere();
	  },
	  Point: function Point(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function MultiPoint(object, stream) {
	    var coordinates = object.coordinates,
	        i = -1,
	        n = coordinates.length;
	    while (++i < n) {
	      object = coordinates[i], stream.point(object[0], object[1], object[2]);
	    }
	  },
	  LineString: function LineString(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function MultiLineString(object, stream) {
	    var coordinates = object.coordinates,
	        i = -1,
	        n = coordinates.length;
	    while (++i < n) {
	      streamLine(coordinates[i], stream, 0);
	    }
	  },
	  Polygon: function Polygon(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function MultiPolygon(object, stream) {
	    var coordinates = object.coordinates,
	        i = -1,
	        n = coordinates.length;
	    while (++i < n) {
	      streamPolygon(coordinates[i], stream);
	    }
	  },
	  GeometryCollection: function GeometryCollection(object, stream) {
	    var geometries = object.geometries,
	        i = -1,
	        n = geometries.length;
	    while (++i < n) {
	      streamGeometry(geometries[i], stream);
	    }
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1,
	      n = coordinates.length - closed,
	      coordinate;
	  stream.lineStart();
	  while (++i < n) {
	    coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  }stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1,
	      n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) {
	    streamLine(coordinates[i], stream, 1);
	  }stream.polygonEnd();
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _path = __webpack_require__(392);
	
	Object.defineProperty(exports, "path", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_path).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var array = Array.prototype;
	
	var map = exports.map = array.map;
	var slice = exports.slice = array.slice;

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x) {
	  return function constant() {
	    return x;
	  };
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Api = undefined;
	
	var _d = __webpack_require__(51);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _mobx = __webpack_require__(80);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _Locale = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Api = exports.Api = (0, _mobx.observable)({
	  domain: 'https://ikids-admin.reportback.org/api/v1',
	  auth: {
	    access_token: "",
	    client: "",
	    uid: "",
	    expiry: ""
	  },
	  authenticate: (0, _mobx.action)('authenticate', function (access_code) {
	    var _this = this;
	
	    var formData = new FormData();
	    formData.append('access_code', access_code.toUpperCase());
	
	    var params = {
	      method: 'POST',
	      body: formData
	    };
	
	    var promise = fetch(this.domain + '/auth/sign_in', params).then(function (response) {
	      ///window.localStorage.setItem('access_code', access_code.toUpperCase());
	      _this._set_headers(response, 4);
	      return response.json();
	    });
	
	    return promise;
	  }),
	
	  getURL: (0, _mobx.action)('get', function (target) {
	    var _this2 = this;
	
	    //no-cors because chrome gets confused with 204 results that do not return the "Access-Control-Allow-Origin" header
	    var myHeaders = this._get_headers('getURL');
	    // console.log("getURL "+target + "\nmyHeaders="+JSON.stringify(myHeaders)); //XXX
	    var promise = fetch(target, { headers: myHeaders }); //mode: "no-cors",
	
	    promise.then(function (response) {
	      _this2._set_headers(response, 3); // this won't be useful since csv/json files do not return a token. only sign_in does
	      if (response.status === 401) {
	        var thehash = window.location.hash;
	        // console.log("getURL error at "+thehash+"=>"+target);
	        if (thehash != "#/" && thehash != "#/login") {
	          _this2.props.history.push("/login");
	          window.scrollTo(0, 0);
	        }
	      }
	    });
	
	    return promise;
	  }),
	
	  get: (0, _mobx.action)('get', function (target) {
	    var _this3 = this;
	
	    var myHeaders = this._get_headers('get');
	    // console.log("get "+target + "\nmyHeaders="+JSON.stringify(myHeaders)); //XXX
	    var promise = fetch(this.domain + target, { headers: myHeaders });
	
	    promise.then(function (response) {
	      _this3._set_headers(response, 3); // this won't be useful since csv/json files do not return a token. only sign_in does
	    });
	
	    return promise;
	  }),
	
	  postURL: (0, _mobx.action)('post', function (target, formData) {
	    var _this4 = this;
	
	    var promise = fetch(target, { headers: this._get_headers(), method: 'POST', body: formData });
	
	    promise.then(function (response) {
	      _this4._set_headers(response, 2);
	    });
	
	    return promise;
	  }),
	
	  post: (0, _mobx.action)('post', function (target, formData) {
	    var _this5 = this;
	
	    var promise = fetch(this.domain + target, { headers: this._get_headers(), method: 'POST', body: formData });
	
	    promise.then(function (response) {
	      _this5._set_headers(response, 2);
	    });
	
	    return promise;
	  }),
	
	  json: (0, _mobx.action)('json', function (target) {
	    return this.get(target).then(function (response) {
	      return response.json();
	    });
	  }),
	
	  csv: (0, _mobx.action)('csv', function (target) {
	    return this.get(target).then(function (response) {
	      return response.text();
	    }).then(function (text) {
	      return d3.csvParse(text);
	    });
	  }),
	
	  logout: (0, _mobx.action)('logout', function () {
	    ///this.auth.access_code = "";
	    this.auth.access_token = "";
	    this.auth.client = "";
	    this.auth.uid = "";
	    this.auth.expiry = "";
	
	    ///window.localStorage.setItem('access_code', '');
	    window.localStorage.setItem('access-token', '');
	    window.localStorage.setItem('client', '');
	    window.localStorage.setItem('uid', '');
	    window.localStorage.setItem('expiry', '');
	  }),
	
	  _get_headers: function _get_headers(name) {
	    // console.log("_get_headers")
	    if (this.auth.access_token !== "") {
	      var result = {
	        'access-token': this.auth.access_token,
	        'token-type': 'Bearer',
	        'client': this.auth.client,
	        'uid': this.auth.uid,
	        'expiry': this.auth.expiry
	        //console.log("_get_headers: " + name + "=>" + JSON.stringify(result));
	      };return result;
	    } else if (window.localStorage.getItem('access-token') !== "") {
	      return {
	        'access-token': window.localStorage.getItem('access-token'),
	        'token-type': 'Bearer',
	        'client': window.localStorage.getItem('client'),
	        'uid': window.localStorage.getItem('uid'),
	        'expiry': window.localStorage.getItem('expiry')
	      };
	    } else {
	      //
	      // send via GET args (XXX kinda works but doesn't authenticate because probably can tell we are spoofing when we try via firefox when logged in on chrome)
	      //
	      //1/2--normally chosen via user, so set them here via get params
	      //if (helpers.findGetParameter('language')) {
	      //  window.localStorage.setItem('language', helpers.findGetParameter('language'));
	      //  window.localStorage.setItem('avatar', helpers.findGetParameter('avatar'));
	      //}
	      //
	      //2/2--for PDF printing service... send args here via get parameters
	      return {
	        'access-token': _helpers2.default.findGetParameter('access-token'),
	        'token-type': 'Bearer',
	        'client': _helpers2.default.findGetParameter('client'),
	        'uid': _helpers2.default.findGetParameter('uid'),
	        'expiry': _helpers2.default.findGetParameter('expiry')
	      };
	    } // end-else
	  } // end _get_headers
	
	
	  , _set_headers: function _set_headers(response, num) {
	    // console.log("_set_headers "+num);
	    // console.log("access-token=" + response.headers.get('access-token'));
	
	    if (response.headers.get('access-token') !== null && response.headers.get('access-token') !== '') {
	      this.auth.access_token = response.headers.get('access-token');
	      this.auth.client = response.headers.get('client');
	      this.auth.uid = response.headers.get('uid');
	      this.auth.expiry = response.headers.get('expiry');
	
	      window.localStorage.setItem('access-token', response.headers.get('access-token'));
	      window.localStorage.setItem('client', response.headers.get('client'));
	      window.localStorage.setItem('uid', response.headers.get('uid'));
	      window.localStorage.setItem('expiry', response.headers.get('expiry'));
	    }
	  } // end _set_headers
	
	  , authenticateshell: function authenticateshell(get_access_code, stateobj) {
	    return Api.authenticate(get_access_code).then(function (response) {
	      // console.log("API RESPONSE");
	      // console.log(response);
	      if (response.success === false) {
	        //this.setState({ error: true })
	      } else {
	        // this.props.history.push('/avatar');
	        stateobj.loadMeasurements();
	        stateobj.loadHeadlines();
	      }
	    }); // end-then
	  } // end-authenticateshell
	
	});

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(232);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(233);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(234);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(130);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(82);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(235);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(236);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(83);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(237);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatch = __webpack_require__(290);
	
	Object.defineProperty(exports, "dispatch", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dispatch).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x) {
	  return function () {
	    return x;
	  };
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return new Adder();
	};
	
	function Adder() {
	  this.reset();
	} // Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function reset() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function add(y) {
	    _add(temp, y, this.t);
	    _add(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;else this.s = temp.t;
	  },
	  valueOf: function valueOf() {
	    return this.s;
	  }
	};
	
	var temp = new Adder();
	
	function _add(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = a - av + (b - bv);
	}

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return Math.random();
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function isNothing(subject) {
	  return typeof subject === 'undefined' || subject === null;
	}
	
	function isObject(subject) {
	  return (typeof subject === 'undefined' ? 'undefined' : _typeof(subject)) === 'object' && subject !== null;
	}
	
	function toArray(sequence) {
	  if (Array.isArray(sequence)) return sequence;else if (isNothing(sequence)) return [];
	
	  return [sequence];
	}
	
	function extend(target, source) {
	  var index, length, key, sourceKeys;
	
	  if (source) {
	    sourceKeys = Object.keys(source);
	
	    for (index = 0, length = sourceKeys.length; index < length; index += 1) {
	      key = sourceKeys[index];
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	function repeat(string, count) {
	  var result = '',
	      cycle;
	
	  for (cycle = 0; cycle < count; cycle += 1) {
	    result += string;
	  }
	
	  return result;
	}
	
	function isNegativeZero(number) {
	  return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
	}
	
	module.exports.isNothing = isNothing;
	module.exports.isObject = isObject;
	module.exports.toArray = toArray;
	module.exports.repeat = repeat;
	module.exports.isNegativeZero = isNegativeZero;
	module.exports.extend = extend;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint-disable max-len*/
	
	var common = __webpack_require__(38);
	var YAMLException = __webpack_require__(54);
	var Type = __webpack_require__(7);
	
	function compileList(schema, name, result) {
	  var exclude = [];
	
	  schema.include.forEach(function (includedSchema) {
	    result = compileList(includedSchema, name, result);
	  });
	
	  schema[name].forEach(function (currentType) {
	    result.forEach(function (previousType, previousIndex) {
	      if (previousType.tag === currentType.tag && previousType.kind === currentType.kind) {
	        exclude.push(previousIndex);
	      }
	    });
	
	    result.push(currentType);
	  });
	
	  return result.filter(function (type, index) {
	    return exclude.indexOf(index) === -1;
	  });
	}
	
	function compileMap() /* lists... */{
	  var result = {
	    scalar: {},
	    sequence: {},
	    mapping: {},
	    fallback: {}
	  },
	      index,
	      length;
	
	  function collectType(type) {
	    result[type.kind][type.tag] = result['fallback'][type.tag] = type;
	  }
	
	  for (index = 0, length = arguments.length; index < length; index += 1) {
	    arguments[index].forEach(collectType);
	  }
	  return result;
	}
	
	function Schema(definition) {
	  this.include = definition.include || [];
	  this.implicit = definition.implicit || [];
	  this.explicit = definition.explicit || [];
	
	  this.implicit.forEach(function (type) {
	    if (type.loadKind && type.loadKind !== 'scalar') {
	      throw new YAMLException('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
	    }
	  });
	
	  this.compiledImplicit = compileList(this, 'implicit', []);
	  this.compiledExplicit = compileList(this, 'explicit', []);
	  this.compiledTypeMap = compileMap(this.compiledImplicit, this.compiledExplicit);
	}
	
	Schema.DEFAULT = null;
	
	Schema.create = function createSchema() {
	  var schemas, types;
	
	  switch (arguments.length) {
	    case 1:
	      schemas = Schema.DEFAULT;
	      types = arguments[0];
	      break;
	
	    case 2:
	      schemas = arguments[0];
	      types = arguments[1];
	      break;
	
	    default:
	      throw new YAMLException('Wrong number of arguments for Schema.create function');
	  }
	
	  schemas = common.toArray(schemas);
	  types = common.toArray(types);
	
	  if (!schemas.every(function (schema) {
	    return schema instanceof Schema;
	  })) {
	    throw new YAMLException('Specified list of super schemas (or a single Schema object) contains a non-Schema object.');
	  }
	
	  if (!types.every(function (type) {
	    return type instanceof Type;
	  })) {
	    throw new YAMLException('Specified list of YAML types (or a single Type object) contains a non-Type object.');
	  }
	
	  return new Schema({
	    include: schemas,
	    explicit: types
	  });
	};
	
	module.exports = Schema;

/***/ },
/* 40 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 41 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x) {
	  return x === null ? NaN : +x;
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.spherical = spherical;
	exports.cartesian = cartesian;
	exports.cartesianDot = cartesianDot;
	exports.cartesianCross = cartesianCross;
	exports.cartesianAddInPlace = cartesianAddInPlace;
	exports.cartesianScale = cartesianScale;
	exports.cartesianNormalizeInPlace = cartesianNormalizeInPlace;
	
	var _math = __webpack_require__(2);
	
	function spherical(cartesian) {
	  return [(0, _math.atan2)(cartesian[1], cartesian[0]), (0, _math.asin)(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0],
	      phi = spherical[1],
	      cosPhi = (0, _math.cos)(phi);
	  return [cosPhi * (0, _math.cos)(lambda), cosPhi * (0, _math.sin)(lambda), (0, _math.sin)(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = (0, _math.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.azimuthalRaw = azimuthalRaw;
	exports.azimuthalInvert = azimuthalInvert;
	
	var _math = __webpack_require__(2);
	
	function azimuthalRaw(scale) {
	  return function (x, y) {
	    var cx = (0, _math.cos)(x),
	        cy = (0, _math.cos)(y),
	        k = scale(cx * cy);
	    return [k * cy * (0, _math.sin)(x), k * (0, _math.sin)(y)];
	  };
	}
	
	function azimuthalInvert(angle) {
	  return function (x, y) {
	    var z = (0, _math.sqrt)(x * x + y * y),
	        c = angle(z),
	        sc = (0, _math.sin)(c),
	        cc = (0, _math.cos)(c);
	    return [(0, _math.atan2)(x * sc, z * cc), (0, _math.asin)(z && y * sc / z)];
	  };
	}

/***/ },
/* 44 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hue = hue;
	exports.gamma = gamma;
	exports.default = nogamma;
	
	var _constant = __webpack_require__(177);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function linear(a, d) {
	  return function (t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constant2.default)(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function (a, b) {
	    return b - a ? exponential(a, b, y) : (0, _constant2.default)(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : (0, _constant2.default)(isNaN(a) ? b : a);
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linearish = linearish;
	exports.default = linear;
	
	var _d3Array = __webpack_require__(9);
	
	var _d3Interpolate = __webpack_require__(14);
	
	var _continuous = __webpack_require__(66);
	
	var _continuous2 = _interopRequireDefault(_continuous);
	
	var _tickFormat = __webpack_require__(467);
	
	var _tickFormat2 = _interopRequireDefault(_tickFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function (count) {
	    var d = domain();
	    return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function (count, specifier) {
	    return (0, _tickFormat2.default)(domain(), count, specifier);
	  };
	
	  scale.nice = function (count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = (0, _d3Array.tickIncrement)(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = (0, _d3Array.tickIncrement)(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = (0, _d3Array.tickIncrement)(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = (0, _continuous2.default)(_continuous.deinterpolateLinear, _d3Interpolate.interpolateNumber);
	
	  scale.copy = function () {
	    return (0, _continuous.copy)(scale, linear());
	  };
	
	  return linearish(scale);
	}

/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.acos = acos;
	exports.asin = asin;
	var abs = exports.abs = Math.abs;
	var atan2 = exports.atan2 = Math.atan2;
	var cos = exports.cos = Math.cos;
	var max = exports.max = Math.max;
	var min = exports.min = Math.min;
	var sin = exports.sin = Math.sin;
	var sqrt = exports.sqrt = Math.sqrt;
	
	var epsilon = exports.epsilon = 1e-12;
	var pi = exports.pi = Math.PI;
	var halfPi = exports.halfPi = pi / 2;
	var tau = exports.tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}

/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series) {
	  var n = series.length,
	      o = new Array(n);
	  while (--n >= 0) {
	    o[n] = n;
	  }return o;
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.edges = exports.circles = exports.cells = exports.beaches = exports.epsilon2 = exports.epsilon = undefined;
	exports.default = Diagram;
	
	var _Beach = __webpack_require__(566);
	
	var _Cell = __webpack_require__(212);
	
	var _Circle = __webpack_require__(213);
	
	var _Edge = __webpack_require__(122);
	
	var _RedBlackTree = __webpack_require__(123);
	
	var _RedBlackTree2 = _interopRequireDefault(_RedBlackTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var epsilon = exports.epsilon = 1e-6;
	var epsilon2 = exports.epsilon2 = 1e-12;
	var beaches = exports.beaches = undefined;
	var cells = exports.cells = undefined;
	var circles = exports.circles = undefined;
	var edges = exports.edges = undefined;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1] || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  exports.edges = edges = [];
	  exports.cells = cells = new Array(sites.length);
	  exports.beaches = beaches = new _RedBlackTree2.default();
	  exports.circles = circles = new _RedBlackTree2.default();
	
	  while (true) {
	    circle = _Circle.firstCircle;
	    if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
	      if (site[0] !== x || site[1] !== y) {
	        (0, _Beach.addBeach)(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      (0, _Beach.removeBeach)(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  (0, _Cell.sortCellHalfedges)();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    (0, _Edge.clipEdges)(x0, y0, x1, y1);
	    (0, _Cell.clipCells)(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  exports.beaches = beaches = exports.circles = circles = exports.edges = edges = exports.cells = cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function polygons() {
	    var edges = this.edges;
	
	    return this.cells.map(function (cell) {
	      var polygon = cell.halfedges.map(function (i) {
	        return (0, _Cell.cellHalfedgeStart)(cell, edges[i]);
	      });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function triangles() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function (cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function links() {
	    return this.edges.filter(function (edge) {
	      return edge.right;
	    }).map(function (edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function find(x, y, radius) {
	    var that = this,
	        i0,
	        i1 = that._found || 0,
	        n = that.cells.length,
	        cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) {
	      if (++i1 >= n) return null;
	    }var dx = x - cell.site[0],
	        dy = y - cell.site[1],
	        d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function (e) {
	        var edge = that.edges[e],
	            v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0],
	            vy = y - v[1],
	            v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _package = __webpack_require__(575);
	
	Object.defineProperty(exports, "version", {
	  enumerable: true,
	  get: function get() {
	    return _package.version;
	  }
	});
	
	var _d3Array = __webpack_require__(9);
	
	Object.keys(_d3Array).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Array[key];
	    }
	  });
	});
	
	var _d3Axis = __webpack_require__(262);
	
	Object.keys(_d3Axis).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Axis[key];
	    }
	  });
	});
	
	var _d3Brush = __webpack_require__(266);
	
	Object.keys(_d3Brush).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Brush[key];
	    }
	  });
	});
	
	var _d3Chord = __webpack_require__(271);
	
	Object.keys(_d3Chord).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Chord[key];
	    }
	  });
	});
	
	var _d3Collection = __webpack_require__(59);
	
	Object.keys(_d3Collection).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Collection[key];
	    }
	  });
	});
	
	var _d3Color = __webpack_require__(18);
	
	Object.keys(_d3Color).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Color[key];
	    }
	  });
	});
	
	var _d3Contour = __webpack_require__(283);
	
	Object.keys(_d3Contour).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Contour[key];
	    }
	  });
	});
	
	var _d3Dispatch = __webpack_require__(34);
	
	Object.keys(_d3Dispatch).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Dispatch[key];
	    }
	  });
	});
	
	var _d3Drag = __webpack_require__(89);
	
	Object.keys(_d3Drag).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Drag[key];
	    }
	  });
	});
	
	var _d3Dsv = __webpack_require__(150);
	
	Object.keys(_d3Dsv).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Dsv[key];
	    }
	  });
	});
	
	var _d3Ease = __webpack_require__(151);
	
	Object.keys(_d3Ease).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Ease[key];
	    }
	  });
	});
	
	var _d3Fetch = __webpack_require__(306);
	
	Object.keys(_d3Fetch).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Fetch[key];
	    }
	  });
	});
	
	var _d3Force = __webpack_require__(313);
	
	Object.keys(_d3Force).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Force[key];
	    }
	  });
	});
	
	var _d3Format = __webpack_require__(93);
	
	Object.keys(_d3Format).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Format[key];
	    }
	  });
	});
	
	var _d3Geo = __webpack_require__(331);
	
	Object.keys(_d3Geo).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Geo[key];
	    }
	  });
	});
	
	var _d3Hierarchy = __webpack_require__(359);
	
	Object.keys(_d3Hierarchy).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Hierarchy[key];
	    }
	  });
	});
	
	var _d3Interpolate = __webpack_require__(14);
	
	Object.keys(_d3Interpolate).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Interpolate[key];
	    }
	  });
	});
	
	var _d3Path = __webpack_require__(28);
	
	Object.keys(_d3Path).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Path[key];
	    }
	  });
	});
	
	var _d3Polygon = __webpack_require__(393);
	
	Object.keys(_d3Polygon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Polygon[key];
	    }
	  });
	});
	
	var _d3Quadtree = __webpack_require__(105);
	
	Object.keys(_d3Quadtree).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Quadtree[key];
	    }
	  });
	});
	
	var _d3Random = __webpack_require__(413);
	
	Object.keys(_d3Random).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Random[key];
	    }
	  });
	});
	
	var _d3Scale = __webpack_require__(458);
	
	Object.keys(_d3Scale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Scale[key];
	    }
	  });
	});
	
	var _d3ScaleChromatic = __webpack_require__(418);
	
	Object.keys(_d3ScaleChromatic).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3ScaleChromatic[key];
	    }
	  });
	});
	
	var _d3Selection = __webpack_require__(8);
	
	Object.keys(_d3Selection).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Selection[key];
	    }
	  });
	});
	
	var _d3Shape = __webpack_require__(503);
	
	Object.keys(_d3Shape).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Shape[key];
	    }
	  });
	});
	
	var _d3Time = __webpack_require__(73);
	
	Object.keys(_d3Time).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Time[key];
	    }
	  });
	});
	
	var _d3TimeFormat = __webpack_require__(118);
	
	Object.keys(_d3TimeFormat).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3TimeFormat[key];
	    }
	  });
	});
	
	var _d3Timer = __webpack_require__(74);
	
	Object.keys(_d3Timer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Timer[key];
	    }
	  });
	});
	
	var _d3Transition = __webpack_require__(121);
	
	Object.keys(_d3Transition).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Transition[key];
	    }
	  });
	});
	
	var _d3Voronoi = __webpack_require__(565);
	
	Object.keys(_d3Voronoi).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Voronoi[key];
	    }
	  });
	});
	
	var _d3Zoom = __webpack_require__(570);
	
	Object.keys(_d3Zoom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _d3Zoom[key];
	    }
	  });
	});

/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 54 */
/***/ function(module, exports) {

	// YAML error class. http://stackoverflow.com/questions/8458984
	//
	'use strict';
	
	function YAMLException(reason, mark) {
	  // Super constructor
	  Error.call(this);
	
	  this.name = 'YAMLException';
	  this.reason = reason;
	  this.mark = mark;
	  this.message = (this.reason || '(unknown reason)') + (this.mark ? ' ' + this.mark.toString() : '');
	
	  // Include stack trace in error object
	  if (Error.captureStackTrace) {
	    // Chrome and NodeJS
	    Error.captureStackTrace(this, this.constructor);
	  } else {
	    // FF, IE 10+ and Safari 6+. Fallback for others
	    this.stack = new Error().stack || '';
	  }
	}
	
	// Inherit from Error
	YAMLException.prototype = Object.create(Error.prototype);
	YAMLException.prototype.constructor = YAMLException;
	
	YAMLException.prototype.toString = function toString(compact) {
	  var result = this.name + ': ';
	
	  result += this.reason || '(unknown reason)';
	
	  if (!compact && this.mark) {
	    result += ' ' + this.mark.toString();
	  }
	
	  return result;
	};
	
	module.exports = YAMLException;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// JS-YAML's default schema for `safeLoad` function.
	// It is not described in the YAML specification.
	//
	// This schema is based on standard YAML's Core schema and includes most of
	// extra types described at YAML tag repository. (http://yaml.org/type/)
	
	
	'use strict';
	
	var Schema = __webpack_require__(39);
	
	module.exports = new Schema({
	  include: [__webpack_require__(225)],
	  implicit: [__webpack_require__(669), __webpack_require__(662)],
	  explicit: [__webpack_require__(654), __webpack_require__(664), __webpack_require__(665), __webpack_require__(667)]
	});

/***/ },
/* 56 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(687);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(688);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(230);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(689);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(690);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(691);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(692);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(231);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(129);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(693);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(694);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(695);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(696);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(40)) === 'object' && __webpack_require__(40)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nest = __webpack_require__(278);
	
	Object.defineProperty(exports, "nest", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_nest).default;
	  }
	});
	
	var _set = __webpack_require__(279);
	
	Object.defineProperty(exports, "set", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_set).default;
	  }
	});
	
	var _map = __webpack_require__(86);
	
	Object.defineProperty(exports, "map", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_map).default;
	  }
	});
	
	var _keys = __webpack_require__(277);
	
	Object.defineProperty(exports, "keys", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_keys).default;
	  }
	});
	
	var _values = __webpack_require__(280);
	
	Object.defineProperty(exports, "values", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_values).default;
	  }
	});
	
	var _entries = __webpack_require__(276);
	
	Object.defineProperty(exports, "entries", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_entries).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x) {
	  return x = (0, _formatDecimal2.default)(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var _formatDecimal = __webpack_require__(94);
	
	var _formatDecimal2 = _interopRequireDefault(_formatDecimal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clipRectangle;
	
	var _math = __webpack_require__(2);
	
	var _buffer = __webpack_require__(159);
	
	var _buffer2 = _interopRequireDefault(_buffer);
	
	var _line = __webpack_require__(335);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _rejoin = __webpack_require__(162);
	
	var _rejoin2 = _interopRequireDefault(_rejoin);
	
	var _d3Array = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clipMax = 1e9,
	    clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipRectangle(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0,
	        a1 = 0;
	    if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
	      do {
	        stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      } while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return (0, _math.abs)(p[0] - x0) < _math.epsilon ? direction > 0 ? 0 : 3 : (0, _math.abs)(p[0] - x1) < _math.epsilon ? direction > 0 ? 2 : 1 : (0, _math.abs)(p[1] - y0) < _math.epsilon ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	  }
	
	  return function (stream) {
	    var activeStream = stream,
	        bufferStream = (0, _buffer2.default)(),
	        segments,
	        polygon,
	        ring,
	        x__,
	        y__,
	        v__,
	        // first point
	    x_,
	        y_,
	        v_,
	        // previous point
	    first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) {
	            if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
	          } else {
	            if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
	          }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = (0, _d3Array.merge)(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          (0, _rejoin2.default)(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if ((0, _line2.default)(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rotateRadians = rotateRadians;
	
	exports.default = function (rotate) {
	  rotate = rotateRadians(rotate[0] * _math.radians, rotate[1] * _math.radians, rotate.length > 2 ? rotate[2] * _math.radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * _math.radians, coordinates[1] * _math.radians);
	    return coordinates[0] *= _math.degrees, coordinates[1] *= _math.degrees, coordinates;
	  }
	
	  forward.invert = function (coordinates) {
	    coordinates = rotate.invert(coordinates[0] * _math.radians, coordinates[1] * _math.radians);
	    return coordinates[0] *= _math.degrees, coordinates[1] *= _math.degrees, coordinates;
	  };
	
	  return forward;
	};
	
	var _compose = __webpack_require__(163);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _math = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > _math.pi ? lambda - _math.tau : lambda < -_math.pi ? lambda + _math.tau : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= _math.tau) ? deltaPhi || deltaGamma ? (0, _compose2.default)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function (lambda, phi) {
	    return lambda += deltaLambda, [lambda > _math.pi ? lambda - _math.tau : lambda < -_math.pi ? lambda + _math.tau : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = (0, _math.cos)(deltaPhi),
	      sinDeltaPhi = (0, _math.sin)(deltaPhi),
	      cosDeltaGamma = (0, _math.cos)(deltaGamma),
	      sinDeltaGamma = (0, _math.sin)(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = (0, _math.cos)(phi),
	        x = (0, _math.cos)(lambda) * cosPhi,
	        y = (0, _math.sin)(lambda) * cosPhi,
	        z = (0, _math.sin)(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [(0, _math.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi), (0, _math.asin)(k * cosDeltaGamma + y * sinDeltaGamma)];
	  }
	
	  rotation.invert = function (lambda, phi) {
	    var cosPhi = (0, _math.cos)(phi),
	        x = (0, _math.cos)(lambda) * cosPhi,
	        y = (0, _math.sin)(lambda) * cosPhi,
	        z = (0, _math.sin)(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [(0, _math.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi), (0, _math.asin)(k * cosDeltaPhi - x * sinDeltaPhi)];
	  };
	
	  return rotation;
	}

/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	exports.transformer = transformer;
	function transformer(methods) {
	  return function (stream) {
	    var s = new TransformStream();
	    for (var key in methods) {
	      s[key] = methods[key];
	    }s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function point(x, y) {
	    this.stream.point(x, y);
	  },
	  sphere: function sphere() {
	    this.stream.sphere();
	  },
	  lineStart: function lineStart() {
	    this.stream.lineStart();
	  },
	  lineEnd: function lineEnd() {
	    this.stream.lineEnd();
	  },
	  polygonStart: function polygonStart() {
	    this.stream.polygonStart();
	  },
	  polygonEnd: function polygonEnd() {
	    this.stream.polygonEnd();
	  }
	};

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};

/***/ },
/* 65 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  return a = +a, b -= a, function (t) {
	    return a + b * t;
	  };
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deinterpolateLinear = deinterpolateLinear;
	exports.copy = copy;
	exports.default = continuous;
	
	var _d3Array = __webpack_require__(9);
	
	var _d3Interpolate = __webpack_require__(14);
	
	var _array = __webpack_require__(29);
	
	var _constant = __webpack_require__(107);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _number = __webpack_require__(185);
	
	var _number2 = _interopRequireDefault(_number);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= a = +a) ? function (x) {
	    return (x - a) / b;
	  } : (0, _constant2.default)(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function (a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function (x) {
	      return x <= a ? 0 : x >= b ? 1 : d(x);
	    };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function (a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function (t) {
	      return t <= 0 ? a : t >= 1 ? b : r(t);
	    };
	  };
	}
	
	function bimap(domain, range, deinterpolate, reinterpolate) {
	  var d0 = domain[0],
	      d1 = domain[1],
	      r0 = range[0],
	      r1 = range[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function (x) {
	    return r0(d0(x));
	  };
	}
	
	function polymap(domain, range, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range[i], range[i + 1]);
	  }
	
	  return function (x) {
	    var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range = unit,
	      interpolate = _d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
	  }
	
	  scale.invert = function (y) {
	    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function (_) {
	    return arguments.length ? (domain = _array.map.call(_, _number2.default), rescale()) : domain.slice();
	  };
	
	  scale.range = function (_) {
	    return arguments.length ? (range = _array.slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function (_) {
	    return range = _array.slice.call(_), interpolate = _d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function (_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function (_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  return rescale();
	}

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name) {
	  var fullname = (0, _namespace2.default)(name);
	  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
	};
	
	var _namespace = __webpack_require__(108);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	var _namespaces = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function creatorInherit(name) {
	  return function () {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === _namespaces.xhtml && document.documentElement.namespaceURI === _namespaces.xhtml ? document.createElement(name) : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function () {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}

/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	};

/***/ },
/* 69 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Basis = Basis;
	
	exports.default = function (context) {
	  return new Basis(context);
	};
	
	function _point(that, x, y) {
	  that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
	}
	
	exports.point = _point;
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    switch (this._point) {
	      case 3:
	        _point(this, this._x1, this._y1); // proceed
	      case 2:
	        this._context.lineTo(this._x1, this._y1);break;
	    }
	    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
	      case 1:
	        this._point = 2;break;
	      case 2:
	        this._point = 3;this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default:
	        _point(this, x, y);break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};

/***/ },
/* 70 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cardinal = Cardinal;
	function _point(that, x, y) {
	  that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
	}
	
	exports.point = _point;
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    switch (this._point) {
	      case 2:
	        this._context.lineTo(this._x2, this._y2);break;
	      case 3:
	        _point(this, this._x1, this._y1);break;
	    }
	    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
	      case 1:
	        this._point = 2;this._x1 = x, this._y1 = y;break;
	      case 2:
	        this._point = 3; // proceed
	      default:
	        _point(this, x, y);break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	exports.default = function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function (tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}(0);

/***/ },
/* 71 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (context) {
	  return new Linear(context);
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
	      case 1:
	        this._point = 2; // proceed
	      default:
	        this._context.lineTo(x, y);break;
	    }
	  }
	};

/***/ },
/* 72 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _interval = __webpack_require__(11);
	
	Object.defineProperty(exports, "timeInterval", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_interval).default;
	  }
	});
	
	var _millisecond = __webpack_require__(531);
	
	Object.defineProperty(exports, "timeMillisecond", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_millisecond).default;
	  }
	});
	Object.defineProperty(exports, "timeMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _millisecond.milliseconds;
	  }
	});
	Object.defineProperty(exports, "utcMillisecond", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_millisecond).default;
	  }
	});
	Object.defineProperty(exports, "utcMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _millisecond.milliseconds;
	  }
	});
	
	var _second = __webpack_require__(534);
	
	Object.defineProperty(exports, "timeSecond", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_second).default;
	  }
	});
	Object.defineProperty(exports, "timeSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _second.seconds;
	  }
	});
	Object.defineProperty(exports, "utcSecond", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_second).default;
	  }
	});
	Object.defineProperty(exports, "utcSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _second.seconds;
	  }
	});
	
	var _minute = __webpack_require__(532);
	
	Object.defineProperty(exports, "timeMinute", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_minute).default;
	  }
	});
	Object.defineProperty(exports, "timeMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _minute.minutes;
	  }
	});
	
	var _hour = __webpack_require__(530);
	
	Object.defineProperty(exports, "timeHour", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hour).default;
	  }
	});
	Object.defineProperty(exports, "timeHours", {
	  enumerable: true,
	  get: function get() {
	    return _hour.hours;
	  }
	});
	
	var _day = __webpack_require__(529);
	
	Object.defineProperty(exports, "timeDay", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_day).default;
	  }
	});
	Object.defineProperty(exports, "timeDays", {
	  enumerable: true,
	  get: function get() {
	    return _day.days;
	  }
	});
	
	var _week = __webpack_require__(541);
	
	Object.defineProperty(exports, "timeWeek", {
	  enumerable: true,
	  get: function get() {
	    return _week.sunday;
	  }
	});
	Object.defineProperty(exports, "timeWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _week.sundays;
	  }
	});
	Object.defineProperty(exports, "timeSunday", {
	  enumerable: true,
	  get: function get() {
	    return _week.sunday;
	  }
	});
	Object.defineProperty(exports, "timeSundays", {
	  enumerable: true,
	  get: function get() {
	    return _week.sundays;
	  }
	});
	Object.defineProperty(exports, "timeMonday", {
	  enumerable: true,
	  get: function get() {
	    return _week.monday;
	  }
	});
	Object.defineProperty(exports, "timeMondays", {
	  enumerable: true,
	  get: function get() {
	    return _week.mondays;
	  }
	});
	Object.defineProperty(exports, "timeTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _week.tuesday;
	  }
	});
	Object.defineProperty(exports, "timeTuesdays", {
	  enumerable: true,
	  get: function get() {
	    return _week.tuesdays;
	  }
	});
	Object.defineProperty(exports, "timeWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _week.wednesday;
	  }
	});
	Object.defineProperty(exports, "timeWednesdays", {
	  enumerable: true,
	  get: function get() {
	    return _week.wednesdays;
	  }
	});
	Object.defineProperty(exports, "timeThursday", {
	  enumerable: true,
	  get: function get() {
	    return _week.thursday;
	  }
	});
	Object.defineProperty(exports, "timeThursdays", {
	  enumerable: true,
	  get: function get() {
	    return _week.thursdays;
	  }
	});
	Object.defineProperty(exports, "timeFriday", {
	  enumerable: true,
	  get: function get() {
	    return _week.friday;
	  }
	});
	Object.defineProperty(exports, "timeFridays", {
	  enumerable: true,
	  get: function get() {
	    return _week.fridays;
	  }
	});
	Object.defineProperty(exports, "timeSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _week.saturday;
	  }
	});
	Object.defineProperty(exports, "timeSaturdays", {
	  enumerable: true,
	  get: function get() {
	    return _week.saturdays;
	  }
	});
	
	var _month = __webpack_require__(533);
	
	Object.defineProperty(exports, "timeMonth", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_month).default;
	  }
	});
	Object.defineProperty(exports, "timeMonths", {
	  enumerable: true,
	  get: function get() {
	    return _month.months;
	  }
	});
	
	var _year = __webpack_require__(542);
	
	Object.defineProperty(exports, "timeYear", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_year).default;
	  }
	});
	Object.defineProperty(exports, "timeYears", {
	  enumerable: true,
	  get: function get() {
	    return _year.years;
	  }
	});
	
	var _utcMinute = __webpack_require__(537);
	
	Object.defineProperty(exports, "utcMinute", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utcMinute).default;
	  }
	});
	Object.defineProperty(exports, "utcMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _utcMinute.utcMinutes;
	  }
	});
	
	var _utcHour = __webpack_require__(536);
	
	Object.defineProperty(exports, "utcHour", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utcHour).default;
	  }
	});
	Object.defineProperty(exports, "utcHours", {
	  enumerable: true,
	  get: function get() {
	    return _utcHour.utcHours;
	  }
	});
	
	var _utcDay = __webpack_require__(535);
	
	Object.defineProperty(exports, "utcDay", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utcDay).default;
	  }
	});
	Object.defineProperty(exports, "utcDays", {
	  enumerable: true,
	  get: function get() {
	    return _utcDay.utcDays;
	  }
	});
	
	var _utcWeek = __webpack_require__(539);
	
	Object.defineProperty(exports, "utcWeek", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcSunday;
	  }
	});
	Object.defineProperty(exports, "utcWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcSundays;
	  }
	});
	Object.defineProperty(exports, "utcSunday", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcSunday;
	  }
	});
	Object.defineProperty(exports, "utcSundays", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcSundays;
	  }
	});
	Object.defineProperty(exports, "utcMonday", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcMonday;
	  }
	});
	Object.defineProperty(exports, "utcMondays", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcMondays;
	  }
	});
	Object.defineProperty(exports, "utcTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcTuesday;
	  }
	});
	Object.defineProperty(exports, "utcTuesdays", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcTuesdays;
	  }
	});
	Object.defineProperty(exports, "utcWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcWednesday;
	  }
	});
	Object.defineProperty(exports, "utcWednesdays", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcWednesdays;
	  }
	});
	Object.defineProperty(exports, "utcThursday", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcThursday;
	  }
	});
	Object.defineProperty(exports, "utcThursdays", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcThursdays;
	  }
	});
	Object.defineProperty(exports, "utcFriday", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcFriday;
	  }
	});
	Object.defineProperty(exports, "utcFridays", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcFridays;
	  }
	});
	Object.defineProperty(exports, "utcSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcSaturday;
	  }
	});
	Object.defineProperty(exports, "utcSaturdays", {
	  enumerable: true,
	  get: function get() {
	    return _utcWeek.utcSaturdays;
	  }
	});
	
	var _utcMonth = __webpack_require__(538);
	
	Object.defineProperty(exports, "utcMonth", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utcMonth).default;
	  }
	});
	Object.defineProperty(exports, "utcMonths", {
	  enumerable: true,
	  get: function get() {
	    return _utcMonth.utcMonths;
	  }
	});
	
	var _utcYear = __webpack_require__(540);
	
	Object.defineProperty(exports, "utcYear", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utcYear).default;
	  }
	});
	Object.defineProperty(exports, "utcYears", {
	  enumerable: true,
	  get: function get() {
	    return _utcYear.utcYears;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _timer = __webpack_require__(120);
	
	Object.defineProperty(exports, "now", {
	  enumerable: true,
	  get: function get() {
	    return _timer.now;
	  }
	});
	Object.defineProperty(exports, "timer", {
	  enumerable: true,
	  get: function get() {
	    return _timer.timer;
	  }
	});
	Object.defineProperty(exports, "timerFlush", {
	  enumerable: true,
	  get: function get() {
	    return _timer.timerFlush;
	  }
	});
	
	var _timeout = __webpack_require__(544);
	
	Object.defineProperty(exports, "timeout", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_timeout).default;
	  }
	});
	
	var _interval = __webpack_require__(543);
	
	Object.defineProperty(exports, "interval", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_interval).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value) {
	  var id = this._id;
	
	  name += "";
	
	  if (arguments.length < 2) {
	    var tween = (0, _schedule.get)(this.node(), id).tween;
	    for (var i = 0, n = tween.length, t; i < n; ++i) {
	      if ((t = tween[i]).name === name) {
	        return t.value;
	      }
	    }
	    return null;
	  }
	
	  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
	};
	
	exports.tweenValue = tweenValue;
	
	var _schedule = __webpack_require__(17);
	
	function tweenRemove(id, name) {
	  var tween0, tween1;
	  return function () {
	    var schedule = (0, _schedule.set)(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = tween0 = tween;
	      for (var i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1 = tween1.slice();
	          tween1.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	function tweenFunction(id, name, value) {
	  var tween0, tween1;
	  if (typeof value !== "function") throw new Error();
	  return function () {
	    var schedule = (0, _schedule.set)(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = (tween0 = tween).slice();
	      for (var t = { name: name, value: value }, i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1[i] = t;
	          break;
	        }
	      }
	      if (i === n) tween1.push(t);
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	function tweenValue(transition, name, value) {
	  var id = transition._id;
	
	  transition.each(function () {
	    var schedule = (0, _schedule.set)(this, id);
	    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
	  });
	
	  return function (node) {
	    return (0, _schedule.get)(node, id).value[name];
	  };
	}

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GLOBAL_locale = exports.locale = undefined;
	exports.default = loadMessages;
	
	var _d = __webpack_require__(51);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _marked = __webpack_require__(672);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _jsYaml = __webpack_require__(649);
	
	var _jsYaml2 = _interopRequireDefault(_jsYaml);
	
	var _State = __webpack_require__(217);
	
	var _en = __webpack_require__(731);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _es = __webpack_require__(732);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _content_en = __webpack_require__(733);
	
	var _content_en2 = _interopRequireDefault(_content_en);
	
	var _content_es = __webpack_require__(734);
	
	var _content_es2 = _interopRequireDefault(_content_es);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// not ok
	// import contentBase64 from './translations/locales/content_es.yaml';
	// export const locale = 'es';
	// new
	
	if (_helpers2.default.findGetParameter('language')) {
	  window.localStorage.setItem('language', _helpers2.default.findGetParameter('language'));
	  window.localStorage.setItem('avatar', _helpers2.default.findGetParameter('avatar'));
	}
	
	// previously set languages in app
	
	
	// ok -- loads en or es using loadMessages()
	//markdown npm -- https://www.npmjs.com/package/marked
	// Locale.js
	
	var possibleLocale = void 0;
	var prevLang = window.localStorage.getItem('language');
	if (prevLang) {
	  possibleLocale = prevLang;
	}
	
	// if the language is not previously set, get browser languge
	if (!possibleLocale) {
	  var browserLang = navigator.language;
	  // remove the country code part
	  if (browserLang.includes("-")) {
	    browserLang = browserLang.split("-")[0];
	  }
	  if (browserLang == "es" || browserLang == "en") {
	    possibleLocale = browserLang;
	  }
	}
	
	// if the browser language is not spanish or english, default to english
	if (!possibleLocale) {
	  possibleLocale = "en";
	} // url-loader -- this will be something like "static/media/content_en.4b5383e7.yaml"
	// url-loader -- this will be something like "static/media/content_en.4b5383e7.yaml"
	
	var locale = exports.locale = possibleLocale;
	var GLOBAL_locale = exports.GLOBAL_locale = possibleLocale; //XXX: allow setting with cookie
	
	function loadMessages() {
	  var cb64filename; // url-loader -- this will be something like "static/media/content_en.4b5383e7.yaml"
	  if (GLOBAL_locale === 'en') cb64filename = _content_en2.default;
	  if (GLOBAL_locale === 'es') cb64filename = _content_es2.default;
	  return d3.text(cb64filename).then(function (rawContent) {
	    return _jsYaml2.default.safeLoad(rawContent);
	  }).then(function (content) {
	    var localeData = GLOBAL_locale === 'en' ? _en2.default : _es2.default;
	    Object.keys(content).forEach(function (key, index) {
	      if (typeof content[key] == "string" && content[key].startsWith('!markdown')) {
	        content[key] = content[key].replace(/PUBLIC_URL/g, (""));
	        content[key] = (0, _marked2.default)(content[key].replace('!markdown', ''));
	
	        content[key] = content[key].replace(/href="http/g, 'target="_blank" href="http'); // external links open in new window/tab
	      }
	
	      localeData = Object.assign({}, localeData, content);
	    });
	
	    _State.state.updateMessages(localeData);
	  });
	}

/***/ },
/* 77 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _resolvePathname = __webpack_require__(238);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(239);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// JS-YAML's default schema for `load` function.
	// It is not described in the YAML specification.
	//
	// This schema is based on JS-YAML's default safe schema and includes
	// JavaScript-specific types: !!js/undefined, !!js/regexp and !!js/function.
	//
	// Also this schema is used as default base schema at `Schema.create` function.
	
	
	'use strict';
	
	var Schema = __webpack_require__(39);
	
	module.exports = Schema.DEFAULT = new Schema({
	  include: [__webpack_require__(55)],
	  explicit: [__webpack_require__(660), __webpack_require__(659), __webpack_require__(658)]
	});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
	    d.__proto__ = b;
	} || function (d, b) {
	    for (var p in b) {
	        if (b.hasOwnProperty(p)) d[p] = b[p];
	    }
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() {
	        this.constructor = d;
	    }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) {
	            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	    }
	    return t;
	};
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	}
	
	var enumerableDescriptorCache = {};
	var nonEnumerableDescriptorCache = {};
	function createPropertyInitializerDescriptor(prop, enumerable) {
	    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
	    return cache[prop] || (cache[prop] = {
	        configurable: true,
	        enumerable: enumerable,
	        get: function get() {
	            initializeInstance(this);
	            return this[prop];
	        },
	        set: function set(value) {
	            initializeInstance(this);
	            this[prop] = value;
	        }
	    });
	}
	function initializeInstance(target) {
	    if (target.__mobxDidRunLazyInitializers === true) return;
	    var decorators = target.__mobxDecorators;
	    if (decorators) {
	        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
	        for (var key in decorators) {
	            var d = decorators[key];
	            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
	        }
	    }
	}
	function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
	    return function decoratorFactory() {
	        var decoratorArguments;
	        var decorator = function decorate(target, prop, descriptor, applyImmediately
	        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
	        // as the instance to apply the deorator to equals the target
	        ) {
	            if (applyImmediately === true) {
	                propertyCreator(target, prop, descriptor, target, decoratorArguments);
	                return null;
	            }
	            if (false) fail$1("This function is a decorator, but it wasn't invoked like a decorator");
	            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
	                var inheritedDecorators = target.__mobxDecorators;
	                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
	            }
	            target.__mobxDecorators[prop] = {
	                prop: prop,
	                propertyCreator: propertyCreator,
	                descriptor: descriptor,
	                decoratorTarget: target,
	                decoratorArguments: decoratorArguments
	            };
	            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
	        };
	        if (quacksLikeADecorator(arguments)) {
	            // @decorator
	            decoratorArguments = EMPTY_ARRAY;
	            return decorator.apply(null, arguments);
	        } else {
	            // @decorator(args)
	            decoratorArguments = Array.prototype.slice.call(arguments);
	            return decorator;
	        }
	    };
	}
	function quacksLikeADecorator(args) {
	    return (args.length === 2 || args.length === 3) && typeof args[1] === "string" || args.length === 4 && args[3] === true;
	}
	
	function isSpyEnabled() {
	    return !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length) return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](event);
	    }
	}
	function spyReportStart(event) {
	    var change = __assign({}, event, { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change) spyReport(__assign({}, change, { spyReportEnd: true }));else spyReport(END_EVENT);
	}
	function spy(listener) {
	    globalState.spyListeners.push(listener);
	    return once(function () {
	        globalState.spyListeners = globalState.spyListeners.filter(function (l) {
	            return l !== listener;
	        });
	    });
	}
	
	function createAction(actionName, fn) {
	    if (false) {
	        invariant(typeof fn === "function", "`action` can only be invoked on functions");
	        if (typeof actionName !== "string" || !actionName) fail("actions should have valid names, got: '" + actionName + "'");
	    }
	    var res = function res() {
	        return executeAction(actionName, fn, this, arguments);
	    };
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = startAction(actionName, fn, scope, args);
	    try {
	        return fn.apply(scope, args);
	    } finally {
	        endAction(runInfo);
	    }
	}
	function startAction(actionName, fn, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = args && args.length || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0) for (var i = 0; i < l; i++) {
	            flattendArgs[i] = args[i];
	        }spyReportStart({
	            type: "action",
	            name: actionName,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    return {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        notifySpy: notifySpy,
	        startTime: startTime
	    };
	}
	function endAction(runInfo) {
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy) spyReportEnd({ time: Date.now() - runInfo.startTime });
	}
	function allowStateChanges(allowStateChanges, func) {
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    } finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	
	function dontReassignFields() {
	    fail$1(("production") !== "production" && "@action fields are not reassignable");
	}
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor) {
	            if (false) {
	                return fail$1("@action cannot be used with getters");
	            }
	            // babel / typescript
	            // @action method() { }
	            if (descriptor.value) {
	                // typescript
	                return {
	                    value: createAction(name, descriptor.value),
	                    enumerable: false,
	                    configurable: false,
	                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
	                };
	            }
	            // babel only: @action method = () => {}
	            var initializer_1 = descriptor.initializer;
	            return {
	                enumerable: false,
	                configurable: false,
	                writable: ("production") !== "production",
	                initializer: function initializer() {
	                    // N.B: we can't immediately invoke initializer; this would be wrong
	                    return createAction(name, initializer_1.call(this));
	                }
	            };
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function actionFieldDecorator(name) {
	    // Simple property that writes on first invocation to the current instance
	    return function (target, prop, descriptor) {
	        Object.defineProperty(target, prop, {
	            configurable: true,
	            enumerable: false,
	            get: function get() {
	                return undefined;
	            },
	            set: function set(value) {
	                addHiddenFinalProp(this, prop, action(name, value));
	            }
	        });
	    };
	}
	function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
	    if (applyToInstance === true) {
	        defineBoundAction(target, propertyName, descriptor.value);
	        return null;
	    }
	    if (descriptor) {
	        // if (descriptor.value)
	        // Typescript / Babel: @action.bound method() { }
	        // also: babel @action.bound method = () => {}
	        return {
	            configurable: true,
	            enumerable: false,
	            get: function get() {
	                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
	                return this[propertyName];
	            },
	            set: dontReassignFields
	        };
	    }
	    // field decorator Typescript @action.bound method = () => {}
	    return {
	        enumerable: false,
	        configurable: true,
	        set: function set(v) {
	            defineBoundAction(this, propertyName, v);
	        },
	        get: function get() {
	            return undefined;
	        }
	    };
	}
	
	var action = function action(arg1, arg2, arg3, arg4) {
	    // action(fn() {})
	    if (arguments.length === 1 && typeof arg1 === "function") return createAction(arg1.name || "<unnamed action>", arg1);
	    // action("name", fn() {})
	    if (arguments.length === 2 && typeof arg2 === "function") return createAction(arg1, arg2);
	    // @action("name") fn() {}
	    if (arguments.length === 1 && typeof arg1 === "string") return namedActionDecorator(arg1);
	    // @action fn() {}
	    if (arg4 === true) {
	        // apply to instance immediately
	        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
	    } else {
	        return namedActionDecorator(arg2).apply(null, arguments);
	    }
	};
	action.bound = boundActionDecorator;
	function runInAction(arg1, arg2) {
	    // TODO: deprecate?
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    if (false) {
	        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
	        if (typeof actionName !== "string" || !actionName) fail$1("actions should have valid names, got: '" + actionName + "'");
	    }
	    return executeAction(actionName, fn, this, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b) {
	    return eq(a, b);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a === "undefined" ? "undefined" : _typeof(a);
	    if (type !== "function" && type !== "object" && (typeof b === "undefined" ? "undefined" : _typeof(b)) != "object") return false;
	    return deepEq(a, b, aStack, bStack);
	}
	// Internal recursive comparison function for `isEqual`.
	function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a) return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if ((typeof a === "undefined" ? "undefined" : _typeof(a)) != "object" || (typeof b === "undefined" ? "undefined" : _typeof(b)) != "object") return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor,
	            bCtor = b.constructor;
	        if (aCtor !== bCtor && !(typeof aCtor === "function" && aCtor instanceof aCtor && typeof bCtor === "function" && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) {
	            return false;
	        }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a) return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length) return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], aStack, bStack)) return false;
	        }
	    } else {
	        // Deep compare objects.
	        var keys$$1 = Object.keys(a),
	            key;
	        length = keys$$1.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length) return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys$$1[length];
	            if (!(has$$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a)) return a.peek();
	    if (isES6Map(a) || isObservableMap(a)) return iteratorToArray(a.entries());
	    return a;
	}
	function has$$1(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function defaultComparer(a, b) {
	    return areBothNaN(a, b) || identityComparer(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer
	};
	
	/**
	 * Creates a named reactive view and keeps it alive, so that the view is always
	 * updated if one of the dependencies changes, even when the view is not further used by something else.
	 * @param view The reactive view
	 * @returns disposer function, which can be used to stop the view from being updated in the future.
	 */
	function autorun(view, opts) {
	    if (opts === void 0) {
	        opts = EMPTY_OBJECT;
	    }
	    if (false) {
	        invariant(typeof view === "function", "Autorun expects a function as first argument");
	        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
	    }
	    var name = opts && opts.name || view.name || "Autorun@" + getNextId();
	    var runSync = !opts.scheduler && !opts.delay;
	    var reaction;
	    if (runSync) {
	        // normal autorun
	        reaction = new Reaction(name, function () {
	            this.track(reactionRunner);
	        }, opts.onError);
	    } else {
	        var scheduler_1 = createSchedulerFromOptions(opts);
	        // debounced autorun
	        var isScheduled_1 = false;
	        reaction = new Reaction(name, function () {
	            if (!isScheduled_1) {
	                isScheduled_1 = true;
	                scheduler_1(function () {
	                    isScheduled_1 = false;
	                    if (!reaction.isDisposed) reaction.track(reactionRunner);
	                });
	            }
	        }, opts.onError);
	    }
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	var run = function run(f) {
	    return f();
	};
	function createSchedulerFromOptions(opts) {
	    return opts.scheduler ? opts.scheduler : opts.delay ? function (f) {
	        return setTimeout(f, opts.delay);
	    } : run;
	}
	function reaction(expression, effect, opts) {
	    if (opts === void 0) {
	        opts = EMPTY_OBJECT;
	    }
	    if (typeof opts === "boolean") {
	        opts = { fireImmediately: opts };
	        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
	    }
	    if (false) {
	        invariant(typeof expression === "function", "First argument to reaction should be a function");
	        invariant((typeof opts === "undefined" ? "undefined" : _typeof(opts)) === "object", "Third argument of reactions should be an object");
	    }
	    var name = opts.name || "Reaction@" + getNextId();
	    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
	    var runSync = !opts.scheduler && !opts.delay;
	    var scheduler = createSchedulerFromOptions(opts);
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer.default;
	    var r = new Reaction(name, function () {
	        if (firstTime || runSync) {
	            reactionRunner();
	        } else if (!isScheduled) {
	            isScheduled = true;
	            scheduler(reactionRunner);
	        }
	    }, opts.onError);
	    function reactionRunner() {
	        isScheduled = false; // Q: move into reaction runner?
	        if (r.isDisposed) return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately) effectAction(value, r);
	        if (!firstTime && changed === true) effectAction(value, r);
	        if (firstTime) firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function wrapErrorHandler(errorHandler, baseFn) {
	    return function () {
	        try {
	            return baseFn.apply(this, arguments);
	        } catch (e) {
	            errorHandler.call(this, e);
	        }
	    };
	}
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce an new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(options) {
	        var _this = this;
	        this.dependenciesState = IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isBeingObserved = false;
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        if (("production") === "production" && !options.get) return fail$1("missing option for computed: get");
	        this.derivation = options.get;
	        this.name = options.name || "ComputedValue@" + getNextId();
	        if (options.set) this.setter = createAction(this.name + "-setter", options.set);
	        this.equals = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer.default);
	        this.scope = options.context;
	        this.requiresReaction = !!options.requiresReaction;
	        if (options.keepAlive === true) {
	            // dangerous: never exposed, so this cmputed value should not depend on observables
	            // that live globally, or it will never get disposed! (nor anything attached to it)
	            autorun(function () {
	                return _this.get();
	            });
	        }
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () {};
	    ComputedValue.prototype.onBecomeObserved = function () {};
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        if (this.isComputing) fail$1("Cycle detected in computation " + this.name + ": " + this.derivation);
	        if (globalState.inBatch === 0) {
	            if (shouldCompute(this)) {
	                this.warnAboutUntrackedRead();
	                startBatch(); // See perf test 'computed memoization'
	                this.value = this.computeValue(false);
	                endBatch();
	            }
	        } else {
	            reportObserved(this);
	            if (shouldCompute(this)) if (this.trackAndCompute()) propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result)) throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res)) throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            } finally {
	                this.isRunningSetter = false;
	            }
	        } else invariant(false, ("production") !== "production" && "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled()) {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                name: this.name
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended =
	        /* see #1208 */this.dependenciesState === IDerivationState.NOT_TRACKING;
	        var newValue = this.value = this.computeValue(true);
	        return wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals(oldValue, newValue);
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        } else {
	            if (globalState.disableErrorBoundaries === true) {
	                res = this.derivation.call(this.scope);
	            } else {
	                try {
	                    res = this.derivation.call(this.scope);
	                } catch (e) {
	                    res = new CaughtException(e);
	                }
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.suspend = function () {
	        clearObserving(this);
	        this.value = undefined; // don't hold on to computed value!
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.warnAboutUntrackedRead = function () {
	        if (true) return;
	        if (this.requiresReaction === true) {
	            fail$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
	        }
	        if (this.isTracing !== TraceMode.NONE) {
	            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
	        }
	        if (globalState.computedRequiresReaction) {
	            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
	        }
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ComputedValue;
	}();
	ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1) interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors) for (var i = 0, l = interceptors.length; i < l; i++) {
	            change = interceptors[i](change);
	            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	            if (!change) break;
	        }
	        return change;
	    } finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1) listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners) return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	var UNCHANGED = {};
	declareAtom();
	var ObservableValue = /** @class */function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy) {
	        if (name === void 0) {
	            name = "ObservableValue@" + getNextId();
	        }
	        if (notifySpy === void 0) {
	            notifySpy = true;
	        }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.hasUnreportedChange = false;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy) {
	                spyReportStart({
	                    type: "update",
	                    name: this.name,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy) spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change) return UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.value !== newValue ? newValue : UNCHANGED;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately) listener({
	            object: this,
	            type: "update",
	            newValue: this.value,
	            oldValue: undefined
	        });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ObservableValue;
	}(Atom);
	ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	var ObservableObjectAdministration = /** @class */function () {
	    function ObservableObjectAdministration(target, name, defaultEnhancer) {
	        this.target = target;
	        this.name = name;
	        this.defaultEnhancer = defaultEnhancer;
	        this.values = {};
	    }
	    ObservableObjectAdministration.prototype.read = function (owner, key) {
	        if (this.target !== owner) {
	            this.illegalAccess(owner, key);
	            return;
	        }
	        return this.values[key].get();
	    };
	    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
	        var instance = this.target;
	        if (instance !== owner) {
	            this.illegalAccess(owner, key);
	            return;
	        }
	        var observable = this.values[key];
	        if (observable instanceof ComputedValue) {
	            observable.set(newValue);
	            return;
	        }
	        // intercept
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "update",
	                object: instance,
	                name: key,
	                newValue: newValue
	            });
	            if (!change) return;
	            newValue = change.newValue;
	        }
	        newValue = observable.prepareNewValue(newValue);
	        // notify spy & observers
	        if (newValue !== UNCHANGED) {
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var change = notify || notifySpy ? {
	                type: "update",
	                object: instance,
	                oldValue: observable.value,
	                name: key,
	                newValue: newValue
	            } : null;
	            if (notifySpy) spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify) notifyListeners(this, change);
	            if (notifySpy) spyReportEnd();
	        }
	    };
	    ObservableObjectAdministration.prototype.remove = function (key) {
	        if (!this.values[key]) return;
	        var target = this.target;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: target,
	                name: key,
	                type: "remove"
	            });
	            if (!change) return;
	        }
	        try {
	            startBatch();
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var oldValue = this.values[key].get();
	            if (this.keys) this.keys.remove(key);
	            delete this.values[key];
	            delete this.target[key];
	            var change = notify || notifySpy ? {
	                type: "remove",
	                object: target,
	                oldValue: oldValue,
	                name: key
	            } : null;
	            if (notifySpy) spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            if (notify) notifyListeners(this, change);
	            if (notifySpy) spyReportEnd();
	        } finally {
	            endBatch();
	        }
	    };
	    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
	        /**
	         * This happens if a property is accessed through the prototype chain, but the property was
	         * declared directly as own property on the prototype.
	         *
	         * E.g.:
	         * class A {
	         * }
	         * extendObservable(A.prototype, { x: 1 })
	         *
	         * classB extens A {
	         * }
	         * console.log(new B().x)
	         *
	         * It is unclear whether the property should be considered 'static' or inherited.
	         * Either use `console.log(A.x)`
	         * or: decorate(A, { x: observable })
	         *
	         * When using decorate, the property will always be redeclared as own property on the actual instance
	         */
	        return fail$1("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        ("production") !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableObjectAdministration.prototype.getKeys = function () {
	        var _this = this;
	        if (this.keys === undefined) {
	            this.keys = new ObservableArray(Object.keys(this.values).filter(function (key) {
	                return _this.values[key] instanceof ObservableValue;
	            }), referenceEnhancer, "keys(" + this.name + ")", true);
	        }
	        return this.keys.slice();
	    };
	    return ObservableObjectAdministration;
	}();
	function asObservableObject(target, name, defaultEnhancer) {
	    if (name === void 0) {
	        name = "";
	    }
	    if (defaultEnhancer === void 0) {
	        defaultEnhancer = deepEnhancer;
	    }
	    var adm = target.$mobx;
	    if (adm) return adm;
	    ("production") !== "production" && invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
	    if (!isPlainObject(target)) name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name) name = "ObservableObject@" + getNextId();
	    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
	    addHiddenFinalProp(target, "$mobx", adm);
	    return adm;
	}
	function defineObservableProperty(target, propName, newValue, enhancer) {
	    var adm = asObservableObject(target);
	    assertPropertyConfigurable(target, propName);
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            object: target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change) return;
	        newValue = change.newValue;
	    }
	    var observable = adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false);
	    newValue = observable.value; // observableValue might have changed it
	    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
	    if (adm.keys) adm.keys.push(propName);
	    notifyPropertyAddition(adm, target, propName, newValue);
	}
	function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
	propName, options) {
	    var adm = asObservableObject(target);
	    options.name = adm.name + "." + propName;
	    options.context = target;
	    adm.values[propName] = new ComputedValue(options);
	    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
	}
	var observablePropertyConfigs = {};
	var computedPropertyConfigs = {};
	function generateObservablePropConfig(propName) {
	    return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
	        configurable: true,
	        enumerable: true,
	        get: function get() {
	            return this.$mobx.read(this, propName);
	        },
	        set: function set(v) {
	            this.$mobx.write(this, propName, v);
	        }
	    });
	}
	function getAdministrationForComputedPropOwner(owner) {
	    var adm = owner.$mobx;
	    if (!adm) {
	        // because computed props are declared on proty,
	        // the current instance might not have been initialized yet
	        initializeInstance(owner);
	        return owner.$mobx;
	    }
	    return adm;
	}
	function generateComputedPropConfig(propName) {
	    return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
	        configurable: true,
	        enumerable: false,
	        get: function get() {
	            return getAdministrationForComputedPropOwner(this).read(this, propName);
	        },
	        set: function set(v) {
	            getAdministrationForComputedPropOwner(this).write(this, propName, v);
	        }
	    });
	}
	function notifyPropertyAddition(adm, object, key, newValue) {
	    var notify = hasListeners(adm);
	    var notifySpy = isSpyEnabled();
	    var change = notify || notifySpy ? {
	        type: "add",
	        object: object,
	        name: key,
	        newValue: newValue
	    } : null;
	    if (notifySpy) spyReportStart(__assign({}, change, { name: adm.name, key: key }));
	    if (notify) notifyListeners(adm, change);
	    if (notifySpy) spyReportEnd();
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
	        var initialValue = descriptor ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value : undefined;
	        defineObservableProperty(target, propertyName, initialValue, enhancer);
	    });
	    var res =
	    // Extra process checks, as this happens during module initialization
	    typeof process !== "undefined" && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") !== "production" ? function observableDecorator() {
	        // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
	        // and simply return the created prop decorator
	        if (arguments.length < 2) return fail$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
	        return decorator.apply(null, arguments);
	    } : decorator;
	    res.enhancer = enhancer;
	    return res;
	}
	
	function _isObservable(value, property) {
	    if (value === null || value === undefined) return false;
	    if (property !== undefined) {
	        if (false) return fail$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
	        if (isObservableObject(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return isObservableObject(value) || !!value.$mobx || isAtom(value) || isReaction(value) || isComputedValue(value);
	}
	function isObservable(value) {
	    if (arguments.length !== 1) fail$1(("production") !== "production" && "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isObservable(value);
	}
	function isObservableProp(value, propName) {
	    if (typeof propName !== "string") return fail$1(("production") !== "production" && "expected a property name as second argument");
	    return _isObservable(value, propName);
	}
	
	function _isComputed(value, property) {
	    if (value === null || value === undefined) return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false) return false;
	        if (!value.$mobx.values[property]) return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	function isComputed(value) {
	    if (arguments.length > 1) return fail$1(("production") !== "production" && "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isComputed(value);
	}
	function isComputedProp(value, propName) {
	    if (typeof propName !== "string") return fail$1(("production") !== "production" && "isComputed expected a property name as second argument");
	    return _isComputed(value, propName);
	}
	
	var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
	    var get = descriptor.get,
	        set = descriptor.set; // initialValue is the descriptor for get / set props
	    // Optimization: faster on decorator target or instance? Assuming target
	    // Optimiziation: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
	    var options = decoratorArgs[0] || {};
	    defineComputedProperty(instance, propertyName, __assign({}, options, { get: get, set: set }));
	});
	var computedStructDecorator = computedDecorator({ equals: comparer.structural });
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        // @computed
	        return computedDecorator.apply(null, arguments);
	    }
	    if (arg1 !== null && (typeof arg1 === "undefined" ? "undefined" : _typeof(arg1)) === "object" && arguments.length === 1) {
	        // @computed({ options })
	        return computedDecorator.apply(null, arguments);
	    }
	    // computed(expr, options?)
	    if (false) {
	        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
	        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
	    }
	    var opts = (typeof arg2 === "undefined" ? "undefined" : _typeof(arg2)) === "object" ? arg2 : {};
	    opts.get = arg1;
	    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
	    opts.name = opts.name || arg1.name || ""; /* for generated name */
	    return new ComputedValue(opts);
	};
	computed.struct = computedStructDecorator;
	
	function extendShallowObservable(target, properties, decorators) {
	    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
	    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
	}
	function extendObservable(target, properties, decorators, options) {
	    if (false) {
	        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
	        invariant((typeof target === "undefined" ? "undefined" : _typeof(target)) === "object", "'extendObservable' expects an object as first argument");
	        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
	        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
	        if (decorators) for (var key in decorators) {
	            if (!(key in properties)) fail$1("Trying to declare a decorator for unspecified property '" + key + "'");
	        }
	    }
	    options = asCreateObservableOptions(options);
	    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
	    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
	    startBatch();
	    try {
	        for (var key in properties) {
	            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	            if (false) {
	                if (Object.getOwnPropertyDescriptor(target, key)) fail$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
	                if (isComputed(descriptor.value)) fail$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
	            }
	            var decorator = decorators && key in decorators ? decorators[key] : descriptor.get ? computedDecorator : defaultDecorator;
	            if (false) return fail$1("Not a valid decorator for '" + key + "', got: " + decorator);
	            var resultDescriptor = decorator(target, key, descriptor, true);
	            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
	            ) Object.defineProperty(target, key, resultDescriptor);
	        }
	    } finally {
	        endBatch();
	    }
	    return target;
	}
	
	// Predefined bags of create observable options, to avoid allocating temporarily option objects
	// in the majority of cases
	var defaultCreateObservableOptions = {
	    deep: true,
	    name: undefined,
	    defaultDecorator: undefined
	};
	var shallowCreateObservableOptions = {
	    deep: false,
	    name: undefined,
	    defaultDecorator: undefined
	};
	Object.freeze(defaultCreateObservableOptions);
	Object.freeze(shallowCreateObservableOptions);
	function assertValidOption(key) {
	    if (!/^(deep|name|defaultDecorator)$/.test(key)) fail$1("invalid option for (extend)observable: " + key);
	}
	function asCreateObservableOptions(thing) {
	    if (thing === null || thing === undefined) return defaultCreateObservableOptions;
	    if (typeof thing === "string") return { name: thing, deep: true };
	    if (false) {
	        if ((typeof thing === "undefined" ? "undefined" : _typeof(thing)) !== "object") return fail$1("expected options object");
	        Object.keys(thing).forEach(assertValidOption);
	    }
	    return thing;
	}
	function getEnhancerFromOptions(options) {
	    return options.defaultDecorator ? options.defaultDecorator.enhancer : options.deep === false ? referenceEnhancer : deepEnhancer;
	}
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v, arg2, arg3) {
	    // @observable someProp;
	    if (typeof arguments[1] === "string") {
	        return deepDecorator.apply(null, arguments);
	    }
	    // it is an observable already, done
	    if (isObservable(v)) return v;
	    // something that can be converted and mutated?
	    var res = isPlainObject(v) ? observable.object(v, arg2, arg3) : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : v;
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v) return res;
	    // otherwise, just box it
	    fail$1(("production") !== "production" && "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
	}
	var observableFactories = {
	    box: function box(value, options) {
	        if (arguments.length > 2) incorrectlyUsedAsDecorator("box");
	        var o = asCreateObservableOptions(options);
	        return new ObservableValue(value, getEnhancerFromOptions(o), o.name);
	    },
	    shallowBox: function shallowBox(value, name) {
	        if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowBox");
	        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
	        return observable.box(value, { name: name, deep: false });
	    },
	    array: function array(initialValues, options) {
	        if (arguments.length > 2) incorrectlyUsedAsDecorator("array");
	        var o = asCreateObservableOptions(options);
	        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowArray: function shallowArray(initialValues, name) {
	        if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowArray");
	        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
	        return observable.array(initialValues, { name: name, deep: false });
	    },
	    map: function map(initialValues, options) {
	        if (arguments.length > 2) incorrectlyUsedAsDecorator("map");
	        var o = asCreateObservableOptions(options);
	        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowMap: function shallowMap(initialValues, name) {
	        if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowMap");
	        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
	        return observable.map(initialValues, { name: name, deep: false });
	    },
	    object: function object(props, decorators, options) {
	        if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("object");
	        var o = asCreateObservableOptions(options);
	        return extendObservable({}, props, decorators, o);
	    },
	    shallowObject: function shallowObject(props, name) {
	        if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("shallowObject");
	        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
	        return observable.object(props, {}, { name: name, deep: false });
	    },
	    ref: refDecorator,
	    shallow: shallowDecorator,
	    deep: deepDecorator,
	    struct: refStructDecorator
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) {
	    return observable[name] = observableFactories[name];
	});
	function incorrectlyUsedAsDecorator(methodName) {
	    fail$1(
	    // process.env.NODE_ENV !== "production" &&
	    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	function deepEnhancer(v, _, name) {
	    // it is an observable already, done
	    if (isObservable(v)) return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v)) return observable.array(v, { name: name });
	    if (isPlainObject(v)) return observable.object(v, undefined, { name: name });
	    if (isES6Map(v)) return observable.map(v, { name: name });
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (v === undefined || v === null) return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v)) return v;
	    if (Array.isArray(v)) return observable.array(v, { name: name, deep: false });
	    if (isPlainObject(v)) return observable.object(v, undefined, { name: name, deep: false });
	    if (isES6Map(v)) return observable.map(v, { name: name, deep: false });
	    return fail$1(("production") !== "production" && "The shallow modifier / decorator can only used in combination with arrays, objects and maps");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if (false) throw "observable.struct should not be used with observable values";
	    if (deepEqual(v, oldValue)) return oldValue;
	    return v;
	}
	
	function iteratorSymbol() {
	    return typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	}
	
	function declareIterator(prototType, iteratorFactory) {
	    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
	}
	function makeIterable(iterator) {
	    iterator[iteratorSymbol()] = self;
	    return iterator;
	}
	function self() {
	    return this;
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) {
	        thisArg = undefined;
	    }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    } finally {
	        endBatch();
	    }
	}
	
	var ObservableMapMarker = {};
	var ObservableMap = /** @class */function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) {
	            enhancer = deepEnhancer;
	        }
	        if (name === void 0) {
	            name = "ObservableMap@" + getNextId();
	        }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
	        if (typeof Map !== "function") {
	            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
	        }
	        this._data = new Map();
	        this._hasMap = new Map();
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return this._data.has(key);
	    };
	    ObservableMap.prototype.has = function (key) {
	        if (this._hasMap.has(key)) return this._hasMap.get(key).get();
	        return this._updateHasMapEntry(key, false).get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change) return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        } else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change) return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy ? {
	                type: "delete",
	                object: this,
	                oldValue: this._data.get(key).value,
	                name: key
	            } : null;
	            if (notifySpy) spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            transaction(function () {
	                _this._keys.remove(key);
	                _this._updateHasMapEntry(key, false);
	                var observable = _this._data.get(key);
	                observable.setNewValue(undefined);
	                _this._data.delete(key);
	            });
	            if (notify) notifyListeners(this, change);
	            if (notifySpy) spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
	        var entry = this._hasMap.get(key);
	        if (entry) {
	            entry.setNewValue(value);
	        } else {
	            entry = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
	            this._hasMap.set(key, entry);
	        }
	        return entry;
	    };
	    ObservableMap.prototype._updateValue = function (key, newValue) {
	        var observable = this._data.get(key);
	        newValue = observable.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy ? {
	                type: "update",
	                object: this,
	                oldValue: observable.value,
	                name: key,
	                newValue: newValue
	            } : null;
	            if (notifySpy) spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify) notifyListeners(this, change);
	            if (notifySpy) spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (key, newValue) {
	        var _this = this;
	        transaction(function () {
	            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + key, false);
	            _this._data.set(key, observable);
	            newValue = observable.value; // value might have been changed
	            _this._updateHasMapEntry(key, true);
	            _this._keys.push(key);
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy ? {
	            type: "add",
	            object: this,
	            name: key,
	            newValue: newValue
	        } : null;
	        if (notifySpy) spyReportStart(__assign({}, change, { name: this.name, key: key }));
	        if (notify) notifyListeners(this, change);
	        if (notifySpy) spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        if (this.has(key)) return this.dehanceValue(this._data.get(key).get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        return this._keys[iteratorSymbol()]();
	    };
	    ObservableMap.prototype.values = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable({
	            next: function next() {
	                return nextIndex < self._keys.length ? { value: self.get(self._keys[nextIndex++]), done: false } : { value: undefined, done: true };
	            }
	        });
	    };
	    ObservableMap.prototype.entries = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable({
	            next: function next() {
	                if (nextIndex < self._keys.length) {
	                    var key = self._keys[nextIndex++];
	                    return {
	                        value: [key, self.get(key)],
	                        done: false
	                    };
	                }
	                return { done: true };
	            }
	        });
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this._keys.forEach(function (key) {
	            return callback.call(thisArg, _this.get(key), key, _this);
	        });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            if (isPlainObject(other)) Object.keys(other).forEach(function (key) {
	                return _this.set(key, other[key]);
	            });else if (Array.isArray(other)) other.forEach(function (_a) {
	                var _b = __read(_a, 2),
	                    key = _b[0],
	                    value = _b[1];
	                return _this.set(key, value);
	            });else if (isES6Map(other)) other.forEach(function (value, key) {
	                return _this.set(key, value);
	            });else if (other !== null && other !== undefined) fail$1("Cannot initialize map from " + other);
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                _this._keys.slice().forEach(function (key) {
	                    return _this.delete(key);
	                });
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        transaction(function () {
	            // grab all the keys that are present in the new map but not present in the current map
	            // and delete them from the map, then merge the new map
	            // this will cause reactions only on changed values
	            var newKeys = getMapLikeKeys(values);
	            var oldKeys = _this._keys;
	            var missingKeys = oldKeys.filter(function (k) {
	                return newKeys.indexOf(k) === -1;
	            });
	            missingKeys.forEach(function (k) {
	                return _this.delete(k);
	            });
	            _this.merge(values);
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function get() {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a plain object that represents this map.
	     * Note that all the keys being stringified.
	     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
	     */
	    ObservableMap.prototype.toPOJO = function () {
	        var _this = this;
	        var res = {};
	        this._keys.forEach(function (key) {
	            return res["" + key] = _this.get(key);
	        });
	        return res;
	    };
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        var _this = this;
	        var res = new Map();
	        this._keys.forEach(function (key) {
	            return res.set(key, _this.get(key));
	        });
	        return res;
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toPOJO();
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return this.name + "[{ " + this._keys.map(function (key) {
	            return key + ": " + ("" + _this.get(key));
	        }).join(", ") + " }]";
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        ("production") !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}();
	declareIterator(ObservableMap.prototype, function () {
	    return this.entries();
	});
	addHiddenFinalProp(ObservableMap.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Map");
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	function getAtom(thing, property) {
	    if ((typeof thing === "undefined" ? "undefined" : _typeof(thing)) === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            if (property !== undefined) fail$1(("production") !== "production" && "It is not possible to get index atoms from arrays");
	            return thing.$mobx.atom;
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined) return getAtom(anyThing._keys);
	            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
	            if (!observable) fail$1(("production") !== "production" && "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        if (property && !thing.$mobx) thing[property]; // See #1072
	        if (isObservableObject(thing)) {
	            if (!property) return fail$1(("production") !== "production" && "please specify a property");
	            var observable = thing.$mobx.values[property];
	            if (!observable) fail$1(("production") !== "production" && "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    } else if (typeof thing === "function") {
	        if (isReaction(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail$1(("production") !== "production" && "Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    if (!thing) fail$1("Expecting some object");
	    if (property !== undefined) return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
	    if (isObservableMap(thing)) return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    initializeInstance(thing);
	    if (thing.$mobx) return thing.$mobx;
	    fail$1(("production") !== "production" && "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined) named = getAtom(thing, property);else if (isObservableObject(thing) || isObservableMap(thing)) named = getAdministration(thing);else named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	function onBecomeObserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeObserved", thing, arg2, arg3);
	}
	function onBecomeUnobserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
	}
	function interceptHook(hook, thing, arg2, arg3) {
	    var atom = typeof arg2 === "string" ? getAtom(thing, arg2) : getAtom(thing);
	    var cb = typeof arg2 === "string" ? arg3 : arg2;
	    var orig = atom[hook];
	    if (typeof orig !== "function") return fail$1(("production") !== "production" && "Not an atom that can be (un)observed");
	    atom[hook] = function () {
	        orig.call(this);
	        cb.call(this);
	    };
	    return function () {
	        atom[hook] = orig;
	    };
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var Atom;
	var isAtom;
	function declareAtom() {
	    if (Atom) return;
	    Atom = /** @class */function () {
	        /**
	         * Create a new atom. For debugging purposes it is recommended to give it a name.
	         * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	         */
	        function AtomImpl(name) {
	            if (name === void 0) {
	                name = "Atom@" + getNextId();
	            }
	            this.name = name;
	            this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	            this.isBeingObserved = false;
	            this.observers = [];
	            this.observersIndexes = {};
	            this.diffValue = 0;
	            this.lastAccessedBy = 0;
	            this.lowestObserverState = IDerivationState.NOT_TRACKING;
	        }
	        AtomImpl.prototype.onBecomeUnobserved = function () {
	            // noop
	        };
	        AtomImpl.prototype.onBecomeObserved = function () {
	            /* noop */
	        };
	        /**
	        * Invoke this method to notify mobx that your atom has been used somehow.
	        * Returns true if there is currently a reactive context.
	        */
	        AtomImpl.prototype.reportObserved = function () {
	            return reportObserved(this);
	        };
	        /**
	        * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	        */
	        AtomImpl.prototype.reportChanged = function () {
	            startBatch();
	            propagateChanged(this);
	            endBatch();
	        };
	        AtomImpl.prototype.toString = function () {
	            return this.name;
	        };
	        return AtomImpl;
	    }();
	    isAtom = createInstanceofPredicate("Atom", Atom);
	}
	function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	    if (onBecomeObservedHandler === void 0) {
	        onBecomeObservedHandler = noop;
	    }
	    if (onBecomeUnobservedHandler === void 0) {
	        onBecomeUnobservedHandler = noop;
	    }
	    var atom = new Atom(name);
	    onBecomeObserved(atom, onBecomeObservedHandler);
	    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
	    return atom;
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function set() {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	}();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray = /** @class */function () {
	    function StubArray() {}
	    return StubArray;
	}();
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    } else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    } else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	
	    ["constructor", "push", "shift", "concat", "pop", "unshift", "replace", "find", "findIndex", "splice", "reverse", "sort"].forEach(function (key) {
	        Object.defineProperty(StubArray.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.atom = new Atom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) {
	            return enhancer(newV, oldV, name + "[..]");
	        };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined && this.values.length > 0) return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) {
	            fireImmediately = false;
	        }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0) throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength) return;else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++) {
	                newItems[i] = undefined;
	            } // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        } else this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE) reserveArrayBuffer(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined) index = 0;else if (index > length) index = length;else if (index < 0) index = Math.max(0, length + index);
	        if (arguments.length === 1) deleteCount = length - index;else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined) newItems = EMPTY_ARRAY;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change) return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) {
	            return _this.enhancer(v, undefined);
	        });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
	        } else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values.slice(0, index).concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	        var _a;
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy ? {
	            object: this.array,
	            type: "update",
	            index: index,
	            newValue: newValue,
	            oldValue: oldValue
	        } : null;
	        if (notifySpy) spyReportStart(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        if (notify) notifyListeners(this, change);
	        if (notifySpy) spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy ? {
	            object: this.array,
	            type: "splice",
	            index: index,
	            removed: removed,
	            added: added,
	            removedCount: removed.length,
	            addedCount: added.length
	        } : null;
	        if (notifySpy) spyReportStart(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify) notifyListeners(this, change);
	        if (notifySpy) spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}();
	var ObservableArray = /** @class */function (_super) {
	    __extends(ObservableArray, _super);
	    function ObservableArray(initialValues, enhancer, name, owned) {
	        if (name === void 0) {
	            name = "ObservableArray@" + getNextId();
	        }
	        if (owned === void 0) {
	            owned = false;
	        }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            _this.spliceWithArray(0, 0, initialValues);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) {
	            fireImmediately = false;
	        }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) {
	            return isObservableArray(a) ? a.peek() : a;
	        }));
	    };
	    ObservableArray.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) {
	            fromIndex = 0;
	        }
	        if (arguments.length === 3) deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) {
	            fromIndex = 0;
	        }
	        if (arguments.length === 3) deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
	        var items = this.peek(),
	            l = items.length;
	        for (var i = fromIndex; i < l; i++) {
	            if (predicate.call(thisArg, items[i], i, this)) return i;
	        }return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray.prototype.move = function (fromIndex, toIndex) {
	        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [oldItems[fromIndex]], oldItems.slice(toIndex + 1));
	        } else {
	            // toIndex < fromIndex
	            newItems = __spread(oldItems.slice(0, toIndex), [oldItems[fromIndex]], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change) return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        } else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        } else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    };
	    return ObservableArray;
	}(StubArray);
	declareIterator(ObservableArray.prototype, function () {
	
	    this.$mobx.atom.reportObserved();
	    var self = this;
	    var nextIndex = 0;
	    return makeIterable({
	        next: function next() {
	            return nextIndex < self.length ? { value: self[nextIndex++], done: false } : { done: true, value: undefined };
	        }
	    });
	});
	Object.defineProperty(ObservableArray.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function get() {
	        return this.$mobx.getArrayLength();
	    },
	    set: function set(newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	["every", "filter", "forEach", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some", "toString", "toLocaleString"].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable(ObservableArray.prototype, ["constructor", "intercept", "observe", "clear", "concat", "get", "replace", "toJS", "toJSON", "peek", "find", "findIndex", "splice", "spliceWithArray", "push", "pop", "set", "shift", "unshift", "reverse", "sort", "remove", "move", "toString", "toLocaleString"]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function get() {
	            return this.get(index);
	        },
	        set: function set(value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++) {
	        createArrayBufferItem(index);
	    }OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer(1000);
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	var EMPTY_OBJECT = {};
	Object.freeze(EMPTY_OBJECT);
	function getGlobal() {
	    return typeof window !== "undefined" ? window : global;
	}
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail$1(message) {
	    invariant(false, message);
	    throw "X"; // unreachable
	}
	function invariant(check, message) {
	    if (!check) throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg, thing) {
	    if (true) return false;
	    if (thing) {
	        return deprecated("'" + msg + "', use '" + thing + "' instead.");
	    }
	    if (deprecatedMessages.indexOf(msg) !== -1) return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked) return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function noop() {};
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1) res.push(item);
	    });
	    return res;
	}
	function isObject(value) {
	    return value !== null && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object";
	}
	function isPlainObject(value) {
	    if (value === null || (typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	
	function makeNonEnumerable(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || descriptor.configurable !== false && descriptor.writable !== false;
	}
	function assertPropertyConfigurable(object, prop) {
	    if (false) fail$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	function areBothNaN(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map) return true;
	    return false;
	}
	function getMapLikeKeys(map) {
	    if (isPlainObject(map)) return Object.keys(map);
	    if (Array.isArray(map)) return map.map(function (_a) {
	        var _b = __read(_a, 1),
	            key = _b[0];
	        return key;
	    });
	    if (isES6Map(map) || isObservableMap(map)) return iteratorToArray(map.keys());
	    return fail$1("Cannot get keys from '" + map + "'");
	}
	// use Array.from in Mobx 5
	function iteratorToArray(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done) break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol() {
	    return typeof Symbol === "function" && Symbol.toPrimitive || "@@toPrimitive";
	}
	function toPrimitive(value) {
	    return value === null ? null : (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" ? "" + value : value;
	}
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = ["mobxGuid", "spyListeners", "enforceActions", "computedRequiresReaction", "disableErrorBoundaries", "runId"];
	var MobXGlobals = /** @class */function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         */
	        this.version = 5;
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.enforceActions = false;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	        /**
	         * Warn if computed values are accessed outside a reactive context
	         */
	        this.computedRequiresReaction = false;
	        /*
	         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
	         * the stack when an exception occurs while debugging.
	         */
	        this.disableErrorBoundaries = false;
	    }
	    return MobXGlobals;
	}();
	var globalState = new MobXGlobals();
	var runInIsolationCalled = false;
	{
	    var global_1 = getGlobal();
	    if (!global_1.__mobxInstanceCount) {
	        global_1.__mobxInstanceCount = 1;
	    } else {
	        global_1.__mobxInstanceCount++;
	        setTimeout(function () {
	            if (!runInIsolationCalled) {
	                fail$1(("production") !== "production" && "There are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	            }
	        }, 1);
	    }
	}
	function isolateGlobalState() {
	    runInIsolationCalled = true;
	    getGlobal().__mobxInstanceCount--;
	}
	function getGlobalState() {
	    return globalState;
	}
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals) {
	        if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
	    }globalState.allowStateChanges = !globalState.enforceActions;
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0) result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node)) result.observers = getObservers(node).map(nodeToObserverTree);
	    return result;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.length > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	// function invariantObservers(observable: IObservable) {
	//     const list = observable.observers
	//     const map = observable.observersIndexes
	//     const l = list.length
	//     for (let i = 0; i < l; i++) {
	//         const id = list[i].__mapid
	//         if (i) {
	//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
	//         } else {
	//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
	//         }
	//     }
	//     invariant(
	//         list.length === 0 || Object.keys(map).length === list.length - 1,
	//         "INTERNAL ERROR there is no junk in map"
	//     )
	// }
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable.observersIndexes[node.__mapid] = l;
	    }
	    observable.observers[l] = node;
	    if (observable.lowestObserverState > node.dependenciesState) observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable.observers.length === 1) {
	        // deleting last observer
	        observable.observers.length = 0;
	        queueForUnobservation(observable);
	    } else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable.observers;
	        var map = observable.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            } else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (observable.isPendingUnobservation === false) {
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.length === 0) {
	                if (observable.isBeingObserved) {
	                    // if this observable had reactive observers, trigger the hooks
	                    observable.isBeingObserved = false;
	                    observable.onBecomeUnobserved();
	                }
	                if (observable instanceof ComputedValue) {
	                    // computed values are automatically teared down when the last observer leaves
	                    // this process happens recursively, this computed might be the last observabe of another, etc..
	                    observable.suspend();
	                }
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	            if (!observable.isBeingObserved) {
	                observable.isBeingObserved = true;
	                observable.onBecomeObserved();
	            }
	        }
	        return true;
	    } else if (observable.observers.length === 0 && globalState.inBatch > 0) {
	        queueForUnobservation(observable);
	    }
	    return false;
	}
	// function invariantLOS(observable: IObservable, msg: string) {
	//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
	//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
	//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
	//     throw new Error(
	//         "lowestObserverState is wrong for " +
	//             msg +
	//             " because " +
	//             min +
	//             " < " +
	//             observable.lowestObserverState
	//     )
	// }
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === IDerivationState.STALE) return;
	    observable.lowestObserverState = IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === IDerivationState.STALE) return;
	    observable.lowestObserverState = IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE) d.dependenciesState = IDerivationState.STALE;else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        ) observable.lowestObserverState = IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE) return;
	    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies) tree.dependencies.forEach(function (child) {
	        return printDepTree(child, lines, depth + 1);
	    });
	}
	
	var IDerivationState;
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(IDerivationState || (exports.IDerivationState = IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}();
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case IDerivationState.UP_TO_DATE:
	            return false;
	        case IDerivationState.NOT_TRACKING:
	        case IDerivationState.STALE:
	            return true;
	        case IDerivationState.POSSIBLY_STALE:
	            {
	                var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	                var obs = derivation.observing,
	                    l = obs.length;
	                for (var i = 0; i < l; i++) {
	                    var obj = obs[i];
	                    if (isComputedValue(obj)) {
	                        if (globalState.disableErrorBoundaries) {
	                            obj.get();
	                        } else {
	                            try {
	                                obj.get();
	                            } catch (e) {
	                                // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                                untrackedEnd(prevUntracked);
	                                return true;
	                            }
	                        }
	                        // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                        // and `derivation` is an observer of `obj`
	                        if (derivation.dependenciesState === IDerivationState.STALE) {
	                            untrackedEnd(prevUntracked);
	                            return true;
	                        }
	                    }
	                }
	                changeDependenciesStateTo0(derivation);
	                untrackedEnd(prevUntracked);
	                return false;
	            }
	    }
	}
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers$$1 = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers$$1) fail$1(("production") !== "production" && "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && hasObservers$$1) fail$1(("production") !== "production" && (globalState.enforceActions ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") + atom.name);
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    if (globalState.disableErrorBoundaries === true) {
	        result = f.call(context);
	    } else {
	        try {
	            result = f.call(context);
	        } catch (e) {
	            result = new CaughtException(e);
	        }
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    return result;
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = derivation.observing = derivation.newObserving;
	    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0,
	        l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i) observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--) {
	        removeObserver(obs[i], derivation);
	    }derivation.dependenciesState = IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    var res = action();
	    untrackedEnd(prev);
	    return res;
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE) return;
	    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--) {
	        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
	    }
	}
	
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail$1(("production") !== "production" && "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	var Reaction = /** @class */function () {
	    function Reaction(name, onInvalidate, errorHandler) {
	        if (name === void 0) {
	            name = "Reaction@" + getNextId();
	        }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.errorHandler = errorHandler;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                this.onInvalidate();
	                if (this._isTrackPending && isSpyEnabled()) {
	                    // onInvalidate didn't trigger track right away..
	                    spyReport({
	                        name: this.name,
	                        type: "scheduled-reaction"
	                    });
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart({
	                name: this.name,
	                type: "reaction"
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result)) this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
	        console.error(message, error);
	        /** If debugging brought you here, please, read the above message :-). Tnx! */
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                name: this.name,
	                message: message,
	                error: "" + error
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) {
	            return f(error, _this);
	        });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) {
	            enterBreakPoint = false;
	        }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}();
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function reactionScheduler(f) {
	    return f();
	};
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++) {
	            remainingReactions[i].runReaction();
	        }
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function reactionScheduler(f) {
	        return fn(function () {
	            return baseScheduler(f);
	        });
	    };
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function") return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);else return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function") return interceptProperty(thing, propOrHandler, handler);else return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	function when(predicate, arg1, arg2) {
	    if (arguments.length === 1 || arg1 && (typeof arg1 === "undefined" ? "undefined" : _typeof(arg1)) === "object") return whenPromise(predicate, arg1);
	    return _when(predicate, arg1, arg2 || {});
	}
	function _when(predicate, effect, opts) {
	    var timeoutHandle;
	    if (typeof opts.timeout === "number") {
	        timeoutHandle = setTimeout(function () {
	            if (!disposer.$mobx.isDisposed) {
	                disposer();
	                var error = new Error("WHEN_TIMEOUT");
	                if (opts.onError) opts.onError(error);else throw error;
	            }
	        }, opts.timeout);
	    }
	    opts.name = opts.name || "When@" + getNextId();
	    var effectAction = createAction(opts.name + "-effect", effect);
	    var disposer = autorun(function (r) {
	        if (predicate()) {
	            r.dispose();
	            if (timeoutHandle) clearTimeout(timeoutHandle);
	            effectAction();
	        }
	    }, opts);
	    return disposer;
	}
	function whenPromise(predicate, opts) {
	    if (false) return fail$1("the options 'onError' and 'promise' cannot be combined");
	    var cancel;
	    var res = new Promise(function (resolve, reject) {
	        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
	        cancel = function cancel() {
	            disposer();
	            reject("WHEN_CANCELLED");
	        };
	    });
	    res.cancel = cancel;
	    return res;
	}
	
	function keys(obj) {
	    if (isObservableObject(obj)) {
	        return obj.$mobx.getKeys();
	    }
	    if (isObservableMap(obj)) {
	        return obj._keys.slice();
	    }
	    return fail$1(("production") !== "production" && "'keys()' can only be used on observable objects and maps");
	}
	function values(obj) {
	    if (isObservableObject(obj)) {
	        return keys(obj).map(function (key) {
	            return obj[key];
	        });
	    }
	    if (isObservableMap(obj)) {
	        return keys(obj).map(function (key) {
	            return obj.get(key);
	        });
	    }
	    if (isObservableArray(obj)) {
	        return obj.slice();
	    }
	    return fail$1(("production") !== "production" && "'values()' can only be used on observable objects, arrays and maps");
	}
	function set(obj, key, value) {
	    if (arguments.length === 2) {
	        startBatch();
	        var values_1 = key;
	        try {
	            for (var key_1 in values_1) {
	                set(obj, key_1, values_1[key_1]);
	            }
	        } finally {
	            endBatch();
	        }
	        return;
	    }
	    if (isObservableObject(obj)) {
	        var adm = obj.$mobx;
	        var existingObservable = adm.values[key];
	        if (existingObservable) {
	            existingObservable.set(value);
	        } else {
	            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
	        }
	    } else if (isObservableMap(obj)) {
	        obj.set(key, value);
	    } else if (isObservableArray(obj)) {
	        if (typeof key !== "number") key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        startBatch();
	        if (key >= obj.length) obj.length = key + 1;
	        obj[key] = value;
	        endBatch();
	    } else {
	        return fail$1(("production") !== "production" && "'set()' can only be used on observable objects, arrays and maps");
	    }
	}
	function remove(obj, key) {
	    if (isObservableObject(obj)) {
	
	        obj.$mobx.remove(key);
	    } else if (isObservableMap(obj)) {
	        obj.delete(key);
	    } else if (isObservableArray(obj)) {
	        if (typeof key !== "number") key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        obj.splice(key, 1);
	    } else {
	        return fail$1(("production") !== "production" && "'remove()' can only be used on observable objects, arrays and maps");
	    }
	}
	function has$1(obj, key) {
	    if (isObservableObject(obj)) {
	        // return keys(obj).indexOf(key) >= 0
	        var adm = getAdministration(obj);
	        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
	        return adm.values[key] instanceof ObservableValue;
	    } else if (isObservableMap(obj)) {
	        return obj.has(key);
	    } else if (isObservableArray(obj)) {
	        return key >= 0 && key < obj.length;
	    } else {
	        return fail$1(("production") !== "production" && "'has()' can only be used on observable objects, arrays and maps");
	    }
	}
	function get(obj, key) {
	    if (!has$1(obj, key)) return undefined;
	    if (isObservableObject(obj)) {
	        return obj[key];
	    } else if (isObservableMap(obj)) {
	        return obj.get(key);
	    } else if (isObservableArray(obj)) {
	        return obj[key];
	    } else {
	        return fail$1(("production") !== "production" && "'get()' can only be used on observable objects, arrays and maps");
	    }
	}
	
	function decorate(thing, decorators) {
	    ("production") !== "production" && invariant(isPlainObject(decorators), "Decorators should be a key value map");
	    var target = typeof thing === "function" ? thing.prototype : thing;
	    for (var prop in decorators) {
	        var decorator = decorators[prop];
	        ("production") !== "production" && invariant(typeof decorator === "function", "Decorate: expected a decorator function for '" + prop + "'");
	        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
	        var newDescriptor = decorator(target, prop, descriptor);
	        if (newDescriptor) Object.defineProperty(target, prop, newDescriptor);
	    }
	    return thing;
	}
	
	function configure(options) {
	    if (options.enforceActions !== undefined) {
	        globalState.enforceActions = !!options.enforceActions;
	        globalState.allowStateChanges = !options.enforceActions;
	    }
	    if (options.computedRequiresReaction !== undefined) {
	        globalState.computedRequiresReaction = !!options.computedRequiresReaction;
	    }
	    if (options.isolateGlobalState === true) {
	        isolateGlobalState();
	    }
	    if (options.disableErrorBoundaries !== undefined) {
	        if (options.disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
	        globalState.disableErrorBoundaries = !!options.disableErrorBoundaries;
	    }
	    if (typeof options.arrayBuffer === "number") {
	        reserveArrayBuffer(options.arrayBuffer);
	    }
	    if (options.reactionScheduler) {
	        setReactionScheduler(options.reactionScheduler);
	    }
	}
	
	var generatorId = 0;
	function flow(generator) {
	    if (arguments.length !== 1) fail(("production") && "Flow expects one 1 argument and cannot be used as decorator");
	    var name = generator.name || "<unnamed flow>";
	    // Implementation based on https://github.com/tj/co/blob/master/index.js
	    return function () {
	        var ctx = this;
	        var args = arguments;
	        var runId = ++generatorId;
	        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
	        var rejector;
	        var pendingPromise = undefined;
	        var res = new Promise(function (resolve, reject) {
	            var stepId = 0;
	            rejector = reject;
	            function onFulfilled(res) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
	                } catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function onRejected(err) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
	                } catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret && typeof ret.then === "function") {
	                    // an async iterator
	                    ret.then(next, reject);
	                    return;
	                }
	                if (ret.done) return resolve(ret.value);
	                pendingPromise = Promise.resolve(ret.value);
	                return pendingPromise.then(onFulfilled, onRejected);
	            }
	            onFulfilled(undefined); // kick off the process
	        });
	        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
	            try {
	                if (pendingPromise) cancelPromise(pendingPromise);
	                // Finally block can return (or yield) stuff..
	                var res_1 = gen.return();
	                // eat anything that promise would do, it's cancelled!
	                var yieldedPromise = Promise.resolve(res_1.value);
	                yieldedPromise.then(noop, noop);
	                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
	                // reject our original promise
	                rejector(new Error("FLOW_CANCELLED"));
	            } catch (e) {
	                rejector(e); // there could be a throwing finally block
	            }
	        });
	        return res;
	    };
	}
	function cancelPromise(promise) {
	    if (typeof promise.cancel === "function") promise.cancel();
	}
	
	var defaultOptions = {
	    detectCycles: true,
	    exportMapsAsObjects: true
	};
	function toJS(source, options, __alreadySeen) {
	    if (__alreadySeen === void 0) {
	        __alreadySeen = [];
	    }
	    // backward compatibility
	    if (typeof options === "boolean") options = { detectCycles: options };
	    if (!options) options = defaultOptions;
	    var detectCycles = options.detectCycles === true;
	    // optimization: using ES6 map would be more efficient!
	    // optimization: lift this function outside toJS, this makes recursion expensive
	    function cache(value) {
	        if (detectCycles) __alreadySeen.push([source, value]);
	        return value;
	    }
	    if (isObservable(source)) {
	        if (detectCycles && __alreadySeen === null) __alreadySeen = [];
	        if (detectCycles && source !== null && (typeof source === "undefined" ? "undefined" : _typeof(source)) === "object") {
	            for (var i = 0, l = __alreadySeen.length; i < l; i++) {
	                if (__alreadySeen[i][0] === source) return __alreadySeen[i][1];
	            }
	        }
	        if (isObservableArray(source)) {
	            var res = cache([]);
	            var toAdd = source.map(function (value) {
	                return toJS(value, options, __alreadySeen);
	            });
	            res.length = toAdd.length;
	            for (var i = 0, l = toAdd.length; i < l; i++) {
	                res[i] = toAdd[i];
	            }return res;
	        }
	        if (isObservableObject(source)) {
	            var res = cache({});
	            keys(source); // make sure we track the keys of the object
	            for (var key in source) {
	                res[key] = toJS(source[key], options, __alreadySeen);
	            }
	            return res;
	        }
	        if (isObservableMap(source)) {
	            if (options.exportMapsAsObjects === false) {
	                var res_1 = cache(new Map());
	                source.forEach(function (value, key) {
	                    res_1.set(key, toJS(value, options, __alreadySeen));
	                });
	                return res_1;
	            } else {
	                var res_2 = cache({});
	                source.forEach(function (value, key) {
	                    res_2[key] = toJS(value, options, __alreadySeen);
	                });
	                return res_2;
	            }
	        }
	        if (isObservableValue(source)) return toJS(source.get(), options, __alreadySeen);
	    }
	    return source;
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    } else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string") return fail$1(("production") !== "production" && "InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    } else {
	        return fail$1(("production") !== "production" && "Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined) return fail$1(("production") !== "production" && "An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2016
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	try {
	    // define process.env if needed
	    // if this is not a production build in the first place
	    // (in which case the expression below would be substituted with 'production')
	    ("production");
	} catch (e) {
	    var g = typeof window !== "undefined" ? window : global;
	    if (typeof process === "undefined") g.process = {};
	    g.process.env = {};
	}
	
	(function () {
	    function testCodeMinification() {}
	    if (testCodeMinification.name !== "testCodeMinification" && ("production") !== "production") {
	        console.warn("[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
	    }
	})();
	// This line should come after all the imports as well, for the same reason
	// as noted above. I will file a bug with rollupjs - @rossipedia
	// Devtools support
	if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    // See: https://github.com/andykog/mobx-devtools/
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
	        spy: spy,
	        extras: {
	            getDebugName: getDebugName
	        }
	    });
	}
	// TODO: remove in some future build
	if (false) {
	    var warnedAboutDefaultExport_1 = false;
	    Object.defineProperty(module.exports, "default", {
	        enumerable: false,
	        get: function get() {
	            if (!warnedAboutDefaultExport_1) {
	                warnedAboutDefaultExport_1 = true;
	                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
	            }
	            return undefined;
	        }
	    });
	    ["extras", "Atom", "BaseAtom", "ObservableMap", "asFlat", "asMap", "asReference", "asStructure", "autorunAsync", "createTranformer", "expr", "isModifierDescriptor", "isStrictModeEnabled", "map", "useStrict", "whyRun"].forEach(function (prop) {
	        Object.defineProperty(module.exports, prop, {
	            enumerable: false,
	            get: function get() {
	                fail$1("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
	            },
	            set: function set() {}
	        });
	    });
	}
	
	exports.Reaction = Reaction;
	exports.untracked = untracked;
	exports.IDerivationState = IDerivationState;
	exports.createAtom = createAtom;
	exports.spy = spy;
	exports.comparer = comparer;
	exports.isObservableObject = isObservableObject;
	exports.isBoxedObservable = isObservableValue;
	exports.isObservableArray = isObservableArray;
	exports.ObservableMap = ObservableMap;
	exports.isObservableMap = isObservableMap;
	exports.transaction = transaction;
	exports.observable = observable;
	exports.computed = computed;
	exports.isObservable = isObservable;
	exports.isObservableProp = isObservableProp;
	exports.isComputed = isComputed;
	exports.isComputedProp = isComputedProp;
	exports.extendObservable = extendObservable;
	exports.extendShallowObservable = extendShallowObservable;
	exports.observe = observe;
	exports.intercept = intercept;
	exports.autorun = autorun;
	exports.reaction = reaction;
	exports.when = when;
	exports.action = action;
	exports.isAction = isAction;
	exports.runInAction = runInAction;
	exports.keys = keys;
	exports.values = values;
	exports.set = set;
	exports.remove = remove;
	exports.has = has$1;
	exports.get = get;
	exports.decorate = decorate;
	exports.configure = configure;
	exports.onBecomeObserved = onBecomeObserved;
	exports.onBecomeUnobserved = onBecomeUnobserved;
	exports.flow = flow;
	exports.toJS = toJS;
	exports.trace = trace;
	exports.getDependencyTree = getDependencyTree;
	exports.getObserverTree = getObserverTree;
	exports._resetGlobalState = resetGlobalState;
	exports._getGlobalState = getGlobalState;
	exports.getDebugName = getDebugName;
	exports.getAtom = getAtom;
	exports._getAdministration = getAdministration;
	exports._allowStateChanges = allowStateChanges;
	exports.isArrayLike = isArrayLike;
	exports._isComputingDerivation = isComputingDerivation;
	exports.onReactionError = onReactionError;
	exports._interceptReads = interceptReads;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(227), (function() { return this; }())))

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(681);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	 * The public API for putting history on context.
	 */
	
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = Router;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pathToRegexp = __webpack_require__(698);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(81);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, p, valueof) {
	  if (valueof == null) valueof = _number2.default;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var _number = __webpack_require__(41);
	
	var _number2 = _interopRequireDefault(_number);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 86 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefix = exports.prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function has(key) {
	    return prefix + key in this;
	  },
	  get: function get(key) {
	    return this[prefix + key];
	  },
	  set: function set(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function remove(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function clear() {
	    for (var property in this) {
	      if (property[0] === prefix) delete this[property];
	    }
	  },
	  keys: function keys() {
	    var keys = [];
	    for (var property in this) {
	      if (property[0] === prefix) keys.push(property.slice(1));
	    }return keys;
	  },
	  values: function values() {
	    var values = [];
	    for (var property in this) {
	      if (property[0] === prefix) values.push(this[property]);
	    }return values;
	  },
	  entries: function entries() {
	    var entries = [];
	    for (var property in this) {
	      if (property[0] === prefix) entries.push({ key: property.slice(1), value: this[property] });
	    }return entries;
	  },
	  size: function size() {
	    var size = 0;
	    for (var property in this) {
	      if (property[0] === prefix) ++size;
	    }return size;
	  },
	  empty: function empty() {
	    for (var property in this) {
	      if (property[0] === prefix) return false;
	    }return true;
	  },
	  each: function each(f) {
	    for (var property in this) {
	      if (property[0] === prefix) f(this[property], property.slice(1), this);
	    }
	  }
	};
	
	function map(object, f) {
	  var map = new Map();
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function (value, key) {
	    map.set(key, value);
	  });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	      var i = -1,
	          n = object.length,
	          o;
	
	      if (f == null) while (++i < n) {
	        map.set(i, object[i]);
	      } else while (++i < n) {
	        map.set(f(o = object[i], i, object), o);
	      }
	    }
	
	    // Convert object to map.
	    else if (object) for (var key in object) {
	        map.set(key, object[key]);
	      }return map;
	}
	
	exports.default = map;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.brighter = exports.darker = undefined;
	exports.Color = Color;
	exports.default = color;
	exports.rgbConvert = rgbConvert;
	exports.rgb = rgb;
	exports.Rgb = Rgb;
	exports.hslConvert = hslConvert;
	exports.hsl = hsl;
	
	var _define = __webpack_require__(88);
	
	var _define2 = _interopRequireDefault(_define);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Color() {}
	
	var _darker = 0.7;
	exports.darker = _darker;
	var _brighter = 1 / _darker;
	
	exports.brighter = _brighter;
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex3 = /^#([0-9a-f]{3})$/,
	    reHex6 = /^#([0-9a-f]{6})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	(0, _define2.default)(Color, color, {
	  displayable: function displayable() {
	    return this.rgb().displayable();
	  },
	  hex: function hex() {
	    return this.rgb().hex();
	  },
	  toString: function toString() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb(m >> 8 & 0xf | m >> 4 & 0x0f0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
	  ) : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	  : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	  : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb();
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	(0, _define2.default)(Rgb, rgb, (0, _define.extend)(Color, {
	  brighter: function brighter(k) {
	    k = k == null ? _brighter : Math.pow(_brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function darker(k) {
	    k = k == null ? _darker : Math.pow(_darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function rgb() {
	    return this;
	  },
	  displayable: function displayable() {
	    return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
	  },
	  hex: function hex() {
	    return "#" + _hex(this.r) + _hex(this.g) + _hex(this.b);
	  },
	  toString: function toString() {
	    var a = this.opacity;a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function _hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl();
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	(0, _define2.default)(Hsl, hsl, (0, _define.extend)(Color, {
	  brighter: function brighter(k) {
	    k = k == null ? _brighter : Math.pow(_brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function darker(k) {
	    k = k == null ? _darker : Math.pow(_darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function rgb() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
	  },
	  displayable: function displayable() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
	}

/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	exports.extend = extend;
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) {
	    prototype[key] = definition[key];
	  }return prototype;
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _drag = __webpack_require__(292);
	
	Object.defineProperty(exports, "drag", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_drag).default;
	  }
	});
	
	var _nodrag = __webpack_require__(148);
	
	Object.defineProperty(exports, "dragDisable", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_nodrag).default;
	  }
	});
	Object.defineProperty(exports, "dragEnable", {
	  enumerable: true,
	  get: function get() {
	    return _nodrag.yesdrag;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 90 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
	      DELIMITER = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert,
	        columns,
	        rows = parseRows(text, function (row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns || [];
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var rows = [],
	        // output rows
	    N = text.length,
	        I = 0,
	        // current character index
	    n = 0,
	        // current line number
	    t,
	        // current token
	    eof = N <= 0,
	        // current token followed by EOF?
	    eol = false; // current token followed by EOL?
	
	    // Strip the trailing newline.
	    if (text.charCodeAt(N - 1) === NEWLINE) --N;
	    if (text.charCodeAt(N - 1) === RETURN) --N;
	
	    function token() {
	      if (eof) return EOF;
	      if (eol) return eol = false, EOL;
	
	      // Unescape quotes.
	      var i,
	          j = I,
	          c;
	      if (text.charCodeAt(j) === QUOTE) {
	        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE) {}
	        if ((i = I) >= N) eof = true;else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;else if (c === RETURN) {
	          eol = true;if (text.charCodeAt(I) === NEWLINE) ++I;
	        }
	        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
	      }
	
	      // Find next delimiter or newline.
	      while (I < N) {
	        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;else if (c === RETURN) {
	          eol = true;if (text.charCodeAt(I) === NEWLINE) ++I;
	        } else if (c !== DELIMITER) continue;
	        return text.slice(j, i);
	      }
	
	      // Return last token before EOF.
	      return eof = true, text.slice(j, N);
	    }
	
	    while ((t = token()) !== EOF) {
	      var row = [];
	      while (t !== EOL && t !== EOF) {
	        row.push(t), t = token();
	      }if (f && (row = f(row, n++)) == null) continue;
	      rows.push(row);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function (row) {
	      return columns.map(function (column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? "" : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\"" : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var EOL = {},
	    EOF = {},
	    QUOTE = 34,
	    NEWLINE = 10,
	    RETURN = 13;
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function (name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function (row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function (row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input, init) {
	  return fetch(input, init).then(responseText);
	};
	
	function responseText(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.text();
	}

/***/ },
/* 92 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return (Math.random() - 0.5) * 1e-6;
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultLocale = __webpack_require__(321);
	
	Object.defineProperty(exports, "formatDefaultLocale", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultLocale).default;
	  }
	});
	Object.defineProperty(exports, "format", {
	  enumerable: true,
	  get: function get() {
	    return _defaultLocale.format;
	  }
	});
	Object.defineProperty(exports, "formatPrefix", {
	  enumerable: true,
	  get: function get() {
	    return _defaultLocale.formatPrefix;
	  }
	});
	
	var _locale = __webpack_require__(155);
	
	Object.defineProperty(exports, "formatLocale", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_locale).default;
	  }
	});
	
	var _formatSpecifier = __webpack_require__(154);
	
	Object.defineProperty(exports, "formatSpecifier", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formatSpecifier).default;
	  }
	});
	
	var _precisionFixed = __webpack_require__(328);
	
	Object.defineProperty(exports, "precisionFixed", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_precisionFixed).default;
	  }
	});
	
	var _precisionPrefix = __webpack_require__(329);
	
	Object.defineProperty(exports, "precisionPrefix", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_precisionPrefix).default;
	  }
	});
	
	var _precisionRound = __webpack_require__(330);
	
	Object.defineProperty(exports, "precisionRound", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_precisionRound).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i,
	      coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
	};

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x) {
	  return x;
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.conicProjection = conicProjection;
	
	var _math = __webpack_require__(2);
	
	var _index = __webpack_require__(19);
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = _math.pi / 3,
	      m = (0, _index.projectionMutator)(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function (_) {
	    return arguments.length ? m(phi0 = _[0] * _math.radians, phi1 = _[1] * _math.radians) : [phi0 * _math.degrees, phi1 * _math.degrees];
	  };
	
	  return p;
	}

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.conicEqualAreaRaw = conicEqualAreaRaw;
	
	exports.default = function () {
	  return (0, _conic.conicProjection)(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
	};
	
	var _math = __webpack_require__(2);
	
	var _conic = __webpack_require__(96);
	
	var _cylindricalEqualArea = __webpack_require__(351);
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = (0, _math.sin)(y0),
	      n = (sy0 + (0, _math.sin)(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if ((0, _math.abs)(n) < _math.epsilon) return (0, _cylindricalEqualArea.cylindricalEqualAreaRaw)(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0),
	      r0 = (0, _math.sqrt)(c) / n;
	
	  function project(x, y) {
	    var r = (0, _math.sqrt)(c - 2 * n * (0, _math.sin)(y)) / n;
	    return [r * (0, _math.sin)(x *= n), r0 - r * (0, _math.cos)(x)];
	  }
	
	  project.invert = function (x, y) {
	    var r0y = r0 - y;
	    return [(0, _math.atan2)(x, (0, _math.abs)(r0y)) / n * (0, _math.sign)(r0y), (0, _math.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fitExtent = fitExtent;
	exports.fitSize = fitSize;
	exports.fitWidth = fitWidth;
	exports.fitHeight = fitHeight;
	
	var _stream = __webpack_require__(27);
	
	var _stream2 = _interopRequireDefault(_stream);
	
	var _bounds = __webpack_require__(166);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fit(projection, fitBounds, object) {
	  var clip = projection.clipExtent && projection.clipExtent();
	  projection.scale(150).translate([0, 0]);
	  if (clip != null) projection.clipExtent(null);
	  (0, _stream2.default)(object, projection.stream(_bounds2.default));
	  fitBounds(_bounds2.default.result());
	  if (clip != null) projection.clipExtent(clip);
	  return projection;
	}
	
	function fitExtent(projection, extent, object) {
	  return fit(projection, function (b) {
	    var w = extent[1][0] - extent[0][0],
	        h = extent[1][1] - extent[0][1],
	        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	function fitWidth(projection, width, object) {
	  return fit(projection, function (b) {
	    var w = +width,
	        k = w / (b[1][0] - b[0][0]),
	        x = (w - k * (b[1][0] + b[0][0])) / 2,
	        y = -k * b[0][1];
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	function fitHeight(projection, height, object) {
	  return fit(projection, function (b) {
	    var h = +height,
	        k = h / (b[1][1] - b[0][1]),
	        x = -k * b[0][0],
	        y = (h - k * (b[1][1] + b[0][1])) / 2;
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mercatorRaw = mercatorRaw;
	
	exports.default = function () {
	  return mercatorProjection(mercatorRaw).scale(961 / _math.tau);
	};
	
	exports.mercatorProjection = mercatorProjection;
	
	var _math = __webpack_require__(2);
	
	var _rotation = __webpack_require__(62);
	
	var _rotation2 = _interopRequireDefault(_rotation);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, (0, _math.log)((0, _math.tan)((_math.halfPi + phi) / 2))];
	}
	
	mercatorRaw.invert = function (x, y) {
	  return [x, 2 * (0, _math.atan)((0, _math.exp)(y)) - _math.halfPi];
	};
	
	function mercatorProjection(project) {
	  var m = (0, _index2.default)(project),
	      center = m.center,
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      x0 = null,
	      y0,
	      x1,
	      y1; // clip extent
	
	  m.scale = function (_) {
	    return arguments.length ? (scale(_), reclip()) : scale();
	  };
	
	  m.translate = function (_) {
	    return arguments.length ? (translate(_), reclip()) : translate();
	  };
	
	  m.center = function (_) {
	    return arguments.length ? (center(_), reclip()) : center();
	  };
	
	  m.clipExtent = function (_) {
	    return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  function reclip() {
	    var k = _math.pi * scale(),
	        t = m((0, _rotation2.default)(m.rotate()).invert([0, 0]));
	    return clipExtent(x0 == null ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]] : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
	  }
	
	  return reclip();
	}

/***/ },
/* 100 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.optional = optional;
	exports.required = required;
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error();
	  return f;
	}

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hierarchy;
	exports.computeHeight = computeHeight;
	exports.Node = Node;
	
	var _count = __webpack_require__(363);
	
	var _count2 = _interopRequireDefault(_count);
	
	var _each = __webpack_require__(365);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _eachBefore = __webpack_require__(367);
	
	var _eachBefore2 = _interopRequireDefault(_eachBefore);
	
	var _eachAfter = __webpack_require__(366);
	
	var _eachAfter2 = _interopRequireDefault(_eachAfter);
	
	var _sum = __webpack_require__(372);
	
	var _sum2 = _interopRequireDefault(_sum);
	
	var _sort = __webpack_require__(371);
	
	var _sort2 = _interopRequireDefault(_sort);
	
	var _path = __webpack_require__(370);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _ancestors = __webpack_require__(362);
	
	var _ancestors2 = _interopRequireDefault(_ancestors);
	
	var _descendants = __webpack_require__(364);
	
	var _descendants2 = _interopRequireDefault(_descendants);
	
	var _leaves = __webpack_require__(368);
	
	var _leaves2 = _interopRequireDefault(_leaves);
	
	var _links = __webpack_require__(369);
	
	var _links2 = _interopRequireDefault(_links);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do {
	    node.height = height;
	  } while ((node = node.parent) && node.height < ++height);
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth = this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: _count2.default,
	  each: _each2.default,
	  eachAfter: _eachAfter2.default,
	  eachBefore: _eachBefore2.default,
	  sum: _sum2.default,
	  sort: _sort2.default,
	  path: _path2.default,
	  ancestors: _ancestors2.default,
	  descendants: _descendants2.default,
	  leaves: _leaves2.default,
	  links: _links2.default,
	  copy: node_copy
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.phi = undefined;
	exports.squarifyRatio = squarifyRatio;
	
	var _dice = __webpack_require__(44);
	
	var _dice2 = _interopRequireDefault(_dice);
	
	var _slice = __webpack_require__(64);
	
	var _slice2 = _interopRequireDefault(_slice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var phi = exports.phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx,
	      dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do {
	      sumValue = nodes[i1++].value;
	    } while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) {
	        sumValue -= nodeValue;break;
	      }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
	    if (row.dice) (0, _dice2.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);else (0, _slice2.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	exports.default = function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function (x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	}(phi);

/***/ },
/* 103 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.basis = basis;
	
	exports.default = function (values) {
	  var n = values.length - 1;
	  return function (t) {
	    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1,
	      t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (a, b) {
	    var t = typeof b === "undefined" ? "undefined" : _typeof(b),
	        c;
	    return b == null || t === "boolean" ? (0, _constant2.default)(b) : (t === "number" ? _number2.default : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgb2.default) : _string2.default : b instanceof _d3Color.color ? _rgb2.default : b instanceof Date ? _date2.default : Array.isArray(b) ? _array2.default : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object2.default : _number2.default)(a, b);
	};
	
	var _d3Color = __webpack_require__(18);
	
	var _rgb = __webpack_require__(180);
	
	var _rgb2 = _interopRequireDefault(_rgb);
	
	var _array = __webpack_require__(175);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _date = __webpack_require__(178);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _number = __webpack_require__(65);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _object = __webpack_require__(179);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _string = __webpack_require__(181);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _constant = __webpack_require__(177);
	
	var _constant2 = _interopRequireDefault(_constant);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _quadtree = __webpack_require__(405);
	
	Object.defineProperty(exports, "quadtree", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quadtree).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 106 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	};

/***/ },
/* 107 */
35,
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name) {
	  var prefix = name += "",
	      i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return _namespaces2.default.hasOwnProperty(prefix) ? { space: _namespaces2.default[prefix], local: name } : name;
	};
	
	var _namespaces = __webpack_require__(109);
	
	var _namespaces2 = _interopRequireDefault(_namespaces);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var xhtml = exports.xhtml = "http://www.w3.org/1999/xhtml";
	
	exports.default = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};

/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (typename, value, capture) {
	  var typenames = parseTypenames(typename + ""),
	      i,
	      n = typenames.length,
	      t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) {
	    this.each(on(typenames[i], value, capture));
	  }return this;
	};
	
	exports.customEvent = customEvent;
	var filterEvents = {};
	
	var event = exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!("onmouseenter" in element)) {
	    filterEvents = { mouseenter: "mouseover", mouseleave: "mouseout" };
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function (event) {
	    var related = event.relatedTarget;
	    if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function (event1) {
	    var event0 = event; // Events can be reentrant (e.g., focus).
	    exports.event = event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function (t) {
	    var name = "",
	        i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return { type: t, name: name };
	  });
	}
	
	function onRemove(typename) {
	  return function () {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function (d, i, group) {
	    var on = this.__on,
	        o,
	        listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = { type: typename.type, name: typename.name, value: value, listener: listener, capture: capture };
	    if (!on) this.__on = [o];else on.push(o);
	  };
	}
	
	function customEvent(event1, listener, that, args) {
	  var event0 = event;
	  event1.sourceEvent = event;
	  exports.event = event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event = event0;
	  }
	}

/***/ },
/* 111 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (selector) {
	  return selector == null ? none : function () {
	    return this.querySelector(selector);
	  };
	};
	
	function none() {}

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var current = _on.event,
	      source;
	  while (source = current.sourceEvent) {
	    current = source;
	  }return current;
	};
	
	var _on = __webpack_require__(110);

/***/ },
/* 113 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (node) {
	    return node.ownerDocument && node.ownerDocument.defaultView || // node is a Node
	    node.document && node // node is a Window
	    || node.defaultView; // node is a Document
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.point = undefined;
	
	var _math = __webpack_require__(47);
	
	var _cardinal = __webpack_require__(70);
	
	function _point(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > _math.epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > _math.epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	exports.point = _point;
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    switch (this._point) {
	      case 2:
	        this._context.lineTo(this._x2, this._y2);break;
	      case 3:
	        this.point(this._x2, this._y2);break;
	    }
	    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
	      case 1:
	        this._point = 2;break;
	      case 2:
	        this._point = 3; // proceed
	      default:
	        _point(this, x, y);break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	exports.default = function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new _cardinal.Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function (alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}(0.5);

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var x = _point.x,
	      y = _point.y,
	      defined = (0, _constant2.default)(true),
	      context = null,
	      curve = _linear2.default,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = (0, _d3Path.path)());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();else output.lineEnd();
	      }
	      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function (_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant2.default)(+_), line) : x;
	  };
	
	  line.y = function (_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant2.default)(+_), line) : y;
	  };
	
	  line.defined = function (_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant2.default)(!!_), line) : defined;
	  };
	
	  line.curve = function (_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function (_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var _d3Path = __webpack_require__(28);
	
	var _constant = __webpack_require__(30);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _linear = __webpack_require__(71);
	
	var _linear2 = _interopRequireDefault(_linear);
	
	var _point = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series) {
	  var sums = series.map(sum);
	  return (0, _none2.default)(series).sort(function (a, b) {
	    return sums[a] - sums[b];
	  });
	};
	
	exports.sum = sum;
	
	var _none = __webpack_require__(49);
	
	var _none2 = _interopRequireDefault(_none);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sum(series) {
	  var s = 0,
	      i = -1,
	      n = series.length,
	      v;
	  while (++i < n) {
	    if (v = +series[i][1]) s += v;
	  }return s;
	}

/***/ },
/* 117 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.x = x;
	exports.y = y;
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultLocale = __webpack_require__(119);
	
	Object.defineProperty(exports, "timeFormatDefaultLocale", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultLocale).default;
	  }
	});
	Object.defineProperty(exports, "timeFormat", {
	  enumerable: true,
	  get: function get() {
	    return _defaultLocale.timeFormat;
	  }
	});
	Object.defineProperty(exports, "timeParse", {
	  enumerable: true,
	  get: function get() {
	    return _defaultLocale.timeParse;
	  }
	});
	Object.defineProperty(exports, "utcFormat", {
	  enumerable: true,
	  get: function get() {
	    return _defaultLocale.utcFormat;
	  }
	});
	Object.defineProperty(exports, "utcParse", {
	  enumerable: true,
	  get: function get() {
	    return _defaultLocale.utcParse;
	  }
	});
	
	var _locale = __webpack_require__(209);
	
	Object.defineProperty(exports, "timeFormatLocale", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_locale).default;
	  }
	});
	
	var _isoFormat = __webpack_require__(208);
	
	Object.defineProperty(exports, "isoFormat", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isoFormat).default;
	  }
	});
	
	var _isoParse = __webpack_require__(528);
	
	Object.defineProperty(exports, "isoParse", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isoParse).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utcParse = exports.utcFormat = exports.timeParse = exports.timeFormat = undefined;
	exports.default = defaultLocale;
	
	var _locale = __webpack_require__(209);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locale;
	var timeFormat = exports.timeFormat = undefined;
	var timeParse = exports.timeParse = undefined;
	var utcFormat = exports.utcFormat = undefined;
	var utcParse = exports.utcParse = undefined;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = (0, _locale2.default)(definition);
	  exports.timeFormat = timeFormat = locale.format;
	  exports.timeParse = timeParse = locale.parse;
	  exports.utcFormat = utcFormat = locale.utcFormat;
	  exports.utcParse = utcParse = locale.utcParse;
	  return locale;
	}

/***/ },
/* 120 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.now = now;
	exports.Timer = Timer;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	var frame = 0,
	    // is an animation frame pending?
	timeout = 0,
	    // is a timeout pending?
	interval = 0,
	    // are any timers active?
	pokeDelay = 1000,
	    // how frequently we check for clock skew
	taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = (typeof performance === "undefined" ? "undefined" : _typeof(performance)) === "object" && performance.now ? performance : Date,
	    setFrame = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) {
	  setTimeout(f, 17);
	};
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call = this._time = this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function restart(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function stop() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer();
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead,
	      e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(),
	      delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0,
	      t1 = taskHead,
	      t2,
	      time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.interrupt = exports.active = exports.transition = undefined;
	
	var _index = __webpack_require__(22);
	
	Object.defineProperty(exports, "transition", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index).default;
	  }
	});
	
	var _active = __webpack_require__(545);
	
	Object.defineProperty(exports, "active", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_active).default;
	  }
	});
	
	var _interrupt = __webpack_require__(210);
	
	Object.defineProperty(exports, "interrupt", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_interrupt).default;
	  }
	});
	
	__webpack_require__(546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEdge = createEdge;
	exports.createBorderEdge = createBorderEdge;
	exports.setEdgeEnd = setEdgeEnd;
	exports.clipEdges = clipEdges;
	
	var _Diagram = __webpack_require__(50);
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = _Diagram.edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  _Diagram.cells[left.index].halfedges.push(index);
	  _Diagram.cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = _Diagram.edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = _Diagram.edges[i], x0, y0, x1, y1) || !clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > _Diagram.epsilon || Math.abs(edge[0][1] - edge[1][1]) > _Diagram.epsilon)) {
	      delete _Diagram.edges[i];
	    }
	  }
	}

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RedBlackNode = RedBlackNode;
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function insert(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) {
	          after = after.L;
	        }after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function remove(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;else if (!right) next = left;else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) {
	      node.C = false;return;
	    }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) {
	    node = node.L;
	  }return node;
	}
	
	exports.default = RedBlackTree;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _resolvePathname = __webpack_require__(238);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(239);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(52);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	// Standard YAML's Failsafe schema.
	// http://www.yaml.org/spec/1.2/spec.html#id2802346
	
	
	'use strict';
	
	var Schema = __webpack_require__(39);
	
	module.exports = new Schema({
	  explicit: [__webpack_require__(668), __webpack_require__(666), __webpack_require__(661)]
	});

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Router = __webpack_require__(82);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(83);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = Route;

/***/ },
/* 131 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var array = Array.prototype;
	
	var slice = exports.slice = array.slice;
	var map = exports.map = array.map;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bisectLeft = exports.bisectRight = undefined;
	
	var _ascending = __webpack_require__(33);
	
	var _ascending2 = _interopRequireDefault(_ascending);
	
	var _bisector = __webpack_require__(133);
	
	var _bisector2 = _interopRequireDefault(_bisector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ascendingBisect = (0, _bisector2.default)(_ascending2.default);
	var bisectRight = exports.bisectRight = ascendingBisect.right;
	var bisectLeft = exports.bisectLeft = ascendingBisect.left;
	exports.default = bisectRight;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function left(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
	      }
	      return lo;
	    },
	    right: function right(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	var _ascending = __webpack_require__(33);
	
	var _ascending2 = _interopRequireDefault(_ascending);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ascendingComparator(f) {
	  return function (d, x) {
	    return (0, _ascending2.default)(f(d), x);
	  };
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, f) {
	  var v = (0, _variance2.default)(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var _variance = __webpack_require__(142);
	
	var _variance2 = _interopRequireDefault(_variance);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 135 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) {
	      // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) {
	          // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  } else {
	    while (++i < n) {
	      // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) {
	          // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};

/***/ },
/* 136 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) {
	      // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) {
	          // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  } else {
	    while (++i < n) {
	      // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) {
	          // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, f) {
	  if (f == null) f = pair;
	  var i = 0,
	      n = array.length - 1,
	      p = array[0],
	      pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) {
	    pairs[i] = f(p, p = array[++i]);
	  }return pairs;
	};
	
	exports.pair = pair;
	function pair(a, b) {
	  return [a, b];
	}

/***/ },
/* 138 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};

/***/ },
/* 139 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};

/***/ },
/* 140 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (start, stop, count) {
	    var reverse,
	        i = -1,
	        n,
	        ticks,
	        step;
	
	    stop = +stop, start = +start, count = +count;
	    if (start === stop && count > 0) return [start];
	    if (reverse = stop < start) n = start, start = stop, stop = n;
	    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	    if (step > 0) {
	        start = Math.ceil(start / step);
	        stop = Math.floor(stop / step);
	        ticks = new Array(n = Math.ceil(stop - start + 1));
	        while (++i < n) {
	            ticks[i] = (start + i) * step;
	        }
	    } else {
	        start = Math.floor(start * step);
	        stop = Math.ceil(stop * step);
	        ticks = new Array(n = Math.ceil(start - stop + 1));
	        while (++i < n) {
	            ticks[i] = (start - i) / step;
	        }
	    }
	
	    if (reverse) ticks.reverse();
	
	    return ticks;
	};
	
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function tickIncrement(start, stop, count) {
	    var step = (stop - start) / Math.max(0, count),
	        power = Math.floor(Math.log(step) / Math.LN10),
	        error = step / Math.pow(10, power);
	    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	    var step0 = Math.abs(stop - start) / Math.max(0, count),
	        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	        error = step0 / step1;
	    if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
	    return stop < start ? -step1 : step1;
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = (0, _min2.default)(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	var _min = __webpack_require__(136);
	
	var _min2 = _interopRequireDefault(_min);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function length(d) {
	  return d.length;
	}

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = (0, _number2.default)(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  } else {
	    while (++i < n) {
	      if (!isNaN(value = (0, _number2.default)(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var _number = __webpack_require__(41);
	
	var _number2 = _interopRequireDefault(_number);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var cos = exports.cos = Math.cos;
	var sin = exports.sin = Math.sin;
	var pi = exports.pi = Math.PI;
	var halfPi = exports.halfPi = pi / 2;
	var tau = exports.tau = pi * 2;
	var max = exports.max = Math.max;

/***/ },
/* 144 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var deg2rad = exports.deg2rad = Math.PI / 180;
	var rad2deg = exports.rad2deg = 180 / Math.PI;

/***/ },
/* 145 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var array = Array.prototype;
	
	var slice = exports.slice = array.slice;

/***/ },
/* 146 */
35,
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var dx = 1,
	      dy = 1,
	      threshold = _d3Array.thresholdSturges,
	      smooth = smoothLinear;
	
	  function contours(values) {
	    var tz = threshold(values);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      var domain = (0, _d3Array.extent)(values),
	          start = domain[0],
	          stop = domain[1];
	      tz = (0, _d3Array.tickStep)(start, stop, tz);
	      tz = (0, _d3Array.range)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
	    } else {
	      tz = tz.slice().sort(_ascending2.default);
	    }
	
	    return tz.map(function (value) {
	      return contour(values, value);
	    });
	  }
	
	  // Accumulate, smooth contour rings, assign holes to exterior rings.
	  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
	  function contour(values, value) {
	    var polygons = [],
	        holes = [];
	
	    isorings(values, value, function (ring) {
	      smooth(ring, values, value);
	      if ((0, _area2.default)(ring) > 0) polygons.push([ring]);else holes.push(ring);
	    });
	
	    holes.forEach(function (hole) {
	      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
	        if ((0, _contains2.default)((polygon = polygons[i])[0], hole) !== -1) {
	          polygon.push(hole);
	          return;
	        }
	      }
	    });
	
	    return {
	      type: "MultiPolygon",
	      value: value,
	      coordinates: polygons
	    };
	  }
	
	  // Marching squares with isolines stitched into rings.
	  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
	  function isorings(values, value, callback) {
	    var fragmentByStart = new Array(),
	        fragmentByEnd = new Array(),
	        x,
	        y,
	        t0,
	        t1,
	        t2,
	        t3;
	
	    // Special case for the first row (y = -1, t2 = t3 = 0).
	    x = y = -1;
	    t1 = values[0] >= value;
	    cases[t1 << 1].forEach(stitch);
	    while (++x < dx - 1) {
	      t0 = t1, t1 = values[x + 1] >= value;
	      cases[t0 | t1 << 1].forEach(stitch);
	    }
	    cases[t1 << 0].forEach(stitch);
	
	    // General case for the intermediate rows.
	    while (++y < dy - 1) {
	      x = -1;
	      t1 = values[y * dx + dx] >= value;
	      t2 = values[y * dx] >= value;
	      cases[t1 << 1 | t2 << 2].forEach(stitch);
	      while (++x < dx - 1) {
	        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
	        t3 = t2, t2 = values[y * dx + x + 1] >= value;
	        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
	      }
	      cases[t1 | t2 << 3].forEach(stitch);
	    }
	
	    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
	    x = -1;
	    t2 = values[y * dx] >= value;
	    cases[t2 << 2].forEach(stitch);
	    while (++x < dx - 1) {
	      t3 = t2, t2 = values[y * dx + x + 1] >= value;
	      cases[t2 << 2 | t3 << 3].forEach(stitch);
	    }
	    cases[t2 << 3].forEach(stitch);
	
	    function stitch(line) {
	      var start = [line[0][0] + x, line[0][1] + y],
	          end = [line[1][0] + x, line[1][1] + y],
	          startIndex = index(start),
	          endIndex = index(end),
	          f,
	          g;
	      if (f = fragmentByEnd[startIndex]) {
	        if (g = fragmentByStart[endIndex]) {
	          delete fragmentByEnd[f.end];
	          delete fragmentByStart[g.start];
	          if (f === g) {
	            f.ring.push(end);
	            callback(f.ring);
	          } else {
	            fragmentByStart[f.start] = fragmentByEnd[g.end] = { start: f.start, end: g.end, ring: f.ring.concat(g.ring) };
	          }
	        } else {
	          delete fragmentByEnd[f.end];
	          f.ring.push(end);
	          fragmentByEnd[f.end = endIndex] = f;
	        }
	      } else if (f = fragmentByStart[endIndex]) {
	        if (g = fragmentByEnd[startIndex]) {
	          delete fragmentByStart[f.start];
	          delete fragmentByEnd[g.end];
	          if (f === g) {
	            f.ring.push(end);
	            callback(f.ring);
	          } else {
	            fragmentByStart[g.start] = fragmentByEnd[f.end] = { start: g.start, end: f.end, ring: g.ring.concat(f.ring) };
	          }
	        } else {
	          delete fragmentByStart[f.start];
	          f.ring.unshift(start);
	          fragmentByStart[f.start = startIndex] = f;
	        }
	      } else {
	        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = { start: startIndex, end: endIndex, ring: [start, end] };
	      }
	    }
	  }
	
	  function index(point) {
	    return point[0] * 2 + point[1] * (dx + 1) * 4;
	  }
	
	  function smoothLinear(ring, values, value) {
	    ring.forEach(function (point) {
	      var x = point[0],
	          y = point[1],
	          xt = x | 0,
	          yt = y | 0,
	          v0,
	          v1 = values[yt * dx + xt];
	      if (x > 0 && x < dx && xt === x) {
	        v0 = values[yt * dx + xt - 1];
	        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
	      }
	      if (y > 0 && y < dy && yt === y) {
	        v0 = values[(yt - 1) * dx + xt];
	        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
	      }
	    });
	  }
	
	  contours.contour = contour;
	
	  contours.size = function (_) {
	    if (!arguments.length) return [dx, dy];
	    var _0 = Math.ceil(_[0]),
	        _1 = Math.ceil(_[1]);
	    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
	    return dx = _0, dy = _1, contours;
	  };
	
	  contours.thresholds = function (_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant2.default)(_array.slice.call(_)) : (0, _constant2.default)(_), contours) : threshold;
	  };
	
	  contours.smooth = function (_) {
	    return arguments.length ? (smooth = _ ? smoothLinear : _noop2.default, contours) : smooth === smoothLinear;
	  };
	
	  return contours;
	};
	
	var _d3Array = __webpack_require__(9);
	
	var _array = __webpack_require__(145);
	
	var _ascending = __webpack_require__(285);
	
	var _ascending2 = _interopRequireDefault(_ascending);
	
	var _area = __webpack_require__(284);
	
	var _area2 = _interopRequireDefault(_area);
	
	var _constant = __webpack_require__(146);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _contains = __webpack_require__(287);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _noop = __webpack_require__(289);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cases = [[], [[[1.0, 1.5], [0.5, 1.0]]], [[[1.5, 1.0], [1.0, 1.5]]], [[[1.5, 1.0], [0.5, 1.0]]], [[[1.0, 0.5], [1.5, 1.0]]], [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]], [[[1.0, 0.5], [1.0, 1.5]]], [[[1.0, 0.5], [0.5, 1.0]]], [[[0.5, 1.0], [1.0, 0.5]]], [[[1.0, 1.5], [1.0, 0.5]]], [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]], [[[1.5, 1.0], [1.0, 0.5]]], [[[0.5, 1.0], [1.5, 1.0]]], [[[1.0, 1.5], [1.5, 1.0]]], [[[0.5, 1.0], [1.0, 1.5]]], []];

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (view) {
	  var root = view.document.documentElement,
	      selection = (0, _d3Selection.select)(view).on("dragstart.drag", _noevent2.default, true);
	  if ("onselectstart" in root) {
	    selection.on("selectstart.drag", _noevent2.default, true);
	  } else {
	    root.__noselect = root.style.MozUserSelect;
	    root.style.MozUserSelect = "none";
	  }
	};
	
	exports.yesdrag = yesdrag;
	
	var _d3Selection = __webpack_require__(8);
	
	var _noevent = __webpack_require__(149);
	
	var _noevent2 = _interopRequireDefault(_noevent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function yesdrag(view, noclick) {
	  var root = view.document.documentElement,
	      selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
	  if (noclick) {
	    selection.on("click.drag", _noevent2.default, true);
	    setTimeout(function () {
	      selection.on("click.drag", null);
	    }, 0);
	  }
	  if ("onselectstart" in root) {
	    selection.on("selectstart.drag", null);
	  } else {
	    root.style.MozUserSelect = root.__noselect;
	    delete root.__noselect;
	  }
	}

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nopropagation = nopropagation;
	
	exports.default = function () {
	  _d3Selection.event.preventDefault();
	  _d3Selection.event.stopImmediatePropagation();
	};
	
	var _d3Selection = __webpack_require__(8);
	
	function nopropagation() {
	  _d3Selection.event.stopImmediatePropagation();
	}

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsv = __webpack_require__(90);
	
	Object.defineProperty(exports, "dsvFormat", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dsv).default;
	  }
	});
	
	var _csv = __webpack_require__(294);
	
	Object.defineProperty(exports, "csvParse", {
	  enumerable: true,
	  get: function get() {
	    return _csv.csvParse;
	  }
	});
	Object.defineProperty(exports, "csvParseRows", {
	  enumerable: true,
	  get: function get() {
	    return _csv.csvParseRows;
	  }
	});
	Object.defineProperty(exports, "csvFormat", {
	  enumerable: true,
	  get: function get() {
	    return _csv.csvFormat;
	  }
	});
	Object.defineProperty(exports, "csvFormatRows", {
	  enumerable: true,
	  get: function get() {
	    return _csv.csvFormatRows;
	  }
	});
	
	var _tsv = __webpack_require__(295);
	
	Object.defineProperty(exports, "tsvParse", {
	  enumerable: true,
	  get: function get() {
	    return _tsv.tsvParse;
	  }
	});
	Object.defineProperty(exports, "tsvParseRows", {
	  enumerable: true,
	  get: function get() {
	    return _tsv.tsvParseRows;
	  }
	});
	Object.defineProperty(exports, "tsvFormat", {
	  enumerable: true,
	  get: function get() {
	    return _tsv.tsvFormat;
	  }
	});
	Object.defineProperty(exports, "tsvFormatRows", {
	  enumerable: true,
	  get: function get() {
	    return _tsv.tsvFormatRows;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _linear = __webpack_require__(302);
	
	Object.defineProperty(exports, "easeLinear", {
	  enumerable: true,
	  get: function get() {
	    return _linear.linear;
	  }
	});
	
	var _quad = __webpack_require__(304);
	
	Object.defineProperty(exports, "easeQuad", {
	  enumerable: true,
	  get: function get() {
	    return _quad.quadInOut;
	  }
	});
	Object.defineProperty(exports, "easeQuadIn", {
	  enumerable: true,
	  get: function get() {
	    return _quad.quadIn;
	  }
	});
	Object.defineProperty(exports, "easeQuadOut", {
	  enumerable: true,
	  get: function get() {
	    return _quad.quadOut;
	  }
	});
	Object.defineProperty(exports, "easeQuadInOut", {
	  enumerable: true,
	  get: function get() {
	    return _quad.quadInOut;
	  }
	});
	
	var _cubic = __webpack_require__(299);
	
	Object.defineProperty(exports, "easeCubic", {
	  enumerable: true,
	  get: function get() {
	    return _cubic.cubicInOut;
	  }
	});
	Object.defineProperty(exports, "easeCubicIn", {
	  enumerable: true,
	  get: function get() {
	    return _cubic.cubicIn;
	  }
	});
	Object.defineProperty(exports, "easeCubicOut", {
	  enumerable: true,
	  get: function get() {
	    return _cubic.cubicOut;
	  }
	});
	Object.defineProperty(exports, "easeCubicInOut", {
	  enumerable: true,
	  get: function get() {
	    return _cubic.cubicInOut;
	  }
	});
	
	var _poly = __webpack_require__(303);
	
	Object.defineProperty(exports, "easePoly", {
	  enumerable: true,
	  get: function get() {
	    return _poly.polyInOut;
	  }
	});
	Object.defineProperty(exports, "easePolyIn", {
	  enumerable: true,
	  get: function get() {
	    return _poly.polyIn;
	  }
	});
	Object.defineProperty(exports, "easePolyOut", {
	  enumerable: true,
	  get: function get() {
	    return _poly.polyOut;
	  }
	});
	Object.defineProperty(exports, "easePolyInOut", {
	  enumerable: true,
	  get: function get() {
	    return _poly.polyInOut;
	  }
	});
	
	var _sin = __webpack_require__(305);
	
	Object.defineProperty(exports, "easeSin", {
	  enumerable: true,
	  get: function get() {
	    return _sin.sinInOut;
	  }
	});
	Object.defineProperty(exports, "easeSinIn", {
	  enumerable: true,
	  get: function get() {
	    return _sin.sinIn;
	  }
	});
	Object.defineProperty(exports, "easeSinOut", {
	  enumerable: true,
	  get: function get() {
	    return _sin.sinOut;
	  }
	});
	Object.defineProperty(exports, "easeSinInOut", {
	  enumerable: true,
	  get: function get() {
	    return _sin.sinInOut;
	  }
	});
	
	var _exp = __webpack_require__(301);
	
	Object.defineProperty(exports, "easeExp", {
	  enumerable: true,
	  get: function get() {
	    return _exp.expInOut;
	  }
	});
	Object.defineProperty(exports, "easeExpIn", {
	  enumerable: true,
	  get: function get() {
	    return _exp.expIn;
	  }
	});
	Object.defineProperty(exports, "easeExpOut", {
	  enumerable: true,
	  get: function get() {
	    return _exp.expOut;
	  }
	});
	Object.defineProperty(exports, "easeExpInOut", {
	  enumerable: true,
	  get: function get() {
	    return _exp.expInOut;
	  }
	});
	
	var _circle = __webpack_require__(298);
	
	Object.defineProperty(exports, "easeCircle", {
	  enumerable: true,
	  get: function get() {
	    return _circle.circleInOut;
	  }
	});
	Object.defineProperty(exports, "easeCircleIn", {
	  enumerable: true,
	  get: function get() {
	    return _circle.circleIn;
	  }
	});
	Object.defineProperty(exports, "easeCircleOut", {
	  enumerable: true,
	  get: function get() {
	    return _circle.circleOut;
	  }
	});
	Object.defineProperty(exports, "easeCircleInOut", {
	  enumerable: true,
	  get: function get() {
	    return _circle.circleInOut;
	  }
	});
	
	var _bounce = __webpack_require__(297);
	
	Object.defineProperty(exports, "easeBounce", {
	  enumerable: true,
	  get: function get() {
	    return _bounce.bounceOut;
	  }
	});
	Object.defineProperty(exports, "easeBounceIn", {
	  enumerable: true,
	  get: function get() {
	    return _bounce.bounceIn;
	  }
	});
	Object.defineProperty(exports, "easeBounceOut", {
	  enumerable: true,
	  get: function get() {
	    return _bounce.bounceOut;
	  }
	});
	Object.defineProperty(exports, "easeBounceInOut", {
	  enumerable: true,
	  get: function get() {
	    return _bounce.bounceInOut;
	  }
	});
	
	var _back = __webpack_require__(296);
	
	Object.defineProperty(exports, "easeBack", {
	  enumerable: true,
	  get: function get() {
	    return _back.backInOut;
	  }
	});
	Object.defineProperty(exports, "easeBackIn", {
	  enumerable: true,
	  get: function get() {
	    return _back.backIn;
	  }
	});
	Object.defineProperty(exports, "easeBackOut", {
	  enumerable: true,
	  get: function get() {
	    return _back.backOut;
	  }
	});
	Object.defineProperty(exports, "easeBackInOut", {
	  enumerable: true,
	  get: function get() {
	    return _back.backInOut;
	  }
	});
	
	var _elastic = __webpack_require__(300);
	
	Object.defineProperty(exports, "easeElastic", {
	  enumerable: true,
	  get: function get() {
	    return _elastic.elasticOut;
	  }
	});
	Object.defineProperty(exports, "easeElasticIn", {
	  enumerable: true,
	  get: function get() {
	    return _elastic.elasticIn;
	  }
	});
	Object.defineProperty(exports, "easeElasticOut", {
	  enumerable: true,
	  get: function get() {
	    return _elastic.elasticOut;
	  }
	});
	Object.defineProperty(exports, "easeElasticInOut", {
	  enumerable: true,
	  get: function get() {
	    return _elastic.elasticInOut;
	  }
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	exports.x = x;
	exports.y = y;
	
	var _d3Dispatch = __webpack_require__(34);
	
	var _d3Collection = __webpack_require__(59);
	
	var _d3Timer = __webpack_require__(74);
	
	function x(d) {
	  return d.x;
	}
	
	function y(d) {
	  return d.y;
	}
	
	var initialRadius = 10,
	    initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	function _default(_nodes) {
	  var simulation,
	      _alpha = 1,
	      _alphaMin = 0.001,
	      _alphaDecay = 1 - Math.pow(_alphaMin, 1 / 300),
	      _alphaTarget = 0,
	      _velocityDecay = 0.6,
	      forces = (0, _d3Collection.map)(),
	      stepper = (0, _d3Timer.timer)(step),
	      event = (0, _d3Dispatch.dispatch)("tick", "end");
	
	  if (_nodes == null) _nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (_alpha < _alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i,
	        n = _nodes.length,
	        node;
	
	    _alpha += (_alphaTarget - _alpha) * _alphaDecay;
	
	    forces.each(function (force) {
	      force(_alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = _nodes[i];
	      if (node.fx == null) node.x += node.vx *= _velocityDecay;else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= _velocityDecay;else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = _nodes.length, node; i < n; ++i) {
	      node = _nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i),
	            angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(_nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function restart() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function stop() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function nodes(_) {
	      return arguments.length ? (_nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : _nodes;
	    },
	
	    alpha: function alpha(_) {
	      return arguments.length ? (_alpha = +_, simulation) : _alpha;
	    },
	
	    alphaMin: function alphaMin(_) {
	      return arguments.length ? (_alphaMin = +_, simulation) : _alphaMin;
	    },
	
	    alphaDecay: function alphaDecay(_) {
	      return arguments.length ? (_alphaDecay = +_, simulation) : +_alphaDecay;
	    },
	
	    alphaTarget: function alphaTarget(_) {
	      return arguments.length ? (_alphaTarget = +_, simulation) : _alphaTarget;
	    },
	
	    velocityDecay: function velocityDecay(_) {
	      return arguments.length ? (_velocityDecay = 1 - _, simulation) : 1 - _velocityDecay;
	    },
	
	    force: function force(name, _) {
	      return arguments.length > 1 ? (_ == null ? forces.remove(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
	    },
	
	    find: function find(x, y, radius) {
	      var i = 0,
	          n = _nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = _nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function on(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	}
	exports.default = _default;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.prefixExponent = undefined;
	
	exports.default = function (x, p) {
	    var d = (0, _formatDecimal2.default)(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1],
	        i = exponent - (exports.prefixExponent = prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	        n = coefficient.length;
	    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimal2.default)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var _formatDecimal = __webpack_require__(94);
	
	var _formatDecimal2 = _interopRequireDefault(_formatDecimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixExponent = exports.prefixExponent = undefined;

/***/ },
/* 154 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatSpecifier;
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  this.fill = match[1] || " ";
	  this.align = match[2] || ">";
	  this.sign = match[3] || "-";
	  this.symbol = match[4] || "";
	  this.zero = !!match[5];
	  this.width = match[6] && +match[6];
	  this.comma = !!match[7];
	  this.precision = match[8] && +match[8].slice(1);
	  this.trim = !!match[9];
	  this.type = match[10] || "";
	}
	
	FormatSpecifier.prototype.toString = function () {
	  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (locale) {
	  var group = locale.grouping && locale.thousands ? (0, _formatGroup2.default)(locale.grouping, locale.thousands) : _identity2.default,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? (0, _formatNumerals2.default)(locale.numerals) : _identity2.default,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = (0, _formatSpecifier2.default)(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!_formatTypes2.default[type]) precision == null && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = _formatTypes2.default[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i,
	          n,
	          c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = (0, _formatTrim2.default)(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? sign === "(" ? sign : "-" : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + _formatPrefixAuto.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<":
	          value = valuePrefix + value + valueSuffix + padding;break;
	        case "=":
	          value = valuePrefix + padding + value + valueSuffix;break;
	        case "^":
	          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);break;
	        default:
	          value = padding + valuePrefix + value + valueSuffix;break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function () {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = (0, _formatSpecifier2.default)(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor((0, _exponent2.default)(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function (value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var _exponent = __webpack_require__(60);
	
	var _exponent2 = _interopRequireDefault(_exponent);
	
	var _formatGroup = __webpack_require__(322);
	
	var _formatGroup2 = _interopRequireDefault(_formatGroup);
	
	var _formatNumerals = __webpack_require__(323);
	
	var _formatNumerals2 = _interopRequireDefault(_formatNumerals);
	
	var _formatSpecifier = __webpack_require__(154);
	
	var _formatSpecifier2 = _interopRequireDefault(_formatSpecifier);
	
	var _formatTrim = __webpack_require__(325);
	
	var _formatTrim2 = _interopRequireDefault(_formatTrim);
	
	var _formatTypes = __webpack_require__(326);
	
	var _formatTypes2 = _interopRequireDefault(_formatTypes);
	
	var _formatPrefixAuto = __webpack_require__(153);
	
	var _identity = __webpack_require__(327);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.areaStream = exports.areaRingSum = undefined;
	
	exports.default = function (object) {
	  areaSum.reset();
	  (0, _stream2.default)(object, areaStream);
	  return areaSum * 2;
	};
	
	var _adder = __webpack_require__(36);
	
	var _adder2 = _interopRequireDefault(_adder);
	
	var _math = __webpack_require__(2);
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _stream = __webpack_require__(27);
	
	var _stream2 = _interopRequireDefault(_stream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var areaRingSum = exports.areaRingSum = (0, _adder2.default)();
	
	var areaSum = (0, _adder2.default)(),
	    lambda00,
	    phi00,
	    lambda0,
	    cosPhi0,
	    sinPhi0;
	
	var areaStream = exports.areaStream = {
	  point: _noop2.default,
	  lineStart: _noop2.default,
	  lineEnd: _noop2.default,
	  polygonStart: function polygonStart() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function polygonEnd() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? _math.tau + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = _noop2.default;
	  },
	  sphere: function sphere() {
	    areaSum.add(_math.tau);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= _math.radians, phi *= _math.radians;
	  lambda0 = lambda, cosPhi0 = (0, _math.cos)(phi = phi / 2 + _math.quarterPi), sinPhi0 = (0, _math.sin)(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= _math.radians, phi *= _math.radians;
	  phi = phi / 2 + _math.quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = (0, _math.cos)(phi),
	      sinPhi = (0, _math.sin)(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * (0, _math.cos)(adLambda),
	      v = k * sdLambda * (0, _math.sin)(adLambda);
	  areaRingSum.add((0, _math.atan2)(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.circleStream = circleStream;
	
	exports.default = function () {
	  var center = (0, _constant2.default)([0, 0]),
	      radius = (0, _constant2.default)(90),
	      precision = (0, _constant2.default)(6),
	      ring,
	      rotate,
	      stream = { point: point };
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= _math.degrees, x[1] *= _math.degrees;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * _math.radians,
	        p = precision.apply(this, arguments) * _math.radians;
	    ring = [];
	    rotate = (0, _rotation.rotateRadians)(-c[0] * _math.radians, -c[1] * _math.radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = { type: "Polygon", coordinates: [ring] };
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function (_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : (0, _constant2.default)([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function (_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constant2.default)(+_), circle) : radius;
	  };
	
	  circle.precision = function (_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : (0, _constant2.default)(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var _cartesian = __webpack_require__(42);
	
	var _constant = __webpack_require__(336);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _math = __webpack_require__(2);
	
	var _rotation = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = (0, _math.cos)(radius),
	      sinRadius = (0, _math.sin)(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * _math.tau;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * _math.tau;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = (0, _cartesian.spherical)([cosRadius, -sinRadius * (0, _math.cos)(t), -sinRadius * (0, _math.sin)(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = (0, _cartesian.cartesian)(point), point[0] -= cosRadius;
	  (0, _cartesian.cartesianNormalizeInPlace)(point);
	  var radius = (0, _math.acos)(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + _math.tau - _math.epsilon) % _math.tau;
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(161);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _math = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _index2.default)(function () {
	  return true;
	}, clipAntimeridianLine, clipAntimeridianInterpolate, [-_math.pi, -_math.halfPi]);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      _clean; // no intersections
	
	  return {
	    lineStart: function lineStart() {
	      stream.lineStart();
	      _clean = 1;
	    },
	    point: function point(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? _math.pi : -_math.pi,
	          delta = (0, _math.abs)(lambda1 - lambda0);
	      if ((0, _math.abs)(delta - _math.pi) < _math.epsilon) {
	        // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? _math.halfPi : -_math.halfPi);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        _clean = 0;
	      } else if (sign0 !== sign1 && delta >= _math.pi) {
	        // line crosses antimeridian
	        if ((0, _math.abs)(lambda0 - sign0) < _math.epsilon) lambda0 -= sign0 * _math.epsilon; // handle degeneracies
	        if ((0, _math.abs)(lambda1 - sign1) < _math.epsilon) lambda1 -= sign1 * _math.epsilon;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        _clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function lineEnd() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function clean() {
	      return 2 - _clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = (0, _math.sin)(lambda0 - lambda1);
	  return (0, _math.abs)(sinLambda0Lambda1) > _math.epsilon ? (0, _math.atan)(((0, _math.sin)(phi0) * (cosPhi1 = (0, _math.cos)(phi1)) * (0, _math.sin)(lambda1) - (0, _math.sin)(phi1) * (cosPhi0 = (0, _math.cos)(phi0)) * (0, _math.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * _math.halfPi;
	    stream.point(-_math.pi, phi);
	    stream.point(0, phi);
	    stream.point(_math.pi, phi);
	    stream.point(_math.pi, 0);
	    stream.point(_math.pi, -phi);
	    stream.point(0, -phi);
	    stream.point(-_math.pi, -phi);
	    stream.point(-_math.pi, 0);
	    stream.point(-_math.pi, phi);
	  } else if ((0, _math.abs)(from[0] - to[0]) > _math.epsilon) {
	    var lambda = from[0] < to[0] ? _math.pi : -_math.pi;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var lines = [],
	      line;
	  return {
	    point: function point(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function lineStart() {
	      lines.push(line = []);
	    },
	    lineEnd: _noop2.default,
	    rejoin: function rejoin() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function result() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (radius) {
	  var cr = (0, _math.cos)(radius),
	      delta = 6 * _math.radians,
	      smallRadius = cr > 0,
	      notHemisphere = (0, _math.abs)(cr) > _math.epsilon; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    (0, _circle.circleStream)(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return (0, _math.cos)(lambda) * (0, _math.cos)(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	    c0, // code for previous point
	    v0, // visibility of previous point
	    v00, // visibility of first point
	    _clean; // no intersections
	    return {
	      lineStart: function lineStart() {
	        v00 = v0 = false;
	        _clean = 1;
	      },
	      point: function point(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? _math.pi : -_math.pi), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (!point2 || (0, _pointEqual2.default)(point0, point2) || (0, _pointEqual2.default)(point1, point2)) {
	            point1[0] += _math.epsilon;
	            point1[1] += _math.epsilon;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          _clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            _clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !(0, _pointEqual2.default)(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function lineEnd() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function clean() {
	        return _clean | (v00 && v0) << 1;
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = (0, _cartesian.cartesian)(a),
	        pb = (0, _cartesian.cartesian)(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0],
	        // normal
	    n2 = (0, _cartesian.cartesianCross)(pa, pb),
	        n2n2 = (0, _cartesian.cartesianDot)(n2, n2),
	        n1n2 = n2[0],
	        // cartesianDot(n1, n2),
	    determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 = cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = (0, _cartesian.cartesianCross)(n1, n2),
	        A = (0, _cartesian.cartesianScale)(n1, c1),
	        B = (0, _cartesian.cartesianScale)(n2, c2);
	    (0, _cartesian.cartesianAddInPlace)(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = (0, _cartesian.cartesianDot)(A, u),
	        uu = (0, _cartesian.cartesianDot)(u, u),
	        t2 = w * w - uu * ((0, _cartesian.cartesianDot)(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = (0, _math.sqrt)(t2),
	        q = (0, _cartesian.cartesianScale)(u, (-w - t) / uu);
	    (0, _cartesian.cartesianAddInPlace)(q, A);
	    q = (0, _cartesian.spherical)(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = (0, _math.abs)(delta - _math.pi) < _math.epsilon,
	        meridian = polar || delta < _math.epsilon;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _math.abs)(q[0] - lambda0) < _math.epsilon ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > _math.pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = (0, _cartesian.cartesianScale)(u, (-w + t) / uu);
	      (0, _cartesian.cartesianAddInPlace)(q1, A);
	      return [q, (0, _cartesian.spherical)(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : _math.pi - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return (0, _index2.default)(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-_math.pi, radius - _math.pi]);
	};
	
	var _cartesian = __webpack_require__(42);
	
	var _circle = __webpack_require__(157);
	
	var _math = __webpack_require__(2);
	
	var _pointEqual = __webpack_require__(167);
	
	var _pointEqual2 = _interopRequireDefault(_pointEqual);
	
	var _index = __webpack_require__(161);
	
	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (pointVisible, clipLine, interpolate, start) {
	  return function (sink) {
	    var line = clipLine(sink),
	        ringBuffer = (0, _buffer2.default)(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function polygonStart() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function polygonEnd() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = (0, _d3Array.merge)(segments);
	        var startInside = (0, _polygonContains2.default)(polygon, start);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          (0, _rejoin2.default)(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function sphere() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      line.point(lambda, phi);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      ringSink.point(lambda, phi);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i,
	          n = ringSegments.length,
	          m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) {
	            sink.point((point = segment[i])[0], point[1]);
	          }sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	var _buffer = __webpack_require__(159);
	
	var _buffer2 = _interopRequireDefault(_buffer);
	
	var _rejoin = __webpack_require__(162);
	
	var _rejoin2 = _interopRequireDefault(_rejoin);
	
	var _math = __webpack_require__(2);
	
	var _polygonContains = __webpack_require__(168);
	
	var _polygonContains2 = _interopRequireDefault(_polygonContains);
	
	var _d3Array = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - _math.halfPi - _math.epsilon : _math.halfPi - a[1]) - ((b = b.x)[0] < 0 ? b[1] - _math.halfPi - _math.epsilon : _math.halfPi - b[1]);
	}

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function (segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n,
	        p0 = segment[0],
	        p1 = segment[n],
	        x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if ((0, _pointEqual2.default)(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) {
	        stream.point((p0 = segment[i])[0], p0[1]);
	      }stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link(subject);
	  link(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) {
	      if ((current = current.n) === start) return;
	    }points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) {
	            stream.point((point = points[i])[0], point[1]);
	          }
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) {
	            stream.point((point = points[i])[0], point[1]);
	          }
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	var _pointEqual = __webpack_require__(167);
	
	var _pointEqual2 = _interopRequireDefault(_pointEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	
	
	function link(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}

/***/ },
/* 163 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function (x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return (0, _length2.default)(object);
	};
	
	var _length = __webpack_require__(165);
	
	var _length2 = _interopRequireDefault(_length);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coordinates = [null, null],
	    object = { type: "LineString", coordinates: coordinates };

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (object) {
	  lengthSum.reset();
	  (0, _stream2.default)(object, lengthStream);
	  return +lengthSum;
	};
	
	var _adder = __webpack_require__(36);
	
	var _adder2 = _interopRequireDefault(_adder);
	
	var _math = __webpack_require__(2);
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _stream = __webpack_require__(27);
	
	var _stream2 = _interopRequireDefault(_stream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengthSum = (0, _adder2.default)(),
	    lambda0,
	    sinPhi0,
	    cosPhi0;
	
	var lengthStream = {
	  sphere: _noop2.default,
	  point: _noop2.default,
	  lineStart: lengthLineStart,
	  lineEnd: _noop2.default,
	  polygonStart: _noop2.default,
	  polygonEnd: _noop2.default
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = _noop2.default;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= _math.radians, phi *= _math.radians;
	  lambda0 = lambda, sinPhi0 = (0, _math.sin)(phi), cosPhi0 = (0, _math.cos)(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= _math.radians, phi *= _math.radians;
	  var sinPhi = (0, _math.sin)(phi),
	      cosPhi = (0, _math.cos)(phi),
	      delta = (0, _math.abs)(lambda - lambda0),
	      cosDelta = (0, _math.cos)(delta),
	      sinDelta = (0, _math.sin)(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
	      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
	  lengthSum.add((0, _math.atan2)((0, _math.sqrt)(x * x + y * y), z));
	  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
	}

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var x0 = Infinity,
	    y0 = x0,
	    x1 = -x0,
	    y1 = x1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: _noop2.default,
	  lineEnd: _noop2.default,
	  polygonStart: _noop2.default,
	  polygonEnd: _noop2.default,
	  result: function result() {
	    var bounds = [[x0, y0], [x1, y1]];
	    x1 = y1 = -(y0 = x0 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint(x, y) {
	  if (x < x0) x0 = x;
	  if (x > x1) x1 = x;
	  if (y < y0) y0 = y;
	  if (y > y1) y1 = y;
	}
	
	exports.default = boundsStream;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  return (0, _math.abs)(a[0] - b[0]) < _math.epsilon && (0, _math.abs)(a[1] - b[1]) < _math.epsilon;
	};
	
	var _math = __webpack_require__(2);

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      sinPhi = (0, _math.sin)(phi),
	      normal = [(0, _math.sin)(lambda), -(0, _math.cos)(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum.reset();
	
	  if (sinPhi === 1) phi = _math.halfPi + _math.epsilon;else if (sinPhi === -1) phi = -_math.halfPi - _math.epsilon;
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + _math.quarterPi,
	        sinPhi0 = (0, _math.sin)(phi0),
	        cosPhi0 = (0, _math.cos)(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + _math.quarterPi,
	          sinPhi1 = (0, _math.sin)(phi1),
	          cosPhi1 = (0, _math.cos)(phi1),
	          delta = lambda1 - lambda0,
	          sign = delta >= 0 ? 1 : -1,
	          absDelta = sign * delta,
	          antimeridian = absDelta > _math.pi,
	          k = sinPhi0 * sinPhi1;
	
	      sum.add((0, _math.atan2)(k * sign * (0, _math.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, _math.cos)(absDelta)));
	      angle += antimeridian ? delta + sign * _math.tau : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = (0, _cartesian.cartesianCross)((0, _cartesian.cartesian)(point0), (0, _cartesian.cartesian)(point1));
	        (0, _cartesian.cartesianNormalizeInPlace)(arc);
	        var intersection = (0, _cartesian.cartesianCross)(normal, arc);
	        (0, _cartesian.cartesianNormalizeInPlace)(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _math.asin)(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -_math.epsilon || angle < _math.epsilon && sum < -_math.epsilon) ^ winding & 1;
	};
	
	var _adder = __webpack_require__(36);
	
	var _adder2 = _interopRequireDefault(_adder);
	
	var _cartesian = __webpack_require__(42);
	
	var _math = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sum = (0, _adder2.default)();

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return (0, _conicEqualArea2.default)().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
	};
	
	var _conicEqualArea = __webpack_require__(97);
	
	var _conicEqualArea2 = _interopRequireDefault(_conicEqualArea);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.equirectangularRaw = equirectangularRaw;
	
	exports.default = function () {
	  return (0, _index2.default)(equirectangularRaw).scale(152.63);
	};
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;

/***/ },
/* 171 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.constantZero = constantZero;
	
	exports.default = function (x) {
	  return function () {
	    return x;
	  };
	};
	
	function constantZero() {
	  return 0;
	}

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (circles) {
	  var i = 0,
	      n = (circles = (0, _array.shuffle)(_array.slice.call(circles))).length,
	      B = [],
	      p,
	      e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	};
	
	var _array = __webpack_require__(360);
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error();
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r,
	      dx = b.x - a.x,
	      dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6,
	      dx = b.x - a.x,
	      dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1:
	      return encloseBasis1(B[0]);
	    case 2:
	      return encloseBasis2(B[0], B[1]);
	    case 3:
	      return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x,
	      y1 = a.y,
	      r1 = a.r,
	      x2 = b.x,
	      y2 = b.y,
	      r2 = b.r,
	      x21 = x2 - x1,
	      y21 = y2 - y1,
	      r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x,
	      y1 = a.y,
	      r1 = a.r,
	      x2 = b.x,
	      y2 = b.y,
	      r2 = b.r,
	      x3 = c.x,
	      y3 = c.y,
	      r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.packEnclose = packEnclose;
	
	exports.default = function (circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	var _enclose = __webpack_require__(172);
	
	var _enclose2 = _interopRequireDefault(_enclose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function place(b, a, c) {
	  var dx = b.x - a.x,
	      x,
	      a2,
	      dy = b.y - a.y,
	      y,
	      b2,
	      d2 = dx * dx + dy * dy;
	  if (d2) {
	    a2 = a.r + c.r, a2 *= a2;
	    b2 = b.r + c.r, b2 *= b2;
	    if (a2 > b2) {
	      x = (d2 + b2 - a2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
	      c.x = b.x - x * dx - y * dy;
	      c.y = b.y - x * dy + y * dx;
	    } else {
	      x = (d2 + a2 - b2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
	      c.x = a.x + x * dx - y * dy;
	      c.y = a.y + x * dy + y * dx;
	    }
	  } else {
	    c.x = a.x + c.r;
	    c.y = a.y;
	  }
	}
	
	function intersects(a, b) {
	  var dr = a.r + b.r - 1e-6,
	      dx = b.x - a.x,
	      dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node(a), b = new Node(b), c = new Node(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b;while ((c = c.next) !== b) {
	    a.push(c._);
	  }c = (0, _enclose2.default)(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) {
	    a = circles[i], a.x -= c.x, a.y -= c.y;
	  }return c.r;
	}

/***/ },
/* 174 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) {
	    x[i] = (0, _value2.default)(a[i], b[i]);
	  }for (; i < nb; ++i) {
	    c[i] = b[i];
	  }return function (t) {
	    for (i = 0; i < na; ++i) {
	      c[i] = x[i](t);
	    }return c;
	  };
	};
	
	var _value = __webpack_require__(104);
	
	var _value2 = _interopRequireDefault(_value);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values) {
	  var n = values.length;
	  return function (t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return (0, _basis.basis)((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var _basis = __webpack_require__(103);

/***/ },
/* 177 */
35,
/* 178 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  var d = new Date();
	  return a = +a, b -= a, function (t) {
	    return d.setTime(a + b * t), d;
	  };
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || (typeof a === "undefined" ? "undefined" : _typeof(a)) !== "object") a = {};
	  if (b === null || (typeof b === "undefined" ? "undefined" : _typeof(b)) !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = (0, _value2.default)(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function (t) {
	    for (k in i) {
	      c[k] = i[k](t);
	    }return c;
	  };
	};
	
	var _value = __webpack_require__(104);
	
	var _value2 = _interopRequireDefault(_value);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rgbBasisClosed = exports.rgbBasis = undefined;
	
	var _d3Color = __webpack_require__(18);
	
	var _basis = __webpack_require__(103);
	
	var _basis2 = _interopRequireDefault(_basis);
	
	var _basisClosed = __webpack_require__(176);
	
	var _basisClosed2 = _interopRequireDefault(_basisClosed);
	
	var _color = __webpack_require__(45);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function rgbGamma(y) {
	  var color = (0, _color.gamma)(y);
	
	  function rgb(start, end) {
	    var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = (0, _color2.default)(start.opacity, end.opacity);
	    return function (t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	}(1);
	
	function rgbSpline(spline) {
	  return function (colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i,
	        color;
	    for (i = 0; i < n; ++i) {
	      color = (0, _d3Color.rgb)(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function (t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = exports.rgbBasis = rgbSpline(_basis2.default);
	var rgbBasisClosed = exports.rgbBasisClosed = rgbSpline(_basisClosed2.default);

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0,
	      // scan index for next number in b
	  am,
	      // current match in a
	  bm,
	      // current match in b
	  bs,
	      // string preceding current number in b, if any
	  i = -1,
	      // index in s
	  s = [],
	      // string constants and placeholders
	  q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) {
	      // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) {
	      // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else {
	      // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({ i: i, x: (0, _number2.default)(am, bm) });
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
	    for (var i = 0, o; i < b; ++i) {
	      s[(o = q[i]).i] = o.x(t);
	    }return s.join("");
	  });
	};
	
	var _number = __webpack_require__(65);
	
	var _number2 = _interopRequireDefault(_number);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function () {
	    return b;
	  };
	}
	
	function one(b) {
	  return function (t) {
	    return b(t) + "";
	  };
	}

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultSource = __webpack_require__(37);
	
	var _defaultSource2 = _interopRequireDefault(_defaultSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function sourceRandomIrwinHall(source) {
	  function randomIrwinHall(n) {
	    return function () {
	      for (var sum = 0, i = 0; i < n; ++i) {
	        sum += source();
	      }return sum;
	    };
	  }
	
	  randomIrwinHall.source = sourceRandomIrwinHall;
	
	  return randomIrwinHall;
	}(_defaultSource2.default);

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultSource = __webpack_require__(37);
	
	var _defaultSource2 = _interopRequireDefault(_defaultSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function sourceRandomNormal(source) {
	  function randomNormal(mu, sigma) {
	    var x, r;
	    mu = mu == null ? 0 : +mu;
	    sigma = sigma == null ? 1 : +sigma;
	    return function () {
	      var y;
	
	      // If available, use the second previously-generated uniform random.
	      if (x != null) y = x, x = null;
	
	      // Otherwise, generate a new x and y.
	      else do {
	          x = source() * 2 - 1;
	          y = source() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	
	      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
	    };
	  }
	
	  randomNormal.source = sourceRandomNormal;
	
	  return randomNormal;
	}(_defaultSource2.default);

/***/ },
/* 184 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};

/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x) {
	  return +x;
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.implicit = undefined;
	exports.default = ordinal;
	
	var _d3Collection = __webpack_require__(59);
	
	var _array = __webpack_require__(29);
	
	var implicit = exports.implicit = { name: "implicit" };
	
	function ordinal(range) {
	  var index = (0, _d3Collection.map)(),
	      domain = [],
	      unknown = implicit;
	
	  range = range == null ? [] : _array.slice.call(range);
	
	  function scale(d) {
	    var key = d + "",
	        i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function (_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = (0, _d3Collection.map)();
	    var i = -1,
	        n = _.length,
	        d,
	        key;
	    while (++i < n) {
	      if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    }return scale;
	  };
	
	  scale.range = function (_) {
	    return arguments.length ? (range = _array.slice.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function (_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function () {
	    return ordinal().domain(domain).range(range).unknown(unknown);
	  };
	
	  return scale;
	}

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calendar = calendar;
	
	exports.default = function () {
	  return calendar(_d3Time.timeYear, _d3Time.timeMonth, _d3Time.timeWeek, _d3Time.timeDay, _d3Time.timeHour, _d3Time.timeMinute, _d3Time.timeSecond, _d3Time.timeMillisecond, _d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var _d3Array = __webpack_require__(9);
	
	var _d3Interpolate = __webpack_require__(14);
	
	var _d3Time = __webpack_require__(73);
	
	var _d3TimeFormat = __webpack_require__(118);
	
	var _array = __webpack_require__(29);
	
	var _continuous = __webpack_require__(66);
	
	var _continuous2 = _interopRequireDefault(_continuous);
	
	var _nice = __webpack_require__(184);
	
	var _nice2 = _interopRequireDefault(_nice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var durationSecond = 1000,
	    durationMinute = durationSecond * 60,
	    durationHour = durationMinute * 60,
	    durationDay = durationHour * 24,
	    durationWeek = durationDay * 7,
	    durationMonth = durationDay * 30,
	    durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	  var scale = (0, _continuous2.default)(_continuous.deinterpolateLinear, _d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [[second, 1, durationSecond], [second, 5, 5 * durationSecond], [second, 15, 15 * durationSecond], [second, 30, 30 * durationSecond], [minute, 1, durationMinute], [minute, 5, 5 * durationMinute], [minute, 15, 15 * durationMinute], [minute, 30, 30 * durationMinute], [hour, 1, durationHour], [hour, 3, 3 * durationHour], [hour, 6, 6 * durationHour], [hour, 12, 12 * durationHour], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = (0, _d3Array.bisector)(function (i) {
	        return i[2];
	      }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = (0, _d3Array.tickStep)(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max((0, _d3Array.tickStep)(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function (y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function (_) {
	    return arguments.length ? domain(_array.map.call(_, number)) : domain().map(date);
	  };
	
	  scale.ticks = function (interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function (count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function (interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, _nice2.default)(d, interval)) : scale;
	  };
	
	  scale.copy = function () {
	    return (0, _continuous.copy)(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	  };
	
	  return scale;
	}

/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var matcher = function matcher(selector) {
	  return function () {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector || element.msMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector;
	    matcher = function matcher(selector) {
	      return function () {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	exports.default = matcher;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (selector) {
	    return typeof selector === "string" ? new _index.Selection([[document.querySelector(selector)]], [document.documentElement]) : new _index.Selection([[selector]], _index.root);
	};
	
	var _index = __webpack_require__(16);

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return new _index.Selection(this._enter || this._groups.map(_sparse2.default), this._parents);
	};
	
	exports.EnterNode = EnterNode;
	
	var _sparse = __webpack_require__(191);
	
	var _sparse2 = _interopRequireDefault(_sparse);
	
	var _index = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function appendChild(child) {
	    return this._parent.insertBefore(child, this._next);
	  },
	  insertBefore: function insertBefore(child, next) {
	    return this._parent.insertBefore(child, next);
	  },
	  querySelector: function querySelector(selector) {
	    return this._parent.querySelector(selector);
	  },
	  querySelectorAll: function querySelectorAll(selector) {
	    return this._parent.querySelectorAll(selector);
	  }
	};

/***/ },
/* 191 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (update) {
	  return new Array(update.length);
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value, priority) {
	  return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
	};
	
	exports.styleValue = styleValue;
	
	var _window = __webpack_require__(113);
	
	var _window2 = _interopRequireDefault(_window);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function styleRemove(name) {
	  return function () {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function () {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function () {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);else this.style.setProperty(name, v, priority);
	  };
	}
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name) || (0, _window2.default)(node).getComputedStyle(node, null).getPropertyValue(name);
	}

/***/ },
/* 193 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (selector) {
	  return selector == null ? empty : function () {
	    return this.querySelectorAll(selector);
	  };
	};
	
	function empty() {
	  return [];
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var x0 = _point.x,
	      x1 = null,
	      y0 = (0, _constant2.default)(0),
	      y1 = _point.y,
	      defined = (0, _constant2.default)(true),
	      context = null,
	      curve = _linear2.default,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = (0, _d3Path.path)());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return (0, _line2.default)().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function (_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant2.default)(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function (_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant2.default)(+_), area) : x0;
	  };
	
	  area.x1 = function (_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant2.default)(+_), area) : x1;
	  };
	
	  area.y = function (_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant2.default)(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function (_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant2.default)(+_), area) : y0;
	  };
	
	  area.y1 = function (_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant2.default)(+_), area) : y1;
	  };
	
	  area.lineX0 = area.lineY0 = function () {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function () {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function () {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function (_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant2.default)(!!_), area) : defined;
	  };
	
	  area.curve = function (_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function (_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var _d3Path = __webpack_require__(28);
	
	var _constant = __webpack_require__(30);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _linear = __webpack_require__(71);
	
	var _linear2 = _interopRequireDefault(_linear);
	
	var _line = __webpack_require__(115);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _point = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 195 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var slice = exports.slice = Array.prototype.slice;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardinalClosed = CardinalClosed;
	
	var _noop = __webpack_require__(72);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _cardinal = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: _noop2.default,
	  areaEnd: _noop2.default,
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    switch (this._point) {
	      case 1:
	        {
	          this._context.moveTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	      case 2:
	        {
	          this._context.lineTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	      case 3:
	        {
	          this.point(this._x3, this._y3);
	          this.point(this._x4, this._y4);
	          this.point(this._x5, this._y5);
	          break;
	        }
	    }
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._x3 = x, this._y3 = y;break;
	      case 1:
	        this._point = 2;this._context.moveTo(this._x4 = x, this._y4 = y);break;
	      case 2:
	        this._point = 3;this._x5 = x, this._y5 = y;break;
	      default:
	        (0, _cardinal.point)(this, x, y);break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	exports.default = function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function (tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}(0);

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardinalOpen = CardinalOpen;
	
	var _cardinal = __webpack_require__(70);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;break;
	      case 1:
	        this._point = 2;break;
	      case 2:
	        this._point = 3;this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);break;
	      case 3:
	        this._point = 4; // proceed
	      default:
	        (0, _cardinal.point)(this, x, y);break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	exports.default = function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function (tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}(0);

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.curveRadialLinear = undefined;
	exports.default = curveRadial;
	
	var _linear = __webpack_require__(71);
	
	var _linear2 = _interopRequireDefault(_linear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var curveRadialLinear = exports.curveRadialLinear = curveRadial(_linear2.default);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function areaStart() {
	    this._curve.areaStart();
	  },
	  areaEnd: function areaEnd() {
	    this._curve.areaEnd();
	  },
	  lineStart: function lineStart() {
	    this._curve.lineStart();
	  },
	  lineEnd: function lineEnd() {
	    this._curve.lineEnd();
	  },
	  point: function point(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lineRadial = lineRadial;
	
	exports.default = function () {
	  return lineRadial((0, _line2.default)().curve(_radial.curveRadialLinear));
	};
	
	var _radial = __webpack_require__(198);
	
	var _radial2 = _interopRequireDefault(_radial);
	
	var _line = __webpack_require__(115);
	
	var _line2 = _interopRequireDefault(_line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function (_) {
	    return arguments.length ? c((0, _radial2.default)(_)) : c()._curve;
	  };
	
	  return l;
	}

/***/ },
/* 200 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _math = __webpack_require__(47);
	
	exports.default = {
	  draw: function draw(context, size) {
	    var r = Math.sqrt(size / _math.pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, _math.tau);
	  }
	};

/***/ },
/* 202 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  draw: function draw(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};

/***/ },
/* 203 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	exports.default = {
	  draw: function draw(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};

/***/ },
/* 204 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  draw: function draw(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _math = __webpack_require__(47);
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(_math.pi / 10) / Math.sin(7 * _math.pi / 10),
	    kx = Math.sin(_math.tau / 10) * kr,
	    ky = -Math.cos(_math.tau / 10) * kr;
	
	exports.default = {
	    draw: function draw(context, size) {
	        var r = Math.sqrt(size * ka),
	            x = kx * r,
	            y = ky * r;
	        context.moveTo(0, -r);
	        context.lineTo(x, y);
	        for (var i = 1; i < 5; ++i) {
	            var a = _math.tau * i / 5,
	                c = Math.cos(a),
	                s = Math.sin(a);
	            context.lineTo(s * r, -c * r);
	            context.lineTo(c * x - s * y, s * x + c * y);
	        }
	        context.closePath();
	    }
	};

/***/ },
/* 206 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var sqrt3 = Math.sqrt(3);
	
	exports.default = {
	  draw: function draw(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};

/***/ },
/* 207 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	exports.default = {
	    draw: function draw(context, size) {
	        var r = Math.sqrt(size / a),
	            x0 = r / 2,
	            y0 = r * k,
	            x1 = x0,
	            y1 = r * k + r,
	            x2 = -x1,
	            y2 = y1;
	        context.moveTo(x0, y0);
	        context.lineTo(x1, y1);
	        context.lineTo(x2, y2);
	        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	        context.closePath();
	    }
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isoSpecifier = undefined;
	
	var _defaultLocale = __webpack_require__(119);
	
	var isoSpecifier = exports.isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	    return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocale.utcFormat)(isoSpecifier);
	
	exports.default = formatIso;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatLocale;
	
	var _d3Time = __webpack_require__(73);
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return { y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0 };
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function (date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function (string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week,
	          day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? _d3Time.utcMonday.ceil(week) : (0, _d3Time.utcMonday)(week);
	          week = _d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? _d3Time.timeMonday.ceil(week) : (0, _d3Time.timeMonday)(week);
	          week = _d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || (j = parse(d, string, j)) < 0) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function format(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function () {
	        return specifier;
	      };
	      return f;
	    },
	    parse: function parse(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function () {
	        return specifier;
	      };
	      return p;
	    },
	    utcFormat: function utcFormat(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function () {
	        return specifier;
	      };
	      return f;
	    },
	    utcParse: function utcParse(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function () {
	        return specifier;
	      };
	      return p;
	    }
	  };
	}
	
	var pads = { "-": "", "_": " ", "0": "0" },
	    numberRe = /^\s*\d+/,
	    // note: ignores next directive
	percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {},
	      i = -1,
	      n = names.length;
	  while (++i < n) {
	    map[names[i].toLowerCase()] = i;
	  }return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0] * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + _d3Time.timeDay.count((0, _d3Time.timeYear)(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(_d3Time.timeSunday.count((0, _d3Time.timeYear)(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : _d3Time.timeThursday.ceil(d);
	  return pad(_d3Time.timeThursday.count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(_d3Time.timeMonday.count((0, _d3Time.timeYear)(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + _d3Time.utcDay.count((0, _d3Time.utcYear)(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(_d3Time.utcSunday.count((0, _d3Time.utcYear)(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : _d3Time.utcThursday.ceil(d);
	  return pad(_d3Time.utcThursday.count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(_d3Time.utcMonday.count((0, _d3Time.utcYear)(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, name) {
	  var schedules = node.__transition,
	      schedule,
	      active,
	      empty = true,
	      i;
	
	  if (!schedules) return;
	
	  name = name == null ? null : name + "";
	
	  for (i in schedules) {
	    if ((schedule = schedules[i]).name !== name) {
	      empty = false;continue;
	    }
	    active = schedule.state > _schedule.STARTING && schedule.state < _schedule.ENDING;
	    schedule.state = _schedule.ENDED;
	    schedule.timer.stop();
	    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
	    delete schedules[i];
	  }
	
	  if (empty) delete node.__transition;
	};
	
	var _schedule = __webpack_require__(17);

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (a, b) {
	    var c;
	    return (typeof b === "number" ? _d3Interpolate.interpolateNumber : b instanceof _d3Color.color ? _d3Interpolate.interpolateRgb : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : _d3Interpolate.interpolateString)(a, b);
	};
	
	var _d3Color = __webpack_require__(18);
	
	var _d3Interpolate = __webpack_require__(14);

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createCell = createCell;
	exports.cellHalfedgeStart = cellHalfedgeStart;
	exports.cellHalfedgeEnd = cellHalfedgeEnd;
	exports.sortCellHalfedges = sortCellHalfedges;
	exports.clipCells = clipCells;
	
	var _Edge = __webpack_require__(122);
	
	var _Diagram = __webpack_require__(50);
	
	function createCell(site) {
	  return _Diagram.cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = _Diagram.cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = _Diagram.cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) {
	        index[j] = j, array[j] = cellHalfedgeAngle(cell, _Diagram.edges[halfedges[j]]);
	      }index.sort(function (i, j) {
	        return array[j] - array[i];
	      });
	      for (j = 0; j < m; ++j) {
	        array[j] = halfedges[index[j]];
	      }for (j = 0; j < m; ++j) {
	        halfedges[j] = array[j];
	      }
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = _Diagram.cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = _Diagram.cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!_Diagram.edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, _Diagram.edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, _Diagram.edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > _Diagram.epsilon || Math.abs(endY - startY) > _Diagram.epsilon) {
	          halfedges.splice(iHalfedge, 0, _Diagram.edges.push((0, _Edge.createBorderEdge)(site, end, Math.abs(endX - x0) < _Diagram.epsilon && y1 - endY > _Diagram.epsilon ? [x0, Math.abs(startX - x0) < _Diagram.epsilon ? startY : y1] : Math.abs(endY - y1) < _Diagram.epsilon && x1 - endX > _Diagram.epsilon ? [Math.abs(startY - y1) < _Diagram.epsilon ? startX : x1, y1] : Math.abs(endX - x1) < _Diagram.epsilon && endY - y0 > _Diagram.epsilon ? [x1, Math.abs(startX - x1) < _Diagram.epsilon ? startY : y0] : Math.abs(endY - y0) < _Diagram.epsilon && endX - x0 > _Diagram.epsilon ? [Math.abs(startY - y0) < _Diagram.epsilon ? startX : x0, y0] : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx,
	        dy,
	        d2,
	        dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = _Diagram.cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0],
	          v01 = [x0, y1],
	          v11 = [x1, y1],
	          v10 = [x1, y0];
	      cover.halfedges.push(_Diagram.edges.push((0, _Edge.createBorderEdge)(site = cover.site, v00, v01)) - 1, _Diagram.edges.push((0, _Edge.createBorderEdge)(site, v01, v11)) - 1, _Diagram.edges.push((0, _Edge.createBorderEdge)(site, v11, v10)) - 1, _Diagram.edges.push((0, _Edge.createBorderEdge)(site, v10, v00)) - 1);
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = _Diagram.cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete _Diagram.cells[iCell];
	      }
	    }
	  }
	}

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.firstCircle = undefined;
	exports.attachCircle = attachCircle;
	exports.detachCircle = detachCircle;
	
	var _RedBlackTree = __webpack_require__(123);
	
	var _Diagram = __webpack_require__(50);
	
	var circlePool = [];
	
	var firstCircle = exports.firstCircle = undefined;
	
	function Circle() {
	  (0, _RedBlackTree.RedBlackNode)(this);
	  this.x = this.y = this.arc = this.site = this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -_Diagram.epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle();
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = _Diagram.circles._;
	
	  while (node) {
	    if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	      if (node.L) node = node.L;else {
	        before = node.P;break;
	      }
	    } else {
	      if (node.R) node = node.R;else {
	        before = node;break;
	      }
	    }
	  }
	
	  _Diagram.circles.insert(before, circle);
	  if (!before) exports.firstCircle = firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) exports.firstCircle = firstCircle = circle.N;
	    _Diagram.circles.remove(circle);
	    circlePool.push(circle);
	    (0, _RedBlackTree.RedBlackNode)(circle);
	    arc.circle = null;
	  }
	}

/***/ },
/* 214 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Transform = Transform;
	exports.default = transform;
	function Transform(k, x, y) {
	  this.k = k;
	  this.x = x;
	  this.y = y;
	}
	
	Transform.prototype = {
	  constructor: Transform,
	  scale: function scale(k) {
	    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
	  },
	  translate: function translate(x, y) {
	    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
	  },
	  apply: function apply(point) {
	    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
	  },
	  applyX: function applyX(x) {
	    return x * this.k + this.x;
	  },
	  applyY: function applyY(y) {
	    return y * this.k + this.y;
	  },
	  invert: function invert(location) {
	    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
	  },
	  invertX: function invertX(x) {
	    return (x - this.x) / this.k;
	  },
	  invertY: function invertY(y) {
	    return (y - this.y) / this.k;
	  },
	  rescaleX: function rescaleX(x) {
	    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
	  },
	  rescaleY: function rescaleY(y) {
	    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
	  },
	  toString: function toString() {
	    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	  }
	};
	
	var identity = exports.identity = new Transform(1, 0, 0);
	
	transform.prototype = Transform.prototype;
	
	function transform(node) {
	  return node.__zoom || identity;
	}

/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i = 0,
	        length = collection.length,
	        cont;
	
	    for (i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if (cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction: isFunction,
	    isArray: isArray,
	    each: each
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // SinaPlot.js
	
	var _d2 = __webpack_require__(51);
	
	var d3 = _interopRequireWildcard(_d2);
	
	var _lodash = __webpack_require__(26);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Labeler = __webpack_require__(584);
	
	var _Labeler2 = _interopRequireDefault(_Labeler);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Color scheme for the Sina Plot
	var colors = {
	  blue: "#097dc2",
	  darkblue: "00659d",
	  orange: "#ff5000",
	  white: 'white'
	
	  // functions for a random number with a seed
	};var randomsfc32 = function randomsfc32(a, b, c, d) {
	  return function () {
	    a >>>= 0;b >>>= 0;c >>>= 0;d >>>= 0;
	    var t = a + b | 0;
	    a = b ^ b >>> 9;
	    b = c + (c << 3) | 0;
	    c = c << 21 | c >>> 11;
	    d = d + 1 | 0;
	    t = t + d | 0;
	    c = c + t | 0;
	    return (t >>> 0) / 4294967296;
	  };
	};
	
	// Helper for building translation strings for use in SVG transform attributes
	var translate = function translate(x, y) {
	  return "translate(" + x + "," + y + ")";
	};
	var jitter = function jitter(width) {
	  return Math.floor(Math.random() * width) - width / 2;
	};
	
	// Standard deviation of an array
	var sd = function sd(xs) {
	  var mean = _lodash2.default.mean(xs);
	
	  var diff = 0;
	  for (var i = 0; i < xs.length; i++) {
	    diff += Math.pow(xs[i] - mean, 2);
	  }
	
	  return Math.sqrt(diff / (xs.length - 1));
	};
	
	var makeLinearInterpolator = function makeLinearInterpolator(domain, range) {
	  var values = _lodash2.default.sortBy(_lodash2.default.zip(domain, range), function (x) {
	    return x[0];
	  });
	  return function (x) {
	    if (x <= domain[0]) return range[0];
	    if (x >= domain[domain.length - 1]) return range[range.length - 1];
	
	    for (var i = 0; i < values.length - 1; i++) {
	      if (x >= values[i][0] && x <= values[i + 1][0]) {
	        return values[i][1] + (x - values[i][0]) * (values[i + 1][1] - values[i][1]) / (values[i + 1][0] - values[i][0]);
	      }
	    }
	  };
	};
	
	var roundToLog10 = function roundToLog10(x) {
	  return Math.pow(10, Math.floor(Math.log10(x)));
	};
	
	var integer = function integer(x) {
	  return Math.floor(x) === x;
	};
	
	var snapExtentToLog10 = function snapExtentToLog10(extent) {
	  var lower = roundToLog10(extent[0]);
	  var upper = integer(Math.log10(extent[1])) ? extent[1] : 10 * roundToLog10(extent[1]);
	  return [lower, upper];
	};
	
	function kernelDensityEstimator(kernel, x) {
	  return function (sample) {
	    return x.map(function (x) {
	      var k = sample;
	      for (var i = 0; i < k.length; i++) {
	        k[i] = kernel(x - sample[i]);
	      }return { x: x, y: _lodash2.default.mean(k) };
	    });
	  };
	}
	
	function kernelDensityEstimatorGaussian(scale, x) {
	  var c = 1 / Math.sqrt(2 * Math.PI);
	  return function (sample) {
	    var ret = [];
	    for (var i = 0; i < x.length; i++) {
	      var sum = 0;
	      for (var j = 0; j < sample.length; j++) {
	        var u = (x[i] - sample[j]) / scale;
	        sum += c * Math.exp(-0.5 * u * u);
	      }
	      ret.push({ x: x[i], y: sum / (sample.length * scale) });
	    }
	
	    return ret;
	  };
	}
	
	function gaussianKernel(scale) {
	  var c = 1 / Math.sqrt(2 * Math.PI);
	  return function (u) {
	    u /= scale;
	    return c * Math.exp(-0.5 * u * u);
	  };
	}
	
	/*
	 * SinaPlot
	 *
	 * The core idea of a SinaPlot as a data visualization is that it is a dot plot paired with a violin plot.
	 *
	 * In other words, each participant's measurement is plotted on to the chart as a dot with its y
	 * position determined by the measurement level (like a dot plot), but its x position is allowed
	 * to vary in relationship to the density of points near it.
	 *
	 * The effect is that the viewer can see where the highest density of measurements is
	 * by looking at the width of the point cloud.
	 *
	 * Mechanically, you need to choose a kernel density estimator and set its parameters.
	 * This implementation currently uses a gaussian density estimator.
	 *
	 * The density is sampled at a number of points, with any holes filled in by linear interpolation.
	 *
	 *
	 * This implementation renders the visualization to both a canvas and SVG. The canvas is used
	 * to plot the measurements of the other participants (1,000+ points, which would bog down the browser
	 * if done in SVG). All other elements (graph labels, axes, current participant measurements) are
	 * rendered with SVG.
	 *
	 */
	
	var SinaPlot = function () {
	  function SinaPlot(container, avatar) {
	    var _this = this;
	
	    _classCallCheck(this, SinaPlot);
	
	    this.container = container;
	
	    // Plot margins
	    this.margin = { top: 0, right: 10, bottom: 0, left: 10 };
	
	    // Width and height of the participant's measurement
	    this.faceSize = 40;
	
	    this.avatar = avatar;
	
	    // Plot dimensions
	    this.width = document.documentElement.clientWidth;
	    this.width = Math.min(this.width, 650);
	    this.height = 500 - this.margin.top - this.margin.bottom;
	    this.nonDetectWidth = 80;
	    this.nonDetectChartArea = this.nonDetectWidth - 10;
	    this.detectWidth = this.width - this.margin.right - this.margin.left - this.nonDetectWidth;
	    this.nonDetectCenter = 48;
	    this.labelOffset = 35;
	    this.axisHeight = 20;
	    this.graphMidline = 50;
	    this.participantFaceRadius = 10;
	    this.participantSmallCircleRadius = 8;
	    this.benchmarkLineThickness = 4;
	
	    // Resolution of the kernel density estimate
	    // in other words, the kernel density will be estimated
	    // at this many points.
	    this.resolution = 512;
	
	    this.kdeArea = d3.area().x0(0).x1(function (d) {
	      return d.x;
	    }).y(function (d) {
	      return _this.y(d.y);
	    }).curve(d3.curveCatmullRom.alpha(0.5));
	
	    this.expanded = false;
	  }
	
	  _createClass(SinaPlot, [{
	    key: 'clear',
	    value: function clear() {
	      d3.select(this.container).text('');
	    }
	
	    /*
	     * Initializes the container for the graph. Sets up scales and axes.
	     */
	
	  }, {
	    key: 'setup',
	    value: function setup() {
	      this.graphContainer = d3.select(this.container).append('div').attr('class', 'graph-container');
	
	      // let width = this.width - this.margin.left - this.margin.right;
	      var height = void 0;
	      if (this.expanded) {
	        height = 280 - this.margin.top - this.margin.bottom;
	        this.axisHeight = 45;
	        this.graphMidline = 170;
	        this.labelOffset = 110;
	      } else {
	        height = 100 - this.margin.top - this.margin.bottom;
	        this.axisHeight = 20;
	        this.graphMidline = 50;
	        this.labelOffset = 35;
	      }
	      this.height = height;
	      var width = this.width;
	
	      this.canvas = this.graphContainer.append('canvas').attr('width', width) /* this.width + this.margin.left + this.margin.right) */
	      .attr('height', height);
	
	      this.chart = this.graphContainer.append('svg').attr('width', width) /* this.width + this.margin.left + this.margin.right) */
	      .attr('height', height).append('g');
	      // .attr('transform', translate(this.margin.left, this.margin.top));
	
	      this.x = d3.scaleOrdinal().range([0, height - this.axisHeight]);
	      this.y = d3.scaleLog().range([this.nonDetectWidth + this.margin.left, width - this.margin.right]);
	
	      this.xAxis = d3.axisLeft().scale(this.x);
	
	      this.yAxis = d3.axisBottom().scale(this.y).tickFormat(d3.format(',.1r'));
	
	      // Containers for holding the x and y axes and axis labels
	      this.chart.append('g')
	      // .attr('transform', translate(30, 0))
	      .attr('class', 'y axis');
	
	      this.chart.append('g').attr('class', 'x axis');
	    } // end setup()
	
	    /*
	     * Plots measurement data and benchmark levels.
	     *
	     * TODO: Refactor into multiple smaller methods.
	     */
	
	  }, {
	    key: 'updateData',
	    value: function updateData(data, benchmarks, participantId) {
	      var _this2 = this;
	
	      var that = this;
	      this.data = data;
	
	      this.participantData = _lodash2.default.filter(data, { mine: true });
	
	      this.detectedData = _lodash2.default.filter(data, function (d) {
	        return d.detected === true && !d.mine;
	      });
	      this.nondetectData = _lodash2.default.filter(data, function (d) {
	        return d.detected === false && !d.mine;
	      });
	
	      var xUniqValues = (0, _lodash2.default)(data).map('chemical').uniq().value();
	
	      var barWidth = this.height / xUniqValues.length;
	      if (this.expanded) {
	        barWidth = barWidth * 0.7;
	      }
	      var kdeMaxWidth = barWidth;
	      // we want to make the graphs closer to a line when there are very few points
	      // so make the max width smaller based on the number of detects.
	      var scaleThreshold = 100;
	      var kdeMinWidth = 4;
	      var numDetects = this.detectedData.length;
	      if (numDetects < scaleThreshold) {
	        var slope = (kdeMaxWidth - kdeMinWidth) / scaleThreshold;
	        kdeMaxWidth = slope * numDetects + kdeMinWidth;
	        // kdeMaxWidth = (kdeMaxWidth-kdeMinWidth)/(1+Math.pow(Math.E, -(numDetects-scaleThreshold))) + kdeMinWidth
	      }
	
	      this.x.domain(xUniqValues);
	
	      if (xUniqValues.length === 1) {
	        this.x.range([this.height]);
	      } else {
	        this.x.range(_lodash2.default.range(0, this.height, barWidth));
	      }
	
	      this.y.domain(this.yLimits).nice();
	
	      var formattedLabels = [0.0001, 0.001, 0.01, 0.1, 1, 10, 100, 1000, 10000, 100000];
	      var numTicks = void 0;
	      if (this.expanded) {
	        var ticksInRange = formattedLabels.filter(function (d) {
	          return d >= _this2.y.domain()[0] && d <= _this2.y.domain()[1];
	        });
	        this.yAxis.tickValues(ticksInRange);
	        numTicks = ticksInRange.length;
	      } else {
	        numTicks = 2;
	        var minDomain = this.y.domain()[0];
	        var maxDomain = this.y.domain()[1];
	
	        var minLabel = void 0;
	        var maxLabel = void 0;
	        for (var i = 0; i < formattedLabels.length; i++) {
	          var label = formattedLabels[i];
	          if (label <= minDomain) {
	            minLabel = label;
	          }
	        }
	        for (var _i = formattedLabels.length - 1; _i >= 0; _i--) {
	          var _label = formattedLabels[_i];
	          if (_label >= maxDomain) {
	            maxLabel = _label;
	          }
	        }
	        this.yAxis.tickValues([minLabel, maxLabel]);
	      }
	
	      var formatComma = d3.format(",.1r");
	      this.yAxis.tickFormat(function (d, i) {
	        if (i == 0) {
	          return "" + formatComma(d) + that.units;
	        } else {
	          return formatComma(d);
	        }
	      });
	
	      if (this.expanded) {
	        this.chart.select('.y.axis').call(this.yAxis).attr('transform', 'translate(0,' + (this.height - this.axisHeight) + ')');
	      } else {
	        this.chart.select('.y.axis').call(this.yAxis.ticks(2)).attr('transform', 'translate(0,' + (this.height - this.axisHeight) + ')');
	      }
	
	      this.chart.select('.y.axis').selectAll("text").attr('font-size', 12).attr("text-anchor", function (d, i) {
	        if (i == 0) {
	          return 'start';
	        } else if (i == numTicks - 1) {
	          return 'end';
	        } else {
	          return 'middle';
	        }
	      }).style("font-weight", function (d, i) {
	        if (i == 0 || i == numTicks - 1) {
	          return 'bold';
	        } else {
	          return null;
	        }
	      });
	
	      if (this.expanded) {
	        this.chart.select('.y.axis').selectAll("text").attr("transform", function (d, i) {
	          if (i == 0 || i == numTicks - 1) {
	            return 'translate(0,14)';
	          } else {
	            return null;
	          }
	        });
	
	        this.chart.select('.y.axis').selectAll("line").attr("y1", function (d, i) {
	          if (i == 0 || i == numTicks - 1) {
	            return 0;
	          } else {
	            return null;
	          }
	        }).attr("y2", function (d, i) {
	          if (i == 0 || i == numTicks - 1) {
	            return 18;
	          } else {
	            return 6;
	          }
	        });
	      }
	
	      this.displayNames = [];
	      data.forEach(function (d) {
	        return _this2.displayNames[d.chemical] = d.display_name;
	      });
	
	      //
	      // X Axis setup
	      //
	      this.xAxis.tickFormat(function (d) {
	        return _this2.displayNames[d] === undefined ? d : _this2.displayNames[d];
	      });
	
	      // Set up the title of the graph
	      // if(this.titleClickable == true) {
	      // xAxisSelection.select('text')
	      //   .style('fill', 'white')
	
	      // xAxisSelection.select('.tick')
	      //   .insert('rect', 'text')
	      //     .attr('x', function(d) {
	      //       return -1 * (this.parentNode.getBBox().width + 20) / 2.0;
	      //     })
	      //     .attr('y', function(d) {
	      //       return -1 * (this.parentNode.getBBox().height + 20) + 13;
	      //     })
	      //     .attr('width', function(d) {
	      //       return this.parentNode.getBBox().width + 20;
	      //     })
	      //     .attr('height', function(d) {
	      //       return this.parentNode.getBBox().height + 6;
	      //     })
	      //     .style('fill', colors.blue)
	      //     .style('stroke', colors.darkblue);
	
	      // this.chart.select('.x.axis')
	      //   .on('click', () => this.onChemicalClicked(xUniqValues[0]));
	      // }
	
	      // Remove x axis line
	      this.chart.selectAll('.x.axis .domain, .x.axis line').remove();
	
	      var kdeData = (0, _lodash2.default)(xUniqValues).mapKeys(function (value, key) {
	        return value;
	      }).mapValues(function (x, key) {
	        var values = (0, _lodash2.default)(that.detectedData).map('value').map(Math.log10).value();
	
	        //var bandwidth = 1.06 * sd(_.map(values, Math.log10)) * Math.pow(values.length, -1.0/5.0)
	        //
	        // In R this is bw.nrd function
	        var bandwidth = 0.9 * sd(values) * Math.pow(values.length, -0.2);
	        // if there is just one point, the standard deviation is NaN, so just set the bandwith to 1
	        if (values.length == 1) {
	          bandwidth = 1;
	        }
	
	        var minValue = d3.min(values);
	        var maxValue = d3.max(values);
	
	        var ticks = Array(that.resolution).fill().map(function (_, i) {
	          return minValue + i * (maxValue - minValue) / that.resolution;
	        });
	        var kde = kernelDensityEstimatorGaussian(bandwidth, ticks);
	
	        var kdeData = kde(values);
	        var kdeScale = d3.scaleLinear().domain(d3.extent(_lodash2.default.map(kdeData, 'y'))).range([0, kdeMaxWidth]);
	
	        var kdeWidths = _lodash2.default.map(kdeData, function (d) {
	          return { x: kdeScale(d.y), y: Math.pow(10, d.x) };
	        });
	
	        var linearInterpolator = makeLinearInterpolator(_lodash2.default.map(kdeWidths, 'y'), _lodash2.default.map(kdeWidths, 'x'));
	
	        var kdeWidth = function kdeWidth(y) {
	          return linearInterpolator(y);
	        };
	
	        return {
	          kdeData: kdeData,
	          kdeScale: kdeScale,
	          kdeWidths: kdeWidths,
	          kdeWidth: kdeWidth
	        };
	      }).value(); // end --> var kdeData =
	
	      //
	      // Draw other participants (the blue dots) onto a canvas.
	      // This uses canvas because it is much more performant than
	      // drawing 1,000+ circles as SVG elements.
	      //
	      if (this.canvas.node() === null) return;
	      var context = this.canvas.node().getContext('2d');
	
	      // for(let i = 0; i < 10; i++) {
	      // let widths = []
	
	      var randomSeeded = randomsfc32(2, 3, 4, 5);
	
	      for (var _i2 = 0; _i2 < this.detectedData.length; _i2++) {
	        var d = this.detectedData[_i2];
	
	        var x = this.graphMidline;
	
	        var y = Math.round(that.y(d.value));
	        var show = true;
	        if (that.sina) {
	          var kdeWidth = kdeData[d.chemical].kdeWidth(d.value) / 4;
	          x += Math.round((randomSeeded() * kdeWidth * 2 - kdeWidth) * that.jitterAmount);
	          // x += Math.round(jitter(kdeWidth * 2) * that.jitterAmount);
	
	          // Probabalistic sampling
	          // let chance = 3 / kdeWidth;
	          // let rand = Math.random()
	          // if (rand < chance) {
	          //   show = true;
	          // } else {
	          //   show = false;
	          // }
	
	          // only sample compressed graphs
	          // if (!this.expanded){
	          //   // sample all equally except outlyers
	          //   let threshold = 2;
	          //   let chance = 0.25;
	          //   let rand = Math.random()
	          //   if (kdeWidth < threshold || rand < chance) {
	          //     show = true;
	          //   } else {
	          //     show = false;
	          //   }
	          // }
	
	          // sample all equally
	          // let chance = 0.25;
	          // let rand = Math.random()
	          // if (rand < chance) {
	          //   show = true;
	          // } else {
	          //   show = false;
	          // }
	        } else if (that.jitter) {
	          x += Math.round(jitter(that.height / 3 * that.jitterAmount));
	        }
	
	        if (show) {
	          context.beginPath();
	          var radius = 4;
	          context.arc(y, x, radius, 0, 2 * Math.PI, false);
	          context.strokeStyle = "rgba(119, 158, 255,1)";
	          context.lineWidth = 1;
	          context.stroke();
	        }
	      }
	
	      //
	      // Add participant's detected data points
	      //
	      if (this.expanded) {
	        if (this.detectedData.length > 0) {
	          this.chart.selectAll('.otherParticipantsClickTarget').data([this.detectedData[0].chemical]).enter().append('rect').attr('class', 'otherParticipantsClickTarget').attr('transform', function (d) {
	            return translate(_this2.nonDetectWidth, _this2.graphMidline - _this2.labelOffset + 50);
	          }).attr('width', this.width - this.nonDetectWidth).attr('height', this.labelOffset * 2 - 100).style('fill', 'transparent').on('click', function (d) {
	            return _this2.onOtherParticipantsClicked ? _this2.onOtherParticipantsClicked(d) : null;
	          });
	
	          this.chart.selectAll('.axisClickTarget').data([this.detectedData[0].chemical]).enter().append('rect').attr('class', 'axisClickTarget').attr('transform', function (d) {
	            return translate(-25, 0);
	          }).attr('width', 55).attr('height', this.height).style('fill', 'transparent');
	        }
	      }
	
	      if (this.expanded) {
	        if (this.nondetectData.length > 0) {
	          this.chart.selectAll('.nondetectClickTarget').data([this.nondetectData[0].chemical]).enter().append('rect').attr('class', 'nondetectClickTarget').attr('transform', function (d) {
	            return translate(_this2.margin.left, _this2.graphMidline - _this2.labelOffset - 50);
	          }).attr('width', this.nonDetectWidth).attr('height', this.labelOffset * 2).style('fill', 'transparent').on('click', function (d) {
	            return _this2.onNonDetectClicked ? _this2.onNonDetectClicked(d) : null;
	          });
	        }
	      }
	
	      //
	      // Non-detects
	      //
	
	      // let kdeWidthND = this.nondetectData.length/10; // NEW WAY: make the ND width consistent across chemicals since based on actual NDs
	
	      // the non-detects should fill a circle proportionally to the amount of nondetects,
	      // with a jitter
	      // scale proportionately to area, not radius
	      // let dataLength = this.detectedData.length + this.nondetectData.length;
	      // let dotRadius = 4;
	      // let minNonDetectArea = Math.PI * Math.pow(dotRadius + 2, 2) // pi*r^2
	      // let maxNonDetectArea = Math.PI * Math.pow(this.nonDetectWidth, 2)
	      // let nonDetectArea = this.map(this.nondetectData.length, 0, dataLength, minNonDetectArea, maxNonDetectArea)
	      // let nonDetectRadius = Math.sqrt(nonDetectArea/Math.PI) // r = sqrt(A/pi)
	
	      // the non-detects should fill a rectagle proportionally to the amount of nondetects,
	      // with a jitter
	      // scale proportionately to area, not radius
	      var dataLength = this.detectedData.length + this.nondetectData.length;
	      var proportionNonDetect = this.nondetectData.length / dataLength;
	      var sideLengthScale = Math.sqrt(proportionNonDetect);
	
	      var dotRadius = 4;
	      // let minNonDetectArea = Math.PI * Math.pow(dotRadius + 2, 2) // pi*r^2
	      // let maxNonDetectArea = Math.PI * Math.pow(this.nonDetectWidth, 2)
	      // let nonDetectArea = this.map(this.nondetectData.length, 0, dataLength, minNonDetectArea, maxNonDetectArea)
	      // let nonDetectRadius = Math.sqrt(nonDetectArea/Math.PI) // r = sqrt(A/pi)
	
	
	      var numNonDetects = this.nondetectData.length;
	
	      // scale width so it doesn't look weird with just a few dots;
	      var width = this.nonDetectChartArea * sideLengthScale;
	      if (numNonDetects < 10) {
	        width = dotRadius + dotRadius * 0.5 * numNonDetects;
	      }
	
	      var maxNonDetectHeight = (that.height - 2 * that.axisHeight - that.margin.top - that.margin.bottom) / 2;
	      if (that.expanded) {
	        maxNonDetectHeight -= 45;
	      } else {
	        maxNonDetectHeight -= 10;
	      }
	      var heightND = maxNonDetectHeight * sideLengthScale;
	      if (heightND > maxNonDetectHeight) {
	        heightND = maxNonDetectHeight;
	      }
	
	      var randomSeededNonDetect = randomsfc32(2, 3, 4, 5);
	
	      this.nondetectData.forEach(function (d) {
	        // let kdeWidth;
	        // if (helpers.findGetParameter('old'))
	        //   kdeWidth = kdeData[d.chemical].kdeWidth(d.value) || 60; // OLD WAY: not right... based on *detected* data and a ND value
	        // else
	        //   kdeWidth = kdeWidthND;
	
	
	        var randomXJitter = randomSeededNonDetect();
	
	        // keep a random sample away from the edges
	        var thousandsPlace = Math.ceil(randomXJitter * 100) * 10 - Math.floor(randomXJitter * 1000);
	        var randomSample1 = thousandsPlace < 3;
	        var randomSample2 = thousandsPlace < 5;
	        var customScale = 1;
	        var customScaleOffset = 0;
	        if (!randomSample1) {
	          customScale = 0.8;customScaleOffset = 0.1;
	        }
	        if (randomSample2) {
	          customScale = 0.9;customScaleOffset = 0.05;
	        }
	
	        var x = that.nonDetectWidth - randomXJitter * width * customScale - width * customScaleOffset;
	
	        // x = randomSeededNonDetect() *width
	        // x = that.nonDetectWidth - width
	
	        // Scale the y-coordinate slightly to make rounded corners
	        // let radius = 0.1; // in percents
	        // let radialScale = 1;
	        // let randomSample = Math.ceil(randomXJitter*100)*10 - Math.floor(randomXJitter*1000) == 2
	        // if (randomXJitter < radius && randomSample) {
	        //   let triangleX = radius - randomXJitter;
	        //   let triangleY = Math.sqrt(Math.pow(radius, 2) - Math.pow(triangleX, 2))
	        //   let yScalePercent = (1-2*radius) + (2*triangleY)
	        //   radialScale = yScalePercent
	        // }
	        // if (randomXJitter > (1-radius) && randomSample) {
	        //   let triangleX = randomXJitter - (1-radius);
	        //   let triangleY = Math.sqrt(Math.pow(radius, 2) - Math.pow(triangleX, 2))
	        //   let yScalePercent = (1-2*radius) + (2*triangleY)
	        //   radialScale = yScalePercent
	        // }
	
	
	        var y = that.graphMidline + jitter(heightND * 2) * that.jitterAmount * customScale;
	
	        context.beginPath();
	        context.arc(x, y, 4, 0, 2 * Math.PI, false);
	        context.strokeStyle = "#ccc";
	        context.lineWidth = 1;
	        context.stroke();
	      });
	
	      var nonDetectFontsize = 12;
	      var nondetectLabel = this.chart.selectAll('.nondetect-label').data([1]).enter().append('g').attr('transform', function () {
	        return translate(5, _this2.height - _this2.axisHeight + nonDetectFontsize / 2);
	      });
	
	      var _noDetectText$split = this.noDetectText.split(" "),
	          _noDetectText$split2 = _slicedToArray(_noDetectText$split, 2),
	          ndt1 = _noDetectText$split2[0],
	          ndt2 = _noDetectText$split2[1]; // no easy way to put it on 2 lines
	
	      nondetectLabel.append('text').attr('text-anchor', 'start').attr('class', 'nondetect-label').style('font-size', nonDetectFontsize + 'px').style('font-weight', 'bold').attr('y', 5).text(this.noDetectText);
	
	      // nondetectLabel
	      //   .append('text')
	      //     .attr('text-anchor', 'start')
	      //     .attr('class', 'nondetect-label')
	      //     .style('font-size', `${nonDetectFontsize}px`)
	      //     .text(ndt1);
	      //
	      // nondetectLabel
	      //   .append('text')
	      //   .attr('y', nonDetectFontsize)
	      //   .attr('text-anchor', 'start')
	      //   .attr('class', 'nondetect-label')
	      //   .style('font-size', `${nonDetectFontsize}px`)
	      //   .text(ndt2);
	
	      //
	      // Non detect bubble
	      //
	      if (this.expanded) {
	        var _numNonDetects = this.nondetectData.length;
	        var _numDetects = this.detectedData.length;
	        var nonDetectPercent = _numNonDetects / (_numNonDetects + _numDetects) * 100;
	        var nonDetectText = void 0;
	        if (nonDetectPercent == 0) {
	          nonDetectText = "0%";
	        } else if (nonDetectPercent < 1) {
	          nonDetectText = "<1%";
	        } else if (nonDetectPercent > 99 && nonDetectPercent < 100) {
	          nonDetectText = "99%";
	        } else {
	          nonDetectText = Math.round(nonDetectPercent) + "%";
	        }
	
	        var nondetectBubble = this.chart.selectAll('.nondetect-bubble').data([0]).enter().append('g').attr('transform', function () {
	          return translate(_this2.nonDetectCenter - _this2.participantSmallCircleRadius / 2, _this2.graphMidline);
	        });
	
	        // nondetectBubble.append('line')
	        //   .attr("x1", 0)
	        //   .attr("y1", 0)
	        //   .attr("x2", 0)
	        //   .attr("y2", -this.labelOffset)
	        //  .style('stroke', '#aaa')
	        //  .style('stroke-width', '2')
	        //  .attr('transform', () => translate(0, 0));
	        var nonDetectBubbleY = -heightND - 2 * this.participantFaceRadius - 10;
	
	        nondetectBubble.append('circle').attr('r', 2 * this.participantFaceRadius).style('fill', 'white').style('stroke', '#aaa').style('stroke-width', '2').attr('transform', function () {
	          return translate(0, nonDetectBubbleY);
	        });
	
	        nondetectBubble.append('text').text(nonDetectText).style('fill', '#aaa').style('text-anchor', 'middle').style('dominant-baseline', 'central').style('font-weight', 'bold').attr('transform', function () {
	          return translate(0, nonDetectBubbleY);
	        });
	
	        // nondetectBubble.append('text')
	        //  .text(ndt1)
	        //  .style('fill', '#aaa')
	        //  .style('text-anchor', 'middle')
	        //  .style('dominant-baseline','central')
	        //  .style('font-weight', 'bold')
	        //  .style('font-size', 14)
	        //  .attr('transform', () => translate(0, nonDetectBubbleY-this.participantFaceRadius-35));
	
	        nondetectBubble.append('text').text(this.noDetectText).style('fill', '#aaa').style('text-anchor', 'middle').style('dominant-baseline', 'central').style('font-weight', 'bold').style('font-size', 14).attr('transform', function () {
	          return translate(3, nonDetectBubbleY - _this2.participantFaceRadius - 20);
	        });
	
	        nondetectBubble.on('click', function (d) {
	          return _this2.onNonDetectClicked ? _this2.onNonDetectClicked(d) : null;
	        });
	      }
	
	      //
	      // Find positions for participant and benchmark labels
	      //
	
	      var participantDetected = true;
	      for (var _i3 = 0; _i3 < this.participantData.length; _i3++) {
	        if (this.participantData[_i3].detected == false) {
	          participantDetected = false;
	          break;
	        }
	      }
	
	      var benchmarkDetected = true;
	      for (var _i4 = 0; _i4 < benchmarks.length; _i4++) {
	        if (benchmarks[_i4].detected == false) {
	          benchmarkDetected = false;
	          break;
	        }
	      }
	
	      var detectZeroPoint = this.margin.left + this.nonDetectWidth;
	      var labeler = new _Labeler2.default();
	      var labels = _lodash2.default.map(this.participantData, function (d) {
	        var x = 0; // doesnt matter, set later that.y(d.chemical);
	        var y = void 0;
	        if (!d.detected) {
	          y = 0;
	        } else {
	          y = that.y(d.value) - detectZeroPoint;
	
	          if (y <= 0) {
	            y = 1 - 1 / y;
	          }
	        }
	        // let y = d.detected ? that.y(d.value) : detectZeroPoint;
	        // y-=that.detectWidth
	        // if (y < 0) {y = 0}
	        return {
	          x: x,
	          y: y,
	          width: that.faceSize + 20,
	          height: that.faceSize + 20,
	          r: (that.faceSize + 10) / 2
	        };
	      });
	      // .concat(_.map(benchmarks, function(d) {
	      //   const x =  0;// doesnt matter, set later that.y(d.chemical);
	      //   const y = d.detected ? that.y(d.value) : that.nonDetectWidth/2 + that.margin.left;
	      //   return {
	      //     x: x,
	      //     y: y,
	      //     width: that.faceSize + 10,
	      //     height: that.faceSize + 10,
	      //     r: (that.faceSize + 10) / 2
	      //   }
	      // }));
	
	      var anchors = _lodash2.default.map(labels, _lodash2.default.clone);
	
	      labeler.label(labels).anchor(anchors)
	      // .width(this.width)
	      // .height(this.height + 75)
	      // .width(this.height)
	      .width(this.height).height(this.width - this.margin.right - this.margin.left - this.nonDetectWidth).start(1000);
	
	      //
	      // Benchmarks
	      //
	
	      var benchmark = this.chart.selectAll('.benchmark').data(benchmarks).enter().append('g').attr('transform', function (d) {
	        return translate(d.detected ? _this2.y(d.value) : that.nonDetectCenter - _this2.benchmarkLineThickness / 2, _this2.graphMidline);
	      });
	
	      var benchmarkHeight = this.labelOffset;
	      if (this.expanded) {
	        benchmarkHeight -= 50;
	      }
	
	      var benchmarkBottomYOffset = -5;
	      if (this.expanded) {
	        benchmarkBottomYOffset = 0;
	      }
	
	      if (benchmarkDetected && !(this.tutorialMode && this.tutorialSettings.noBenchmark)) {
	        benchmark.append('line').attr('x1', 0).attr('x2', 0).attr('y1', -benchmarkHeight + 2).attr('y2', benchmarkHeight + benchmarkBottomYOffset - 2).style('stroke', "rgb(13 94 143)").style('stroke-width', this.benchmarkLineThickness).style('stroke-linecap', 'round');
	      }
	
	      //
	      // Participant icon
	      //
	
	      var expandedOffset = 0;
	      var participant = this.chart.selectAll('.participant').data(this.participantData).enter().append('g').attr('class', 'participant').attr('transform', function (d) {
	        // const y = that.x(d.chemical);
	        var y = that.graphMidline;
	        var x = void 0;
	        if (d.detected) {
	          x = Math.round(that.y(d.value));
	          if (x < that.nonDetectWidth + that.margin.left + 15) {
	            expandedOffset = 15;
	          }
	        } else {
	          x = that.nonDetectCenter - that.participantSmallCircleRadius / 2;
	        }
	        return translate(x, y);
	      });
	
	      if (this.expanded && !(this.tutorialMode && this.tutorialSettings.noAvatar)) {
	
	        participant.append('line').attr('x1', 0).attr('x2', function (d, i) {
	          var x = void 0;
	          if (d.detected) {
	            x = labeler.lab[i].y + detectZeroPoint - that.y(d.value);
	            if (that.expanded) {
	              x = x + expandedOffset;
	            }
	          } else {
	            x = labeler.lab[i].y + that.participantFaceRadius + that.nonDetectWidth / 2 + that.participantSmallCircleRadius / 2 + 18;
	          }
	          return x;
	        }).attr('y1', 0).attr('y2', -this.labelOffset).style('stroke-width', 6).style('stroke', 'white');
	
	        participant.append('line').attr('x1', 0).attr('x2', function (d, i) {
	          var x = void 0;
	          if (d.detected) {
	            x = labeler.lab[i].y + detectZeroPoint - that.y(d.value);
	            if (that.expanded) {
	              x = x + expandedOffset;
	            }
	          } else {
	            x = labeler.lab[i].y + that.participantFaceRadius + that.nonDetectWidth / 2 + that.participantSmallCircleRadius / 2 + 18;
	          }
	          return x;
	        }).attr('y1', 0).attr('y2', -this.labelOffset).style('stroke-width', 2).style('stroke', colors.orange);
	
	        // participant.append('line')
	        //   .attr('x1', 0)
	        //   .attr('x2', this.labelOffset)
	        //   .attr('y1', 0)
	        //   .attr('y2', (d, i) => labeler.lab[i].y - (d.detected ? that.y(d.value) : that.height + 15) )
	        //   .style('stroke-width', 6)
	        //   .style('stroke', 'white');
	        //
	        // participant.append('line')
	        //   .attr('x1', 0)
	        //   .attr('x2', this.labelOffset)
	        //   .attr('y1', 0)
	        //   .attr('y2', (d, i) => labeler.lab[i].y - (d.detected ? that.y(d.value) : that.height + 15) )
	        //   .style('stroke-width', 2)
	        //   .style('stroke', colors.orange);
	      }
	
	      var participantIcon = void 0;
	      if (!(this.tutorialMode && this.tutorialSettings.noAvatar)) {
	        participantIcon = participant.append('g').attr('transform', function (d, i) {
	          var x = void 0;
	          if (d.detected) {
	            x = labeler.lab[i].y + detectZeroPoint - that.y(d.value);
	          } else {
	            x = labeler.lab[i].y + that.participantFaceRadius + that.nonDetectWidth / 2 + that.participantSmallCircleRadius / 2 + 18;
	          }
	          if (that.expanded) {
	            x = x + expandedOffset;
	          }
	          var y = -that.labelOffset;
	          return translate(x, y);
	        });
	
	        if (this.useParticipantAvatar) {
	          if (this.expanded || this.avatar == 'face-7') {
	            participant.append('circle').attr('x', -this.participantSmallCircleRadius).attr('y', -this.participantSmallCircleRadius).attr('r', this.participantSmallCircleRadius).style('fill', colors.orange).style('stroke', 'white').style('stroke-width', 2);
	          } else {
	            participant.append('image').attr('xlink:href', ("") + '/images/' + this.avatar + '.png').attr('x', -this.participantFaceRadius).attr('y', function (d) {
	              if (!d.detected && !benchmarkDetected) {
	                return -that.participantFaceRadius - 8;
	              } else {
	                return -that.participantFaceRadius;
	              }
	            }).attr('width', this.participantFaceRadius * 2).attr('height', this.participantFaceRadius * 2);
	
	            participant.append('circle')
	            // .attr('x', -this.participantFaceRadius)
	            .attr('transform', function (d) {
	              if (!d.detected && !benchmarkDetected) {
	                return translate(0, -that.participantFaceRadius + 2);
	              } else {
	                return translate(0, 0);
	              }
	            }).attr('r', this.participantFaceRadius).style('stroke', colors.orange).style('stroke-width', 1).style('fill', 'transparent');
	          }
	
	          if (this.expanded) {
	            participantIcon.append('image').attr('xlink:href', ("") + '/images/' + this.avatar + '.png').attr('x', -this.faceSize / 2).attr('y', -this.faceSize / 2).attr('width', this.faceSize).attr('height', this.faceSize);
	          }
	        } else {
	          participant.append('circle').attr('x', -this.participantFaceRadius).attr('y', -this.participantFaceRadius).attr('r', this.participantFaceRadius).style('fill', colors.orange);
	
	          participantIcon.append('circle').attr('x', -(this.participantFaceRadius - 2)).attr('y', -(this.participantFaceRadius - 2)).attr('r', 2 * (this.participantFaceRadius - 2)).style('stroke-width', 2).style('stroke', 'white').style('fill', 'rgb(255, 80, 0)');
	        }
	      }
	
	      //add actual value for benchmark
	      var flagWidth = 20;
	      var flagHeight = 14;
	      var self = this;
	
	      var benchmarkIcon = void 0;
	      if (!(this.tutorialMode && this.tutorialSettings.noBenchmark)) {
	        benchmarkIcon = this.chart.selectAll('.benchmark-icon').data(benchmarks).enter().append('g').attr('transform', function (d) {
	          if (d.detected) {
	            return translate(self.y(d.value) - flagWidth / 2, self.graphMidline - benchmarkHeight);
	          } else {
	            if (self.expanded) {
	              return translate(self.nonDetectCenter - 13, self.graphMidline + 15);
	            } else {
	              if (participantDetected) {
	                return translate(self.nonDetectCenter - 13, self.graphMidline - 18);
	              } else {
	                return translate(self.nonDetectCenter - 13, self.graphMidline + 7);
	              }
	            }
	          }
	        });
	
	        benchmarkIcon.append('image').attr('xlink:href', function (d) {
	          if (d.symbol === 'star') return '';else {
	            return ("") + '/images/usflag.svg';
	          }
	        }).attr('transform', translate(0, -4)).attr('width', 20).attr('height', 20);
	
	        benchmarkIcon.append('rect').attr("x", 0).attr("y", -1).attr("rx", 2).attr("ry", 2).attr("width", flagWidth).attr("height", flagHeight).style('fill', 'none').style('stroke-width', 1.5).style('stroke', "rgb(13 94 143)");
	
	        benchmarkIcon.on('click', function () {
	          if (that.onBenchmarkClicked) {
	            that.onBenchmarkClicked();
	          }
	        });
	
	        if (this.expanded) {
	          // get the width of the text
	          var textData = ['a', 'b', 'c']; // your text here
	          var textWidth = [];
	
	          this.chart.append('g').selectAll('.dummyText') // declare a new CSS class 'dummyText'
	          .data(Array.from(benchmarks, function (x) {
	            return valuetext(x);
	          })).enter() // create new element
	          .append("text") // add element to class
	          .attr('font-size', '14px').attr('font-weight', 'bold').attr("opacity", 0.0) // not really necessary
	          .text(function (d) {
	            return d;
	          }).each(function (d, i) {
	            var thisWidth = this.getComputedTextLength();
	            textWidth.push(thisWidth);
	            this.remove(); // remove them just after displaying them
	          });
	          var benchmarkTextWidth = textWidth[0] + 6;
	
	          var benchmark_text = this.chart.selectAll('.benchmark-text').data(benchmarks).enter().append('g').attr('transform', function (d) {
	            if (d.detected) {
	              var middleXValue = self.y(d.value);
	              if (middleXValue - benchmarkTextWidth / 2 < self.nonDetectWidth + self.margin.left) {
	                middleXValue = self.nonDetectWidth + self.margin.left + benchmarkTextWidth / 2;
	              }
	              return translate(middleXValue, self.graphMidline - benchmarkHeight);
	            } else {
	              return translate(self.nonDetectCenter - 3, self.graphMidline + 52);
	            }
	          });
	          // .attr('transform', (d) => translate(d.detected ? this.y(d.value) : that.nonDetectCenter - 3, this.graphMidline-benchmarkHeight));
	
	          benchmark_text.append('rect').attr('x', -benchmarkTextWidth / 2).attr('width', benchmarkTextWidth).attr('y', -24).attr('height', 18).attr("rx", 8).attr("ry", 8).style('fill', function (d) {
	            if (d.detected) {
	              return 'rgba(255,255,255,0.75)';
	            } else {
	              return "none";
	            }
	          });
	
	          benchmark_text.append('text').attr('y', -flagHeight)
	          // .attr('width',0)
	          .attr('text-anchor', 'middle').attr('alignment-baseline', 'middle').attr('fill', colors.blue).attr('font-size', '14px').attr('font-weight', 'bold').text(function (d) {
	            return valuetext(d);
	          });
	
	          benchmark_text.on('click', function () {
	            if (that.onBenchmarkClicked) {
	              that.onBenchmarkClicked();
	            }
	          });
	        }
	      }
	
	      function valuetext(d) {
	        var thevaluetext = d.value + ' ' + that.units;
	        if (!d.detected) thevaluetext = that.noDetectText;
	        return thevaluetext;
	      }
	
	      if (!(this.tutorialMode && this.tutorialSettings.noBenchmark)) {
	        if (this.expanded) {
	          participantIcon.append('circle').attr('r', this.faceSize / 2).style('fill', this.useParticipantAvatar ? 'transparent' : 'white').style('stroke', colors.orange).style('stroke-width', 2);
	        }
	
	        //add actual value
	        if (this.expanded) {
	          participantIcon.append('text').attr('x', 0).attr('y', -this.faceSize + 14).attr('width', 0).attr('text-anchor', 'middle')
	          // .attr('alignment-baseline', 'top')
	          .attr('fill', colors.orange).attr('font-size', '14px').attr('font-weight', 'bold').text(function (d) {
	            return valuetext(d);
	          });
	        }
	
	        // if(this.useParticipantAvatar === false) {
	        // participantIcon.append('text')
	        //   .text('you')
	        //   .attr('text-anchor', 'middle')
	        //   .attr('alignment-baseline', 'central');
	        // }
	
	        if (this.showVisitBadges) {
	          var visitBadge = participantIcon.append('g').attr('transform', 'translate(' + (this.faceSize / 2 - 5) + ', -' + (this.faceSize / 2 - 5) + ')');
	
	          visitBadge.append('circle').attr('r', function (d) {
	            return !isNaN(d.visit) ? 15 : 0;
	          }).attr('stroke', colors.white).attr('stroke-width', 2).style('fill', colors.orange);
	
	          visitBadge.append('text').attr('text-anchor', 'middle').attr('alignment-baseline', 'middle').attr('fill', colors.white).text(function (d) {
	            return !isNaN(d.visit) ? d.visit : "";
	          });
	        }
	
	        participantIcon.on('click', function (d) {
	          if (that.onParticipantClicked) {
	            that.onParticipantClicked(d);
	          }
	        });
	      }
	
	      // if a tutorial, draw in sample participants A, B, and C
	      if (this.tutorialMode && this.tutorialSettings.drawSampleDots) {
	        var sampleRadius = 10;
	
	        // here2
	        // dots should be at:
	        // A: nondetect
	        // B: 40th percentile, or if 20th percentile is nondetect, then the smallest detect
	        // C: 98th percetile, or if it would overlap with B, then B + 2.5 facewidths
	        var a_x = self.nonDetectCenter - sampleRadius * 2;
	
	        var b_participant = void 0;
	        for (var _i5 = 0; _i5 < this.data.length; _i5++) {
	          var person = this.data[_i5];
	          if (person.detected && person.percentile > 0.2) {
	            // first detected person above the 40th percentile
	            b_participant = person;
	            break;
	          }
	        }
	        var b_x = this.y(b_participant.value);
	
	        var b_plus_facewidth = b_x + this.participantFaceRadius * 5;
	        var c_participant = void 0;
	        for (var _i6 = 0; _i6 < this.data.length; _i6++) {
	          var _person = this.data[_i6];
	          if (_person.detected && _person.percentile > 0.98) {
	            // first detected person above the 85th percentile
	            c_participant = _person;
	            break;
	          }
	        }
	        var c_participant_x = this.y(c_participant.value);
	        var c_x = Math.max(b_plus_facewidth, c_participant_x);
	
	        var sampleDots = this.chart.selectAll('.sample-dots').data(["A", "B", "C"]).enter().append('g').attr('transform', translate(0, self.graphMidline));
	
	        sampleDots.append("circle").attr("cx", function (d, i) {
	          if (d == "A") {
	            return a_x;
	          } else if (d == "B") {
	            return b_x;
	          }
	          return c_x;
	        }).attr("cy", 0).attr("r", sampleRadius).style("fill", "#c51149").style("stroke", "none");
	
	        sampleDots.append('text').attr("x", function (d, i) {
	          if (d == "A") {
	            return a_x;
	          } else if (d == "B") {
	            return b_x;
	          }
	          return c_x;
	        }).attr("y", 1).attr('text-anchor', 'middle').attr('alignment-baseline', 'middle').attr('fill', colors.white).attr('font-weight', 'bold').style('font-size', '14px').text(function (d) {
	          return d;
	        });
	      }
	    } // end updateData()
	
	  }, {
	    key: 'map',
	    value: function map(old_value, old_bottom, old_top, new_bottom, new_top) {
	      var new_value = (old_value - old_bottom) / (old_top - old_bottom) * (new_top - new_bottom) + new_bottom;
	      return new_value;
	    }
	  }]);
	
	  return SinaPlot;
	}(); // end class-SinaPlot
	
	exports.default = SinaPlot;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.state = undefined;
	
	var _lodash = __webpack_require__(26);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _mobx = __webpack_require__(80);
	
	var _Api = __webpack_require__(31);
	
	var _Locale = __webpack_require__(76);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	if (_helpers2.default.findGetParameter('language')) {
	  window.localStorage.setItem('language', _helpers2.default.findGetParameter('language'));
	  window.localStorage.setItem('avatar', _helpers2.default.findGetParameter('avatar'));
	} // State.js
	
	var state = exports.state = (0, _mobx.observable)({
	  messages: {},
	  locale: {},
	  graphs: {
	    useAvatars: false,
	    useParticipantAvatar: true,
	    jitter: false,
	    sina: true,
	    jitterAmount: 1.0,
	    labelOffset: 60,
	    showVisitBadges: true
	  },
	  language: window.localStorage.getItem('language') || 'en',
	  avatar: window.localStorage.getItem('avatar') || 'face-1', //false,
	  data: [],
	  participantId: '',
	  groups: {},
	  headlines: [],
	  benchmarks: [],
	  chemicals: {},
	  changeLanguage: (0, _mobx.action)('changeLanguage', function (val) {
	    this.language = val;
	    _helpers2.default.eventLog("changeLanguage - " + val);
	    if (val != '') window.localStorage.setItem('language', val);
	  }),
	  changeAvatar: (0, _mobx.action)('changeAvatar', function (avatar) {
	    this.avatar = avatar;
	    if (avatar != '') window.localStorage.setItem('avatar', avatar);
	  }),
	  updateData: (0, _mobx.action)('updateData', function (data, groups, chemicals, benchmarks) {
	    this.data = data;
	    this.groups = groups;
	    this.chemicals = chemicals;
	    this.benchmarks = benchmarks;
	  }),
	  updateHeadlines: (0, _mobx.action)('updateHeadlines', function (headlines) {
	    return this.headlines.replace(headlines);
	  }),
	  updateBenchmarks: (0, _mobx.action)('updateBenchmarks', function (data) {
	    this.benchmarks = data;
	  }),
	  updateStudyGroup: (0, _mobx.action)('updateStudyGroup', function (studyGroup) {
	    this.studyGroup = studyGroup;
	    if (studyGroup.toLowerCase() == "poe") {
	      this.showPOE = true;
	    } else {
	      this.showPOE = false;
	    }
	  }),
	  updateLocale: (0, _mobx.action)('updateLocale', function (data) {
	    this.locale = data;
	  }),
	  updateMessages: (0, _mobx.action)('updateMessages', function (data) {
	    this.messages = data;
	  }),
	  toggleGraphAvatars: (0, _mobx.action)('toggleGraphAvatars', function () {
	    this.graphs.useAvatars = !this.graphs.useAvatars;
	  }),
	
	  loadMeasurements: (0, _mobx.action)('loadMeasurements', function () {
	    var _this = this;
	
	    var compoundsURL = '/report/compounds.json?language=' + _Locale.locale;
	    return Promise.all([_Api.Api.csv('/report/detections.csv'), _Api.Api.json(compoundsURL)]).then(function (values) {
	      if (values[1].errors !== undefined) return Promise.reject("Load Data Error");
	      var results = [];
	      var groups = {};
	      var chemicals = {};
	
	      var detections = values[0];
	      var compounds = values[1];
	
	      var benchmarks = [];
	
	      _.values(compounds.compounds).forEach(function (compound) {
	        compound.benchmarks.forEach(function (benchmark) {
	          benchmarks.push({
	            value: +benchmark.value,
	            chemical_full: compound.name,
	            chemical: compound.abbreviation === "" ? compound.name : compound.abbreviation,
	            detected: benchmark.detected,
	            name: benchmark.name,
	            description: benchmark.description,
	            medium: benchmark.medium,
	            symbol: benchmark.symbol,
	            unit: benchmark.unit
	          });
	        });
	      });
	
	      var studyGroup = void 0;
	      detections.forEach(function (row) {
	        var compound = compounds.compounds[row.compound_id];
	        row.compound_name = compound.name;
	        if (!compound.abbreviation) {
	          // if(compound.abbreviation === "") {
	          row.abbreviation = compound.name;
	        } else {
	          row.abbreviation = compound.abbreviation;
	        }
	
	        if (groups[compound.group] === undefined) {
	          groups[compound.group] = [];
	        }
	
	        if (chemicals[compound.group + "-" + row.abbreviation] === undefined) {
	          chemicals[compound.group + "-" + row.abbreviation] = [];
	        }
	
	        // get study group
	        if (row.mine === "t") {
	          studyGroup = row.study_group;
	        }
	
	        // XXX: ideally type DataType and BenchmarkType would be classes with methods
	        _.times(parseInt(row.count), function () {
	          var obj = {
	            mine: row.mine === 't',
	            chemical: row.abbreviation,
	            chemical_full: row.compound_name,
	            group: compound.group,
	            value: +row.level,
	            detected: row.detected === 't',
	            visit: +row.batch,
	            display_name: row.display_name,
	            unit: row.unit
	          };
	
	          results.push(obj);
	          groups[compound.group].push(obj);
	          chemicals[compound.group + "-" + row.abbreviation].push(obj);
	        });
	      });
	
	      state.updateStudyGroup(studyGroup);
	      state.updateData(results, groups, chemicals, benchmarks);
	
	      return _this;
	    });
	  }),
	  loadHeadlines: (0, _mobx.action)('loadHeadlines', function () {
	    var headlinesURL = '/report/headlines.json?language=' + _Locale.locale;
	    return _Api.Api.json(headlinesURL).then(function (json) {
	      if (json.errors !== undefined) return Promise.reject("Load Headlines Error");
	      state.updateHeadlines(json.headlines);
	    });
	  }),
	  loggedIn: false, // TODO set to false before launching!
	  logIn: (0, _mobx.action)('logIn', function () {
	    this.loggedIn = true;
	  }),
	  logOut: (0, _mobx.action)('logOut', function () {
	    this.loggedIn = false;
	  })
	});
	
	window.state = state;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	__webpack_require__(241);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// DetectionsTable.js
	
	var DetectionsTable = function (_React$Component) {
	  _inherits(DetectionsTable, _React$Component);
	
	  function DetectionsTable() {
	    _classCallCheck(this, DetectionsTable);
	
	    return _possibleConstructorReturn(this, (DetectionsTable.__proto__ || Object.getPrototypeOf(DetectionsTable)).apply(this, arguments));
	  }
	
	  _createClass(DetectionsTable, [{
	    key: 'render',
	
	    //
	    // props: thedetections, iswatertable, thispage
	    //
	
	    // WAS mydetectionsDisplayDoit(thedetections: DataType[], iswatergroup: boolean)
	
	    value: function render() {
	      var _this2 = this;
	
	      /* should we show the visit column?  if water... no */
	      var showvisit = true;
	      var visitHTMLheader = null; //JSX whitespace
	      if (1) {
	        // let iswatergroup = this.waterpage(); // make it an INPUT
	        if (this.props.iswatertable) showvisit = false;
	        if (showvisit) visitHTMLheader = React.createElement(
	          'th',
	          null,
	          React.createElement(_reactIntl.FormattedMessage, { id: 'your_results.visit' })
	        );
	      }
	
	      var mydetectionsDisplayHead = React.createElement(
	        'tr',
	        null,
	        React.createElement(
	          'th',
	          null,
	          React.createElement(_reactIntl.FormattedMessage, { id: 'your_results.chemical' })
	        ),
	        React.createElement(
	          'th',
	          null,
	          React.createElement(_reactIntl.FormattedMessage, { id: 'your_results.measurement' })
	        ),
	        visitHTMLheader,
	        React.createElement(
	          'th',
	          null,
	          React.createElement(_reactIntl.FormattedMessage, { id: 'your_results.group' })
	        )
	      );
	
	      // const thedetections = this.mydetections();// make it an INPUT
	
	      var filtered_detections = this.props.thedetections;
	      filtered_detections = this.mydetectionsFiltered(filtered_detections, this.props.iswatertable);
	
	      var mydetectionsDisplayRows = filtered_detections.map(function (x, i) {
	        return _this2.mydetectionsDisplayDoit_row(x, i, showvisit);
	      });
	
	      return React.createElement(
	        'table',
	        { className: 'table mydetections-table' },
	        React.createElement(
	          'thead',
	          null,
	          mydetectionsDisplayHead
	        ),
	        React.createElement(
	          'tbody',
	          null,
	          mydetectionsDisplayRows
	        )
	      );
	    } // END render (WAS mydetectionsDisplayDoit)
	
	  }, {
	    key: 'watergroup',
	    value: function watergroup(groupkey) {
	      // perhaps better than looking at the page URL so a mixed results page is possible
	      return groupkey.search(/water/i) >= 0;
	    }
	  }, {
	    key: 'mydetectionsDisplayDoit_nameANDabbr',
	    value: function mydetectionsDisplayDoit_nameANDabbr(detection) {
	      var result = detection.chemical_full + ' (' + detection.chemical + ')';
	      if (detection.chemical_full === detection.chemical) {
	        result = detection.chemical_full; // e.g. parabens have no abbreviation
	      }
	      return result;
	    }
	  }, {
	    key: 'mydetectionsDisplayDoit_row',
	    value: function mydetectionsDisplayDoit_row(detection, i, showvisit) {
	      var thispage = this.props.thispage; // WAS this
	      var detectiongroupkey = _helpers2.default.convertGroupName(detection.group);
	      var thegroup = thispage.props.intl.messages['chemicals.' + detectiongroupkey + '.title']; // .title in ES or EN.  .data is in EN always and is group name - capitalized and space instead of _ except for sunscreen
	
	      var groupurl = Object.keys(_NavigationStructure2.default).filter(function (key) {
	        return _NavigationStructure2.default[key].group === detectiongroupkey;
	      })[0];
	
	      var iswatergroup = this.watergroup(detectiongroupkey);
	      var inmedium = void 0;
	      if (iswatergroup) inmedium = " " + thispage.props.intl.messages['in_water']; //XXX medium would ideally be in detections.csv
	      else inmedium = " " + thispage.props.intl.messages['in_urine']; //XXX medium
	
	      // conditional 1
	      var thevalue = detection.value + "  μg/L" + inmedium; // XXX: units
	      if (!detection.detected) thevalue = thispage.props.intl.messages['not_detected'] + inmedium;
	
	      // conditional 2
	      var visitHTML = null; //JSX whitespace
	      if (showvisit) {
	        var thevisit = "";
	        if (detection.visit) thevisit = detection.visit; // thispage.props.intl.messages['your_level_visit'] + "#" +    e.g. Visit#3
	        visitHTML = React.createElement(
	          'td',
	          null,
	          thevisit
	        );
	      }
	
	      //  <a href="#" onClick={(e) => thispage.goto(e, groupurl)}>{thegroup}</a>
	
	      var thename = this.mydetectionsDisplayDoit_nameANDabbr(detection);
	
	      return React.createElement(
	        'tr',
	        { key: i },
	        React.createElement(
	          'td',
	          null,
	          thename
	        ),
	        React.createElement(
	          'td',
	          null,
	          thevalue
	        ),
	        visitHTML,
	        React.createElement(
	          'td',
	          null,
	          thegroup
	        )
	      );
	    } // END mydetectionsDisplayDoit_row  
	
	
	  }, {
	    key: 'mydetections1_waterFilterFunction',
	    value: function mydetections1_waterFilterFunction(d) {
	      // "this": value of the optional argument to a JS filter function, send true or false
	      var ispagewater = this;
	      var isdatawater = d.group === "Water CVOCs" || d.group === "Water Phthalates";
	      if (ispagewater === true) return isdatawater;else return !isdatawater;
	    }
	  }, {
	    key: 'mydetections1_Compare',
	    value: function mydetections1_Compare(a, b) {
	      var x = a.chemical_full + a.visit;
	      var y = b.chemical_full + b.visit;
	      return x < y ? -1 : x > y ? 1 : 0;
	    }
	  }, {
	    key: 'mydetectionsFiltered',
	    value: function mydetectionsFiltered(thedata, wantwaterYN) {
	      // let wantwaterYN = this.waterpage();
	      // let thedata = this.props.appState.data;
	      return thedata.filter(function (d) {
	        return d.mine === true;
	      }).filter(this.mydetections1_waterFilterFunction, wantwaterYN).sort(this.mydetections1_Compare);
	    }
	  }]);
	
	  return DetectionsTable;
	}(React.Component); // END Class DetectionsTable
	
	exports.default = DetectionsTable;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _lodash = __webpack_require__(26);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _reactRouter = __webpack_require__(32);
	
	var _mobxReact = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _SinaPlot = __webpack_require__(216);
	
	var _SinaPlot2 = _interopRequireDefault(_SinaPlot);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(719);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Graph.js
	
	
	var Graph = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)((0, _mobxReact.observer)(function (_React$Component) {
		_inherits(Graph, _React$Component);
	
		function Graph(props) {
			_classCallCheck(this, Graph);
	
			var _this = _possibleConstructorReturn(this, (Graph.__proto__ || Object.getPrototypeOf(Graph)).call(this, props));
	
			_this.benchmarks = _this.getBenchmarks(props);
			_this.onModalClose = _this.onModalClose.bind(_this);
			_this.state = {
				showParticipantModal: false,
				showBenchmarkModal: false,
				showChemicalModal: false,
				showOtherParticipantsModal: false,
				showNonDetectModal: false,
				participantModal: {},
				chemicalModalMessageId: '',
				expanded: false
			};
			return _this;
		}
	
		_createClass(Graph, [{
			key: 'getData',
			value: function getData() {
				return this.props.data;
			}
		}, {
			key: 'getParticipantData',
			value: function getParticipantData() {
				return _.filter(this.getData(), { mine: true });
			}
		}, {
			key: 'getNonDetects',
			value: function getNonDetects() {
				return _.filter(this.getData(), { detected: false });
			}
		}, {
			key: 'getBenchmarks',
			value: function getBenchmarks(props) {
				if (!props) props = this.props;
				var benchmarks = props.appState.benchmarks.slice();
	
				if (props.chemical_full !== undefined && props.chemical_full !== null) {
					benchmarks = _.filter(benchmarks, { chemical_full: props.chemical_full });
				}
	
				if (props.medium !== undefined && props.medium !== null) {
					benchmarks = _.filter(benchmarks, function (d) {
						return props.medium.toLowerCase() === d.medium.toLowerCase();
					});
				}
	
				return benchmarks;
			}
		}, {
			key: 'showVisitBadges',
			value: function showVisitBadges() {
				return false;
				// return this.props.chemicalGroup !== 'Water CVOCs' && this.props.chemicalGroup !== 'Water Phthalates';
			}
		}, {
			key: 'avatarName',
			value: function avatarName() {
				return this.props.appState.avatar || 'house';
				// return !this.showVisitBadges() ? 'house' : this.props.appState.avatar;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var avatar = this.avatarName();
				var units = this.getData()[0].unit;
	
				this.sinaPlot = new _SinaPlot2.default(this.refs.graph, avatar);
	
				this.sinaPlot.useAvatars = this.props.appState.graphs.useAvatars;
				this.sinaPlot.useParticipantAvatar = this.props.appState.graphs.useParticipantAvatar;
				this.sinaPlot.jitter = this.props.appState.graphs.jitter;
				this.sinaPlot.sina = this.props.appState.graphs.sina;
				this.sinaPlot.jitterAmount = this.props.appState.graphs.jitterAmount;
				// this.sinaPlot.labelOffset = this.props.appState.graphs.labelOffset;
				this.sinaPlot.showVisitBadges = this.showVisitBadges();
				this.sinaPlot.units = units;
	
				this.sinaPlot.yLimits = this.props.yLimits;
				this.sinaPlot.noDetectText = this.props.intl.messages['nodetecttext_yaxis']; // this.props.noDetectText -- not needed
				this.sinaPlot.tutorialMode = this.props.tutorialMode || false;
				this.sinaPlot.tutorialSettings = this.props.tutorialSettings;
				this.sinaPlot.setup();
				this.sinaPlot.onChemicalClicked = this.onChemicalClicked.bind(this);
				this.sinaPlot.onParticipantClicked = this.onParticipantClicked.bind(this);
				this.sinaPlot.onBenchmarkClicked = this.onBenchmarkClicked.bind(this);
				this.sinaPlot.onNonDetectClicked = this.onNonDetectClicked.bind(this);
				this.sinaPlot.onOtherParticipantsClicked = this.onOtherParticipantsClicked.bind(this);
				this.sinaPlot.onAxisClicked = this.onAxisClicked.bind(this);
	
				this.sinaPlot.titleClickable = this.hasChemicalSpecificData();
	
				if (this.props.appState.data.length > 0) {
					this.sinaPlot.updateData(this.getData(), this.getBenchmarks(), this.props.appState.participantId);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState, snapshot) {
				if (prevProps.chemical !== this.props.chemical || prevProps.chemicalGroup !== this.props.chemicalGroup) {
					this.sinaPlot.clear();
					this.sinaPlot.avatar = this.avatarName();
					this.sinaPlot.showVisitBadges = this.showVisitBadges();
					this.sinaPlot.yLimits = this.props.yLimits;
					this.sinaPlot.noDetectText = this.props.intl.messages['nodetecttext_yaxis']; // this.props.noDetectText -- not needed
					this.sinaPlot.titleClickable = this.hasChemicalSpecificData();
					this.sinaPlot.tutorialMode = this.props.tutorialMode || false;
					this.sinaPlot.tutorialSettings = this.props.tutorialSettings;
					this.sinaPlot.setup();
					if (this.props.appState.data.length > 0) {
						this.sinaPlot.updateData(this.getData(), this.getBenchmarks(), this.props.appState.participantId);
					}
				}
				if (prevState.expanded !== this.state.expanded) {
					this.sinaPlot.clear();
					this.sinaPlot.expanded = this.state.expanded;
					this.sinaPlot.setup();
					if (this.props.appState.data.length > 0) {
						this.sinaPlot.updateData(this.getData(), this.getBenchmarks(), this.props.appState.participantId);
					}
				}
			}
		}, {
			key: 'hasChemicalSpecificData',
			value: function hasChemicalSpecificData() {
				return this.props.intl.messages['chemicals.' + this.props.chemicalGroup.toLowerCase().replace(' ', '_') + '.moreinfo.' + this.props.chemical] !== undefined;
			}
		}, {
			key: 'onParticipantClicked',
			value: function onParticipantClicked(d) {
				if (this.state.expanded) {
					console.log("onParticipantClicked", this);
					_helpers2.default.eventLog("modal - showParticipantModal");
					this.setState({
						showParticipantModal: true,
						showBenchmarkModal: false,
						showNonDetectModal: false,
						showOtherParticipantsModal: false,
						showChemicalModal: false,
						participantModal: d
					});
					document.getElementsByTagName("body")[0].style.overflow = "hidden";
				}
			}
		}, {
			key: 'onBenchmarkClicked',
			value: function onBenchmarkClicked() {
				if (this.state.expanded) {
					console.log("benchmarkClicked", this);
					_helpers2.default.eventLog("modal - showBenchmarkModal");
					this.setState({
						showBenchmarkModal: true,
						showParticipantModal: false,
						showNonDetectModal: false,
						showOtherParticipantsModal: false,
						showChemicalModal: false
					});
					document.getElementsByTagName("body")[0].style.overflow = "hidden";
				}
			}
		}, {
			key: 'onChemicalClicked',
			value: function onChemicalClicked(chemical) {
				if (this.state.expanded) {
					_helpers2.default.eventLog("modal - showChemicalModal - chem:" + chemical);
					this.setState({
						showChemicalModal: true,
						showParticipantModal: false,
						showBenchmarkModal: false,
						showNonDetectModal: false,
						showOtherParticipantsModal: false,
						chemicalModalMessageId: chemical
					});
					document.getElementsByTagName("body")[0].style.overflow = "hidden";
				}
			}
		}, {
			key: 'onNonDetectClicked',
			value: function onNonDetectClicked() {
				if (this.state.expanded) {
					console.log("onNonDetectClicked", this);
					_helpers2.default.eventLog("modal - showNonDetectModal");
					this.setState({
						showNonDetectModal: true,
						showParticipantModal: false,
						showBenchmarkModal: false,
						showOtherParticipantsModal: false,
						showChemicalModal: false
					});
					document.getElementsByTagName("body")[0].style.overflow = "hidden";
				}
			}
		}, {
			key: 'onOtherParticipantsClicked',
			value: function onOtherParticipantsClicked(d) {
				if (this.state.expanded) {
					console.log("showOtherParticipantsModal", this);
					_helpers2.default.eventLog("modal - showOtherParticipantsModal");
					this.setState({
						showOtherParticipantsModal: true,
						showParticipantModal: false,
						showBenchmarkModal: false,
						showNonDetectModal: false,
						showChemicalModal: false
					});
	
					document.getElementsByTagName("body")[0].style.overflow = "hidden";
				}
			}
		}, {
			key: 'onAxisClicked',
			value: function onAxisClicked() {}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {
				//this.sinaPlot.updateData(this.getData(), this.getBenchmarks(), this.props.appState.participantId);
			}
		}, {
			key: 'onModalClose',
			value: function onModalClose(e) {
				console.log("graph - close modal");
				this.setState({
					showParticipantModal: false,
					showBenchmarkModal: false,
					showNonDetectModal: false,
					showOtherParticipantsModal: false,
					showChemicalModal: false
				});
				document.getElementsByTagName("body")[0].style.overflow = "visible";
			}
		}, {
			key: 'toggleExpanded',
			value: function toggleExpanded() {
				if (this.state.expanded) {
					_helpers2.default.eventLog('graph - collapse graph - ' + this.props.chemical);
				} else {
					_helpers2.default.eventLog('graph - expand graph - ' + this.props.chemical);
				}
	
				var newToggle = !this.state.expanded;
				if (this.props.tutorialMode && this.props.tutorialSettings.clickExpandedGraph) {
					this.props.tutorialSettings.clickExpandedGraph(newToggle);
				}
				if (this.props.tutorialMode && this.props.tutorialSettings.noToggle) {
					// do nothing
				} else {
					this.setState({
						expanded: newToggle
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				if (this.getParticipantData().length === 0) {
					return React.createElement('div', null);
				}
	
				// let participantModal;
				// let benchmarkModal;
				// let nonDetectModal;
				// let otherParticipantsModal;
				// let chemicalModal;
				// if (this.state.showParticipantModal){
				// 	participantModal = (<ParticipantModal
				// 		// appState={this.props.appState}
				// 		data={this.state.participantModal}
				// 		showVisitBadge={this.showVisitBadges()}
				// 		avatarName={this.avatarName()}
				// 		onClose={this.onModalClose} />)
				// } else if (this.state.showBenchmarkModal){
				// 		benchmarkModal = (<BenchmarkModal
				// 			// appState={this.props.appState}
				// 			data={this.benchmarks}
				// 			onClose={this.onModalClose} />)
				// } else if (this.state.showNonDetectModal) {
				// 		nonDetectModal = <NonDetectModal
				// 			appState={this.props.appState}
				// 			data={this.getNonDetects()}
				// 			allData={this.getData()}
				// 			onClose={this.onModalClose} />
				// } else if (this.state.showOtherParticipantsModal) {
				// 		otherParticipantsModal = <OtherParticipantsModal
				// 			appState={this.props.appState}
				// 			data={this.getData()}
				// 			onClose={this.onModalClose} />
				// } else if (this.state.showChemicalModal) {
				// 	chemicalModal = <ChemicalModal
				// 		appState={this.props.appState}
				// 		chemicalGroup={this.props.chemicalGroup}
				// 		chemical={this.state.chemicalModalMessageId}
				// 		onClose={this.onModalClose}
				// 		/>
				// }
	
				var className = 'graph ' + (this.props.pointerEvents === false ? 'no-pointer-events' : '');
	
				var chevronState = void 0;
				if (this.state.expanded) {
					chevronState = "lighter chevron-arrow-down";
				} else {
					chevronState = "lighter chevron-arrow-right";
				}
				var chevron = void 0;
				if (this.props.tutorialMode && this.props.tutorialSettings.noToggle) {
					// don't have the chevron to toggle
				} else {
					chevron = React.createElement('span', { className: chevronState });
				}
	
				var learnMoreChemical = void 0;
				if (this.state.expanded && this.hasChemicalSpecificData()) {
					learnMoreChemical = React.createElement(
						'div',
						{
							className: 'learn-more-about-chemical',
							onClick: function onClick() {
								return _this2.onChemicalClicked(_this2.props.chemical);
							}
						},
						React.createElement(_reactIntl.FormattedMessage, { id: 'learn_more_about_this_chemical' })
					);
				}
	
				// {participantModal}
				// {benchmarkModal}
				// {nonDetectModal}
				// {otherParticipantsModal}
				// {chemicalModal}
	
	
				return React.createElement(
					'div',
					this.state.expanded ? {} : { onClick: this.toggleExpanded.bind(this) },
					React.createElement(
						'h3',
						Object.assign({
							className: 'graphs-chemical-name'
						}, this.state.expanded ? { onClick: this.toggleExpanded.bind(this) } : {}),
						chevron,
						this.props.chemical
					),
					learnMoreChemical,
					React.createElement(
						'div',
						{ className: className, ref: 'graph' },
						!this.state.showParticipantModal ? null : React.createElement(ParticipantModal, {
							data: this.state.participantModal,
							showVisitBadge: this.showVisitBadges(),
							avatarName: this.avatarName(),
							onClose: this.onModalClose }),
						!this.state.showBenchmarkModal ? null : React.createElement(BenchmarkModal, {
							data: this.benchmarks,
							onClose: this.onModalClose }),
						!this.state.showNonDetectModal ? null : React.createElement(NonDetectModal, {
							appState: this.props.appState,
							data: this.getNonDetects(),
							allData: this.getData(),
							onClose: this.onModalClose }),
						!this.state.showOtherParticipantsModal ? null : React.createElement(OtherParticipantsModal, {
							appState: this.props.appState,
							data: this.getData(),
							onClose: this.onModalClose }),
						!this.state.showChemicalModal ? null : React.createElement(ChemicalModal, {
							appState: this.props.appState,
							chemicalGroup: this.props.chemicalGroup,
							chemical: this.state.chemicalModalMessageId,
							onClose: this.onModalClose
						})
					),
					this.state.expanded && React.createElement(
						'p',
						{ className: 'tap-graph-message' },
						React.createElement(_reactIntl.FormattedMessage, { id: 'click_to_learn_more' })
					)
				);
			}
		}]);
	
		return Graph;
	}(React.Component))));
	
	// type ParticipantModalProps = { data: Object, onClose: () => void, appState: Object, showVisitBadge: boolean, avatarName: string };
	
	var ParticipantModal = function (_React$Component2) {
		_inherits(ParticipantModal, _React$Component2);
	
		function ParticipantModal() {
			_classCallCheck(this, ParticipantModal);
	
			return _possibleConstructorReturn(this, (ParticipantModal.__proto__ || Object.getPrototypeOf(ParticipantModal)).apply(this, arguments));
		}
	
		_createClass(ParticipantModal, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate() {
				console.log("participant modal - should component update");
				return false;
			}
		}, {
			key: 'render',
			value: function render() {
				console.log("render participant modal");
	
				var nobr = { whiteSpace: 'nowrap' };
	
				var visitText = isNaN(this.props.data.visit) || this.props.data.visit === 0 ? null : React.createElement(
					'span',
					{ style: nobr },
					' ',
					React.createElement(_reactIntl.FormattedMessage, { id: 'your_level_in_visit', defaultMessage: 'en la visita' }),
					' ',
					this.props.data.visit
				);
	
				var units = this.props.data.unit;
	
				var content = this.props.data.detected ? React.createElement(
					'span',
					null,
					React.createElement(_reactIntl.FormattedMessage, { id: 'your_level', values: { chemical: this.props.data.chemical, value: this.props.data.value, units: units } }),
					' ',
					visitText
				) : React.createElement(
					'span',
					null,
					React.createElement(_reactIntl.FormattedMessage, { id: 'your_level_not_detected', values: { chemical: this.props.data.chemical } }),
					' ',
					visitText
				);
	
				var visit = void 0;
				if (this.props.data.visit) {
					visit = React.createElement(
						'div',
						null,
						this.props.data.visit
					);
				}
	
				return React.createElement(
					_Modal2.default,
					{ onClose: this.props.onClose, className: 'participant' },
					React.createElement(
						'div',
						{ className: 'participant' },
						React.createElement('img', { src: (0, _safeUrl2.default)('/images/' + this.props.avatarName + '.png'), width: '100', alt: 'Your Avatar' }),
						visit
					),
					React.createElement(
						'h1',
						null,
						React.createElement(_reactIntl.FormattedMessage, { id: 'your_results', defaultMessage: 'Sus resultados' }),
						' ',
						this.props.data.chemical
					),
					content
				);
			}
		}]);
	
		return ParticipantModal;
	}(React.Component);
	
	// type BenchmarkModalProps = {data: Object[], onClose: () => void };
	
	
	var BenchmarkModal = function (_React$Component3) {
		_inherits(BenchmarkModal, _React$Component3);
	
		function BenchmarkModal() {
			_classCallCheck(this, BenchmarkModal);
	
			return _possibleConstructorReturn(this, (BenchmarkModal.__proto__ || Object.getPrototypeOf(BenchmarkModal)).apply(this, arguments));
		}
	
		_createClass(BenchmarkModal, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				console.log("benchmark modal - should component update");
				return false;
			}
		}, {
			key: 'render',
			value: function render() {
				console.log("benchmark modal - render");
	
				var h1name = this.props.data[0].name;
	
				// XXX: compounds.json name and description is normally hardwired in spanish.  Except see DINP
				// https://trello.com/c/zlQfWcJc/23-us-median-needs-translation-when-clicking-legend
				var usingspanish = 0; // should not happen now ... see GLOBAL_locale
				if (usingspanish) {
					if (h1name.match(/US Median/i)) h1name = "Media EEUU...";
				}
	
				//XXX: missing description in DINP in compounds.json from api
				var thedesc = this.props.data[0].description;
				if (!thedesc) thedesc = "[Error: no detalles]";
				var isStar = this.props.data[0].symbol === 'star'; // props.data[0] -> chemical, chemical_full, description, detected, medium, name, symbol, value,
				var svg = React.createElement('img', { src: (0, _safeUrl2.default)('/images/usflag.svg'), width: '100', alt: '{h1name}' });
				if (isStar) {
					svg = React.createElement('img', { src: (0, _safeUrl2.default)('/images/graph-blue-star.png'), width: '100', alt: '{h1name}' });
				}
	
				return React.createElement(
					_Modal2.default,
					{ onClose: this.props.onClose },
					svg,
					React.createElement(
						'h1',
						null,
						h1name
					),
					thedesc
				);
			}
		}]);
	
		return BenchmarkModal;
	}(React.Component);
	
	var NonDetectModal = function (_React$Component4) {
		_inherits(NonDetectModal, _React$Component4);
	
		function NonDetectModal() {
			_classCallCheck(this, NonDetectModal);
	
			return _possibleConstructorReturn(this, (NonDetectModal.__proto__ || Object.getPrototypeOf(NonDetectModal)).apply(this, arguments));
		}
	
		_createClass(NonDetectModal, [{
			key: 'render',
			value: function render() {
				var avatar = this.props.appState.avatar === 'face-1' ? 'face-2' : 'face-1';
				var chemical = this.props.allData[0].chemical;
				var numNonDetects = this.props.data.length;
				var percentage = Math.round(this.props.data.length / this.props.allData.length * 100);
				if (percentage < 1) percentage = React.createElement(_reactIntl.FormattedMessage, { id: 'non_detects_less_than_1' });
				if (percentage == 100 && this.props.data.length < this.props.allData.length) {
					percentage = 99;
				}
	
				return React.createElement(
					_Modal2.default,
					{ onClose: this.props.onClose },
					React.createElement('img', { src: (0, _safeUrl2.default)('/images/' + avatar + '.png'), width: '100', alt: 'Non-detect values' }),
					React.createElement(
						'h1',
						null,
						React.createElement(_reactIntl.FormattedMessage, { id: 'not_detected', defaultMessage: 'No se detectado' })
					),
					React.createElement(_reactIntl.FormattedMessage, { id: 'non_detects', values: { value: numNonDetects, percent: percentage, chemical: chemical } })
				);
			}
		}]);
	
		return NonDetectModal;
	}(React.Component);
	
	var OtherParticipantsModal = function (_React$Component5) {
		_inherits(OtherParticipantsModal, _React$Component5);
	
		function OtherParticipantsModal() {
			_classCallCheck(this, OtherParticipantsModal);
	
			return _possibleConstructorReturn(this, (OtherParticipantsModal.__proto__ || Object.getPrototypeOf(OtherParticipantsModal)).apply(this, arguments));
		}
	
		_createClass(OtherParticipantsModal, [{
			key: 'render',
			value: function render() {
				var avatar = this.props.appState.avatar === 'face-1' ? 'face-2' : 'face-1';
				var data = this.props.data;
				var numParticipants = _.chain(this.props.data).map('recruit_identifier').uniq().value().length;
				var numSamples = _.filter(this.props.data, function (d) {
					return d.mine === false;
				}).length;
	
				return React.createElement(
					_Modal2.default,
					{ onClose: this.props.onClose },
					React.createElement('img', { src: (0, _safeUrl2.default)('/images/' + avatar + '.png'), width: '100', alt: 'Other Participants' }),
					React.createElement(
						'h1',
						null,
						React.createElement(_reactIntl.FormattedMessage, { id: 'other_participants' })
					),
					React.createElement(_reactIntl.FormattedMessage, { id: 'other_participants_content', values: { number: numParticipants - 1, chemical: data[0].chemical, samples: numSamples } })
				);
			}
		}]);
	
		return OtherParticipantsModal;
	}(React.Component);
	
	var ChemicalModal = function (_React$Component6) {
		_inherits(ChemicalModal, _React$Component6);
	
		function ChemicalModal() {
			_classCallCheck(this, ChemicalModal);
	
			return _possibleConstructorReturn(this, (ChemicalModal.__proto__ || Object.getPrototypeOf(ChemicalModal)).apply(this, arguments));
		}
	
		_createClass(ChemicalModal, [{
			key: 'render',
			value: function render() {
				var group_name = _helpers2.default.convertGroupName(this.props.chemicalGroup); // this.props.chemicalGroup.toLowerCase().replace(' ', '_')
				var messageId = 'chemicals.' + group_name + '.moreinfo.' + this.props.chemical;
				return React.createElement(
					_Modal2.default,
					{ onClose: this.props.onClose, className: 'more-info left-align', fullScreen: true },
					React.createElement(_reactIntl.FormattedHTMLMessage, { id: messageId })
				);
			}
		}]);
	
		return ChemicalModal;
	}(React.Component);
	
	exports.default = Graph;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationButton = (0, _reactRouter.withRouter)(function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));
	  }
	
	  _createClass(Button, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      e.preventDefault();
	
	      _helpers2.default.eventLog("nav:bottom button pressed - " + this.props.messageId + " - " + this.props.to);
	
	      this.props.history.push(this.props.to);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = ['button', this.props.side, this.props.messageId, this.props.lowPriority ? 'lowpriority' : '',
	      // this.state.enabled ? 'enabled' : 'disabled',
	      this.props.page].join(' ');
	
	      var message = _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.messageId });
	
	      return _react2.default.createElement(
	        'a',
	        { className: classes, onClick: this.onClick.bind(this) },
	        message
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component));
	
	exports.default = (0, _mobxReact.observer)(NavigationButton);

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 223 */
[737, 638, 639],
/* 224 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.extend = extend;
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	var hop = exports.hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i,
	        len,
	        source,
	        key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) {
	            continue;
	        }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// Standard YAML's Core schema.
	// http://www.yaml.org/spec/1.2/spec.html#id2804923
	//
	// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
	// So, Core schema has no distinctions from JSON schema is JS-YAML.
	
	
	'use strict';
	
	var Schema = __webpack_require__(39);
	
	module.exports = new Schema({
	  include: [__webpack_require__(226)]
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	// Standard YAML's JSON schema.
	// http://www.yaml.org/spec/1.2/spec.html#id2803231
	//
	// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
	// So, this schema is not such strict as defined in the YAML specification.
	// It allows numbers in binary notaion, use `Null` and `NULL` as `null`, etc.
	
	
	'use strict';
	
	var Schema = __webpack_require__(39);
	
	module.exports = new Schema({
	  include: [__webpack_require__(128)],
	  implicit: [__webpack_require__(663), __webpack_require__(655), __webpack_require__(657), __webpack_require__(656)]
	});

/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var asap = __webpack_require__(243);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (_typeof(this) !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function () {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(self, new TypeError('A promise cannot be resolved with itself.'));
	  }
	  if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (then === self.then && newValue instanceof Promise) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}

/***/ },
/* 229 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = Link;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Route = __webpack_require__(130);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(627);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(82);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	
	exports.default = MemoryRouter;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = Prompt;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(631);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	
	exports.default = Redirect;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(52);
	
	var _Router = __webpack_require__(82);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = StaticRouter;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(83);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	
	exports.default = Switch;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(632);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(130);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 238 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;

/***/ },
/* 239 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;

/***/ },
/* 240 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ },
/* 241 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(675).enable();
	  window.Promise = __webpack_require__(674);
	}
	
	__webpack_require__(679);
	
	// fetch() polyfill for making API calls.
	__webpack_require__(712);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(56);
	
	// https://github.com/akiran/react-slick/issues/742
	window.matchMedia = window.matchMedia || function() {
	  return {
	    matches : false,
	    addListener : function() {},
	    removeListener: function() {}
	  };
	};


/***/ },
/* 243 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	    // MessageChannels are desirable because they give direct access to the HTML
	    // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	    // 11-12, and in web workers in many engines.
	    // Although message channels yield to any queued rendering and IO tasks, they
	    // would be better than imposing the 4ms delay of timers.
	    // However, they do not work reliably in Internet Explorer or Safari.
	
	    // Internet Explorer 10 is the only browser that has setImmediate but does
	    // not have MutationObservers.
	    // Although setImmediate yields to the browser's renderer, it would be
	    // preferrable to falling back to setTimeout since it does not have
	    // the minimum 4ms penalty.
	    // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	    // Desktop to a lesser extent) that renders both setImmediate and
	    // MessageChannel useless for the purposes of ASAP.
	    // https://github.com/kriskowal/q/issues/396
	
	    // Timers are implemented universally.
	    // We fall back to timers in workers in most engines, and in foreground
	    // contexts in the following browsers.
	    // However, note that even this simple case requires nuances to operate in a
	    // broad spectrum of browsers.
	    //
	    // - Firefox 3-13
	    // - Internet Explorer 6-9
	    // - iPad Safari 4.3
	    // - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, { characterData: true });
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 244 */
/***/ function(module, exports) {

	'use strict';
	
	exports.byteLength = byteLength;
	exports.toByteArray = toByteArray;
	exports.fromByteArray = fromByteArray;
	
	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i];
	  revLookup[code.charCodeAt(i)] = i;
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;
	
	function placeHoldersCount(b64) {
	  var len = b64.length;
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4');
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
	}
	
	function byteLength(b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64);
	}
	
	function toByteArray(b64) {
	  var i, l, tmp, placeHolders, arr;
	  var len = b64.length;
	  placeHolders = placeHoldersCount(b64);
	
	  arr = new Arr(len * 3 / 4 - placeHolders);
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len;
	
	  var L = 0;
	
	  for (i = 0; i < l; i += 4) {
	    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
	    arr[L++] = tmp >> 16 & 0xFF;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  if (placeHolders === 2) {
	    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
	    arr[L++] = tmp & 0xFF;
	  } else if (placeHolders === 1) {
	    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  return arr;
	}
	
	function tripletToBase64(num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
	}
	
	function encodeChunk(uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('');
	}
	
	function fromByteArray(uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var output = '';
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    output += lookup[tmp >> 2];
	    output += lookup[tmp << 4 & 0x3F];
	    output += '==';
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    output += lookup[tmp >> 10];
	    output += lookup[tmp >> 4 & 0x3F];
	    output += lookup[tmp << 2 & 0x3F];
	    output += '=';
	  }
	
	  parts.push(output);
	
	  return parts.join('');
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict';
	
	var base64 = __webpack_require__(244);
	var ieee754 = __webpack_require__(633);
	var isArray = __webpack_require__(648);
	
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength();
	
	function typedArraySupport() {
	  try {
	    var arr = new Uint8Array(1);
	    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
	        return 42;
	      } };
	    return arr.foo() === 42 && // typed array instances can be augmented
	    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
	  } catch (e) {
	    return false;
	  }
	}
	
	function kMaxLength() {
	  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
	}
	
	function createBuffer(that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length');
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length);
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length);
	    }
	    that.length = length;
	  }
	
	  return that;
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer(arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length);
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error('If encoding is specified then the first argument must be a string');
	    }
	    return allocUnsafe(this, arg);
	  }
	  return from(this, arg, encodingOrOffset, length);
	}
	
	Buffer.poolSize = 8192; // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype;
	  return arr;
	};
	
	function from(that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length);
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset);
	  }
	
	  return fromObject(that, value);
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length);
	};
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype;
	  Buffer.__proto__ = Uint8Array;
	  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    });
	  }
	}
	
	function assertSize(size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number');
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative');
	  }
	}
	
	function alloc(that, size, fill, encoding) {
	  assertSize(size);
	  if (size <= 0) {
	    return createBuffer(that, size);
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
	  }
	  return createBuffer(that, size);
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding);
	};
	
	function allocUnsafe(that, size) {
	  assertSize(size);
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0;
	    }
	  }
	  return that;
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size);
	};
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size);
	};
	
	function fromString(that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8';
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding');
	  }
	
	  var length = byteLength(string, encoding) | 0;
	  that = createBuffer(that, length);
	
	  var actual = that.write(string, encoding);
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual);
	  }
	
	  return that;
	}
	
	function fromArrayLike(that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0;
	  that = createBuffer(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	function fromArrayBuffer(that, array, byteOffset, length) {
	  array.byteLength; // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds');
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds');
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array);
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset);
	  } else {
	    array = new Uint8Array(array, byteOffset, length);
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array;
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array);
	  }
	  return that;
	}
	
	function fromObject(that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0;
	    that = createBuffer(that, len);
	
	    if (that.length === 0) {
	      return that;
	    }
	
	    obj.copy(that, 0, 0, len);
	    return that;
	  }
	
	  if (obj) {
	    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0);
	      }
	      return fromArrayLike(that, obj);
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
	}
	
	function checked(length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
	  }
	  return length | 0;
	}
	
	function SlowBuffer(length) {
	  if (+length != length) {
	    // eslint-disable-line eqeqeq
	    length = 0;
	  }
	  return Buffer.alloc(+length);
	}
	
	Buffer.isBuffer = function isBuffer(b) {
	  return !!(b != null && b._isBuffer);
	};
	
	Buffer.compare = function compare(a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers');
	  }
	
	  if (a === b) return 0;
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	Buffer.isEncoding = function isEncoding(encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true;
	    default:
	      return false;
	  }
	};
	
	Buffer.concat = function concat(list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers');
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0);
	  }
	
	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length;
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length);
	  var pos = 0;
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i];
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers');
	    }
	    buf.copy(buffer, pos);
	    pos += buf.length;
	  }
	  return buffer;
	};
	
	function byteLength(string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length;
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength;
	  }
	  if (typeof string !== 'string') {
	    string = '' + string;
	  }
	
	  var len = string.length;
	  if (len === 0) return 0;
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len;
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length;
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2;
	      case 'hex':
	        return len >>> 1;
	      case 'base64':
	        return base64ToBytes(string).length;
	      default:
	        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;
	
	function slowToString(encoding, start, end) {
	  var loweredCase = false;
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0;
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return '';
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length;
	  }
	
	  if (end <= 0) {
	    return '';
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0;
	  start >>>= 0;
	
	  if (end <= start) {
	    return '';
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end);
	
	      case 'ascii':
	        return asciiSlice(this, start, end);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end);
	
	      case 'base64':
	        return base64Slice(this, start, end);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true;
	
	function swap(b, n, m) {
	  var i = b[n];
	  b[n] = b[m];
	  b[m] = i;
	}
	
	Buffer.prototype.swap16 = function swap16() {
	  var len = this.length;
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits');
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1);
	  }
	  return this;
	};
	
	Buffer.prototype.swap32 = function swap32() {
	  var len = this.length;
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits');
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3);
	    swap(this, i + 1, i + 2);
	  }
	  return this;
	};
	
	Buffer.prototype.swap64 = function swap64() {
	  var len = this.length;
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits');
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7);
	    swap(this, i + 1, i + 6);
	    swap(this, i + 2, i + 5);
	    swap(this, i + 3, i + 4);
	  }
	  return this;
	};
	
	Buffer.prototype.toString = function toString() {
	  var length = this.length | 0;
	  if (length === 0) return '';
	  if (arguments.length === 0) return utf8Slice(this, 0, length);
	  return slowToString.apply(this, arguments);
	};
	
	Buffer.prototype.equals = function equals(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return true;
	  return Buffer.compare(this, b) === 0;
	};
	
	Buffer.prototype.inspect = function inspect() {
	  var str = '';
	  var max = exports.INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>';
	};
	
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer');
	  }
	
	  if (start === undefined) {
	    start = 0;
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0;
	  }
	  if (thisStart === undefined) {
	    thisStart = 0;
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length;
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index');
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0;
	  }
	  if (thisStart >= thisEnd) {
	    return -1;
	  }
	  if (start >= end) {
	    return 1;
	  }
	
	  start >>>= 0;
	  end >>>= 0;
	  thisStart >>>= 0;
	  thisEnd >>>= 0;
	
	  if (this === target) return 0;
	
	  var x = thisEnd - thisStart;
	  var y = end - start;
	  var len = Math.min(x, y);
	
	  var thisCopy = this.slice(thisStart, thisEnd);
	  var targetCopy = target.slice(start, end);
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i];
	      y = targetCopy[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1;
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset;
	    byteOffset = 0;
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff;
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000;
	  }
	  byteOffset = +byteOffset; // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : buffer.length - 1;
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1;else byteOffset = buffer.length - 1;
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0;else return -1;
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding);
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1;
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	  } else if (typeof val === 'number') {
	    val = val & 0xFF; // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	  }
	
	  throw new TypeError('val must be string, number or Buffer');
	}
	
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1;
	  var arrLength = arr.length;
	  var valLength = val.length;
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase();
	    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1;
	      }
	      indexSize = 2;
	      arrLength /= 2;
	      valLength /= 2;
	      byteOffset /= 2;
	    }
	  }
	
	  function read(buf, i) {
	    if (indexSize === 1) {
	      return buf[i];
	    } else {
	      return buf.readUInt16BE(i * indexSize);
	    }
	  }
	
	  var i;
	  if (dir) {
	    var foundIndex = -1;
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex;
	        foundIndex = -1;
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true;
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false;
	          break;
	        }
	      }
	      if (found) return i;
	    }
	  }
	
	  return -1;
	}
	
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	
	function hexWrite(buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
	
	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (isNaN(parsed)) return i;
	    buf[offset + i] = parsed;
	  }
	  return i;
	}
	
	function utf8Write(buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	function asciiWrite(buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	
	function latin1Write(buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length);
	}
	
	function base64Write(buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	
	function ucs2Write(buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	Buffer.prototype.write = function write(string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0;
	    if (isFinite(length)) {
	      length = length | 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	    // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
	  }
	
	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;
	
	  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds');
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length);
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length);
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};
	
	Buffer.prototype.toJSON = function toJSON() {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  };
	};
	
	function base64Slice(buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf);
	  } else {
	    return base64.fromByteArray(buf.slice(start, end));
	  }
	}
	
	function utf8Slice(buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];
	
	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break;
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }
	
	    res.push(codePoint);
	    i += bytesPerSequence;
	  }
	
	  return decodeCodePointsArray(res);
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	function decodeCodePointsArray(codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	  }
	  return res;
	}
	
	function asciiSlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret;
	}
	
	function latin1Slice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret;
	}
	
	function hexSlice(buf, start, end) {
	  var len = buf.length;
	
	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;
	
	  var out = '';
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i]);
	  }
	  return out;
	}
	
	function utf16leSlice(buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res;
	}
	
	Buffer.prototype.slice = function slice(start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;
	
	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }
	
	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }
	
	  if (end < start) end = start;
	
	  var newBuf;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end);
	    newBuf.__proto__ = Buffer.prototype;
	  } else {
	    var sliceLen = end - start;
	    newBuf = new Buffer(sliceLen, undefined);
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start];
	    }
	  }
	
	  return newBuf;
	};
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset(offset, ext, length) {
	  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }
	
	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset];
	};
	
	Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | this[offset + 1] << 8;
	};
	
	Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] << 8 | this[offset + 1];
	};
	
	Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
	};
	
	Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return this[offset];
	  return (0xff - this[offset] + 1) * -1;
	};
	
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | this[offset + 1] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | this[offset] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, true, 23, 4);
	};
	
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, false, 23, 4);
	};
	
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, true, 52, 8);
	};
	
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, false, 52, 8);
	};
	
	function checkInt(buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	function objectWriteUInt16(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	function objectWriteUInt32(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = value >>> 24;
	    this[offset + 2] = value >>> 16;
	    this[offset + 1] = value >>> 8;
	    this[offset] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = 0;
	  var mul = 1;
	  var sub = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	    this[offset + 2] = value >>> 16;
	    this[offset + 3] = value >>> 24;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	function checkIEEE754(buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	  if (offset < 0) throw new RangeError('Index out of range');
	}
	
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4;
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert);
	};
	
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8;
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert);
	};
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0;
	  if (target.length === 0 || this.length === 0) return 0;
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds');
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
	  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }
	
	  var len = end - start;
	  var i;
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
	  }
	
	  return len;
	};
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start;
	      start = 0;
	      end = this.length;
	    } else if (typeof end === 'string') {
	      encoding = end;
	      end = this.length;
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0);
	      if (code < 256) {
	        val = code;
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string');
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding);
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255;
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index');
	  }
	
	  if (end <= start) {
	    return this;
	  }
	
	  start = start >>> 0;
	  end = end === undefined ? this.length : end >>> 0;
	
	  if (!val) val = 0;
	
	  var i;
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val;
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
	    var len = bytes.length;
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len];
	    }
	  }
	
	  return this;
	};
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
	function base64clean(str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return '';
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str;
	}
	
	function stringtrim(str) {
	  if (str.trim) return str.trim();
	  return str.replace(/^\s+|\s+$/g, '');
	}
	
	function toHex(n) {
	  if (n < 16) return '0' + n.toString(16);
	  return n.toString(16);
	}
	
	function utf8ToBytes(string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i);
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        }
	
	        // valid lead
	        leadSurrogate = codePoint;
	
	        continue;
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue;
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }
	
	    leadSurrogate = null;
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break;
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break;
	      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break;
	      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break;
	      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else {
	      throw new Error('Invalid code point');
	    }
	  }
	
	  return bytes;
	}
	
	function asciiToBytes(str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray;
	}
	
	function utf16leToBytes(str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break;
	
	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }
	
	  return byteArray;
	}
	
	function base64ToBytes(str) {
	  return base64.toByteArray(base64clean(str));
	}
	
	function blitBuffer(src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if (i + offset >= dst.length || i >= src.length) break;
	    dst[i + offset] = src[i];
	  }
	  return i;
	}
	
	function isnan(val) {
	  return val !== val; // eslint-disable-line no-self-compare
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 246 */
35,
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = _pairs.pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var _pairs = __webpack_require__(137);

/***/ },
/* 248 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var value = _identity2.default,
	      domain = _extent2.default,
	      threshold = _sturges2.default;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = (0, _ticks.tickStep)(x0, x1, tz);
	      tz = (0, _range2.default)(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) {
	      tz.shift(), --m;
	    }while (tz[m - 1] > x1) {
	      tz.pop(), --m;
	    }var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[(0, _bisect2.default)(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function (_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant2.default)(_), histogram) : value;
	  };
	
	  histogram.domain = function (_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constant2.default)([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function (_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant2.default)(_array.slice.call(_)) : (0, _constant2.default)(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var _array = __webpack_require__(131);
	
	var _bisect = __webpack_require__(132);
	
	var _bisect2 = _interopRequireDefault(_bisect);
	
	var _constant = __webpack_require__(246);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _extent = __webpack_require__(135);
	
	var _extent2 = _interopRequireDefault(_extent);
	
	var _identity = __webpack_require__(250);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _range = __webpack_require__(138);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _ticks = __webpack_require__(140);
	
	var _sturges = __webpack_require__(139);
	
	var _sturges2 = _interopRequireDefault(_sturges);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 250 */
95,
/* 251 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) {
	      // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) {
	          // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  } else {
	    while (++i < n) {
	      // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) {
	          // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = (0, _number2.default)(values[i]))) sum += value;else --m;
	    }
	  } else {
	    while (++i < n) {
	      if (!isNaN(value = (0, _number2.default)(valueof(values[i], i, values)))) sum += value;else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var _number = __webpack_require__(41);
	
	var _number2 = _interopRequireDefault(_number);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = (0, _number2.default)(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  } else {
	    while (++i < n) {
	      if (!isNaN(value = (0, _number2.default)(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return (0, _quantile2.default)(numbers.sort(_ascending2.default), 0.5);
	};
	
	var _ascending = __webpack_require__(33);
	
	var _ascending2 = _interopRequireDefault(_ascending);
	
	var _number = __webpack_require__(41);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _quantile = __webpack_require__(85);
	
	var _quantile2 = _interopRequireDefault(_quantile);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 254 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) {
	    j += arrays[i].length;
	  }merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};

/***/ },
/* 255 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, indexes) {
	  var i = indexes.length,
	      permutes = new Array(i);
	  while (i--) {
	    permutes[i] = array[indexes[i]];
	  }return permutes;
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = _ascending2.default;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var _ascending = __webpack_require__(33);
	
	var _ascending2 = _interopRequireDefault(_ascending);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 257 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};

/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  } else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, min, max) {
	  values = _array.map.call(values, _number2.default).sort(_ascending2.default);
	  return Math.ceil((max - min) / (2 * ((0, _quantile2.default)(values, 0.75) - (0, _quantile2.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var _array = __webpack_require__(131);
	
	var _ascending = __webpack_require__(33);
	
	var _ascending2 = _interopRequireDefault(_ascending);
	
	var _number = __webpack_require__(41);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _quantile = __webpack_require__(85);
	
	var _quantile2 = _interopRequireDefault(_quantile);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (values, min, max) {
	  return Math.ceil((max - min) / (3.5 * (0, _deviation2.default)(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var _deviation = __webpack_require__(134);
	
	var _deviation2 = _interopRequireDefault(_deviation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return (0, _transpose2.default)(arguments);
	};
	
	var _transpose = __webpack_require__(141);
	
	var _transpose2 = _interopRequireDefault(_transpose);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axis = __webpack_require__(264);
	
	Object.defineProperty(exports, "axisTop", {
	  enumerable: true,
	  get: function get() {
	    return _axis.axisTop;
	  }
	});
	Object.defineProperty(exports, "axisRight", {
	  enumerable: true,
	  get: function get() {
	    return _axis.axisRight;
	  }
	});
	Object.defineProperty(exports, "axisBottom", {
	  enumerable: true,
	  get: function get() {
	    return _axis.axisBottom;
	  }
	});
	Object.defineProperty(exports, "axisLeft", {
	  enumerable: true,
	  get: function get() {
	    return _axis.axisLeft;
	  }
	});

/***/ },
/* 263 */
195,
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	
	var _array = __webpack_require__(263);
	
	var _identity = __webpack_require__(265);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var top = 1,
	    right = 2,
	    bottom = 3,
	    left = 4,
	    epsilon = 1e-6;
	
	function translateX(x) {
	  return "translate(" + (x + 0.5) + ",0)";
	}
	
	function translateY(y) {
	  return "translate(0," + (y + 0.5) + ")";
	}
	
	function number(scale) {
	  return function (d) {
	    return +scale(d);
	  };
	}
	
	function center(scale) {
	  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
	  if (scale.round()) offset = Math.round(offset);
	  return function (d) {
	    return +scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3,
	      k = orient === top || orient === left ? -1 : 1,
	      x = orient === left || orient === right ? "x" : "y",
	      transform = orient === top || orient === bottom ? translateX : translateY;
	
	  function axis(context) {
	    var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues,
	        format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : _identity2.default : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        range = scale.range(),
	        range0 = +range[0] + 0.5,
	        range1 = +range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : number)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text");
	
	    path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line").attr("stroke", "#000").attr(x + "2", k * tickSizeInner));
	
	    text = text.merge(tickEnter.append("text").attr("fill", "#000").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function (d) {
	        return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
	      });
	
	      tickEnter.attr("opacity", epsilon).attr("transform", function (d) {
	        var p = this.parentNode.__axis;return transform(p && isFinite(p = p(d)) ? p : position(d));
	      });
	    }
	
	    tickExit.remove();
	
	    path.attr("d", orient === left || orient == right ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick.attr("opacity", 1).attr("transform", function (d) {
	      return transform(position(d));
	    });
	
	    line.attr(x + "2", k * tickSizeInner);
	
	    text.attr(x, k * spacing).text(format);
	
	    selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection.each(function () {
	      this.__axis = position;
	    });
	  }
	
	  axis.scale = function (_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function () {
	    return tickArguments = _array.slice.call(arguments), axis;
	  };
	
	  axis.tickArguments = function (_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : _array.slice.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function (_) {
	    return arguments.length ? (tickValues = _ == null ? null : _array.slice.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function (_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function (_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function (_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function (_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function (_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}

/***/ },
/* 265 */
95,
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _brush = __webpack_require__(267);
	
	Object.defineProperty(exports, "brush", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_brush).default;
	  }
	});
	Object.defineProperty(exports, "brushX", {
	  enumerable: true,
	  get: function get() {
	    return _brush.brushX;
	  }
	});
	Object.defineProperty(exports, "brushY", {
	  enumerable: true,
	  get: function get() {
	    return _brush.brushY;
	  }
	});
	Object.defineProperty(exports, "brushSelection", {
	  enumerable: true,
	  get: function get() {
	    return _brush.brushSelection;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.brushSelection = brushSelection;
	exports.brushX = brushX;
	exports.brushY = brushY;
	
	exports.default = function () {
	  return brush(XY);
	};
	
	var _d3Dispatch = __webpack_require__(34);
	
	var _d3Drag = __webpack_require__(89);
	
	var _d3Interpolate = __webpack_require__(14);
	
	var _d3Selection = __webpack_require__(8);
	
	var _d3Transition = __webpack_require__(121);
	
	var _constant = __webpack_require__(268);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _event = __webpack_require__(269);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _noevent = __webpack_require__(270);
	
	var _noevent2 = _interopRequireDefault(_noevent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MODE_DRAG = { name: "drag" },
	    MODE_SPACE = { name: "space" },
	    MODE_HANDLE = { name: "handle" },
	    MODE_CENTER = { name: "center" };
	
	var X = {
	  name: "x",
	  handles: ["e", "w"].map(type),
	  input: function input(x, e) {
	    return x && [[x[0], e[0][1]], [x[1], e[1][1]]];
	  },
	  output: function output(xy) {
	    return xy && [xy[0][0], xy[1][0]];
	  }
	};
	
	var Y = {
	  name: "y",
	  handles: ["n", "s"].map(type),
	  input: function input(y, e) {
	    return y && [[e[0][0], y[0]], [e[1][0], y[1]]];
	  },
	  output: function output(xy) {
	    return xy && [xy[0][1], xy[1][1]];
	  }
	};
	
	var XY = {
	  name: "xy",
	  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
	  input: function input(xy) {
	    return xy;
	  },
	  output: function output(xy) {
	    return xy;
	  }
	};
	
	var cursors = {
	  overlay: "crosshair",
	  selection: "move",
	  n: "ns-resize",
	  e: "ew-resize",
	  s: "ns-resize",
	  w: "ew-resize",
	  nw: "nwse-resize",
	  ne: "nesw-resize",
	  se: "nwse-resize",
	  sw: "nesw-resize"
	};
	
	var flipX = {
	  e: "w",
	  w: "e",
	  nw: "ne",
	  ne: "nw",
	  se: "sw",
	  sw: "se"
	};
	
	var flipY = {
	  n: "s",
	  s: "n",
	  nw: "sw",
	  ne: "se",
	  se: "ne",
	  sw: "nw"
	};
	
	var signsX = {
	  overlay: +1,
	  selection: +1,
	  n: null,
	  e: +1,
	  s: null,
	  w: -1,
	  nw: -1,
	  ne: +1,
	  se: +1,
	  sw: -1
	};
	
	var signsY = {
	  overlay: +1,
	  selection: +1,
	  n: -1,
	  e: null,
	  s: +1,
	  w: null,
	  nw: -1,
	  ne: -1,
	  se: +1,
	  sw: +1
	};
	
	function type(t) {
	  return { type: t };
	}
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !_d3Selection.event.button;
	}
	
	function defaultExtent() {
	  var svg = this.ownerSVGElement || this;
	  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
	}
	
	// Like d3.local, but with the name “__brush” rather than auto-generated.
	function local(node) {
	  while (!node.__brush) {
	    if (!(node = node.parentNode)) return;
	  }return node.__brush;
	}
	
	function empty(extent) {
	  return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
	}
	
	function brushSelection(node) {
	  var state = node.__brush;
	  return state ? state.dim.output(state.selection) : null;
	}
	
	function brushX() {
	  return brush(X);
	}
	
	function brushY() {
	  return brush(Y);
	}
	
	function brush(dim) {
	  var extent = defaultExtent,
	      filter = defaultFilter,
	      listeners = (0, _d3Dispatch.dispatch)(brush, "start", "brush", "end"),
	      handleSize = 6,
	      touchending;
	
	  function brush(group) {
	    var overlay = group.property("__brush", initialize).selectAll(".overlay").data([type("overlay")]);
	
	    overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function () {
	      var extent = local(this).extent;
	      (0, _d3Selection.select)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
	    });
	
	    group.selectAll(".selection").data([type("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
	
	    var handle = group.selectAll(".handle").data(dim.handles, function (d) {
	      return d.type;
	    });
	
	    handle.exit().remove();
	
	    handle.enter().append("rect").attr("class", function (d) {
	      return "handle handle--" + d.type;
	    }).attr("cursor", function (d) {
	      return cursors[d.type];
	    });
	
	    group.each(redraw).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", started);
	  }
	
	  brush.move = function (group, selection) {
	    if (group.selection) {
	      group.on("start.brush", function () {
	        emitter(this, arguments).beforestart().start();
	      }).on("interrupt.brush end.brush", function () {
	        emitter(this, arguments).end();
	      }).tween("brush", function () {
	        var that = this,
	            state = that.__brush,
	            emit = emitter(that, arguments),
	            selection0 = state.selection,
	            selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
	            i = (0, _d3Interpolate.interpolate)(selection0, selection1);
	
	        function tween(t) {
	          state.selection = t === 1 && empty(selection1) ? null : i(t);
	          redraw.call(that);
	          emit.brush();
	        }
	
	        return selection0 && selection1 ? tween : tween(1);
	      });
	    } else {
	      group.each(function () {
	        var that = this,
	            args = arguments,
	            state = that.__brush,
	            selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
	            emit = emitter(that, args).beforestart();
	
	        (0, _d3Transition.interrupt)(that);
	        state.selection = selection1 == null || empty(selection1) ? null : selection1;
	        redraw.call(that);
	        emit.start().brush().end();
	      });
	    }
	  };
	
	  function redraw() {
	    var group = (0, _d3Selection.select)(this),
	        selection = local(this).selection;
	
	    if (selection) {
	      group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
	
	      group.selectAll(".handle").style("display", null).attr("x", function (d) {
	        return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
	      }).attr("y", function (d) {
	        return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
	      }).attr("width", function (d) {
	        return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
	      }).attr("height", function (d) {
	        return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
	      });
	    } else {
	      group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
	    }
	  }
	
	  function emitter(that, args) {
	    return that.__brush.emitter || new Emitter(that, args);
	  }
	
	  function Emitter(that, args) {
	    this.that = that;
	    this.args = args;
	    this.state = that.__brush;
	    this.active = 0;
	  }
	
	  Emitter.prototype = {
	    beforestart: function beforestart() {
	      if (++this.active === 1) this.state.emitter = this, this.starting = true;
	      return this;
	    },
	    start: function start() {
	      if (this.starting) this.starting = false, this.emit("start");
	      return this;
	    },
	    brush: function brush() {
	      this.emit("brush");
	      return this;
	    },
	    end: function end() {
	      if (--this.active === 0) delete this.state.emitter, this.emit("end");
	      return this;
	    },
	    emit: function emit(type) {
	      (0, _d3Selection.customEvent)(new _event2.default(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function started() {
	    if (_d3Selection.event.touches) {
	      if (_d3Selection.event.changedTouches.length < _d3Selection.event.touches.length) return (0, _noevent2.default)();
	    } else if (touchending) return;
	    if (!filter.apply(this, arguments)) return;
	
	    var that = this,
	        type = _d3Selection.event.target.__data__.type,
	        mode = (_d3Selection.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : _d3Selection.event.altKey ? MODE_CENTER : MODE_HANDLE,
	        signX = dim === Y ? null : signsX[type],
	        signY = dim === X ? null : signsY[type],
	        state = local(that),
	        extent = state.extent,
	        selection = state.selection,
	        W = extent[0][0],
	        w0,
	        w1,
	        N = extent[0][1],
	        n0,
	        n1,
	        E = extent[1][0],
	        e0,
	        e1,
	        S = extent[1][1],
	        s0,
	        s1,
	        dx,
	        dy,
	        moving,
	        shifting = signX && signY && _d3Selection.event.shiftKey,
	        lockX,
	        lockY,
	        point0 = (0, _d3Selection.mouse)(that),
	        point = point0,
	        emit = emitter(that, arguments).beforestart();
	
	    if (type === "overlay") {
	      state.selection = selection = [[w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]], [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]];
	    } else {
	      w0 = selection[0][0];
	      n0 = selection[0][1];
	      e0 = selection[1][0];
	      s0 = selection[1][1];
	    }
	
	    w1 = w0;
	    n1 = n0;
	    e1 = e0;
	    s1 = s0;
	
	    var group = (0, _d3Selection.select)(that).attr("pointer-events", "none");
	
	    var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
	
	    if (_d3Selection.event.touches) {
	      group.on("touchmove.brush", moved, true).on("touchend.brush touchcancel.brush", ended, true);
	    } else {
	      var view = (0, _d3Selection.select)(_d3Selection.event.view).on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
	
	      (0, _d3Drag.dragDisable)(_d3Selection.event.view);
	    }
	
	    (0, _noevent.nopropagation)();
	    (0, _d3Transition.interrupt)(that);
	    redraw.call(that);
	    emit.start();
	
	    function moved() {
	      var point1 = (0, _d3Selection.mouse)(that);
	      if (shifting && !lockX && !lockY) {
	        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;else lockX = true;
	      }
	      point = point1;
	      moving = true;
	      (0, _noevent2.default)();
	      move();
	    }
	
	    function move() {
	      var t;
	
	      dx = point[0] - point0[0];
	      dy = point[1] - point0[1];
	
	      switch (mode) {
	        case MODE_SPACE:
	        case MODE_DRAG:
	          {
	            if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
	            if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
	            break;
	          }
	        case MODE_HANDLE:
	          {
	            if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
	            if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
	            break;
	          }
	        case MODE_CENTER:
	          {
	            if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
	            if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
	            break;
	          }
	      }
	
	      if (e1 < w1) {
	        signX *= -1;
	        t = w0, w0 = e0, e0 = t;
	        t = w1, w1 = e1, e1 = t;
	        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
	      }
	
	      if (s1 < n1) {
	        signY *= -1;
	        t = n0, n0 = s0, s0 = t;
	        t = n1, n1 = s1, s1 = t;
	        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
	      }
	
	      if (state.selection) selection = state.selection; // May be set by brush.move!
	      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
	      if (lockY) n1 = selection[0][1], s1 = selection[1][1];
	
	      if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
	        state.selection = [[w1, n1], [e1, s1]];
	        redraw.call(that);
	        emit.brush();
	      }
	    }
	
	    function ended() {
	      (0, _noevent.nopropagation)();
	      if (_d3Selection.event.touches) {
	        if (_d3Selection.event.touches.length) return;
	        if (touchending) clearTimeout(touchending);
	        touchending = setTimeout(function () {
	          touchending = null;
	        }, 500); // Ghost clicks are delayed!
	        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
	      } else {
	        (0, _d3Drag.dragEnable)(_d3Selection.event.view, moving);
	        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
	      }
	      group.attr("pointer-events", "all");
	      overlay.attr("cursor", cursors.overlay);
	      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
	      if (empty(selection)) state.selection = null, redraw.call(that);
	      emit.end();
	    }
	
	    function keydowned() {
	      switch (_d3Selection.event.keyCode) {
	        case 16:
	          {
	            // SHIFT
	            shifting = signX && signY;
	            break;
	          }
	        case 18:
	          {
	            // ALT
	            if (mode === MODE_HANDLE) {
	              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	              mode = MODE_CENTER;
	              move();
	            }
	            break;
	          }
	        case 32:
	          {
	            // SPACE; takes priority over ALT
	            if (mode === MODE_HANDLE || mode === MODE_CENTER) {
	              if (signX < 0) e0 = e1 - dx;else if (signX > 0) w0 = w1 - dx;
	              if (signY < 0) s0 = s1 - dy;else if (signY > 0) n0 = n1 - dy;
	              mode = MODE_SPACE;
	              overlay.attr("cursor", cursors.selection);
	              move();
	            }
	            break;
	          }
	        default:
	          return;
	      }
	      (0, _noevent2.default)();
	    }
	
	    function keyupped() {
	      switch (_d3Selection.event.keyCode) {
	        case 16:
	          {
	            // SHIFT
	            if (shifting) {
	              lockX = lockY = shifting = false;
	              move();
	            }
	            break;
	          }
	        case 18:
	          {
	            // ALT
	            if (mode === MODE_CENTER) {
	              if (signX < 0) e0 = e1;else if (signX > 0) w0 = w1;
	              if (signY < 0) s0 = s1;else if (signY > 0) n0 = n1;
	              mode = MODE_HANDLE;
	              move();
	            }
	            break;
	          }
	        case 32:
	          {
	            // SPACE
	            if (mode === MODE_SPACE) {
	              if (_d3Selection.event.altKey) {
	                if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	                if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	                mode = MODE_CENTER;
	              } else {
	                if (signX < 0) e0 = e1;else if (signX > 0) w0 = w1;
	                if (signY < 0) s0 = s1;else if (signY > 0) n0 = n1;
	                mode = MODE_HANDLE;
	              }
	              overlay.attr("cursor", cursors[type]);
	              move();
	            }
	            break;
	          }
	        default:
	          return;
	      }
	      (0, _noevent2.default)();
	    }
	  }
	
	  function initialize() {
	    var state = this.__brush || { selection: null };
	    state.extent = extent.apply(this, arguments);
	    state.dim = dim;
	    return state;
	  }
	
	  brush.extent = function (_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constant2.default)([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
	  };
	
	  brush.filter = function (_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constant2.default)(!!_), brush) : filter;
	  };
	
	  brush.handleSize = function (_) {
	    return arguments.length ? (handleSize = +_, brush) : handleSize;
	  };
	
	  brush.on = function () {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? brush : value;
	  };
	
	  return brush;
	}

/***/ },
/* 268 */
35,
/* 269 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target, type, selection) {
	  this.target = target;
	  this.type = type;
	  this.selection = selection;
	};

/***/ },
/* 270 */
149,
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chord = __webpack_require__(273);
	
	Object.defineProperty(exports, "chord", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_chord).default;
	  }
	});
	
	var _ribbon = __webpack_require__(275);
	
	Object.defineProperty(exports, "ribbon", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ribbon).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 272 */
195,
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = (0, _d3Array.range)(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1;while (++i < n) {
	      x = 0, j = -1;while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push((0, _d3Array.range)(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function (a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function (d, i) {
	      d.sort(function (a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = (0, _math.max)(0, _math.tau - padAngle * n) / k;
	    dx = k ? padAngle : _math.tau / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1;while (++i < n) {
	      x0 = x, j = -1;while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1;while (++i < n) {
	      j = i - 1;while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value ? { source: target, target: source } : { source: source, target: target });
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function (_) {
	    return arguments.length ? (padAngle = (0, _math.max)(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function (_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function (_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function (_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	};
	
	var _d3Array = __webpack_require__(9);
	
	var _math = __webpack_require__(143);
	
	function compareValue(compare) {
	  return function (a, b) {
	    return compare(a.source.value + a.target.value, b.source.value + b.target.value);
	  };
	}

/***/ },
/* 274 */
35,
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = _array.slice.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - _math.halfPi,
	        sa1 = endAngle.apply(this, argv) - _math.halfPi,
	        sx0 = sr * (0, _math.cos)(sa0),
	        sy0 = sr * (0, _math.sin)(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - _math.halfPi,
	        ta1 = endAngle.apply(this, argv) - _math.halfPi;
	
	    if (!context) context = buffer = (0, _d3Path.path)();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) {
	      // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * (0, _math.cos)(ta0), tr * (0, _math.sin)(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function (_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constant2.default)(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function (_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function (_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function (_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function (_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function (_) {
	    return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
	  };
	
	  return ribbon;
	};
	
	var _array = __webpack_require__(272);
	
	var _constant = __webpack_require__(274);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _math = __webpack_require__(143);
	
	var _d3Path = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}

/***/ },
/* 276 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (map) {
	  var entries = [];
	  for (var key in map) {
	    entries.push({ key: key, value: map[key] });
	  }return entries;
	};

/***/ },
/* 277 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (map) {
	  var keys = [];
	  for (var key in map) {
	    keys.push(key);
	  }return keys;
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var keys = [],
	      _sortKeys = [],
	      _sortValues,
	      _rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (_sortValues != null) array.sort(_sortValues);
	      return _rollup != null ? _rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = (0, _map2.default)(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function (values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function _entries(map, depth) {
	    if (++depth > keys.length) return map;
	    var array,
	        sortKey = _sortKeys[depth - 1];
	    if (_rollup != null && depth >= keys.length) array = map.entries();else array = [], map.each(function (v, k) {
	      array.push({ key: k, values: _entries(v, depth) });
	    });
	    return sortKey != null ? array.sort(function (a, b) {
	      return sortKey(a.key, b.key);
	    }) : array;
	  }
	
	  return nest = {
	    object: function object(array) {
	      return apply(array, 0, createObject, setObject);
	    },
	    map: function map(array) {
	      return apply(array, 0, createMap, setMap);
	    },
	    entries: function entries(array) {
	      return _entries(apply(array, 0, createMap, setMap), 0);
	    },
	    key: function key(d) {
	      keys.push(d);return nest;
	    },
	    sortKeys: function sortKeys(order) {
	      _sortKeys[keys.length - 1] = order;return nest;
	    },
	    sortValues: function sortValues(order) {
	      _sortValues = order;return nest;
	    },
	    rollup: function rollup(f) {
	      _rollup = f;return nest;
	    }
	  };
	};
	
	var _map = __webpack_require__(86);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return (0, _map2.default)();
	}
	
	function setMap(map, key, value) {
	  map.set(key, value);
	}

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(86);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Set() {}
	
	var proto = _map2.default.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function add(value) {
	    value += "";
	    this[_map.prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set();
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function (value) {
	    set.add(value);
	  });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	      var i = -1,
	          n = object.length;
	      if (f == null) while (++i < n) {
	        set.add(object[i]);
	      } else while (++i < n) {
	        set.add(f(object[i], i, object));
	      }
	    }
	
	  return set;
	}
	
	exports.default = set;

/***/ },
/* 280 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (map) {
	  var values = [];
	  for (var key in map) {
	    values.push(map[key]);
	  }return values;
	};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cubehelix;
	exports.Cubehelix = Cubehelix;
	
	var _define = __webpack_require__(88);
	
	var _define2 = _interopRequireDefault(_define);
	
	var _color = __webpack_require__(87);
	
	var _math = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
	      // NaN if l=0 or l=1
	  h = s ? Math.atan2(k, bl) * _math.rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	(0, _define2.default)(Cubehelix, cubehelix, (0, _define.extend)(_color.Color, {
	  brighter: function brighter(k) {
	    k = k == null ? _color.brighter : Math.pow(_color.brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function darker(k) {
	    k = k == null ? _color.darker : Math.pow(_color.darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function rgb() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * _math.deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new _color.Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
	  }
	}));

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gray = gray;
	exports.default = lab;
	exports.Lab = Lab;
	exports.lch = lch;
	exports.hcl = hcl;
	exports.Hcl = Hcl;
	
	var _define = __webpack_require__(88);
	
	var _define2 = _interopRequireDefault(_define);
	
	var _color = __webpack_require__(87);
	
	var _math = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * _math.deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
	      x,
	      z;
	  if (r === g && g === b) x = z = y;else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	(0, _define2.default)(Lab, lab, (0, _define.extend)(_color.Color, {
	  brighter: function brighter(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function darker(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function rgb() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new _color.Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * _math.rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	(0, _define2.default)(Hcl, hcl, (0, _define.extend)(_color.Color, {
	  brighter: function brighter(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function darker(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function rgb() {
	    return labConvert(this).rgb();
	  }
	}));

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contours = __webpack_require__(147);
	
	Object.defineProperty(exports, "contours", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_contours).default;
	  }
	});
	
	var _density = __webpack_require__(288);
	
	Object.defineProperty(exports, "contourDensity", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_density).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 284 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (ring) {
	  var i = 0,
	      n = ring.length,
	      area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
	  while (++i < n) {
	    area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
	  }return area;
	};

/***/ },
/* 285 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  return a - b;
	};

/***/ },
/* 286 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.blurX = blurX;
	exports.blurY = blurY;
	// TODO Optimize edge cases.
	// TODO Optimize index calculation.
	// TODO Optimize arguments.
	function blurX(source, target, r) {
	  var n = source.width,
	      m = source.height,
	      w = (r << 1) + 1;
	  for (var j = 0; j < m; ++j) {
	    for (var i = 0, sr = 0; i < n + r; ++i) {
	      if (i < n) {
	        sr += source.data[i + j * n];
	      }
	      if (i >= r) {
	        if (i >= w) {
	          sr -= source.data[i - w + j * n];
	        }
	        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
	      }
	    }
	  }
	}
	
	// TODO Optimize edge cases.
	// TODO Optimize index calculation.
	// TODO Optimize arguments.
	function blurY(source, target, r) {
	  var n = source.width,
	      m = source.height,
	      w = (r << 1) + 1;
	  for (var i = 0; i < n; ++i) {
	    for (var j = 0, sr = 0; j < m + r; ++j) {
	      if (j < m) {
	        sr += source.data[i + j * n];
	      }
	      if (j >= r) {
	        if (j >= w) {
	          sr -= source.data[i + (j - w) * n];
	        }
	        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
	      }
	    }
	  }
	}

/***/ },
/* 287 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (ring, hole) {
	  var i = -1,
	      n = hole.length,
	      c;
	  while (++i < n) {
	    if (c = ringContains(ring, hole[i])) return c;
	  }return 0;
	};
	
	function ringContains(ring, point) {
	  var x = point[0],
	      y = point[1],
	      contains = -1;
	  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
	    var pi = ring[i],
	        xi = pi[0],
	        yi = pi[1],
	        pj = ring[j],
	        xj = pj[0],
	        yj = pj[1];
	    if (segmentContains(pi, pj, point)) return 0;
	    if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
	  }
	  return contains;
	}
	
	function segmentContains(a, b, c) {
	  var i;return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
	}
	
	function collinear(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
	}
	
	function within(p, q, r) {
	  return p <= q && q <= r || r <= q && q <= p;
	}

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var x = defaultX,
	      y = defaultY,
	      dx = 960,
	      dy = 500,
	      r = 20,
	      // blur radius
	  k = 2,
	      // log2(grid cell size)
	  o = r * 3,
	      // grid offset, to pad for blur
	  n = dx + o * 2 >> k,
	      // grid width
	  m = dy + o * 2 >> k,
	      // grid height
	  threshold = (0, _constant2.default)(20);
	
	  function density(data) {
	    var values0 = new Float32Array(n * m),
	        values1 = new Float32Array(n * m);
	
	    data.forEach(function (d, i, data) {
	      var xi = x(d, i, data) + o >> k,
	          yi = y(d, i, data) + o >> k;
	      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
	        ++values0[xi + yi * n];
	      }
	    });
	
	    // TODO Optimize.
	    (0, _blur.blurX)({ width: n, height: m, data: values0 }, { width: n, height: m, data: values1 }, r >> k);
	    (0, _blur.blurY)({ width: n, height: m, data: values1 }, { width: n, height: m, data: values0 }, r >> k);
	    (0, _blur.blurX)({ width: n, height: m, data: values0 }, { width: n, height: m, data: values1 }, r >> k);
	    (0, _blur.blurY)({ width: n, height: m, data: values1 }, { width: n, height: m, data: values0 }, r >> k);
	    (0, _blur.blurX)({ width: n, height: m, data: values0 }, { width: n, height: m, data: values1 }, r >> k);
	    (0, _blur.blurY)({ width: n, height: m, data: values1 }, { width: n, height: m, data: values0 }, r >> k);
	
	    var tz = threshold(values0);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      var stop = (0, _d3Array.max)(values0);
	      tz = (0, _d3Array.tickStep)(0, stop, tz);
	      tz = (0, _d3Array.range)(0, Math.floor(stop / tz) * tz, tz);
	      tz.shift();
	    }
	
	    return (0, _contours2.default)().thresholds(tz).size([n, m])(values0).map(transform);
	  }
	
	  function transform(geometry) {
	    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
	    geometry.coordinates.forEach(transformPolygon);
	    return geometry;
	  }
	
	  function transformPolygon(coordinates) {
	    coordinates.forEach(transformRing);
	  }
	
	  function transformRing(coordinates) {
	    coordinates.forEach(transformPoint);
	  }
	
	  // TODO Optimize.
	  function transformPoint(coordinates) {
	    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
	    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
	  }
	
	  function resize() {
	    o = r * 3;
	    n = dx + o * 2 >> k;
	    m = dy + o * 2 >> k;
	    return density;
	  }
	
	  density.x = function (_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant2.default)(+_), density) : x;
	  };
	
	  density.y = function (_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant2.default)(+_), density) : y;
	  };
	
	  density.size = function (_) {
	    if (!arguments.length) return [dx, dy];
	    var _0 = Math.ceil(_[0]),
	        _1 = Math.ceil(_[1]);
	    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
	    return dx = _0, dy = _1, resize();
	  };
	
	  density.cellSize = function (_) {
	    if (!arguments.length) return 1 << k;
	    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
	    return k = Math.floor(Math.log(_) / Math.LN2), resize();
	  };
	
	  density.thresholds = function (_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant2.default)(_array.slice.call(_)) : (0, _constant2.default)(_), density) : threshold;
	  };
	
	  density.bandwidth = function (_) {
	    if (!arguments.length) return Math.sqrt(r * (r + 1));
	    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
	    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
	  };
	
	  return density;
	};
	
	var _d3Array = __webpack_require__(9);
	
	var _array = __webpack_require__(145);
	
	var _blur = __webpack_require__(286);
	
	var _constant = __webpack_require__(146);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _contours = __webpack_require__(147);
	
	var _contours2 = _interopRequireDefault(_contours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultX(d) {
	  return d[0];
	}
	
	function defaultY(d) {
	  return d[1];
	}

/***/ },
/* 289 */
72,
/* 290 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var noop = { value: function value() {} };
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || t in _) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function (t) {
	    var name = "",
	        i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return { type: t, name: name };
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function on(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) {
	        if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      }return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);else if (callback == null) for (t in _) {
	        _[t] = set(_[t], typename.name, null);
	      }
	    }
	
	    return this;
	  },
	  copy: function copy() {
	    var copy = {},
	        _ = this._;
	    for (var t in _) {
	      copy[t] = _[t].slice();
	    }return new Dispatch(copy);
	  },
	  call: function call(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) {
	      args[i] = arguments[i + 2];
	    }if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) {
	      t[i].value.apply(that, args);
	    }
	  },
	  apply: function apply(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) {
	      t[i].value.apply(that, args);
	    }
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({ name: name, value: callback });
	  return type;
	}
	
	exports.default = dispatch;

/***/ },
/* 291 */
35,
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var filter = defaultFilter,
	      container = defaultContainer,
	      subject = defaultSubject,
	      touchable = defaultTouchable,
	      gestures = {},
	      listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"),
	      active = 0,
	      mousedownx,
	      mousedowny,
	      mousemoving,
	      touchending,
	      clickDistance2 = 0;
	
	  function drag(selection) {
	    selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var gesture = beforestart("mouse", container.apply(this, arguments), _d3Selection.mouse, this, arguments);
	    if (!gesture) return;
	    (0, _d3Selection.select)(_d3Selection.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
	    (0, _nodrag2.default)(_d3Selection.event.view);
	    (0, _noevent.nopropagation)();
	    mousemoving = false;
	    mousedownx = _d3Selection.event.clientX;
	    mousedowny = _d3Selection.event.clientY;
	    gesture("start");
	  }
	
	  function mousemoved() {
	    (0, _noevent2.default)();
	    if (!mousemoving) {
	      var dx = _d3Selection.event.clientX - mousedownx,
	          dy = _d3Selection.event.clientY - mousedowny;
	      mousemoving = dx * dx + dy * dy > clickDistance2;
	    }
	    gestures.mouse("drag");
	  }
	
	  function mouseupped() {
	    (0, _d3Selection.select)(_d3Selection.event.view).on("mousemove.drag mouseup.drag", null);
	    (0, _nodrag.yesdrag)(_d3Selection.event.view, mousemoving);
	    (0, _noevent2.default)();
	    gestures.mouse("end");
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var touches = _d3Selection.event.changedTouches,
	        c = container.apply(this, arguments),
	        n = touches.length,
	        i,
	        gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = beforestart(touches[i].identifier, c, _d3Selection.touch, this, arguments)) {
	        (0, _noevent.nopropagation)();
	        gesture("start");
	      }
	    }
	  }
	
	  function touchmoved() {
	    var touches = _d3Selection.event.changedTouches,
	        n = touches.length,
	        i,
	        gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches[i].identifier]) {
	        (0, _noevent2.default)();
	        gesture("drag");
	      }
	    }
	  }
	
	  function touchended() {
	    var touches = _d3Selection.event.changedTouches,
	        n = touches.length,
	        i,
	        gesture;
	
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function () {
	      touchending = null;
	    }, 500); // Ghost clicks are delayed!
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches[i].identifier]) {
	        (0, _noevent.nopropagation)();
	        gesture("end");
	      }
	    }
	  }
	
	  function beforestart(id, container, point, that, args) {
	    var p = point(container, id),
	        s,
	        dx,
	        dy,
	        sublisteners = listeners.copy();
	
	    if (!(0, _d3Selection.customEvent)(new _event2.default(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function () {
	      if ((_d3Selection.event.subject = s = subject.apply(that, args)) == null) return false;
	      dx = s.x - p[0] || 0;
	      dy = s.y - p[1] || 0;
	      return true;
	    })) return;
	
	    return function gesture(type) {
	      var p0 = p,
	          n;
	      switch (type) {
	        case "start":
	          gestures[id] = gesture, n = active++;break;
	        case "end":
	          delete gestures[id], --active; // nobreak
	        case "drag":
	          p = point(container, id), n = active;break;
	      }
	      (0, _d3Selection.customEvent)(new _event2.default(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
	    };
	  }
	
	  drag.filter = function (_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constant2.default)(!!_), drag) : filter;
	  };
	
	  drag.container = function (_) {
	    return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constant2.default)(_), drag) : container;
	  };
	
	  drag.subject = function (_) {
	    return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constant2.default)(_), drag) : subject;
	  };
	
	  drag.touchable = function (_) {
	    return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constant2.default)(!!_), drag) : touchable;
	  };
	
	  drag.on = function () {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? drag : value;
	  };
	
	  drag.clickDistance = function (_) {
	    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
	  };
	
	  return drag;
	};
	
	var _d3Dispatch = __webpack_require__(34);
	
	var _d3Selection = __webpack_require__(8);
	
	var _nodrag = __webpack_require__(148);
	
	var _nodrag2 = _interopRequireDefault(_nodrag);
	
	var _noevent = __webpack_require__(149);
	
	var _noevent2 = _interopRequireDefault(_noevent);
	
	var _constant = __webpack_require__(291);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _event = __webpack_require__(293);
	
	var _event2 = _interopRequireDefault(_event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !_d3Selection.event.button;
	}
	
	function defaultContainer() {
	  return this.parentNode;
	}
	
	function defaultSubject(d) {
	  return d == null ? { x: _d3Selection.event.x, y: _d3Selection.event.y } : d;
	}
	
	function defaultTouchable() {
	  return "ontouchstart" in this;
	}

/***/ },
/* 293 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DragEvent;
	function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
	  this.target = target;
	  this.type = type;
	  this.subject = subject;
	  this.identifier = id;
	  this.active = active;
	  this.x = x;
	  this.y = y;
	  this.dx = dx;
	  this.dy = dy;
	  this._ = dispatch;
	}
	
	DragEvent.prototype.on = function () {
	  var value = this._.on.apply(this._, arguments);
	  return value === this._ ? this : value;
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.csvFormatRows = exports.csvFormat = exports.csvParseRows = exports.csvParse = undefined;
	
	var _dsv = __webpack_require__(90);
	
	var _dsv2 = _interopRequireDefault(_dsv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var csv = (0, _dsv2.default)(",");
	
	var csvParse = exports.csvParse = csv.parse;
	var csvParseRows = exports.csvParseRows = csv.parseRows;
	var csvFormat = exports.csvFormat = csv.format;
	var csvFormatRows = exports.csvFormatRows = csv.formatRows;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tsvFormatRows = exports.tsvFormat = exports.tsvParseRows = exports.tsvParse = undefined;
	
	var _dsv = __webpack_require__(90);
	
	var _dsv2 = _interopRequireDefault(_dsv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tsv = (0, _dsv2.default)("\t");
	
	var tsvParse = exports.tsvParse = tsv.parse;
	var tsvParseRows = exports.tsvParseRows = tsv.parseRows;
	var tsvFormat = exports.tsvFormat = tsv.format;
	var tsvFormatRows = exports.tsvFormatRows = tsv.formatRows;

/***/ },
/* 296 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var overshoot = 1.70158;
	
	var backIn = exports.backIn = function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	}(overshoot);
	
	var backOut = exports.backOut = function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	}(overshoot);
	
	var backInOut = exports.backInOut = function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	}(overshoot);

/***/ },
/* 297 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bounceIn = bounceIn;
	exports.bounceOut = bounceOut;
	exports.bounceInOut = bounceInOut;
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}

/***/ },
/* 298 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.circleIn = circleIn;
	exports.circleOut = circleOut;
	exports.circleInOut = circleInOut;
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}

/***/ },
/* 299 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cubicIn = cubicIn;
	exports.cubicOut = cubicOut;
	exports.cubicInOut = cubicInOut;
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}

/***/ },
/* 300 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = exports.elasticIn = function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function (a) {
	    return custom(a, p * tau);
	  };
	  elasticIn.period = function (p) {
	    return custom(a, p);
	  };
	
	  return elasticIn;
	}(amplitude, period);
	
	var elasticOut = exports.elasticOut = function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function (a) {
	    return custom(a, p * tau);
	  };
	  elasticOut.period = function (p) {
	    return custom(a, p);
	  };
	
	  return elasticOut;
	}(amplitude, period);
	
	var elasticInOut = exports.elasticInOut = function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0 ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p) : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function (a) {
	    return custom(a, p * tau);
	  };
	  elasticInOut.period = function (p) {
	    return custom(a, p);
	  };
	
	  return elasticInOut;
	}(amplitude, period);

/***/ },
/* 301 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.expIn = expIn;
	exports.expOut = expOut;
	exports.expInOut = expInOut;
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}

/***/ },
/* 302 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linear = linear;
	function linear(t) {
	  return +t;
	}

/***/ },
/* 303 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var exponent = 3;
	
	var polyIn = exports.polyIn = function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	}(exponent);
	
	var polyOut = exports.polyOut = function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	}(exponent);
	
	var polyInOut = exports.polyInOut = function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	}(exponent);

/***/ },
/* 304 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.quadIn = quadIn;
	exports.quadOut = quadOut;
	exports.quadInOut = quadInOut;
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}

/***/ },
/* 305 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sinIn = sinIn;
	exports.sinOut = sinOut;
	exports.sinInOut = sinInOut;
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _blob = __webpack_require__(307);
	
	Object.defineProperty(exports, "blob", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blob).default;
	  }
	});
	
	var _buffer = __webpack_require__(308);
	
	Object.defineProperty(exports, "buffer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buffer).default;
	  }
	});
	
	var _dsv = __webpack_require__(309);
	
	Object.defineProperty(exports, "dsv", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dsv).default;
	  }
	});
	Object.defineProperty(exports, "csv", {
	  enumerable: true,
	  get: function get() {
	    return _dsv.csv;
	  }
	});
	Object.defineProperty(exports, "tsv", {
	  enumerable: true,
	  get: function get() {
	    return _dsv.tsv;
	  }
	});
	
	var _image = __webpack_require__(310);
	
	Object.defineProperty(exports, "image", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_image).default;
	  }
	});
	
	var _json = __webpack_require__(311);
	
	Object.defineProperty(exports, "json", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_json).default;
	  }
	});
	
	var _text = __webpack_require__(91);
	
	Object.defineProperty(exports, "text", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text).default;
	  }
	});
	
	var _xml = __webpack_require__(312);
	
	Object.defineProperty(exports, "xml", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_xml).default;
	  }
	});
	Object.defineProperty(exports, "html", {
	  enumerable: true,
	  get: function get() {
	    return _xml.html;
	  }
	});
	Object.defineProperty(exports, "svg", {
	  enumerable: true,
	  get: function get() {
	    return _xml.svg;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 307 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input, init) {
	  return fetch(input, init).then(responseBlob);
	};
	
	function responseBlob(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.blob();
	}

/***/ },
/* 308 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input, init) {
	  return fetch(input, init).then(responseArrayBuffer);
	};
	
	function responseArrayBuffer(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.arrayBuffer();
	}

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tsv = exports.csv = undefined;
	exports.default = dsv;
	
	var _d3Dsv = __webpack_require__(150);
	
	var _text = __webpack_require__(91);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dsvParse(parse) {
	  return function (input, init, row) {
	    if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
	    return (0, _text2.default)(input, init).then(function (response) {
	      return parse(response, row);
	    });
	  };
	}
	
	function dsv(delimiter, input, init, row) {
	  if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
	  var format = (0, _d3Dsv.dsvFormat)(delimiter);
	  return (0, _text2.default)(input, init).then(function (response) {
	    return format.parse(response, row);
	  });
	}
	
	var csv = exports.csv = dsvParse(_d3Dsv.csvParse);
	var tsv = exports.tsv = dsvParse(_d3Dsv.tsvParse);

/***/ },
/* 310 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input, init) {
	  return new Promise(function (resolve, reject) {
	    var image = new Image();
	    for (var key in init) {
	      image[key] = init[key];
	    }image.onerror = reject;
	    image.onload = function () {
	      resolve(image);
	    };
	    image.src = input;
	  });
	};

/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input, init) {
	  return fetch(input, init).then(responseJson);
	};
	
	function responseJson(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.json();
	}

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.svg = exports.html = undefined;
	
	var _text = __webpack_require__(91);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parser(type) {
	  return function (input, init) {
	    return (0, _text2.default)(input, init).then(function (text) {
	      return new DOMParser().parseFromString(text, type);
	    });
	  };
	}
	
	exports.default = parser("application/xml");
	var html = exports.html = parser("text/html");
	
	var svg = exports.svg = parser("image/svg+xml");

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _center = __webpack_require__(314);
	
	Object.defineProperty(exports, "forceCenter", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_center).default;
	  }
	});
	
	var _collide = __webpack_require__(315);
	
	Object.defineProperty(exports, "forceCollide", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_collide).default;
	  }
	});
	
	var _link = __webpack_require__(316);
	
	Object.defineProperty(exports, "forceLink", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_link).default;
	  }
	});
	
	var _manyBody = __webpack_require__(317);
	
	Object.defineProperty(exports, "forceManyBody", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_manyBody).default;
	  }
	});
	
	var _radial = __webpack_require__(318);
	
	Object.defineProperty(exports, "forceRadial", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_radial).default;
	  }
	});
	
	var _simulation = __webpack_require__(152);
	
	Object.defineProperty(exports, "forceSimulation", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_simulation).default;
	  }
	});
	
	var _x = __webpack_require__(319);
	
	Object.defineProperty(exports, "forceX", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_x).default;
	  }
	});
	
	var _y = __webpack_require__(320);
	
	Object.defineProperty(exports, "forceY", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_y).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 314 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function (_) {
	    nodes = _;
	  };
	
	  force.x = function (_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function (_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = (0, _constant2.default)(radius == null ? 1 : +radius);
	
	  function force() {
	    var i,
	        n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[node.index], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data,
	          rj = quad.r,
	          r = ri + rj;
	      if (data) {
	        if (data.index > node.index) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = (0, _jiggle2.default)(), l += x * x;
	            if (y === 0) y = (0, _jiggle2.default)(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i,
	        n = nodes.length,
	        node;
	    radii = new Array(n);
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	    }
	  }
	
	  force.initialize = function (_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.iterations = function (_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function (_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function (_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : radius;
	  };
	
	  return force;
	};
	
	var _constant = __webpack_require__(35);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _jiggle = __webpack_require__(92);
	
	var _jiggle2 = _interopRequireDefault(_jiggle);
	
	var _d3Quadtree = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function x(d) {
	  return d.x + d.vx;
	}
	
	function y(d) {
	  return d.y + d.vy;
	}

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (links) {
	  var id = index,
	      strength = defaultStrength,
	      strengths,
	      distance = (0, _constant2.default)(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || (0, _jiggle2.default)();
	        y = target.y + target.vy - source.y - source.vy || (0, _jiggle2.default)();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = (0, _d3Collection.map)(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < m; ++i) {
	      link = links[i], link.index = i;
	      if (_typeof(link.source) !== "object") link.source = find(nodeById, link.source);
	      if (_typeof(link.target) !== "object") link.target = find(nodeById, link.target);
	      count[link.source.index] = (count[link.source.index] || 0) + 1;
	      count[link.target.index] = (count[link.target.index] || 0) + 1;
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function (_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function (_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function (_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function (_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function (_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function (_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	};
	
	var _constant = __webpack_require__(35);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _jiggle = __webpack_require__(92);
	
	var _jiggle2 = _interopRequireDefault(_jiggle);
	
	var _d3Collection = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function index(d) {
	  return d.index;
	}
	
	function find(nodeById, nodeId) {
	  var node = nodeById.get(nodeId);
	  if (!node) throw new Error("missing: " + nodeId);
	  return node;
	}

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var nodes,
	      node,
	      alpha,
	      strength = (0, _constant2.default)(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i,
	        n = nodes.length,
	        tree = (0, _d3Quadtree.quadtree)(nodes, _simulation.x, _simulation.y).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) {
	      node = nodes[i], tree.visit(apply);
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i,
	        n = nodes.length,
	        node;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
	    }
	  }
	
	  function accumulate(quad) {
	    var strength = 0,
	        q,
	        c,
	        weight = 0,
	        x,
	        y,
	        i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x = y = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = Math.abs(q.value))) {
	          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
	        }
	      }
	      quad.x = x / weight;
	      quad.y = y / weight;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	        q = quad;
	        q.x = q.data.x;
	        q.y = q.data.y;
	        do {
	          strength += strengths[q.data.index];
	        } while (q = q.next);
	      }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x = quad.x - node.x,
	        y = quad.y - node.y,
	        w = x2 - x1,
	        l = x * x + y * y;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x === 0) x = (0, _jiggle2.default)(), l += x * x;
	        if (y === 0) y = (0, _jiggle2.default)(), l += y * y;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x * quad.value * alpha / l;
	        node.vy += y * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x === 0) x = (0, _jiggle2.default)(), l += x * x;
	      if (y === 0) y = (0, _jiggle2.default)(), l += y * y;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do {
	      if (quad.data !== node) {
	        w = strengths[quad.data.index] * alpha / l;
	        node.vx += x * w;
	        node.vy += y * w;
	      }
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function (_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function (_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function (_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function (_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function (_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	};
	
	var _constant = __webpack_require__(35);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _jiggle = __webpack_require__(92);
	
	var _jiggle2 = _interopRequireDefault(_jiggle);
	
	var _d3Quadtree = __webpack_require__(105);
	
	var _simulation = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (radius, x, y) {
	  var nodes,
	      strength = (0, _constant2.default)(0.1),
	      strengths,
	      radiuses;
	
	  if (typeof radius !== "function") radius = (0, _constant2.default)(+radius);
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length; i < n; ++i) {
	      var node = nodes[i],
	          dx = node.x - x || 1e-6,
	          dy = node.y - y || 1e-6,
	          r = Math.sqrt(dx * dx + dy * dy),
	          k = (radiuses[i] - r) * strengths[i] * alpha / r;
	      node.vx += dx * k;
	      node.vy += dy * k;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i,
	        n = nodes.length;
	    strengths = new Array(n);
	    radiuses = new Array(n);
	    for (i = 0; i < n; ++i) {
	      radiuses[i] = +radius(nodes[i], i, nodes);
	      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function (_) {
	    nodes = _, initialize();
	  };
	
	  force.strength = function (_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : strength;
	  };
	
	  force.radius = function (_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : radius;
	  };
	
	  force.x = function (_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function (_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var _constant = __webpack_require__(35);
	
	var _constant2 = _interopRequireDefault(_constant);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x) {
	  var strength = (0, _constant2.default)(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = (0, _constant2.default)(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i,
	        n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function (_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function (_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : strength;
	  };
	
	  force.x = function (_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : x;
	  };
	
	  return force;
	};
	
	var _constant = __webpack_require__(35);
	
	var _constant2 = _interopRequireDefault(_constant);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (y) {
	  var strength = (0, _constant2.default)(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = (0, _constant2.default)(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i,
	        n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function (_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function (_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : strength;
	  };
	
	  force.y = function (_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant2.default)(+_), initialize(), force) : y;
	  };
	
	  return force;
	};
	
	var _constant = __webpack_require__(35);
	
	var _constant2 = _interopRequireDefault(_constant);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatPrefix = exports.format = undefined;
	exports.default = defaultLocale;
	
	var _locale = __webpack_require__(155);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locale;
	var format = exports.format = undefined;
	var formatPrefix = exports.formatPrefix = undefined;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = (0, _locale2.default)(definition);
	  exports.format = format = locale.format;
	  exports.formatPrefix = formatPrefix = locale.formatPrefix;
	  return locale;
	}

/***/ },
/* 322 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (grouping, thousands) {
	  return function (value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};

/***/ },
/* 323 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (numerals) {
	  return function (value) {
	    return value.replace(/[0-9]/g, function (i) {
	      return numerals[+i];
	    });
	  };
	};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (x, p) {
	    var d = (0, _formatDecimal2.default)(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1];
	    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var _formatDecimal = __webpack_require__(94);
	
	var _formatDecimal2 = _interopRequireDefault(_formatDecimal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 325 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".":
	        i0 = i1 = i;break;
	      case "0":
	        if (i0 === 0) i0 = i;i1 = i;break;
	      default:
	        if (i0 > 0) {
	          if (!+s[i]) break out;i0 = 0;
	        }break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formatPrefixAuto = __webpack_require__(153);
	
	var _formatPrefixAuto2 = _interopRequireDefault(_formatPrefixAuto);
	
	var _formatRounded = __webpack_require__(324);
	
	var _formatRounded2 = _interopRequireDefault(_formatRounded);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  "%": function _(x, p) {
	    return (x * 100).toFixed(p);
	  },
	  "b": function b(x) {
	    return Math.round(x).toString(2);
	  },
	  "c": function c(x) {
	    return x + "";
	  },
	  "d": function d(x) {
	    return Math.round(x).toString(10);
	  },
	  "e": function e(x, p) {
	    return x.toExponential(p);
	  },
	  "f": function f(x, p) {
	    return x.toFixed(p);
	  },
	  "g": function g(x, p) {
	    return x.toPrecision(p);
	  },
	  "o": function o(x) {
	    return Math.round(x).toString(8);
	  },
	  "p": function p(x, _p) {
	    return (0, _formatRounded2.default)(x * 100, _p);
	  },
	  "r": _formatRounded2.default,
	  "s": _formatPrefixAuto2.default,
	  "X": function X(x) {
	    return Math.round(x).toString(16).toUpperCase();
	  },
	  "x": function x(_x) {
	    return Math.round(_x).toString(16);
	  }
	};

/***/ },
/* 327 */
95,
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (step) {
	  return Math.max(0, -(0, _exponent2.default)(Math.abs(step)));
	};
	
	var _exponent = __webpack_require__(60);
	
	var _exponent2 = _interopRequireDefault(_exponent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent2.default)(value) / 3))) * 3 - (0, _exponent2.default)(Math.abs(step)));
	};
	
	var _exponent = __webpack_require__(60);
	
	var _exponent2 = _interopRequireDefault(_exponent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, (0, _exponent2.default)(max) - (0, _exponent2.default)(step)) + 1;
	};
	
	var _exponent = __webpack_require__(60);
	
	var _exponent2 = _interopRequireDefault(_exponent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _area = __webpack_require__(156);
	
	Object.defineProperty(exports, "geoArea", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_area).default;
	  }
	});
	
	var _bounds = __webpack_require__(332);
	
	Object.defineProperty(exports, "geoBounds", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bounds).default;
	  }
	});
	
	var _centroid = __webpack_require__(333);
	
	Object.defineProperty(exports, "geoCentroid", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_centroid).default;
	  }
	});
	
	var _circle = __webpack_require__(157);
	
	Object.defineProperty(exports, "geoCircle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_circle).default;
	  }
	});
	
	var _antimeridian = __webpack_require__(158);
	
	Object.defineProperty(exports, "geoClipAntimeridian", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_antimeridian).default;
	  }
	});
	
	var _circle2 = __webpack_require__(160);
	
	Object.defineProperty(exports, "geoClipCircle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_circle2).default;
	  }
	});
	
	var _extent = __webpack_require__(334);
	
	Object.defineProperty(exports, "geoClipExtent", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_extent).default;
	  }
	});
	
	var _rectangle = __webpack_require__(61);
	
	Object.defineProperty(exports, "geoClipRectangle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_rectangle).default;
	  }
	});
	
	var _contains = __webpack_require__(337);
	
	Object.defineProperty(exports, "geoContains", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_contains).default;
	  }
	});
	
	var _distance = __webpack_require__(164);
	
	Object.defineProperty(exports, "geoDistance", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_distance).default;
	  }
	});
	
	var _graticule = __webpack_require__(338);
	
	Object.defineProperty(exports, "geoGraticule", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_graticule).default;
	  }
	});
	Object.defineProperty(exports, "geoGraticule10", {
	  enumerable: true,
	  get: function get() {
	    return _graticule.graticule10;
	  }
	});
	
	var _interpolate = __webpack_require__(339);
	
	Object.defineProperty(exports, "geoInterpolate", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_interpolate).default;
	  }
	});
	
	var _length = __webpack_require__(165);
	
	Object.defineProperty(exports, "geoLength", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_length).default;
	  }
	});
	
	var _index = __webpack_require__(343);
	
	Object.defineProperty(exports, "geoPath", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index).default;
	  }
	});
	
	var _albers = __webpack_require__(169);
	
	Object.defineProperty(exports, "geoAlbers", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_albers).default;
	  }
	});
	
	var _albersUsa = __webpack_require__(346);
	
	Object.defineProperty(exports, "geoAlbersUsa", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_albersUsa).default;
	  }
	});
	
	var _azimuthalEqualArea = __webpack_require__(347);
	
	Object.defineProperty(exports, "geoAzimuthalEqualArea", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_azimuthalEqualArea).default;
	  }
	});
	Object.defineProperty(exports, "geoAzimuthalEqualAreaRaw", {
	  enumerable: true,
	  get: function get() {
	    return _azimuthalEqualArea.azimuthalEqualAreaRaw;
	  }
	});
	
	var _azimuthalEquidistant = __webpack_require__(348);
	
	Object.defineProperty(exports, "geoAzimuthalEquidistant", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_azimuthalEquidistant).default;
	  }
	});
	Object.defineProperty(exports, "geoAzimuthalEquidistantRaw", {
	  enumerable: true,
	  get: function get() {
	    return _azimuthalEquidistant.azimuthalEquidistantRaw;
	  }
	});
	
	var _conicConformal = __webpack_require__(349);
	
	Object.defineProperty(exports, "geoConicConformal", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_conicConformal).default;
	  }
	});
	Object.defineProperty(exports, "geoConicConformalRaw", {
	  enumerable: true,
	  get: function get() {
	    return _conicConformal.conicConformalRaw;
	  }
	});
	
	var _conicEqualArea = __webpack_require__(97);
	
	Object.defineProperty(exports, "geoConicEqualArea", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_conicEqualArea).default;
	  }
	});
	Object.defineProperty(exports, "geoConicEqualAreaRaw", {
	  enumerable: true,
	  get: function get() {
	    return _conicEqualArea.conicEqualAreaRaw;
	  }
	});
	
	var _conicEquidistant = __webpack_require__(350);
	
	Object.defineProperty(exports, "geoConicEquidistant", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_conicEquidistant).default;
	  }
	});
	Object.defineProperty(exports, "geoConicEquidistantRaw", {
	  enumerable: true,
	  get: function get() {
	    return _conicEquidistant.conicEquidistantRaw;
	  }
	});
	
	var _equirectangular = __webpack_require__(170);
	
	Object.defineProperty(exports, "geoEquirectangular", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_equirectangular).default;
	  }
	});
	Object.defineProperty(exports, "geoEquirectangularRaw", {
	  enumerable: true,
	  get: function get() {
	    return _equirectangular.equirectangularRaw;
	  }
	});
	
	var _gnomonic = __webpack_require__(352);
	
	Object.defineProperty(exports, "geoGnomonic", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gnomonic).default;
	  }
	});
	Object.defineProperty(exports, "geoGnomonicRaw", {
	  enumerable: true,
	  get: function get() {
	    return _gnomonic.gnomonicRaw;
	  }
	});
	
	var _identity = __webpack_require__(353);
	
	Object.defineProperty(exports, "geoIdentity", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_identity).default;
	  }
	});
	
	var _index2 = __webpack_require__(19);
	
	Object.defineProperty(exports, "geoProjection", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index2).default;
	  }
	});
	Object.defineProperty(exports, "geoProjectionMutator", {
	  enumerable: true,
	  get: function get() {
	    return _index2.projectionMutator;
	  }
	});
	
	var _mercator = __webpack_require__(99);
	
	Object.defineProperty(exports, "geoMercator", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mercator).default;
	  }
	});
	Object.defineProperty(exports, "geoMercatorRaw", {
	  enumerable: true,
	  get: function get() {
	    return _mercator.mercatorRaw;
	  }
	});
	
	var _naturalEarth = __webpack_require__(354);
	
	Object.defineProperty(exports, "geoNaturalEarth1", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_naturalEarth).default;
	  }
	});
	Object.defineProperty(exports, "geoNaturalEarth1Raw", {
	  enumerable: true,
	  get: function get() {
	    return _naturalEarth.naturalEarth1Raw;
	  }
	});
	
	var _orthographic = __webpack_require__(355);
	
	Object.defineProperty(exports, "geoOrthographic", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_orthographic).default;
	  }
	});
	Object.defineProperty(exports, "geoOrthographicRaw", {
	  enumerable: true,
	  get: function get() {
	    return _orthographic.orthographicRaw;
	  }
	});
	
	var _stereographic = __webpack_require__(357);
	
	Object.defineProperty(exports, "geoStereographic", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stereographic).default;
	  }
	});
	Object.defineProperty(exports, "geoStereographicRaw", {
	  enumerable: true,
	  get: function get() {
	    return _stereographic.stereographicRaw;
	  }
	});
	
	var _transverseMercator = __webpack_require__(358);
	
	Object.defineProperty(exports, "geoTransverseMercator", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transverseMercator).default;
	  }
	});
	Object.defineProperty(exports, "geoTransverseMercatorRaw", {
	  enumerable: true,
	  get: function get() {
	    return _transverseMercator.transverseMercatorRaw;
	  }
	});
	
	var _rotation = __webpack_require__(62);
	
	Object.defineProperty(exports, "geoRotation", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_rotation).default;
	  }
	});
	
	var _stream = __webpack_require__(27);
	
	Object.defineProperty(exports, "geoStream", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stream).default;
	  }
	});
	
	var _transform = __webpack_require__(63);
	
	Object.defineProperty(exports, "geoTransform", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transform).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
	  ranges = [];
	  (0, _stream2.default)(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range = null;
	
	  return lambda0 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda0, phi0], [lambda1, phi1]];
	};
	
	var _adder = __webpack_require__(36);
	
	var _adder2 = _interopRequireDefault(_adder);
	
	var _area = __webpack_require__(156);
	
	var _cartesian = __webpack_require__(42);
	
	var _math = __webpack_require__(2);
	
	var _stream = __webpack_require__(27);
	
	var _stream2 = _interopRequireDefault(_stream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lambda0,
	    phi0,
	    lambda1,
	    phi1,
	    // bounds
	lambda2,
	    // previous lambda-coordinate
	lambda00,
	    phi00,
	    // first point
	p0,
	    // previous 3D point
	deltaSum = (0, _adder2.default)(),
	    ranges,
	    range;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function polygonStart() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    _area.areaStream.polygonStart();
	  },
	  polygonEnd: function polygonEnd() {
	    _area.areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (_area.areaRingSum < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);else if (deltaSum > _math.epsilon) phi1 = 90;else if (deltaSum < -_math.epsilon) phi0 = -90;
	    range[0] = lambda0, range[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = (0, _cartesian.cartesian)([lambda * _math.radians, phi * _math.radians]);
	  if (p0) {
	    var normal = (0, _cartesian.cartesianCross)(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = (0, _cartesian.cartesianCross)(equatorial, normal);
	    (0, _cartesian.cartesianNormalizeInPlace)(inflection);
	    inflection = (0, _cartesian.spherical)(inflection);
	    var delta = lambda - lambda2,
	        sign = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * _math.degrees * sign,
	        phii,
	        antimeridian = (0, _math.abs)(delta) > 180;
	    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
	      phii = inflection[1] * _math.degrees;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
	      phii = -inflection[1] * _math.degrees;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0) {
	        if (lambda < lambda0) lambda0 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
	        }
	      }
	    }
	  } else {
	    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
	  }
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range[0] = lambda0, range[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add((0, _math.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00 = lambda, phi00 = phi;
	  }
	  _area.areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  _area.areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00, phi00);
	  _area.areaStream.lineEnd();
	  if ((0, _math.abs)(deltaSum) > _math.epsilon) lambda0 = -(lambda1 = 180);
	  range[0] = lambda0, range[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range, x) {
	  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	}

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (object) {
	  W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
	  (0, _stream2.default)(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < _math.epsilon2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < _math.epsilon) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < _math.epsilon2) return [NaN, NaN];
	  }
	
	  return [(0, _math.atan2)(y, x) * _math.degrees, (0, _math.asin)(z / (0, _math.sqrt)(m)) * _math.degrees];
	};
	
	var _math = __webpack_require__(2);
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _stream = __webpack_require__(27);
	
	var _stream2 = _interopRequireDefault(_stream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, // first point
	x0, y0, z0; // previous point
	
	var centroidStream = {
	  sphere: _noop2.default,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function polygonStart() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function polygonEnd() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= _math.radians, phi *= _math.radians;
	  var cosPhi = (0, _math.cos)(phi);
	  centroidPointCartesian(cosPhi * (0, _math.cos)(lambda), cosPhi * (0, _math.sin)(lambda), (0, _math.sin)(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= _math.radians, phi *= _math.radians;
	  var cosPhi = (0, _math.cos)(phi);
	  x0 = cosPhi * (0, _math.cos)(lambda);
	  y0 = cosPhi * (0, _math.sin)(lambda);
	  z0 = (0, _math.sin)(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= _math.radians, phi *= _math.radians;
	  var cosPhi = (0, _math.cos)(phi),
	      x = cosPhi * (0, _math.cos)(lambda),
	      y = cosPhi * (0, _math.sin)(lambda),
	      z = (0, _math.sin)(phi),
	      w = (0, _math.atan2)((0, _math.sqrt)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00, phi00);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00 = lambda, phi00 = phi;
	  lambda *= _math.radians, phi *= _math.radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = (0, _math.cos)(phi);
	  x0 = cosPhi * (0, _math.cos)(lambda);
	  y0 = cosPhi * (0, _math.sin)(lambda);
	  z0 = (0, _math.sin)(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= _math.radians, phi *= _math.radians;
	  var cosPhi = (0, _math.cos)(phi),
	      x = cosPhi * (0, _math.cos)(lambda),
	      y = cosPhi * (0, _math.sin)(lambda),
	      z = (0, _math.sin)(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = (0, _math.sqrt)(cx * cx + cy * cy + cz * cz),
	      w = (0, _math.asin)(m),
	      // line weight = angle
	  v = m && -w / m; // area weight multiplier
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function stream(_stream) {
	      return cache && cacheStream === _stream ? cache : cache = (0, _rectangle2.default)(x0, y0, x1, y1)(cacheStream = _stream);
	    },
	    extent: function extent(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var _rectangle = __webpack_require__(61);
	
	var _rectangle2 = _interopRequireDefault(_rectangle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 335 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};

/***/ },
/* 336 */
35,
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (object, point) {
	  return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
	};
	
	var _polygonContains = __webpack_require__(168);
	
	var _polygonContains2 = _interopRequireDefault(_polygonContains);
	
	var _distance = __webpack_require__(164);
	
	var _distance2 = _interopRequireDefault(_distance);
	
	var _math = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containsObjectType = {
	  Feature: function Feature(object, point) {
	    return containsGeometry(object.geometry, point);
	  },
	  FeatureCollection: function FeatureCollection(object, point) {
	    var features = object.features,
	        i = -1,
	        n = features.length;
	    while (++i < n) {
	      if (containsGeometry(features[i].geometry, point)) return true;
	    }return false;
	  }
	};
	
	var containsGeometryType = {
	  Sphere: function Sphere() {
	    return true;
	  },
	  Point: function Point(object, point) {
	    return containsPoint(object.coordinates, point);
	  },
	  MultiPoint: function MultiPoint(object, point) {
	    var coordinates = object.coordinates,
	        i = -1,
	        n = coordinates.length;
	    while (++i < n) {
	      if (containsPoint(coordinates[i], point)) return true;
	    }return false;
	  },
	  LineString: function LineString(object, point) {
	    return containsLine(object.coordinates, point);
	  },
	  MultiLineString: function MultiLineString(object, point) {
	    var coordinates = object.coordinates,
	        i = -1,
	        n = coordinates.length;
	    while (++i < n) {
	      if (containsLine(coordinates[i], point)) return true;
	    }return false;
	  },
	  Polygon: function Polygon(object, point) {
	    return containsPolygon(object.coordinates, point);
	  },
	  MultiPolygon: function MultiPolygon(object, point) {
	    var coordinates = object.coordinates,
	        i = -1,
	        n = coordinates.length;
	    while (++i < n) {
	      if (containsPolygon(coordinates[i], point)) return true;
	    }return false;
	  },
	  GeometryCollection: function GeometryCollection(object, point) {
	    var geometries = object.geometries,
	        i = -1,
	        n = geometries.length;
	    while (++i < n) {
	      if (containsGeometry(geometries[i], point)) return true;
	    }return false;
	  }
	};
	
	function containsGeometry(geometry, point) {
	  return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
	}
	
	function containsPoint(coordinates, point) {
	  return (0, _distance2.default)(coordinates, point) === 0;
	}
	
	function containsLine(coordinates, point) {
	  var ab = (0, _distance2.default)(coordinates[0], coordinates[1]),
	      ao = (0, _distance2.default)(coordinates[0], point),
	      ob = (0, _distance2.default)(point, coordinates[1]);
	  return ao + ob <= ab + _math.epsilon;
	}
	
	function containsPolygon(coordinates, point) {
	  return !!(0, _polygonContains2.default)(coordinates.map(ringRadians), pointRadians(point));
	}
	
	function ringRadians(ring) {
	  return ring = ring.map(pointRadians), ring.pop(), ring;
	}
	
	function pointRadians(point) {
	  return [point[0] * _math.radians, point[1] * _math.radians];
	}

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = graticule;
	exports.graticule10 = graticule10;
	
	var _d3Array = __webpack_require__(9);
	
	var _math = __webpack_require__(2);
	
	function graticuleX(y0, y1, dy) {
	  var y = (0, _d3Array.range)(y0, y1 - _math.epsilon, dy).concat(y1);
	  return function (x) {
	    return y.map(function (y) {
	      return [x, y];
	    });
	  };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = (0, _d3Array.range)(x0, x1 - _math.epsilon, dx).concat(x1);
	  return function (y) {
	    return x.map(function (x) {
	      return [x, y];
	    });
	  };
	}
	
	function graticule() {
	  var x1,
	      x0,
	      X1,
	      X0,
	      y1,
	      y0,
	      Y1,
	      Y0,
	      dx = 10,
	      dy = dx,
	      DX = 90,
	      DY = 360,
	      x,
	      y,
	      X,
	      Y,
	      precision = 2.5;
	
	  function graticule() {
	    return { type: "MultiLineString", coordinates: lines() };
	  }
	
	  function lines() {
	    return (0, _d3Array.range)((0, _math.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, _d3Array.range)((0, _math.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, _d3Array.range)((0, _math.ceil)(x0 / dx) * dx, x1, dx).filter(function (x) {
	      return (0, _math.abs)(x % DX) > _math.epsilon;
	    }).map(x)).concat((0, _d3Array.range)((0, _math.ceil)(y0 / dy) * dy, y1, dy).filter(function (y) {
	      return (0, _math.abs)(y % DY) > _math.epsilon;
	    }).map(y));
	  }
	
	  graticule.lines = function () {
	    return lines().map(function (coordinates) {
	      return { type: "LineString", coordinates: coordinates };
	    });
	  };
	
	  graticule.outline = function () {
	    return {
	      type: "Polygon",
	      coordinates: [X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))]
	    };
	  };
	
	  graticule.extent = function (_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function (_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function (_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function (_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function (_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function (_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function (_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule.extentMajor([[-180, -90 + _math.epsilon], [180, 90 - _math.epsilon]]).extentMinor([[-180, -80 - _math.epsilon], [180, 80 + _math.epsilon]]);
	}
	
	function graticule10() {
	  return graticule()();
	}

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  var x0 = a[0] * _math.radians,
	      y0 = a[1] * _math.radians,
	      x1 = b[0] * _math.radians,
	      y1 = b[1] * _math.radians,
	      cy0 = (0, _math.cos)(y0),
	      sy0 = (0, _math.sin)(y0),
	      cy1 = (0, _math.cos)(y1),
	      sy1 = (0, _math.sin)(y1),
	      kx0 = cy0 * (0, _math.cos)(x0),
	      ky0 = cy0 * (0, _math.sin)(x0),
	      kx1 = cy1 * (0, _math.cos)(x1),
	      ky1 = cy1 * (0, _math.sin)(x1),
	      d = 2 * (0, _math.asin)((0, _math.sqrt)((0, _math.haversin)(y1 - y0) + cy0 * cy1 * (0, _math.haversin)(x1 - x0))),
	      k = (0, _math.sin)(d);
	
	  var interpolate = d ? function (t) {
	    var B = (0, _math.sin)(t *= d) / k,
	        A = (0, _math.sin)(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [(0, _math.atan2)(y, x) * _math.degrees, (0, _math.atan2)(z, (0, _math.sqrt)(x * x + y * y)) * _math.degrees];
	  } : function () {
	    return [x0 * _math.degrees, y0 * _math.degrees];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var _math = __webpack_require__(2);

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adder = __webpack_require__(36);
	
	var _adder2 = _interopRequireDefault(_adder);
	
	var _math = __webpack_require__(2);
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var areaSum = (0, _adder2.default)(),
	    areaRingSum = (0, _adder2.default)(),
	    x00,
	    y00,
	    x0,
	    y0;
	
	var areaStream = {
	  point: _noop2.default,
	  lineStart: _noop2.default,
	  lineEnd: _noop2.default,
	  polygonStart: function polygonStart() {
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function polygonEnd() {
	    areaStream.lineStart = areaStream.lineEnd = areaStream.point = _noop2.default;
	    areaSum.add((0, _math.abs)(areaRingSum));
	    areaRingSum.reset();
	  },
	  result: function result() {
	    var area = areaSum / 2;
	    areaSum.reset();
	    return area;
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaPointFirst(x, y) {
	  areaStream.point = areaPoint;
	  x00 = x0 = x, y00 = y0 = y;
	}
	
	function areaPoint(x, y) {
	  areaRingSum.add(y0 * x - x0 * y);
	  x0 = x, y0 = y;
	}
	
	function areaRingEnd() {
	  areaPoint(x00, y00);
	}
	
	exports.default = areaStream;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _math = __webpack_require__(2);
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0 = 0,
	    Y0 = 0,
	    Z0 = 0,
	    X1 = 0,
	    Y1 = 0,
	    Z1 = 0,
	    X2 = 0,
	    Y2 = 0,
	    Z2 = 0,
	    x00,
	    y00,
	    x0,
	    y0;
	
	var centroidStream = {
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function polygonStart() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function polygonEnd() {
	    centroidStream.point = centroidPoint;
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  },
	  result: function result() {
	    var centroid = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
	    X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint(x, y) {
	  X0 += x;
	  Y0 += y;
	  ++Z0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream.point = centroidPointLine;
	  centroidPoint(x0 = x, y0 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0,
	      dy = y - y0,
	      z = (0, _math.sqrt)(dx * dx + dy * dy);
	  X1 += z * (x0 + x) / 2;
	  Y1 += z * (y0 + y) / 2;
	  Z1 += z;
	  centroidPoint(x0 = x, y0 = y);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingStart() {
	  centroidStream.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd() {
	  centroidPointRing(x00, y00);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream.point = centroidPointRing;
	  centroidPoint(x00 = x0 = x, y00 = y0 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0,
	      dy = y - y0,
	      z = (0, _math.sqrt)(dx * dx + dy * dy);
	
	  X1 += z * (x0 + x) / 2;
	  Y1 += z * (y0 + y) / 2;
	  Z1 += z;
	
	  z = y0 * x - x0 * y;
	  X2 += z * (x0 + x);
	  Y2 += z * (y0 + y);
	  Z2 += z * 3;
	  centroidPoint(x0 = x, y0 = y);
	}
	
	exports.default = centroidStream;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PathContext;
	
	var _math = __webpack_require__(2);
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function pointRadius(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function polygonStart() {
	    this._line = 0;
	  },
	  polygonEnd: function polygonEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function point(x, y) {
	    switch (this._point) {
	      case 0:
	        {
	          this._context.moveTo(x, y);
	          this._point = 1;
	          break;
	        }
	      case 1:
	        {
	          this._context.lineTo(x, y);
	          break;
	        }
	      default:
	        {
	          this._context.moveTo(x + this._radius, y);
	          this._context.arc(x, y, this._radius, 0, _math.tau);
	          break;
	        }
	    }
	  },
	  result: _noop2.default
	};

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      (0, _stream2.default)(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function (object) {
	    (0, _stream2.default)(object, projectionStream(_area2.default));
	    return _area2.default.result();
	  };
	
	  path.measure = function (object) {
	    (0, _stream2.default)(object, projectionStream(_measure2.default));
	    return _measure2.default.result();
	  };
	
	  path.bounds = function (object) {
	    (0, _stream2.default)(object, projectionStream(_bounds2.default));
	    return _bounds2.default.result();
	  };
	
	  path.centroid = function (object) {
	    (0, _stream2.default)(object, projectionStream(_centroid2.default));
	    return _centroid2.default.result();
	  };
	
	  path.projection = function (_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, _identity2.default) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function (_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new _string2.default()) : new _context2.default(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function (_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var _identity = __webpack_require__(95);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _stream = __webpack_require__(27);
	
	var _stream2 = _interopRequireDefault(_stream);
	
	var _area = __webpack_require__(340);
	
	var _area2 = _interopRequireDefault(_area);
	
	var _bounds = __webpack_require__(166);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _centroid = __webpack_require__(341);
	
	var _centroid2 = _interopRequireDefault(_centroid);
	
	var _context = __webpack_require__(342);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _measure = __webpack_require__(344);
	
	var _measure2 = _interopRequireDefault(_measure);
	
	var _string = __webpack_require__(345);
	
	var _string2 = _interopRequireDefault(_string);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adder = __webpack_require__(36);
	
	var _adder2 = _interopRequireDefault(_adder);
	
	var _math = __webpack_require__(2);
	
	var _noop = __webpack_require__(21);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengthSum = (0, _adder2.default)(),
	    lengthRing,
	    x00,
	    y00,
	    x0,
	    y0;
	
	var lengthStream = {
	  point: _noop2.default,
	  lineStart: function lineStart() {
	    lengthStream.point = lengthPointFirst;
	  },
	  lineEnd: function lineEnd() {
	    if (lengthRing) lengthPoint(x00, y00);
	    lengthStream.point = _noop2.default;
	  },
	  polygonStart: function polygonStart() {
	    lengthRing = true;
	  },
	  polygonEnd: function polygonEnd() {
	    lengthRing = null;
	  },
	  result: function result() {
	    var length = +lengthSum;
	    lengthSum.reset();
	    return length;
	  }
	};
	
	function lengthPointFirst(x, y) {
	  lengthStream.point = lengthPoint;
	  x00 = x0 = x, y00 = y0 = y;
	}
	
	function lengthPoint(x, y) {
	  x0 -= x, y0 -= y;
	  lengthSum.add((0, _math.sqrt)(x0 * x0 + y0 * y0));
	  x0 = x, y0 = y;
	}
	
	exports.default = lengthStream;

/***/ },
/* 345 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PathString;
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _radius: 4.5,
	  _circle: circle(4.5),
	  pointRadius: function pointRadius(_) {
	    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
	    return this;
	  },
	  polygonStart: function polygonStart() {
	    this._line = 0;
	  },
	  polygonEnd: function polygonEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function point(x, y) {
	    switch (this._point) {
	      case 0:
	        {
	          this._string.push("M", x, ",", y);
	          this._point = 1;
	          break;
	        }
	      case 1:
	        {
	          this._string.push("L", x, ",", y);
	          break;
	        }
	      default:
	        {
	          if (this._circle == null) this._circle = circle(this._radius);
	          this._string.push("M", x, ",", y, this._circle);
	          break;
	        }
	    }
	  },
	  result: function result() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    } else {
	      return null;
	    }
	  }
	};
	
	function circle(radius) {
	  return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	}

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var cache,
	      cacheStream,
	      lower48 = (0, _albers2.default)(),
	      lower48Point,
	      alaska = (0, _conicEqualArea2.default)().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
	      alaskaPoint,
	      // EPSG:3338
	  hawaii = (0, _conicEqualArea2.default)().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
	      hawaiiPoint,
	      // ESRI:102007
	  _point,
	      pointStream = { point: function point(x, y) {
	      _point = [x, y];
	    } };
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0],
	        y = coordinates[1];
	    return _point = null, (lower48Point.point(x, y), _point) || (alaskaPoint.point(x, y), _point) || (hawaiiPoint.point(x, y), _point);
	  }
	
	  albersUsa.invert = function (coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function (stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function (_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function (_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function (_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(),
	        x = +_[0],
	        y = +_[1];
	
	    lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
	
	    alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + _math.epsilon, y + 0.120 * k + _math.epsilon], [x - 0.214 * k - _math.epsilon, y + 0.234 * k - _math.epsilon]]).stream(pointStream);
	
	    hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + _math.epsilon, y + 0.166 * k + _math.epsilon], [x - 0.115 * k - _math.epsilon, y + 0.234 * k - _math.epsilon]]).stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function (extent, object) {
	    return (0, _fit.fitExtent)(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function (size, object) {
	    return (0, _fit.fitSize)(albersUsa, size, object);
	  };
	
	  albersUsa.fitWidth = function (width, object) {
	    return (0, _fit.fitWidth)(albersUsa, width, object);
	  };
	
	  albersUsa.fitHeight = function (height, object) {
	    return (0, _fit.fitHeight)(albersUsa, height, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	var _math = __webpack_require__(2);
	
	var _albers = __webpack_require__(169);
	
	var _albers2 = _interopRequireDefault(_albers);
	
	var _conicEqualArea = __webpack_require__(97);
	
	var _conicEqualArea2 = _interopRequireDefault(_conicEqualArea);
	
	var _fit = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function point(x, y) {
	      var i = -1;while (++i < n) {
	        streams[i].point(x, y);
	      }
	    },
	    sphere: function sphere() {
	      var i = -1;while (++i < n) {
	        streams[i].sphere();
	      }
	    },
	    lineStart: function lineStart() {
	      var i = -1;while (++i < n) {
	        streams[i].lineStart();
	      }
	    },
	    lineEnd: function lineEnd() {
	      var i = -1;while (++i < n) {
	        streams[i].lineEnd();
	      }
	    },
	    polygonStart: function polygonStart() {
	      var i = -1;while (++i < n) {
	        streams[i].polygonStart();
	      }
	    },
	    polygonEnd: function polygonEnd() {
	      var i = -1;while (++i < n) {
	        streams[i].polygonEnd();
	      }
	    }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.azimuthalEqualAreaRaw = undefined;
	
	exports.default = function () {
	  return (0, _index2.default)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
	};
	
	var _math = __webpack_require__(2);
	
	var _azimuthal = __webpack_require__(43);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var azimuthalEqualAreaRaw = exports.azimuthalEqualAreaRaw = (0, _azimuthal.azimuthalRaw)(function (cxcy) {
	  return (0, _math.sqrt)(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = (0, _azimuthal.azimuthalInvert)(function (z) {
	  return 2 * (0, _math.asin)(z / 2);
	});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.azimuthalEquidistantRaw = undefined;
	
	exports.default = function () {
	  return (0, _index2.default)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
	};
	
	var _math = __webpack_require__(2);
	
	var _azimuthal = __webpack_require__(43);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var azimuthalEquidistantRaw = exports.azimuthalEquidistantRaw = (0, _azimuthal.azimuthalRaw)(function (c) {
	  return (c = (0, _math.acos)(c)) && c / (0, _math.sin)(c);
	});
	
	azimuthalEquidistantRaw.invert = (0, _azimuthal.azimuthalInvert)(function (z) {
	  return z;
	});

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.conicConformalRaw = conicConformalRaw;
	
	exports.default = function () {
	  return (0, _conic.conicProjection)(conicConformalRaw).scale(109.5).parallels([30, 30]);
	};
	
	var _math = __webpack_require__(2);
	
	var _conic = __webpack_require__(96);
	
	var _mercator = __webpack_require__(99);
	
	function tany(y) {
	  return (0, _math.tan)((_math.halfPi + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = (0, _math.cos)(y0),
	      n = y0 === y1 ? (0, _math.sin)(y0) : (0, _math.log)(cy0 / (0, _math.cos)(y1)) / (0, _math.log)(tany(y1) / tany(y0)),
	      f = cy0 * (0, _math.pow)(tany(y0), n) / n;
	
	  if (!n) return _mercator.mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) {
	      if (y < -_math.halfPi + _math.epsilon) y = -_math.halfPi + _math.epsilon;
	    } else {
	      if (y > _math.halfPi - _math.epsilon) y = _math.halfPi - _math.epsilon;
	    }
	    var r = f / (0, _math.pow)(tany(y), n);
	    return [r * (0, _math.sin)(n * x), f - r * (0, _math.cos)(n * x)];
	  }
	
	  project.invert = function (x, y) {
	    var fy = f - y,
	        r = (0, _math.sign)(n) * (0, _math.sqrt)(x * x + fy * fy);
	    return [(0, _math.atan2)(x, (0, _math.abs)(fy)) / n * (0, _math.sign)(fy), 2 * (0, _math.atan)((0, _math.pow)(f / r, 1 / n)) - _math.halfPi];
	  };
	
	  return project;
	}

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.conicEquidistantRaw = conicEquidistantRaw;
	
	exports.default = function () {
	  return (0, _conic.conicProjection)(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
	};
	
	var _math = __webpack_require__(2);
	
	var _conic = __webpack_require__(96);
	
	var _equirectangular = __webpack_require__(170);
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = (0, _math.cos)(y0),
	      n = y0 === y1 ? (0, _math.sin)(y0) : (cy0 - (0, _math.cos)(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if ((0, _math.abs)(n) < _math.epsilon) return _equirectangular.equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y,
	        nx = n * x;
	    return [gy * (0, _math.sin)(nx), g - gy * (0, _math.cos)(nx)];
	  }
	
	  project.invert = function (x, y) {
	    var gy = g - y;
	    return [(0, _math.atan2)(x, (0, _math.abs)(gy)) / n * (0, _math.sign)(gy), g - (0, _math.sign)(n) * (0, _math.sqrt)(x * x + gy * gy)];
	  };
	
	  return project;
	}

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cylindricalEqualAreaRaw = cylindricalEqualAreaRaw;
	
	var _math = __webpack_require__(2);
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = (0, _math.cos)(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, (0, _math.sin)(phi) / cosPhi0];
	  }
	
	  forward.invert = function (x, y) {
	    return [x / cosPhi0, (0, _math.asin)(y * cosPhi0)];
	  };
	
	  return forward;
	}

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gnomonicRaw = gnomonicRaw;
	
	exports.default = function () {
	  return (0, _index2.default)(gnomonicRaw).scale(144.049).clipAngle(60);
	};
	
	var _math = __webpack_require__(2);
	
	var _azimuthal = __webpack_require__(43);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function gnomonicRaw(x, y) {
	  var cy = (0, _math.cos)(y),
	      k = (0, _math.cos)(x) * cy;
	  return [cy * (0, _math.sin)(x) / k, (0, _math.sin)(y) / k];
	}
	
	gnomonicRaw.invert = (0, _azimuthal.azimuthalInvert)(_math.atan);

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var k = 1,
	      tx = 0,
	      ty = 0,
	      sx = 1,
	      sy = 1,
	      transform = _identity2.default,
	      // scale, translate and reflect
	  x0 = null,
	      y0,
	      x1,
	      y1,
	      // clip extent
	  _postclip = _identity2.default,
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function stream(_stream) {
	      return cache && cacheStream === _stream ? cache : cache = transform(_postclip(cacheStream = _stream));
	    },
	    postclip: function postclip(_) {
	      return arguments.length ? (_postclip = _, x0 = y0 = x1 = y1 = null, reset()) : _postclip;
	    },
	    clipExtent: function clipExtent(_) {
	      return arguments.length ? (_postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identity2.default) : (0, _rectangle2.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function scale(_) {
	      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function translate(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function reflectX(_) {
	      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function reflectY(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function fitExtent(extent, object) {
	      return (0, _fit.fitExtent)(projection, extent, object);
	    },
	    fitSize: function fitSize(size, object) {
	      return (0, _fit.fitSize)(projection, size, object);
	    },
	    fitWidth: function fitWidth(width, object) {
	      return (0, _fit.fitWidth)(projection, width, object);
	    },
	    fitHeight: function fitHeight(height, object) {
	      return (0, _fit.fitHeight)(projection, height, object);
	    }
	  };
	};
	
	var _rectangle = __webpack_require__(61);
	
	var _rectangle2 = _interopRequireDefault(_rectangle);
	
	var _identity = __webpack_require__(95);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _transform = __webpack_require__(63);
	
	var _fit = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? _identity2.default : (0, _transform.transformer)({
	    point: function point(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.naturalEarth1Raw = naturalEarth1Raw;
	
	exports.default = function () {
	  return (0, _index2.default)(naturalEarth1Raw).scale(175.295);
	};
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _math = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function naturalEarth1Raw(lambda, phi) {
	  var phi2 = phi * phi,
	      phi4 = phi2 * phi2;
	  return [lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))), phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))];
	}
	
	naturalEarth1Raw.invert = function (x, y) {
	  var phi = y,
	      i = 25,
	      delta;
	  do {
	    var phi2 = phi * phi,
	        phi4 = phi2 * phi2;
	    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
	  } while ((0, _math.abs)(delta) > _math.epsilon && --i > 0);
	  return [x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))), phi];
	};

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.orthographicRaw = orthographicRaw;
	
	exports.default = function () {
	  return (0, _index2.default)(orthographicRaw).scale(249.5).clipAngle(90 + _math.epsilon);
	};
	
	var _math = __webpack_require__(2);
	
	var _azimuthal = __webpack_require__(43);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function orthographicRaw(x, y) {
	  return [(0, _math.cos)(y) * (0, _math.sin)(x), (0, _math.sin)(y)];
	}
	
	orthographicRaw.invert = (0, _azimuthal.azimuthalInvert)(_math.asin);

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (project, delta2) {
	  return +delta2 ? resample(project, delta2) : resampleNone(project);
	};
	
	var _cartesian = __webpack_require__(42);
	
	var _math = __webpack_require__(2);
	
	var _transform = __webpack_require__(63);
	
	var maxDepth = 16,
	    // maximum depth of subdivision
	cosMinDistance = (0, _math.cos)(30 * _math.radians); // cos(minimum angular distance)
	
	function resampleNone(project) {
	  return (0, _transform.transformer)({
	    point: function point(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = (0, _math.sqrt)(a * a + b * b + c * c),
	          phi2 = (0, _math.asin)(c /= m),
	          lambda2 = (0, _math.abs)((0, _math.abs)(c) - 1) < _math.epsilon || (0, _math.abs)(lambda0 - lambda1) < _math.epsilon ? (lambda0 + lambda1) / 2 : (0, _math.atan2)(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	      || (0, _math.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	      || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	        // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function (stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	    lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function polygonStart() {
	        stream.polygonStart();resampleStream.lineStart = ringStart;
	      },
	      polygonEnd: function polygonEnd() {
	        stream.polygonEnd();resampleStream.lineStart = lineStart;
	      }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = (0, _cartesian.cartesian)([lambda, phi]),
	          p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stereographicRaw = stereographicRaw;
	
	exports.default = function () {
	  return (0, _index2.default)(stereographicRaw).scale(250).clipAngle(142);
	};
	
	var _math = __webpack_require__(2);
	
	var _azimuthal = __webpack_require__(43);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stereographicRaw(x, y) {
	  var cy = (0, _math.cos)(y),
	      k = 1 + (0, _math.cos)(x) * cy;
	  return [cy * (0, _math.sin)(x) / k, (0, _math.sin)(y) / k];
	}
	
	stereographicRaw.invert = (0, _azimuthal.azimuthalInvert)(function (z) {
	  return 2 * (0, _math.atan)(z);
	});

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.transverseMercatorRaw = transverseMercatorRaw;
	
	exports.default = function () {
	  var m = (0, _mercator.mercatorProjection)(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function (_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function (_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90]).scale(159.155);
	};
	
	var _math = __webpack_require__(2);
	
	var _mercator = __webpack_require__(99);
	
	function transverseMercatorRaw(lambda, phi) {
	  return [(0, _math.log)((0, _math.tan)((_math.halfPi + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function (x, y) {
	  return [-y, 2 * (0, _math.atan)((0, _math.exp)(x)) - _math.halfPi];
	};

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cluster = __webpack_require__(361);
	
	Object.defineProperty(exports, "cluster", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cluster).default;
	  }
	});
	
	var _index = __webpack_require__(101);
	
	Object.defineProperty(exports, "hierarchy", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index).default;
	  }
	});
	
	var _index2 = __webpack_require__(373);
	
	Object.defineProperty(exports, "pack", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index2).default;
	  }
	});
	
	var _siblings = __webpack_require__(173);
	
	Object.defineProperty(exports, "packSiblings", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_siblings).default;
	  }
	});
	
	var _enclose = __webpack_require__(172);
	
	Object.defineProperty(exports, "packEnclose", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_enclose).default;
	  }
	});
	
	var _partition = __webpack_require__(374);
	
	Object.defineProperty(exports, "partition", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_partition).default;
	  }
	});
	
	var _stratify = __webpack_require__(375);
	
	Object.defineProperty(exports, "stratify", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stratify).default;
	  }
	});
	
	var _tree = __webpack_require__(376);
	
	Object.defineProperty(exports, "tree", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_tree).default;
	  }
	});
	
	var _index3 = __webpack_require__(378);
	
	Object.defineProperty(exports, "treemap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index3).default;
	  }
	});
	
	var _binary = __webpack_require__(377);
	
	Object.defineProperty(exports, "treemapBinary", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_binary).default;
	  }
	});
	
	var _dice = __webpack_require__(44);
	
	Object.defineProperty(exports, "treemapDice", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dice).default;
	  }
	});
	
	var _slice = __webpack_require__(64);
	
	Object.defineProperty(exports, "treemapSlice", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slice).default;
	  }
	});
	
	var _sliceDice = __webpack_require__(380);
	
	Object.defineProperty(exports, "treemapSliceDice", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sliceDice).default;
	  }
	});
	
	var _squarify = __webpack_require__(102);
	
	Object.defineProperty(exports, "treemapSquarify", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_squarify).default;
	  }
	});
	
	var _resquarify = __webpack_require__(379);
	
	Object.defineProperty(exports, "treemapResquarify", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_resquarify).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 360 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shuffle = shuffle;
	var slice = exports.slice = Array.prototype.slice;
	
	function shuffle(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}

/***/ },
/* 361 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function (node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function (node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function (node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function (x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function (x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [dx, dy];
	  };
	
	  cluster.nodeSize = function (x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [dx, dy] : null;
	  };
	
	  return cluster;
	};
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) {
	    node = children[0];
	  }return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) {
	    node = children[children.length - 1];
	  }return node;
	}

/***/ },
/* 362 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var node = this,
	      nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};

/***/ },
/* 363 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return this.eachAfter(count);
	};
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;else while (--i >= 0) {
	    sum += children[i].value;
	  }node.value = sum;
	}

/***/ },
/* 364 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var nodes = [];
	  this.each(function (node) {
	    nodes.push(node);
	  });
	  return nodes;
	};

/***/ },
/* 365 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback) {
	  var node = this,
	      current,
	      next = [node],
	      children,
	      i,
	      n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};

/***/ },
/* 366 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback) {
	  var node = this,
	      nodes = [node],
	      next = [],
	      children,
	      i,
	      n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};

/***/ },
/* 367 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback) {
	  var node = this,
	      nodes = [node],
	      children,
	      i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};

/***/ },
/* 368 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var leaves = [];
	  this.eachBefore(function (node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};

/***/ },
/* 369 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var root = this,
	      links = [];
	  root.each(function (node) {
	    if (node !== root) {
	      // Don’t include the root’s parent, if any.
	      links.push({ source: node.parent, target: node });
	    }
	  });
	  return links;
	};

/***/ },
/* 370 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}

/***/ },
/* 371 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (compare) {
	  return this.eachBefore(function (node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};

/***/ },
/* 372 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return this.eachAfter(function (node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) {
	      sum += children[i].value;
	    }node.value = sum;
	  });
	};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = _constant.constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, 0.5)).eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren(_constant.constantZero, 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function (x) {
	    return arguments.length ? (radius = (0, _accessors.optional)(x), pack) : radius;
	  };
	
	  pack.size = function (x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function (x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : (0, _constant2.default)(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	var _siblings = __webpack_require__(173);
	
	var _accessors = __webpack_require__(100);
	
	var _constant = __webpack_require__(171);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	function radiusLeaf(radius) {
	  return function (node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function (node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) {
	        children[i].r += r;
	      }e = (0, _siblings.packEnclose)(children);
	      if (r) for (i = 0; i < n; ++i) {
	        children[i].r -= r;
	      }node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function (node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 = root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(_round2.default);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function (node) {
	      if (node.children) {
	        (0, _dice2.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function (x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function (x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function (x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var _round = __webpack_require__(174);
	
	var _round2 = _interopRequireDefault(_round);
	
	var _dice = __webpack_require__(44);
	
	var _dice2 = _interopRequireDefault(_dice);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new _index.Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function (node) {
	      node.depth = node.parent.depth + 1;--n;
	    }).eachBefore(_index.computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function (x) {
	    return arguments.length ? (id = (0, _accessors.required)(x), stratify) : id;
	  };
	
	  stratify.parentId = function (x) {
	    return arguments.length ? (parentId = (0, _accessors.required)(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	var _accessors = __webpack_require__(100);
	
	var _index = __webpack_require__(101);
	
	var keyPrefix = "$",
	    // Protect against keys like “__proto__”.
	preroot = { depth: -1 },
	    ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	        var left = root,
	            right = root,
	            bottom = root;
	        root.eachBefore(function (node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var s = left === right ? 1 : separation(left, right) / 2,
	            tx = s - left.x,
	            kx = dx / (right.x + s + tx),
	            ky = dy / (bottom.depth || 1);
	        root.eachBefore(function (node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function (x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function (x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [dx, dy];
	  };
	
	  tree.nodeSize = function (x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [dx, dy] : null;
	  };
	
	  return tree;
	};
	
	var _index = __webpack_require__(101);
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(_index.Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm

/***/ },
/* 377 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i,
	      n = nodes.length,
	      sum,
	      sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = value / 2 + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;else hi = mid;
	    }
	
	    if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if (x1 - x0 > y1 - y0) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var tile = _squarify2.default,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = _constant.constantZero,
	      paddingTop = _constant.constantZero,
	      paddingRight = _constant.constantZero,
	      paddingBottom = _constant.constantZero,
	      paddingLeft = _constant.constantZero;
	
	  function treemap(root) {
	    root.x0 = root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(_round2.default);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function (x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function (x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function (x) {
	    return arguments.length ? (tile = (0, _accessors.required)(x), treemap) : tile;
	  };
	
	  treemap.padding = function (x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function (x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, _constant2.default)(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function (x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function (x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, _constant2.default)(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function (x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, _constant2.default)(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function (x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, _constant2.default)(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function (x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, _constant2.default)(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var _round = __webpack_require__(174);
	
	var _round2 = _interopRequireDefault(_round);
	
	var _squarify = __webpack_require__(102);
	
	var _squarify2 = _interopRequireDefault(_squarify);
	
	var _accessors = __webpack_require__(100);
	
	var _constant = __webpack_require__(171);
	
	var _constant2 = _interopRequireDefault(_constant);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dice = __webpack_require__(44);
	
	var _dice2 = _interopRequireDefault(_dice);
	
	var _slice = __webpack_require__(64);
	
	var _slice2 = _interopRequireDefault(_slice);
	
	var _squarify = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && rows.ratio === ratio) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) {
	          row.value += nodes[i].value;
	        }if (row.dice) (0, _dice2.default)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);else (0, _slice2.default)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = (0, _squarify.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function (x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	}(_squarify.phi);

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? _slice2.default : _dice2.default)(parent, x0, y0, x1, y1);
	};
	
	var _dice = __webpack_require__(44);
	
	var _dice2 = _interopRequireDefault(_dice);
	
	var _slice = __webpack_require__(64);
	
	var _slice2 = _interopRequireDefault(_slice);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cubehelixLong = undefined;
	
	var _d3Color = __webpack_require__(18);
	
	var _color = __webpack_require__(45);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cubehelix(hue) {
	  return function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h),
	          s = (0, _color2.default)(start.s, end.s),
	          l = (0, _color2.default)(start.l, end.l),
	          opacity = (0, _color2.default)(start.opacity, end.opacity);
	      return function (t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  }(1);
	}
	
	exports.default = cubehelix(_color.hue);
	var cubehelixLong = exports.cubehelixLong = cubehelix(_color2.default);

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hclLong = undefined;
	
	var _d3Color = __webpack_require__(18);
	
	var _color = __webpack_require__(45);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hcl(hue) {
	  return function (start, end) {
	    var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h),
	        c = (0, _color2.default)(start.c, end.c),
	        l = (0, _color2.default)(start.l, end.l),
	        opacity = (0, _color2.default)(start.opacity, end.opacity);
	    return function (t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  };
	}
	
	exports.default = hcl(_color.hue);
	var hclLong = exports.hclLong = hcl(_color2.default);

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hslLong = undefined;
	
	var _d3Color = __webpack_require__(18);
	
	var _color = __webpack_require__(45);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hsl(hue) {
	  return function (start, end) {
	    var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h),
	        s = (0, _color2.default)(start.s, end.s),
	        l = (0, _color2.default)(start.l, end.l),
	        opacity = (0, _color2.default)(start.opacity, end.opacity);
	    return function (t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  };
	}
	
	exports.default = hsl(_color.hue);
	var hslLong = exports.hslLong = hsl(_color2.default);

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lab;
	
	var _d3Color = __webpack_require__(18);
	
	var _color = __webpack_require__(45);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function lab(start, end) {
	  var l = (0, _color2.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l),
	      a = (0, _color2.default)(start.a, end.a),
	      b = (0, _color2.default)(start.b, end.b),
	      opacity = (0, _color2.default)(start.opacity, end.opacity);
	  return function (t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}

/***/ },
/* 385 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = piecewise;
	function piecewise(interpolate, values) {
	  var i = 0,
	      n = values.length - 1,
	      v = values[0],
	      I = new Array(n < 0 ? 0 : n);
	  while (i < n) {
	    I[i] = interpolate(v, v = values[++i]);
	  }return function (t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}

/***/ },
/* 386 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) {
	    samples[i] = interpolator(i / (n - 1));
	  }return samples;
	};

/***/ },
/* 387 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  return a = +a, b -= a, function (t) {
	    return Math.round(a + b * t);
	  };
	};

/***/ },
/* 388 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = exports.identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.interpolateTransformSvg = exports.interpolateTransformCss = undefined;
	
	var _number = __webpack_require__(65);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _parse = __webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({ i: i - 4, x: (0, _number2.default)(xa, xb) }, { i: i - 2, x: (0, _number2.default)(ya, yb) });
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path
	      q.push({ i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: (0, _number2.default)(a, b) });
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({ i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: (0, _number2.default)(a, b) });
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({ i: i - 4, x: (0, _number2.default)(xa, xb) }, { i: i - 2, x: (0, _number2.default)(ya, yb) });
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function (a, b) {
	    var s = [],
	        // string constants and placeholders
	    q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function (t) {
	      var i = -1,
	          n = q.length,
	          o;
	      while (++i < n) {
	        s[(o = q[i]).i] = o.x(t);
	      }return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = exports.interpolateTransformCss = interpolateTransform(_parse.parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = exports.interpolateTransformSvg = interpolateTransform(_parse.parseSvg, ", ", ")", ")");

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseCss = parseCss;
	exports.parseSvg = parseSvg;
	
	var _decompose = __webpack_require__(388);
	
	var _decompose2 = _interopRequireDefault(_decompose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cssNode, cssRoot, cssView, svgNode;
	
	function parseCss(value) {
	  if (value === "none") return _decompose.identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return (0, _decompose2.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return _decompose.identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return _decompose.identity;
	  value = value.matrix;
	  return (0, _decompose2.default)(value.a, value.b, value.c, value.d, value.e, value.f);
	}

/***/ },
/* 391 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (p0, p1) {
	  var ux0 = p0[0],
	      uy0 = p0[1],
	      w0 = p0[2],
	      ux1 = p1[0],
	      uy1 = p1[1],
	      w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function i(t) {
	      return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
	    };
	  }
	
	  // General case.
	  else {
	      var d1 = Math.sqrt(d2),
	          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / rho;
	      i = function i(t) {
	        var s = t * S,
	            coshr0 = cosh(r0),
	            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
	      };
	    }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]

/***/ },
/* 392 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path();
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function moveTo(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function closePath() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function lineTo(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
	    this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
	    this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function arcTo(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	      // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	      // Equivalently, is (x1,y1) coincident with (x2,y2)?
	      // Or, is the radius zero? Line to (x1,y1).
	      else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	          this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	        }
	
	        // Otherwise, draw an arc!
	        else {
	            var x20 = x2 - x0,
	                y20 = y2 - y0,
	                l21_2 = x21 * x21 + y21 * y21,
	                l20_2 = x20 * x20 + y20 * y20,
	                l21 = Math.sqrt(l21_2),
	                l01 = Math.sqrt(l01_2),
	                l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	                t01 = l / l01,
	                t21 = l / l21;
	
	            // If the start tangent is not coincident with (x0,y0), line to.
	            if (Math.abs(t01 - 1) > epsilon) {
	              this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	            }
	
	            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	          }
	  },
	  arc: function arc(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	        this._ += "L" + x0 + "," + y0;
	      }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	        this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	      }
	  },
	  rect: function rect(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
	  },
	  toString: function toString() {
	    return this._;
	  }
	};
	
	exports.default = path;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _area = __webpack_require__(394);
	
	Object.defineProperty(exports, "polygonArea", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_area).default;
	  }
	});
	
	var _centroid = __webpack_require__(395);
	
	Object.defineProperty(exports, "polygonCentroid", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_centroid).default;
	  }
	});
	
	var _hull = __webpack_require__(398);
	
	Object.defineProperty(exports, "polygonHull", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hull).default;
	  }
	});
	
	var _contains = __webpack_require__(396);
	
	Object.defineProperty(exports, "polygonContains", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_contains).default;
	  }
	});
	
	var _length = __webpack_require__(399);
	
	Object.defineProperty(exports, "polygonLength", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_length).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 394 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (polygon) {
	  var i = -1,
	      n = polygon.length,
	      a,
	      b = polygon[n - 1],
	      area = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    area += a[1] * b[0] - a[0] * b[1];
	  }
	
	  return area / 2;
	};

/***/ },
/* 395 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (polygon) {
	  var i = -1,
	      n = polygon.length,
	      x = 0,
	      y = 0,
	      a,
	      b = polygon[n - 1],
	      c,
	      k = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    k += c = a[0] * b[1] - b[0] * a[1];
	    x += (a[0] + b[0]) * c;
	    y += (a[1] + b[1]) * c;
	  }
	
	  return k *= 3, [x / k, y / k];
	};

/***/ },
/* 396 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (polygon, point) {
	  var n = polygon.length,
	      p = polygon[n - 1],
	      x = point[0],
	      y = point[1],
	      x0 = p[0],
	      y0 = p[1],
	      x1,
	      y1,
	      inside = false;
	
	  for (var i = 0; i < n; ++i) {
	    p = polygon[i], x1 = p[0], y1 = p[1];
	    if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
	    x0 = x1, y0 = y1;
	  }
	
	  return inside;
	};

/***/ },
/* 397 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	};

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (points) {
	    if ((n = points.length) < 3) return null;
	
	    var i,
	        n,
	        sortedPoints = new Array(n),
	        flippedPoints = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	        sortedPoints[i] = [+points[i][0], +points[i][1], i];
	    }sortedPoints.sort(lexicographicOrder);
	    for (i = 0; i < n; ++i) {
	        flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
	    }var upperIndexes = computeUpperHullIndexes(sortedPoints),
	        lowerIndexes = computeUpperHullIndexes(flippedPoints);
	
	    // Construct the hull polygon, removing possible duplicate endpoints.
	    var skipLeft = lowerIndexes[0] === upperIndexes[0],
	        skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
	        hull = [];
	
	    // Add upper hull in right-to-l order.
	    // Then add lower hull in left-to-right order.
	    for (i = upperIndexes.length - 1; i >= 0; --i) {
	        hull.push(points[sortedPoints[upperIndexes[i]][2]]);
	    }for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) {
	        hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
	    }return hull;
	};
	
	var _cross = __webpack_require__(397);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function lexicographicOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	}
	
	// Computes the upper convex hull per the monotone chain algorithm.
	// Assumes points.length >= 3, is sorted by x, unique in y.
	// Returns an array of indices into points in left-to-right order.
	function computeUpperHullIndexes(points) {
	    var n = points.length,
	        indexes = [0, 1],
	        size = 2;
	
	    for (var i = 2; i < n; ++i) {
	        while (size > 1 && (0, _cross2.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) {
	            --size;
	        }indexes[size++] = i;
	    }
	
	    return indexes.slice(0, size); // remove popped points
	}

/***/ },
/* 399 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (polygon) {
	  var i = -1,
	      n = polygon.length,
	      b = polygon[n - 1],
	      xa,
	      ya,
	      xb = b[0],
	      yb = b[1],
	      perimeter = 0;
	
	  while (++i < n) {
	    xa = xb;
	    ya = yb;
	    b = polygon[i];
	    xb = b[0];
	    yb = b[1];
	    xa -= xb;
	    ya -= yb;
	    perimeter += Math.sqrt(xa * xa + ya * ya);
	  }
	
	  return perimeter;
	};

/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	};
	
	exports.addAll = addAll;
	
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = { data: d },
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d,
	      i,
	      n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}

/***/ },
/* 401 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	      var z = x1 - x0,
	          node = this._root,
	          parent,
	          i;
	
	      switch (i = (y < (y0 + y1) / 2) << 1 | x < (x0 + x1) / 2) {
	        case 0:
	          {
	            do {
	              parent = new Array(4), parent[i] = node, node = parent;
	            } while ((z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1));
	            break;
	          }
	        case 1:
	          {
	            do {
	              parent = new Array(4), parent[i] = node, node = parent;
	            } while ((z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1));
	            break;
	          }
	        case 2:
	          {
	            do {
	              parent = new Array(4), parent[i] = node, node = parent;
	            } while ((z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y));
	            break;
	          }
	        case 3:
	          {
	            do {
	              parent = new Array(4), parent[i] = node, node = parent;
	            } while ((z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y));
	            break;
	          }
	      }
	
	      if (this._root && this._root.length) this._root = node;
	    }
	
	    // If the quadtree covers the point already, just return.
	    else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	};

/***/ },
/* 402 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var data = [];
	  this.visit(function (node) {
	    if (!node.length) do {
	      data.push(node.data);
	    } while (node = node.next);
	  });
	  return data;
	};

/***/ },
/* 403 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_) {
	    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	};

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new _quad2.default(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(new _quad2.default(node[3], xm, ym, x2, y2), new _quad2.default(node[2], x1, ym, xm, y2), new _quad2.default(node[1], xm, y1, x2, ym), new _quad2.default(node[0], x1, y1, xm, ym));
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | x >= xm) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	        var dx = x - +this._x.call(null, node.data),
	            dy = y - +this._y.call(null, node.data),
	            d2 = dx * dx + dy * dy;
	        if (d2 < radius) {
	          var d = Math.sqrt(radius = d2);
	          x0 = x - d, y0 = y - d;
	          x3 = x + d, y3 = y + d;
	          data = node.data;
	        }
	      }
	  }
	
	  return data;
	};
	
	var _quad = __webpack_require__(106);
	
	var _quad2 = _interopRequireDefault(_quad);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quadtree;
	
	var _add = __webpack_require__(400);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _cover = __webpack_require__(401);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _data = __webpack_require__(402);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _extent = __webpack_require__(403);
	
	var _extent2 = _interopRequireDefault(_extent);
	
	var _find = __webpack_require__(404);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _remove = __webpack_require__(406);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _root = __webpack_require__(407);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _size = __webpack_require__(408);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _visit = __webpack_require__(409);
	
	var _visit2 = _interopRequireDefault(_visit);
	
	var _visitAfter = __webpack_require__(410);
	
	var _visitAfter2 = _interopRequireDefault(_visitAfter);
	
	var _x = __webpack_require__(411);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _y = __webpack_require__(412);
	
	var _y2 = _interopRequireDefault(_y);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? _x.defaultX : x, y == null ? _y.defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = { data: leaf.data },
	      next = copy;
	  while (leaf = leaf.next) {
	    next = next.next = { data: leaf.data };
	  }return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function () {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{ source: node, target: copy._root = new Array(4) }];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({ source: child, target: node.target[i] = new Array(4) });else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = _add2.default;
	treeProto.addAll = _add.addAll;
	treeProto.cover = _cover2.default;
	treeProto.data = _data2.default;
	treeProto.extent = _extent2.default;
	treeProto.find = _find2.default;
	treeProto.remove = _remove2.default;
	treeProto.removeAll = _remove.removeAll;
	treeProto.root = _root2.default;
	treeProto.size = _size2.default;
	treeProto.visit = _visit2.default;
	treeProto.visitAfter = _visitAfter2.default;
	treeProto.x = _x2.default;
	treeProto.y = _y2.default;

/***/ },
/* 406 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) {
	    if (!(previous = node, node = node.next)) return this;
	  }if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return next ? previous.next = next : delete previous.next, this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
	    if (retainer) retainer[j] = node;else this._root = node;
	  }
	
	  return this;
	};
	
	exports.removeAll = removeAll;
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) {
	    this.remove(data[i]);
	  }return this;
	}

/***/ },
/* 407 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return this._root;
	};

/***/ },
/* 408 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var size = 0;
	  this.visit(function (node) {
	    if (!node.length) do {
	      ++size;
	    } while (node = node.next);
	  });
	  return size;
	};

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback) {
	  var quads = [],
	      q,
	      node = this._root,
	      child,
	      x0,
	      y0,
	      x1,
	      y1;
	  if (node) quads.push(new _quad2.default(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2,
	          ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new _quad2.default(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new _quad2.default(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new _quad2.default(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new _quad2.default(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	};
	
	var _quad = __webpack_require__(106);
	
	var _quad2 = _interopRequireDefault(_quad);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback) {
	  var quads = [],
	      next = [],
	      q;
	  if (this._root) quads.push(new _quad2.default(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child,
	          x0 = q.x0,
	          y0 = q.y0,
	          x1 = q.x1,
	          y1 = q.y1,
	          xm = (x0 + x1) / 2,
	          ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new _quad2.default(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new _quad2.default(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new _quad2.default(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new _quad2.default(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	};
	
	var _quad = __webpack_require__(106);
	
	var _quad2 = _interopRequireDefault(_quad);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 411 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultX = defaultX;
	
	exports.default = function (_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	};
	
	function defaultX(d) {
	  return d[0];
	}

/***/ },
/* 412 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultY = defaultY;
	
	exports.default = function (_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	};
	
	function defaultY(d) {
	  return d[1];
	}

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uniform = __webpack_require__(417);
	
	Object.defineProperty(exports, "randomUniform", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_uniform).default;
	  }
	});
	
	var _normal = __webpack_require__(183);
	
	Object.defineProperty(exports, "randomNormal", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_normal).default;
	  }
	});
	
	var _logNormal = __webpack_require__(416);
	
	Object.defineProperty(exports, "randomLogNormal", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_logNormal).default;
	  }
	});
	
	var _bates = __webpack_require__(414);
	
	Object.defineProperty(exports, "randomBates", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bates).default;
	  }
	});
	
	var _irwinHall = __webpack_require__(182);
	
	Object.defineProperty(exports, "randomIrwinHall", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_irwinHall).default;
	  }
	});
	
	var _exponential = __webpack_require__(415);
	
	Object.defineProperty(exports, "randomExponential", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_exponential).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultSource = __webpack_require__(37);
	
	var _defaultSource2 = _interopRequireDefault(_defaultSource);
	
	var _irwinHall = __webpack_require__(182);
	
	var _irwinHall2 = _interopRequireDefault(_irwinHall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function sourceRandomBates(source) {
	  function randomBates(n) {
	    var randomIrwinHall = _irwinHall2.default.source(source)(n);
	    return function () {
	      return randomIrwinHall() / n;
	    };
	  }
	
	  randomBates.source = sourceRandomBates;
	
	  return randomBates;
	}(_defaultSource2.default);

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultSource = __webpack_require__(37);
	
	var _defaultSource2 = _interopRequireDefault(_defaultSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function sourceRandomExponential(source) {
	  function randomExponential(lambda) {
	    return function () {
	      return -Math.log(1 - source()) / lambda;
	    };
	  }
	
	  randomExponential.source = sourceRandomExponential;
	
	  return randomExponential;
	}(_defaultSource2.default);

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultSource = __webpack_require__(37);
	
	var _defaultSource2 = _interopRequireDefault(_defaultSource);
	
	var _normal = __webpack_require__(183);
	
	var _normal2 = _interopRequireDefault(_normal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function sourceRandomLogNormal(source) {
	  function randomLogNormal() {
	    var randomNormal = _normal2.default.source(source).apply(this, arguments);
	    return function () {
	      return Math.exp(randomNormal());
	    };
	  }
	
	  randomLogNormal.source = sourceRandomLogNormal;
	
	  return randomLogNormal;
	}(_defaultSource2.default);

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultSource = __webpack_require__(37);
	
	var _defaultSource2 = _interopRequireDefault(_defaultSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function sourceRandomUniform(source) {
	  function randomUniform(min, max) {
	    min = min == null ? 0 : +min;
	    max = max == null ? 1 : +max;
	    if (arguments.length === 1) max = min, min = 0;else max -= min;
	    return function () {
	      return source() * max + min;
	    };
	  }
	
	  randomUniform.source = sourceRandomUniform;
	
	  return randomUniform;
	}(_defaultSource2.default);

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _category = __webpack_require__(427);
	
	Object.defineProperty(exports, "schemeCategory10", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_category).default;
	  }
	});
	
	var _Accent = __webpack_require__(419);
	
	Object.defineProperty(exports, "schemeAccent", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Accent).default;
	  }
	});
	
	var _Dark = __webpack_require__(420);
	
	Object.defineProperty(exports, "schemeDark2", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dark).default;
	  }
	});
	
	var _Paired = __webpack_require__(421);
	
	Object.defineProperty(exports, "schemePaired", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Paired).default;
	  }
	});
	
	var _Pastel = __webpack_require__(422);
	
	Object.defineProperty(exports, "schemePastel1", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pastel).default;
	  }
	});
	
	var _Pastel2 = __webpack_require__(423);
	
	Object.defineProperty(exports, "schemePastel2", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pastel2).default;
	  }
	});
	
	var _Set = __webpack_require__(424);
	
	Object.defineProperty(exports, "schemeSet1", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Set).default;
	  }
	});
	
	var _Set2 = __webpack_require__(425);
	
	Object.defineProperty(exports, "schemeSet2", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Set2).default;
	  }
	});
	
	var _Set3 = __webpack_require__(426);
	
	Object.defineProperty(exports, "schemeSet3", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Set3).default;
	  }
	});
	
	var _BrBG = __webpack_require__(428);
	
	Object.defineProperty(exports, "interpolateBrBG", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BrBG).default;
	  }
	});
	Object.defineProperty(exports, "schemeBrBG", {
	  enumerable: true,
	  get: function get() {
	    return _BrBG.scheme;
	  }
	});
	
	var _PRGn = __webpack_require__(429);
	
	Object.defineProperty(exports, "interpolatePRGn", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PRGn).default;
	  }
	});
	Object.defineProperty(exports, "schemePRGn", {
	  enumerable: true,
	  get: function get() {
	    return _PRGn.scheme;
	  }
	});
	
	var _PiYG = __webpack_require__(430);
	
	Object.defineProperty(exports, "interpolatePiYG", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PiYG).default;
	  }
	});
	Object.defineProperty(exports, "schemePiYG", {
	  enumerable: true,
	  get: function get() {
	    return _PiYG.scheme;
	  }
	});
	
	var _PuOr = __webpack_require__(431);
	
	Object.defineProperty(exports, "interpolatePuOr", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PuOr).default;
	  }
	});
	Object.defineProperty(exports, "schemePuOr", {
	  enumerable: true,
	  get: function get() {
	    return _PuOr.scheme;
	  }
	});
	
	var _RdBu = __webpack_require__(432);
	
	Object.defineProperty(exports, "interpolateRdBu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RdBu).default;
	  }
	});
	Object.defineProperty(exports, "schemeRdBu", {
	  enumerable: true,
	  get: function get() {
	    return _RdBu.scheme;
	  }
	});
	
	var _RdGy = __webpack_require__(433);
	
	Object.defineProperty(exports, "interpolateRdGy", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RdGy).default;
	  }
	});
	Object.defineProperty(exports, "schemeRdGy", {
	  enumerable: true,
	  get: function get() {
	    return _RdGy.scheme;
	  }
	});
	
	var _RdYlBu = __webpack_require__(434);
	
	Object.defineProperty(exports, "interpolateRdYlBu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RdYlBu).default;
	  }
	});
	Object.defineProperty(exports, "schemeRdYlBu", {
	  enumerable: true,
	  get: function get() {
	    return _RdYlBu.scheme;
	  }
	});
	
	var _RdYlGn = __webpack_require__(435);
	
	Object.defineProperty(exports, "interpolateRdYlGn", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RdYlGn).default;
	  }
	});
	Object.defineProperty(exports, "schemeRdYlGn", {
	  enumerable: true,
	  get: function get() {
	    return _RdYlGn.scheme;
	  }
	});
	
	var _Spectral = __webpack_require__(436);
	
	Object.defineProperty(exports, "interpolateSpectral", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spectral).default;
	  }
	});
	Object.defineProperty(exports, "schemeSpectral", {
	  enumerable: true,
	  get: function get() {
	    return _Spectral.scheme;
	  }
	});
	
	var _BuGn = __webpack_require__(437);
	
	Object.defineProperty(exports, "interpolateBuGn", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BuGn).default;
	  }
	});
	Object.defineProperty(exports, "schemeBuGn", {
	  enumerable: true,
	  get: function get() {
	    return _BuGn.scheme;
	  }
	});
	
	var _BuPu = __webpack_require__(438);
	
	Object.defineProperty(exports, "interpolateBuPu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BuPu).default;
	  }
	});
	Object.defineProperty(exports, "schemeBuPu", {
	  enumerable: true,
	  get: function get() {
	    return _BuPu.scheme;
	  }
	});
	
	var _GnBu = __webpack_require__(439);
	
	Object.defineProperty(exports, "interpolateGnBu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GnBu).default;
	  }
	});
	Object.defineProperty(exports, "schemeGnBu", {
	  enumerable: true,
	  get: function get() {
	    return _GnBu.scheme;
	  }
	});
	
	var _OrRd = __webpack_require__(440);
	
	Object.defineProperty(exports, "interpolateOrRd", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OrRd).default;
	  }
	});
	Object.defineProperty(exports, "schemeOrRd", {
	  enumerable: true,
	  get: function get() {
	    return _OrRd.scheme;
	  }
	});
	
	var _PuBuGn = __webpack_require__(442);
	
	Object.defineProperty(exports, "interpolatePuBuGn", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PuBuGn).default;
	  }
	});
	Object.defineProperty(exports, "schemePuBuGn", {
	  enumerable: true,
	  get: function get() {
	    return _PuBuGn.scheme;
	  }
	});
	
	var _PuBu = __webpack_require__(441);
	
	Object.defineProperty(exports, "interpolatePuBu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PuBu).default;
	  }
	});
	Object.defineProperty(exports, "schemePuBu", {
	  enumerable: true,
	  get: function get() {
	    return _PuBu.scheme;
	  }
	});
	
	var _PuRd = __webpack_require__(443);
	
	Object.defineProperty(exports, "interpolatePuRd", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PuRd).default;
	  }
	});
	Object.defineProperty(exports, "schemePuRd", {
	  enumerable: true,
	  get: function get() {
	    return _PuRd.scheme;
	  }
	});
	
	var _RdPu = __webpack_require__(444);
	
	Object.defineProperty(exports, "interpolateRdPu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RdPu).default;
	  }
	});
	Object.defineProperty(exports, "schemeRdPu", {
	  enumerable: true,
	  get: function get() {
	    return _RdPu.scheme;
	  }
	});
	
	var _YlGnBu = __webpack_require__(446);
	
	Object.defineProperty(exports, "interpolateYlGnBu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YlGnBu).default;
	  }
	});
	Object.defineProperty(exports, "schemeYlGnBu", {
	  enumerable: true,
	  get: function get() {
	    return _YlGnBu.scheme;
	  }
	});
	
	var _YlGn = __webpack_require__(445);
	
	Object.defineProperty(exports, "interpolateYlGn", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YlGn).default;
	  }
	});
	Object.defineProperty(exports, "schemeYlGn", {
	  enumerable: true,
	  get: function get() {
	    return _YlGn.scheme;
	  }
	});
	
	var _YlOrBr = __webpack_require__(447);
	
	Object.defineProperty(exports, "interpolateYlOrBr", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YlOrBr).default;
	  }
	});
	Object.defineProperty(exports, "schemeYlOrBr", {
	  enumerable: true,
	  get: function get() {
	    return _YlOrBr.scheme;
	  }
	});
	
	var _YlOrRd = __webpack_require__(448);
	
	Object.defineProperty(exports, "interpolateYlOrRd", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YlOrRd).default;
	  }
	});
	Object.defineProperty(exports, "schemeYlOrRd", {
	  enumerable: true,
	  get: function get() {
	    return _YlOrRd.scheme;
	  }
	});
	
	var _Blues = __webpack_require__(452);
	
	Object.defineProperty(exports, "interpolateBlues", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Blues).default;
	  }
	});
	Object.defineProperty(exports, "schemeBlues", {
	  enumerable: true,
	  get: function get() {
	    return _Blues.scheme;
	  }
	});
	
	var _Greens = __webpack_require__(453);
	
	Object.defineProperty(exports, "interpolateGreens", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Greens).default;
	  }
	});
	Object.defineProperty(exports, "schemeGreens", {
	  enumerable: true,
	  get: function get() {
	    return _Greens.scheme;
	  }
	});
	
	var _Greys = __webpack_require__(454);
	
	Object.defineProperty(exports, "interpolateGreys", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Greys).default;
	  }
	});
	Object.defineProperty(exports, "schemeGreys", {
	  enumerable: true,
	  get: function get() {
	    return _Greys.scheme;
	  }
	});
	
	var _Purples = __webpack_require__(456);
	
	Object.defineProperty(exports, "interpolatePurples", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Purples).default;
	  }
	});
	Object.defineProperty(exports, "schemePurples", {
	  enumerable: true,
	  get: function get() {
	    return _Purples.scheme;
	  }
	});
	
	var _Reds = __webpack_require__(457);
	
	Object.defineProperty(exports, "interpolateReds", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Reds).default;
	  }
	});
	Object.defineProperty(exports, "schemeReds", {
	  enumerable: true,
	  get: function get() {
	    return _Reds.scheme;
	  }
	});
	
	var _Oranges = __webpack_require__(455);
	
	Object.defineProperty(exports, "interpolateOranges", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Oranges).default;
	  }
	});
	Object.defineProperty(exports, "schemeOranges", {
	  enumerable: true,
	  get: function get() {
	    return _Oranges.scheme;
	  }
	});
	
	var _cubehelix = __webpack_require__(449);
	
	Object.defineProperty(exports, "interpolateCubehelixDefault", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cubehelix).default;
	  }
	});
	
	var _rainbow = __webpack_require__(450);
	
	Object.defineProperty(exports, "interpolateRainbow", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_rainbow).default;
	  }
	});
	Object.defineProperty(exports, "interpolateWarm", {
	  enumerable: true,
	  get: function get() {
	    return _rainbow.warm;
	  }
	});
	Object.defineProperty(exports, "interpolateCool", {
	  enumerable: true,
	  get: function get() {
	    return _rainbow.cool;
	  }
	});
	
	var _viridis = __webpack_require__(451);
	
	Object.defineProperty(exports, "interpolateViridis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_viridis).default;
	  }
	});
	Object.defineProperty(exports, "interpolateMagma", {
	  enumerable: true,
	  get: function get() {
	    return _viridis.magma;
	  }
	});
	Object.defineProperty(exports, "interpolateInferno", {
	  enumerable: true,
	  get: function get() {
	    return _viridis.inferno;
	  }
	});
	Object.defineProperty(exports, "interpolatePlasma", {
	  enumerable: true,
	  get: function get() {
	    return _viridis.plasma;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _colors2.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Color = __webpack_require__(18);
	
	var _d3Interpolate = __webpack_require__(14);
	
	exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cool = exports.warm = undefined;
	
	exports.default = function (t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	var _d3Color = __webpack_require__(18);
	
	var _d3Interpolate = __webpack_require__(14);
	
	var warm = exports.warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
	
	var cool = exports.cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
	
	var rainbow = (0, _d3Color.cubehelix)();

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.plasma = exports.inferno = exports.magma = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ramp(range) {
	  var n = range.length;
	  return function (t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	exports.default = ramp((0, _colors2.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	var magma = exports.magma = ramp((0, _colors2.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = exports.inferno = ramp((0, _colors2.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = exports.plasma = ramp((0, _colors2.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheme = undefined;
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ramp = __webpack_require__(5);
	
	var _ramp2 = _interopRequireDefault(_ramp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheme = exports.scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(_colors2.default);
	
	exports.default = (0, _ramp2.default)(scheme);

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _band = __webpack_require__(459);
	
	Object.defineProperty(exports, "scaleBand", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_band).default;
	  }
	});
	Object.defineProperty(exports, "scalePoint", {
	  enumerable: true,
	  get: function get() {
	    return _band.point;
	  }
	});
	
	var _identity = __webpack_require__(460);
	
	Object.defineProperty(exports, "scaleIdentity", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_identity).default;
	  }
	});
	
	var _linear = __webpack_require__(46);
	
	Object.defineProperty(exports, "scaleLinear", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_linear).default;
	  }
	});
	
	var _log = __webpack_require__(461);
	
	Object.defineProperty(exports, "scaleLog", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_log).default;
	  }
	});
	
	var _ordinal = __webpack_require__(186);
	
	Object.defineProperty(exports, "scaleOrdinal", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ordinal).default;
	  }
	});
	Object.defineProperty(exports, "scaleImplicit", {
	  enumerable: true,
	  get: function get() {
	    return _ordinal.implicit;
	  }
	});
	
	var _pow = __webpack_require__(462);
	
	Object.defineProperty(exports, "scalePow", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pow).default;
	  }
	});
	Object.defineProperty(exports, "scaleSqrt", {
	  enumerable: true,
	  get: function get() {
	    return _pow.sqrt;
	  }
	});
	
	var _quantile = __webpack_require__(463);
	
	Object.defineProperty(exports, "scaleQuantile", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantile).default;
	  }
	});
	
	var _quantize = __webpack_require__(464);
	
	Object.defineProperty(exports, "scaleQuantize", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantize).default;
	  }
	});
	
	var _threshold = __webpack_require__(466);
	
	Object.defineProperty(exports, "scaleThreshold", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_threshold).default;
	  }
	});
	
	var _time = __webpack_require__(187);
	
	Object.defineProperty(exports, "scaleTime", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_time).default;
	  }
	});
	
	var _utcTime = __webpack_require__(468);
	
	Object.defineProperty(exports, "scaleUtc", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utcTime).default;
	  }
	});
	
	var _sequential = __webpack_require__(465);
	
	Object.defineProperty(exports, "scaleSequential", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sequential).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = band;
	exports.point = point;
	
	var _d3Array = __webpack_require__(9);
	
	var _ordinal = __webpack_require__(186);
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function band() {
	  var scale = (0, _ordinal2.default)().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = (0, _d3Array.range)(n).map(function (i) {
	      return start + step * i;
	    });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function (_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function (_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function (_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function () {
	    return bandwidth;
	  };
	
	  scale.step = function () {
	    return step;
	  };
	
	  scale.round = function (_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function (_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function (_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function (_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function (_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function () {
	    return band().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function () {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = identity;
	
	var _array = __webpack_require__(29);
	
	var _linear = __webpack_require__(46);
	
	var _number = __webpack_require__(185);
	
	var _number2 = _interopRequireDefault(_number);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function (_) {
	    return arguments.length ? (domain = _array.map.call(_, _number2.default), scale) : domain.slice();
	  };
	
	  scale.copy = function () {
	    return identity().domain(domain);
	  };
	
	  return (0, _linear.linearish)(scale);
	}

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	var _d3Array = __webpack_require__(9);
	
	var _d3Format = __webpack_require__(93);
	
	var _constant = __webpack_require__(107);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _nice = __webpack_require__(184);
	
	var _nice2 = _interopRequireDefault(_nice);
	
	var _continuous = __webpack_require__(66);
	
	var _continuous2 = _interopRequireDefault(_continuous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a)) ? function (x) {
	    return Math.log(x / a) / b;
	  } : (0, _constant2.default)(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0 ? function (t) {
	    return -Math.pow(-b, t) * Math.pow(-a, 1 - t);
	  } : function (t) {
	    return Math.pow(b, t) * Math.pow(a, 1 - t);
	  };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10 : base === Math.E ? Math.exp : function (x) {
	    return Math.pow(base, x);
	  };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function (x) {
	    return Math.log(x) / base;
	  });
	}
	
	function reflect(f) {
	  return function (x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = (0, _continuous2.default)(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function (_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function (_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function (count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function (count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = (0, _d3Format.format)(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function (d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function () {
	    return domain((0, _nice2.default)(domain(), {
	      floor: function floor(x) {
	        return pows(Math.floor(logs(x)));
	      },
	      ceil: function ceil(x) {
	        return pows(Math.ceil(logs(x)));
	      }
	    }));
	  };
	
	  scale.copy = function () {
	    return (0, _continuous.copy)(scale, log().base(base));
	  };
	
	  return scale;
	}

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pow;
	exports.sqrt = sqrt;
	
	var _constant = __webpack_require__(107);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _linear = __webpack_require__(46);
	
	var _continuous = __webpack_require__(66);
	
	var _continuous2 = _interopRequireDefault(_continuous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = (0, _continuous2.default)(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent))) ? function (x) {
	      return (raise(x, exponent) - a) / b;
	    } : (0, _constant2.default)(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function (t) {
	      return raise(a + b * t, 1 / exponent);
	    };
	  }
	
	  scale.exponent = function (_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function () {
	    return (0, _continuous.copy)(scale, pow().exponent(exponent));
	  };
	
	  return (0, _linear.linearish)(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quantile;
	
	var _d3Array = __webpack_require__(9);
	
	var _array = __webpack_require__(29);
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0,
	        n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) {
	      thresholds[i - 1] = (0, _d3Array.quantile)(domain, i / n);
	    }return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range[(0, _d3Array.bisect)(thresholds, x)];
	  }
	
	  scale.invertExtent = function (y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
	  };
	
	  scale.domain = function (_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) {
	      if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    }domain.sort(_d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function (_) {
	    return arguments.length ? (range = _array.slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.quantiles = function () {
	    return thresholds.slice();
	  };
	
	  scale.copy = function () {
	    return quantile().domain(domain).range(range);
	  };
	
	  return scale;
	}

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quantize;
	
	var _d3Array = __webpack_require__(9);
	
	var _array = __webpack_require__(29);
	
	var _linear = __webpack_require__(46);
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range[(0, _d3Array.bisect)(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) {
	      domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    }return scale;
	  }
	
	  scale.domain = function (_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function (_) {
	    return arguments.length ? (n = (range = _array.slice.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function (y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function () {
	    return quantize().domain([x0, x1]).range(range);
	  };
	
	  return (0, _linear.linearish)(scale);
	}

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sequential;
	
	var _linear = __webpack_require__(46);
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function (_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function (_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function (_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function () {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return (0, _linear.linearish)(scale);
	}

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = threshold;
	
	var _d3Array = __webpack_require__(9);
	
	var _array = __webpack_require__(29);
	
	function threshold() {
	  var domain = [0.5],
	      range = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range[(0, _d3Array.bisect)(domain, x, 0, n)];
	  }
	
	  scale.domain = function (_) {
	    return arguments.length ? (domain = _array.slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function (_) {
	    return arguments.length ? (range = _array.slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function (y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function () {
	    return threshold().domain(domain).range(range);
	  };
	
	  return scale;
	}

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = (0, _d3Array.tickStep)(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s":
	      {
	        var value = Math.max(Math.abs(start), Math.abs(stop));
	        if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
	        return (0, _d3Format.formatPrefix)(specifier, value);
	      }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r":
	      {
	        if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	        break;
	      }
	    case "f":
	    case "%":
	      {
	        if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	        break;
	      }
	  }
	  return (0, _d3Format.format)(specifier);
	};
	
	var _d3Array = __webpack_require__(9);
	
	var _d3Format = __webpack_require__(93);

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return (0, _time.calendar)(_d3Time.utcYear, _d3Time.utcMonth, _d3Time.utcWeek, _d3Time.utcDay, _d3Time.utcHour, _d3Time.utcMinute, _d3Time.utcSecond, _d3Time.utcMillisecond, _d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var _time = __webpack_require__(187);
	
	var _d3TimeFormat = __webpack_require__(118);
	
	var _d3Time = __webpack_require__(73);

/***/ },
/* 469 */
35,
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name) {
	  return (0, _select2.default)((0, _creator2.default)(name).call(document.documentElement));
	};
	
	var _creator = __webpack_require__(67);
	
	var _creator2 = _interopRequireDefault(_creator);
	
	var _select = __webpack_require__(189);
	
	var _select2 = _interopRequireDefault(_select);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 471 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = local;
	var nextId = 0;
	
	function local() {
	  return new Local();
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function get(node) {
	    var id = this._;
	    while (!(id in node)) {
	      if (!(node = node.parentNode)) return;
	    }return node[id];
	  },
	  set: function set(node, value) {
	    return node[this._] = value;
	  },
	  remove: function remove(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function toString() {
	    return this._;
	  }
	};

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node) {
	  var event = (0, _sourceEvent2.default)();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return (0, _point2.default)(node, event);
	};
	
	var _sourceEvent = __webpack_require__(112);
	
	var _sourceEvent2 = _interopRequireDefault(_sourceEvent);
	
	var _point = __webpack_require__(68);
	
	var _point2 = _interopRequireDefault(_point);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (selector) {
	    return typeof selector === "string" ? new _index.Selection([document.querySelectorAll(selector)], [document.documentElement]) : new _index.Selection([selector == null ? [] : selector], _index.root);
	};
	
	var _index = __webpack_require__(16);

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name) {
	  var create = typeof name === "function" ? name : (0, _creator2.default)(name);
	  return this.select(function () {
	    return this.appendChild(create.apply(this, arguments));
	  });
	};
	
	var _creator = __webpack_require__(67);
	
	var _creator2 = _interopRequireDefault(_creator);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value) {
	  var fullname = (0, _namespace2.default)(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
	};
	
	var _namespace = __webpack_require__(108);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function attrRemove(name) {
	  return function () {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function () {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function () {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function () {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function () {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function () {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}

/***/ },
/* 476 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	};

/***/ },
/* 477 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()),
	        i = -1,
	        n = names.length;
	    while (++i < n) {
	      if (!list.contains(names[i])) return false;
	    }return true;
	  }
	
	  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
	};
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function add(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function remove(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function contains(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node),
	      i = -1,
	      n = names.length;
	  while (++i < n) {
	    list.add(names[i]);
	  }
	}
	
	function classedRemove(node, names) {
	  var list = classList(node),
	      i = -1,
	      n = names.length;
	  while (++i < n) {
	    list.remove(names[i]);
	  }
	}
	
	function classedTrue(names) {
	  return function () {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function () {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function () {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}

/***/ },
/* 478 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (deep) {
	  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
	};
	
	function selection_cloneShallow() {
	  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
	}
	
	function selection_cloneDeep() {
	  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
	}

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function (d) {
	      data[++j] = d;
	    });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = (0, _constant2.default)(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength) {}
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new _index.Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	};
	
	var _index = __webpack_require__(16);
	
	var _enter = __webpack_require__(190);
	
	var _constant = __webpack_require__(469);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new _enter.EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new _enter.EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) {
	      exit[i] = node;
	    }
	  }
	}

/***/ },
/* 480 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (value) {
	    return arguments.length ? this.property("__data__", value) : this.node().__data__;
	};

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (type, params) {
	  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
	};
	
	var _window = __webpack_require__(113);
	
	var _window2 = _interopRequireDefault(_window);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dispatchEvent(node, type, params) {
	  var window = (0, _window2.default)(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function () {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function () {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}

/***/ },
/* 482 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	};

/***/ },
/* 483 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return !this.node();
	};

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return new _index.Selection(this._exit || this._groups.map(_sparse2.default), this._parents);
	};
	
	var _sparse = __webpack_require__(191);
	
	var _sparse2 = _interopRequireDefault(_sparse);
	
	var _index = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (match) {
	  if (typeof match !== "function") match = (0, _matcher2.default)(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new _index.Selection(subgroups, this._parents);
	};
	
	var _index = __webpack_require__(16);
	
	var _matcher = __webpack_require__(188);
	
	var _matcher2 = _interopRequireDefault(_matcher);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 486 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
	};
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function () {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function () {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, before) {
	  var create = typeof name === "function" ? name : (0, _creator2.default)(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : (0, _selector2.default)(before);
	  return this.select(function () {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	};
	
	var _creator = __webpack_require__(67);
	
	var _creator2 = _interopRequireDefault(_creator);
	
	var _selector = __webpack_require__(111);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function constantNull() {
	  return null;
	}

/***/ },
/* 488 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return this.each(lower);
	};
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new _index.Selection(merges, this._parents);
	};
	
	var _index = __webpack_require__(16);

/***/ },
/* 490 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	};

/***/ },
/* 491 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var nodes = new Array(this.size()),
	      i = -1;
	  this.each(function () {
	    nodes[++i] = this;
	  });
	  return nodes;
	};

/***/ },
/* 492 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	};

/***/ },
/* 493 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value) {
	  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
	};
	
	function propertyRemove(name) {
	  return function () {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function () {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function () {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];else this[name] = v;
	  };
	}

/***/ },
/* 494 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return this.each(raise);
	};
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}

/***/ },
/* 495 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return this.each(remove);
	};
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (select) {
	  if (typeof select !== "function") select = (0, _selector2.default)(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new _index.Selection(subgroups, this._parents);
	};
	
	var _index = __webpack_require__(16);
	
	var _selector = __webpack_require__(111);
	
	var _selector2 = _interopRequireDefault(_selector);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (select) {
	  if (typeof select !== "function") select = (0, _selectorAll2.default)(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new _index.Selection(subgroups, parents);
	};
	
	var _index = __webpack_require__(16);
	
	var _selectorAll = __webpack_require__(193);
	
	var _selectorAll2 = _interopRequireDefault(_selectorAll);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 498 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var size = 0;
	  this.each(function () {
	    ++size;
	  });
	  return size;
	};

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new _index.Selection(sortgroups, this._parents).order();
	};
	
	var _index = __webpack_require__(16);
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}

/***/ },
/* 500 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
	};
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function () {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function () {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = (0, _sourceEvent2.default)().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return (0, _point2.default)(node, touch);
	    }
	  }
	
	  return null;
	};
	
	var _sourceEvent = __webpack_require__(112);
	
	var _sourceEvent2 = _interopRequireDefault(_sourceEvent);
	
	var _point = __webpack_require__(68);
	
	var _point2 = _interopRequireDefault(_point);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, touches) {
	  if (touches == null) touches = (0, _sourceEvent2.default)().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = (0, _point2.default)(node, touches[i]);
	  }
	
	  return points;
	};
	
	var _sourceEvent = __webpack_require__(112);
	
	var _sourceEvent2 = _interopRequireDefault(_sourceEvent);
	
	var _point = __webpack_require__(68);
	
	var _point2 = _interopRequireDefault(_point);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arc = __webpack_require__(504);
	
	Object.defineProperty(exports, "arc", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_arc).default;
	  }
	});
	
	var _area = __webpack_require__(194);
	
	Object.defineProperty(exports, "area", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_area).default;
	  }
	});
	
	var _line = __webpack_require__(115);
	
	Object.defineProperty(exports, "line", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_line).default;
	  }
	});
	
	var _pie = __webpack_require__(525);
	
	Object.defineProperty(exports, "pie", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pie).default;
	  }
	});
	
	var _areaRadial = __webpack_require__(505);
	
	Object.defineProperty(exports, "areaRadial", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_areaRadial).default;
	  }
	});
	Object.defineProperty(exports, "radialArea", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_areaRadial).default;
	  }
	});
	
	var _lineRadial = __webpack_require__(199);
	
	Object.defineProperty(exports, "lineRadial", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lineRadial).default;
	  }
	});
	Object.defineProperty(exports, "radialLine", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lineRadial).default;
	  }
	});
	
	var _pointRadial = __webpack_require__(200);
	
	Object.defineProperty(exports, "pointRadial", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pointRadial).default;
	  }
	});
	
	var _index = __webpack_require__(517);
	
	Object.defineProperty(exports, "linkHorizontal", {
	  enumerable: true,
	  get: function get() {
	    return _index.linkHorizontal;
	  }
	});
	Object.defineProperty(exports, "linkVertical", {
	  enumerable: true,
	  get: function get() {
	    return _index.linkVertical;
	  }
	});
	Object.defineProperty(exports, "linkRadial", {
	  enumerable: true,
	  get: function get() {
	    return _index.linkRadial;
	  }
	});
	
	var _symbol = __webpack_require__(527);
	
	Object.defineProperty(exports, "symbol", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_symbol).default;
	  }
	});
	Object.defineProperty(exports, "symbols", {
	  enumerable: true,
	  get: function get() {
	    return _symbol.symbols;
	  }
	});
	
	var _circle = __webpack_require__(201);
	
	Object.defineProperty(exports, "symbolCircle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_circle).default;
	  }
	});
	
	var _cross = __webpack_require__(202);
	
	Object.defineProperty(exports, "symbolCross", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cross).default;
	  }
	});
	
	var _diamond = __webpack_require__(203);
	
	Object.defineProperty(exports, "symbolDiamond", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_diamond).default;
	  }
	});
	
	var _square = __webpack_require__(204);
	
	Object.defineProperty(exports, "symbolSquare", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_square).default;
	  }
	});
	
	var _star = __webpack_require__(205);
	
	Object.defineProperty(exports, "symbolStar", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_star).default;
	  }
	});
	
	var _triangle = __webpack_require__(206);
	
	Object.defineProperty(exports, "symbolTriangle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_triangle).default;
	  }
	});
	
	var _wye = __webpack_require__(207);
	
	Object.defineProperty(exports, "symbolWye", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_wye).default;
	  }
	});
	
	var _basisClosed = __webpack_require__(506);
	
	Object.defineProperty(exports, "curveBasisClosed", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_basisClosed).default;
	  }
	});
	
	var _basisOpen = __webpack_require__(507);
	
	Object.defineProperty(exports, "curveBasisOpen", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_basisOpen).default;
	  }
	});
	
	var _basis = __webpack_require__(69);
	
	Object.defineProperty(exports, "curveBasis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_basis).default;
	  }
	});
	
	var _bundle = __webpack_require__(508);
	
	Object.defineProperty(exports, "curveBundle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bundle).default;
	  }
	});
	
	var _cardinalClosed = __webpack_require__(196);
	
	Object.defineProperty(exports, "curveCardinalClosed", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cardinalClosed).default;
	  }
	});
	
	var _cardinalOpen = __webpack_require__(197);
	
	Object.defineProperty(exports, "curveCardinalOpen", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cardinalOpen).default;
	  }
	});
	
	var _cardinal = __webpack_require__(70);
	
	Object.defineProperty(exports, "curveCardinal", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cardinal).default;
	  }
	});
	
	var _catmullRomClosed = __webpack_require__(509);
	
	Object.defineProperty(exports, "curveCatmullRomClosed", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_catmullRomClosed).default;
	  }
	});
	
	var _catmullRomOpen = __webpack_require__(510);
	
	Object.defineProperty(exports, "curveCatmullRomOpen", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_catmullRomOpen).default;
	  }
	});
	
	var _catmullRom = __webpack_require__(114);
	
	Object.defineProperty(exports, "curveCatmullRom", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_catmullRom).default;
	  }
	});
	
	var _linearClosed = __webpack_require__(511);
	
	Object.defineProperty(exports, "curveLinearClosed", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_linearClosed).default;
	  }
	});
	
	var _linear = __webpack_require__(71);
	
	Object.defineProperty(exports, "curveLinear", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_linear).default;
	  }
	});
	
	var _monotone = __webpack_require__(512);
	
	Object.defineProperty(exports, "curveMonotoneX", {
	  enumerable: true,
	  get: function get() {
	    return _monotone.monotoneX;
	  }
	});
	Object.defineProperty(exports, "curveMonotoneY", {
	  enumerable: true,
	  get: function get() {
	    return _monotone.monotoneY;
	  }
	});
	
	var _natural = __webpack_require__(513);
	
	Object.defineProperty(exports, "curveNatural", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_natural).default;
	  }
	});
	
	var _step = __webpack_require__(514);
	
	Object.defineProperty(exports, "curveStep", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_step).default;
	  }
	});
	Object.defineProperty(exports, "curveStepAfter", {
	  enumerable: true,
	  get: function get() {
	    return _step.stepAfter;
	  }
	});
	Object.defineProperty(exports, "curveStepBefore", {
	  enumerable: true,
	  get: function get() {
	    return _step.stepBefore;
	  }
	});
	
	var _stack = __webpack_require__(526);
	
	Object.defineProperty(exports, "stack", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stack).default;
	  }
	});
	
	var _expand = __webpack_require__(519);
	
	Object.defineProperty(exports, "stackOffsetExpand", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_expand).default;
	  }
	});
	
	var _diverging = __webpack_require__(518);
	
	Object.defineProperty(exports, "stackOffsetDiverging", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_diverging).default;
	  }
	});
	
	var _none = __webpack_require__(48);
	
	Object.defineProperty(exports, "stackOffsetNone", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_none).default;
	  }
	});
	
	var _silhouette = __webpack_require__(520);
	
	Object.defineProperty(exports, "stackOffsetSilhouette", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_silhouette).default;
	  }
	});
	
	var _wiggle = __webpack_require__(521);
	
	Object.defineProperty(exports, "stackOffsetWiggle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_wiggle).default;
	  }
	});
	
	var _ascending = __webpack_require__(116);
	
	Object.defineProperty(exports, "stackOrderAscending", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ascending).default;
	  }
	});
	
	var _descending = __webpack_require__(522);
	
	Object.defineProperty(exports, "stackOrderDescending", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_descending).default;
	  }
	});
	
	var _insideOut = __webpack_require__(523);
	
	Object.defineProperty(exports, "stackOrderInsideOut", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_insideOut).default;
	  }
	});
	
	var _none2 = __webpack_require__(49);
	
	Object.defineProperty(exports, "stackOrderNone", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_none2).default;
	  }
	});
	
	var _reverse = __webpack_require__(524);
	
	Object.defineProperty(exports, "stackOrderReverse", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reverse).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = (0, _constant2.default)(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - _math.halfPi,
	        a1 = endAngle.apply(this, arguments) - _math.halfPi,
	        da = (0, _math.abs)(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = (0, _d3Path.path)();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > _math.epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > _math.tau - _math.epsilon) {
	        context.moveTo(r1 * (0, _math.cos)(a0), r1 * (0, _math.sin)(a0));
	        context.arc(0, 0, r1, a0, a1, !cw);
	        if (r0 > _math.epsilon) {
	          context.moveTo(r0 * (0, _math.cos)(a1), r0 * (0, _math.sin)(a1));
	          context.arc(0, 0, r0, a1, a0, cw);
	        }
	      }
	
	      // Or is it a circular or annular sector?
	      else {
	          var a01 = a0,
	              a11 = a1,
	              a00 = a0,
	              a10 = a1,
	              da0 = da,
	              da1 = da,
	              ap = padAngle.apply(this, arguments) / 2,
	              rp = ap > _math.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, _math.sqrt)(r0 * r0 + r1 * r1)),
	              rc = (0, _math.min)((0, _math.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	              rc0 = rc,
	              rc1 = rc,
	              t0,
	              t1;
	
	          // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	          if (rp > _math.epsilon) {
	            var p0 = (0, _math.asin)(rp / r0 * (0, _math.sin)(ap)),
	                p1 = (0, _math.asin)(rp / r1 * (0, _math.sin)(ap));
	            if ((da0 -= p0 * 2) > _math.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	            if ((da1 -= p1 * 2) > _math.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	          }
	
	          var x01 = r1 * (0, _math.cos)(a01),
	              y01 = r1 * (0, _math.sin)(a01),
	              x10 = r0 * (0, _math.cos)(a10),
	              y10 = r0 * (0, _math.sin)(a10);
	
	          // Apply rounded corners?
	          if (rc > _math.epsilon) {
	            var x11 = r1 * (0, _math.cos)(a11),
	                y11 = r1 * (0, _math.sin)(a11),
	                x00 = r0 * (0, _math.cos)(a00),
	                y00 = r0 * (0, _math.sin)(a00);
	
	            // Restrict the corner radius according to the sector angle.
	            if (da < _math.pi) {
	              var oc = da0 > _math.epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	                  ax = x01 - oc[0],
	                  ay = y01 - oc[1],
	                  bx = x11 - oc[0],
	                  by = y11 - oc[1],
	                  kc = 1 / (0, _math.sin)((0, _math.acos)((ax * bx + ay * by) / ((0, _math.sqrt)(ax * ax + ay * ay) * (0, _math.sqrt)(bx * bx + by * by))) / 2),
	                  lc = (0, _math.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
	              rc0 = (0, _math.min)(rc, (r0 - lc) / (kc - 1));
	              rc1 = (0, _math.min)(rc, (r1 - lc) / (kc + 1));
	            }
	          }
	
	          // Is the sector collapsed to a line?
	          if (!(da1 > _math.epsilon)) context.moveTo(x01, y01);
	
	          // Does the sector’s outer ring have rounded corners?
	          else if (rc1 > _math.epsilon) {
	              t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	              t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	              context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	              // Have the corners merged?
	              if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw);
	
	              // Otherwise, draw the two corners and the ring.
	              else {
	                  context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
	                  context.arc(0, 0, r1, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	                  context.arc(t1.cx, t1.cy, rc1, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
	                }
	            }
	
	            // Or is the outer ring just a circular arc?
	            else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	          // Is there no inner ring, and it’s a circular sector?
	          // Or perhaps it’s an annular sector collapsed due to padding?
	          if (!(r0 > _math.epsilon) || !(da0 > _math.epsilon)) context.lineTo(x10, y10);
	
	          // Does the sector’s inner ring (or point) have rounded corners?
	          else if (rc0 > _math.epsilon) {
	              t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	              t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	              context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	              // Have the corners merged?
	              if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw);
	
	              // Otherwise, draw the two corners and the ring.
	              else {
	                  context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
	                  context.arc(0, 0, r0, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	                  context.arc(t1.cx, t1.cy, rc0, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
	                }
	            }
	
	            // Or is the inner ring just a circular arc?
	            else context.arc(0, 0, r0, a10, a00, cw);
	        }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function () {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - _math.pi / 2;
	    return [(0, _math.cos)(a) * r, (0, _math.sin)(a) * r];
	  };
	
	  arc.innerRadius = function (_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constant2.default)(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function (_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constant2.default)(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function (_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constant2.default)(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function (_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constant2.default)(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function (_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function (_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function (_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), arc) : padAngle;
	  };
	
	  arc.context = function (_) {
	    return arguments.length ? (context = _ == null ? null : _, arc) : context;
	  };
	
	  return arc;
	};
	
	var _d3Path = __webpack_require__(28);
	
	var _constant = __webpack_require__(30);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _math = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0,
	      y10 = y1 - y0,
	      x32 = x3 - x2,
	      y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / (0, _math.sqrt)(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * (0, _math.sqrt)((0, _math.max)(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var a = (0, _area2.default)().curve(_radial.curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function () {
	    return (0, _lineRadial.lineRadial)(x0());
	  }, delete a.lineX0;
	  a.lineEndAngle = function () {
	    return (0, _lineRadial.lineRadial)(x1());
	  }, delete a.lineX1;
	  a.lineInnerRadius = function () {
	    return (0, _lineRadial.lineRadial)(y0());
	  }, delete a.lineY0;
	  a.lineOuterRadius = function () {
	    return (0, _lineRadial.lineRadial)(y1());
	  }, delete a.lineY1;
	
	  a.curve = function (_) {
	    return arguments.length ? c((0, _radial2.default)(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var _radial = __webpack_require__(198);
	
	var _radial2 = _interopRequireDefault(_radial);
	
	var _area = __webpack_require__(194);
	
	var _area2 = _interopRequireDefault(_area);
	
	var _lineRadial = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (context) {
	  return new BasisClosed(context);
	};
	
	var _noop = __webpack_require__(72);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _basis = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: _noop2.default,
	  areaEnd: _noop2.default,
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    switch (this._point) {
	      case 1:
	        {
	          this._context.moveTo(this._x2, this._y2);
	          this._context.closePath();
	          break;
	        }
	      case 2:
	        {
	          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	          this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	          this._context.closePath();
	          break;
	        }
	      case 3:
	        {
	          this.point(this._x2, this._y2);
	          this.point(this._x3, this._y3);
	          this.point(this._x4, this._y4);
	          break;
	        }
	    }
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._x2 = x, this._y2 = y;break;
	      case 1:
	        this._point = 2;this._x3 = x, this._y3 = y;break;
	      case 2:
	        this._point = 3;this._x4 = x, this._y4 = y;this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);break;
	      default:
	        (0, _basis.point)(this, x, y);break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (context) {
	  return new BasisOpen(context);
	};
	
	var _basis = __webpack_require__(69);
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;break;
	      case 1:
	        this._point = 2;break;
	      case 2:
	        this._point = 3;var x0 = (this._x0 + 4 * this._x1 + x) / 6,
	            y0 = (this._y0 + 4 * this._y1 + y) / 6;this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);break;
	      case 3:
	        this._point = 4; // proceed
	      default:
	        (0, _basis.point)(this, x, y);break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _basis = __webpack_require__(69);
	
	function Bundle(context, beta) {
	  this._basis = new _basis.Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function lineStart() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function lineEnd() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function point(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	exports.default = function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new _basis.Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function (beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}(0.85);

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardinalClosed = __webpack_require__(196);
	
	var _noop = __webpack_require__(72);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _catmullRom = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: _noop2.default,
	  areaEnd: _noop2.default,
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    switch (this._point) {
	      case 1:
	        {
	          this._context.moveTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	      case 2:
	        {
	          this._context.lineTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	      case 3:
	        {
	          this.point(this._x3, this._y3);
	          this.point(this._x4, this._y4);
	          this.point(this._x5, this._y5);
	          break;
	        }
	    }
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._x3 = x, this._y3 = y;break;
	      case 1:
	        this._point = 2;this._context.moveTo(this._x4 = x, this._y4 = y);break;
	      case 2:
	        this._point = 3;this._x5 = x, this._y5 = y;break;
	      default:
	        (0, _catmullRom.point)(this, x, y);break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	exports.default = function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new _cardinalClosed.CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function (alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}(0.5);

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardinalOpen = __webpack_require__(197);
	
	var _catmullRom = __webpack_require__(114);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0:
	        this._point = 1;break;
	      case 1:
	        this._point = 2;break;
	      case 2:
	        this._point = 3;this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);break;
	      case 3:
	        this._point = 4; // proceed
	      default:
	        (0, _catmullRom.point)(this, x, y);break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	exports.default = function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new _cardinalOpen.CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function (alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}(0.5);

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (context) {
	  return new LinearClosed(context);
	};
	
	var _noop = __webpack_require__(72);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: _noop2.default,
	  areaEnd: _noop2.default,
	  lineStart: function lineStart() {
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (this._point) this._context.closePath();
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);else this._point = 1, this._context.moveTo(x, y);
	  }
	};

/***/ },
/* 512 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.monotoneX = monotoneX;
	exports.monotoneY = monotoneY;
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function _point(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    switch (this._point) {
	      case 2:
	        this._context.lineTo(this._x1, this._y1);break;
	      case 3:
	        _point(this, this._t0, slope2(this, this._t0));break;
	    }
	    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
	      case 1:
	        this._point = 2;break;
	      case 2:
	        this._point = 3;_point(this, slope2(this, t1 = slope3(this, x, y)), t1);break;
	      default:
	        _point(this, this._t0, t1 = slope3(this, x, y));break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function moveTo(x, y) {
	    this._context.moveTo(y, x);
	  },
	  closePath: function closePath() {
	    this._context.closePath();
	  },
	  lineTo: function lineTo(x, y) {
	    this._context.lineTo(y, x);
	  },
	  bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
	    this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
	  }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}

/***/ },
/* 513 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (context) {
	  return new Natural(context);
	};
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function lineEnd() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || this._line !== 0 && n === 1) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function point(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) {
	    a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  }a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) {
	    m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  }a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) {
	    a[i] = (r[i] - a[i + 1]) / b[i];
	  }b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) {
	    b[i] = 2 * x[i + 1] - a[i + 1];
	  }return [a, b];
	}

/***/ },
/* 514 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (context) {
	  return new Step(context, 0.5);
	};
	
	exports.stepBefore = stepBefore;
	exports.stepAfter = stepAfter;
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function areaStart() {
	    this._line = 0;
	  },
	  areaEnd: function areaEnd() {
	    this._line = NaN;
	  },
	  lineStart: function lineStart() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function lineEnd() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function point(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0:
	        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
	      case 1:
	        this._point = 2; // proceed
	      default:
	        {
	          if (this._t <= 0) {
	            this._context.lineTo(this._x, y);
	            this._context.lineTo(x, y);
	          } else {
	            var x1 = this._x * (1 - this._t) + x * this._t;
	            this._context.lineTo(x1, this._y);
	            this._context.lineTo(x1, y);
	          }
	          break;
	        }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}

/***/ },
/* 515 */
248,
/* 516 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (d) {
	  return d;
	};

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	
	var _d3Path = __webpack_require__(28);
	
	var _array = __webpack_require__(195);
	
	var _constant = __webpack_require__(30);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _point = __webpack_require__(117);
	
	var _pointRadial = __webpack_require__(200);
	
	var _pointRadial2 = _interopRequireDefault(_pointRadial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x = _point.x,
	      y = _point.y,
	      context = null;
	
	  function link() {
	    var buffer,
	        argv = _array.slice.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv);
	    if (!context) context = buffer = (0, _d3Path.path)();
	    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function (_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function (_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function (_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant2.default)(+_), link) : x;
	  };
	
	  link.y = function (_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant2.default)(+_), link) : y;
	  };
	
	  link.context = function (_) {
	    return arguments.length ? (context = _ == null ? null : _, link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial(context, x0, y0, x1, y1) {
	  var p0 = (0, _pointRadial2.default)(x0, y0),
	      p1 = (0, _pointRadial2.default)(x0, y0 = (y0 + y1) / 2),
	      p2 = (0, _pointRadial2.default)(x1, y0),
	      p3 = (0, _pointRadial2.default)(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}

/***/ },
/* 518 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) {
	      y += series[i][j][1] || 0;
	    }if (y) for (i = 0; i < n; ++i) {
	      series[i][j][1] /= y;
	    }
	  }
	  (0, _none2.default)(series, order);
	};
	
	var _none = __webpack_require__(48);
	
	var _none2 = _interopRequireDefault(_none);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) {
	      y += series[i][j][1] || 0;
	    }s0[j][1] += s0[j][0] = -y / 2;
	  }
	  (0, _none2.default)(series, order);
	};
	
	var _none = __webpack_require__(48);
	
	var _none2 = _interopRequireDefault(_none);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  (0, _none2.default)(series, order);
	};
	
	var _none = __webpack_require__(48);
	
	var _none2 = _interopRequireDefault(_none);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series) {
	  return (0, _ascending2.default)(series).reverse();
	};
	
	var _ascending = __webpack_require__(116);
	
	var _ascending2 = _interopRequireDefault(_ascending);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(_ascending.sum),
	      order = (0, _none2.default)(series).sort(function (a, b) {
	    return sums[b] - sums[a];
	  }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var _none = __webpack_require__(49);
	
	var _none2 = _interopRequireDefault(_none);
	
	var _ascending = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (series) {
	  return (0, _none2.default)(series).reverse();
	};
	
	var _none = __webpack_require__(49);
	
	var _none2 = _interopRequireDefault(_none);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var value = _identity2.default,
	      sortValues = _descending2.default,
	      sort = null,
	      startAngle = (0, _constant2.default)(0),
	      endAngle = (0, _constant2.default)(_math.tau),
	      padAngle = (0, _constant2.default)(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(_math.tau, Math.max(-_math.tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function (i, j) {
	      return sortValues(arcs[i], arcs[j]);
	    });else if (sort != null) index.sort(function (i, j) {
	      return sort(data[i], data[j]);
	    });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function (_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant2.default)(+_), pie) : value;
	  };
	
	  pie.sortValues = function (_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function (_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function (_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function (_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function (_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant2.default)(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var _constant = __webpack_require__(30);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _descending = __webpack_require__(515);
	
	var _descending2 = _interopRequireDefault(_descending);
	
	var _identity = __webpack_require__(516);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _math = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var keys = (0, _constant2.default)([]),
	      order = _none4.default,
	      offset = _none2.default,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function (_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constant2.default)(_array.slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function (_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant2.default)(+_), stack) : value;
	  };
	
	  stack.order = function (_) {
	    return arguments.length ? (order = _ == null ? _none4.default : typeof _ === "function" ? _ : (0, _constant2.default)(_array.slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function (_) {
	    return arguments.length ? (offset = _ == null ? _none2.default : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var _array = __webpack_require__(195);
	
	var _constant = __webpack_require__(30);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _none = __webpack_require__(48);
	
	var _none2 = _interopRequireDefault(_none);
	
	var _none3 = __webpack_require__(49);
	
	var _none4 = _interopRequireDefault(_none3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stackValue(d, key) {
	  return d[key];
	}

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.symbols = undefined;
	
	exports.default = function () {
	  var type = (0, _constant2.default)(_circle2.default),
	      size = (0, _constant2.default)(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = (0, _d3Path.path)();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function (_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constant2.default)(_), symbol) : type;
	  };
	
	  symbol.size = function (_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constant2.default)(+_), symbol) : size;
	  };
	
	  symbol.context = function (_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var _d3Path = __webpack_require__(28);
	
	var _circle = __webpack_require__(201);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _cross = __webpack_require__(202);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _diamond = __webpack_require__(203);
	
	var _diamond2 = _interopRequireDefault(_diamond);
	
	var _star = __webpack_require__(205);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _square = __webpack_require__(204);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _triangle = __webpack_require__(206);
	
	var _triangle2 = _interopRequireDefault(_triangle);
	
	var _wye = __webpack_require__(207);
	
	var _wye2 = _interopRequireDefault(_wye);
	
	var _constant = __webpack_require__(30);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var symbols = exports.symbols = [_circle2.default, _cross2.default, _diamond2.default, _square2.default, _star2.default, _triangle2.default, _wye2.default];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isoFormat = __webpack_require__(208);
	
	var _defaultLocale = __webpack_require__(119);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocale.utcParse)(_isoFormat.isoSpecifier);
	
	exports.default = parseIso;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.days = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var day = (0, _interval2.default)(function (date) {
	  date.setHours(0, 0, 0, 0);
	}, function (date, step) {
	  date.setDate(date.getDate() + step);
	}, function (start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationDay;
	}, function (date) {
	  return date.getDate() - 1;
	});
	
	exports.default = day;
	var days = exports.days = day.range;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hours = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hour = (0, _interval2.default)(function (date) {
	  var offset = date.getTimezoneOffset() * _duration.durationMinute % _duration.durationHour;
	  if (offset < 0) offset += _duration.durationHour;
	  date.setTime(Math.floor((+date - offset) / _duration.durationHour) * _duration.durationHour + offset);
	}, function (date, step) {
	  date.setTime(+date + step * _duration.durationHour);
	}, function (start, end) {
	  return (end - start) / _duration.durationHour;
	}, function (date) {
	  return date.getHours();
	});
	
	exports.default = hour;
	var hours = exports.hours = hour.range;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.milliseconds = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var millisecond = (0, _interval2.default)(function () {
	  // noop
	}, function (date, step) {
	  date.setTime(+date + step);
	}, function (start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function (k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return (0, _interval2.default)(function (date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function (date, step) {
	    date.setTime(+date + step * k);
	  }, function (start, end) {
	    return (end - start) / k;
	  });
	};
	
	exports.default = millisecond;
	var milliseconds = exports.milliseconds = millisecond.range;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.minutes = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var minute = (0, _interval2.default)(function (date) {
	  date.setTime(Math.floor(date / _duration.durationMinute) * _duration.durationMinute);
	}, function (date, step) {
	  date.setTime(+date + step * _duration.durationMinute);
	}, function (start, end) {
	  return (end - start) / _duration.durationMinute;
	}, function (date) {
	  return date.getMinutes();
	});
	
	exports.default = minute;
	var minutes = exports.minutes = minute.range;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.months = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var month = (0, _interval2.default)(function (date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function (date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function (start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function (date) {
	  return date.getMonth();
	});
	
	exports.default = month;
	var months = exports.months = month.range;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.seconds = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var second = (0, _interval2.default)(function (date) {
	  date.setTime(Math.floor(date / _duration.durationSecond) * _duration.durationSecond);
	}, function (date, step) {
	  date.setTime(+date + step * _duration.durationSecond);
	}, function (start, end) {
	  return (end - start) / _duration.durationSecond;
	}, function (date) {
	  return date.getUTCSeconds();
	});
	
	exports.default = second;
	var seconds = exports.seconds = second.range;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utcDays = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utcDay = (0, _interval2.default)(function (date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function (date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function (start, end) {
	  return (end - start) / _duration.durationDay;
	}, function (date) {
	  return date.getUTCDate() - 1;
	});
	
	exports.default = utcDay;
	var utcDays = exports.utcDays = utcDay.range;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utcHours = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utcHour = (0, _interval2.default)(function (date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function (date, step) {
	  date.setTime(+date + step * _duration.durationHour);
	}, function (start, end) {
	  return (end - start) / _duration.durationHour;
	}, function (date) {
	  return date.getUTCHours();
	});
	
	exports.default = utcHour;
	var utcHours = exports.utcHours = utcHour.range;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utcMinutes = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utcMinute = (0, _interval2.default)(function (date) {
	  date.setUTCSeconds(0, 0);
	}, function (date, step) {
	  date.setTime(+date + step * _duration.durationMinute);
	}, function (start, end) {
	  return (end - start) / _duration.durationMinute;
	}, function (date) {
	  return date.getUTCMinutes();
	});
	
	exports.default = utcMinute;
	var utcMinutes = exports.utcMinutes = utcMinute.range;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utcMonths = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utcMonth = (0, _interval2.default)(function (date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function (date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function (start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function (date) {
	  return date.getUTCMonth();
	});
	
	exports.default = utcMonth;
	var utcMonths = exports.utcMonths = utcMonth.range;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utcSaturdays = exports.utcFridays = exports.utcThursdays = exports.utcWednesdays = exports.utcTuesdays = exports.utcMondays = exports.utcSundays = exports.utcSaturday = exports.utcFriday = exports.utcThursday = exports.utcWednesday = exports.utcTuesday = exports.utcMonday = exports.utcSunday = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function utcWeekday(i) {
	  return (0, _interval2.default)(function (date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function (date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function (start, end) {
	    return (end - start) / _duration.durationWeek;
	  });
	}
	
	var utcSunday = exports.utcSunday = utcWeekday(0);
	var utcMonday = exports.utcMonday = utcWeekday(1);
	var utcTuesday = exports.utcTuesday = utcWeekday(2);
	var utcWednesday = exports.utcWednesday = utcWeekday(3);
	var utcThursday = exports.utcThursday = utcWeekday(4);
	var utcFriday = exports.utcFriday = utcWeekday(5);
	var utcSaturday = exports.utcSaturday = utcWeekday(6);
	
	var utcSundays = exports.utcSundays = utcSunday.range;
	var utcMondays = exports.utcMondays = utcMonday.range;
	var utcTuesdays = exports.utcTuesdays = utcTuesday.range;
	var utcWednesdays = exports.utcWednesdays = utcWednesday.range;
	var utcThursdays = exports.utcThursdays = utcThursday.range;
	var utcFridays = exports.utcFridays = utcFriday.range;
	var utcSaturdays = exports.utcSaturdays = utcSaturday.range;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utcYears = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utcYear = (0, _interval2.default)(function (date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function (date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function (start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function (date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function (k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval2.default)(function (date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function (date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	exports.default = utcYear;
	var utcYears = exports.utcYears = utcYear.range;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saturdays = exports.fridays = exports.thursdays = exports.wednesdays = exports.tuesdays = exports.mondays = exports.sundays = exports.saturday = exports.friday = exports.thursday = exports.wednesday = exports.tuesday = exports.monday = exports.sunday = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	var _duration = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function weekday(i) {
	  return (0, _interval2.default)(function (date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function (date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function (start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationWeek;
	  });
	}
	
	var sunday = exports.sunday = weekday(0);
	var monday = exports.monday = weekday(1);
	var tuesday = exports.tuesday = weekday(2);
	var wednesday = exports.wednesday = weekday(3);
	var thursday = exports.thursday = weekday(4);
	var friday = exports.friday = weekday(5);
	var saturday = exports.saturday = weekday(6);
	
	var sundays = exports.sundays = sunday.range;
	var mondays = exports.mondays = monday.range;
	var tuesdays = exports.tuesdays = tuesday.range;
	var wednesdays = exports.wednesdays = wednesday.range;
	var thursdays = exports.thursdays = thursday.range;
	var fridays = exports.fridays = friday.range;
	var saturdays = exports.saturdays = saturday.range;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.years = undefined;
	
	var _interval = __webpack_require__(11);
	
	var _interval2 = _interopRequireDefault(_interval);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var year = (0, _interval2.default)(function (date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function (date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function (start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function (date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function (k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval2.default)(function (date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function (date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	exports.default = year;
	var years = exports.years = year.range;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback, delay, time) {
	  var t = new _timer.Timer(),
	      total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? (0, _timer.now)() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	var _timer = __webpack_require__(120);

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (callback, delay, time) {
	  var t = new _timer.Timer();
	  delay = delay == null ? 0 : +delay;
	  t.restart(function (elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var _timer = __webpack_require__(120);

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, name) {
	  var schedules = node.__transition,
	      schedule,
	      i;
	
	  if (schedules) {
	    name = name == null ? null : name + "";
	    for (i in schedules) {
	      if ((schedule = schedules[i]).state > _schedule.SCHEDULED && schedule.name === name) {
	        return new _index.Transition([[node]], root, name, +i);
	      }
	    }
	  }
	
	  return null;
	};
	
	var _index = __webpack_require__(22);
	
	var _schedule = __webpack_require__(17);
	
	var root = [null];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _d3Selection = __webpack_require__(8);
	
	var _interrupt = __webpack_require__(547);
	
	var _interrupt2 = _interopRequireDefault(_interrupt);
	
	var _transition = __webpack_require__(548);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_d3Selection.selection.prototype.interrupt = _interrupt2.default;
	_d3Selection.selection.prototype.transition = _transition2.default;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name) {
	  return this.each(function () {
	    (0, _interrupt2.default)(this, name);
	  });
	};
	
	var _interrupt = __webpack_require__(210);
	
	var _interrupt2 = _interopRequireDefault(_interrupt);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name) {
	  var id, timing;
	
	  if (name instanceof _index.Transition) {
	    id = name._id, name = name._name;
	  } else {
	    id = (0, _index.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
	  }
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        (0, _schedule2.default)(node, name, id, i, group, timing || inherit(node, id));
	      }
	    }
	  }
	
	  return new _index.Transition(groups, this._parents, name, id);
	};
	
	var _index = __webpack_require__(22);
	
	var _schedule = __webpack_require__(17);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _d3Ease = __webpack_require__(151);
	
	var _d3Timer = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTiming = {
	  time: null, // Set on use.
	  delay: 0,
	  duration: 250,
	  ease: _d3Ease.easeCubicInOut
	};
	
	function inherit(node, id) {
	  var timing;
	  while (!(timing = node.__transition) || !(timing = timing[id])) {
	    if (!(node = node.parentNode)) {
	      return defaultTiming.time = (0, _d3Timer.now)(), defaultTiming;
	    }
	  }
	  return timing;
	}

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value) {
	  var fullname = (0, _d3Selection.namespace)(name),
	      i = fullname === "transform" ? _d3Interpolate.interpolateTransformSvg : _interpolate2.default;
	  return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tween.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
	};
	
	var _d3Interpolate = __webpack_require__(14);
	
	var _d3Selection = __webpack_require__(8);
	
	var _tween = __webpack_require__(75);
	
	var _interpolate = __webpack_require__(211);
	
	var _interpolate2 = _interopRequireDefault(_interpolate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function attrRemove(name) {
	  return function () {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function () {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, interpolate, value1) {
	  var value00, interpolate0;
	  return function () {
	    var value0 = this.getAttribute(name);
	    return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
	  };
	}
	
	function attrConstantNS(fullname, interpolate, value1) {
	  var value00, interpolate0;
	  return function () {
	    var value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
	  };
	}
	
	function attrFunction(name, interpolate, value) {
	  var value00, value10, interpolate0;
	  return function () {
	    var value0,
	        value1 = value(this);
	    if (value1 == null) return void this.removeAttribute(name);
	    value0 = this.getAttribute(name);
	    return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
	  };
	}
	
	function attrFunctionNS(fullname, interpolate, value) {
	  var value00, value10, interpolate0;
	  return function () {
	    var value0,
	        value1 = value(this);
	    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
	    value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
	  };
	}

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value) {
	  var key = "attr." + name;
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error();
	  var fullname = (0, _d3Selection.namespace)(name);
	  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
	};
	
	var _d3Selection = __webpack_require__(8);
	
	function attrTweenNS(fullname, value) {
	  function tween() {
	    var node = this,
	        i = value.apply(node, arguments);
	    return i && function (t) {
	      node.setAttributeNS(fullname.space, fullname.local, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	function attrTween(name, value) {
	  function tween() {
	    var node = this,
	        i = value.apply(node, arguments);
	    return i && function (t) {
	      node.setAttribute(name, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  var id = this._id;
	
	  return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _schedule.get)(this.node(), id).delay;
	};
	
	var _schedule = __webpack_require__(17);
	
	function delayFunction(id, value) {
	  return function () {
	    (0, _schedule.init)(this, id).delay = +value.apply(this, arguments);
	  };
	}
	
	function delayConstant(id, value) {
	  return value = +value, function () {
	    (0, _schedule.init)(this, id).delay = value;
	  };
	}

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  var id = this._id;
	
	  return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _schedule.get)(this.node(), id).duration;
	};
	
	var _schedule = __webpack_require__(17);
	
	function durationFunction(id, value) {
	  return function () {
	    (0, _schedule.set)(this, id).duration = +value.apply(this, arguments);
	  };
	}
	
	function durationConstant(id, value) {
	  return value = +value, function () {
	    (0, _schedule.set)(this, id).duration = value;
	  };
	}

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  var id = this._id;
	
	  return arguments.length ? this.each(easeConstant(id, value)) : (0, _schedule.get)(this.node(), id).ease;
	};
	
	var _schedule = __webpack_require__(17);
	
	function easeConstant(id, value) {
	  if (typeof value !== "function") throw new Error();
	  return function () {
	    (0, _schedule.set)(this, id).ease = value;
	  };
	}

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (match) {
	  if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new _index.Transition(subgroups, this._parents, this._name, this._id);
	};
	
	var _d3Selection = __webpack_require__(8);
	
	var _index = __webpack_require__(22);

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (transition) {
	  if (transition._id !== this._id) throw new Error();
	
	  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new _index.Transition(merges, this._parents, this._name, this._id);
	};
	
	var _index = __webpack_require__(22);

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, listener) {
	  var id = this._id;
	
	  return arguments.length < 2 ? (0, _schedule.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
	};
	
	var _schedule = __webpack_require__(17);
	
	function start(name) {
	  return (name + "").trim().split(/^|\s+/).every(function (t) {
	    var i = t.indexOf(".");
	    if (i >= 0) t = t.slice(0, i);
	    return !t || t === "start";
	  });
	}
	
	function onFunction(id, name, listener) {
	  var on0,
	      on1,
	      sit = start(name) ? _schedule.init : _schedule.set;
	  return function () {
	    var schedule = sit(this, id),
	        on = schedule.on;
	
	    // If this node shared a dispatch with the previous node,
	    // just assign the updated shared dispatch and we’re done!
	    // Otherwise, copy-on-write.
	    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
	
	    schedule.on = on1;
	  };
	}

/***/ },
/* 557 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return this.on("end.remove", removeFunction(this._id));
	};
	
	function removeFunction(id) {
	  return function () {
	    var parent = this.parentNode;
	    for (var i in this.__transition) {
	      if (+i !== id) return;
	    }if (parent) parent.removeChild(this);
	  };
	}

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (select) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	        (0, _schedule2.default)(subgroup[i], name, id, i, subgroup, (0, _schedule.get)(node, id));
	      }
	    }
	  }
	
	  return new _index.Transition(subgroups, this._parents, name, id);
	};
	
	var _d3Selection = __webpack_require__(8);
	
	var _index = __webpack_require__(22);
	
	var _schedule = __webpack_require__(17);
	
	var _schedule2 = _interopRequireDefault(_schedule);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (select) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        for (var children = select.call(node, node.__data__, i, group), child, inherit = (0, _schedule.get)(node, id), k = 0, l = children.length; k < l; ++k) {
	          if (child = children[k]) {
	            (0, _schedule2.default)(child, name, id, k, children, inherit);
	          }
	        }
	        subgroups.push(children);
	        parents.push(node);
	      }
	    }
	  }
	
	  return new _index.Transition(subgroups, parents, name, id);
	};
	
	var _d3Selection = __webpack_require__(8);
	
	var _index = __webpack_require__(22);
	
	var _schedule = __webpack_require__(17);
	
	var _schedule2 = _interopRequireDefault(_schedule);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return new Selection(this._groups, this._parents);
	};
	
	var _d3Selection = __webpack_require__(8);
	
	var Selection = _d3Selection.selection.prototype.constructor;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (name, value, priority) {
	    var i = (name += "") === "transform" ? _d3Interpolate.interpolateTransformCss : _interpolate2.default;
	    return value == null ? this.styleTween(name, styleRemove(name, i)).on("end.style." + name, styleRemoveEnd(name)) : this.styleTween(name, typeof value === "function" ? styleFunction(name, i, (0, _tween.tweenValue)(this, "style." + name, value)) : styleConstant(name, i, value + ""), priority);
	};
	
	var _d3Interpolate = __webpack_require__(14);
	
	var _d3Selection = __webpack_require__(8);
	
	var _tween = __webpack_require__(75);
	
	var _interpolate = __webpack_require__(211);
	
	var _interpolate2 = _interopRequireDefault(_interpolate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function styleRemove(name, interpolate) {
	    var value00, value10, interpolate0;
	    return function () {
	        var value0 = (0, _d3Selection.style)(this, name),
	            value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
	        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
	    };
	}
	
	function styleRemoveEnd(name) {
	    return function () {
	        this.style.removeProperty(name);
	    };
	}
	
	function styleConstant(name, interpolate, value1) {
	    var value00, interpolate0;
	    return function () {
	        var value0 = (0, _d3Selection.style)(this, name);
	        return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
	    };
	}
	
	function styleFunction(name, interpolate, value) {
	    var value00, value10, interpolate0;
	    return function () {
	        var value0 = (0, _d3Selection.style)(this, name),
	            value1 = value(this);
	        if (value1 == null) value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
	        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
	    };
	}

/***/ },
/* 562 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (name, value, priority) {
	  var key = "style." + (name += "");
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error();
	  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
	};
	
	function styleTween(name, value, priority) {
	  function tween() {
	    var node = this,
	        i = value.apply(node, arguments);
	    return i && function (t) {
	      node.style.setProperty(name, i(t), priority);
	    };
	  }
	  tween._value = value;
	  return tween;
	}

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return this.tween("text", typeof value === "function" ? textFunction((0, _tween.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
	};
	
	var _tween = __webpack_require__(75);
	
	function textConstant(value) {
	  return function () {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function () {
	    var value1 = value(this);
	    this.textContent = value1 == null ? "" : value1;
	  };
	}

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var name = this._name,
	      id0 = this._id,
	      id1 = (0, _index.newId)();
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        var inherit = (0, _schedule.get)(node, id0);
	        (0, _schedule2.default)(node, name, id1, i, group, {
	          time: inherit.time + inherit.delay + inherit.duration,
	          delay: 0,
	          duration: inherit.duration,
	          ease: inherit.ease
	        });
	      }
	    }
	  }
	
	  return new _index.Transition(groups, this._parents, name, id1);
	};
	
	var _index = __webpack_require__(22);
	
	var _schedule = __webpack_require__(17);
	
	var _schedule2 = _interopRequireDefault(_schedule);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _voronoi = __webpack_require__(569);
	
	Object.defineProperty(exports, "voronoi", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_voronoi).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeBeach = removeBeach;
	exports.addBeach = addBeach;
	
	var _RedBlackTree = __webpack_require__(123);
	
	var _Cell = __webpack_require__(212);
	
	var _Circle = __webpack_require__(213);
	
	var _Edge = __webpack_require__(122);
	
	var _Diagram = __webpack_require__(50);
	
	var beachPool = [];
	
	function Beach() {
	  (0, _RedBlackTree.RedBlackNode)(this);
	  this.edge = this.site = this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach();
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  (0, _Circle.detachCircle)(beach);
	  _Diagram.beaches.remove(beach);
	  beachPool.push(beach);
	  (0, _RedBlackTree.RedBlackNode)(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle && Math.abs(x - lArc.circle.x) < _Diagram.epsilon && Math.abs(y - lArc.circle.cy) < _Diagram.epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  (0, _Circle.detachCircle)(lArc);
	
	  var rArc = next;
	  while (rArc.circle && Math.abs(x - rArc.circle.x) < _Diagram.epsilon && Math.abs(y - rArc.circle.cy) < _Diagram.epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  (0, _Circle.detachCircle)(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    (0, _Edge.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = (0, _Edge.createEdge)(lArc.site, rArc.site, null, vertex);
	
	  (0, _Circle.attachCircle)(lArc);
	  (0, _Circle.attachCircle)(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = _Diagram.beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > _Diagram.epsilon) node = node.L;else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > _Diagram.epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -_Diagram.epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -_Diagram.epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  (0, _Cell.createCell)(site);
	  var newArc = createBeach(site);
	  _Diagram.beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    (0, _Circle.detachCircle)(lArc);
	    rArc = createBeach(lArc.site);
	    _Diagram.beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = (0, _Edge.createEdge)(lArc.site, newArc.site);
	    (0, _Circle.attachCircle)(lArc);
	    (0, _Circle.attachCircle)(rArc);
	    return;
	  }
	
	  if (!rArc) {
	    // && lArc
	    newArc.edge = (0, _Edge.createEdge)(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  (0, _Circle.detachCircle)(lArc);
	  (0, _Circle.detachCircle)(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  (0, _Edge.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = (0, _Edge.createEdge)(lSite, site, null, vertex);
	  rArc.edge = (0, _Edge.createEdge)(site, rSite, null, vertex);
	  (0, _Circle.attachCircle)(lArc);
	  (0, _Circle.attachCircle)(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}

/***/ },
/* 567 */
35,
/* 568 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.x = x;
	exports.y = y;
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var x = _point.x,
	      y = _point.y,
	      extent = null;
	
	  function voronoi(data) {
	    return new _Diagram2.default(data.map(function (d, i) {
	      var s = [Math.round(x(d, i, data) / _Diagram.epsilon) * _Diagram.epsilon, Math.round(y(d, i, data) / _Diagram.epsilon) * _Diagram.epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function (data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function (data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function (data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function (_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant2.default)(+_), voronoi) : x;
	  };
	
	  voronoi.y = function (_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant2.default)(+_), voronoi) : y;
	  };
	
	  voronoi.extent = function (_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function (_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	var _constant = __webpack_require__(567);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _point = __webpack_require__(568);
	
	var _Diagram = __webpack_require__(50);
	
	var _Diagram2 = _interopRequireDefault(_Diagram);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zoom = __webpack_require__(574);
	
	Object.defineProperty(exports, "zoom", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_zoom).default;
	  }
	});
	
	var _transform = __webpack_require__(214);
	
	Object.defineProperty(exports, "zoomTransform", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transform).default;
	  }
	});
	Object.defineProperty(exports, "zoomIdentity", {
	  enumerable: true,
	  get: function get() {
	    return _transform.identity;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 571 */
35,
/* 572 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ZoomEvent;
	function ZoomEvent(target, type, transform) {
	  this.target = target;
	  this.type = type;
	  this.transform = transform;
	}

/***/ },
/* 573 */
149,
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var filter = defaultFilter,
	      extent = defaultExtent,
	      constrain = defaultConstrain,
	      wheelDelta = defaultWheelDelta,
	      touchable = defaultTouchable,
	      scaleExtent = [0, Infinity],
	      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
	      duration = 250,
	      interpolate = _d3Interpolate.interpolateZoom,
	      gestures = [],
	      listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"),
	      touchstarting,
	      touchending,
	      touchDelay = 500,
	      wheelDelay = 150,
	      clickDistance2 = 0;
	
	  function zoom(selection) {
	    selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  zoom.transform = function (collection, transform) {
	    var selection = collection.selection ? collection.selection() : collection;
	    selection.property("__zoom", defaultTransform);
	    if (collection !== selection) {
	      schedule(collection, transform);
	    } else {
	      selection.interrupt().each(function () {
	        gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
	      });
	    }
	  };
	
	  zoom.scaleBy = function (selection, k) {
	    zoom.scaleTo(selection, function () {
	      var k0 = this.__zoom.k,
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return k0 * k1;
	    });
	  };
	
	  zoom.scaleTo = function (selection, k) {
	    zoom.transform(selection, function () {
	      var e = extent.apply(this, arguments),
	          t0 = this.__zoom,
	          p0 = centroid(e),
	          p1 = t0.invert(p0),
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
	    });
	  };
	
	  zoom.translateBy = function (selection, x, y) {
	    zoom.transform(selection, function () {
	      return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
	    });
	  };
	
	  zoom.translateTo = function (selection, x, y) {
	    zoom.transform(selection, function () {
	      var e = extent.apply(this, arguments),
	          t = this.__zoom,
	          p = centroid(e);
	      return constrain(_transform.identity.translate(p[0], p[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
	    });
	  };
	
	  function scale(transform, k) {
	    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
	    return k === transform.k ? transform : new _transform.Transform(k, transform.x, transform.y);
	  }
	
	  function translate(transform, p0, p1) {
	    var x = p0[0] - p1[0] * transform.k,
	        y = p0[1] - p1[1] * transform.k;
	    return x === transform.x && y === transform.y ? transform : new _transform.Transform(transform.k, x, y);
	  }
	
	  function centroid(extent) {
	    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
	  }
	
	  function schedule(transition, transform, center) {
	    transition.on("start.zoom", function () {
	      gesture(this, arguments).start();
	    }).on("interrupt.zoom end.zoom", function () {
	      gesture(this, arguments).end();
	    }).tween("zoom", function () {
	      var that = this,
	          args = arguments,
	          g = gesture(that, args),
	          e = extent.apply(that, args),
	          p = center || centroid(e),
	          w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
	          a = that.__zoom,
	          b = typeof transform === "function" ? transform.apply(that, args) : transform,
	          i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
	      return function (t) {
	        if (t === 1) t = b; // Avoid rounding error on end.
	        else {
	            var l = i(t),
	                k = w / l[2];t = new _transform.Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
	          }
	        g.zoom(null, t);
	      };
	    });
	  }
	
	  function gesture(that, args) {
	    for (var i = 0, n = gestures.length, g; i < n; ++i) {
	      if ((g = gestures[i]).that === that) {
	        return g;
	      }
	    }
	    return new Gesture(that, args);
	  }
	
	  function Gesture(that, args) {
	    this.that = that;
	    this.args = args;
	    this.index = -1;
	    this.active = 0;
	    this.extent = extent.apply(that, args);
	  }
	
	  Gesture.prototype = {
	    start: function start() {
	      if (++this.active === 1) {
	        this.index = gestures.push(this) - 1;
	        this.emit("start");
	      }
	      return this;
	    },
	    zoom: function zoom(key, transform) {
	      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
	      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
	      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
	      this.that.__zoom = transform;
	      this.emit("zoom");
	      return this;
	    },
	    end: function end() {
	      if (--this.active === 0) {
	        gestures.splice(this.index, 1);
	        this.index = -1;
	        this.emit("end");
	      }
	      return this;
	    },
	    emit: function emit(type) {
	      (0, _d3Selection.customEvent)(new _event2.default(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function wheeled() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        t = this.__zoom,
	        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
	        p = (0, _d3Selection.mouse)(this);
	
	    // If the mouse is in the same location as before, reuse it.
	    // If there were recent wheel events, reset the wheel idle timeout.
	    if (g.wheel) {
	      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
	        g.mouse[1] = t.invert(g.mouse[0] = p);
	      }
	      clearTimeout(g.wheel);
	    }
	
	    // If this wheel event won’t trigger a transform change, ignore it.
	    else if (t.k === k) return;
	
	      // Otherwise, capture the mouse point and location at the start.
	      else {
	          g.mouse = [p, t.invert(p)];
	          (0, _d3Transition.interrupt)(this);
	          g.start();
	        }
	
	    (0, _noevent2.default)();
	    g.wheel = setTimeout(wheelidled, wheelDelay);
	    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
	
	    function wheelidled() {
	      g.wheel = null;
	      g.end();
	    }
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        v = (0, _d3Selection.select)(_d3Selection.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
	        p = (0, _d3Selection.mouse)(this),
	        x0 = _d3Selection.event.clientX,
	        y0 = _d3Selection.event.clientY;
	
	    (0, _d3Drag.dragDisable)(_d3Selection.event.view);
	    (0, _noevent.nopropagation)();
	    g.mouse = [p, this.__zoom.invert(p)];
	    (0, _d3Transition.interrupt)(this);
	    g.start();
	
	    function mousemoved() {
	      (0, _noevent2.default)();
	      if (!g.moved) {
	        var dx = _d3Selection.event.clientX - x0,
	            dy = _d3Selection.event.clientY - y0;
	        g.moved = dx * dx + dy * dy > clickDistance2;
	      }
	      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.mouse)(g.that), g.mouse[1]), g.extent, translateExtent));
	    }
	
	    function mouseupped() {
	      v.on("mousemove.zoom mouseup.zoom", null);
	      (0, _d3Drag.dragEnable)(_d3Selection.event.view, g.moved);
	      (0, _noevent2.default)();
	      g.end();
	    }
	  }
	
	  function dblclicked() {
	    if (!filter.apply(this, arguments)) return;
	    var t0 = this.__zoom,
	        p0 = (0, _d3Selection.mouse)(this),
	        p1 = t0.invert(p0),
	        k1 = t0.k * (_d3Selection.event.shiftKey ? 0.5 : 2),
	        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
	
	    (0, _noevent2.default)();
	    if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0);else (0, _d3Selection.select)(this).call(zoom.transform, t1);
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        touches = _d3Selection.event.changedTouches,
	        started,
	        n = touches.length,
	        i,
	        t,
	        p;
	
	    (0, _noevent.nopropagation)();
	    for (i = 0; i < n; ++i) {
	      t = touches[i], p = (0, _d3Selection.touch)(this, touches, t.identifier);
	      p = [p, this.__zoom.invert(p), t.identifier];
	      if (!g.touch0) g.touch0 = p, started = true;else if (!g.touch1) g.touch1 = p;
	    }
	
	    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
	    if (touchstarting) {
	      touchstarting = clearTimeout(touchstarting);
	      if (!g.touch1) {
	        g.end();
	        p = (0, _d3Selection.select)(this).on("dblclick.zoom");
	        if (p) p.apply(this, arguments);
	        return;
	      }
	    }
	
	    if (started) {
	      touchstarting = setTimeout(function () {
	        touchstarting = null;
	      }, touchDelay);
	      (0, _d3Transition.interrupt)(this);
	      g.start();
	    }
	  }
	
	  function touchmoved() {
	    var g = gesture(this, arguments),
	        touches = _d3Selection.event.changedTouches,
	        n = touches.length,
	        i,
	        t,
	        p,
	        l;
	
	    (0, _noevent2.default)();
	    if (touchstarting) touchstarting = clearTimeout(touchstarting);
	    for (i = 0; i < n; ++i) {
	      t = touches[i], p = (0, _d3Selection.touch)(this, touches, t.identifier);
	      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
	    }
	    t = g.that.__zoom;
	    if (g.touch1) {
	      var p0 = g.touch0[0],
	          l0 = g.touch0[1],
	          p1 = g.touch1[0],
	          l1 = g.touch1[1],
	          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
	          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
	      t = scale(t, Math.sqrt(dp / dl));
	      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
	      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
	    } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];else return;
	    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
	  }
	
	  function touchended() {
	    var g = gesture(this, arguments),
	        touches = _d3Selection.event.changedTouches,
	        n = touches.length,
	        i,
	        t;
	
	    (0, _noevent.nopropagation)();
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function () {
	      touchending = null;
	    }, touchDelay);
	    for (i = 0; i < n; ++i) {
	      t = touches[i];
	      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
	    }
	    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
	    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);else g.end();
	  }
	
	  zoom.wheelDelta = function (_) {
	    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constant2.default)(+_), zoom) : wheelDelta;
	  };
	
	  zoom.filter = function (_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constant2.default)(!!_), zoom) : filter;
	  };
	
	  zoom.touchable = function (_) {
	    return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constant2.default)(!!_), zoom) : touchable;
	  };
	
	  zoom.extent = function (_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constant2.default)([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
	  };
	
	  zoom.scaleExtent = function (_) {
	    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
	  };
	
	  zoom.translateExtent = function (_) {
	    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
	  };
	
	  zoom.constrain = function (_) {
	    return arguments.length ? (constrain = _, zoom) : constrain;
	  };
	
	  zoom.duration = function (_) {
	    return arguments.length ? (duration = +_, zoom) : duration;
	  };
	
	  zoom.interpolate = function (_) {
	    return arguments.length ? (interpolate = _, zoom) : interpolate;
	  };
	
	  zoom.on = function () {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? zoom : value;
	  };
	
	  zoom.clickDistance = function (_) {
	    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
	  };
	
	  return zoom;
	};
	
	var _d3Dispatch = __webpack_require__(34);
	
	var _d3Drag = __webpack_require__(89);
	
	var _d3Interpolate = __webpack_require__(14);
	
	var _d3Selection = __webpack_require__(8);
	
	var _d3Transition = __webpack_require__(121);
	
	var _constant = __webpack_require__(571);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _event = __webpack_require__(572);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _transform = __webpack_require__(214);
	
	var _noevent = __webpack_require__(573);
	
	var _noevent2 = _interopRequireDefault(_noevent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !_d3Selection.event.button;
	}
	
	function defaultExtent() {
	  var e = this,
	      w,
	      h;
	  if (e instanceof SVGElement) {
	    e = e.ownerSVGElement || e;
	    w = e.width.baseVal.value;
	    h = e.height.baseVal.value;
	  } else {
	    w = e.clientWidth;
	    h = e.clientHeight;
	  }
	  return [[0, 0], [w, h]];
	}
	
	function defaultTransform() {
	  return this.__zoom || _transform.identity;
	}
	
	function defaultWheelDelta() {
	  return -_d3Selection.event.deltaY * (_d3Selection.event.deltaMode ? 120 : 1) / 500;
	}
	
	function defaultTouchable() {
	  return "ontouchstart" in this;
	}
	
	function defaultConstrain(transform, extent, translateExtent) {
	  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
	      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
	      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
	      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
	  return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
	}

/***/ },
/* 575 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var name = exports.name = "d3";
	var version = exports.version = "5.0.2";
	var description = exports.description = "Data-Driven Documents";
	var keywords = exports.keywords = ["dom", "visualization", "svg", "animation", "canvas"];
	var homepage = exports.homepage = "https://d3js.org";
	var license = exports.license = "BSD-3-Clause";
	var author = exports.author = { "name": "Mike Bostock", "url": "https://bost.ocks.org/mike" };
	var main = exports.main = "dist/d3.node.js";
	var unpkg = exports.unpkg = "dist/d3.min.js";
	var jsdelivr = exports.jsdelivr = "dist/d3.min.js";
	var _module = "index";
	exports.module = _module;
	var repository = exports.repository = { "type": "git", "url": "https://github.com/d3/d3.git" };
	var scripts = exports.scripts = { "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && node rollup.node", "test": "tape 'test/**/*-test.js'", "prepublishOnly": "npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" dist/d3.js -c negate_iife=false -m -o dist/d3.min.js", "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v5.js && cp ../d3/dist/d3.min.js d3.v5.min.js && git add d3.v5.js d3.v5.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/dist/d3.js ../d3/dist/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js" };
	var devDependencies = exports.devDependencies = { "json2module": "0.0", "package-preamble": "0.1", "rimraf": "2", "rollup": "0.57", "rollup-plugin-ascii": "0.0", "rollup-plugin-node-resolve": "3", "tape": "4", "uglify-js": "3.2" };
	var dependencies = exports.dependencies = { "d3-array": "1", "d3-axis": "1", "d3-brush": "1", "d3-chord": "1", "d3-collection": "1", "d3-color": "1", "d3-contour": "1", "d3-dispatch": "1", "d3-drag": "1", "d3-dsv": "1", "d3-ease": "1", "d3-fetch": "1", "d3-force": "1", "d3-format": "1", "d3-geo": "1", "d3-hierarchy": "1", "d3-interpolate": "1", "d3-path": "1", "d3-polygon": "1", "d3-quadtree": "1", "d3-random": "1", "d3-scale": "2", "d3-scale-chromatic": "1", "d3-selection": "1", "d3-shape": "1", "d3-time": "1", "d3-time-format": "2", "d3-timer": "1", "d3-transition": "1", "d3-voronoi": "1", "d3-zoom": "1" };

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(578);
	var isArguments = __webpack_require__(577);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	    // 7.3. Other pairs that do not both pass typeof value == 'object',
	    // equivalence is determined by ==.
	  } else if (!actual || !expected || (typeof actual === 'undefined' ? 'undefined' : _typeof(actual)) != 'object' && (typeof expected === 'undefined' ? 'undefined' : _typeof(expected)) != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	    // 7.4. For all other Object pairs, including Array objects, equivalence is
	    // determined by having the same number of owned properties (as verified
	    // with Object.prototype.hasOwnProperty.call), the same set of keys
	    // (although not necessarily the same order), equivalent values for every
	    // corresponding key, and an identical 'prototype' property. Note: this
	    // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	};
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {
	    //happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length) return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === (typeof b === 'undefined' ? 'undefined' : _typeof(b));
	}

/***/ },
/* 577 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var supportsArgumentsClass = function () {
	  return Object.prototype.toString.call(arguments);
	}() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object) {
	  return object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
	};

/***/ },
/* 578 */
/***/ function(module, exports) {

	'use strict';
	
	exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
	
	exports.shim = shim;
	function shim(obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	}

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var QueryHandler = __webpack_require__(581);
	var each = __webpack_require__(215).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function (mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor: MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler: function addHandler(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler: function removeHandler(handler) {
	        var handlers = this.handlers;
	        each(handlers, function (h, i) {
	            if (h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i, 1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches: function matches() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear: function clear() {
	        each(this.handlers, function (handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess: function assess() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function (handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MediaQuery = __webpack_require__(579);
	var Util = __webpack_require__(215);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch() {
	    if (!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor: MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register: function register(q, options, shouldDegrade) {
	        var queries = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if (!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if (isFunction(options)) {
	            options = { match: options };
	        }
	        if (!isArray(options)) {
	            options = [options];
	        }
	        each(options, function (handler) {
	            if (isFunction(handler)) {
	                handler = { match: handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister: function unregister(q, handler) {
	        var query = this.queries[q];
	
	        if (query) {
	            if (handler) {
	                query.removeHandler(handler);
	            } else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;

/***/ },
/* 581 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor: QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup: function setup() {
	        if (this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on: function on() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off: function off() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy: function destroy() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals: function equals(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MediaQueryDispatch = __webpack_require__(580);
	module.exports = new MediaQueryDispatch();

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactHelmet = __webpack_require__(683);
	
	var _mobxReact = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _Locale = __webpack_require__(76);
	
	var _es = __webpack_require__(686);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _en = __webpack_require__(685);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _reactRouterDom = __webpack_require__(57);
	
	var _reactRouter = __webpack_require__(32);
	
	var _Header = __webpack_require__(587);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _NavigationButtons = __webpack_require__(592);
	
	var _NavigationButtons2 = _interopRequireDefault(_NavigationButtons);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	var _HomePage = __webpack_require__(606);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _LoginPage = __webpack_require__(608);
	
	var _LoginPage2 = _interopRequireDefault(_LoginPage);
	
	var _ConsentPage = __webpack_require__(602);
	
	var _ConsentPage2 = _interopRequireDefault(_ConsentPage);
	
	var _LanguagePage = __webpack_require__(607);
	
	var _LanguagePage2 = _interopRequireDefault(_LanguagePage);
	
	var _AvatarPage = __webpack_require__(598);
	
	var _AvatarPage2 = _interopRequireDefault(_AvatarPage);
	
	var _AboutPage = __webpack_require__(596);
	
	var _AboutPage2 = _interopRequireDefault(_AboutPage);
	
	var _SummaryPage = __webpack_require__(611);
	
	var _SummaryPage2 = _interopRequireDefault(_SummaryPage);
	
	var _ChemicalPage = __webpack_require__(599);
	
	var _ChemicalPage2 = _interopRequireDefault(_ChemicalPage);
	
	var _CommunityActionPage = __webpack_require__(600);
	
	var _CommunityActionPage2 = _interopRequireDefault(_CommunityActionPage);
	
	var _SurveyPage = __webpack_require__(612);
	
	var _SurveyPage2 = _interopRequireDefault(_SurveyPage);
	
	var _ConclusionPage = __webpack_require__(601);
	
	var _ConclusionPage2 = _interopRequireDefault(_ConclusionPage);
	
	var _OverallStudyResultsPage = __webpack_require__(609);
	
	var _OverallStudyResultsPage2 = _interopRequireDefault(_OverallStudyResultsPage);
	
	var _HealthAndChemicalsPage = __webpack_require__(605);
	
	var _HealthAndChemicalsPage2 = _interopRequireDefault(_HealthAndChemicalsPage);
	
	var _GraphReadingTutorialPage = __webpack_require__(604);
	
	var _GraphReadingTutorialPage2 = _interopRequireDefault(_GraphReadingTutorialPage);
	
	var _FAQPage = __webpack_require__(603);
	
	var _FAQPage2 = _interopRequireDefault(_FAQPage);
	
	var _PrintPage = __webpack_require__(610);
	
	var _PrintPage2 = _interopRequireDefault(_PrintPage);
	
	var _AppendixPage = __webpack_require__(597);
	
	var _AppendixPage2 = _interopRequireDefault(_AppendixPage);
	
	var _State = __webpack_require__(217);
	
	__webpack_require__(714);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _Api = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // App.js
	
	
	//OLD hardwired
	//import es from 'react-intl/locale-data/es';
	//addLocaleData([...es]);
	
	//NEW -- XXX and do the same with Locale.js
	//from: https://stackoverflow.com/questions/41282510/how-to-add-locale-data-dynamically-using-react-intl https://github.com/yahoo/react-intl/issues/777
	//addLocaleData(require(`react-intl/locale-data/${GLOBAL_locale}`));
	
	var GLOBAL_locale = _Locale.locale; // from Locale.js
	
	if (GLOBAL_locale === 'es') {
	  (0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_es2.default)));
	} else {
	  (0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en2.default)));
	}
	
	//import Cookies from 'universal-cookie'; // PREFIX: unicoo_
	//const unicoo_cookies = new Cookies();
	
	// Top level components
	
	
	// Pages
	
	
	if (!global.Intl) {
	  global.Intl = __webpack_require__(646);
	}
	
	var prevPage1 = void 0;
	var prevPage2 = void 0;
	var StateRoute = function StateRoute(_ref) {
	  var Component = _ref.Component,
	      rest = _objectWithoutProperties(_ref, ['Component']);
	
	  return React.createElement(_reactRouterDom.Route, Object.assign({}, rest, { render: function render(props) {
	      return React.createElement(Component, Object.assign({ appState: _State.state }, props, { prevPage: prevPage2 }));
	    } }));
	};
	
	var App = (0, _reactRouter.withRouter)(function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  } // end-render
	
	
	  _createClass(App, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	
	      var get_access_code = _helpers2.default.findGetParameter('access_code');
	      var thepromise;
	      if (get_access_code && _State.state.data.length === 0) {
	        // console.log("path1");
	        thepromise = _Api.Api.authenticateshell(get_access_code, _State.state);
	        window.thepromise = thepromise;
	      } else {
	        // console.log("path2");
	        thepromise = new Promise(function (resolve, reject) {
	          resolve(0);
	        });
	      }
	
	      window.thepromise = thepromise;
	      var current = this;
	
	      thepromise.then(function (result) {
	        // console.log("get_access_code ="+get_access_code + " pathname="+current.props.location.pathname);
	        if (current.props.location.pathname !== '/' && current.props.location.pathname !== '/login') {
	
	          if (_State.state.data.length === 0) {
	            _State.state.loadMeasurements().catch(function (error) {
	              if (!get_access_code) current.props.history.push("/login");
	            });
	          }
	
	          if (_State.state.headlines.length === 0) {
	            _State.state.loadHeadlines().catch(function (error) {
	              if (!get_access_code) current.props.history.push("/login");
	            });
	          }
	        } // end checkMeasurements and Headlines
	      }); // end thepromise.then
	    } // end-componentWillMount
	
	
	  }, {
	    key: 'render',
	    value: function render() {
	      // get the previous page, for use on the avatar page
	      prevPage2 = prevPage1;
	      prevPage1 = this.props.location.pathname;
	
	      // if not logged in, don't allow access to the rest of the site
	      var loggedOutPages = ["/", "/login"];
	      if (!loggedOutPages.includes(this.props.location.pathname)) {
	        // if the path is a page when you're supposed to be logged in
	        if (!_State.state.loggedIn) {
	          // but if you're not logged in,
	          // redirect to loging
	          return React.createElement(_reactRouterDom.Redirect, { to: "/login" });
	        }
	      }
	
	      var dynamic_inline_css = "";
	
	      // don't log the main page and login page because a user hasn't logged in yet
	      if (this.props.location.pathname != "/" && this.props.location.pathname != "/login") {
	        _helpers2.default.eventLog("App.render() - " + this.props.location.pathname);
	      }
	
	      if (_helpers2.default.findGetParameter('print')) {
	        // inline for print #6 -- hide many of the buttons since not needed in print
	        dynamic_inline_css = ".faq-button, .button, .buttons, .feedback, .printhide {display:none;}  .printhide_v {visibility:hidden;}";
	      }
	
	      return React.createElement(
	        'div',
	        { className: 'wrapper' },
	        React.createElement(
	          'style',
	          null,
	          dynamic_inline_css
	        ),
	        React.createElement(
	          'div',
	          { className: 'content' },
	          React.createElement(
	            'div',
	            { className: 'content-inside' },
	            React.createElement(_Header2.default, { appState: _State.state }),
	            this.props.children
	          )
	        ),
	        React.createElement(_NavigationButtons2.default, { appState: _State.state })
	      );
	    }
	  }]);
	
	  return App;
	}(React.Component));
	
	var AppRouter = function (_React$Component2) {
	  _inherits(AppRouter, _React$Component2);
	
	  function AppRouter() {
	    _classCallCheck(this, AppRouter);
	
	    return _possibleConstructorReturn(this, (AppRouter.__proto__ || Object.getPrototypeOf(AppRouter)).apply(this, arguments));
	  }
	
	  _createClass(AppRouter, [{
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        _reactIntl.IntlProvider,
	        { locale: _Locale.locale, key: _Locale.locale, messages: _State.state.messages },
	        React.createElement(
	          _reactRouterDom.HashRouter,
	          { onUpdate: function onUpdate() {
	              return window.scrollTo(0, 0);
	            }, basename: _NavigationStructure2.default.rootPath },
	          React.createElement(
	            App,
	            null,
	            React.createElement(
	              _reactHelmet.Helmet,
	              null,
	              React.createElement(
	                'title',
	                null,
	                _State.state.messages['app.home.title']
	              )
	            ),
	            React.createElement(StateRoute, { exact: true, path: '/', Component: _HomePage2.default }),
	            React.createElement(StateRoute, { path: '/login', Component: _LoginPage2.default }),
	            React.createElement(StateRoute, { path: '/consent', Component: _ConsentPage2.default }),
	            React.createElement(StateRoute, { path: '/avatar', Component: _AvatarPage2.default }),
	            React.createElement(StateRoute, { path: '/langset', Component: _LanguagePage2.default }),
	            React.createElement(StateRoute, { path: '/about', Component: _AboutPage2.default }),
	            React.createElement(StateRoute, { path: '/health', Component: _HealthAndChemicalsPage2.default }),
	            React.createElement(StateRoute, { path: '/readinggraphs', Component: _GraphReadingTutorialPage2.default }),
	            React.createElement(StateRoute, { path: '/summary', Component: _SummaryPage2.default }),
	            React.createElement(StateRoute, { path: '/water_summary', Component: _SummaryPage2.default }),
	            React.createElement(StateRoute, { path: '/overallstudyresults', Component: _OverallStudyResultsPage2.default }),
	            React.createElement(StateRoute, { exact: true, path: '/chemicals/:chemical', Component: _ChemicalPage2.default }),
	            React.createElement(StateRoute, { exact: true, path: '/community_action', Component: _CommunityActionPage2.default }),
	            React.createElement(StateRoute, { path: '/survey', Component: _SurveyPage2.default }),
	            React.createElement(StateRoute, { path: '/conclusion', Component: _ConclusionPage2.default }),
	            React.createElement(StateRoute, { path: '/faqpage', Component: _FAQPage2.default }),
	            React.createElement(StateRoute, { path: '/appendix', Component: _AppendixPage2.default }),
	            React.createElement(StateRoute, { path: '/printpage', Component: _PrintPage2.default })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppRouter;
	}(React.Component);
	
	exports.default = (0, _mobxReact.observer)(AppRouter);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 584 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	The MIT License (MIT)
	
	Copyright (c) 2013 Evan Wang
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	*/
	
	var Labeler = function () {
	  function Labeler() {
	    _classCallCheck(this, Labeler);
	
	    this.height = function (x) {
	      // users insert graph height
	      if (!arguments.length) return this.h;
	      this.h = x;
	      return this;
	    };
	
	    this.lab = [];
	    this.anc = [];
	    this.w = 1; // box width
	    this.h = 1; // box width
	
	    this.max_move = 2.0;
	    this.max_angle = 0.5;
	    this.acc = 0;
	    this.rej = 0;
	
	    // weights
	    this.w_len = 1.0; // leader line length
	    this.w_inter = 1.0; // leader line intersection
	    this.w_lab2 = 30.0; // label-label overlap
	    this.w_lab_anc = 0.0; // label-anchor overlap
	    this.w_orient = 0.0; // orientation bias
	
	    // booleans for user defined functions
	    this.user_energy = false;
	    this.user_schedule = false;
	  }
	
	  _createClass(Labeler, [{
	    key: "energy",
	    value: function energy(index) {
	      // energy function, tailored for label placement
	
	      var m = this.lab.length;
	      var ener = 0;
	      var dx = this.lab[index].x - this.anc[index].x;
	      var dy = this.anc[index].y - this.lab[index].y;
	      var dist = Math.sqrt(dx * dx + dy * dy);
	      var overlap = true;
	
	      // penalty for length of leader line
	      if (dist > 0) ener += dist * this.w_len;
	
	      // label orientation bias
	      dx /= dist;
	      dy /= dist;
	      if (dx > 0 && dy > 0) {
	        ener += 0 * this.w_orient;
	      } else if (dx < 0 && dy > 0) {
	        ener += 1 * this.w_orient;
	      } else if (dx < 0 && dy < 0) {
	        ener += 2 * this.w_orient;
	      } else {
	        ener += 3 * this.w_orient;
	      }
	
	      var x21 = this.lab[index].x,
	          y21 = this.lab[index].y - this.lab[index].height + 2.0,
	          x22 = this.lab[index].x + this.lab[index].width,
	          y22 = this.lab[index].y + 2.0;
	      var x11, x12, y11, y12, x_overlap, y_overlap, overlap_area;
	
	      for (var i = 0; i < m; i++) {
	        if (i !== index) {
	          // penalty for intersection of leader lines
	          overlap = this.intersect(this.anc[index].x, this.lab[index].x, this.anc[i].x, this.lab[i].x, this.anc[index].y, this.lab[index].y, this.anc[i].y, this.lab[i].y);
	          if (overlap) ener += this.w_inter;
	
	          // penalty for label-label overlap
	          x11 = this.lab[i].x;
	          y11 = this.lab[i].y - this.lab[i].height + 2.0;
	          x12 = this.lab[i].x + this.lab[i].width;
	          y12 = this.lab[i].y + 2.0;
	          x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
	          y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
	          overlap_area = x_overlap * y_overlap;
	          ener += overlap_area * this.w_lab2;
	        }
	
	        // penalty for label-anchor overlap
	        x11 = this.anc[i].x - this.anc[i].r;
	        y11 = this.anc[i].y - this.anc[i].r;
	        x12 = this.anc[i].x + this.anc[i].r;
	        y12 = this.anc[i].y + this.anc[i].r;
	        x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
	        y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
	        overlap_area = x_overlap * y_overlap;
	        ener += overlap_area * this.w_lab_anc;
	      }
	      return ener;
	    }
	  }, {
	    key: "mcmove",
	    value: function mcmove(currT) {
	      // Monte Carlo translation move
	
	      // select a random label
	      var i = Math.floor(Math.random() * this.lab.length);
	
	      // save old coordinates
	      var x_old = this.lab[i].x;
	      var y_old = this.lab[i].y;
	
	      // old energy
	      var old_energy;
	      if (this.user_energy) {
	        old_energy = this.user_defined_energy(i, this.lab, this.anc);
	      } else {
	        old_energy = this.energy(i);
	      }
	
	      // random translation
	      //this.lab[i].x += (Math.random() - 0.5) * this.max_move;
	      this.lab[i].y += (Math.random() - 0.5) * this.max_move;
	
	      // hard wall boundaries
	      // console.log("labeler width", this.h, this.lab[i].y, y_old);
	      if (this.lab[i].x > this.w) this.lab[i].x = x_old;
	      if (this.lab[i].x < 0) this.lab[i].x = x_old;
	      if (this.lab[i].y > this.h) this.lab[i].y = y_old;
	      if (this.lab[i].y < 0) this.lab[i].y = y_old;
	      // console.log("labeler width2", this.lab[i].y);
	
	
	      // new energy
	      var new_energy;
	      if (this.user_energy) {
	        new_energy = this.user_defined_energy(i, this.lab, this.anc);
	      } else {
	        new_energy = this.energy(i);
	      }
	
	      // delta E
	      var delta_energy = new_energy - old_energy;
	
	      if (Math.random() < Math.exp(-delta_energy / currT)) {
	        this.acc += 1;
	      } else {
	        // move back to old coordinates
	        this.lab[i].x = x_old;
	        this.lab[i].y = y_old;
	        this.rej += 1;
	      }
	    }
	  }, {
	    key: "mcrotate",
	    value: function mcrotate(currT) {
	      // Monte Carlo rotation move
	
	      // select a random label
	      var i = Math.floor(Math.random() * this.lab.length);
	
	      // save old coordinates
	      var x_old = this.lab[i].x;
	      var y_old = this.lab[i].y;
	
	      // old energy
	      var old_energy;
	      if (this.user_energy) {
	        old_energy = this.user_defined_energy(i, this.lab, this.anc);
	      } else {
	        old_energy = this.energy(i);
	      }
	
	      // random angle
	      //var angle = (Math.random() - 0.5) * this.max_angle;
	
	      var movement = Math.random() - 0.5;
	
	      // translate label back
	      this.lab[i].x += movement;
	
	      // hard wall boundaries
	      if (this.lab[i].x > this.w) this.lab[i].x = x_old;
	      if (this.lab[i].x < 0) this.lab[i].x = x_old;
	      if (this.lab[i].y > this.h) this.lab[i].y = y_old;
	      if (this.lab[i].y < 0) this.lab[i].y = y_old;
	
	      // new energy
	      var new_energy;
	      if (this.user_energy) {
	        new_energy = this.user_defined_energy(i, this.lab, this.anc);
	      } else {
	        new_energy = this.energy(i);
	      }
	
	      // delta E
	      var delta_energy = new_energy - old_energy;
	
	      if (Math.random() < Math.exp(-delta_energy / currT)) {
	        this.acc += 1;
	      } else {
	        // move back to old coordinates
	        this.lab[i].x = x_old;
	        this.lab[i].y = y_old;
	        this.rej += 1;
	      }
	    }
	  }, {
	    key: "intersect",
	    value: function intersect(x1, x2, x3, x4, y1, y2, y3, y4) {
	      // returns true if two lines intersect, else false
	      // from http://paulbourke.net/geometry/lineline2d/
	
	      var mua, mub;
	      var denom, numera, numerb;
	
	      denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
	      numera = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
	      numerb = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
	
	      /* Is the intersection along the the segments */
	      mua = numera / denom;
	      mub = numerb / denom;
	      if (!(mua < 0 || mua > 1 || mub < 0 || mub > 1)) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "cooling_schedule",
	    value: function cooling_schedule(currT, initialT, nsweeps) {
	      // linear cooling
	      return currT - initialT / nsweeps;
	    }
	  }, {
	    key: "start",
	    value: function start(nsweeps) {
	      // main simulated annealing function
	      var m = this.lab.length,
	          currT = 1.0,
	          initialT = 1.0;
	
	      for (var i = 0; i < nsweeps; i++) {
	        for (var j = 0; j < m; j++) {
	          this.mcmove(currT);
	        }
	        currT = this.cooling_schedule(currT, initialT, nsweeps);
	      }
	    }
	  }, {
	    key: "width",
	    value: function width(x) {
	      // users insert graph width
	      if (!arguments.length) return this.w;
	      this.w = x;
	      return this;
	    }
	  }, {
	    key: "label",
	    value: function label(x) {
	      // users insert label positions
	      if (!arguments.length) return this.lab;
	      this.lab = x;
	      return this;
	    }
	  }, {
	    key: "anchor",
	    value: function anchor(x) {
	      // users insert anchor positions
	      if (!arguments.length) return this.anc;
	      this.anc = x;
	      return this;
	    }
	  }, {
	    key: "alt_energy",
	    value: function alt_energy(x) {
	      // user defined energy
	      if (!arguments.length) return this.energy;
	      this.user_defined_energy = x;
	      this.user_energy = true;
	      return this;
	    }
	  }, {
	    key: "alt_schedule",
	    value: function alt_schedule(x) {
	      // user defined cooling_schedule
	      if (!arguments.length) return this.cooling_schedule;
	      this.user_defined_schedule = x;
	      this.user_schedule = true;
	      return this;
	    }
	  }]);
	
	  return Labeler;
	}();
	
	exports.default = Labeler;
	;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIntl = __webpack_require__(4);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(718);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FAQModal = function (_React$Component) {
	  _inherits(FAQModal, _React$Component);
	
	  function FAQModal(props) {
	    _classCallCheck(this, FAQModal);
	
	    var _this = _possibleConstructorReturn(this, (FAQModal.__proto__ || Object.getPrototypeOf(FAQModal)).call(this, props));
	
	    _this.numFAQs = props.numFAQs;
	    _this.state = {
	      expanded: new Array(props.numFAQs).fill(false)
	    };
	    return _this;
	  }
	
	  _createClass(FAQModal, [{
	    key: 'onClose',
	    value: function onClose() {
	      this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var common_questions = [];
	      var self = this;
	
	      var _loop = function _loop(i) {
	        var expanded = _this2.state.expanded[i];
	        var toggleFunction = function toggleFunction() {
	          var expanded = self.state.expanded;
	          if (!expanded[i]) {
	            _helpers2.default.eventLog('faq: expand question - ' + i);
	          } else {
	            _helpers2.default.eventLog('faq: collapse question - ' + i);
	          }
	          expanded[i] = !expanded[i];
	          self.setState({
	            expanded: expanded
	          });
	        };
	
	        var q_props = {
	          key: 'title' + (i + 1),
	          className: "question expanded-" + expanded,
	          onClick: toggleFunction
	        };
	        var q_text_id = 'common_questions.q' + (i + 1) + '.title';
	        var a_props = {
	          key: 'content' + (i + 1),
	          className: "answer expanded-" + expanded
	        };
	        var a_text_id = 'common_questions.q' + (i + 1) + '.content';
	
	        var q = React.createElement(
	          'div',
	          q_props,
	          React.createElement(
	            'div',
	            { className: 'chevron-faq ' + expanded },
	            React.createElement('span', null)
	          ),
	          React.createElement(
	            'span',
	            { className: 'q-text' },
	            React.createElement(_reactIntl.FormattedMessage, { id: q_text_id })
	          )
	        );
	        common_questions.push(q);
	
	        if (_this2.state.expanded[i]) {
	          var a = React.createElement(
	            'div',
	            a_props,
	            React.createElement(
	              'span',
	              { className: 'a-text' },
	              React.createElement(_reactIntl.FormattedHTMLMessage, { id: a_text_id })
	            )
	          );
	          common_questions.push(a);
	        }
	      };
	
	      for (var i = 0; i < this.numFAQs; i++) {
	        _loop(i);
	      }
	
	      return React.createElement(
	        _Modal2.default,
	        { fullScreen: true, onClose: this.onClose.bind(this), className: 'common-questions' },
	        React.createElement(
	          'h2',
	          null,
	          React.createElement(_reactIntl.FormattedMessage, { id: 'common_questions.title', defaultMessage: 'Common Questions' })
	        ),
	        React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'common_questions.contact', defaultMessage: 'test' }),
	        common_questions
	      );
	    }
	  }]);
	
	  return FAQModal;
	}(React.Component);
	
	var FAQ = function (_React$Component2) {
	  _inherits(FAQ, _React$Component2);
	
	  function FAQ() {
	    _classCallCheck(this, FAQ);
	
	    var _this3 = _possibleConstructorReturn(this, (FAQ.__proto__ || Object.getPrototypeOf(FAQ)).call(this));
	
	    _this3.state = { open: false };
	    return _this3;
	  }
	
	  _createClass(FAQ, [{
	    key: 'onClick',
	    value: function onClick() {
	      _helpers2.default.eventLog("modal - nav:faq");
	      this.setState({ open: true });
	      document.getElementsByTagName("body")[0].style.overflow = "hidden";
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.setState({ open: false });
	      document.getElementsByTagName("body")[0].style.overflow = "visible";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modal = this.state.open ? React.createElement(FAQModal, { numFAQs: this.props.numFAQs, onClose: this.onClose.bind(this) }) : null;
	
	      return React.createElement(
	        'div',
	        { className: 'faq-wrapper' },
	        React.createElement(
	          'div',
	          { className: 'faq-button', onClick: this.onClick.bind(this), onTouchStart: this.onClick.bind(this) },
	          React.createElement(
	            'div',
	            null,
	            React.createElement(
	              'span',
	              null,
	              '?'
	            )
	          )
	        ),
	        modal
	      );
	    }
	  }]);
	
	  return FAQ;
	}(React.Component);
	
	exports.default = FAQ;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _d2 = __webpack_require__(51);
	
	var d3 = _interopRequireWildcard(_d2);
	
	var _lodash = __webpack_require__(26);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _mobxReact = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _reactSlick = __webpack_require__(703);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Graph = __webpack_require__(219);
	
	var _Graph2 = _interopRequireDefault(_Graph);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Graphs.js
	
	var Graphs = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Graphs, _React$Component);
	
	  function Graphs(props) {
	    _classCallCheck(this, Graphs);
	
	    var _this = _possibleConstructorReturn(this, (Graphs.__proto__ || Object.getPrototypeOf(Graphs)).call(this, props));
	
	    _this.state = {
	      horizontalCueVisible: true,
	      pointerEvents: false
	    };
	    _this.sliderRef = React.createRef();
	
	    return _this;
	  } // end-render
	
	  _createClass(Graphs, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // if(this.sliderRef.current !== null) {
	      //   this.sliderRef.current.slickGoTo(0, true);
	      // }
	
	      /* =========================== */
	
	      var d3n = 0;
	      var d3n_max = 0;
	      // console.log("endall setup");
	
	      d3.selectAll('g').each(function () {
	        // I believe you could do this with .on('start', cb) but I haven't tested it
	        d3n++;d3n_max++;
	      }).transition().on('end', function () {
	        // use to be .each('end', function(){})
	        d3n--;
	        if (!d3n) {
	          endall();
	        }
	      });
	
	      function endall() {
	        // console.log("endall fired" + d3n_max);
	        var div1 = document.createElement('span');
	        div1.className = "restpack_shutter";
	        document.body.appendChild(div1);
	      }
	      /* =========================== */
	    } // end componentDidUpdate()
	
	  }, {
	    key: 'getDataThisGroup',
	    value: function getDataThisGroup() {
	      return this.props.appState.groups[this.props.group];
	    }
	  }, {
	    key: 'getChemicalData',
	    value: function getChemicalData(chemical) {
	      var data = this.props.appState.chemicals[this.props.group + "-" + chemical];
	      data = data.sort(function (a, b) {
	        if (!a.detected && !b.detected) {
	          return 0;
	        }
	        if (!a.detected && b.detected) {
	          return -1;
	        }
	        if (a.detected && !b.detected) {
	          return 1;
	        }
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].detected) {
	          data[i].percentile = i / data.length;
	        } else {
	          data[i].percentile = 0;
	        }
	      }
	
	      return data;
	    }
	  }, {
	    key: 'getGraphMetaData',
	    value: function getGraphMetaData(data) {
	      // data is already sorted
	      // in case of multiple results per chemical, return the highest percentile
	      var myPercentiles = [];
	      var numDetected = 0;
	      var meDetected = false;
	      for (var d = 0; d < data.length; d++) {
	        // find percentile
	        if (data[d].mine) {
	          // if (!sortedData[d].detected) {
	          //   myPercentiles.push(0)
	          // } else {
	          //   myPercentiles.push(d/sortedData.length)
	          // }
	          myPercentiles.push(data[d].percentile);
	
	          // save if I'm detected
	          if (data[d].detected) {
	            meDetected = true;
	          }
	        }
	
	        // count nondetected
	        if (data[d].detected) {
	          numDetected++;
	        }
	      }
	      var percentile = Math.max.apply(Math, myPercentiles);
	      return [meDetected, percentile, numDetected];
	    }
	  }, {
	    key: 'getDetectedData',
	    value: function getDetectedData() {
	      return _.filter(this.getDataThisGroup(), { detected: true });
	    }
	  }, {
	    key: 'getYLimits',
	    value: function getYLimits() {
	      //console.log(d3.extent(_.map(this.getDetectedData(), 'value')));
	      return d3.extent(_.map(this.getDetectedData(), 'value'));
	    }
	
	    // Since these handlers are attached to both onClick and onTouchStart on the same element, we need a workaround to keep both from firing
	    // when on a computer (see https://github.com/facebook/react/issues/9809)
	
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      this.setState({ horizontalCueVisible: false });
	    }
	  }, {
	    key: 'onTouchStart',
	    value: function onTouchStart(e) {
	      var _this2 = this;
	
	      this.setState({ horizontalCueVisible: false });
	      setTimeout(function () {
	        _this2.setState({ pointerEvents: true });
	      }, 200);
	    }
	  }, {
	    key: 'graph_event_log',
	    value: function graph_event_log(num, chemical) {
	      _helpers2.default.eventLog("viewing graph - " + num + " - chem:" + chemical);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.appState.data.length === 0) {
	        return React.createElement(
	          'div',
	          { className: 'graphs loading' },
	          React.createElement(_reactIntl.FormattedMessage, { id: 'loading', defaultMessage: 'Cargando...' })
	        );
	      }
	
	      var myData = _.filter(this.getDataThisGroup(), { mine: true });
	      var medium = _.uniq(_.map(myData, 'medium'))[0];
	
	      //method1--sort graphs with max value of any visit
	      //const myData_HiToLoMax = _.orderBy(myData, ['value'], ['desc']); // sort the graphs -- we want the highest single values (from each visit) to rank the graph order  XXX ideally this would be 1)average across visits and 2)relative to benchmarks
	
	      //method2--sort graphs with max avg of visits
	      var myData_Avgs = _.chain(myData).groupBy("chemical").mapValues(function (v, i) {
	        return {
	          chemical: v[0].chemical,
	          chemical_full: v[0].chemical_full,
	          value_numvisits: v.length,
	          value_avg: _.meanBy(v, 'value') };
	      }).value();
	      var myData_HiToLoAvgs = _.orderBy(myData_Avgs, ['value_avg'], ['desc']);
	
	      // sorted graphs! use either myData_HiToLoMax or myData_HiToLoAvgs
	      var chemicals = _.uniq(_.map(myData_HiToLoAvgs, 'chemical'));
	      var chemicals_full = _.uniq(_.map(myData_HiToLoAvgs, 'chemical_full'));
	
	      var yLimits = this.getYLimits();
	
	      // console.log("myData_HiToLoAvgs", myData_HiToLoAvgs);
	
	
	      /*
	      const horizontalCue = this.state.horizontalCueVisible === true ?
	        (
	          <div className='horizontal-cue' onClick={this.onClick.bind(this)} onTouchStart={this.onTouchStart.bind(this)}>
	            <div><FormattedMessage id='swipe-right' defaultMessage='Swipe right' /></div>
	          </div>
	         ) : null;
	      */
	      var horizontalCue = null;
	
	      var graphs = [];
	
	      for (var c = 0; c < chemicals.length; c++) {
	        var chemical = chemicals[c];
	        var data = this.getChemicalData(chemical);
	        var anyDetects = false;
	        for (var d = 0; d < data.length; d++) {
	          if (data[d].detected) {
	            anyDetects = true;
	            break;
	          }
	        }
	        if (anyDetects) {
	          graphs.push(React.createElement(_Graph2.default, {
	            key: chemical + c,
	            appState: this.props.appState,
	            data: this.getChemicalData(chemical),
	            chemical: chemical,
	            chemical_full: chemicals_full[c],
	            medium: medium,
	            yLimits: yLimits,
	            chemicalGroup: this.props.group,
	            pointerEvents: this.state.pointerEvents }));
	        }
	      }
	
	      var self = this;
	      graphs.sort(function (a, b) {
	        var _self$getGraphMetaDat = self.getGraphMetaData(a.props.data),
	            _self$getGraphMetaDat2 = _slicedToArray(_self$getGraphMetaDat, 3),
	            a_detected = _self$getGraphMetaDat2[0],
	            a_percentile = _self$getGraphMetaDat2[1],
	            a_numDetected = _self$getGraphMetaDat2[2];
	
	        var _self$getGraphMetaDat3 = self.getGraphMetaData(b.props.data),
	            _self$getGraphMetaDat4 = _slicedToArray(_self$getGraphMetaDat3, 3),
	            b_detected = _self$getGraphMetaDat4[0],
	            b_percentile = _self$getGraphMetaDat4[1],
	            b_numDetected = _self$getGraphMetaDat4[2];
	
	        if (!a_detected && !b_detected) {
	          // when neither is detected, sort by which has more detects;
	          if (a_numDetected > b_numDetected) {
	            return -1;
	          }
	          if (a_numDetected < b_numDetected) {
	            return 1;
	          }
	          return 0;
	        }
	        if (a_percentile > b_percentile) {
	          return -1;
	        }
	        if (b_percentile < a_percentile) {
	          return 1;
	        }
	        return 0;
	      });
	
	      // const graphs : Graph[] = chemicals.filter((chemical) => {
	      //   return _.filter(this.getChemicalData(chemical), function(d){
	      //     // console.log(d);
	      //       // { mine: true }).length > 0;
	      //       return d
	      //     })
	      // }).map((chemical, i) => {
	      //   return (<Graph
	      //       key={chemical + i}
	      //       appState={this.props.appState}
	      //       data={this.getChemicalData(chemical)}
	      //       chemical={chemical}
	      //       chemical_full={chemicals_full[i]}
	      //       medium={medium}
	      //       yLimits={yLimits}
	      //       chemicalGroup={this.props.group}
	      //       pointerEvents={this.state.pointerEvents} />)
	      // })
	
	      if (_helpers2.default.findGetParameter('print')) {
	        // inline for print #3 -- tile the graphs instead of slick slider
	        return React.createElement(
	          'div',
	          { className: 'printgraphswrapper' },
	          graphs
	        );
	      } else {
	
	        // infinite={false} dots={true} useTransform={false} ref={this.sliderRef}
	        var slider_settings = {
	          infinite: false,
	          dots: true,
	          useTransform: false,
	          ref: this.sliderRef,
	          init: this.graph_event_log(0, chemicals[0]),
	          afterChange: function afterChange(current) {
	            return _this3.graph_event_log(current, chemicals[current]);
	          }
	        };
	
	        var render_result = React.createElement(
	          'div',
	          null,
	          horizontalCue,
	          React.createElement(
	            'div',
	            null,
	            graphs
	          )
	        );
	
	        return render_result;
	      }
	    }
	  }]);
	
	  return Graphs;
	}(React.Component)); // end Graphs
	
	
	exports.default = Graphs;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _reactRouterDom = __webpack_require__(57);
	
	var _reactRouter = __webpack_require__(32);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _MenuButton = __webpack_require__(591);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _Progress = __webpack_require__(593);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPosition = function getPosition(path) {
	  var keys = Object.keys(_NavigationStructure2.default);
	  return keys.indexOf(path) - 4;
	};
	var showProgress = function showProgress(path) {
	  return getPosition(path) >= 1;
	};
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, [{
	    key: 'languageClicked',
	    value: function languageClicked(val) {
	
	      var that = this;
	      var page = this.props.location.pathname;
	      var loggedOutPages = ["/", "/login"];
	      var linkTo = "/about";
	      if (!loggedOutPages.includes(page)) {
	        linkTo = "/";
	      }
	      _helpers2.default.eventLog('changeLanguageTo - ' + val);
	      setTimeout(function () {
	
	        that.props.appState.changeLanguage(val);
	        // we need the whole app to do a hard reload in the new language // not... that.props.history.push(`/`);
	        // if (window.localStorage.getItem('uid') && window.localStorage.getItem('avatar'))
	        // {
	        //    window.location = '/#/about';  // XXX: ideally we go back to where we came from
	        // }
	        // else
	        // {
	        //   window.location = '/';
	        // }
	        window.location = linkTo;
	        window.location.reload(); // forces a reload even if there is a # in the URL
	      }, 100);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var appState = this.props.appState;
	
	      var path = (0, _safeUrl2.default)('/images/' + appState.avatar + '.png');
	      var avatar = appState.avatar ? _react2.default.createElement(
	        'span',
	        { className: 'printhide' },
	        _react2.default.createElement(
	          'a',
	          { href: '/#/avatar' },
	          _react2.default.createElement('img', { border: '0', src: path, className: 'header-avatar', alt: 'Your Avatar' })
	        )
	      ) : null;
	
	      // const languageHTML    = appState.language ? (<span className='language printhide'><a href='/#/langset'>es/en</a></span>) : null;
	      // console.log(appState.language);
	      // console.log(languageHTML);
	      var languageHTML = void 0;
	      if (!appState.language) {
	        languageHTML = null;
	      } else {
	        if (appState.language == 'en') {
	          languageHTML = _react2.default.createElement(
	            'span',
	            { className: 'language printhide', onClick: function onClick() {
	                return _this2.languageClicked('es');
	              } },
	            'Espa\xF1ol'
	          );
	        } else if (appState.language == 'es') {
	          languageHTML = _react2.default.createElement(
	            'span',
	            { className: 'language printhide', onClick: function onClick() {
	                return _this2.languageClicked('en');
	              } },
	            'English'
	          );
	        }
	      }
	
	      var progress = showProgress(this.props.location.pathname) ? _react2.default.createElement(_Progress2.default, { at: getPosition(this.props.location.pathname), total: Object.keys(_NavigationStructure2.default).length - 5 }) : null;
	      //const progress = <Progress at={1} total={4} />;
	
	      var menu = _NavigationStructure2.default[this.props.location.pathname].menu === true ? _react2.default.createElement(_MenuButton2.default, { appState: appState }) : null;
	
	      var page = this.props.location.pathname;
	      var loggedOutPages = ["/", "/login"];
	      var titleLink = _react2.default.createElement(
	        'div',
	        { className: 'appTitle' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.title', defaultMessage: 'My <strong>IKIDS</strong>' })
	      );
	      // if (loggedOutPages.includes(page)) {
	      //   titleLink = <Link to='/' className="appTitle">
	      //     <FormattedHTMLMessage id='app.title' defaultMessage='My <strong>IKIDS</strong>' />
	      //   </Link>
	      // } else {
	      //   titleLink = <Link to='/about' className="appTitle">
	      //     <FormattedHTMLMessage id='app.title' defaultMessage='My <strong>IKIDS</strong>' />
	      //   </Link>
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          null,
	          avatar,
	          titleLink,
	          menu
	        ),
	        progress
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	;
	
	exports.default = (0, _reactRouter.withRouter)((0, _mobxReact.observer)(Header));

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(722);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Headline = function (_React$Component) {
	  _inherits(Headline, _React$Component);
	
	  function Headline() {
	    _classCallCheck(this, Headline);
	
	    return _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).apply(this, arguments));
	  }
	
	  _createClass(Headline, [{
	    key: 'scrollToTips',
	    value: function scrollToTips() {
	      _helpers2.default.eventLog("chemicalPage - jumpToTips");
	      var target = document.getElementById('section5_whatcanido');
	      // smoothScroll = function(target) {
	      var scrollContainer = target;
	      do {
	        //find scroll container
	        scrollContainer = scrollContainer.parentNode;
	        if (!scrollContainer) return;
	        scrollContainer.scrollTop += 1;
	      } while (scrollContainer.scrollTop == 0);
	
	      var targetY = 0;
	      do {
	        //find the top of target relatively to the container
	        if (target == scrollContainer) break;
	        targetY += target.offsetTop;
	      } while (target = target.offsetParent);
	
	      scroll = function (_scroll) {
	        function scroll(_x, _x2, _x3, _x4) {
	          return _scroll.apply(this, arguments);
	        }
	
	        scroll.toString = function () {
	          return _scroll.toString();
	        };
	
	        return scroll;
	      }(function (c, a, b, i) {
	        i++;if (i > 20) return;
	        c.scrollTop = a + (b - a) / 20 * i;
	        setTimeout(function () {
	          scroll(c, a, b, i);
	        }, 20);
	      });
	      // start scrolling
	      scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
	      // }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var highHeadline = false;
	      //  version 1: read the priority based on what's set by the researcher in priority_hml
	      // if (this.props.headline.priority_hml == "1-high") {highHeadline = true}
	      // version 2: read the priority based on a threshold for priorities
	      var highPriorityThreshold = 8;
	      if (this.props.headline.priority <= highPriorityThreshold) {
	        highHeadline = true;
	      }
	
	      var avatar = this.props.useAvatar === true && this.props.avatarName !== undefined ? React.createElement('img', { src: '/images/' + this.props.avatarName + '.png', width: '50', alt: 'Your Avatar' }) : React.createElement('div', null);
	
	      return React.createElement(
	        'div',
	        { className: 'headline ' + (highHeadline ? 'high' : 'low') },
	        React.createElement(
	          'div',
	          { className: 'headline-adjacent-content' },
	          avatar,
	          React.createElement(
	            'div',
	            null,
	            React.createElement(
	              'strong',
	              null,
	              this.props.headline.contents
	            )
	          )
	        ),
	        React.createElement(
	          'p',
	          { onClick: this.scrollToTips },
	          React.createElement(
	            'span',
	            { className: 'down-arrow' },
	            '\u2193'
	          ),
	          React.createElement(
	            'em',
	            { className: 'what-you-can-do' },
	            React.createElement(_reactIntl.FormattedMessage, { id: 'what_you_can_do', defaultMessage: 'Que se puede hacer' })
	          ),
	          React.createElement('br', null)
	        )
	      );
	    }
	  }]);
	
	  return Headline;
	}(React.Component);
	
	Headline.defaultProps = {
	  border: true
	};
	exports.default = Headline;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Legend.js
	
	
	var Legend = function (_React$Component) {
		_inherits(Legend, _React$Component);
	
		function Legend(props) {
			_classCallCheck(this, Legend);
	
			var _this = _possibleConstructorReturn(this, (Legend.__proto__ || Object.getPrototypeOf(Legend)).call(this, props));
	
			_this.state = { expanded: true };
			return _this;
		}
	
		_createClass(Legend, [{
			key: 'toggleExpanded',
			value: function toggleExpanded() {
				if (this.state.expanded) {
					_helpers2.default.eventLog('legend - collapse legend');
				} else {
					_helpers2.default.eventLog('legend - expand legend');
				}
	
				var newToggle = !this.state.expanded;
				this.setState({
					expanded: newToggle
				});
			}
		}, {
			key: 'render',
			value: function render() {
				// console.log(this.props); //EPH
				var chemicalGroup = this.props.chemicalGroup;
	
				var houseORavatarPNG = _helpers2.default.houseORavatar(this.props.appState.avatar, this.props.group) + ".png";
	
				//console.log(houseORavatarPNG + "|" + this.props.group + "|"+ this.props.appState.avatar);
	
				var benchMarkIcon = _helpers2.default.benchmarkName(this.props.group); //XXX hardwired - better to glean this direct from the compounds.json data
				var benchMarkHTML = React.createElement('tr', null);
	
				if (benchMarkIcon === "max_level") {
					benchMarkHTML = React.createElement(
						'tr',
						null,
						React.createElement(
							'td',
							null,
							React.createElement(
								'svg',
								{ height: '20', width: '20' },
								React.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/graph-blue-star.png'), width: '12', height: '12', transform: 'translate(7, 7)' })
							)
						),
						React.createElement(
							'td',
							null,
							React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.max_level', defaultMessage: 'Nivel m\xE1ximo de contaminante' })
						)
					);
				}
	
				if (benchMarkIcon === "us_median") {
					benchMarkHTML = React.createElement(
						'tr',
						null,
						React.createElement(
							'td',
							null,
							React.createElement(
								'svg',
								{ height: '20', width: '20' },
								React.createElement('circle', { cx: '13', cy: '13', r: '5', stroke: 'rgb(13 94 143)', fill: 'transparent' }),
								React.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/us.svg'), width: '8', height: '8', transform: 'translate(9, 9)' })
							)
						),
						React.createElement(
							'td',
							null,
							React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.us_median', defaultMessage: 'Media EEUU' })
						)
					);
				}
	
				var chevronState = void 0;
				if (this.state.expanded) {
					chevronState = "chevron-arrow-down";
				} else {
					chevronState = "chevron-arrow-right";
				}
	
				var circleRadius = 15;
				var rectWidth = circleRadius * 2 - 10;
				var rectHeight = rectWidth * 0.7;
	
				var avatarHTML = void 0;
				var avatarCircleHTML = void 0;
				if (this.props.appState.avatar == "face-7") {
					avatarCircleHTML = React.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 1, stroke: 'white', strokeWidth: '2px', fill: '#ff5000' });
				} else {
					avatarHTML = React.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/' + houseORavatarPNG), width: 2 * circleRadius, height: 2 * circleRadius });
					avatarCircleHTML = React.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 1, stroke: '#ff5000', strokeWidth: '2px', fill: 'transparent' });
				}
	
				var iconRow = void 0;
				if (!this.state.expanded) {
					iconRow = React.createElement(
						'div',
						{ className: 'icon-row' },
						React.createElement(
							'svg',
							{ height: 2 * circleRadius, width: 2 * circleRadius },
							avatarHTML,
							avatarCircleHTML
						),
						React.createElement(
							'svg',
							{ height: 2 * circleRadius, width: 2 * circleRadius },
							React.createElement('line', { x1: '0', y1: circleRadius, x2: 2 * circleRadius, y2: circleRadius, stroke: 'rgb(13 94 143)', strokeWidth: '3px' }),
							React.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/usflag.svg'), y: 5, width: 30, height: 20 }),
							React.createElement('rect', { x: circleRadius - rectWidth / 2, y: circleRadius - rectHeight / 2, width: rectWidth, height: rectHeight, rx: 2, ry: 2, stroke: 'rgb(13 94 143)', strokeWidth: '2px', fill: 'transparent' })
						),
						React.createElement(
							'svg',
							{ height: 2 * circleRadius, width: 2 * circleRadius },
							React.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 4, stroke: 'rgb(119, 158, 255)', strokeWidth: '3px', fill: 'transparent' })
						),
						React.createElement(
							'svg',
							{ height: 2 * circleRadius, width: 2 * circleRadius },
							React.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 4, stroke: '#ccc', strokeWidth: '3px', fill: 'transparent' })
						)
					);
				}
	
				var legendHeader = React.createElement(
					'div',
					{ className: 'legend-header', onClick: this.toggleExpanded.bind(this) },
					React.createElement('span', { className: chevronState + " legend-chevron" }),
					React.createElement(
						'h3',
						{ className: 'legend-header-text' },
						React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.legend', defaultMessage: 'Leyenda123' })
					),
					iconRow
				);
	
				var legendBody = void 0;
				if (this.state.expanded) {
					legendBody = React.createElement(
						'div',
						null,
						React.createElement(
							'div',
							{ className: 'legend-item' },
							React.createElement(
								'div',
								{ className: 'legend-icon' },
								React.createElement(
									'svg',
									{ height: 2 * circleRadius, width: 2 * circleRadius },
									avatarHTML,
									avatarCircleHTML
								)
							),
							React.createElement(
								'span',
								{ className: 'legend-label' },
								React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.your_results', defaultMessage: 'Sus resultados' })
							)
						),
						React.createElement(
							'div',
							{ className: 'legend-item' },
							React.createElement(
								'div',
								{ className: 'legend-icon' },
								React.createElement(
									'svg',
									{ height: 2 * circleRadius, width: 2 * circleRadius },
									React.createElement('line', { x1: '0', y1: circleRadius, x2: 2 * circleRadius, y2: circleRadius, stroke: 'rgb(13 94 143)', strokeWidth: '5px' }),
									React.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/usflag.svg'), y: 5, width: 30, height: 20 }),
									React.createElement('rect', { x: circleRadius - rectWidth / 2, y: circleRadius - rectHeight / 2, width: rectWidth, height: rectHeight, rx: 2, ry: 2, stroke: 'rgb(13 94 143)', strokeWidth: '2px', fill: 'transparent' })
								)
							),
							React.createElement(
								'span',
								{ className: 'legend-label' },
								React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.us_median', defaultMessage: 'Media EEUU' })
							)
						),
						React.createElement(
							'div',
							{ className: 'legend-item' },
							React.createElement(
								'div',
								{ className: 'legend-icon' },
								React.createElement(
									'svg',
									{ height: 2 * circleRadius, width: 2 * circleRadius },
									React.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 4, stroke: 'rgb(119, 158, 255)', strokeWidth: '3px', fill: 'transparent' })
								)
							),
							React.createElement(
								'span',
								{ className: 'legend-label' },
								React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.other_women', defaultMessage: 'Otras mujeres en PROTECT' })
							)
						),
						React.createElement(
							'div',
							{ className: 'legend-item' },
							React.createElement(
								'div',
								{ className: 'legend-icon' },
								React.createElement(
									'svg',
									{ height: 2 * circleRadius, width: 2 * circleRadius },
									React.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 4, stroke: '#ccc', strokeWidth: '3px', fill: 'transparent' })
								)
							),
							React.createElement(
								'span',
								{ className: 'legend-label' },
								React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.non_detects', defaultMessage: 'Muestras donde no se detect\xF3 la sustancia qu\xEDmica' })
							)
						),
						React.createElement(
							'div',
							{ className: 'legend-item' },
							React.createElement(
								'span',
								{ className: 'legend-icon legend-unit' },
								React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + chemicalGroup + '.graph.units' })
							),
							React.createElement(
								'span',
								{ className: 'legend-label legend-unit-description' },
								React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + chemicalGroup + '.graph.units_description' })
							)
						)
					);
				}
	
				var theHTML2 = React.createElement(
					'div',
					null,
					React.createElement(
						'em',
						null,
						React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.legend', defaultMessage: 'Leyenda123' })
					),
					React.createElement('br', null),
					React.createElement(
						'table',
						null,
						React.createElement(
							'tbody',
							null,
							benchMarkHTML,
							React.createElement(
								'tr',
								null,
								React.createElement(
									'td',
									{ valign: 'top' },
									React.createElement(
										'svg',
										{ height: '20', width: '20' },
										React.createElement('circle', { cx: '13', cy: '13', r: '5', stroke: '#ff5000', fill: 'transparent' }),
										React.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/' + houseORavatarPNG), width: '10', height: '10', transform: 'translate(8, 8)' })
									)
								),
								React.createElement(
									'td',
									null,
									React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.your_results', defaultMessage: 'Sus resultados' })
								)
							),
							React.createElement(
								'tr',
								null,
								React.createElement(
									'td',
									{ valign: 'top' },
									React.createElement(
										'svg',
										{ height: '20', width: '20' },
										React.createElement('circle', { cx: '13', cy: '13', r: '5', stroke: '#097dc2', fill: 'transparent' })
									)
								),
								React.createElement(
									'td',
									null,
									React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.other_women', defaultMessage: 'Otras mujeres en PROTECT' })
								)
							),
							React.createElement(
								'tr',
								null,
								React.createElement(
									'td',
									{ valign: 'top' },
									React.createElement(
										'svg',
										{ height: '20', width: '20' },
										React.createElement('circle', { cx: '13', cy: '13', r: '5', stroke: '#ccc', fill: 'transparent' })
									)
								),
								React.createElement(
									'td',
									null,
									React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.non_detects', defaultMessage: 'Muestras donde no se detect\xF3 la sustancia qu\xEDmica' })
								)
							)
						)
					),
					React.createElement(
						'p',
						{ className: 'printhide_v', id: 'id_clickformoreinfo' },
						React.createElement(_reactIntl.FormattedMessage, { id: 'graphs.tap_to_learn', defaultMessage: 'Toque cualquier parte del gr\xE1fico para obtener m\xE1s informaci\xF3n' })
					)
				);
	
				// return theHTML;
				return React.createElement(
					'div',
					null,
					legendHeader,
					legendBody
				);
			}
		}]);
	
		return Legend;
	}(React.Component);
	
	exports.default = Legend;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(57);
	
	var _reactIntl = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(32);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	var _Api = __webpack_require__(31);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { FAQ } from './FAQ.js';
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
	  }
	
	  _createClass(Menu, [{
	    key: 'linkClicked',
	    value: function linkClicked(linkClickedTo) {
	      _helpers2.default.eventLog("nav:menu button pressed - Menu.linkClicked() - " + linkClickedTo);
	      this.props.linkClicked(); // attach to onClick handlers of Links in Menu. Call Menu's parent (MenuButton) linkClicked via function sent via JSX props linkClicked={...}
	    }
	  }, {
	    key: 'faqClicked',
	    value: function faqClicked() {
	      alert('open faq');
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose(e) {
	      //e.stopPropagation();
	      e.preventDefault();
	      //1 -- eh (not updating menuopen so has side-effects)
	      //document.getElementsByClassName("menu")[0].style.display = 'none' // not quite -- we want to trigger toggleMenu
	      //2 -- better, but not taking advantage of React
	      //document.getElementsByClassName("menu-button-span")[0].click(); // toggleMenu
	      //3 -- correct
	      this.linkClicked('menu.close top');
	      return false;
	    }
	  }, {
	    key: 'logoutClicked',
	    value: function logoutClicked() {
	      _helpers2.default.eventLog("nav:menu button pressed - Menu.logoutClicked()");
	      document.getElementsByTagName("body")[0].style.overflow = "visible";
	      _Api.Api.logout();
	      this.props.history.push('/');
	      this.props.appState.logOut();
	    }
	  }, {
	    key: 'participantHasResultsInGroup',
	    value: function participantHasResultsInGroup(group) {
	      var group_name = this.props.intl.messages['chemicals.' + group + '.data'];
	      if (this.props.appState.groups !== undefined && this.props.appState.groups[group_name] !== undefined) {
	        return this.props.appState.groups[group_name].filter(function (d) {
	          return d.mine === true;
	        }).length > 0;
	      } else return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currentPage = this.props.location.pathname;
	
	      var pageKeys = Object.keys(_NavigationStructure2.default);
	      var itemsByHeader = {};
	      for (var i = 0; i < pageKeys.length; i++) {
	        var pageKey = pageKeys[i];
	        var thisPage = _NavigationStructure2.default[pageKey];
	
	        var showInMenu = true;
	        // some pages have a flag to not show in the menu
	        if (thisPage.hideinmenu) {
	          showInMenu = false;
	        }
	        // some of the beginning pages don't have a menu, and won't be in the menu
	        if (!thisPage.menu) {
	          showInMenu = false;
	        }
	        // don't show in menu if the participant doesn't have results
	        if (thisPage.group) {
	          if (!this.participantHasResultsInGroup(thisPage.group)) {
	            showInMenu = false;
	          }
	        }
	        // don't show the poe in the menu unless the study group is poe
	        if (thisPage.id == "page.graphreading" && !this.props.appState.showPOE) {
	          showInMenu = false;
	        }
	
	        if (showInMenu) {
	          var header = thisPage.menuSection || "";
	          if (!itemsByHeader[header]) {
	            itemsByHeader[header] = [];
	          }
	          thisPage.key = pageKey;
	          itemsByHeader[header].push(thisPage);
	        }
	      }
	
	      var items = [];
	      var headers = Object.keys(itemsByHeader);
	      for (var h = 0; h < headers.length; h++) {
	        var _header = headers[h];
	        var noHeader = "";
	        if (_header) {
	          var headerObject = _react2.default.createElement(
	            'li',
	            { key: "header" + h, className: 'menu-section-header' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: _header })
	          );
	          items.push(headerObject);
	        } else if (_header == "") {
	          items.push(_react2.default.createElement('div', { className: 'menu-section-separator', key: "section-separator" + h }));
	          noHeader = "no-header";
	        }
	
	        for (var _i = 0; _i < itemsByHeader[_header].length; _i++) {
	          var page = itemsByHeader[_header][_i];
	          var myPage = "";
	          if (page.key == currentPage) {
	            myPage = " current-page";
	          }
	          var menuItem = _react2.default.createElement(
	            'li',
	            { key: page.key },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: page.key, onClick: this.linkClicked.bind(this, page.key /*linkClickedTo*/), className: 'menu-item ' + noHeader + myPage },
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: page.id + ".title" })
	            )
	          );
	          items.push(menuItem);
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'menu' },
	        _react2.default.createElement(
	          'a',
	          { href: '#', className: 'button right', onClick: this.onClose.bind(this) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'close', defaultMessage: 'Cerrar' })
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'menu-title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu', defaultMessage: 'Men\xFA' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          items,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'menu-item lowpriority no-header', onClick: this.logoutClicked.bind(this) },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.logout' })
	            )
	          ),
	          _react2.default.createElement('li', null)
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactIntl.injectIntl)(Menu));

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _Menu = __webpack_require__(590);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuButton = function (_Component) {
	  _inherits(MenuButton, _Component);
	
	  function MenuButton() {
	    _classCallCheck(this, MenuButton);
	
	    var _this = _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call(this));
	
	    _this.state = { menuopen: false };
	    return _this;
	  }
	
	  _createClass(MenuButton, [{
	    key: 'toggleMenu',
	    value: function toggleMenu() {
	      if (this.state.menuopen) {
	        this.setState({ menuopen: false });
	        document.getElementsByTagName("body")[0].style.overflow = "visible";
	      } else {
	        _helpers2.default.eventLog("modal - menuopen");
	        this.setState({ menuopen: true });
	        document.getElementsByTagName("body")[0].style.overflow = "hidden";
	      }
	    }
	  }, {
	    key: 'linkClicked',
	    value: function linkClicked() {
	      this.setState({ menuopen: false });
	      // NO do this in Menu.js -- helpers.eventLog("nav:menu button pressed -  - " + this.props.to);
	      document.getElementsByTagName("body")[0].style.overflow = "visible";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var menu = this.state.menuopen ? _react2.default.createElement(_Menu2.default, { linkClicked: this.linkClicked.bind(this), appState: this.props.appState }) : '';
	
	      // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z" fill="rgba(255,255,255,1)"/></svg>
	      var hamburgerIcon = _react2.default.createElement(
	        'svg',
	        { className: 'hamburgerIcon', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', width: '24', height: '24' },
	        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' }),
	        _react2.default.createElement('path', { d: 'M3 4h25v3H3V4zm0 8h25v3H3v-2zm0 8h25v3H3v-2z', fill: 'rgba(255,255,255,1)' })
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'menu-button printhide' },
	        _react2.default.createElement(
	          'span',
	          { className: 'menu-button-span', onClick: this.toggleMenu.bind(this) },
	          hamburgerIcon
	        ),
	        menu
	      );
	    }
	  }]);
	
	  return MenuButton;
	}(_react.Component);
	
	exports.default = MenuButton;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	var _FAQ = __webpack_require__(585);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _NavigationButton = __webpack_require__(220);
	
	var _NavigationButton2 = _interopRequireDefault(_NavigationButton);
	
	__webpack_require__(727);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationButtons = function (_Component) {
	  _inherits(NavigationButtons, _Component);
	
	  function NavigationButtons() {
	    _classCallCheck(this, NavigationButtons);
	
	    return _possibleConstructorReturn(this, (NavigationButtons.__proto__ || Object.getPrototypeOf(NavigationButtons)).apply(this, arguments));
	  }
	
	  _createClass(NavigationButtons, [{
	    key: 'showPreviousButton',
	    value: function showPreviousButton() {
	      return _NavigationStructure2.default[this.props.location.pathname].showButtons || _NavigationStructure2.default[this.props.location.pathname].showPrevious;
	    }
	  }, {
	    key: 'showNextButton',
	    value: function showNextButton() {
	      return _NavigationStructure2.default[this.props.location.pathname].showButtons || _NavigationStructure2.default[this.props.location.pathname].showNext;
	    }
	  }, {
	    key: 'showFAQ',
	    value: function showFAQ() {
	      return _NavigationStructure2.default[this.props.location.pathname].FAQ || false;
	    }
	  }, {
	    key: 'participantHasResultsInGroup',
	    value: function participantHasResultsInGroup(group) {
	      var group_name = this.props.intl.messages['chemicals.' + group + '.data'];
	      if (this.props.appState.groups !== undefined && this.props.appState.groups[group_name] !== undefined) {
	        return this.props.appState.groups[group_name].filter(function (d) {
	          return d.mine === true;
	        }).length > 0;
	      } else return false;
	    }
	  }, {
	    key: 'previousPage',
	    value: function previousPage() {
	      var keys = Object.keys(_NavigationStructure2.default);
	      var index = keys.indexOf(this.props.location.pathname);
	      return this._previousPage(index);
	    }
	  }, {
	    key: '_previousPage',
	    value: function _previousPage(index) {
	      var keys = Object.keys(_NavigationStructure2.default);
	      // if(navigationStructure[keys[index - 1]].group !== undefined) {
	      //   if(this.participantHasResultsInGroup(navigationStructure[keys[index - 1]].group)) {
	      //     return keys[index - 1];
	      //   }
	      //   else {
	      //     return this._previousPage(index - 1);
	      //   }
	      // }
	      // else if(keys[index - 1] === '/water_summary') {
	      //   if(!this.participantHasResultsInGroup('water_cvocs') && !this.participantHasResultsInGroup('water_phthalates')) {
	      //     return this._previousPage(index - 1);
	      //   }
	      // }
	
	      // skip the poe if not in the study group that gets it
	      if (keys[index - 1] == "/readinggraphs") {
	        if (!this.props.appState.showPOE) {
	          return keys[index - 2];
	        }
	      }
	
	      // from the community action, the previous button does to summary
	      if (this.props.location.pathname.includes("/community_action")) {
	        return "/summary";
	      }
	
	      return keys[index - 1];
	    }
	  }, {
	    key: 'nextPage',
	    value: function nextPage() {
	      // the next button on the tour page behaves differently
	      if (this.props.location.pathname == "/readinggraphs") {
	        return "/readinggraphs#tour";
	      }
	
	      var keys = Object.keys(_NavigationStructure2.default);
	      var index = keys.indexOf(this.props.location.pathname);
	      return this._nextPage(index);
	    }
	  }, {
	    key: '_nextPage',
	    value: function _nextPage(index) {
	      var keys = Object.keys(_NavigationStructure2.default);
	
	      // from the chemical page, the "next" button goes back to the summary
	      if (this.props.location.pathname.includes("/chemicals/")) {
	        return "/summary";
	      }
	
	      // from the personal results summary page, the "next" button goes back to the community action
	      if (this.props.location.pathname.includes("/summary")) {
	        return "/community_action";
	      }
	
	      // if(navigationStructure[keys[index + 1]].group !== undefined) {
	      //   if(this.participantHasResultsInGroup(navigationStructure[keys[index + 1]].group)) {
	      //     return keys[index + 1];
	      //   }
	      //   else {
	      //     return this._nextPage(index + 1);
	      //   }
	      // }
	      // else if(keys[index + 1] === '/water_summary') {
	      //   // check if the participant has any water results
	      //   if(!this.participantHasResultsInGroup('water_cvocs') && !this.participantHasResultsInGroup('water_phthalates')) {
	      //     return '/community_action';
	      //   }
	      // }
	
	      // skip the poe if not in the study group that gets it
	      if (keys[index + 1] == "/readinggraphs") {
	        if (!this.props.appState.showPOE) {
	          return keys[index + 2];
	        }
	      }
	
	      return keys[index + 1];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log(this.props);
	      // let chemicalPage = false;
	      // if (this.props.location.pathname.includes("/chemicals/")) {chemicalPage = true}
	      var page = "";
	      if (this.props.location.pathname.includes("/about")) {
	        page = "about";
	      }
	      if (this.props.location.pathname.includes("/summary")) {
	        page = "summaryResultsPage";
	      }
	      if (this.props.location.pathname.includes("/chemicals/")) {
	        page = "chemicalsPage";
	      }
	
	      var previous = this.showPreviousButton() ? _react2.default.createElement(_NavigationButton2.default, { to: this.previousPage(), side: 'left', lowPriority: true, messageId: 'previous' }) : null;
	
	      var nextMessageID = "next";
	      if (this.props.location.pathname.includes("/summary")) {
	        nextMessageID = 'more_ways_to_help';
	      }
	      if (this.props.location.pathname.includes("/chemicals/")) {
	        nextMessageID = "back_to_summary";
	      }
	      var next = this.showNextButton() ? _react2.default.createElement(_NavigationButton2.default, { to: this.nextPage(), side: 'right', messageId: nextMessageID, page: page }) : null;
	
	      var numFAQs = this.props.intl.messages['common_questions.number_questions'];
	      var faq = this.showFAQ() ? _react2.default.createElement(_FAQ2.default, { numFAQs: numFAQs }) : null;
	
	      var backToSummary = void 0;
	      // if (chemicalPage) {
	      //   backToSummary = <NavigationButton to="/summary" side="left" lowPriority={true} messageId='back_to_summary' currentPage={this.props.location.pathname}/>
	      // }
	
	
	      return previous != null || next != null ? _react2.default.createElement(
	        'div',
	        { className: 'buttons' },
	        backToSummary,
	        next,
	        previous,
	        faq
	      ) : null;
	    }
	  }]);
	
	  return NavigationButtons;
	}(_react.Component);
	
	;
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)((0, _mobxReact.observer)(NavigationButtons)));

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Progress = function (_Component) {
	  _inherits(Progress, _Component);
	
	  function Progress() {
	    _classCallCheck(this, Progress);
	
	    return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
	  }
	
	  _createClass(Progress, [{
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: this.props.at / this.props.total * 100 + '%'
	      };
	
	      return _react2.default.createElement('div', { className: 'progress', style: style });
	    }
	  }]);
	
	  return Progress;
	}(_react.Component);
	
	exports.default = Progress;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _reactRouter = __webpack_require__(32);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableOfContentsItem = (0, _reactRouter.withRouter)((0, _reactIntl.injectIntl)((0, _mobxReact.observer)(function (_Component) {
	  _inherits(SummaryTableItem, _Component);
	
	  function SummaryTableItem() {
	    _classCallCheck(this, SummaryTableItem);
	
	    return _possibleConstructorReturn(this, (SummaryTableItem.__proto__ || Object.getPrototypeOf(SummaryTableItem)).apply(this, arguments));
	  }
	
	  _createClass(SummaryTableItem, [{
	    key: 'navigate',
	    value: function navigate() {
	      var url = '/' + this.props.value.id.replace('.', '/');
	      _helpers2.default.eventLog("nav:tableofcontents link clicked -  - " + url);
	      this.props.history.push(url);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chemical = this.props.value.group;
	      var iconUrl = (0, _safeUrl2.default)('/images/' + this.props.intl.messages['chemicals.' + _helpers2.default.convertGroupName(chemical) + '.icon']);
	      var hexColor = _helpers2.default.getIconColor(_helpers2.default.convertGroupName(chemical), this.props.intl);
	
	      return _react2.default.createElement(
	        'tr',
	        { key: this.props.value.id, onTouchEnd: this.navigate.bind(this), onClick: this.navigate.bind(this) },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement('span', { className: 'group-icon', style: {
	              mask: 'url(' + iconUrl + ')',
	              WebkitMask: 'url(' + iconUrl + ')',
	              display: "inline-block",
	              background: hexColor,
	              WebkitMaskSize: "cover",
	              maskSize: "cover",
	              width: 35,
	              height: 35
	            } })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.value.id + ".title" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SummaryTableItem;
	}(_react.Component))));
	
	var TableOfContents = function (_Component2) {
	  _inherits(TableOfContents, _Component2);
	
	  function TableOfContents() {
	    _classCallCheck(this, TableOfContents);
	
	    return _possibleConstructorReturn(this, (TableOfContents.__proto__ || Object.getPrototypeOf(TableOfContents)).apply(this, arguments));
	  }
	
	  _createClass(TableOfContents, [{
	    key: 'goToPersonalSummary',
	    value: function goToPersonalSummary() {
	      var url = '/summary';
	      _helpers2.default.eventLog("nav:tableofcontents link clicked -  - " + url);
	      this.props.history.push(url);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'goToStudySummary',
	    value: function goToStudySummary() {
	      var url = '/overallstudyresults';
	      _helpers2.default.eventLog("nav:tableofcontents link clicked -  - " + url);
	      this.props.history.push(url);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // let homeUrl = safeUrl(`/images/icon-home.svg`)
	      // let return_to_summary = (
	      //   <tr key={"summary"} onClick={this.goToSummary.bind(this)}>
	      //     <td>
	      //       <span className='group-icon' style={{
	      //           mask: `url(${homeUrl})`,
	      //           WebkitMask: `url(${homeUrl})`,
	      //           display: "inline-block",
	      //           background: "black",
	      //           WebkitMaskSize: "cover",
	      //           maskSize: "cover",
	      //           width: 35,
	      //           height: 35,
	      //         }}/>
	      //     </td>
	      //     <td>
	      //       <strong><FormattedMessage id={"app.pages.summary.title"} /></strong>
	      //     </td>
	      //   </tr>
	      //   )
	      var return_to_personal_summary = _react2.default.createElement(
	        'p',
	        { className: 'no-icon-page-link', onClick: this.goToPersonalSummary.bind(this) },
	        _react2.default.createElement(
	          'strong',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: "app.pages.summary.title" })
	        )
	      );
	      var return_to_study_summary = _react2.default.createElement(
	        'p',
	        { className: 'no-icon-page-link', onClick: this.goToStudySummary.bind(this) },
	        _react2.default.createElement(
	          'strong',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: "page.overallstudyresults.title" })
	        )
	      );
	
	      var summary_items = this.props.items.map(function (value) {
	        return _react2.default.createElement(TableOfContentsItem, { key: value.id, value: value, appState: _this3.props.appState });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        return_to_study_summary,
	        return_to_personal_summary,
	        _react2.default.createElement(
	          'table',
	          { className: 'overview' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            summary_items
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableOfContents;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(TableOfContents);

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(81);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(583);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(730);
	
	var _Locale = __webpack_require__(76);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _Locale2.default)().then(function () {
	  return _reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));
	});

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIntl = __webpack_require__(4);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutModal = function (_Component) {
	  _inherits(AboutModal, _Component);
	
	  function AboutModal() {
	    _classCallCheck(this, AboutModal);
	
	    return _possibleConstructorReturn(this, (AboutModal.__proto__ || Object.getPrototypeOf(AboutModal)).apply(this, arguments));
	  }
	
	  _createClass(AboutModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClose: this.props.onClose, className: 'left-align' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'about.read_more_content' })
	      );
	    }
	  }]);
	
	  return AboutModal;
	}(_react.Component);
	
	var AboutPage = function (_Component2) {
	  _inherits(AboutPage, _Component2);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    var _this2 = _possibleConstructorReturn(this, (AboutPage.__proto__ || Object.getPrototypeOf(AboutPage)).call(this));
	
	    _this2.state = {
	      modal: false,
	      showMore: false
	    };
	    return _this2;
	  }
	
	  _createClass(AboutPage, [{
	    key: 'onClick',
	    value: function onClick() {
	      if (this.state.showMore) {
	        _helpers2.default.eventLog("modal - lessabout");
	      } else {
	        _helpers2.default.eventLog("modal - moreabout");
	      }
	      // this.setState({ modal: true });
	      // document.getElementsByTagName("body")[0].style.overflow = "hidden";
	      this.setState({ showMore: !this.state.showMore });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      // this.setState({ modal: false });
	      // document.getElementsByTagName("body")[0].style.overflow = "visible";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modal = this.state.modal ? _react2.default.createElement(AboutModal, { onClose: this.onClose.bind(this) }) : null;
	
	      var readMoreButton = void 0;
	      if (this.state.showMore) {
	        readMoreButton = _react2.default.createElement(
	          'a',
	          { className: 'button secondary scroll-content arrow-up', onClick: this.onClick.bind(this) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'show_less', defaultMessage: 'Show less' })
	        );
	      } else {
	        readMoreButton = _react2.default.createElement(
	          'a',
	          { className: 'button secondary scroll-content arrow-down', onClick: this.onClick.bind(this) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'about.read_more_button', defaultMessage: 'Show more' })
	        );
	      }
	
	      var additionText = void 0;
	      if (this.state.showMore) {
	        additionText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'about.read_more_content' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page about' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'about.title', defaultMessage: 'About IKIDS' })
	        ),
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'about.content' }),
	        _react2.default.createElement('br', null),
	        additionText,
	        readMoreButton
	      );
	    }
	  }]);
	
	  return AboutPage;
	}(_react.Component);
	
	exports.default = AboutPage;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _DetectionsTable = __webpack_require__(218);
	
	var _DetectionsTable2 = _interopRequireDefault(_DetectionsTable);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// AppendixPage.js
	// adapated from OverallStudyResultsPage.js
	
	//import Modal from '../components/Modal.js';
	
	
	var AppendixPage = function (_React$Component) {
	    _inherits(AppendixPage, _React$Component);
	
	    function AppendixPage() {
	        _classCallCheck(this, AppendixPage);
	
	        return _possibleConstructorReturn(this, (AppendixPage.__proto__ || Object.getPrototypeOf(AppendixPage)).apply(this, arguments));
	    }
	
	    _createClass(AppendixPage, [{
	        key: 'mydetections_UNFILTERED',
	        value: function mydetections_UNFILTERED() {
	            //let wantwaterYN = this.waterpage();
	            return this.props.appState.data.filter(function (d) {
	                return d.mine === true;
	            });
	            //  .filter(this.mydetections_waterFilterFunction, wantwaterYN)
	            //  .sort(this.mydetections_Compare)
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                'div',
	                { className: 'page appendix-page' },
	                React.createElement(
	                    'h1',
	                    null,
	                    React.createElement(_reactIntl.FormattedMessage, { id: 'your_results', defaultMessage: 'Your Results' })
	                ),
	                React.createElement(
	                    'h2',
	                    { 'class': 'capfirstletter' },
	                    React.createElement(_reactIntl.FormattedMessage, { id: 'in_urine', defaultMessage: 'XXX2' })
	                ),
	                React.createElement(_DetectionsTable2.default, {
	                    thedetections: this.mydetections_UNFILTERED(),
	                    iswatertable: false,
	                    thispage: this
	                }),
	                React.createElement(
	                    'h2',
	                    { 'class': 'capfirstletter' },
	                    React.createElement(_reactIntl.FormattedMessage, { id: 'in_water', defaultMessage: 'XXX2' })
	                ),
	                React.createElement(_DetectionsTable2.default, {
	                    thedetections: this.mydetections_UNFILTERED(),
	                    iswatertable: true,
	                    thispage: this
	                })
	            );
	        }
	    }]);
	
	    return AppendixPage;
	}(React.Component); // end AppendixPage
	
	exports.default = (0, _reactIntl.injectIntl)((0, _mobxReact.observer)(AppendixPage));

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AvatarPage = function (_Component) {
	  _inherits(AvatarPage, _Component);
	
	  function AvatarPage() {
	    _classCallCheck(this, AvatarPage);
	
	    return _possibleConstructorReturn(this, (AvatarPage.__proto__ || Object.getPrototypeOf(AvatarPage)).apply(this, arguments));
	  }
	
	  _createClass(AvatarPage, [{
	    key: 'avatarClicked',
	    value: function avatarClicked(face) {
	      var faceNoDash = face.replace(/-/g, "");
	      _helpers2.default.eventLog('chooseAvatar - ' + faceNoDash);
	
	      var clone = this.refs[face].cloneNode(true);
	      var position = this.refs[face].getBoundingClientRect();
	      clone.style.width = position.right - position.left + 'px';
	      clone.style.height = position.bottom - position.top + 'px';
	      clone.style.position = 'absolute';
	      clone.style.left = position.left + 'px';
	      clone.style.top = position.top + window.scrollY - 30 + 'px';
	      clone.className += " animate";
	
	      document.body.appendChild(clone);
	
	      this.refs[face].style.visibility = 'hidden';
	
	      // perhaps changing this order will make it less laggy
	      var that = this;
	      setTimeout(function () {
	        that.props.appState.changeAvatar(face);
	        if (that.props.prevPage == "/login" && that.props.appState.loggedIn) {
	          that.props.history.push('/about');
	        } else {
	          that.props.history.goBack();
	        }
	        window.scrollTo(0, 0);
	        clone.remove();
	      }, 1100);
	
	      setTimeout(function () {
	        clone.style.left = '10px';
	        clone.style.top = '-20px';
	        clone.style.height = '40px';
	        clone.style.width = '40px';
	      }, 50);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      window.scrollTo(0, 0);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page avatar', ref: 'page' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.pages.avatar.instructions', defaultMessage: 'Choose your avatar' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.pages.avatar.contents', defaultMessage: 'This face represents you in the report!' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'avatar-container' },
	          _react2.default.createElement('img', { src: ("") + '/images/face-1.png', className: 'avatar', ref: 'face-1', onClick: function onClick() {
	              return _this2.avatarClicked('face-1');
	            }, alt: 'Avatar 1' }),
	          _react2.default.createElement('img', { src: ("") + '/images/face-5.png', className: 'avatar', ref: 'face-5', onClick: function onClick() {
	              return _this2.avatarClicked('face-5');
	            }, alt: 'Avatar 5' }),
	          _react2.default.createElement('img', { src: ("") + '/images/face-2.png', className: 'avatar', ref: 'face-2', onClick: function onClick() {
	              return _this2.avatarClicked('face-2');
	            }, alt: 'Avatar 2' }),
	          _react2.default.createElement('img', { src: ("") + '/images/face-3.png', className: 'avatar', ref: 'face-3', onClick: function onClick() {
	              return _this2.avatarClicked('face-3');
	            }, alt: 'Avatar 3' }),
	          _react2.default.createElement('img', { src: ("") + '/images/face-4.png', className: 'avatar', ref: 'face-4', onClick: function onClick() {
	              return _this2.avatarClicked('face-4');
	            }, alt: 'Avatar 4' }),
	          _react2.default.createElement('img', { src: ("") + '/images/face-6.png', className: 'avatar', ref: 'face-6', onClick: function onClick() {
	              return _this2.avatarClicked('face-6');
	            }, alt: 'Avatar 6' }),
	          _react2.default.createElement('img', { src: ("") + '/images/face-7.png', className: 'avatar', ref: 'face-7', onClick: function onClick() {
	              return _this2.avatarClicked('face-7');
	            }, alt: 'Avatar 7' })
	        )
	      );
	    }
	  }]);
	
	  return AvatarPage;
	}(_react.Component);
	
	exports.default = AvatarPage;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _Legend = __webpack_require__(589);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Graphs = __webpack_require__(586);
	
	var _Graphs2 = _interopRequireDefault(_Graphs);
	
	var _Headline = __webpack_require__(588);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _lodash = __webpack_require__(26);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(715);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ChemicalPage.js
	// _.filter() etc
	
	
	var MoreInfoModal = function (_React$Component) {
	  _inherits(MoreInfoModal, _React$Component);
	
	  function MoreInfoModal() {
	    _classCallCheck(this, MoreInfoModal);
	
	    return _possibleConstructorReturn(this, (MoreInfoModal.__proto__ || Object.getPrototypeOf(MoreInfoModal)).apply(this, arguments));
	  }
	
	  _createClass(MoreInfoModal, [{
	    key: 'render',
	    value: function render() {
	      var messageIdFull = 'chemicals.' + this.props.chemicalGroup + '.moreinfo.' + this.props.messageId;
	
	      return React.createElement(
	        _Modal2.default,
	        { onClose: this.props.onClose, className: 'more-info left-align', fullScreen: true },
	        React.createElement(_reactIntl.FormattedHTMLMessage, { id: messageIdFull })
	      );
	    }
	  }]);
	
	  return MoreInfoModal;
	}(React.Component);
	
	var MoreButton = function MoreButton(_ref) {
	  var onClick = _ref.onClick,
	      id = _ref.id,
	      classes = _ref.classes;
	  return React.createElement(
	    'a',
	    { className: 'button right secondary chem-more-tips-button ' + classes, onClick: onClick },
	    React.createElement(_reactIntl.FormattedMessage, { id: id })
	  );
	};
	
	var ChemicalPage = function (_React$Component2) {
	  _inherits(ChemicalPage, _React$Component2);
	
	  function ChemicalPage() {
	    _classCallCheck(this, ChemicalPage);
	
	    var _this2 = _possibleConstructorReturn(this, (ChemicalPage.__proto__ || Object.getPrototypeOf(ChemicalPage)).call(this));
	
	    _this2.state = { showMoreInfoModal: false, moreInfoMessageId: '', showAllActions: false };
	
	    return _this2;
	  }
	
	  _createClass(ChemicalPage, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      // for when you go between chemical pages, reset this state value
	      this.setState({ showAllActions: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'avatarClicked',
	    value: function avatarClicked(face) {
	      var url = '/summary';
	      _helpers2.default.eventLog("nav:chemicalpage:avatarClicked - " + face + " - " + url);
	      this.props.appState.changeAvatar(face);
	      this.props.history.push(url);
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal(messageId, buttonid) {
	      _helpers2.default.eventLog("modal - showMoreInfoModal." + messageId + " - " + buttonid);
	      this.setState({ showMoreInfoModal: true, moreInfoMessageId: messageId });
	      document.getElementsByTagName("body")[0].style.overflow = "hidden";
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.setState({ showMoreInfoModal: false });
	      document.getElementsByTagName("body")[0].style.overflow = "visible";
	    }
	  }, {
	    key: 'showMoreTips',
	    value: function showMoreTips() {
	      _helpers2.default.eventLog("modal - showMoreTips");
	      this.setState({ showAllActions: true });
	    }
	  }, {
	    key: 'showLessTips',
	    value: function showLessTips() {
	      _helpers2.default.eventLog("modal - showLessTips");
	      this.setState({ showAllActions: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var chemicalGroup = this.props.match.params.chemical;
	      var buttonid = this.props.intl.messages['chemicals.' + chemicalGroup + '.moreinfo.desc_button'];
	
	      var morebutton = React.createElement(MoreButton, { onClick: function onClick() {
	          return _this3.showModal.bind(_this3)('description', buttonid);
	        }, id: buttonid });
	
	      var moremodal = void 0;
	
	      if (_helpers2.default.findGetParameter('print')) {
	        //inline for print #1 -- top MORE INFO (or PHOTOS) inlined
	        var moreInfoMessageId2 = 'description';
	        var messageIdFull = 'chemicals.' + chemicalGroup + '.moreinfo.' + moreInfoMessageId2;
	        moremodal = React.createElement(
	          'div',
	          { id: 'inline_MoreInfoModal' },
	          React.createElement(_reactIntl.FormattedHTMLMessage, { id: messageIdFull })
	        );
	      } else {
	        //normally
	        moremodal = this.state.showMoreInfoModal ? React.createElement(MoreInfoModal, {
	          onClose: this.onClose.bind(this),
	          chemicalGroup: chemicalGroup,
	          messageId: this.state.moreInfoMessageId }) : null;
	      }
	
	      var iconPath = (0, _safeUrl2.default)('/images/' + this.props.intl.messages['chemicals.' + chemicalGroup + '.icon']);
	      var hexColor = _helpers2.default.getIconColor(_helpers2.default.convertGroupName(chemicalGroup), this.props.intl);
	      var icon = React.createElement('span', { className: 'group-icon title-icon', style: {
	          mask: 'url(' + iconPath + ')',
	          WebkitMask: 'url(' + iconPath + ') 0% 0% / cover',
	          display: "inline-block",
	          background: hexColor,
	          WebkitMaskSize: "cover",
	          maskSize: "cover",
	          width: 40,
	          height: 40
	        } });
	
	      var headlines = this.props.appState.headlines.filter(function (d) {
	        return d.group.toLowerCase().replace(' ', '_') === _this3.props.match.params.chemical || d.group === "Sunscreen Chemicals" && _this3.props.match.params.chemical === "sunscreen";
	      });
	
	      var headlineDisplay = headlines.length === 0 ? React.createElement('div', null) : headlines.map(function (headline, i) {
	        return React.createElement(_Headline2.default, { headline: headline, key: i, useAvatar: _this3.props.appState.avatar !== undefined, avatarName: _this3.props.appState.avatar, border: true });
	      });
	
	      var actionsMessageId = 'chemicals.' + chemicalGroup + '.moreinfo.actions';
	      var actionsMessage = this.props.intl.messages[actionsMessageId];
	
	      // let actionsReadMore;
	
	      // if (helpers.findGetParameter('print'))
	      // {
	      //   //inline for print #2 -- more actions -- show inline -- use a p rather than a div since the initial action list is wrapped in a p
	      //   //const moreInfoMessageId2 = 'actions';
	      //   const messageIdFull = actionsMessageId; //`chemicals.${chemicalGroup}.moreinfo.${moreInfoMessageId2}`;
	      //   console.log("actionsMessage for chemicalGroup="+chemicalGroup+"=>["+actionsMessage+"]");
	      //   actionsReadMore = (actionsMessage !== undefined && actionsMessage !== "") ?
	      //     <p id="inline_ActionsModal"><FormattedHTMLMessage id={messageIdFull}  /></p>: null;
	      // }
	      // else
	      // {
	      //   //normally
	      //   actionsReadMore = (actionsMessage !== undefined && actionsMessage !== "") ?
	      //     <MoreButton onClick={() => this.showModal.bind(this)('actions', "more")} id="more" /> : null;
	      // }
	
	      var affectmyhealth_inlinechemicals = "";
	
	      if (_helpers2.default.findGetParameter('print')) {
	        // inline for print #4 -- the graph buttons on chemical names -- list them inline in the "affectmyhealth" section here instead in modal button -- ChemicalModal -- in graphs
	        var group_name_fixed = _helpers2.default.convertGroupName(chemicalGroup); // this.props.chemicalGroup.toLowerCase().replace(' ', '_')
	
	        // see Graphs.js for looping thru chemicals in a chemicalGroup
	
	        var chemicalGroupCaps = this.props.intl.messages['chemicals.' + chemicalGroup + '.data']; //  capitalized version needed to read the data
	        var gData = this.props.appState.groups[chemicalGroupCaps]; // getData from Graphs.js --
	        var myData = _.filter(gData, { mine: true });
	        var chemicals = _.uniq(_.map(myData, 'chemical')); // the abbreviation forms
	        var that = this;
	
	        // parabens (for example) have no additional info -- e.g. chemicals.parabens.moreinfo.methyl paraben
	        affectmyhealth_inlinechemicals = chemicals.map(function (chemical, i) {
	          var key = "chem" + i;
	          var messageIdFull = 'chemicals.' + group_name_fixed + '.moreinfo.' + chemical;
	          var msg = that.props.intl.messages[messageIdFull];
	          if (msg != undefined && msg != "") return React.createElement(
	            'div',
	            { key: key },
	            React.createElement(_reactIntl.FormattedHTMLMessage, { id: messageIdFull })
	          );else return null;
	        });
	      }
	
	      var self = this;
	      var actionsReadMore = void 0;
	      if (this.state.showAllActions) {
	        actionsReadMore = React.createElement(MoreButton, { onClick: this.showLessTips.bind(this), id: 'show_less', classes: 'scroll-content arrow-up' });
	      } else {
	        actionsReadMore = React.createElement(MoreButton, { onClick: this.showMoreTips.bind(this), id: 'show_more', classes: 'scroll-content ' });
	      }
	
	      var additionalActions = void 0;
	      if (this.state.showAllActions) {
	        additionalActions = React.createElement(
	          'p',
	          { className: 'chemical-more-tips' },
	          React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'chemicals.' + chemicalGroup + '.moreinfo.actions' })
	        );
	      }
	
	      return React.createElement(
	        'div',
	        { className: 'page chemical' },
	        React.createElement(
	          'h1',
	          { className: 'title-vertical-align' },
	          icon,
	          React.createElement(
	            'span',
	            { className: 'title-vertical-align' },
	            React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + chemicalGroup + '.title' })
	          )
	        ),
	        React.createElement(
	          'div',
	          { id: 'section1_headlines' },
	          headlineDisplay
	        ),
	        React.createElement(
	          'div',
	          { id: 'section2_description' },
	          React.createElement(
	            'h2',
	            null,
	            React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + chemicalGroup + '.description_header' })
	          ),
	          React.createElement(
	            'p',
	            null,
	            React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'chemicals.' + chemicalGroup + '.description' })
	          ),
	          morebutton,
	          moremodal
	        ),
	        React.createElement(
	          'div',
	          { className: 'page-break-no', id: 'section3_affectmyhealth' },
	          React.createElement(
	            'h2',
	            null,
	            React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + chemicalGroup + '.health_header' })
	          ),
	          React.createElement(
	            'p',
	            null,
	            React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'chemicals.' + chemicalGroup + '.health' })
	          ),
	          React.createElement(
	            'div',
	            { id: 'inline_section3_affectmyhealth_chemicals' },
	            affectmyhealth_inlinechemicals
	          )
	        ),
	        React.createElement(
	          'div',
	          { id: 'section4_yourresults' },
	          React.createElement(
	            'h2',
	            null,
	            React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.text.results', defaultMessage: 'Your Results' })
	          ),
	          React.createElement(
	            'p',
	            null,
	            React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + chemicalGroup + '.graph.description' })
	          ),
	          React.createElement(_Legend2.default, { appState: this.props.appState, group: this.props.intl.messages['chemicals.' + chemicalGroup + '.data'], chemicalGroup: chemicalGroup }),
	          React.createElement(
	            'p',
	            { className: 'graphs-click-to-expand' },
	            React.createElement(_reactIntl.FormattedMessage, { id: 'click_to_expand_graph', defaultMessage: 'Click on any graph to see an expanded version with more details.' })
	          ),
	          React.createElement(_Graphs2.default, { appState: this.props.appState, group: this.props.intl.messages['chemicals.' + chemicalGroup + '.data'] }),
	          React.createElement(
	            'p',
	            { className: 'graphs-click-to-expand' },
	            React.createElement(_reactIntl.FormattedMessage, { id: 'click_to_expand_graph', defaultMessage: 'Click on any graph to see an expanded version with more details.' })
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'page-break-no', id: 'section5_whatcanido' },
	          React.createElement(
	            'h2',
	            null,
	            React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.text.actions', defaultMessage: 'What can I do?' })
	          ),
	          React.createElement(
	            'p',
	            { className: 'chemical-first-tips' },
	            React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'chemicals.' + chemicalGroup + '.actions' })
	          ),
	          additionalActions,
	          actionsReadMore
	        )
	      );
	    }
	  }]);
	
	  return ChemicalPage;
	}(React.Component);
	
	exports.default = (0, _reactIntl.injectIntl)((0, _mobxReact.observer)(ChemicalPage));

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CommunityActionPage = function (_Component) {
	  _inherits(CommunityActionPage, _Component);
	
	  function CommunityActionPage() {
	    _classCallCheck(this, CommunityActionPage);
	
	    return _possibleConstructorReturn(this, (CommunityActionPage.__proto__ || Object.getPrototypeOf(CommunityActionPage)).apply(this, arguments));
	  }
	
	  _createClass(CommunityActionPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'page community-action' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.community_action.title' })
	        ),
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'page.community_action.content' })
	      );
	    }
	  }]);
	
	  return CommunityActionPage;
	}(_react.Component);
	
	exports.default = CommunityActionPage;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(26);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _Api = __webpack_require__(31);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	var _TableOfContents = __webpack_require__(594);
	
	var _TableOfContents2 = _interopRequireDefault(_TableOfContents);
	
	__webpack_require__(717);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackForm = function (_Component) {
	  _inherits(FeedbackForm, _Component);
	
	  function FeedbackForm(props) {
	    _classCallCheck(this, FeedbackForm);
	
	    var _this = _possibleConstructorReturn(this, (FeedbackForm.__proto__ || Object.getPrototypeOf(FeedbackForm)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(FeedbackForm, [{
	    key: 'onSubmit',
	    value: function onSubmit(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      var formData = new FormData();
	      formData.append('feedback', "PROTECT: " + this.state.value);
	
	      _Api.Api.post('/report/feedback', formData).then(function (response) {
	        alert(_this2.props.thankyouText);
	      }).catch(function (error) {
	        console(error);
	        alert(this.props.errorText);
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.setState({ value: event.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { className: 'feedback', onSubmit: this.onSubmit.bind(this) },
	        _react2.default.createElement('textarea', { value: this.state.value, onChange: this.handleChange.bind(this) }),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('input', { type: 'submit', value: this.props.sendButtonText, className: 'button lowpriority' })
	        )
	      );
	    }
	  }]);
	
	  return FeedbackForm;
	}(_react.Component);
	
	var ConclusionPage = function (_Component2) {
	  _inherits(ConclusionPage, _Component2);
	
	  function ConclusionPage() {
	    _classCallCheck(this, ConclusionPage);
	
	    return _possibleConstructorReturn(this, (ConclusionPage.__proto__ || Object.getPrototypeOf(ConclusionPage)).apply(this, arguments));
	  }
	
	  _createClass(ConclusionPage, [{
	    key: 'onClick',
	    value: function onClick(path) {
	      //this.props.history.push(path);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var filterer = function filterer(value) {
	        var group_name = _this4.props.intl.messages['chemicals.' + value.group + '.data'];
	        if (_this4.props.appState.groups[group_name] !== undefined && _this4.props.appState.groups[group_name].length > 0) {
	          return _.filter(_this4.props.appState.groups[group_name], { mine: true }).length > 0;
	        } else return false;
	      };
	
	      var summary_items = Object.values(_NavigationStructure2.default).filter(function (value) {
	        return value.summary;
	      }).filter(filterer);
	
	      var water_summary_items = Object.values(_NavigationStructure2.default).filter(function (value) {
	        return value.water_summary;
	      }).filter(filterer);
	
	      /*
	        <FeedbackForm
	              thankyouText={this.props.intl.messages['app.conclusion.thankyou']}
	              errorText={this.props.intl.messages['app.conclusion.error']}
	              sendButtonText={this.props.intl.messages['app.login.submit']} />
	      */
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'conclusion page' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.conclusion.title' })
	        ),
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'page.conclusion.content' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'toc printhide' },
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'page.conclusion.see_again' })
	          ),
	          _react2.default.createElement(_TableOfContents2.default, { appState: this.props.appState, history: this.props.history, items: summary_items })
	        )
	      );
	    }
	  }]);
	
	  return ConclusionPage;
	}(_react.Component);
	
	exports.default = (0, _mobxReact.observer)((0, _reactIntl.injectIntl)(ConclusionPage));

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConsentPage = function (_Component) {
	  _inherits(ConsentPage, _Component);
	
	  function ConsentPage() {
	    _classCallCheck(this, ConsentPage);
	
	    return _possibleConstructorReturn(this, (ConsentPage.__proto__ || Object.getPrototypeOf(ConsentPage)).apply(this, arguments));
	  }
	
	  _createClass(ConsentPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'page consent' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.consent.header', defaultMessage: 'Consent' })
	        ),
	        '[informed consent here]'
	      );
	    }
	  }]);
	
	  return ConsentPage;
	}(_react.Component);
	
	exports.default = ConsentPage;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIntl = __webpack_require__(4);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // FAQPage.js
	// adapated from OverallStudyResultsPage.js
	
	var FAQPage = function (_Component) {
	  _inherits(FAQPage, _Component);
	
	  function FAQPage(props) {
	    _classCallCheck(this, FAQPage);
	
	    var _this = _possibleConstructorReturn(this, (FAQPage.__proto__ || Object.getPrototypeOf(FAQPage)).call(this, props));
	
	    _this.numFAQs = props.intl.messages['common_questions.number_questions'];
	    _this.state = {
	      modals: [false, false, false, false],
	      expanded: new Array(_this.numFAQs).fill(false)
	    };
	
	    return _this;
	  }
	
	  _createClass(FAQPage, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var common_questions = [];
	      var self = this;
	
	      var _loop = function _loop(i) {
	        var expanded = _this2.state.expanded[i];
	        var toggleFunction = function toggleFunction() {
	          var expanded = self.state.expanded;
	          if (!expanded[i]) {
	            _helpers2.default.eventLog('faq: expand question - ' + i);
	          } else {
	            _helpers2.default.eventLog('faq: collapse question - ' + i);
	          }
	          expanded[i] = !expanded[i];
	          self.setState({
	            expanded: expanded
	          });
	        };
	
	        var q_props = {
	          key: 'title' + (i + 1),
	          className: "question expanded-" + expanded,
	          onClick: toggleFunction
	        };
	        var q_text_id = 'common_questions.q' + (i + 1) + '.title';
	        var a_props = {
	          key: 'content' + (i + 1),
	          className: "answer expanded-" + expanded
	        };
	        var a_text_id = 'common_questions.q' + (i + 1) + '.content';
	
	        var q = _react2.default.createElement(
	          'div',
	          q_props,
	          _react2.default.createElement(
	            'div',
	            { className: 'chevron-faq ' + expanded },
	            _react2.default.createElement('span', null)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'q-text' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: q_text_id })
	          )
	        );
	        common_questions.push(q);
	
	        if (_this2.state.expanded[i]) {
	          var a = _react2.default.createElement(
	            'div',
	            a_props,
	            _react2.default.createElement(
	              'span',
	              { className: 'a-text' },
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: a_text_id })
	            )
	          );
	          common_questions.push(a);
	        }
	      };
	
	      for (var i = 0; i < this.numFAQs; i++) {
	        _loop(i);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page common-questions' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'common_questions.title', defaultMessage: 'Common Questions' })
	        ),
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'common_questions.contact', defaultMessage: 'test' }),
	        common_questions
	      );
	    }
	  }]);
	
	  return FAQPage;
	}(_react.Component); // end FAQPage
	
	exports.default = (0, _reactIntl.injectIntl)(FAQPage);

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(682);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _d = __webpack_require__(51);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _lodash = __webpack_require__(26);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _NavigationButton = __webpack_require__(220);
	
	var _NavigationButton2 = _interopRequireDefault(_NavigationButton);
	
	var _Graph = __webpack_require__(219);
	
	var _Graph2 = _interopRequireDefault(_Graph);
	
	var _SinaPlot = __webpack_require__(216);
	
	var _SinaPlot2 = _interopRequireDefault(_SinaPlot);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(720);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnswerHandler = function (_Component) {
	  _inherits(AnswerHandler, _Component);
	
	  function AnswerHandler() {
	    _classCallCheck(this, AnswerHandler);
	
	    return _possibleConstructorReturn(this, (AnswerHandler.__proto__ || Object.getPrototypeOf(AnswerHandler)).apply(this, arguments));
	  }
	
	  _createClass(AnswerHandler, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var pageNum = this.props.pageNum;
	      var answerAttempt = this.props.answerAttempt;
	      var disabledAnswers = [];
	      if (this.props.disabledAnswers) {
	        disabledAnswers = this.props.disabledAnswers;
	      }
	
	      var buttons = this.props.answerChoices.map(function (answer) {
	        return _react2.default.createElement(
	          'button',
	          {
	            className: 'answer-button',
	            key: answer,
	            onClick: function onClick() {
	              return _this2.props.handleAnswerClick(pageNum, answer, answerAttempt);
	            },
	            disabled: disabledAnswers.includes(answer)
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.answers.' + answer })
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'answer-button-container' },
	        buttons
	      );
	    }
	  }]);
	
	  return AnswerHandler;
	}(_react.Component);
	
	var GraphReadingTutorialPage = function (_Component2) {
	  _inherits(GraphReadingTutorialPage, _Component2);
	
	  function GraphReadingTutorialPage(props) {
	    _classCallCheck(this, GraphReadingTutorialPage);
	
	    // this.state.chemical = 'PFOA'
	    // this.state.group = 'PFAS'
	    var _this3 = _possibleConstructorReturn(this, (GraphReadingTutorialPage.__proto__ || Object.getPrototypeOf(GraphReadingTutorialPage)).call(this, props));
	
	    _this3.state = {
	      chemical: 'PFOA',
	      group: 'PFAS',
	      currentPage: 0,
	      currentSubPage: "q",
	      answers: {},
	      correctAnswers: {
	        0: ["less", "similar", "more"],
	        1: ["c"],
	        2: ["a"],
	        3: ["similar"],
	        4: ["less", "similar"]
	      },
	      numCorrect: 0,
	      attempt: 1,
	      p5_graph_expanded_once: false,
	      p5_graph_currently_expanded: false
	    };
	    return _this3;
	  }
	
	  _createClass(GraphReadingTutorialPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // decide which chemicals to use
	      var self = this;
	      function setChemicals() {
	        if (Object.keys(self.props.appState.chemicals).length > 0) {
	          var minDetectedThreshold = 0.5; // from 1 = all detected to 0 = none detected
	          self.getHighestPercentile(minDetectedThreshold);
	        } else {
	          setTimeout(setChemicals, 200);
	        }
	      }
	      setChemicals();
	
	      // start timer
	      this.mountTime = performance.now();
	      this.pageStartTime = performance.now();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // restart the tutorial if needed
	      // only from the first "launch" page
	      if (this.props.location.hash != "#tour") {
	        if (this.state.attempt !== 1 || this.state.currentPage !== 0 || this.state.currentSubPage !== "q") {
	          this.restartTutorial();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var endTime = performance.now();
	      var ellapsedSeconds = (endTime - this.mountTime) / 1000;
	      var currentPage = this.getPageName(this.state.currentPage);
	      if (!this.tutorialEnd) {
	        this.tutorialEnd = "nativeBrowserControls";
	      }
	
	      _helpers2.default.eventLog('poe:total_time.sec - ' + ellapsedSeconds);
	      _helpers2.default.eventLog('poe:exit_method - ' + this.tutorialEnd);
	    }
	  }, {
	    key: 'getPageName',
	    value: function getPageName(pageNum) {
	      var currentPage = void 0;
	      switch (pageNum) {
	        case 0:
	          currentPage = "predict";
	          break;
	        case 1:
	          currentPage = "ABChighest";
	          break;
	        case 2:
	          currentPage = "ABCnotDetected";
	          break;
	        case 3:
	          currentPage = "compareStudy";
	          break;
	        case 4:
	          currentPage = "compareUs";
	          break;
	        case 5:
	          currentPage = "expandGraph";
	          break;
	        case 6:
	          currentPage = "selectSources";
	          break;
	        case 7:
	          currentPage = "selectActions";
	          break;
	        case 8:
	          currentPage = "finalPage";
	          break;
	        default:
	          // code block
	          currentPage = "undefined";
	      }
	      return currentPage;
	    }
	  }, {
	    key: 'getHighestPercentile',
	    value: function getHighestPercentile(minDetectedThreshold) {
	      var allChemicals = [];
	      for (var x in this.props.appState.chemicals) {
	        var separatorIndex = x.indexOf("-");
	        var group = x.substring(0, separatorIndex);
	        var chemical = x.substring(separatorIndex + 1, x.length);
	        allChemicals.push({
	          chemical: chemical,
	          group: group,
	          groupSingular: this.props.intl.messages['chemicals.' + _helpers2.default.convertGroupName(group) + '.singular'],
	          combinedName: x
	        });
	      }
	
	      // get chemical metadata
	      var chemicalsWithData = [];
	      for (var i = 0; i < allChemicals.length; i++) {
	        var _chemical = allChemicals[i].chemical;
	        var _group = allChemicals[i].group;
	        var groupSingular = allChemicals[i].groupSingular;
	        var combinedName = allChemicals[i].combinedName;
	        var chemData = this.props.appState.chemicals[combinedName];
	
	        var _getGraphMetaData = this.getGraphMetaData(chemData),
	            _getGraphMetaData2 = _slicedToArray(_getGraphMetaData, 5),
	            meDetected = _getGraphMetaData2[0],
	            percentile = _getGraphMetaData2[1],
	            value = _getGraphMetaData2[2],
	            percentDetected = _getGraphMetaData2[3],
	            numNonDetects = _getGraphMetaData2[4];
	
	        var benchmark = this.getBenchmarkDetected(_chemical);
	        var _benchmarkDetected = void 0;
	        if (benchmark) {
	          _benchmarkDetected = benchmark.detected;
	        }
	
	        var chemObject = {
	          chemical: _chemical,
	          group: _group,
	          groupSingular: groupSingular,
	          percentile: percentile,
	          value: value,
	          detectedResult: meDetected,
	          percentDetected: percentDetected,
	          benchmarkDetected: _benchmarkDetected,
	          benchmark: benchmark,
	          numNonDetects: numNonDetects
	        };
	        chemicalsWithData.push(chemObject);
	      }
	
	      // sort list to prioritize the criteria for choosing chemicals:
	      // 1. The chemical has at least 1 non detect
	      // 2. >50% of the results are detected
	      // 3. The person's result is detected
	      // 4. The median is detected
	      // 5. There are at least 10 non-detects
	      // we would like all five to be true, if not, just 1&2, if not, just 1
	      // if none of the above apply (unlikely) return the ones with the most detected
	      // TODO: what if the benchmark is not defined? - for now, that is 0th criteria
	
	      function atLeastOneNondetect(x) {
	        return x.numNonDetects > 0;
	      }
	      function greaterThanThresholdDetected(x) {
	        return x.percentDetected > minDetectedThreshold;
	      }
	      function personalResultDetected(x) {
	        return x.detectedResult;
	      }
	      function benchmarkDetected(x) {
	        return x.benchmarkDetected;
	      }
	      function atLeastTenNondetect(x) {
	        return x.numNonDetects >= 10;
	      }
	      function benchmarkExists(x) {
	        if (x.benchmark == undefined) {
	          return false;
	        }
	        return true;
	      }
	
	      var criteria = [benchmarkExists, atLeastOneNondetect, greaterThanThresholdDetected, personalResultDetected, benchmarkDetected, atLeastTenNondetect];
	
	      // get the chemical with all possible criteria met, with the given comparator
	      // ("greater" or "less")
	      function getChemical(data, comparator) {
	        var chemical = void 0;
	        var attemptingCriteria = criteria.length;
	        while (chemical == undefined && attemptingCriteria > 0) {
	          // try to filter the data by all available criteria
	          var meetsAllCriteria = data;
	
	          var _loop = function _loop(_i) {
	            meetsAllCriteria = meetsAllCriteria.filter(function (x) {
	              return criteria[_i](x);
	            });
	          };
	
	          for (var _i = 0; _i < attemptingCriteria; _i++) {
	            _loop(_i);
	          }
	
	          // if there are chemicals that meet the criteria
	          if (meetsAllCriteria.length > 0) {
	            // then sort (according to comparator)
	            meetsAllCriteria = meetsAllCriteria.sort(function (a, b) {
	              if (comparator == "greater") {
	                return b.percentile - a.percentile;
	              } else if (comparator == "less") {
	                return a.percentile - b.percentile;
	              }
	              return 0;
	            });
	
	            // and return the optimal one
	            chemical = meetsAllCriteria[0];
	            return chemical;
	          }
	
	          // if unsuccessful, use one less criteria next time
	          attemptingCriteria -= 1;
	        }
	
	        // if none of the criteria can be met,
	        // just sort by which have the most detected
	        var lastResort = data.sort(function (a, b) {
	          return b.percentDetected - a.percentDetected;
	        });
	        chemical = lastResort[0];
	        return chemical;
	      }
	
	      // get the chemical with the **greatest** percentile that meets all possible criteria
	      var chemical_1 = getChemical(chemicalsWithData, "greater");
	      // now remove this chemical from the list, so we don't pick it again
	      var elementPos = chemicalsWithData.indexOf(chemical_1);
	      chemicalsWithData.splice(elementPos, 1);
	
	      // get the chemical with the **least** percentile that meets all possible criteria
	      var chemical_2 = getChemical(chemicalsWithData, "less");
	
	      _helpers2.default.eventLog("poe:chemical1 - " + chemical_1.chemical);
	      _helpers2.default.eventLog("poe:chemical2 - " + chemical_2.chemical);
	
	      chemical_1.answers = this.setChemicalAnswers(chemical_1);
	      chemical_2.answers = this.setChemicalAnswers(chemical_2);
	
	      for (var _i2 = 1; _i2 < 5; _i2++) {
	        _helpers2.default.eventLog('poe:chemical1_correctAnswer_' + this.getPageName(_i2) + ' - ' + chemical_1.answers[_i2]);
	        _helpers2.default.eventLog('poe:chemical2_correctAnswer_' + this.getPageName(_i2) + ' - ' + chemical_2.answers[_i2]);
	      }
	
	      this.setState({
	        chemical_1: chemical_1,
	        chemical_2: chemical_2,
	        chemical: chemical_1.chemical,
	        group: chemical_1.group,
	        groupSingular: chemical_1.groupSingular,
	        correctAnswers: chemical_1.answers
	      });
	    }
	  }, {
	    key: 'getGraphMetaData',
	    value: function getGraphMetaData(data) {
	      // sort by values, lowest to highest
	      var sortedData = data.sort(function (a, b) {
	        if (!a.detected && !b.detected) {
	          return 0;
	        }
	        if (!a.detected && b.detected) {
	          return -1;
	        }
	        if (a.detected && !b.detected) {
	          return 1;
	        }
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	
	      // in case of multiple results per chemical, return the highest percentile
	      var myPercentiles = [];
	      var numDetected = 0;
	      var meDetected = false;
	      var value = void 0;
	      for (var d = 0; d < sortedData.length; d++) {
	        // find percentile
	        if (sortedData[d].mine) {
	          value = sortedData[d].value;
	          if (!sortedData[d].detected) {
	            myPercentiles.push(0);
	          } else {
	            myPercentiles.push(d / sortedData.length);
	          }
	
	          // save if I'm detected
	          if (sortedData[d].detected) {
	            meDetected = true;
	          }
	        }
	
	        // count nondetected
	        if (sortedData[d].detected) {
	          numDetected++;
	        }
	      }
	      var percentile = Math.max.apply(Math, myPercentiles);
	      var percentDetected = numDetected / sortedData.length;
	      var numNonDetects = sortedData.length - numDetected;
	      return [meDetected, percentile, value, percentDetected, numNonDetects];
	    }
	  }, {
	    key: 'getChemicalData',
	    value: function getChemicalData(chemical, group) {
	      if (!chemical) {
	        chemical = this.state.chemical;
	      }
	      if (!group) {
	        group = this.state.group;
	      }
	
	      var data = this.props.appState.chemicals[group + "-" + chemical];
	      data = data.sort(function (a, b) {
	        if (!a.detected && !b.detected) {
	          return 0;
	        }
	        if (!a.detected && b.detected) {
	          return -1;
	        }
	        if (a.detected && !b.detected) {
	          return 1;
	        }
	        if (a.value > b.value) {
	          return 1;
	        }
	        if (a.value < b.value) {
	          return -1;
	        }
	        return 0;
	      });
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].detected) {
	          data[i].percentile = i / data.length;
	        } else {
	          data[i].percentile = 0;
	        }
	      }
	
	      return data;
	    }
	  }, {
	    key: 'getBenchmarkDetected',
	    value: function getBenchmarkDetected(chemical) {
	      for (var i = 0; i < this.props.appState.benchmarks.length; i++) {
	        var benchmark = this.props.appState.benchmarks[i];
	        if (benchmark.chemical == chemical) {
	          return benchmark;
	        }
	      }
	    }
	  }, {
	    key: 'setChemicalAnswers',
	    value: function setChemicalAnswers(chemicalInfo) {
	      // calculate the correct answer for your result
	      var compareToOthersAnswers = [];
	      var percentile = chemicalInfo.percentile;
	      if (percentile < 0.3) {
	        compareToOthersAnswers.push("less");
	      }
	      if (percentile > 0.2 && percentile < 0.8) {
	        compareToOthersAnswers.push("similar");
	      }
	      if (percentile > 0.7) {
	        compareToOthersAnswers.push("more");
	      }
	
	      // calculate the correct answer for the benchmark
	      // this depends on the pixels and y-axis, so let's make a reference sinaplot
	      var compareToBenchmark = void 0;
	      if (chemicalInfo.benchmark != undefined) {
	        var _getSinaplotData = this.getSinaplotData(chemicalInfo),
	            _getSinaplotData2 = _slicedToArray(_getSinaplotData, 2),
	            yAxis = _getSinaplotData2[0],
	            sizing = _getSinaplotData2[1];
	
	        var benchmarkPx = yAxis(chemicalInfo.benchmark.value);
	        var participantPx = yAxis(chemicalInfo.value);
	
	        // the order of the items here must be less, similar, more
	        // to correspond to the keys in the en.json file
	        compareToBenchmark = [];
	        // range for "less": less than median, as long as the center of the face is
	        // not on the line for benchmark (considering line width)
	        if (participantPx + sizing.benchmarkLineThickness / 2 < benchmarkPx) {
	          compareToBenchmark.push("less");
	        }
	        // range for "similar": ------{( )-|-( )}----
	        // where | is the median, and ( ) is the face
	        // so the center of the face is +/- 1 face width on either side
	        // and the outer edge of tha face is +/- 1.5 face width on either side
	        if (Math.abs(benchmarkPx - participantPx) < sizing.faceWidth) {
	          compareToBenchmark.push("similar");
	        }
	        // range for "more": more than median, as long as the center of the face is
	        // not on the line for benchmark (considering line width)
	        if (participantPx - sizing.benchmarkLineThickness / 2 > benchmarkPx) {
	          compareToBenchmark.push("more");
	        }
	      }
	
	      var correctAnswers = {
	        0: ["less", "similar", "more"], // there is no wrong answer for the first guess
	        1: ["c"], // c is always the highest dot
	        2: ["a"], // a is always a non-detect dot
	        3: compareToOthersAnswers,
	        4: compareToBenchmark
	      };
	
	      return correctAnswers;
	    }
	  }, {
	    key: 'getSinaplotData',
	    value: function getSinaplotData(chemicalInfo) {
	      var chemical = chemicalInfo.chemical;
	      var benchmark = chemicalInfo.benchmark;
	      var group = chemicalInfo.group;
	
	      this.sinaPlot = new _SinaPlot2.default(this.refs.tempContainer, this.props.appState.avatar);
	
	      this.sinaPlot.useAvatars = this.props.appState.graphs.useAvatars;
	      this.sinaPlot.useParticipantAvatar = this.props.appState.graphs.useParticipantAvatar;
	      this.sinaPlot.jitter = this.props.appState.graphs.jitter;
	      this.sinaPlot.sina = this.props.appState.graphs.sina;
	      this.sinaPlot.jitterAmount = this.props.appState.graphs.jitterAmount;
	      // this.sinaPlot.labelOffset = this.props.appState.graphs.labelOffset;
	      this.sinaPlot.showVisitBadges = false; //this.showVisitBadges();
	      this.sinaPlot.units = "not needed"; //units;
	
	      this.sinaPlot.yLimits = this.getYLimits(chemicalInfo.group);
	      this.sinaPlot.noDetectText = this.props.intl.messages['nodetecttext_yaxis']; // this.props.noDetectText -- not needed
	      this.sinaPlot.tutorialMode = false;
	      // this.sinaPlot.tutorialSettings = this.props.tutorialSettings;
	      this.sinaPlot.setup();
	
	      var benchmarks = [benchmark];
	      if (benchmark == undefined) {
	        benchmarks = [];
	      }
	      this.sinaPlot.updateData(this.getChemicalData(chemical, group), benchmarks, this.props.appState.participantId);
	
	      return [this.sinaPlot.y, {
	        faceWidth: this.sinaPlot.participantFaceRadius * 2,
	        benchmarkLineThickness: this.sinaPlot.benchmarkLineThickness
	      }];
	    }
	  }, {
	    key: 'getDataThisGroup',
	    value: function getDataThisGroup(group) {
	      if (!group) {
	        group = this.state.group;
	      }
	      return this.props.appState.groups[group];
	    }
	  }, {
	    key: 'getDetectedData',
	    value: function getDetectedData(group) {
	      if (!group) {
	        group = this.state.group;
	      }
	      return _.filter(this.getDataThisGroup(group), { detected: true });
	    }
	  }, {
	    key: 'getYLimits',
	    value: function getYLimits(group) {
	      if (!group) {
	        group = this.state.group;
	      }
	      return d3.extent(_.map(this.getDetectedData(group), 'value'));
	    }
	  }, {
	    key: 'getChemicalFullName',
	    value: function getChemicalFullName() {
	      var myData = _.filter(this.getDataThisGroup(), { mine: true });
	      var medium = _.uniq(_.map(myData, 'medium'))[0];
	
	      var myData_Avgs = _.chain(myData).groupBy("chemical").mapValues(function (v, i) {
	        return {
	          chemical: v[0].chemical,
	          chemical_full: v[0].chemical_full,
	          value_numvisits: v.length,
	          value_avg: _.meanBy(v, 'value') };
	      }).value();
	
	      return myData_Avgs[this.state.chemical].chemical_full;
	    }
	  }, {
	    key: 'handleAnswerClick',
	    value: function handleAnswerClick(pageNum, answer, answerAttempt) {
	      if (!answerAttempt) {
	        answerAttempt = 1;
	      }
	      var numCorrect = this.state.numCorrect;
	
	      // store the answer
	      var answers = this.state.answers;
	      if (!answers['page-' + pageNum]) {
	        answers['page-' + pageNum] = {};
	      }
	      answers['page-' + pageNum]['a-' + answerAttempt] = answer;
	
	      // log the answer
	      if (pageNum == 0) {
	        // there's only one attempt for the predict page, so no need to log that
	        _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_page_' + this.getPageName(pageNum) + ' - ' + answer);
	      } else {
	        _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_page_' + this.getPageName(pageNum) + '_attempt' + answerAttempt + ' - ' + answer);
	      }
	
	      // decide the next page based on which answer is correct
	      var subpage = "a";
	      var correctAnswers = this.state.correctAnswers[pageNum];
	      if (correctAnswers.includes(answer)) {
	        subpage = "a";
	        if (pageNum != 0) {
	          numCorrect++;
	        }
	      } else if (answerAttempt == 1) {
	        subpage = "q2";
	      } else {
	        subpage = "a2";
	      }
	
	      this.setState({
	        answers: answers,
	        currentSubPage: subpage,
	        numCorrect: numCorrect
	      });
	    }
	  }, {
	    key: 'handleNextClick',
	    value: function handleNextClick(pageNum) {
	      var answers = this.state.answers;
	      var nextPage = pageNum + 1;
	      var numCorrect = this.state.numCorrect;
	
	      // save answers as needed
	      if (pageNum == 6) {
	        var checkedAnswers = [];
	        var checkboxes = document.querySelectorAll('input[type=checkbox]');
	
	        for (var i = 0; i < checkboxes.length; i++) {
	          var value = checkboxes[i].value;
	          var checked = checkboxes[i].checked ? "checked" : "unchecked";
	          if (checked == "checked") {
	            checkedAnswers.push(value);
	          }
	          _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_page_' + this.getPageName(pageNum) + '_source_' + value + ' - ' + checked);
	        }
	
	        var freeAnswer = document.getElementById('free-answer-box').value;
	
	        answers['page-' + pageNum] = {};
	        answers['page-' + pageNum]['a-checked'] = checkedAnswers;
	        answers['page-' + pageNum]['a-otherAnswer'] = freeAnswer;
	
	        _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_page_' + this.getPageName(pageNum) + '_text_box - ' + freeAnswer);
	      }
	      if (pageNum == 7) {
	        var _checkedAnswers = [];
	        var radioContainers = document.querySelectorAll('.radio-container');
	
	        for (var _i3 = 0; _i3 < radioContainers.length; _i3++) {
	          var allCheckboxes = radioContainers[_i3].querySelectorAll('input[type=radio]');
	          var selected_radio = radioContainers[_i3].querySelector('input[type=radio]:checked');
	
	          if (selected_radio == null) {
	            var name = allCheckboxes[0].name;
	            _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_page_' + this.getPageName(pageNum) + '_' + name + ' - none_selected');
	          } else {
	            var _name = selected_radio.name;
	            var _value = selected_radio.value;
	            _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_page_' + this.getPageName(pageNum) + '_' + _name + ' - ' + _value);
	          }
	        }
	      }
	
	      // if there is no benchmark, skip over the benchmark page
	      if (pageNum == 3) {
	        if (this.state.correctAnswers[4] == undefined) {
	          // there is no benchmark here, so skip page
	          nextPage = nextPage + 1;
	          // also add one to the number correct, so the person is not penalized
	          numCorrect = numCorrect + 1;
	        }
	      }
	
	      // log how long this page took
	      var pageEndTime = performance.now();
	      var ellapsedSeconds = (pageEndTime - this.pageStartTime) / 1000;
	      _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_page_' + this.getPageName(pageNum) + '_time.sec - ' + ellapsedSeconds);
	      // restart the page timer
	      this.pageStartTime = performance.now();
	
	      this.setState({
	        answers: answers,
	        currentPage: nextPage,
	        currentSubPage: "q",
	        numCorrect: numCorrect
	      });
	    }
	  }, {
	    key: 'handleExpandedGraphClick',
	    value: function handleExpandedGraphClick(toggleState) {
	      this.setState({
	        p5_graph_expanded_once: true,
	        p5_graph_currently_expanded: toggleState
	      });
	    }
	
	    // TODO - make this work for spanish
	    // getCompareWord(word) {
	    //   if (word == "similar") {return "to"}
	    //   else {return "than"}
	    // }
	    //
	    // amountToLevel(word) {
	    //   if (word == "more") {return "higher"}
	    //   if (word == "less") {return "lower"}
	    //   return word
	    // }
	
	  }, {
	    key: 'skipTutorial',
	    value: function skipTutorial() {
	      var currentPage = this.getPageName(this.state.currentPage);
	      _helpers2.default.eventLog('poe:lastPageBeforeSkip - ' + currentPage);
	      this.tutorialEnd = "skipTutorialClicked";
	      this.props.history.push("/summary");
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'endTutorial',
	    value: function endTutorial() {
	      _helpers2.default.eventLog("poe:last_page_button_clicked - viewAllResultsButtonClicked");
	      this.tutorialEnd = "viewAllResultsButtonClicked";
	      this.props.history.push("/summary");
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'retakeTutorial',
	    value: function retakeTutorial() {
	      _helpers2.default.eventLog("poe:last_page_button_clicked - retakeTutorial");
	      this.setState({
	        chemical: this.state.chemical_2.chemical,
	        group: this.state.chemical_2.group,
	        groupSingular: this.state.chemical_2.groupSingular,
	        currentPage: 0,
	        currentSubPage: "q",
	        answers: {},
	        correctAnswers: this.state.chemical_2.answers,
	        numCorrect: 0,
	        attempt: 2,
	        p5_graph_expanded_once: false,
	        p5_graph_currently_expanded: false
	      });
	    }
	  }, {
	    key: 'restartTutorial',
	    value: function restartTutorial() {
	      this.setState({
	        chemical: this.state.chemical_1.chemical,
	        group: this.state.chemical_1.group,
	        groupSingular: this.state.chemical_1.groupSingular,
	        currentPage: 0,
	        currentSubPage: "q",
	        answers: {},
	        correctAnswers: this.state.chemical_1.answers,
	        numCorrect: 0,
	        attempt: 2,
	        p5_graph_expanded_once: false,
	        p5_graph_currently_expanded: false
	      });
	    }
	  }, {
	    key: 'getPageContent',
	    value: function getPageContent(pageNum) {
	      var _this4 = this;
	
	      var pagesWithGraphs = [1];
	      var circleRadius = 12;
	      var rectWidth = circleRadius * 2 - 10;
	      var rectHeight = rectWidth * 0.7;
	
	      var pageContent = _react2.default.createElement('div', null);
	      var iconPath = (0, _safeUrl2.default)('/images/' + this.props.intl.messages['chemicals.' + _helpers2.default.convertGroupName(this.state.group) + '.icon']);
	      // const iconPath = safeUrl(`/images/${this.props.intl.messages['chemicals.' + chemicalGroup + '.icon']}`);
	      var hexColor = _helpers2.default.getIconColor(_helpers2.default.convertGroupName(this.state.group), this.props.intl);
	      var icon = _react2.default.createElement('span', { className: 'group-icon title-icon', style: {
	          mask: 'url(' + iconPath + ')',
	          WebkitMask: 'url(' + iconPath + ') 0% 0% / cover',
	          display: "inline-block",
	          background: hexColor,
	          WebkitMaskSize: "cover",
	          maskSize: "cover",
	          width: 40,
	          height: 40
	        } });
	
	      var nextButton = _react2.default.createElement(
	        'button',
	        { className: 'next-button', onClick: function onClick() {
	            return _this4.handleNextClick(pageNum);
	          } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.answers.next' })
	      );
	
	      var baseGraph = void 0;
	      if (this.getDataThisGroup()) {
	        baseGraph = _react2.default.createElement(_Graph2.default, {
	          appState: this.props.appState,
	          data: this.getChemicalData(),
	          chemical: this.state.chemical,
	          chemical_full: this.getChemicalFullName(),
	          yLimits: this.getYLimits(),
	          chemicalGroup: this.state.group,
	          tutorialMode: true
	        });
	      }
	
	      //////////////////////////////////////////////////////////////////// PAGE 0
	      if (pageNum == 0) {
	        var highlightContent = void 0;
	
	        if (this.state.currentSubPage == "q") {
	          this.pageStartTime = performance.now();
	          highlightContent = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'graphreading.page0.how_much_chemical_was_in_your_sample',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 1,
	              answerChoices: ["less", "similar", "more"],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a") {
	          var answer = this.state.answers["page-0"]["a-1"];
	          highlightContent = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page0.you_guessed_' + answer,
	                values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        }
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	              id: 'graphreading.page0.youre_about_to_find_out',
	              values: { chemical: this.state.chemical } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page0.chemical_is_a_type_of',
	              values: {
	                chemical: _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.chemical
	                ),
	                group: _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.groupSingular
	                ),
	                icon: _react2.default.createElement('span', { className: 'grt-icon', style: {
	                    mask: 'url(' + iconPath + ')',
	                    WebkitMask: 'url(' + iconPath + ') 0% 0% / cover',
	                    display: "inline-block",
	                    background: hexColor,
	                    WebkitMaskSize: "cover",
	                    maskSize: "cover",
	                    width: 15,
	                    height: 20
	                  } })
	              }
	            }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page0.' + _helpers2.default.convertGroupName(this.state.group) + '.description' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            highlightContent
	          )
	        );
	      } else if (pageNum == 1) {
	        ////////////////////////////////////////////////////////////////// PAGE 1
	        var _highlightContent = void 0;
	
	        if (this.state.currentSubPage == "q") {
	          _highlightContent = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page1.which_woman_had_the_most_chemical',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 1,
	              answerChoices: ["a", "b", "c"],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a") {
	          _highlightContent = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page1.other_women_correct' })
	            ),
	            nextButton
	          );
	        } else if (this.state.currentSubPage == "q2") {
	          var _answer = this.state.answers["page-1"]["a-1"];
	
	          _highlightContent = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'graphreading.page1.other_women_try_again',
	                values: { answer: _answer.toUpperCase() } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tip-box' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                  id: 'graphreading.page1.other_women_tip' })
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page1.which_woman_had_the_most_chemical',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 2,
	              answerChoices: ["a", "b", "c"],
	              disabledAnswers: [_answer],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a2") {
	          _highlightContent = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page1.other_women_incorrect',
	                values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        }
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'graphreading.page1.graph_shows_other_women', values: { chemical: this.state.chemical } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page1.each_blue_circle',
	              values: {
	                icon: _react2.default.createElement(
	                  'svg',
	                  { className: 'legend-item-icon', height: 2 * circleRadius, width: 2 * circleRadius },
	                  _react2.default.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 2, stroke: 'rgb(119, 158, 255)', strokeWidth: '3px', fill: 'transparent' })
	                )
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tutorial-graph-wrapper' },
	            _react2.default.cloneElement(baseGraph, { tutorialSettings: {
	                noToggle: true,
	                noBenchmark: true,
	                noAvatar: true,
	                drawSampleDots: true
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            _highlightContent
	          )
	        );
	      } else if (pageNum == 2) {
	        ////////////////////////////////////////////////////////////////// PAGE 2
	        var _highlightContent2 = void 0;
	
	        if (this.state.currentSubPage == "q") {
	          _highlightContent2 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page2.which_woman_was_nondetected',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 1,
	              answerChoices: ["a", "b", "c"],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a") {
	          _highlightContent2 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'graphreading.page2.nondetects_correct', values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        } else if (this.state.currentSubPage == "q2") {
	          var _answer2 = this.state.answers["page-2"]["a-1"];
	
	          _highlightContent2 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page2.nondetects_try_again', values: { answer: _answer2.toUpperCase(), chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tip-box' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                  id: 'graphreading.page2.nondetects_tip',
	                  values: { chemical: this.state.chemical } })
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page2.which_woman_was_nondetected',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 2,
	              answerChoices: ["a", "b", "c"],
	              disabledAnswers: [_answer2],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a2") {
	          _highlightContent2 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page2.nondetects_incorrect',
	                values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        }
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page2.each_grey_circle',
	              values: {
	                chemical: this.state.chemical,
	                icon: _react2.default.createElement(
	                  'svg',
	                  { className: 'legend-item-icon', height: 2 * circleRadius, width: 2 * circleRadius },
	                  _react2.default.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 2, stroke: '#ccc', strokeWidth: '3px', fill: 'transparent' })
	                )
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tutorial-graph-wrapper' },
	            _react2.default.cloneElement(baseGraph, { tutorialSettings: {
	                noToggle: true,
	                noBenchmark: true,
	                noAvatar: true,
	                drawSampleDots: true
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            _highlightContent2
	          )
	        );
	      } else if (pageNum == 3) {
	        ////////////////////////////////////////////////////////////////// PAGE 3
	        var _highlightContent3 = void 0;
	
	        if (this.state.currentSubPage == "q") {
	          _highlightContent3 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'graphreading.page3.your_result_compared_to_others',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 1,
	              answerChoices: ["less", "similar", "more"],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a") {
	          var correctAnswer = this.state.correctAnswers[pageNum];
	
	          _highlightContent3 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page3.your_result_correct.' + correctAnswer,
	                values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        } else if (this.state.currentSubPage == "q2") {
	          var _answer3 = this.state.answers["page-3"]["a-1"];
	
	          _highlightContent3 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page3.your_result_not_quite' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tip-box' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'graphreading.page3.your_result_tip' })
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page3.your_result_compared_to_others',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 2,
	              answerChoices: ["less", "similar", "more"],
	              disabledAnswers: [_answer3],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a2") {
	          var _correctAnswer = this.state.correctAnswers[pageNum];
	
	          _highlightContent3 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page3.your_result_incorrect.' + _correctAnswer,
	                values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        }
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page3.getting_your_result', values: { chemical: this.state.chemical } }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page3.tips_to_lower_exposure',
	              values: {
	                chemical: this.state.chemical,
	                group: _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.group
	                ),
	                icon: _react2.default.createElement('span', { className: 'grt-icon', style: {
	                    mask: 'url(' + iconPath + ')',
	                    WebkitMask: 'url(' + iconPath + ') 0% 0% / cover',
	                    display: "inline-block",
	                    background: hexColor,
	                    WebkitMaskSize: "cover",
	                    maskSize: "cover",
	                    width: 15,
	                    height: 20
	                  } })
	              } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page3.face_is_your_personal_result',
	              values: {
	                icon: _react2.default.createElement(
	                  'svg',
	                  { className: 'legend-item-icon', height: 2 * circleRadius, width: 2 * circleRadius },
	                  _react2.default.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/' + this.props.appState.avatar + '.png'), width: 2 * circleRadius, height: 2 * circleRadius }),
	                  _react2.default.createElement('circle', { cx: circleRadius, cy: circleRadius, r: circleRadius - 1, stroke: '#ff5000', strokeWidth: '2px', fill: 'transparent' })
	                )
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tutorial-graph-wrapper' },
	            _react2.default.cloneElement(baseGraph, { tutorialSettings: {
	                noToggle: true,
	                noBenchmark: true,
	                noAvatar: false,
	                drawSampleDots: false
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            _highlightContent3
	          )
	        );
	      } else if (pageNum == 4) {
	        var _React$createElement;
	
	        ////////////////////////////////////////////////////////////////// PAGE 4
	        var _highlightContent4 = void 0;
	
	        if (this.state.currentSubPage == "q") {
	          _highlightContent4 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page4.your_result_compared_to_median',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'negative-bottom-margin' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page4.my_level_is' })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 1,
	              answerChoices: ["less", "similar", "more"],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a") {
	          var _correctAnswer2 = this.state.correctAnswers[pageNum];
	
	          _highlightContent4 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page4.us_median_correct.' + _correctAnswer2,
	                values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        } else if (this.state.currentSubPage == "q2") {
	          var _answer4 = this.state.answers["page-4"]["a-1"];
	
	          _highlightContent4 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page4.us_median_not_quite' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tip-box' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'graphreading.page4.us_median_tip' })
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page4.your_result_compared_to_median',
	                values: { chemical: this.state.chemical } })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'negative-bottom-margin' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page4.my_level_is' })
	            ),
	            _react2.default.createElement(AnswerHandler, {
	              pageNum: pageNum,
	              answerAttempt: 2,
	              answerChoices: ["less", "similar", "more"],
	              disabledAnswers: [_answer4],
	              handleAnswerClick: this.handleAnswerClick.bind(this)
	            })
	          );
	        } else if (this.state.currentSubPage == "a2") {
	          var _correctAnswer3 = this.state.correctAnswers[pageNum];
	
	          _highlightContent4 = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                id: 'graphreading.page4.us_median_incorrect.' + _correctAnswer3,
	                values: { chemical: this.state.chemical } })
	            ),
	            nextButton
	          );
	        }
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page4.the_flag_icon_shows',
	              values: {
	                icon: _react2.default.createElement(
	                  'svg',
	                  { className: 'legend-item-icon', height: 2 * circleRadius, width: 2 * circleRadius },
	                  _react2.default.createElement('line', (_React$createElement = { x1: '0' }, _defineProperty(_React$createElement, 'x1', 13), _defineProperty(_React$createElement, 'y1', 12), _defineProperty(_React$createElement, 'x2', 13), _defineProperty(_React$createElement, 'y2', 25), _defineProperty(_React$createElement, 'stroke', 'rgb(13 94 143)'), _defineProperty(_React$createElement, 'strokeWidth', '3px'), _React$createElement)),
	                  _react2.default.createElement('image', { xlinkHref: (0, _safeUrl2.default)('/images/usflag.svg'), x: -2, y: 0, width: 30, height: 20 }),
	                  _react2.default.createElement('rect', { x: 3, y: 3, width: 18, height: 14, rx: 2, ry: 2, stroke: 'rgb(13 94 143)', strokeWidth: '2px', fill: 'transparent' })
	                )
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tutorial-graph-wrapper' },
	            _react2.default.cloneElement(baseGraph, { tutorialSettings: {
	                noToggle: true,
	                noBenchmark: false,
	                noAvatar: false,
	                drawSampleDots: false
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            _highlightContent4
	          )
	        );
	      } else if (pageNum == 5) {
	        ////////////////////////////////////////////////////////////////// PAGE 5
	
	        var unit = void 0;
	        if (this.state.group == "PFAS") {
	          unit = "ng/mL";
	        } else if (this.state.group == "PBDEs") {
	          unit = "ng/n lipid";
	        }
	        unit = "ng/mL"; // TODO - this is just a placeholder until we have unit text
	        var _highlightContent5 = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'graphreading.page5.' + unit })
	          ),
	          nextButton
	        );
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page5.click_to_expand',
	              values: {
	                chemical: _react2.default.createElement(
	                  'span',
	                  { className: 'chemical-with-arrow' },
	                  this.state.chemical
	                )
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tutorial-graph-wrapper' },
	            _react2.default.cloneElement(baseGraph, { tutorialSettings: {
	                noToggle: false,
	                noBenchmark: false,
	                noAvatar: false,
	                drawSampleDots: false,
	                clickExpandedGraph: this.handleExpandedGraphClick.bind(this)
	              }
	            })
	          ),
	          this.state.p5_graph_expanded_once && _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            _highlightContent5
	          )
	        );
	      } else if (pageNum == 6) {
	        ////////////////////////////////////////////////////////////////// PAGE 6
	        var guessAnswer = this.state.answers["page-0"]["a-1"];
	        var _correctAnswer4 = this.state.correctAnswers[3];
	
	        var introText = _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	            id: 'graphreading.page6.initial_guess.' + guessAnswer,
	            values: { chemical: this.state.chemical } }),
	          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	            id: 'graphreading.page6.graph_showed.' + _correctAnswer4,
	            values: { chemical: this.state.chemical } })
	        );
	        var boldText = void 0;
	        if (_correctAnswer4.includes(guessAnswer)) {
	          boldText = _react2.default.createElement(
	            'p',
	            { className: 'bold-blue' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page6.you_guessed_correctly' })
	          );
	        } else {
	          boldText = _react2.default.createElement(
	            'p',
	            { className: 'bold-blue' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page6.many_people_are_surprised' })
	          );
	        }
	
	        var numActions = this.props.intl.messages['graphreading.page6.' + _helpers2.default.convertGroupName(this.state.group) + '.numSources'];
	        // if (this.state.group == "PFAS") {
	        //   numActions = 6;
	        // }
	        // if (this.state.group == "PBDEs") {
	        //   numActions = 6;
	        // }
	        var checkboxes = [];
	        for (var i = 0; i < numActions; i++) {
	          var item = _react2.default.createElement(
	            'label',
	            { key: 'source' + i, className: 'checkbox-container' },
	            _react2.default.createElement('input', { type: 'checkbox', value: i }),
	            _react2.default.createElement('span', { className: 'checkmark' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page6.' + _helpers2.default.convertGroupName(this.state.group) + '.source' + i })
	            )
	          );
	
	          checkboxes.push(item);
	        }
	
	        var noneOfTheAbove = _react2.default.createElement(
	          'label',
	          { key: 'source-none', className: 'checkbox-container' },
	          _react2.default.createElement('input', { type: 'checkbox', value: 'none' }),
	          _react2.default.createElement('span', { className: 'checkmark' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page6.noneOfTheAbove' })
	          )
	        );
	        checkboxes.push(noneOfTheAbove);
	
	        var anotherIdea = _react2.default.createElement(
	          'label',
	          { key: 'source-another', className: 'checkbox-container' },
	          _react2.default.createElement('input', { type: 'checkbox', value: 'other' }),
	          _react2.default.createElement('span', { className: 'checkmark' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page6.anotherIdea' })
	          ),
	          _react2.default.createElement('textarea', { id: 'free-answer-box', rows: '3', cols: '50' })
	        );
	        checkboxes.push(anotherIdea);
	
	        var _highlightContent6 = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'p6-before-checklist' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page6.ways_people_get_exposed',
	              values: { group: this.state.group } })
	          ),
	          checkboxes,
	          nextButton
	        );
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          introText,
	          boldText,
	          _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            _highlightContent6
	          )
	        );
	      } else if (pageNum == 7) {
	        ////////////////////////////////////////////////////////////////// PAGE 7
	        var _guessAnswer = this.state.answers["page-0"]["a-1"];
	        var _correctAnswer5 = this.state.correctAnswers[3];
	
	        var _introText = _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'graphreading.page7.these_actions_lower_exposure',
	            values: { group: this.state.group } })
	        );
	
	        var toggleRadio = function toggleRadio(id) {
	          if (document.getElementById(id).classList.contains('selected')) {
	            // radio button was checked
	            document.getElementById(id).checked = false;
	            document.getElementById(id).classList.remove('selected');
	          } else {
	            // first uncheck everything else
	            var idMinusEnding = id.substring(0, id.length - 2);
	            var divs = document.querySelectorAll('[id^="' + idMinusEnding + '"]');
	
	            for (var _i4 = 0; _i4 < divs.length; ++_i4) {
	              divs[_i4].classList.remove('selected');
	            }
	
	            // then check this one
	            document.getElementById(id).classList.add('selected');
	            document.getElementById(id).checked = true;
	          }
	        };
	
	        var makeAction = function makeAction(id, group) {
	          return _react2.default.createElement(
	            'div',
	            { key: id },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page7.' + group + '.' + id })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'answer-button-container actions-radios radio-container' },
	              _react2.default.createElement('input', { type: 'radio', name: id, id: id + '-1', value: 'i_do_this', onClick: function onClick(e) {
	                  return toggleRadio(id + '-1');
	                } }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: id + '-1' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page7.i_do_this' })
	              ),
	              _react2.default.createElement('input', { type: 'radio', name: id, id: id + '-2', value: 'i_want_to', onClick: function onClick() {
	                  return toggleRadio(id + '-2');
	                } }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: id + '-2' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page7.i_want_to' })
	              ),
	              _react2.default.createElement('input', { type: 'radio', name: id, id: id + '-3', value: 'not_now', onClick: function onClick() {
	                  return toggleRadio(id + '-3');
	                } }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: id + '-3' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page7.not_now' })
	              )
	            )
	          );
	        };
	
	        var numberToLetter = function numberToLetter(num) {
	          var char = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(num);
	          return char;
	        };
	
	        var actions = [];
	        // add the actions that everyone gets
	        var numDefaultActions = this.props.intl.messages['graphreading.page7.' + _helpers2.default.convertGroupName(this.state.group) + '.default_numActions'];
	        if (numDefaultActions) {
	          for (var _i5 = 0; _i5 < numDefaultActions; _i5++) {
	            var action = makeAction('action_default' + numberToLetter(_i5), _helpers2.default.convertGroupName(this.state.group));
	            actions.push(action);
	          }
	        } else {
	          var _action = makeAction('action_default', _helpers2.default.convertGroupName(this.state.group));
	          actions.push(_action);
	        }
	
	        var _numActions = void 0;
	        if (this.state.group == "PFAS") {
	          _numActions = 6;
	        }
	        var selectedSources = this.state.answers["page-6"]["a-checked"];
	        for (var _i6 = 0; _i6 < selectedSources.length; _i6++) {
	          var sourceNum = selectedSources[_i6];
	          if (!isNaN(sourceNum)) {
	            var _numActions2 = this.props.intl.messages['graphreading.page7.' + _helpers2.default.convertGroupName(this.state.group) + '.source' + sourceNum + '_numActions'];
	            if (_numActions2) {
	              for (var j = 0; j < _numActions2; j++) {
	                var _action2 = makeAction('action_' + sourceNum + numberToLetter(j), _helpers2.default.convertGroupName(this.state.group));
	                actions.push(_action2);
	              }
	            } else {
	              var _action3 = makeAction('action_' + sourceNum, _helpers2.default.convertGroupName(this.state.group));
	              actions.push(_action3);
	            }
	          }
	        }
	
	        if (selectedSources.length == 0 || selectedSources.includes("none")) {
	          // add for non selected
	          var numNonSelected = this.props.intl.messages['graphreading.page7.' + _helpers2.default.convertGroupName(this.state.group) + '.none_numActions'];
	          if (numNonSelected) {
	            for (var _i7 = 0; _i7 < numNonSelected; _i7++) {
	              var _action4 = makeAction('action_none' + numberToLetter(_i7), _helpers2.default.convertGroupName(this.state.group));
	              actions.push(_action4);
	            }
	          } else {
	            var _action5 = makeAction('action_none', _helpers2.default.convertGroupName(this.state.group));
	            actions.push(_action5);
	          }
	        }
	
	        var _highlightContent7 = _react2.default.createElement(
	          'div',
	          null,
	          actions
	        );
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _introText,
	          _react2.default.createElement(
	            'div',
	            { className: 'highlight-box' },
	            _highlightContent7
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'graphreading.page7.thanks_for_taking_action',
	              values: {
	                group: _react2.default.createElement(
	                  'strong',
	                  null,
	                  this.state.group
	                ),
	                icon: _react2.default.createElement('span', { className: 'grt-icon', style: {
	                    mask: 'url(' + iconPath + ')',
	                    WebkitMask: 'url(' + iconPath + ') 0% 0% / cover',
	                    display: "inline-block",
	                    background: hexColor,
	                    WebkitMaskSize: "cover",
	                    maskSize: "cover",
	                    width: 15,
	                    height: 20
	                  } })
	              }
	            })
	          ),
	          nextButton
	        );
	      } else if (pageNum == 8) {
	        ////////////////////////////////////////////////////////////////// PAGE 8
	
	        var _introText2 = void 0;
	        var buttons = void 0;
	
	        _helpers2.default.eventLog('poe:chemical' + this.state.attempt + '_numCorrectBothAttempts - ' + this.state.numCorrect);
	        if (this.state.attempt == 1) {
	          if (this.state.numCorrect == 4) {
	            // first try: all correct
	            _helpers2.default.eventLog("poe:last_page_high_priority_button - view_all_results");
	            _introText2 = _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.end_tutorial_all_correct_try1' })
	            );
	            buttons = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'grt-pg8 emphasized-button', onClick: this.endTutorial.bind(this) },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.view_all_results' }),
	                _react2.default.createElement('span', { className: 'next-symbol' })
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'grt-pg8 not-emphasized-button', onClick: this.retakeTutorial.bind(this) },
	                _react2.default.createElement('span', { className: 'redo-symbol' }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.take_the_tour_again_detail' })
	              )
	            );
	          } else {
	            // first try: not all correct
	            _helpers2.default.eventLog("poe:last_page_high_priority_button - retake_tutorial");
	            _introText2 = _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.end_tutorial_not_correct_try1' })
	            );
	            buttons = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'grt-pg8 emphasized-button', onClick: this.retakeTutorial.bind(this) },
	                _react2.default.createElement('span', { className: 'redo-symbol white-mask' }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.take_the_tour_again' })
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'grt-pg8 not-emphasized-button', onClick: this.endTutorial.bind(this) },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.view_all_results_detail' }),
	                _react2.default.createElement('span', { className: 'next-symbol blue-mask' })
	              )
	            );
	          }
	        } else {
	          if (this.state.numCorrect >= 3) {
	            // second try: most correct
	            _introText2 = _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.end_tutorial_most_correct_try2' })
	            );
	            buttons = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'grt-pg8 emphasized-button', onClick: this.endTutorial.bind(this) },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.view_all_results' }),
	                _react2.default.createElement('span', { className: 'next-symbol' })
	              )
	            );
	          } else {
	            // second try: not most correct
	            _introText2 = _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'graphreading.page8.end_tutorial_not_correct_try2' })
	            );
	            buttons = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'grt-pg8 emphasized-button', onClick: this.endTutorial.bind(this) },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.page8.view_all_results' }),
	                _react2.default.createElement('span', { className: 'next-symbol' })
	              )
	            );
	          }
	        }
	
	        pageContent = _react2.default.createElement(
	          'div',
	          { className: 'grt-popup-content' },
	          _introText2,
	          buttons
	        );
	      }
	
	      return pageContent;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var popup = false;
	      if (this.props.location.hash == "#tour") {
	        popup = true;
	      }
	
	      var homepage = _react2.default.createElement(
	        'div',
	        { className: 'page graphreading' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.title', defaultMessage: 'How to read your graphs' })
	        ),
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'graphreading.description' }),
	        _react2.default.createElement('div', { ref: 'tempContainer', style: { position: "absolute", top: 0, left: -9999 } })
	      );
	
	      if (!popup) {
	        return homepage;
	      }
	
	      var pageContent = this.getPageContent(this.state.currentPage);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'full-page-popup graphreading' },
	        _react2.default.createElement(
	          'button',
	          { className: 'skip-tour', onClick: this.skipTutorial.bind(this) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'graphreading.skip_tour' })
	        ),
	        pageContent,
	        _react2.default.createElement('div', { ref: 'tempContainer', style: { position: "absolute", top: 0, left: -9999 } })
	      );
	    }
	  }]);
	
	  return GraphReadingTutorialPage;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)((0, _mobxReact.observer)(GraphReadingTutorialPage));

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIntl = __webpack_require__(4);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(716);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HealthModal = function (_Component) {
	  _inherits(HealthModal, _Component);
	
	  function HealthModal() {
	    _classCallCheck(this, HealthModal);
	
	    return _possibleConstructorReturn(this, (HealthModal.__proto__ || Object.getPrototypeOf(HealthModal)).apply(this, arguments));
	  }
	
	  _createClass(HealthModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClose: this.props.onClose, className: 'left-align' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'chemicals_and_health.read_more_content' })
	      );
	    }
	  }]);
	
	  return HealthModal;
	}(_react.Component);
	
	var HealthAndChemicalsPage = function (_Component2) {
	  _inherits(HealthAndChemicalsPage, _Component2);
	
	  function HealthAndChemicalsPage() {
	    _classCallCheck(this, HealthAndChemicalsPage);
	
	    var _this2 = _possibleConstructorReturn(this, (HealthAndChemicalsPage.__proto__ || Object.getPrototypeOf(HealthAndChemicalsPage)).call(this));
	
	    _this2.state = {
	      modal: false,
	      showMore: false
	    };
	    return _this2;
	  }
	
	  _createClass(HealthAndChemicalsPage, [{
	    key: 'onClick',
	    value: function onClick() {
	      if (this.state.showMore) {
	        _helpers2.default.eventLog("modal - lesshealth");
	      } else {
	        _helpers2.default.eventLog("modal - morehealth");
	      }
	      // this.setState({ modal: true });
	      // document.getElementsByTagName("body")[0].style.overflow = "hidden";
	      this.setState({ showMore: !this.state.showMore });
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      // this.setState({ modal: false });
	      // document.getElementsByTagName("body")[0].style.overflow = "visible";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modal = this.state.modal ? _react2.default.createElement(HealthModal, { onClose: this.onClose.bind(this) }) : null;
	
	      var readMoreButton = void 0;
	      if (this.state.showMore) {
	        readMoreButton = _react2.default.createElement(
	          'a',
	          { className: 'button secondary scroll-content arrow-up', onClick: this.onClick.bind(this) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'show_less', defaultMessage: 'Show less' })
	        );
	      } else {
	        readMoreButton = _react2.default.createElement(
	          'a',
	          { className: 'button secondary scroll-content arrow-down', onClick: this.onClick.bind(this) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'chemicals_and_health.read_more_button', defaultMessage: 'Show more' })
	        );
	      }
	
	      var additionText = void 0;
	      if (this.state.showMore) {
	        additionText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'chemicals_and_health.read_more_content' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page healthandchemicals' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'chemicals_and_health.title', defaultMessage: 'Chemicals and Health' })
	        ),
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'chemicals_and_health.description' }),
	        _react2.default.createElement('br', null),
	        additionText,
	        readMoreButton
	      );
	    }
	  }]);
	
	  return HealthAndChemicalsPage;
	}(_react.Component);
	
	exports.default = HealthAndChemicalsPage;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactRouterDom = __webpack_require__(57);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _reactIntl = __webpack_require__(4);
	
	__webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomePage = function (_React$Component) {
	  _inherits(HomePage, _React$Component);
	
	  function HomePage() {
	    _classCallCheck(this, HomePage);
	
	    return _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).apply(this, arguments));
	  }
	
	  _createClass(HomePage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.appState.changeAvatar('');
	    }
	  }, {
	    key: 'toggleLanguage',
	    value: function toggleLanguage() {
	      // in case of multiple languages, make each language map to a different link
	      var currLang = this.props.appState.language;
	      var newLang = void 0;
	      if (currLang == "en") {
	        newLang = "es";
	      } else {
	        newLang = "en";
	      }
	
	      var that = this;
	      setTimeout(function () {
	        that.props.appState.changeLanguage(newLang);
	        window.location = '/';
	        window.location.reload(); // forces a reload even if there is a # in the URL
	      }, 100);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // if we got to this page (by clicking the back button, for example) log out
	      // so that the user doesn't mistakenly think they are logged out and leave
	      // the computer with their data still accessible
	      this.props.appState.logOut();
	
	      return React.createElement(
	        'div',
	        { className: 'page home' },
	        React.createElement('img', { src: (0, _safeUrl2.default)('/images/women-with-babies.jpg'), className: 'banner', alt: 'Mothers with Babies' }),
	        React.createElement(
	          'h1',
	          null,
	          React.createElement(_reactIntl.FormattedMessage, { id: 'app.home.header', defaultMessage: 'Welcome to My IKIDS Report.' })
	        ),
	        React.createElement(
	          'p',
	          { className: 'intro' },
	          React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.home.intro', defaultMessage: 'In this website you will be able to see your chemical test results.' })
	        ),
	        React.createElement(
	          _reactRouterDom.Link,
	          { to: '/login', className: 'button' },
	          React.createElement(_reactIntl.FormattedMessage, { id: 'get_started', defaultMessage: 'a empezar' })
	        )
	      );
	    }
	  }]);
	
	  return HomePage;
	}(React.Component);
	
	exports.default = HomePage;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/pages/LanguagePage.js
	// adapated from AvatarPage.js
	
	//// NOTE: This page should not be used anymote, but is still temporarily kept in case it breaks something.
	
	var LanguagePage = function (_Component) {
	  _inherits(LanguagePage, _Component);
	
	  function LanguagePage() {
	    _classCallCheck(this, LanguagePage);
	
	    return _possibleConstructorReturn(this, (LanguagePage.__proto__ || Object.getPrototypeOf(LanguagePage)).apply(this, arguments));
	  }
	
	  return LanguagePage;
	}(_react.Component);
	
	exports.default = LanguagePage;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _Api = __webpack_require__(31);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(724);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginPage = function (_Component) {
	  _inherits(LoginPage, _Component);
	
	  function LoginPage() {
	    _classCallCheck(this, LoginPage);
	
	    var _this = _possibleConstructorReturn(this, (LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call(this));
	
	    _this.state = { access_code: "", error: false };
	    return _this;
	  }
	
	  _createClass(LoginPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      var _this2 = this;
	
	      _Api.Api.authenticate(this.state.access_code).then(function (response) {
	        if (response.success === false) {
	          _helpers2.default.eventLog("event - login failed");
	          _this2.setState({ error: true });
	        } else {
	          _this2.logBrowserMetrics();
	          _this2.props.appState.logIn();
	          _this2.props.history.push('/avatar');
	          _this2.props.appState.loadMeasurements();
	          _this2.props.appState.loadHeadlines();
	        }
	      });
	    }
	  }, {
	    key: 'logBrowserMetrics',
	    value: function logBrowserMetrics() {
	      var options = [];
	      var header = [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera];
	      var dataos = [{ name: 'Windows Phone', value: 'Windows Phone', version: 'OS' }, { name: 'Windows', value: 'Win', version: 'NT' }, { name: 'iPhone', value: 'iPhone', version: 'OS' }, { name: 'iPad', value: 'iPad', version: 'OS' }, { name: 'Kindle', value: 'Silk', version: 'Silk' }, { name: 'Android', value: 'Android', version: 'Android' }, { name: 'PlayBook', value: 'PlayBook', version: 'OS' }, { name: 'BlackBerry', value: 'BlackBerry', version: '/' }, { name: 'Macintosh', value: 'Mac', version: 'OS X' }, { name: 'Linux', value: 'Linux', version: 'rv' }, { name: 'Palm', value: 'Palm', version: 'PalmOS' }];
	      var databrowser = [{ name: 'Chrome', value: 'Chrome', version: 'Chrome' }, { name: 'Firefox', value: 'Firefox', version: 'Firefox' }, { name: 'Safari', value: 'Safari', version: 'Version' }, { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' }, { name: 'Opera', value: 'Opera', version: 'Opera' }, { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' }, { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }];
	
	      var matchItem = function matchItem(string, data) {
	        var i = 0,
	            j = 0,
	            html = '',
	            regex,
	            regexv,
	            match,
	            matches,
	            version;
	
	        for (i = 0; i < data.length; i += 1) {
	          regex = new RegExp(data[i].value, 'i');
	          match = regex.test(string);
	          if (match) {
	            regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
	            matches = string.match(regexv);
	            version = '';
	            if (matches) {
	              if (matches[1]) {
	                matches = matches[1];
	              }
	            }
	            if (matches) {
	              matches = matches.split(/[._]+/);
	              for (j = 0; j < matches.length; j += 1) {
	                if (j === 0) {
	                  version += matches[j] + '.';
	                } else {
	                  version += matches[j];
	                }
	              }
	            } else {
	              version = '0';
	            }
	            return {
	              name: data[i].name,
	              version: parseFloat(version)
	            };
	          }
	        }
	        return { name: 'unknown', version: 0 };
	      };
	
	      var agent = header.join(' ');
	      var os = matchItem(agent, dataos);
	      var browser = matchItem(agent, databrowser);
	
	      var platformString = '' + os.name + os.version;
	      var browserString = '' + browser.name + browser.version;
	
	      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	
	      var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	
	      var browserData = {
	        device: platformString,
	        browser: browserString,
	        width: width,
	        height: height
	      };
	      _helpers2.default.eventLog('deviceAnalytics - device:' + platformString + ',browser:' + browserString + ',width:' + width + ',height:' + height); /// to do change to normal string
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      this.setState({ access_code: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // if we got to this page (by clicking the back button, for example) log out
	      // so that the user doesn't mistakenly think they are logged out and leave
	      // the computer with their data still accessible
	      this.props.appState.logOut();
	
	      var error = this.state.error ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.login.failed', defaultMessage: 'Incorrect access code.  Please try again.' }) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page login' },
	        _react2.default.createElement('img', { src: ("") + '/images/women-with-babies.jpg', width: '100%', alt: '' }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.login.header', defaultMessage: 'Login' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.login.content', defaultMessage: 'Enter your access code to get your results.' })
	        ),
	        error,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', { type: 'text', placeholder: '', size: '10', value: this.state.access_code, onChange: this.onChange.bind(this) })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', onClick: this.onClick.bind(this) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.login.submit', defaultMessage: 'Submit' })
	        )
	      );
	    }
	  }]);
	
	  return LoginPage;
	}(_react.Component);
	
	exports.default = LoginPage;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(24);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIntl = __webpack_require__(4);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	__webpack_require__(728);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoreModal = function (_Component) {
	  _inherits(MoreModal, _Component);
	
	  function MoreModal() {
	    _classCallCheck(this, MoreModal);
	
	    return _possibleConstructorReturn(this, (MoreModal.__proto__ || Object.getPrototypeOf(MoreModal)).apply(this, arguments));
	  }
	
	  _createClass(MoreModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClose: this.props.onClose, className: 'left-align', fullScreen: true },
	        this.props.children
	      );
	    }
	  }]);
	
	  return MoreModal;
	}(_react.Component);
	
	var OverallStudyResultsPage = function (_Component2) {
	  _inherits(OverallStudyResultsPage, _Component2);
	
	  function OverallStudyResultsPage(props) {
	    _classCallCheck(this, OverallStudyResultsPage);
	
	    var _this2 = _possibleConstructorReturn(this, (OverallStudyResultsPage.__proto__ || Object.getPrototypeOf(OverallStudyResultsPage)).call(this, props));
	
	    var numHeadlines = props.intl.messages['page.overallstudyresults.number_headlines'];
	    var arrayOfFalse = new Array(numHeadlines).fill(false);
	    _this2.state = {
	      modals: arrayOfFalse,
	      numHeadlines: numHeadlines
	    };
	    return _this2;
	  }
	
	  _createClass(OverallStudyResultsPage, [{
	    key: 'onClick',
	    value: function onClick(index) {
	      _helpers2.default.eventLog("modal - OverallStudyResults - " + index);
	      var arrayOfFalse = new Array(this.state.numHeadlines).fill(false);
	      arrayOfFalse[index] = true;
	      this.setState({ modals: arrayOfFalse });
	      document.getElementsByTagName("body")[0].style.overflow = "hidden";
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      var arrayOfFalse = new Array(this.state.numHeadlines).fill(false);
	      this.setState({ modals: arrayOfFalse });
	      document.getElementsByTagName("body")[0].style.overflow = "auto";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var that = this;
	
	      var countUpArray = [];
	      for (var i = 0; i < this.state.numHeadlines; i++) {
	        countUpArray.push(i);
	      }
	
	      var modals = countUpArray.map(function (index) {
	        return _this3.state.modals[index] ? _react2.default.createElement(
	          MoreModal,
	          { onClose: that.onClose.bind(that) },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.overallstudyresults.item' + (index + 1) + '.title' })
	          ),
	          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'page.overallstudyresults.item' + (index + 1) + '.content' })
	        ) : null;
	      });
	
	      var items = countUpArray.map(function (index) {
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'image' },
	              _react2.default.createElement('img', { src: '' + ("") + _this3.props.intl.messages['page.overallstudyresults.item' + (index + 1) + '.image'], alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.overallstudyresults.item' + (index + 1) + '.title' })
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'button right secondary', onClick: function onClick() {
	                    return _this3.onClick.bind(_this3)(index);
	                  } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'learn_more' })
	              )
	            )
	          ),
	          modals[index]
	        );
	      });
	
	      var displaynone = { display: 'none' };
	
	      var items_print = countUpArray.map(function (index) {
	
	        var thecontent = _this3.props.intl.messages['page.overallstudyresults.item' + (index + 1) + '.content'];
	        // <p><FormattedHTMLMessage id={`page.overallstudyresults.item${index + 1}.content`} /></p>
	
	        // special re-formatting of the yaml content for print
	        thecontent = thecontent.replace(/[\r\n\t ]+/g, ' '); //remove line breaks/whitespace to make matching easier in next line
	        thecontent = thecontent.replace(/><\/p> <p>/g, ' > <!-- remove extra p after image -->');
	        thecontent = thecontent.replace(/<img/g, '<img style="margin-left:20px;margin-bottom:15px;width:200px;" align="right"'); // small and right-aligned
	        thecontent = thecontent.replace(/<p>(.*)(<img.*?>)(.*)/, '<p>$2$1$3'); // force 1 image to the top!
	
	        thecontent = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: thecontent } });
	
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'image', style: displaynone },
	              _react2.default.createElement('img', { src: '' + ("") + _this3.props.intl.messages['page.overallstudyresults.item' + (index + 1) + '.image'], alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.overallstudyresults.item' + (index + 1) + '.title' })
	              ),
	              thecontent
	            )
	          )
	        );
	      });
	
	      if (_helpers2.default.findGetParameter('print')) {
	        // inline for print #5 -- overall study results -- show the full MORE INFO content and small images
	        items = items_print;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: { maxWidth: '850px' }, className: 'page overallstudyresults' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.overallstudyresults.title', defaultMessage: 'Overall Study Results' })
	        ),
	        items
	      );
	    }
	  }]);
	
	  return OverallStudyResultsPage;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(OverallStudyResultsPage);

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // PrintPage.js
	// adapated from OverallStudyResultsPage.js
	
	//import Modal from '../components/Modal.js';
	
	
	var PrintPage = function (_React$Component) {
	    _inherits(PrintPage, _React$Component);
	
	    function PrintPage() {
	        _classCallCheck(this, PrintPage);
	
	        var _this = _possibleConstructorReturn(this, (PrintPage.__proto__ || Object.getPrototypeOf(PrintPage)).call(this));
	
	        _this.state = {
	            modals: [false, false, false, false]
	        };
	        return _this;
	    }
	
	    _createClass(PrintPage, [{
	        key: 'onClickPrint',
	        value: function onClickPrint(e) {
	            /// OLD method 1 -- simple get link
	            /// <a href='#' className="button" onClick={this.onClickPrint.bind(this)}><FormattedMessage id='download' defaultMessage='Download' /></a>
	            ///e.preventDefault();
	
	            _helpers2.default.eventLog("nav:print download button pressed - PrintPage.onClickPrint()");
	            return true;
	
	            ///const av = window.localStorage.getItem('avatar');
	            ///const la = window.localStorage.getItem('language');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var av = window.localStorage.getItem('avatar') || 'face-1';
	            var la = window.localStorage.getItem('language') || 'es';
	            ///const ac = window.localStorage.getItem('access_code'); // OLD method 2
	            /// <!-- <input type="hidden" name="access_code" value={ac} /> -->
	
	            // method 3 -- devisetokenauth accepts token vals as headers OR params
	            var token_at = window.localStorage.getItem('access-token');
	            var token_client = window.localStorage.getItem('client');
	            var token_uid = window.localStorage.getItem('uid');
	            var token_expiry = window.localStorage.getItem('expiry');
	
	            var buttontext = this.props.intl.messages["download"];
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'page print-page' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.print_page.title', defaultMessage: 'Print' })
	                ),
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'page.print_page.content', defaultMessage: 'code=pp1' }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'form',
	                    { action: 'https://ikids-admin.reportback.org/pdfmerge?avatar=' + av + '&language=' + la, target: '_blank', method: 'post' },
	                    _react2.default.createElement('input', { type: 'hidden', name: 'access-token', value: token_at }),
	                    _react2.default.createElement('input', { type: 'hidden', name: 'client', value: token_client }),
	                    _react2.default.createElement('input', { type: 'hidden', name: 'uid', value: token_uid }),
	                    _react2.default.createElement('input', { type: 'hidden', name: 'expiry', value: token_expiry }),
	                    _react2.default.createElement('input', { className: 'button', type: 'submit', value: buttontext, onClick: this.onClickPrint.bind(this) })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement('br', null)
	                )
	            );
	        } // end render
	
	    }]);
	
	    return PrintPage;
	}(_react2.default.Component); // end PrintPage
	
	//export default injectIntl(PrintPage);
	
	
	exports.default = (0, _reactIntl.injectIntl)((0, _mobxReact.observer)(PrintPage));

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(57);
	
	var _safeUrl = __webpack_require__(25);
	
	var _safeUrl2 = _interopRequireDefault(_safeUrl);
	
	var _mobxReact = __webpack_require__(12);
	
	var _mobx = __webpack_require__(80);
	
	var _DetectionsTable = __webpack_require__(218);
	
	var _DetectionsTable2 = _interopRequireDefault(_DetectionsTable);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	__webpack_require__(241);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SummaryPage = function (_React$Component) {
	  _inherits(SummaryPage, _React$Component);
	
	  function SummaryPage(props) {
	    _classCallCheck(this, SummaryPage);
	
	    return _possibleConstructorReturn(this, (SummaryPage.__proto__ || Object.getPrototypeOf(SummaryPage)).call(this, props));
	  }
	
	  _createClass(SummaryPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	    /*
	    // already loaded in App.js (and using a promise on authentication)
	    if(this.props.appState.headlines.length === 0) {
	      this.props.appState.loadHeadlines();
	    }
	    */
	
	
	    // headlines() : HeadlineType[] {
	    //   if(this.waterpage()) {
	    //     return this.props.appState.headlines
	    //       .filter((d) => d.group === "Water CVOCs" || d.group === "Water Phthalates")
	    //       .sort((a, b) => a.priority - b.priority)
	    //   }
	    //   else {
	    //     return this.props.appState.headlines
	    //       .filter((d) => d.group !== "Water CVOCs" && d.group !== "Water Phthalates")
	    //       .sort((a, b) => a.priority - b.priority)
	    //       .slice(0, 4);
	    //   }
	    // }
	
	  }, {
	    key: 'headlineToHTML',
	    value: function headlineToHTML(headline) {
	      // this takes the markdown link formatting of the headline [*](*)
	      // and turns it into an html underline
	      // assumes only one line per headline
	
	      var htmlHeadline = void 0;
	      if (headline.includes("](")) {
	        var middleIndex = headline.indexOf("](");
	        var startIndex = headline.lastIndexOf("[", middleIndex);
	        var endIndex = headline.indexOf(")", middleIndex);
	
	        if (startIndex != -1 && endIndex != -1) {
	          var beforeText = headline.substring(0, startIndex);
	          var linkName = headline.substring(startIndex + 1, middleIndex);
	          var remainingText = headline.substring(endIndex + 1);
	          htmlHeadline = React.createElement(
	            'span',
	            null,
	            beforeText,
	            React.createElement(
	              'span',
	              { className: 'underline' },
	              linkName
	            ),
	            remainingText
	          );
	        }
	      }
	
	      return htmlHeadline;
	    }
	  }, {
	    key: 'getHighHeadlines',
	    value: function getHighHeadlines() {
	      var relevantHeadlines = void 0;
	      relevantHeadlines = this.props.appState.headlines.sort(function (a, b) {
	        return a.priority - b.priority;
	      });
	
	      // version 1: read the priority based on what's set by the researcher in priority_hml
	      // let highHeadlines = [];
	      // for (let i = 0; i < relevantHeadlines.length; i++) {
	      //   let priority = relevantHeadlines[i].priority_hml
	      //   if (priority == "1-high") {
	      //     highHeadlines.push(relevantHeadlines[i])
	      //   }
	      // }
	
	      //  version 2: read the priority based on a threshold for priorities
	      var highHeadlines = [];
	      var highPriorityThreshold = 8;
	      for (var i = 0; i < relevantHeadlines.length; i++) {
	        var priority = relevantHeadlines[i].priority;
	        if (priority <= highPriorityThreshold) {
	          highHeadlines.push(relevantHeadlines[i]);
	        }
	      }
	
	      return highHeadlines;
	    }
	  }, {
	    key: 'getLowChemicals',
	    value: function getLowChemicals() {
	      var relevantHeadlines = void 0;
	      relevantHeadlines = this.props.appState.headlines.sort(function (a, b) {
	        return a.priority - b.priority;
	      });
	
	      // // Version 1: read the priority based on what's set by the researcher in priority_hml
	      // let lowGroups = [];
	      // for (let i = 0; i < relevantHeadlines.length; i++) {
	      //   let priority = relevantHeadlines[i].priority_hml
	      //   if (priority != "1-high") {
	      //     lowGroups.push(relevantHeadlines[i].group)
	      //   }
	      // }
	
	      //  version 2: read the priority based on a threshold for priorities
	      var lowGroups = [];
	      var highPriorityThreshold = 8;
	      for (var i = 0; i < relevantHeadlines.length; i++) {
	        var priority = relevantHeadlines[i].priority;
	        if (priority > highPriorityThreshold) {
	          lowGroups.push(relevantHeadlines[i].group);
	        }
	      }
	
	      // get list of all groups
	      var relevantGroups = [];
	      for (var x in this.props.appState.groups) {
	        relevantGroups.push(x);
	      }
	
	      // find groups without headlines
	      var noHeadlines = [];
	      for (var g = 0; g < relevantGroups.length; g++) {
	        var headlineFound = false;
	        for (var _i = 0; _i < relevantHeadlines.length; _i++) {
	          var group = relevantHeadlines[_i].group;
	          if (group == relevantGroups[g]) {
	            headlineFound = true;
	            break;
	          }
	        }
	        if (!headlineFound) {
	          noHeadlines.push(relevantGroups[g]);
	        }
	      }
	
	      // if there are groups without headlines, see if there is a result for this participant
	
	      if (noHeadlines.length > 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = this.props.appState.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var dataPoint = _step.value;
	
	            if (noHeadlines.length == 0) {
	              break;
	            }
	            if (noHeadlines.includes(dataPoint.group)) {
	              // there is a measurement, just no headline;
	              lowGroups.push(dataPoint.group);
	              var index = noHeadlines.indexOf(dataPoint.group);
	              noHeadlines.splice(index, 1);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	
	      return [lowGroups, noHeadlines];
	    }
	  }, {
	    key: 'mydetections_waterFilterFunction',
	    value: function mydetections_waterFilterFunction(d) {
	      // "this": value of the optional argument to a JS filter function, send true or false
	      var ispagewater = this;
	      var isdatawater = d.group === "Water CVOCs" || d.group === "Water Phthalates";
	      if (ispagewater === true) return isdatawater;else return !isdatawater;
	    }
	  }, {
	    key: 'mydetections_Compare',
	    value: function mydetections_Compare(a, b) {
	      var x = a.chemical_full + a.visit;
	      var y = b.chemical_full + b.visit;
	      return x < y ? -1 : x > y ? 1 : 0;
	    }
	  }, {
	    key: 'mydetections_UNFILTERED',
	    value: function mydetections_UNFILTERED() {
	      //let wantwaterYN = this.waterpage();
	      return this.props.appState.data.filter(function (d) {
	        return d.mine === true;
	      });
	      //  .filter(this.mydetections_waterFilterFunction, wantwaterYN)
	      //  .sort(this.mydetections_Compare)
	    }
	  }, {
	    key: 'mydetections',
	    value: function mydetections() {
	      var wantwaterYN = this.waterpage();
	      return this.props.appState.data.filter(function (d) {
	        return d.mine === true;
	      }).filter(this.mydetections_waterFilterFunction, wantwaterYN).sort(this.mydetections_Compare);
	    }
	  }, {
	    key: 'waterpage',
	    value: function waterpage() {
	      return this.props.match.path === "/water_summary";
	    }
	  }, {
	    key: 'MOVEDconvertGroupName',
	    value: function MOVEDconvertGroupName(name) {
	      return name === "Sunscreen Chemicals" ? "sunscreen" : name.toLowerCase().replace(' ', '_');
	    }
	  }, {
	    key: 'goto',
	    value: function goto(e, url) {
	      e.preventDefault();
	      _helpers2.default.eventLog("nav:summarypage link clicked -  - " + url);
	      this.props.history.push(url);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(group, headline_priority) {
	      _helpers2.default.eventLog('nav:summarypage headline_clicked - ' + group + '_' + headline_priority);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var colorIndex = 0;
	      var self = this;
	
	      var highHeadlines = this.getHighHeadlines();
	      var remainingHighHeadlines = void 0;
	      if (highHeadlines.length > 2) {
	        remainingHighHeadlines = highHeadlines.slice(2, highHeadlines.length);
	        highHeadlines = highHeadlines.slice(0, 2);
	      }
	
	      var headlinesDisplay = highHeadlines.map(function (headline) {
	        var iconUrl = (0, _safeUrl2.default)('/images/' + self.props.intl.messages['chemicals.' + _helpers2.default.convertGroupName(headline.group) + '.icon']);
	        return React.createElement(
	          'div',
	          { key: headline.summary, onClick: function onClick() {
	              return self.onClick(headline.group, "highHeadlineBox");
	            } },
	          React.createElement(
	            _reactRouterDom.Link,
	            { className: 'high-headline-box', to: '/chemicals/' + _helpers2.default.convertGroupName(headline.group) },
	            React.createElement(
	              'div',
	              { className: 'group-icon' },
	              React.createElement('span', { className: 'group-icon', style: {
	                  mask: 'url(' + iconUrl + ')',
	                  WebkitMask: 'url(' + iconUrl + ')',
	                  display: "inline-block",
	                  background: "black",
	                  WebkitMaskSize: "cover",
	                  maskSize: "cover",
	                  width: 40,
	                  height: 40
	                } })
	            ),
	            React.createElement(
	              'div',
	              { className: 'headline-summary-text' },
	              React.createElement(
	                'strong',
	                null,
	                self.headlineToHTML(headline.summary)
	              )
	            ),
	            React.createElement(
	              'p',
	              null,
	              React.createElement(
	                'em',
	                null,
	                React.createElement(_reactIntl.FormattedMessage, { id: 'learn_more_and_improve', defaultMessage: 'Lo que puedes hacer' })
	              ),
	              React.createElement('br', null)
	            )
	          )
	        );
	      });
	
	      var remainingHighHeadlinesDisplay = null;
	      if (remainingHighHeadlines) {
	        var remainingHighHeadlinesList = remainingHighHeadlines.map(function (headline) {
	          var iconUrl = (0, _safeUrl2.default)('/images/' + self.props.intl.messages['chemicals.' + _helpers2.default.convertGroupName(headline.group) + '.icon']);
	          var hexColor = _helpers2.default.getIconColor(_helpers2.default.convertGroupName(headline.group), self.props.intl);
	
	          return React.createElement(
	            'div',
	            { key: headline.summary, onClick: function onClick() {
	                return self.onClick(headline.group, "highHeadlineList");
	              } },
	            React.createElement(
	              _reactRouterDom.Link,
	              { key: headline.summary, className: 'high-chemical-name', to: '/chemicals/' + _helpers2.default.convertGroupName(headline.group) },
	              React.createElement(
	                'span',
	                { className: 'group-icon-wrapper' },
	                React.createElement('span', { className: 'group-icon', style: {
	                    mask: 'url(' + iconUrl + ')',
	                    WebkitMask: 'url(' + iconUrl + ')',
	                    display: "inline-block",
	                    background: hexColor,
	                    WebkitMaskSize: "cover",
	                    maskSize: "cover",
	                    width: 40,
	                    height: 40
	                  } })
	              ),
	              React.createElement(
	                'p',
	                { className: 'low-chemical-name' },
	                React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + _helpers2.default.convertGroupName(headline.group) + '.title' })
	              )
	            )
	          );
	        });
	
	        remainingHighHeadlinesDisplay = React.createElement(
	          'div',
	          { className: 'high-chemical-summary' },
	          React.createElement(
	            'p',
	            null,
	            React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'also_higher_levels_for', defaultMessage: 'TODO' })
	          ),
	          remainingHighHeadlinesList
	        );
	      }
	
	      var lowChemicals = void 0;
	      var noResults = void 0;
	
	      var _getLowChemicals = this.getLowChemicals();
	
	      var _getLowChemicals2 = _slicedToArray(_getLowChemicals, 2);
	
	      lowChemicals = _getLowChemicals2[0];
	      noResults = _getLowChemicals2[1];
	
	
	      var lowChemicalsDisplay = null;
	      if (lowChemicals.length > 0) {
	        var lowChemicalsList = lowChemicals.map(function (group) {
	          var iconUrl = (0, _safeUrl2.default)('/images/' + self.props.intl.messages['chemicals.' + _helpers2.default.convertGroupName(group) + '.icon']);
	          var hexColor = _helpers2.default.getIconColor(_helpers2.default.convertGroupName(group), self.props.intl);
	
	          return React.createElement(
	            'div',
	            { key: group, onClick: function onClick() {
	                return self.onClick(group, "lowHeadline");
	              } },
	            React.createElement(
	              _reactRouterDom.Link,
	              { key: group, className: 'low-chemical-name', to: '/chemicals/' + _helpers2.default.convertGroupName(group) },
	              React.createElement(
	                'span',
	                { className: 'group-icon-wrapper' },
	                React.createElement('span', { className: 'group-icon', style: {
	                    mask: 'url(' + iconUrl + ')',
	                    WebkitMask: 'url(' + iconUrl + ')',
	                    display: "inline-block",
	                    background: hexColor,
	                    WebkitMaskSize: "cover",
	                    maskSize: "cover",
	                    width: 40,
	                    height: 40
	                  } })
	              ),
	              React.createElement(
	                'p',
	                { className: 'low-chemical-name' },
	                React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + _helpers2.default.convertGroupName(group) + '.title' })
	              )
	            )
	          );
	        });
	
	        lowChemicalsDisplay = React.createElement(
	          'div',
	          { className: 'low-chemical-summary' },
	          React.createElement(
	            'p',
	            null,
	            React.createElement(_reactIntl.FormattedHTMLMessage, { id: 'same_or_lower_levels', defaultMessage: 'You had the same or lower levels' })
	          ),
	          lowChemicalsList
	        );
	      }
	
	      var noResultsChemicalsDisplay = null;
	      if (noResults.length > 0) {
	        var noResultsList = noResults.map(function (group) {
	          var iconUrl = (0, _safeUrl2.default)('/images/' + self.props.intl.messages['chemicals.' + _helpers2.default.convertGroupName(group) + '.icon']);
	          var hexColor = _helpers2.default.getIconColor(_helpers2.default.convertGroupName(group), self.props.intl);
	
	          return React.createElement(
	            'div',
	            { key: group, onClick: function onClick() {
	                return self.onClick(group, "noResultHeadline");
	              } },
	            React.createElement(
	              _reactRouterDom.Link,
	              { key: group, className: 'low-chemical-name', to: '/chemicals/' + _helpers2.default.convertGroupName(group) },
	              React.createElement(
	                'span',
	                { className: 'group-icon-wrapper' },
	                React.createElement('span', { className: 'group-icon', style: {
	                    mask: 'url(' + iconUrl + ')',
	                    WebkitMask: 'url(' + iconUrl + ')',
	                    display: "inline-block",
	                    background: hexColor,
	                    WebkitMaskSize: "cover",
	                    maskSize: "cover",
	                    width: 40,
	                    height: 40
	                  } })
	              ),
	              React.createElement(
	                'p',
	                { className: 'low-chemical-name' },
	                React.createElement(_reactIntl.FormattedMessage, { id: 'chemicals.' + _helpers2.default.convertGroupName(group) + '.title' })
	              )
	            )
	          );
	        });
	
	        noResultsChemicalsDisplay = React.createElement(
	          'div',
	          { className: 'low-chemical-summary' },
	          React.createElement(
	            'p',
	            null,
	            React.createElement(_reactIntl.FormattedMessage, { id: 'no_results_for', defaultMessage: 'TODO' })
	          ),
	          noResultsList
	        );
	      }
	
	      //let tableDisplay = this.mydetectionsDisplayDoit(this.mydetections(), this.waterpage());
	
	      var tableDisplay = null; // move to AppendixPage -- print only
	
	      /*
	      let tableDisplay = <DetectionsTable
	              thedetections={this.mydetections_UNFILTERED()}
	              iswatertable={this.waterpage()}
	              thispage={this}
	                />
	      */
	
	      var header = this.waterpage() ? React.createElement(_reactIntl.FormattedMessage, { id: 'app.pages.water_summary.title', defaultMessage: 'Water Summary' }) : React.createElement(_reactIntl.FormattedMessage, { id: 'app.pages.summary.title', defaultMessage: 'Summary' });
	
	      return React.createElement(
	        'div',
	        { className: 'page summary' },
	        React.createElement(
	          'h1',
	          null,
	          header
	        ),
	        React.createElement(
	          'p',
	          null,
	          React.createElement(_reactIntl.FormattedMessage, { id: 'app.pages.summary.desc', defaultMessage: 'Click each chemical group to see your complete results. When you\u2019re done, continue to the rest of the report.' })
	        ),
	        React.createElement(
	          'div',
	          { className: 'summary-table' },
	          headlinesDisplay,
	          remainingHighHeadlinesDisplay,
	          lowChemicalsDisplay,
	          noResultsChemicalsDisplay
	        ),
	        tableDisplay
	      );
	    } //END render
	
	  }]);
	
	  return SummaryPage;
	}(React.Component); // END class SummaryPage
	
	
	exports.default = (0, _reactIntl.injectIntl)((0, _mobxReact.observer)(SummaryPage));

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(26);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _reactIntl = __webpack_require__(4);
	
	var _mobxReact = __webpack_require__(12);
	
	var _Api = __webpack_require__(31);
	
	var _NavigationStructure = __webpack_require__(23);
	
	var _NavigationStructure2 = _interopRequireDefault(_NavigationStructure);
	
	__webpack_require__(729);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackForm = function (_Component) {
	    _inherits(FeedbackForm, _Component);
	
	    function FeedbackForm() {
	        _classCallCheck(this, FeedbackForm);
	
	        var _this = _possibleConstructorReturn(this, (FeedbackForm.__proto__ || Object.getPrototypeOf(FeedbackForm)).call(this));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        return _this;
	    }
	
	    _createClass(FeedbackForm, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var theform = document.getElementById("id_surveyform");
	            this.submitDoit(theform, 0);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(event) {
	            event.preventDefault();
	            var theform = event.target;
	            this.submitDoit(theform, 0);
	        }
	    }, {
	        key: 'fd_itoa',
	        value: function fd_itoa(formdata) {
	            var thearray = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = formdata[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var prop = _step.value;
	                    thearray[prop[0]] = prop[1];
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return thearray;
	        }
	    }, {
	        key: 'newFormData_removeItemIfEmpty',
	        value: function newFormData_removeItemIfEmpty(theform, name) {
	            // text and textarea -- remove form item if empty to prevent overwriting survey item in DERBI
	            var elem = document.getElementsByName(name)[0];
	            var formData = new FormData(theform);
	            if (elem && elem.value === "") {
	                //do not remove the element itself
	                //let e = elem.parentNode.removeChild(elem);
	                formData = this.newFormData_withoutItem(theform, name);
	            }
	            return formData;
	        }
	    }, {
	        key: 'newFormData_withoutItem',
	        value: function newFormData_withoutItem(theform, excludefieldname) {
	            // because formData.remove() AND several other methods are  not well supported yet, make new with append() which is supported
	            var inputs = theform.getElementsByTagName('input');
	            var inputsList = Array.prototype.slice.call(inputs);
	
	            var newData = new FormData();
	            inputsList.forEach(function (i) {
	                var add = 1;
	                if (i.name === "") add = 0; // like a submit button without a name
	                if (i.name === excludefieldname) add = 0;
	                if ((i.type === "radio" || i.type === "checkbox") && !i.checked) add = 0;
	                if (add) newData.append(i.name, i.value);
	            });
	            return newData;
	        }
	    }, {
	        key: 'submitDoit',
	        value: function submitDoit(theform, is_silent) {
	            var _this2 = this;
	
	            //alert("submitting..." + is_silent);
	
	            var formData = this.newFormData_removeItemIfEmpty(theform, "survey[popup_q4]"); // don't submit && overwrite if the person does not type anything
	
	            //test -- see if it's removing the right thing
	            var a = this.fd_itoa(formData); //console.log(a);
	            if (Object.keys(a).length === 0) return; //nothing to do
	
	            var url = 'https://ikids-admin.reportback.org/report/survey?popup=1&id=cleaning';
	
	            _Api.Api.postURL(url, formData).then(function (response) {
	                if (!is_silent) alert(_this2.props.thankyouText);
	            }).catch(function (error) {
	                console(error);
	                if (!is_silent) alert(this.props.errorText);
	            });
	        }
	    }, {
	        key: 'UNUSEDhandleChange',
	        value: function UNUSEDhandleChange(event) {
	            this.setState({ value: event.target.value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'form',
	                { id: 'id_surveyform', className: 'survey', onSubmit: this.handleSubmit },
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'page.survey.formcontent' })
	            );
	        }
	    }]);
	
	    return FeedbackForm;
	}(_react.Component);
	
	var SurveyPage = function (_Component2) {
	    _inherits(SurveyPage, _Component2);
	
	    function SurveyPage() {
	        _classCallCheck(this, SurveyPage);
	
	        return _possibleConstructorReturn(this, (SurveyPage.__proto__ || Object.getPrototypeOf(SurveyPage)).apply(this, arguments));
	    }
	
	    _createClass(SurveyPage, [{
	        key: 'onClick',
	        value: function onClick(path) {
	            //this.props.history.push(path);
	            window.scrollTo(0, 0);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var filterer = function filterer(value) {
	                var group_name = _this4.props.intl.messages['chemicals.' + value.group + '.data'];
	                if (_this4.props.appState.groups[group_name] !== undefined && _this4.props.appState.groups[group_name].length > 0) {
	                    return _.filter(_this4.props.appState.groups[group_name], { mine: true }).length > 0;
	                } else return false;
	            };
	
	            var summary_items = Object.values(_NavigationStructure2.default).filter(function (value) {
	                return value.summary;
	            }).filter(filterer);
	
	            var water_summary_items = Object.values(_NavigationStructure2.default).filter(function (value) {
	                return value.water_summary;
	            }).filter(filterer);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'survey page' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page.survey.title' })
	                ),
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'page.survey.content' }),
	                _react2.default.createElement(FeedbackForm, {
	                    thankyouText: this.props.intl.messages['app.survey.thankyou'],
	                    errorText: this.props.intl.messages['app.survey.error'],
	                    sendButtonText: this.props.intl.messages['app.login.submit']
	                })
	            );
	        }
	    }]);
	
	    return SurveyPage;
	}(_react.Component);
	
	exports.default = (0, _mobxReact.observer)((0, _reactIntl.injectIntl)(SurveyPage));

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function webpackUniversalModuleDefinition(root, factory) {
		/* istanbul ignore next */
		if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		/* istanbul ignore next */
		else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["esprima"] = factory();else root["esprima"] = factory();
	})(undefined, function () {
		return (/******/function (modules) {
				// webpackBootstrap
				/******/ // The module cache
				/******/var installedModules = {};
	
				/******/ // The require function
				/******/function __webpack_require__(moduleId) {
	
					/******/ // Check if module is in cache
					/* istanbul ignore if */
					/******/if (installedModules[moduleId])
						/******/return installedModules[moduleId].exports;
	
					/******/ // Create a new module (and put it into the cache)
					/******/var module = installedModules[moduleId] = {
						/******/exports: {},
						/******/id: moduleId,
						/******/loaded: false
						/******/ };
	
					/******/ // Execute the module function
					/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
					/******/ // Flag the module as loaded
					/******/module.loaded = true;
	
					/******/ // Return the exports of the module
					/******/return module.exports;
					/******/
				}
	
				/******/ // expose the modules object (__webpack_modules__)
				/******/__webpack_require__.m = modules;
	
				/******/ // expose the module cache
				/******/__webpack_require__.c = installedModules;
	
				/******/ // __webpack_public_path__
				/******/__webpack_require__.p = "";
	
				/******/ // Load entry module and return exports
				/******/return __webpack_require__(0);
				/******/
			}(
			/************************************************************************/
			/******/[
			/* 0 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
				/*
	     Copyright JS Foundation and other contributors, https://js.foundation/
	   
	     Redistribution and use in source and binary forms, with or without
	     modification, are permitted provided that the following conditions are met:
	   
	       * Redistributions of source code must retain the above copyright
	         notice, this list of conditions and the following disclaimer.
	       * Redistributions in binary form must reproduce the above copyright
	         notice, this list of conditions and the following disclaimer in the
	         documentation and/or other materials provided with the distribution.
	   
	     THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	     IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	     ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	     DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	     (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	     LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	     ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	     (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	     THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   */
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var comment_handler_1 = __webpack_require__(1);
				var jsx_parser_1 = __webpack_require__(3);
				var parser_1 = __webpack_require__(8);
				var tokenizer_1 = __webpack_require__(15);
				function parse(code, options, delegate) {
					var commentHandler = null;
					var proxyDelegate = function proxyDelegate(node, metadata) {
						if (delegate) {
							delegate(node, metadata);
						}
						if (commentHandler) {
							commentHandler.visit(node, metadata);
						}
					};
					var parserDelegate = typeof delegate === 'function' ? proxyDelegate : null;
					var collectComment = false;
					if (options) {
						collectComment = typeof options.comment === 'boolean' && options.comment;
						var attachComment = typeof options.attachComment === 'boolean' && options.attachComment;
						if (collectComment || attachComment) {
							commentHandler = new comment_handler_1.CommentHandler();
							commentHandler.attach = attachComment;
							options.comment = true;
							parserDelegate = proxyDelegate;
						}
					}
					var isModule = false;
					if (options && typeof options.sourceType === 'string') {
						isModule = options.sourceType === 'module';
					}
					var parser;
					if (options && typeof options.jsx === 'boolean' && options.jsx) {
						parser = new jsx_parser_1.JSXParser(code, options, parserDelegate);
					} else {
						parser = new parser_1.Parser(code, options, parserDelegate);
					}
					var program = isModule ? parser.parseModule() : parser.parseScript();
					var ast = program;
					if (collectComment && commentHandler) {
						ast.comments = commentHandler.comments;
					}
					if (parser.config.tokens) {
						ast.tokens = parser.tokens;
					}
					if (parser.config.tolerant) {
						ast.errors = parser.errorHandler.errors;
					}
					return ast;
				}
				exports.parse = parse;
				function parseModule(code, options, delegate) {
					var parsingOptions = options || {};
					parsingOptions.sourceType = 'module';
					return parse(code, parsingOptions, delegate);
				}
				exports.parseModule = parseModule;
				function parseScript(code, options, delegate) {
					var parsingOptions = options || {};
					parsingOptions.sourceType = 'script';
					return parse(code, parsingOptions, delegate);
				}
				exports.parseScript = parseScript;
				function tokenize(code, options, delegate) {
					var tokenizer = new tokenizer_1.Tokenizer(code, options);
					var tokens;
					tokens = [];
					try {
						while (true) {
							var token = tokenizer.getNextToken();
							if (!token) {
								break;
							}
							if (delegate) {
								token = delegate(token);
							}
							tokens.push(token);
						}
					} catch (e) {
						tokenizer.errorHandler.tolerate(e);
					}
					if (tokenizer.errorHandler.tolerant) {
						tokens.errors = tokenizer.errors();
					}
					return tokens;
				}
				exports.tokenize = tokenize;
				var syntax_1 = __webpack_require__(2);
				exports.Syntax = syntax_1.Syntax;
				// Sync with *.json manifests.
				exports.version = '4.0.0';
	
				/***/
			},
			/* 1 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var syntax_1 = __webpack_require__(2);
				var CommentHandler = function () {
					function CommentHandler() {
						this.attach = false;
						this.comments = [];
						this.stack = [];
						this.leading = [];
						this.trailing = [];
					}
					CommentHandler.prototype.insertInnerComments = function (node, metadata) {
						//  innnerComments for properties empty block
						//  `function a() {/** comments **\/}`
						if (node.type === syntax_1.Syntax.BlockStatement && node.body.length === 0) {
							var innerComments = [];
							for (var i = this.leading.length - 1; i >= 0; --i) {
								var entry = this.leading[i];
								if (metadata.end.offset >= entry.start) {
									innerComments.unshift(entry.comment);
									this.leading.splice(i, 1);
									this.trailing.splice(i, 1);
								}
							}
							if (innerComments.length) {
								node.innerComments = innerComments;
							}
						}
					};
					CommentHandler.prototype.findTrailingComments = function (metadata) {
						var trailingComments = [];
						if (this.trailing.length > 0) {
							for (var i = this.trailing.length - 1; i >= 0; --i) {
								var entry_1 = this.trailing[i];
								if (entry_1.start >= metadata.end.offset) {
									trailingComments.unshift(entry_1.comment);
								}
							}
							this.trailing.length = 0;
							return trailingComments;
						}
						var entry = this.stack[this.stack.length - 1];
						if (entry && entry.node.trailingComments) {
							var firstComment = entry.node.trailingComments[0];
							if (firstComment && firstComment.range[0] >= metadata.end.offset) {
								trailingComments = entry.node.trailingComments;
								delete entry.node.trailingComments;
							}
						}
						return trailingComments;
					};
					CommentHandler.prototype.findLeadingComments = function (metadata) {
						var leadingComments = [];
						var target;
						while (this.stack.length > 0) {
							var entry = this.stack[this.stack.length - 1];
							if (entry && entry.start >= metadata.start.offset) {
								target = entry.node;
								this.stack.pop();
							} else {
								break;
							}
						}
						if (target) {
							var count = target.leadingComments ? target.leadingComments.length : 0;
							for (var i = count - 1; i >= 0; --i) {
								var comment = target.leadingComments[i];
								if (comment.range[1] <= metadata.start.offset) {
									leadingComments.unshift(comment);
									target.leadingComments.splice(i, 1);
								}
							}
							if (target.leadingComments && target.leadingComments.length === 0) {
								delete target.leadingComments;
							}
							return leadingComments;
						}
						for (var i = this.leading.length - 1; i >= 0; --i) {
							var entry = this.leading[i];
							if (entry.start <= metadata.start.offset) {
								leadingComments.unshift(entry.comment);
								this.leading.splice(i, 1);
							}
						}
						return leadingComments;
					};
					CommentHandler.prototype.visitNode = function (node, metadata) {
						if (node.type === syntax_1.Syntax.Program && node.body.length > 0) {
							return;
						}
						this.insertInnerComments(node, metadata);
						var trailingComments = this.findTrailingComments(metadata);
						var leadingComments = this.findLeadingComments(metadata);
						if (leadingComments.length > 0) {
							node.leadingComments = leadingComments;
						}
						if (trailingComments.length > 0) {
							node.trailingComments = trailingComments;
						}
						this.stack.push({
							node: node,
							start: metadata.start.offset
						});
					};
					CommentHandler.prototype.visitComment = function (node, metadata) {
						var type = node.type[0] === 'L' ? 'Line' : 'Block';
						var comment = {
							type: type,
							value: node.value
						};
						if (node.range) {
							comment.range = node.range;
						}
						if (node.loc) {
							comment.loc = node.loc;
						}
						this.comments.push(comment);
						if (this.attach) {
							var entry = {
								comment: {
									type: type,
									value: node.value,
									range: [metadata.start.offset, metadata.end.offset]
								},
								start: metadata.start.offset
							};
							if (node.loc) {
								entry.comment.loc = node.loc;
							}
							node.type = type;
							this.leading.push(entry);
							this.trailing.push(entry);
						}
					};
					CommentHandler.prototype.visit = function (node, metadata) {
						if (node.type === 'LineComment') {
							this.visitComment(node, metadata);
						} else if (node.type === 'BlockComment') {
							this.visitComment(node, metadata);
						} else if (this.attach) {
							this.visitNode(node, metadata);
						}
					};
					return CommentHandler;
				}();
				exports.CommentHandler = CommentHandler;
	
				/***/
			},
			/* 2 */
			/***/function (module, exports) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				exports.Syntax = {
					AssignmentExpression: 'AssignmentExpression',
					AssignmentPattern: 'AssignmentPattern',
					ArrayExpression: 'ArrayExpression',
					ArrayPattern: 'ArrayPattern',
					ArrowFunctionExpression: 'ArrowFunctionExpression',
					AwaitExpression: 'AwaitExpression',
					BlockStatement: 'BlockStatement',
					BinaryExpression: 'BinaryExpression',
					BreakStatement: 'BreakStatement',
					CallExpression: 'CallExpression',
					CatchClause: 'CatchClause',
					ClassBody: 'ClassBody',
					ClassDeclaration: 'ClassDeclaration',
					ClassExpression: 'ClassExpression',
					ConditionalExpression: 'ConditionalExpression',
					ContinueStatement: 'ContinueStatement',
					DoWhileStatement: 'DoWhileStatement',
					DebuggerStatement: 'DebuggerStatement',
					EmptyStatement: 'EmptyStatement',
					ExportAllDeclaration: 'ExportAllDeclaration',
					ExportDefaultDeclaration: 'ExportDefaultDeclaration',
					ExportNamedDeclaration: 'ExportNamedDeclaration',
					ExportSpecifier: 'ExportSpecifier',
					ExpressionStatement: 'ExpressionStatement',
					ForStatement: 'ForStatement',
					ForOfStatement: 'ForOfStatement',
					ForInStatement: 'ForInStatement',
					FunctionDeclaration: 'FunctionDeclaration',
					FunctionExpression: 'FunctionExpression',
					Identifier: 'Identifier',
					IfStatement: 'IfStatement',
					ImportDeclaration: 'ImportDeclaration',
					ImportDefaultSpecifier: 'ImportDefaultSpecifier',
					ImportNamespaceSpecifier: 'ImportNamespaceSpecifier',
					ImportSpecifier: 'ImportSpecifier',
					Literal: 'Literal',
					LabeledStatement: 'LabeledStatement',
					LogicalExpression: 'LogicalExpression',
					MemberExpression: 'MemberExpression',
					MetaProperty: 'MetaProperty',
					MethodDefinition: 'MethodDefinition',
					NewExpression: 'NewExpression',
					ObjectExpression: 'ObjectExpression',
					ObjectPattern: 'ObjectPattern',
					Program: 'Program',
					Property: 'Property',
					RestElement: 'RestElement',
					ReturnStatement: 'ReturnStatement',
					SequenceExpression: 'SequenceExpression',
					SpreadElement: 'SpreadElement',
					Super: 'Super',
					SwitchCase: 'SwitchCase',
					SwitchStatement: 'SwitchStatement',
					TaggedTemplateExpression: 'TaggedTemplateExpression',
					TemplateElement: 'TemplateElement',
					TemplateLiteral: 'TemplateLiteral',
					ThisExpression: 'ThisExpression',
					ThrowStatement: 'ThrowStatement',
					TryStatement: 'TryStatement',
					UnaryExpression: 'UnaryExpression',
					UpdateExpression: 'UpdateExpression',
					VariableDeclaration: 'VariableDeclaration',
					VariableDeclarator: 'VariableDeclarator',
					WhileStatement: 'WhileStatement',
					WithStatement: 'WithStatement',
					YieldExpression: 'YieldExpression'
				};
	
				/***/
			},
			/* 3 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
				/* istanbul ignore next */
	
				var __extends = this && this.__extends || function () {
					var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
						d.__proto__ = b;
					} || function (d, b) {
						for (var p in b) {
							if (b.hasOwnProperty(p)) d[p] = b[p];
						}
					};
					return function (d, b) {
						extendStatics(d, b);
						function __() {
							this.constructor = d;
						}
						d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
					};
				}();
				Object.defineProperty(exports, "__esModule", { value: true });
				var character_1 = __webpack_require__(4);
				var JSXNode = __webpack_require__(5);
				var jsx_syntax_1 = __webpack_require__(6);
				var Node = __webpack_require__(7);
				var parser_1 = __webpack_require__(8);
				var token_1 = __webpack_require__(13);
				var xhtml_entities_1 = __webpack_require__(14);
				token_1.TokenName[100 /* Identifier */] = 'JSXIdentifier';
				token_1.TokenName[101 /* Text */] = 'JSXText';
				// Fully qualified element name, e.g. <svg:path> returns "svg:path"
				function getQualifiedElementName(elementName) {
					var qualifiedName;
					switch (elementName.type) {
						case jsx_syntax_1.JSXSyntax.JSXIdentifier:
							var id = elementName;
							qualifiedName = id.name;
							break;
						case jsx_syntax_1.JSXSyntax.JSXNamespacedName:
							var ns = elementName;
							qualifiedName = getQualifiedElementName(ns.namespace) + ':' + getQualifiedElementName(ns.name);
							break;
						case jsx_syntax_1.JSXSyntax.JSXMemberExpression:
							var expr = elementName;
							qualifiedName = getQualifiedElementName(expr.object) + '.' + getQualifiedElementName(expr.property);
							break;
						/* istanbul ignore next */
						default:
							break;
					}
					return qualifiedName;
				}
				var JSXParser = function (_super) {
					__extends(JSXParser, _super);
					function JSXParser(code, options, delegate) {
						return _super.call(this, code, options, delegate) || this;
					}
					JSXParser.prototype.parsePrimaryExpression = function () {
						return this.match('<') ? this.parseJSXRoot() : _super.prototype.parsePrimaryExpression.call(this);
					};
					JSXParser.prototype.startJSX = function () {
						// Unwind the scanner before the lookahead token.
						this.scanner.index = this.startMarker.index;
						this.scanner.lineNumber = this.startMarker.line;
						this.scanner.lineStart = this.startMarker.index - this.startMarker.column;
					};
					JSXParser.prototype.finishJSX = function () {
						// Prime the next lookahead.
						this.nextToken();
					};
					JSXParser.prototype.reenterJSX = function () {
						this.startJSX();
						this.expectJSX('}');
						// Pop the closing '}' added from the lookahead.
						if (this.config.tokens) {
							this.tokens.pop();
						}
					};
					JSXParser.prototype.createJSXNode = function () {
						this.collectComments();
						return {
							index: this.scanner.index,
							line: this.scanner.lineNumber,
							column: this.scanner.index - this.scanner.lineStart
						};
					};
					JSXParser.prototype.createJSXChildNode = function () {
						return {
							index: this.scanner.index,
							line: this.scanner.lineNumber,
							column: this.scanner.index - this.scanner.lineStart
						};
					};
					JSXParser.prototype.scanXHTMLEntity = function (quote) {
						var result = '&';
						var valid = true;
						var terminated = false;
						var numeric = false;
						var hex = false;
						while (!this.scanner.eof() && valid && !terminated) {
							var ch = this.scanner.source[this.scanner.index];
							if (ch === quote) {
								break;
							}
							terminated = ch === ';';
							result += ch;
							++this.scanner.index;
							if (!terminated) {
								switch (result.length) {
									case 2:
										// e.g. '&#123;'
										numeric = ch === '#';
										break;
									case 3:
										if (numeric) {
											// e.g. '&#x41;'
											hex = ch === 'x';
											valid = hex || character_1.Character.isDecimalDigit(ch.charCodeAt(0));
											numeric = numeric && !hex;
										}
										break;
									default:
										valid = valid && !(numeric && !character_1.Character.isDecimalDigit(ch.charCodeAt(0)));
										valid = valid && !(hex && !character_1.Character.isHexDigit(ch.charCodeAt(0)));
										break;
								}
							}
						}
						if (valid && terminated && result.length > 2) {
							// e.g. '&#x41;' becomes just '#x41'
							var str = result.substr(1, result.length - 2);
							if (numeric && str.length > 1) {
								result = String.fromCharCode(parseInt(str.substr(1), 10));
							} else if (hex && str.length > 2) {
								result = String.fromCharCode(parseInt('0' + str.substr(1), 16));
							} else if (!numeric && !hex && xhtml_entities_1.XHTMLEntities[str]) {
								result = xhtml_entities_1.XHTMLEntities[str];
							}
						}
						return result;
					};
					// Scan the next JSX token. This replaces Scanner#lex when in JSX mode.
					JSXParser.prototype.lexJSX = function () {
						var cp = this.scanner.source.charCodeAt(this.scanner.index);
						// < > / : = { }
						if (cp === 60 || cp === 62 || cp === 47 || cp === 58 || cp === 61 || cp === 123 || cp === 125) {
							var value = this.scanner.source[this.scanner.index++];
							return {
								type: 7 /* Punctuator */
								, value: value,
								lineNumber: this.scanner.lineNumber,
								lineStart: this.scanner.lineStart,
								start: this.scanner.index - 1,
								end: this.scanner.index
							};
						}
						// " '
						if (cp === 34 || cp === 39) {
							var start = this.scanner.index;
							var quote = this.scanner.source[this.scanner.index++];
							var str = '';
							while (!this.scanner.eof()) {
								var ch = this.scanner.source[this.scanner.index++];
								if (ch === quote) {
									break;
								} else if (ch === '&') {
									str += this.scanXHTMLEntity(quote);
								} else {
									str += ch;
								}
							}
							return {
								type: 8 /* StringLiteral */
								, value: str,
								lineNumber: this.scanner.lineNumber,
								lineStart: this.scanner.lineStart,
								start: start,
								end: this.scanner.index
							};
						}
						// ... or .
						if (cp === 46) {
							var n1 = this.scanner.source.charCodeAt(this.scanner.index + 1);
							var n2 = this.scanner.source.charCodeAt(this.scanner.index + 2);
							var value = n1 === 46 && n2 === 46 ? '...' : '.';
							var start = this.scanner.index;
							this.scanner.index += value.length;
							return {
								type: 7 /* Punctuator */
								, value: value,
								lineNumber: this.scanner.lineNumber,
								lineStart: this.scanner.lineStart,
								start: start,
								end: this.scanner.index
							};
						}
						// `
						if (cp === 96) {
							// Only placeholder, since it will be rescanned as a real assignment expression.
							return {
								type: 10 /* Template */
								, value: '',
								lineNumber: this.scanner.lineNumber,
								lineStart: this.scanner.lineStart,
								start: this.scanner.index,
								end: this.scanner.index
							};
						}
						// Identifer can not contain backslash (char code 92).
						if (character_1.Character.isIdentifierStart(cp) && cp !== 92) {
							var start = this.scanner.index;
							++this.scanner.index;
							while (!this.scanner.eof()) {
								var ch = this.scanner.source.charCodeAt(this.scanner.index);
								if (character_1.Character.isIdentifierPart(ch) && ch !== 92) {
									++this.scanner.index;
								} else if (ch === 45) {
									// Hyphen (char code 45) can be part of an identifier.
									++this.scanner.index;
								} else {
									break;
								}
							}
							var id = this.scanner.source.slice(start, this.scanner.index);
							return {
								type: 100 /* Identifier */
								, value: id,
								lineNumber: this.scanner.lineNumber,
								lineStart: this.scanner.lineStart,
								start: start,
								end: this.scanner.index
							};
						}
						return this.scanner.lex();
					};
					JSXParser.prototype.nextJSXToken = function () {
						this.collectComments();
						this.startMarker.index = this.scanner.index;
						this.startMarker.line = this.scanner.lineNumber;
						this.startMarker.column = this.scanner.index - this.scanner.lineStart;
						var token = this.lexJSX();
						this.lastMarker.index = this.scanner.index;
						this.lastMarker.line = this.scanner.lineNumber;
						this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
						if (this.config.tokens) {
							this.tokens.push(this.convertToken(token));
						}
						return token;
					};
					JSXParser.prototype.nextJSXText = function () {
						this.startMarker.index = this.scanner.index;
						this.startMarker.line = this.scanner.lineNumber;
						this.startMarker.column = this.scanner.index - this.scanner.lineStart;
						var start = this.scanner.index;
						var text = '';
						while (!this.scanner.eof()) {
							var ch = this.scanner.source[this.scanner.index];
							if (ch === '{' || ch === '<') {
								break;
							}
							++this.scanner.index;
							text += ch;
							if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
								++this.scanner.lineNumber;
								if (ch === '\r' && this.scanner.source[this.scanner.index] === '\n') {
									++this.scanner.index;
								}
								this.scanner.lineStart = this.scanner.index;
							}
						}
						this.lastMarker.index = this.scanner.index;
						this.lastMarker.line = this.scanner.lineNumber;
						this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
						var token = {
							type: 101 /* Text */
							, value: text,
							lineNumber: this.scanner.lineNumber,
							lineStart: this.scanner.lineStart,
							start: start,
							end: this.scanner.index
						};
						if (text.length > 0 && this.config.tokens) {
							this.tokens.push(this.convertToken(token));
						}
						return token;
					};
					JSXParser.prototype.peekJSXToken = function () {
						var state = this.scanner.saveState();
						this.scanner.scanComments();
						var next = this.lexJSX();
						this.scanner.restoreState(state);
						return next;
					};
					// Expect the next JSX token to match the specified punctuator.
					// If not, an exception will be thrown.
					JSXParser.prototype.expectJSX = function (value) {
						var token = this.nextJSXToken();
						if (token.type !== 7 /* Punctuator */ || token.value !== value) {
							this.throwUnexpectedToken(token);
						}
					};
					// Return true if the next JSX token matches the specified punctuator.
					JSXParser.prototype.matchJSX = function (value) {
						var next = this.peekJSXToken();
						return next.type === 7 /* Punctuator */ && next.value === value;
					};
					JSXParser.prototype.parseJSXIdentifier = function () {
						var node = this.createJSXNode();
						var token = this.nextJSXToken();
						if (token.type !== 100 /* Identifier */) {
								this.throwUnexpectedToken(token);
							}
						return this.finalize(node, new JSXNode.JSXIdentifier(token.value));
					};
					JSXParser.prototype.parseJSXElementName = function () {
						var node = this.createJSXNode();
						var elementName = this.parseJSXIdentifier();
						if (this.matchJSX(':')) {
							var namespace = elementName;
							this.expectJSX(':');
							var name_1 = this.parseJSXIdentifier();
							elementName = this.finalize(node, new JSXNode.JSXNamespacedName(namespace, name_1));
						} else if (this.matchJSX('.')) {
							while (this.matchJSX('.')) {
								var object = elementName;
								this.expectJSX('.');
								var property = this.parseJSXIdentifier();
								elementName = this.finalize(node, new JSXNode.JSXMemberExpression(object, property));
							}
						}
						return elementName;
					};
					JSXParser.prototype.parseJSXAttributeName = function () {
						var node = this.createJSXNode();
						var attributeName;
						var identifier = this.parseJSXIdentifier();
						if (this.matchJSX(':')) {
							var namespace = identifier;
							this.expectJSX(':');
							var name_2 = this.parseJSXIdentifier();
							attributeName = this.finalize(node, new JSXNode.JSXNamespacedName(namespace, name_2));
						} else {
							attributeName = identifier;
						}
						return attributeName;
					};
					JSXParser.prototype.parseJSXStringLiteralAttribute = function () {
						var node = this.createJSXNode();
						var token = this.nextJSXToken();
						if (token.type !== 8 /* StringLiteral */) {
								this.throwUnexpectedToken(token);
							}
						var raw = this.getTokenRaw(token);
						return this.finalize(node, new Node.Literal(token.value, raw));
					};
					JSXParser.prototype.parseJSXExpressionAttribute = function () {
						var node = this.createJSXNode();
						this.expectJSX('{');
						this.finishJSX();
						if (this.match('}')) {
							this.tolerateError('JSX attributes must only be assigned a non-empty expression');
						}
						var expression = this.parseAssignmentExpression();
						this.reenterJSX();
						return this.finalize(node, new JSXNode.JSXExpressionContainer(expression));
					};
					JSXParser.prototype.parseJSXAttributeValue = function () {
						return this.matchJSX('{') ? this.parseJSXExpressionAttribute() : this.matchJSX('<') ? this.parseJSXElement() : this.parseJSXStringLiteralAttribute();
					};
					JSXParser.prototype.parseJSXNameValueAttribute = function () {
						var node = this.createJSXNode();
						var name = this.parseJSXAttributeName();
						var value = null;
						if (this.matchJSX('=')) {
							this.expectJSX('=');
							value = this.parseJSXAttributeValue();
						}
						return this.finalize(node, new JSXNode.JSXAttribute(name, value));
					};
					JSXParser.prototype.parseJSXSpreadAttribute = function () {
						var node = this.createJSXNode();
						this.expectJSX('{');
						this.expectJSX('...');
						this.finishJSX();
						var argument = this.parseAssignmentExpression();
						this.reenterJSX();
						return this.finalize(node, new JSXNode.JSXSpreadAttribute(argument));
					};
					JSXParser.prototype.parseJSXAttributes = function () {
						var attributes = [];
						while (!this.matchJSX('/') && !this.matchJSX('>')) {
							var attribute = this.matchJSX('{') ? this.parseJSXSpreadAttribute() : this.parseJSXNameValueAttribute();
							attributes.push(attribute);
						}
						return attributes;
					};
					JSXParser.prototype.parseJSXOpeningElement = function () {
						var node = this.createJSXNode();
						this.expectJSX('<');
						var name = this.parseJSXElementName();
						var attributes = this.parseJSXAttributes();
						var selfClosing = this.matchJSX('/');
						if (selfClosing) {
							this.expectJSX('/');
						}
						this.expectJSX('>');
						return this.finalize(node, new JSXNode.JSXOpeningElement(name, selfClosing, attributes));
					};
					JSXParser.prototype.parseJSXBoundaryElement = function () {
						var node = this.createJSXNode();
						this.expectJSX('<');
						if (this.matchJSX('/')) {
							this.expectJSX('/');
							var name_3 = this.parseJSXElementName();
							this.expectJSX('>');
							return this.finalize(node, new JSXNode.JSXClosingElement(name_3));
						}
						var name = this.parseJSXElementName();
						var attributes = this.parseJSXAttributes();
						var selfClosing = this.matchJSX('/');
						if (selfClosing) {
							this.expectJSX('/');
						}
						this.expectJSX('>');
						return this.finalize(node, new JSXNode.JSXOpeningElement(name, selfClosing, attributes));
					};
					JSXParser.prototype.parseJSXEmptyExpression = function () {
						var node = this.createJSXChildNode();
						this.collectComments();
						this.lastMarker.index = this.scanner.index;
						this.lastMarker.line = this.scanner.lineNumber;
						this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
						return this.finalize(node, new JSXNode.JSXEmptyExpression());
					};
					JSXParser.prototype.parseJSXExpressionContainer = function () {
						var node = this.createJSXNode();
						this.expectJSX('{');
						var expression;
						if (this.matchJSX('}')) {
							expression = this.parseJSXEmptyExpression();
							this.expectJSX('}');
						} else {
							this.finishJSX();
							expression = this.parseAssignmentExpression();
							this.reenterJSX();
						}
						return this.finalize(node, new JSXNode.JSXExpressionContainer(expression));
					};
					JSXParser.prototype.parseJSXChildren = function () {
						var children = [];
						while (!this.scanner.eof()) {
							var node = this.createJSXChildNode();
							var token = this.nextJSXText();
							if (token.start < token.end) {
								var raw = this.getTokenRaw(token);
								var child = this.finalize(node, new JSXNode.JSXText(token.value, raw));
								children.push(child);
							}
							if (this.scanner.source[this.scanner.index] === '{') {
								var container = this.parseJSXExpressionContainer();
								children.push(container);
							} else {
								break;
							}
						}
						return children;
					};
					JSXParser.prototype.parseComplexJSXElement = function (el) {
						var stack = [];
						while (!this.scanner.eof()) {
							el.children = el.children.concat(this.parseJSXChildren());
							var node = this.createJSXChildNode();
							var element = this.parseJSXBoundaryElement();
							if (element.type === jsx_syntax_1.JSXSyntax.JSXOpeningElement) {
								var opening = element;
								if (opening.selfClosing) {
									var child = this.finalize(node, new JSXNode.JSXElement(opening, [], null));
									el.children.push(child);
								} else {
									stack.push(el);
									el = { node: node, opening: opening, closing: null, children: [] };
								}
							}
							if (element.type === jsx_syntax_1.JSXSyntax.JSXClosingElement) {
								el.closing = element;
								var open_1 = getQualifiedElementName(el.opening.name);
								var close_1 = getQualifiedElementName(el.closing.name);
								if (open_1 !== close_1) {
									this.tolerateError('Expected corresponding JSX closing tag for %0', open_1);
								}
								if (stack.length > 0) {
									var child = this.finalize(el.node, new JSXNode.JSXElement(el.opening, el.children, el.closing));
									el = stack[stack.length - 1];
									el.children.push(child);
									stack.pop();
								} else {
									break;
								}
							}
						}
						return el;
					};
					JSXParser.prototype.parseJSXElement = function () {
						var node = this.createJSXNode();
						var opening = this.parseJSXOpeningElement();
						var children = [];
						var closing = null;
						if (!opening.selfClosing) {
							var el = this.parseComplexJSXElement({ node: node, opening: opening, closing: closing, children: children });
							children = el.children;
							closing = el.closing;
						}
						return this.finalize(node, new JSXNode.JSXElement(opening, children, closing));
					};
					JSXParser.prototype.parseJSXRoot = function () {
						// Pop the opening '<' added from the lookahead.
						if (this.config.tokens) {
							this.tokens.pop();
						}
						this.startJSX();
						var element = this.parseJSXElement();
						this.finishJSX();
						return element;
					};
					JSXParser.prototype.isStartOfExpression = function () {
						return _super.prototype.isStartOfExpression.call(this) || this.match('<');
					};
					return JSXParser;
				}(parser_1.Parser);
				exports.JSXParser = JSXParser;
	
				/***/
			},
			/* 4 */
			/***/function (module, exports) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				// See also tools/generate-unicode-regex.js.
				var Regex = {
					// Unicode v8.0.0 NonAsciiIdentifierStart:
					NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
					// Unicode v8.0.0 NonAsciiIdentifierPart:
					NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
				};
				exports.Character = {
					/* tslint:disable:no-bitwise */
					fromCodePoint: function fromCodePoint(cp) {
						return cp < 0x10000 ? String.fromCharCode(cp) : String.fromCharCode(0xD800 + (cp - 0x10000 >> 10)) + String.fromCharCode(0xDC00 + (cp - 0x10000 & 1023));
					},
					// https://tc39.github.io/ecma262/#sec-white-space
					isWhiteSpace: function isWhiteSpace(cp) {
						return cp === 0x20 || cp === 0x09 || cp === 0x0B || cp === 0x0C || cp === 0xA0 || cp >= 0x1680 && [0x1680, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF].indexOf(cp) >= 0;
					},
					// https://tc39.github.io/ecma262/#sec-line-terminators
					isLineTerminator: function isLineTerminator(cp) {
						return cp === 0x0A || cp === 0x0D || cp === 0x2028 || cp === 0x2029;
					},
					// https://tc39.github.io/ecma262/#sec-names-and-keywords
					isIdentifierStart: function isIdentifierStart(cp) {
						return cp === 0x24 || cp === 0x5F || cp >= 0x41 && cp <= 0x5A || cp >= 0x61 && cp <= 0x7A || cp === 0x5C || cp >= 0x80 && Regex.NonAsciiIdentifierStart.test(exports.Character.fromCodePoint(cp));
					},
					isIdentifierPart: function isIdentifierPart(cp) {
						return cp === 0x24 || cp === 0x5F || cp >= 0x41 && cp <= 0x5A || cp >= 0x61 && cp <= 0x7A || cp >= 0x30 && cp <= 0x39 || cp === 0x5C || cp >= 0x80 && Regex.NonAsciiIdentifierPart.test(exports.Character.fromCodePoint(cp));
					},
					// https://tc39.github.io/ecma262/#sec-literals-numeric-literals
					isDecimalDigit: function isDecimalDigit(cp) {
						return cp >= 0x30 && cp <= 0x39; // 0..9
					},
					isHexDigit: function isHexDigit(cp) {
						return cp >= 0x30 && cp <= 0x39 || cp >= 0x41 && cp <= 0x46 || cp >= 0x61 && cp <= 0x66; // a..f
					},
					isOctalDigit: function isOctalDigit(cp) {
						return cp >= 0x30 && cp <= 0x37; // 0..7
					}
				};
	
				/***/
			},
			/* 5 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var jsx_syntax_1 = __webpack_require__(6);
				/* tslint:disable:max-classes-per-file */
				var JSXClosingElement = function () {
					function JSXClosingElement(name) {
						this.type = jsx_syntax_1.JSXSyntax.JSXClosingElement;
						this.name = name;
					}
					return JSXClosingElement;
				}();
				exports.JSXClosingElement = JSXClosingElement;
				var JSXElement = function () {
					function JSXElement(openingElement, children, closingElement) {
						this.type = jsx_syntax_1.JSXSyntax.JSXElement;
						this.openingElement = openingElement;
						this.children = children;
						this.closingElement = closingElement;
					}
					return JSXElement;
				}();
				exports.JSXElement = JSXElement;
				var JSXEmptyExpression = function () {
					function JSXEmptyExpression() {
						this.type = jsx_syntax_1.JSXSyntax.JSXEmptyExpression;
					}
					return JSXEmptyExpression;
				}();
				exports.JSXEmptyExpression = JSXEmptyExpression;
				var JSXExpressionContainer = function () {
					function JSXExpressionContainer(expression) {
						this.type = jsx_syntax_1.JSXSyntax.JSXExpressionContainer;
						this.expression = expression;
					}
					return JSXExpressionContainer;
				}();
				exports.JSXExpressionContainer = JSXExpressionContainer;
				var JSXIdentifier = function () {
					function JSXIdentifier(name) {
						this.type = jsx_syntax_1.JSXSyntax.JSXIdentifier;
						this.name = name;
					}
					return JSXIdentifier;
				}();
				exports.JSXIdentifier = JSXIdentifier;
				var JSXMemberExpression = function () {
					function JSXMemberExpression(object, property) {
						this.type = jsx_syntax_1.JSXSyntax.JSXMemberExpression;
						this.object = object;
						this.property = property;
					}
					return JSXMemberExpression;
				}();
				exports.JSXMemberExpression = JSXMemberExpression;
				var JSXAttribute = function () {
					function JSXAttribute(name, value) {
						this.type = jsx_syntax_1.JSXSyntax.JSXAttribute;
						this.name = name;
						this.value = value;
					}
					return JSXAttribute;
				}();
				exports.JSXAttribute = JSXAttribute;
				var JSXNamespacedName = function () {
					function JSXNamespacedName(namespace, name) {
						this.type = jsx_syntax_1.JSXSyntax.JSXNamespacedName;
						this.namespace = namespace;
						this.name = name;
					}
					return JSXNamespacedName;
				}();
				exports.JSXNamespacedName = JSXNamespacedName;
				var JSXOpeningElement = function () {
					function JSXOpeningElement(name, selfClosing, attributes) {
						this.type = jsx_syntax_1.JSXSyntax.JSXOpeningElement;
						this.name = name;
						this.selfClosing = selfClosing;
						this.attributes = attributes;
					}
					return JSXOpeningElement;
				}();
				exports.JSXOpeningElement = JSXOpeningElement;
				var JSXSpreadAttribute = function () {
					function JSXSpreadAttribute(argument) {
						this.type = jsx_syntax_1.JSXSyntax.JSXSpreadAttribute;
						this.argument = argument;
					}
					return JSXSpreadAttribute;
				}();
				exports.JSXSpreadAttribute = JSXSpreadAttribute;
				var JSXText = function () {
					function JSXText(value, raw) {
						this.type = jsx_syntax_1.JSXSyntax.JSXText;
						this.value = value;
						this.raw = raw;
					}
					return JSXText;
				}();
				exports.JSXText = JSXText;
	
				/***/
			},
			/* 6 */
			/***/function (module, exports) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				exports.JSXSyntax = {
					JSXAttribute: 'JSXAttribute',
					JSXClosingElement: 'JSXClosingElement',
					JSXElement: 'JSXElement',
					JSXEmptyExpression: 'JSXEmptyExpression',
					JSXExpressionContainer: 'JSXExpressionContainer',
					JSXIdentifier: 'JSXIdentifier',
					JSXMemberExpression: 'JSXMemberExpression',
					JSXNamespacedName: 'JSXNamespacedName',
					JSXOpeningElement: 'JSXOpeningElement',
					JSXSpreadAttribute: 'JSXSpreadAttribute',
					JSXText: 'JSXText'
				};
	
				/***/
			},
			/* 7 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var syntax_1 = __webpack_require__(2);
				/* tslint:disable:max-classes-per-file */
				var ArrayExpression = function () {
					function ArrayExpression(elements) {
						this.type = syntax_1.Syntax.ArrayExpression;
						this.elements = elements;
					}
					return ArrayExpression;
				}();
				exports.ArrayExpression = ArrayExpression;
				var ArrayPattern = function () {
					function ArrayPattern(elements) {
						this.type = syntax_1.Syntax.ArrayPattern;
						this.elements = elements;
					}
					return ArrayPattern;
				}();
				exports.ArrayPattern = ArrayPattern;
				var ArrowFunctionExpression = function () {
					function ArrowFunctionExpression(params, body, expression) {
						this.type = syntax_1.Syntax.ArrowFunctionExpression;
						this.id = null;
						this.params = params;
						this.body = body;
						this.generator = false;
						this.expression = expression;
						this.async = false;
					}
					return ArrowFunctionExpression;
				}();
				exports.ArrowFunctionExpression = ArrowFunctionExpression;
				var AssignmentExpression = function () {
					function AssignmentExpression(operator, left, right) {
						this.type = syntax_1.Syntax.AssignmentExpression;
						this.operator = operator;
						this.left = left;
						this.right = right;
					}
					return AssignmentExpression;
				}();
				exports.AssignmentExpression = AssignmentExpression;
				var AssignmentPattern = function () {
					function AssignmentPattern(left, right) {
						this.type = syntax_1.Syntax.AssignmentPattern;
						this.left = left;
						this.right = right;
					}
					return AssignmentPattern;
				}();
				exports.AssignmentPattern = AssignmentPattern;
				var AsyncArrowFunctionExpression = function () {
					function AsyncArrowFunctionExpression(params, body, expression) {
						this.type = syntax_1.Syntax.ArrowFunctionExpression;
						this.id = null;
						this.params = params;
						this.body = body;
						this.generator = false;
						this.expression = expression;
						this.async = true;
					}
					return AsyncArrowFunctionExpression;
				}();
				exports.AsyncArrowFunctionExpression = AsyncArrowFunctionExpression;
				var AsyncFunctionDeclaration = function () {
					function AsyncFunctionDeclaration(id, params, body) {
						this.type = syntax_1.Syntax.FunctionDeclaration;
						this.id = id;
						this.params = params;
						this.body = body;
						this.generator = false;
						this.expression = false;
						this.async = true;
					}
					return AsyncFunctionDeclaration;
				}();
				exports.AsyncFunctionDeclaration = AsyncFunctionDeclaration;
				var AsyncFunctionExpression = function () {
					function AsyncFunctionExpression(id, params, body) {
						this.type = syntax_1.Syntax.FunctionExpression;
						this.id = id;
						this.params = params;
						this.body = body;
						this.generator = false;
						this.expression = false;
						this.async = true;
					}
					return AsyncFunctionExpression;
				}();
				exports.AsyncFunctionExpression = AsyncFunctionExpression;
				var AwaitExpression = function () {
					function AwaitExpression(argument) {
						this.type = syntax_1.Syntax.AwaitExpression;
						this.argument = argument;
					}
					return AwaitExpression;
				}();
				exports.AwaitExpression = AwaitExpression;
				var BinaryExpression = function () {
					function BinaryExpression(operator, left, right) {
						var logical = operator === '||' || operator === '&&';
						this.type = logical ? syntax_1.Syntax.LogicalExpression : syntax_1.Syntax.BinaryExpression;
						this.operator = operator;
						this.left = left;
						this.right = right;
					}
					return BinaryExpression;
				}();
				exports.BinaryExpression = BinaryExpression;
				var BlockStatement = function () {
					function BlockStatement(body) {
						this.type = syntax_1.Syntax.BlockStatement;
						this.body = body;
					}
					return BlockStatement;
				}();
				exports.BlockStatement = BlockStatement;
				var BreakStatement = function () {
					function BreakStatement(label) {
						this.type = syntax_1.Syntax.BreakStatement;
						this.label = label;
					}
					return BreakStatement;
				}();
				exports.BreakStatement = BreakStatement;
				var CallExpression = function () {
					function CallExpression(callee, args) {
						this.type = syntax_1.Syntax.CallExpression;
						this.callee = callee;
						this.arguments = args;
					}
					return CallExpression;
				}();
				exports.CallExpression = CallExpression;
				var CatchClause = function () {
					function CatchClause(param, body) {
						this.type = syntax_1.Syntax.CatchClause;
						this.param = param;
						this.body = body;
					}
					return CatchClause;
				}();
				exports.CatchClause = CatchClause;
				var ClassBody = function () {
					function ClassBody(body) {
						this.type = syntax_1.Syntax.ClassBody;
						this.body = body;
					}
					return ClassBody;
				}();
				exports.ClassBody = ClassBody;
				var ClassDeclaration = function () {
					function ClassDeclaration(id, superClass, body) {
						this.type = syntax_1.Syntax.ClassDeclaration;
						this.id = id;
						this.superClass = superClass;
						this.body = body;
					}
					return ClassDeclaration;
				}();
				exports.ClassDeclaration = ClassDeclaration;
				var ClassExpression = function () {
					function ClassExpression(id, superClass, body) {
						this.type = syntax_1.Syntax.ClassExpression;
						this.id = id;
						this.superClass = superClass;
						this.body = body;
					}
					return ClassExpression;
				}();
				exports.ClassExpression = ClassExpression;
				var ComputedMemberExpression = function () {
					function ComputedMemberExpression(object, property) {
						this.type = syntax_1.Syntax.MemberExpression;
						this.computed = true;
						this.object = object;
						this.property = property;
					}
					return ComputedMemberExpression;
				}();
				exports.ComputedMemberExpression = ComputedMemberExpression;
				var ConditionalExpression = function () {
					function ConditionalExpression(test, consequent, alternate) {
						this.type = syntax_1.Syntax.ConditionalExpression;
						this.test = test;
						this.consequent = consequent;
						this.alternate = alternate;
					}
					return ConditionalExpression;
				}();
				exports.ConditionalExpression = ConditionalExpression;
				var ContinueStatement = function () {
					function ContinueStatement(label) {
						this.type = syntax_1.Syntax.ContinueStatement;
						this.label = label;
					}
					return ContinueStatement;
				}();
				exports.ContinueStatement = ContinueStatement;
				var DebuggerStatement = function () {
					function DebuggerStatement() {
						this.type = syntax_1.Syntax.DebuggerStatement;
					}
					return DebuggerStatement;
				}();
				exports.DebuggerStatement = DebuggerStatement;
				var Directive = function () {
					function Directive(expression, directive) {
						this.type = syntax_1.Syntax.ExpressionStatement;
						this.expression = expression;
						this.directive = directive;
					}
					return Directive;
				}();
				exports.Directive = Directive;
				var DoWhileStatement = function () {
					function DoWhileStatement(body, test) {
						this.type = syntax_1.Syntax.DoWhileStatement;
						this.body = body;
						this.test = test;
					}
					return DoWhileStatement;
				}();
				exports.DoWhileStatement = DoWhileStatement;
				var EmptyStatement = function () {
					function EmptyStatement() {
						this.type = syntax_1.Syntax.EmptyStatement;
					}
					return EmptyStatement;
				}();
				exports.EmptyStatement = EmptyStatement;
				var ExportAllDeclaration = function () {
					function ExportAllDeclaration(source) {
						this.type = syntax_1.Syntax.ExportAllDeclaration;
						this.source = source;
					}
					return ExportAllDeclaration;
				}();
				exports.ExportAllDeclaration = ExportAllDeclaration;
				var ExportDefaultDeclaration = function () {
					function ExportDefaultDeclaration(declaration) {
						this.type = syntax_1.Syntax.ExportDefaultDeclaration;
						this.declaration = declaration;
					}
					return ExportDefaultDeclaration;
				}();
				exports.ExportDefaultDeclaration = ExportDefaultDeclaration;
				var ExportNamedDeclaration = function () {
					function ExportNamedDeclaration(declaration, specifiers, source) {
						this.type = syntax_1.Syntax.ExportNamedDeclaration;
						this.declaration = declaration;
						this.specifiers = specifiers;
						this.source = source;
					}
					return ExportNamedDeclaration;
				}();
				exports.ExportNamedDeclaration = ExportNamedDeclaration;
				var ExportSpecifier = function () {
					function ExportSpecifier(local, exported) {
						this.type = syntax_1.Syntax.ExportSpecifier;
						this.exported = exported;
						this.local = local;
					}
					return ExportSpecifier;
				}();
				exports.ExportSpecifier = ExportSpecifier;
				var ExpressionStatement = function () {
					function ExpressionStatement(expression) {
						this.type = syntax_1.Syntax.ExpressionStatement;
						this.expression = expression;
					}
					return ExpressionStatement;
				}();
				exports.ExpressionStatement = ExpressionStatement;
				var ForInStatement = function () {
					function ForInStatement(left, right, body) {
						this.type = syntax_1.Syntax.ForInStatement;
						this.left = left;
						this.right = right;
						this.body = body;
						this.each = false;
					}
					return ForInStatement;
				}();
				exports.ForInStatement = ForInStatement;
				var ForOfStatement = function () {
					function ForOfStatement(left, right, body) {
						this.type = syntax_1.Syntax.ForOfStatement;
						this.left = left;
						this.right = right;
						this.body = body;
					}
					return ForOfStatement;
				}();
				exports.ForOfStatement = ForOfStatement;
				var ForStatement = function () {
					function ForStatement(init, test, update, body) {
						this.type = syntax_1.Syntax.ForStatement;
						this.init = init;
						this.test = test;
						this.update = update;
						this.body = body;
					}
					return ForStatement;
				}();
				exports.ForStatement = ForStatement;
				var FunctionDeclaration = function () {
					function FunctionDeclaration(id, params, body, generator) {
						this.type = syntax_1.Syntax.FunctionDeclaration;
						this.id = id;
						this.params = params;
						this.body = body;
						this.generator = generator;
						this.expression = false;
						this.async = false;
					}
					return FunctionDeclaration;
				}();
				exports.FunctionDeclaration = FunctionDeclaration;
				var FunctionExpression = function () {
					function FunctionExpression(id, params, body, generator) {
						this.type = syntax_1.Syntax.FunctionExpression;
						this.id = id;
						this.params = params;
						this.body = body;
						this.generator = generator;
						this.expression = false;
						this.async = false;
					}
					return FunctionExpression;
				}();
				exports.FunctionExpression = FunctionExpression;
				var Identifier = function () {
					function Identifier(name) {
						this.type = syntax_1.Syntax.Identifier;
						this.name = name;
					}
					return Identifier;
				}();
				exports.Identifier = Identifier;
				var IfStatement = function () {
					function IfStatement(test, consequent, alternate) {
						this.type = syntax_1.Syntax.IfStatement;
						this.test = test;
						this.consequent = consequent;
						this.alternate = alternate;
					}
					return IfStatement;
				}();
				exports.IfStatement = IfStatement;
				var ImportDeclaration = function () {
					function ImportDeclaration(specifiers, source) {
						this.type = syntax_1.Syntax.ImportDeclaration;
						this.specifiers = specifiers;
						this.source = source;
					}
					return ImportDeclaration;
				}();
				exports.ImportDeclaration = ImportDeclaration;
				var ImportDefaultSpecifier = function () {
					function ImportDefaultSpecifier(local) {
						this.type = syntax_1.Syntax.ImportDefaultSpecifier;
						this.local = local;
					}
					return ImportDefaultSpecifier;
				}();
				exports.ImportDefaultSpecifier = ImportDefaultSpecifier;
				var ImportNamespaceSpecifier = function () {
					function ImportNamespaceSpecifier(local) {
						this.type = syntax_1.Syntax.ImportNamespaceSpecifier;
						this.local = local;
					}
					return ImportNamespaceSpecifier;
				}();
				exports.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
				var ImportSpecifier = function () {
					function ImportSpecifier(local, imported) {
						this.type = syntax_1.Syntax.ImportSpecifier;
						this.local = local;
						this.imported = imported;
					}
					return ImportSpecifier;
				}();
				exports.ImportSpecifier = ImportSpecifier;
				var LabeledStatement = function () {
					function LabeledStatement(label, body) {
						this.type = syntax_1.Syntax.LabeledStatement;
						this.label = label;
						this.body = body;
					}
					return LabeledStatement;
				}();
				exports.LabeledStatement = LabeledStatement;
				var Literal = function () {
					function Literal(value, raw) {
						this.type = syntax_1.Syntax.Literal;
						this.value = value;
						this.raw = raw;
					}
					return Literal;
				}();
				exports.Literal = Literal;
				var MetaProperty = function () {
					function MetaProperty(meta, property) {
						this.type = syntax_1.Syntax.MetaProperty;
						this.meta = meta;
						this.property = property;
					}
					return MetaProperty;
				}();
				exports.MetaProperty = MetaProperty;
				var MethodDefinition = function () {
					function MethodDefinition(key, computed, value, kind, isStatic) {
						this.type = syntax_1.Syntax.MethodDefinition;
						this.key = key;
						this.computed = computed;
						this.value = value;
						this.kind = kind;
						this.static = isStatic;
					}
					return MethodDefinition;
				}();
				exports.MethodDefinition = MethodDefinition;
				var Module = function () {
					function Module(body) {
						this.type = syntax_1.Syntax.Program;
						this.body = body;
						this.sourceType = 'module';
					}
					return Module;
				}();
				exports.Module = Module;
				var NewExpression = function () {
					function NewExpression(callee, args) {
						this.type = syntax_1.Syntax.NewExpression;
						this.callee = callee;
						this.arguments = args;
					}
					return NewExpression;
				}();
				exports.NewExpression = NewExpression;
				var ObjectExpression = function () {
					function ObjectExpression(properties) {
						this.type = syntax_1.Syntax.ObjectExpression;
						this.properties = properties;
					}
					return ObjectExpression;
				}();
				exports.ObjectExpression = ObjectExpression;
				var ObjectPattern = function () {
					function ObjectPattern(properties) {
						this.type = syntax_1.Syntax.ObjectPattern;
						this.properties = properties;
					}
					return ObjectPattern;
				}();
				exports.ObjectPattern = ObjectPattern;
				var Property = function () {
					function Property(kind, key, computed, value, method, shorthand) {
						this.type = syntax_1.Syntax.Property;
						this.key = key;
						this.computed = computed;
						this.value = value;
						this.kind = kind;
						this.method = method;
						this.shorthand = shorthand;
					}
					return Property;
				}();
				exports.Property = Property;
				var RegexLiteral = function () {
					function RegexLiteral(value, raw, pattern, flags) {
						this.type = syntax_1.Syntax.Literal;
						this.value = value;
						this.raw = raw;
						this.regex = { pattern: pattern, flags: flags };
					}
					return RegexLiteral;
				}();
				exports.RegexLiteral = RegexLiteral;
				var RestElement = function () {
					function RestElement(argument) {
						this.type = syntax_1.Syntax.RestElement;
						this.argument = argument;
					}
					return RestElement;
				}();
				exports.RestElement = RestElement;
				var ReturnStatement = function () {
					function ReturnStatement(argument) {
						this.type = syntax_1.Syntax.ReturnStatement;
						this.argument = argument;
					}
					return ReturnStatement;
				}();
				exports.ReturnStatement = ReturnStatement;
				var Script = function () {
					function Script(body) {
						this.type = syntax_1.Syntax.Program;
						this.body = body;
						this.sourceType = 'script';
					}
					return Script;
				}();
				exports.Script = Script;
				var SequenceExpression = function () {
					function SequenceExpression(expressions) {
						this.type = syntax_1.Syntax.SequenceExpression;
						this.expressions = expressions;
					}
					return SequenceExpression;
				}();
				exports.SequenceExpression = SequenceExpression;
				var SpreadElement = function () {
					function SpreadElement(argument) {
						this.type = syntax_1.Syntax.SpreadElement;
						this.argument = argument;
					}
					return SpreadElement;
				}();
				exports.SpreadElement = SpreadElement;
				var StaticMemberExpression = function () {
					function StaticMemberExpression(object, property) {
						this.type = syntax_1.Syntax.MemberExpression;
						this.computed = false;
						this.object = object;
						this.property = property;
					}
					return StaticMemberExpression;
				}();
				exports.StaticMemberExpression = StaticMemberExpression;
				var Super = function () {
					function Super() {
						this.type = syntax_1.Syntax.Super;
					}
					return Super;
				}();
				exports.Super = Super;
				var SwitchCase = function () {
					function SwitchCase(test, consequent) {
						this.type = syntax_1.Syntax.SwitchCase;
						this.test = test;
						this.consequent = consequent;
					}
					return SwitchCase;
				}();
				exports.SwitchCase = SwitchCase;
				var SwitchStatement = function () {
					function SwitchStatement(discriminant, cases) {
						this.type = syntax_1.Syntax.SwitchStatement;
						this.discriminant = discriminant;
						this.cases = cases;
					}
					return SwitchStatement;
				}();
				exports.SwitchStatement = SwitchStatement;
				var TaggedTemplateExpression = function () {
					function TaggedTemplateExpression(tag, quasi) {
						this.type = syntax_1.Syntax.TaggedTemplateExpression;
						this.tag = tag;
						this.quasi = quasi;
					}
					return TaggedTemplateExpression;
				}();
				exports.TaggedTemplateExpression = TaggedTemplateExpression;
				var TemplateElement = function () {
					function TemplateElement(value, tail) {
						this.type = syntax_1.Syntax.TemplateElement;
						this.value = value;
						this.tail = tail;
					}
					return TemplateElement;
				}();
				exports.TemplateElement = TemplateElement;
				var TemplateLiteral = function () {
					function TemplateLiteral(quasis, expressions) {
						this.type = syntax_1.Syntax.TemplateLiteral;
						this.quasis = quasis;
						this.expressions = expressions;
					}
					return TemplateLiteral;
				}();
				exports.TemplateLiteral = TemplateLiteral;
				var ThisExpression = function () {
					function ThisExpression() {
						this.type = syntax_1.Syntax.ThisExpression;
					}
					return ThisExpression;
				}();
				exports.ThisExpression = ThisExpression;
				var ThrowStatement = function () {
					function ThrowStatement(argument) {
						this.type = syntax_1.Syntax.ThrowStatement;
						this.argument = argument;
					}
					return ThrowStatement;
				}();
				exports.ThrowStatement = ThrowStatement;
				var TryStatement = function () {
					function TryStatement(block, handler, finalizer) {
						this.type = syntax_1.Syntax.TryStatement;
						this.block = block;
						this.handler = handler;
						this.finalizer = finalizer;
					}
					return TryStatement;
				}();
				exports.TryStatement = TryStatement;
				var UnaryExpression = function () {
					function UnaryExpression(operator, argument) {
						this.type = syntax_1.Syntax.UnaryExpression;
						this.operator = operator;
						this.argument = argument;
						this.prefix = true;
					}
					return UnaryExpression;
				}();
				exports.UnaryExpression = UnaryExpression;
				var UpdateExpression = function () {
					function UpdateExpression(operator, argument, prefix) {
						this.type = syntax_1.Syntax.UpdateExpression;
						this.operator = operator;
						this.argument = argument;
						this.prefix = prefix;
					}
					return UpdateExpression;
				}();
				exports.UpdateExpression = UpdateExpression;
				var VariableDeclaration = function () {
					function VariableDeclaration(declarations, kind) {
						this.type = syntax_1.Syntax.VariableDeclaration;
						this.declarations = declarations;
						this.kind = kind;
					}
					return VariableDeclaration;
				}();
				exports.VariableDeclaration = VariableDeclaration;
				var VariableDeclarator = function () {
					function VariableDeclarator(id, init) {
						this.type = syntax_1.Syntax.VariableDeclarator;
						this.id = id;
						this.init = init;
					}
					return VariableDeclarator;
				}();
				exports.VariableDeclarator = VariableDeclarator;
				var WhileStatement = function () {
					function WhileStatement(test, body) {
						this.type = syntax_1.Syntax.WhileStatement;
						this.test = test;
						this.body = body;
					}
					return WhileStatement;
				}();
				exports.WhileStatement = WhileStatement;
				var WithStatement = function () {
					function WithStatement(object, body) {
						this.type = syntax_1.Syntax.WithStatement;
						this.object = object;
						this.body = body;
					}
					return WithStatement;
				}();
				exports.WithStatement = WithStatement;
				var YieldExpression = function () {
					function YieldExpression(argument, delegate) {
						this.type = syntax_1.Syntax.YieldExpression;
						this.argument = argument;
						this.delegate = delegate;
					}
					return YieldExpression;
				}();
				exports.YieldExpression = YieldExpression;
	
				/***/
			},
			/* 8 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var assert_1 = __webpack_require__(9);
				var error_handler_1 = __webpack_require__(10);
				var messages_1 = __webpack_require__(11);
				var Node = __webpack_require__(7);
				var scanner_1 = __webpack_require__(12);
				var syntax_1 = __webpack_require__(2);
				var token_1 = __webpack_require__(13);
				var ArrowParameterPlaceHolder = 'ArrowParameterPlaceHolder';
				var Parser = function () {
					function Parser(code, options, delegate) {
						if (options === void 0) {
							options = {};
						}
						this.config = {
							range: typeof options.range === 'boolean' && options.range,
							loc: typeof options.loc === 'boolean' && options.loc,
							source: null,
							tokens: typeof options.tokens === 'boolean' && options.tokens,
							comment: typeof options.comment === 'boolean' && options.comment,
							tolerant: typeof options.tolerant === 'boolean' && options.tolerant
						};
						if (this.config.loc && options.source && options.source !== null) {
							this.config.source = String(options.source);
						}
						this.delegate = delegate;
						this.errorHandler = new error_handler_1.ErrorHandler();
						this.errorHandler.tolerant = this.config.tolerant;
						this.scanner = new scanner_1.Scanner(code, this.errorHandler);
						this.scanner.trackComment = this.config.comment;
						this.operatorPrecedence = {
							')': 0,
							';': 0,
							',': 0,
							'=': 0,
							']': 0,
							'||': 1,
							'&&': 2,
							'|': 3,
							'^': 4,
							'&': 5,
							'==': 6,
							'!=': 6,
							'===': 6,
							'!==': 6,
							'<': 7,
							'>': 7,
							'<=': 7,
							'>=': 7,
							'<<': 8,
							'>>': 8,
							'>>>': 8,
							'+': 9,
							'-': 9,
							'*': 11,
							'/': 11,
							'%': 11
						};
						this.lookahead = {
							type: 2 /* EOF */
							, value: '',
							lineNumber: this.scanner.lineNumber,
							lineStart: 0,
							start: 0,
							end: 0
						};
						this.hasLineTerminator = false;
						this.context = {
							isModule: false,
							await: false,
							allowIn: true,
							allowStrictDirective: true,
							allowYield: true,
							firstCoverInitializedNameError: null,
							isAssignmentTarget: false,
							isBindingElement: false,
							inFunctionBody: false,
							inIteration: false,
							inSwitch: false,
							labelSet: {},
							strict: false
						};
						this.tokens = [];
						this.startMarker = {
							index: 0,
							line: this.scanner.lineNumber,
							column: 0
						};
						this.lastMarker = {
							index: 0,
							line: this.scanner.lineNumber,
							column: 0
						};
						this.nextToken();
						this.lastMarker = {
							index: this.scanner.index,
							line: this.scanner.lineNumber,
							column: this.scanner.index - this.scanner.lineStart
						};
					}
					Parser.prototype.throwError = function (messageFormat) {
						var values = [];
						for (var _i = 1; _i < arguments.length; _i++) {
							values[_i - 1] = arguments[_i];
						}
						var args = Array.prototype.slice.call(arguments, 1);
						var msg = messageFormat.replace(/%(\d)/g, function (whole, idx) {
							assert_1.assert(idx < args.length, 'Message reference must be in range');
							return args[idx];
						});
						var index = this.lastMarker.index;
						var line = this.lastMarker.line;
						var column = this.lastMarker.column + 1;
						throw this.errorHandler.createError(index, line, column, msg);
					};
					Parser.prototype.tolerateError = function (messageFormat) {
						var values = [];
						for (var _i = 1; _i < arguments.length; _i++) {
							values[_i - 1] = arguments[_i];
						}
						var args = Array.prototype.slice.call(arguments, 1);
						var msg = messageFormat.replace(/%(\d)/g, function (whole, idx) {
							assert_1.assert(idx < args.length, 'Message reference must be in range');
							return args[idx];
						});
						var index = this.lastMarker.index;
						var line = this.scanner.lineNumber;
						var column = this.lastMarker.column + 1;
						this.errorHandler.tolerateError(index, line, column, msg);
					};
					// Throw an exception because of the token.
					Parser.prototype.unexpectedTokenError = function (token, message) {
						var msg = message || messages_1.Messages.UnexpectedToken;
						var value;
						if (token) {
							if (!message) {
								msg = token.type === 2 /* EOF */ ? messages_1.Messages.UnexpectedEOS : token.type === 3 /* Identifier */ ? messages_1.Messages.UnexpectedIdentifier : token.type === 6 /* NumericLiteral */ ? messages_1.Messages.UnexpectedNumber : token.type === 8 /* StringLiteral */ ? messages_1.Messages.UnexpectedString : token.type === 10 /* Template */ ? messages_1.Messages.UnexpectedTemplate : messages_1.Messages.UnexpectedToken;
								if (token.type === 4 /* Keyword */) {
										if (this.scanner.isFutureReservedWord(token.value)) {
											msg = messages_1.Messages.UnexpectedReserved;
										} else if (this.context.strict && this.scanner.isStrictModeReservedWord(token.value)) {
											msg = messages_1.Messages.StrictReservedWord;
										}
									}
							}
							value = token.value;
						} else {
							value = 'ILLEGAL';
						}
						msg = msg.replace('%0', value);
						if (token && typeof token.lineNumber === 'number') {
							var index = token.start;
							var line = token.lineNumber;
							var lastMarkerLineStart = this.lastMarker.index - this.lastMarker.column;
							var column = token.start - lastMarkerLineStart + 1;
							return this.errorHandler.createError(index, line, column, msg);
						} else {
							var index = this.lastMarker.index;
							var line = this.lastMarker.line;
							var column = this.lastMarker.column + 1;
							return this.errorHandler.createError(index, line, column, msg);
						}
					};
					Parser.prototype.throwUnexpectedToken = function (token, message) {
						throw this.unexpectedTokenError(token, message);
					};
					Parser.prototype.tolerateUnexpectedToken = function (token, message) {
						this.errorHandler.tolerate(this.unexpectedTokenError(token, message));
					};
					Parser.prototype.collectComments = function () {
						if (!this.config.comment) {
							this.scanner.scanComments();
						} else {
							var comments = this.scanner.scanComments();
							if (comments.length > 0 && this.delegate) {
								for (var i = 0; i < comments.length; ++i) {
									var e = comments[i];
									var node = void 0;
									node = {
										type: e.multiLine ? 'BlockComment' : 'LineComment',
										value: this.scanner.source.slice(e.slice[0], e.slice[1])
									};
									if (this.config.range) {
										node.range = e.range;
									}
									if (this.config.loc) {
										node.loc = e.loc;
									}
									var metadata = {
										start: {
											line: e.loc.start.line,
											column: e.loc.start.column,
											offset: e.range[0]
										},
										end: {
											line: e.loc.end.line,
											column: e.loc.end.column,
											offset: e.range[1]
										}
									};
									this.delegate(node, metadata);
								}
							}
						}
					};
					// From internal representation to an external structure
					Parser.prototype.getTokenRaw = function (token) {
						return this.scanner.source.slice(token.start, token.end);
					};
					Parser.prototype.convertToken = function (token) {
						var t = {
							type: token_1.TokenName[token.type],
							value: this.getTokenRaw(token)
						};
						if (this.config.range) {
							t.range = [token.start, token.end];
						}
						if (this.config.loc) {
							t.loc = {
								start: {
									line: this.startMarker.line,
									column: this.startMarker.column
								},
								end: {
									line: this.scanner.lineNumber,
									column: this.scanner.index - this.scanner.lineStart
								}
							};
						}
						if (token.type === 9 /* RegularExpression */) {
								var pattern = token.pattern;
								var flags = token.flags;
								t.regex = { pattern: pattern, flags: flags };
							}
						return t;
					};
					Parser.prototype.nextToken = function () {
						var token = this.lookahead;
						this.lastMarker.index = this.scanner.index;
						this.lastMarker.line = this.scanner.lineNumber;
						this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
						this.collectComments();
						if (this.scanner.index !== this.startMarker.index) {
							this.startMarker.index = this.scanner.index;
							this.startMarker.line = this.scanner.lineNumber;
							this.startMarker.column = this.scanner.index - this.scanner.lineStart;
						}
						var next = this.scanner.lex();
						this.hasLineTerminator = token.lineNumber !== next.lineNumber;
						if (next && this.context.strict && next.type === 3 /* Identifier */) {
								if (this.scanner.isStrictModeReservedWord(next.value)) {
									next.type = 4 /* Keyword */;
								}
							}
						this.lookahead = next;
						if (this.config.tokens && next.type !== 2 /* EOF */) {
								this.tokens.push(this.convertToken(next));
							}
						return token;
					};
					Parser.prototype.nextRegexToken = function () {
						this.collectComments();
						var token = this.scanner.scanRegExp();
						if (this.config.tokens) {
							// Pop the previous token, '/' or '/='
							// This is added from the lookahead token.
							this.tokens.pop();
							this.tokens.push(this.convertToken(token));
						}
						// Prime the next lookahead.
						this.lookahead = token;
						this.nextToken();
						return token;
					};
					Parser.prototype.createNode = function () {
						return {
							index: this.startMarker.index,
							line: this.startMarker.line,
							column: this.startMarker.column
						};
					};
					Parser.prototype.startNode = function (token) {
						return {
							index: token.start,
							line: token.lineNumber,
							column: token.start - token.lineStart
						};
					};
					Parser.prototype.finalize = function (marker, node) {
						if (this.config.range) {
							node.range = [marker.index, this.lastMarker.index];
						}
						if (this.config.loc) {
							node.loc = {
								start: {
									line: marker.line,
									column: marker.column
								},
								end: {
									line: this.lastMarker.line,
									column: this.lastMarker.column
								}
							};
							if (this.config.source) {
								node.loc.source = this.config.source;
							}
						}
						if (this.delegate) {
							var metadata = {
								start: {
									line: marker.line,
									column: marker.column,
									offset: marker.index
								},
								end: {
									line: this.lastMarker.line,
									column: this.lastMarker.column,
									offset: this.lastMarker.index
								}
							};
							this.delegate(node, metadata);
						}
						return node;
					};
					// Expect the next token to match the specified punctuator.
					// If not, an exception will be thrown.
					Parser.prototype.expect = function (value) {
						var token = this.nextToken();
						if (token.type !== 7 /* Punctuator */ || token.value !== value) {
							this.throwUnexpectedToken(token);
						}
					};
					// Quietly expect a comma when in tolerant mode, otherwise delegates to expect().
					Parser.prototype.expectCommaSeparator = function () {
						if (this.config.tolerant) {
							var token = this.lookahead;
							if (token.type === 7 /* Punctuator */ && token.value === ',') {
								this.nextToken();
							} else if (token.type === 7 /* Punctuator */ && token.value === ';') {
								this.nextToken();
								this.tolerateUnexpectedToken(token);
							} else {
								this.tolerateUnexpectedToken(token, messages_1.Messages.UnexpectedToken);
							}
						} else {
							this.expect(',');
						}
					};
					// Expect the next token to match the specified keyword.
					// If not, an exception will be thrown.
					Parser.prototype.expectKeyword = function (keyword) {
						var token = this.nextToken();
						if (token.type !== 4 /* Keyword */ || token.value !== keyword) {
							this.throwUnexpectedToken(token);
						}
					};
					// Return true if the next token matches the specified punctuator.
					Parser.prototype.match = function (value) {
						return this.lookahead.type === 7 /* Punctuator */ && this.lookahead.value === value;
					};
					// Return true if the next token matches the specified keyword
					Parser.prototype.matchKeyword = function (keyword) {
						return this.lookahead.type === 4 /* Keyword */ && this.lookahead.value === keyword;
					};
					// Return true if the next token matches the specified contextual keyword
					// (where an identifier is sometimes a keyword depending on the context)
					Parser.prototype.matchContextualKeyword = function (keyword) {
						return this.lookahead.type === 3 /* Identifier */ && this.lookahead.value === keyword;
					};
					// Return true if the next token is an assignment operator
					Parser.prototype.matchAssign = function () {
						if (this.lookahead.type !== 7 /* Punctuator */) {
								return false;
							}
						var op = this.lookahead.value;
						return op === '=' || op === '*=' || op === '**=' || op === '/=' || op === '%=' || op === '+=' || op === '-=' || op === '<<=' || op === '>>=' || op === '>>>=' || op === '&=' || op === '^=' || op === '|=';
					};
					// Cover grammar support.
					//
					// When an assignment expression position starts with an left parenthesis, the determination of the type
					// of the syntax is to be deferred arbitrarily long until the end of the parentheses pair (plus a lookahead)
					// or the first comma. This situation also defers the determination of all the expressions nested in the pair.
					//
					// There are three productions that can be parsed in a parentheses pair that needs to be determined
					// after the outermost pair is closed. They are:
					//
					//   1. AssignmentExpression
					//   2. BindingElements
					//   3. AssignmentTargets
					//
					// In order to avoid exponential backtracking, we use two flags to denote if the production can be
					// binding element or assignment target.
					//
					// The three productions have the relationship:
					//
					//   BindingElements ⊆ AssignmentTargets ⊆ AssignmentExpression
					//
					// with a single exception that CoverInitializedName when used directly in an Expression, generates
					// an early error. Therefore, we need the third state, firstCoverInitializedNameError, to track the
					// first usage of CoverInitializedName and report it when we reached the end of the parentheses pair.
					//
					// isolateCoverGrammar function runs the given parser function with a new cover grammar context, and it does not
					// effect the current flags. This means the production the parser parses is only used as an expression. Therefore
					// the CoverInitializedName check is conducted.
					//
					// inheritCoverGrammar function runs the given parse function with a new cover grammar context, and it propagates
					// the flags outside of the parser. This means the production the parser parses is used as a part of a potential
					// pattern. The CoverInitializedName check is deferred.
					Parser.prototype.isolateCoverGrammar = function (parseFunction) {
						var previousIsBindingElement = this.context.isBindingElement;
						var previousIsAssignmentTarget = this.context.isAssignmentTarget;
						var previousFirstCoverInitializedNameError = this.context.firstCoverInitializedNameError;
						this.context.isBindingElement = true;
						this.context.isAssignmentTarget = true;
						this.context.firstCoverInitializedNameError = null;
						var result = parseFunction.call(this);
						if (this.context.firstCoverInitializedNameError !== null) {
							this.throwUnexpectedToken(this.context.firstCoverInitializedNameError);
						}
						this.context.isBindingElement = previousIsBindingElement;
						this.context.isAssignmentTarget = previousIsAssignmentTarget;
						this.context.firstCoverInitializedNameError = previousFirstCoverInitializedNameError;
						return result;
					};
					Parser.prototype.inheritCoverGrammar = function (parseFunction) {
						var previousIsBindingElement = this.context.isBindingElement;
						var previousIsAssignmentTarget = this.context.isAssignmentTarget;
						var previousFirstCoverInitializedNameError = this.context.firstCoverInitializedNameError;
						this.context.isBindingElement = true;
						this.context.isAssignmentTarget = true;
						this.context.firstCoverInitializedNameError = null;
						var result = parseFunction.call(this);
						this.context.isBindingElement = this.context.isBindingElement && previousIsBindingElement;
						this.context.isAssignmentTarget = this.context.isAssignmentTarget && previousIsAssignmentTarget;
						this.context.firstCoverInitializedNameError = previousFirstCoverInitializedNameError || this.context.firstCoverInitializedNameError;
						return result;
					};
					Parser.prototype.consumeSemicolon = function () {
						if (this.match(';')) {
							this.nextToken();
						} else if (!this.hasLineTerminator) {
							if (this.lookahead.type !== 2 /* EOF */ && !this.match('}')) {
								this.throwUnexpectedToken(this.lookahead);
							}
							this.lastMarker.index = this.startMarker.index;
							this.lastMarker.line = this.startMarker.line;
							this.lastMarker.column = this.startMarker.column;
						}
					};
					// https://tc39.github.io/ecma262/#sec-primary-expression
					Parser.prototype.parsePrimaryExpression = function () {
						var node = this.createNode();
						var expr;
						var token, raw;
						switch (this.lookahead.type) {
							case 3 /* Identifier */:
								if ((this.context.isModule || this.context.await) && this.lookahead.value === 'await') {
									this.tolerateUnexpectedToken(this.lookahead);
								}
								expr = this.matchAsyncFunction() ? this.parseFunctionExpression() : this.finalize(node, new Node.Identifier(this.nextToken().value));
								break;
							case 6 /* NumericLiteral */:
							case 8 /* StringLiteral */:
								if (this.context.strict && this.lookahead.octal) {
									this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.StrictOctalLiteral);
								}
								this.context.isAssignmentTarget = false;
								this.context.isBindingElement = false;
								token = this.nextToken();
								raw = this.getTokenRaw(token);
								expr = this.finalize(node, new Node.Literal(token.value, raw));
								break;
							case 1 /* BooleanLiteral */:
								this.context.isAssignmentTarget = false;
								this.context.isBindingElement = false;
								token = this.nextToken();
								raw = this.getTokenRaw(token);
								expr = this.finalize(node, new Node.Literal(token.value === 'true', raw));
								break;
							case 5 /* NullLiteral */:
								this.context.isAssignmentTarget = false;
								this.context.isBindingElement = false;
								token = this.nextToken();
								raw = this.getTokenRaw(token);
								expr = this.finalize(node, new Node.Literal(null, raw));
								break;
							case 10 /* Template */:
								expr = this.parseTemplateLiteral();
								break;
							case 7 /* Punctuator */:
								switch (this.lookahead.value) {
									case '(':
										this.context.isBindingElement = false;
										expr = this.inheritCoverGrammar(this.parseGroupExpression);
										break;
									case '[':
										expr = this.inheritCoverGrammar(this.parseArrayInitializer);
										break;
									case '{':
										expr = this.inheritCoverGrammar(this.parseObjectInitializer);
										break;
									case '/':
									case '/=':
										this.context.isAssignmentTarget = false;
										this.context.isBindingElement = false;
										this.scanner.index = this.startMarker.index;
										token = this.nextRegexToken();
										raw = this.getTokenRaw(token);
										expr = this.finalize(node, new Node.RegexLiteral(token.regex, raw, token.pattern, token.flags));
										break;
									default:
										expr = this.throwUnexpectedToken(this.nextToken());
								}
								break;
							case 4 /* Keyword */:
								if (!this.context.strict && this.context.allowYield && this.matchKeyword('yield')) {
									expr = this.parseIdentifierName();
								} else if (!this.context.strict && this.matchKeyword('let')) {
									expr = this.finalize(node, new Node.Identifier(this.nextToken().value));
								} else {
									this.context.isAssignmentTarget = false;
									this.context.isBindingElement = false;
									if (this.matchKeyword('function')) {
										expr = this.parseFunctionExpression();
									} else if (this.matchKeyword('this')) {
										this.nextToken();
										expr = this.finalize(node, new Node.ThisExpression());
									} else if (this.matchKeyword('class')) {
										expr = this.parseClassExpression();
									} else {
										expr = this.throwUnexpectedToken(this.nextToken());
									}
								}
								break;
							default:
								expr = this.throwUnexpectedToken(this.nextToken());
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-array-initializer
					Parser.prototype.parseSpreadElement = function () {
						var node = this.createNode();
						this.expect('...');
						var arg = this.inheritCoverGrammar(this.parseAssignmentExpression);
						return this.finalize(node, new Node.SpreadElement(arg));
					};
					Parser.prototype.parseArrayInitializer = function () {
						var node = this.createNode();
						var elements = [];
						this.expect('[');
						while (!this.match(']')) {
							if (this.match(',')) {
								this.nextToken();
								elements.push(null);
							} else if (this.match('...')) {
								var element = this.parseSpreadElement();
								if (!this.match(']')) {
									this.context.isAssignmentTarget = false;
									this.context.isBindingElement = false;
									this.expect(',');
								}
								elements.push(element);
							} else {
								elements.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
								if (!this.match(']')) {
									this.expect(',');
								}
							}
						}
						this.expect(']');
						return this.finalize(node, new Node.ArrayExpression(elements));
					};
					// https://tc39.github.io/ecma262/#sec-object-initializer
					Parser.prototype.parsePropertyMethod = function (params) {
						this.context.isAssignmentTarget = false;
						this.context.isBindingElement = false;
						var previousStrict = this.context.strict;
						var previousAllowStrictDirective = this.context.allowStrictDirective;
						this.context.allowStrictDirective = params.simple;
						var body = this.isolateCoverGrammar(this.parseFunctionSourceElements);
						if (this.context.strict && params.firstRestricted) {
							this.tolerateUnexpectedToken(params.firstRestricted, params.message);
						}
						if (this.context.strict && params.stricted) {
							this.tolerateUnexpectedToken(params.stricted, params.message);
						}
						this.context.strict = previousStrict;
						this.context.allowStrictDirective = previousAllowStrictDirective;
						return body;
					};
					Parser.prototype.parsePropertyMethodFunction = function () {
						var isGenerator = false;
						var node = this.createNode();
						var previousAllowYield = this.context.allowYield;
						this.context.allowYield = false;
						var params = this.parseFormalParameters();
						var method = this.parsePropertyMethod(params);
						this.context.allowYield = previousAllowYield;
						return this.finalize(node, new Node.FunctionExpression(null, params.params, method, isGenerator));
					};
					Parser.prototype.parsePropertyMethodAsyncFunction = function () {
						var node = this.createNode();
						var previousAllowYield = this.context.allowYield;
						var previousAwait = this.context.await;
						this.context.allowYield = false;
						this.context.await = true;
						var params = this.parseFormalParameters();
						var method = this.parsePropertyMethod(params);
						this.context.allowYield = previousAllowYield;
						this.context.await = previousAwait;
						return this.finalize(node, new Node.AsyncFunctionExpression(null, params.params, method));
					};
					Parser.prototype.parseObjectPropertyKey = function () {
						var node = this.createNode();
						var token = this.nextToken();
						var key;
						switch (token.type) {
							case 8 /* StringLiteral */:
							case 6 /* NumericLiteral */:
								if (this.context.strict && token.octal) {
									this.tolerateUnexpectedToken(token, messages_1.Messages.StrictOctalLiteral);
								}
								var raw = this.getTokenRaw(token);
								key = this.finalize(node, new Node.Literal(token.value, raw));
								break;
							case 3 /* Identifier */:
							case 1 /* BooleanLiteral */:
							case 5 /* NullLiteral */:
							case 4 /* Keyword */:
								key = this.finalize(node, new Node.Identifier(token.value));
								break;
							case 7 /* Punctuator */:
								if (token.value === '[') {
									key = this.isolateCoverGrammar(this.parseAssignmentExpression);
									this.expect(']');
								} else {
									key = this.throwUnexpectedToken(token);
								}
								break;
							default:
								key = this.throwUnexpectedToken(token);
						}
						return key;
					};
					Parser.prototype.isPropertyKey = function (key, value) {
						return key.type === syntax_1.Syntax.Identifier && key.name === value || key.type === syntax_1.Syntax.Literal && key.value === value;
					};
					Parser.prototype.parseObjectProperty = function (hasProto) {
						var node = this.createNode();
						var token = this.lookahead;
						var kind;
						var key = null;
						var value = null;
						var computed = false;
						var method = false;
						var shorthand = false;
						var isAsync = false;
						if (token.type === 3 /* Identifier */) {
								var id = token.value;
								this.nextToken();
								computed = this.match('[');
								isAsync = !this.hasLineTerminator && id === 'async' && !this.match(':') && !this.match('(') && !this.match('*');
								key = isAsync ? this.parseObjectPropertyKey() : this.finalize(node, new Node.Identifier(id));
							} else if (this.match('*')) {
							this.nextToken();
						} else {
							computed = this.match('[');
							key = this.parseObjectPropertyKey();
						}
						var lookaheadPropertyKey = this.qualifiedPropertyName(this.lookahead);
						if (token.type === 3 /* Identifier */ && !isAsync && token.value === 'get' && lookaheadPropertyKey) {
							kind = 'get';
							computed = this.match('[');
							key = this.parseObjectPropertyKey();
							this.context.allowYield = false;
							value = this.parseGetterMethod();
						} else if (token.type === 3 /* Identifier */ && !isAsync && token.value === 'set' && lookaheadPropertyKey) {
							kind = 'set';
							computed = this.match('[');
							key = this.parseObjectPropertyKey();
							value = this.parseSetterMethod();
						} else if (token.type === 7 /* Punctuator */ && token.value === '*' && lookaheadPropertyKey) {
							kind = 'init';
							computed = this.match('[');
							key = this.parseObjectPropertyKey();
							value = this.parseGeneratorMethod();
							method = true;
						} else {
							if (!key) {
								this.throwUnexpectedToken(this.lookahead);
							}
							kind = 'init';
							if (this.match(':') && !isAsync) {
								if (!computed && this.isPropertyKey(key, '__proto__')) {
									if (hasProto.value) {
										this.tolerateError(messages_1.Messages.DuplicateProtoProperty);
									}
									hasProto.value = true;
								}
								this.nextToken();
								value = this.inheritCoverGrammar(this.parseAssignmentExpression);
							} else if (this.match('(')) {
								value = isAsync ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction();
								method = true;
							} else if (token.type === 3 /* Identifier */) {
									var id = this.finalize(node, new Node.Identifier(token.value));
									if (this.match('=')) {
										this.context.firstCoverInitializedNameError = this.lookahead;
										this.nextToken();
										shorthand = true;
										var init = this.isolateCoverGrammar(this.parseAssignmentExpression);
										value = this.finalize(node, new Node.AssignmentPattern(id, init));
									} else {
										shorthand = true;
										value = id;
									}
								} else {
								this.throwUnexpectedToken(this.nextToken());
							}
						}
						return this.finalize(node, new Node.Property(kind, key, computed, value, method, shorthand));
					};
					Parser.prototype.parseObjectInitializer = function () {
						var node = this.createNode();
						this.expect('{');
						var properties = [];
						var hasProto = { value: false };
						while (!this.match('}')) {
							properties.push(this.parseObjectProperty(hasProto));
							if (!this.match('}')) {
								this.expectCommaSeparator();
							}
						}
						this.expect('}');
						return this.finalize(node, new Node.ObjectExpression(properties));
					};
					// https://tc39.github.io/ecma262/#sec-template-literals
					Parser.prototype.parseTemplateHead = function () {
						assert_1.assert(this.lookahead.head, 'Template literal must start with a template head');
						var node = this.createNode();
						var token = this.nextToken();
						var raw = token.value;
						var cooked = token.cooked;
						return this.finalize(node, new Node.TemplateElement({ raw: raw, cooked: cooked }, token.tail));
					};
					Parser.prototype.parseTemplateElement = function () {
						if (this.lookahead.type !== 10 /* Template */) {
								this.throwUnexpectedToken();
							}
						var node = this.createNode();
						var token = this.nextToken();
						var raw = token.value;
						var cooked = token.cooked;
						return this.finalize(node, new Node.TemplateElement({ raw: raw, cooked: cooked }, token.tail));
					};
					Parser.prototype.parseTemplateLiteral = function () {
						var node = this.createNode();
						var expressions = [];
						var quasis = [];
						var quasi = this.parseTemplateHead();
						quasis.push(quasi);
						while (!quasi.tail) {
							expressions.push(this.parseExpression());
							quasi = this.parseTemplateElement();
							quasis.push(quasi);
						}
						return this.finalize(node, new Node.TemplateLiteral(quasis, expressions));
					};
					// https://tc39.github.io/ecma262/#sec-grouping-operator
					Parser.prototype.reinterpretExpressionAsPattern = function (expr) {
						switch (expr.type) {
							case syntax_1.Syntax.Identifier:
							case syntax_1.Syntax.MemberExpression:
							case syntax_1.Syntax.RestElement:
							case syntax_1.Syntax.AssignmentPattern:
								break;
							case syntax_1.Syntax.SpreadElement:
								expr.type = syntax_1.Syntax.RestElement;
								this.reinterpretExpressionAsPattern(expr.argument);
								break;
							case syntax_1.Syntax.ArrayExpression:
								expr.type = syntax_1.Syntax.ArrayPattern;
								for (var i = 0; i < expr.elements.length; i++) {
									if (expr.elements[i] !== null) {
										this.reinterpretExpressionAsPattern(expr.elements[i]);
									}
								}
								break;
							case syntax_1.Syntax.ObjectExpression:
								expr.type = syntax_1.Syntax.ObjectPattern;
								for (var i = 0; i < expr.properties.length; i++) {
									this.reinterpretExpressionAsPattern(expr.properties[i].value);
								}
								break;
							case syntax_1.Syntax.AssignmentExpression:
								expr.type = syntax_1.Syntax.AssignmentPattern;
								delete expr.operator;
								this.reinterpretExpressionAsPattern(expr.left);
								break;
							default:
								// Allow other node type for tolerant parsing.
								break;
						}
					};
					Parser.prototype.parseGroupExpression = function () {
						var expr;
						this.expect('(');
						if (this.match(')')) {
							this.nextToken();
							if (!this.match('=>')) {
								this.expect('=>');
							}
							expr = {
								type: ArrowParameterPlaceHolder,
								params: [],
								async: false
							};
						} else {
							var startToken = this.lookahead;
							var params = [];
							if (this.match('...')) {
								expr = this.parseRestElement(params);
								this.expect(')');
								if (!this.match('=>')) {
									this.expect('=>');
								}
								expr = {
									type: ArrowParameterPlaceHolder,
									params: [expr],
									async: false
								};
							} else {
								var arrow = false;
								this.context.isBindingElement = true;
								expr = this.inheritCoverGrammar(this.parseAssignmentExpression);
								if (this.match(',')) {
									var expressions = [];
									this.context.isAssignmentTarget = false;
									expressions.push(expr);
									while (this.lookahead.type !== 2 /* EOF */) {
										if (!this.match(',')) {
											break;
										}
										this.nextToken();
										if (this.match(')')) {
											this.nextToken();
											for (var i = 0; i < expressions.length; i++) {
												this.reinterpretExpressionAsPattern(expressions[i]);
											}
											arrow = true;
											expr = {
												type: ArrowParameterPlaceHolder,
												params: expressions,
												async: false
											};
										} else if (this.match('...')) {
											if (!this.context.isBindingElement) {
												this.throwUnexpectedToken(this.lookahead);
											}
											expressions.push(this.parseRestElement(params));
											this.expect(')');
											if (!this.match('=>')) {
												this.expect('=>');
											}
											this.context.isBindingElement = false;
											for (var i = 0; i < expressions.length; i++) {
												this.reinterpretExpressionAsPattern(expressions[i]);
											}
											arrow = true;
											expr = {
												type: ArrowParameterPlaceHolder,
												params: expressions,
												async: false
											};
										} else {
											expressions.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
										}
										if (arrow) {
											break;
										}
									}
									if (!arrow) {
										expr = this.finalize(this.startNode(startToken), new Node.SequenceExpression(expressions));
									}
								}
								if (!arrow) {
									this.expect(')');
									if (this.match('=>')) {
										if (expr.type === syntax_1.Syntax.Identifier && expr.name === 'yield') {
											arrow = true;
											expr = {
												type: ArrowParameterPlaceHolder,
												params: [expr],
												async: false
											};
										}
										if (!arrow) {
											if (!this.context.isBindingElement) {
												this.throwUnexpectedToken(this.lookahead);
											}
											if (expr.type === syntax_1.Syntax.SequenceExpression) {
												for (var i = 0; i < expr.expressions.length; i++) {
													this.reinterpretExpressionAsPattern(expr.expressions[i]);
												}
											} else {
												this.reinterpretExpressionAsPattern(expr);
											}
											var parameters = expr.type === syntax_1.Syntax.SequenceExpression ? expr.expressions : [expr];
											expr = {
												type: ArrowParameterPlaceHolder,
												params: parameters,
												async: false
											};
										}
									}
									this.context.isBindingElement = false;
								}
							}
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-left-hand-side-expressions
					Parser.prototype.parseArguments = function () {
						this.expect('(');
						var args = [];
						if (!this.match(')')) {
							while (true) {
								var expr = this.match('...') ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAssignmentExpression);
								args.push(expr);
								if (this.match(')')) {
									break;
								}
								this.expectCommaSeparator();
								if (this.match(')')) {
									break;
								}
							}
						}
						this.expect(')');
						return args;
					};
					Parser.prototype.isIdentifierName = function (token) {
						return token.type === 3 /* Identifier */ || token.type === 4 /* Keyword */ || token.type === 1 /* BooleanLiteral */ || token.type === 5 /* NullLiteral */;
					};
					Parser.prototype.parseIdentifierName = function () {
						var node = this.createNode();
						var token = this.nextToken();
						if (!this.isIdentifierName(token)) {
							this.throwUnexpectedToken(token);
						}
						return this.finalize(node, new Node.Identifier(token.value));
					};
					Parser.prototype.parseNewExpression = function () {
						var node = this.createNode();
						var id = this.parseIdentifierName();
						assert_1.assert(id.name === 'new', 'New expression must start with `new`');
						var expr;
						if (this.match('.')) {
							this.nextToken();
							if (this.lookahead.type === 3 /* Identifier */ && this.context.inFunctionBody && this.lookahead.value === 'target') {
								var property = this.parseIdentifierName();
								expr = new Node.MetaProperty(id, property);
							} else {
								this.throwUnexpectedToken(this.lookahead);
							}
						} else {
							var callee = this.isolateCoverGrammar(this.parseLeftHandSideExpression);
							var args = this.match('(') ? this.parseArguments() : [];
							expr = new Node.NewExpression(callee, args);
							this.context.isAssignmentTarget = false;
							this.context.isBindingElement = false;
						}
						return this.finalize(node, expr);
					};
					Parser.prototype.parseAsyncArgument = function () {
						var arg = this.parseAssignmentExpression();
						this.context.firstCoverInitializedNameError = null;
						return arg;
					};
					Parser.prototype.parseAsyncArguments = function () {
						this.expect('(');
						var args = [];
						if (!this.match(')')) {
							while (true) {
								var expr = this.match('...') ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAsyncArgument);
								args.push(expr);
								if (this.match(')')) {
									break;
								}
								this.expectCommaSeparator();
								if (this.match(')')) {
									break;
								}
							}
						}
						this.expect(')');
						return args;
					};
					Parser.prototype.parseLeftHandSideExpressionAllowCall = function () {
						var startToken = this.lookahead;
						var maybeAsync = this.matchContextualKeyword('async');
						var previousAllowIn = this.context.allowIn;
						this.context.allowIn = true;
						var expr;
						if (this.matchKeyword('super') && this.context.inFunctionBody) {
							expr = this.createNode();
							this.nextToken();
							expr = this.finalize(expr, new Node.Super());
							if (!this.match('(') && !this.match('.') && !this.match('[')) {
								this.throwUnexpectedToken(this.lookahead);
							}
						} else {
							expr = this.inheritCoverGrammar(this.matchKeyword('new') ? this.parseNewExpression : this.parsePrimaryExpression);
						}
						while (true) {
							if (this.match('.')) {
								this.context.isBindingElement = false;
								this.context.isAssignmentTarget = true;
								this.expect('.');
								var property = this.parseIdentifierName();
								expr = this.finalize(this.startNode(startToken), new Node.StaticMemberExpression(expr, property));
							} else if (this.match('(')) {
								var asyncArrow = maybeAsync && startToken.lineNumber === this.lookahead.lineNumber;
								this.context.isBindingElement = false;
								this.context.isAssignmentTarget = false;
								var args = asyncArrow ? this.parseAsyncArguments() : this.parseArguments();
								expr = this.finalize(this.startNode(startToken), new Node.CallExpression(expr, args));
								if (asyncArrow && this.match('=>')) {
									for (var i = 0; i < args.length; ++i) {
										this.reinterpretExpressionAsPattern(args[i]);
									}
									expr = {
										type: ArrowParameterPlaceHolder,
										params: args,
										async: true
									};
								}
							} else if (this.match('[')) {
								this.context.isBindingElement = false;
								this.context.isAssignmentTarget = true;
								this.expect('[');
								var property = this.isolateCoverGrammar(this.parseExpression);
								this.expect(']');
								expr = this.finalize(this.startNode(startToken), new Node.ComputedMemberExpression(expr, property));
							} else if (this.lookahead.type === 10 /* Template */ && this.lookahead.head) {
								var quasi = this.parseTemplateLiteral();
								expr = this.finalize(this.startNode(startToken), new Node.TaggedTemplateExpression(expr, quasi));
							} else {
								break;
							}
						}
						this.context.allowIn = previousAllowIn;
						return expr;
					};
					Parser.prototype.parseSuper = function () {
						var node = this.createNode();
						this.expectKeyword('super');
						if (!this.match('[') && !this.match('.')) {
							this.throwUnexpectedToken(this.lookahead);
						}
						return this.finalize(node, new Node.Super());
					};
					Parser.prototype.parseLeftHandSideExpression = function () {
						assert_1.assert(this.context.allowIn, 'callee of new expression always allow in keyword.');
						var node = this.startNode(this.lookahead);
						var expr = this.matchKeyword('super') && this.context.inFunctionBody ? this.parseSuper() : this.inheritCoverGrammar(this.matchKeyword('new') ? this.parseNewExpression : this.parsePrimaryExpression);
						while (true) {
							if (this.match('[')) {
								this.context.isBindingElement = false;
								this.context.isAssignmentTarget = true;
								this.expect('[');
								var property = this.isolateCoverGrammar(this.parseExpression);
								this.expect(']');
								expr = this.finalize(node, new Node.ComputedMemberExpression(expr, property));
							} else if (this.match('.')) {
								this.context.isBindingElement = false;
								this.context.isAssignmentTarget = true;
								this.expect('.');
								var property = this.parseIdentifierName();
								expr = this.finalize(node, new Node.StaticMemberExpression(expr, property));
							} else if (this.lookahead.type === 10 /* Template */ && this.lookahead.head) {
								var quasi = this.parseTemplateLiteral();
								expr = this.finalize(node, new Node.TaggedTemplateExpression(expr, quasi));
							} else {
								break;
							}
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-update-expressions
					Parser.prototype.parseUpdateExpression = function () {
						var expr;
						var startToken = this.lookahead;
						if (this.match('++') || this.match('--')) {
							var node = this.startNode(startToken);
							var token = this.nextToken();
							expr = this.inheritCoverGrammar(this.parseUnaryExpression);
							if (this.context.strict && expr.type === syntax_1.Syntax.Identifier && this.scanner.isRestrictedWord(expr.name)) {
								this.tolerateError(messages_1.Messages.StrictLHSPrefix);
							}
							if (!this.context.isAssignmentTarget) {
								this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
							}
							var prefix = true;
							expr = this.finalize(node, new Node.UpdateExpression(token.value, expr, prefix));
							this.context.isAssignmentTarget = false;
							this.context.isBindingElement = false;
						} else {
							expr = this.inheritCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
							if (!this.hasLineTerminator && this.lookahead.type === 7 /* Punctuator */) {
									if (this.match('++') || this.match('--')) {
										if (this.context.strict && expr.type === syntax_1.Syntax.Identifier && this.scanner.isRestrictedWord(expr.name)) {
											this.tolerateError(messages_1.Messages.StrictLHSPostfix);
										}
										if (!this.context.isAssignmentTarget) {
											this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
										}
										this.context.isAssignmentTarget = false;
										this.context.isBindingElement = false;
										var operator = this.nextToken().value;
										var prefix = false;
										expr = this.finalize(this.startNode(startToken), new Node.UpdateExpression(operator, expr, prefix));
									}
								}
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-unary-operators
					Parser.prototype.parseAwaitExpression = function () {
						var node = this.createNode();
						this.nextToken();
						var argument = this.parseUnaryExpression();
						return this.finalize(node, new Node.AwaitExpression(argument));
					};
					Parser.prototype.parseUnaryExpression = function () {
						var expr;
						if (this.match('+') || this.match('-') || this.match('~') || this.match('!') || this.matchKeyword('delete') || this.matchKeyword('void') || this.matchKeyword('typeof')) {
							var node = this.startNode(this.lookahead);
							var token = this.nextToken();
							expr = this.inheritCoverGrammar(this.parseUnaryExpression);
							expr = this.finalize(node, new Node.UnaryExpression(token.value, expr));
							if (this.context.strict && expr.operator === 'delete' && expr.argument.type === syntax_1.Syntax.Identifier) {
								this.tolerateError(messages_1.Messages.StrictDelete);
							}
							this.context.isAssignmentTarget = false;
							this.context.isBindingElement = false;
						} else if (this.context.await && this.matchContextualKeyword('await')) {
							expr = this.parseAwaitExpression();
						} else {
							expr = this.parseUpdateExpression();
						}
						return expr;
					};
					Parser.prototype.parseExponentiationExpression = function () {
						var startToken = this.lookahead;
						var expr = this.inheritCoverGrammar(this.parseUnaryExpression);
						if (expr.type !== syntax_1.Syntax.UnaryExpression && this.match('**')) {
							this.nextToken();
							this.context.isAssignmentTarget = false;
							this.context.isBindingElement = false;
							var left = expr;
							var right = this.isolateCoverGrammar(this.parseExponentiationExpression);
							expr = this.finalize(this.startNode(startToken), new Node.BinaryExpression('**', left, right));
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-exp-operator
					// https://tc39.github.io/ecma262/#sec-multiplicative-operators
					// https://tc39.github.io/ecma262/#sec-additive-operators
					// https://tc39.github.io/ecma262/#sec-bitwise-shift-operators
					// https://tc39.github.io/ecma262/#sec-relational-operators
					// https://tc39.github.io/ecma262/#sec-equality-operators
					// https://tc39.github.io/ecma262/#sec-binary-bitwise-operators
					// https://tc39.github.io/ecma262/#sec-binary-logical-operators
					Parser.prototype.binaryPrecedence = function (token) {
						var op = token.value;
						var precedence;
						if (token.type === 7 /* Punctuator */) {
								precedence = this.operatorPrecedence[op] || 0;
							} else if (token.type === 4 /* Keyword */) {
								precedence = op === 'instanceof' || this.context.allowIn && op === 'in' ? 7 : 0;
							} else {
							precedence = 0;
						}
						return precedence;
					};
					Parser.prototype.parseBinaryExpression = function () {
						var startToken = this.lookahead;
						var expr = this.inheritCoverGrammar(this.parseExponentiationExpression);
						var token = this.lookahead;
						var prec = this.binaryPrecedence(token);
						if (prec > 0) {
							this.nextToken();
							this.context.isAssignmentTarget = false;
							this.context.isBindingElement = false;
							var markers = [startToken, this.lookahead];
							var left = expr;
							var right = this.isolateCoverGrammar(this.parseExponentiationExpression);
							var stack = [left, token.value, right];
							var precedences = [prec];
							while (true) {
								prec = this.binaryPrecedence(this.lookahead);
								if (prec <= 0) {
									break;
								}
								// Reduce: make a binary expression from the three topmost entries.
								while (stack.length > 2 && prec <= precedences[precedences.length - 1]) {
									right = stack.pop();
									var operator = stack.pop();
									precedences.pop();
									left = stack.pop();
									markers.pop();
									var node = this.startNode(markers[markers.length - 1]);
									stack.push(this.finalize(node, new Node.BinaryExpression(operator, left, right)));
								}
								// Shift.
								stack.push(this.nextToken().value);
								precedences.push(prec);
								markers.push(this.lookahead);
								stack.push(this.isolateCoverGrammar(this.parseExponentiationExpression));
							}
							// Final reduce to clean-up the stack.
							var i = stack.length - 1;
							expr = stack[i];
							markers.pop();
							while (i > 1) {
								var node = this.startNode(markers.pop());
								var operator = stack[i - 1];
								expr = this.finalize(node, new Node.BinaryExpression(operator, stack[i - 2], expr));
								i -= 2;
							}
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-conditional-operator
					Parser.prototype.parseConditionalExpression = function () {
						var startToken = this.lookahead;
						var expr = this.inheritCoverGrammar(this.parseBinaryExpression);
						if (this.match('?')) {
							this.nextToken();
							var previousAllowIn = this.context.allowIn;
							this.context.allowIn = true;
							var consequent = this.isolateCoverGrammar(this.parseAssignmentExpression);
							this.context.allowIn = previousAllowIn;
							this.expect(':');
							var alternate = this.isolateCoverGrammar(this.parseAssignmentExpression);
							expr = this.finalize(this.startNode(startToken), new Node.ConditionalExpression(expr, consequent, alternate));
							this.context.isAssignmentTarget = false;
							this.context.isBindingElement = false;
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-assignment-operators
					Parser.prototype.checkPatternParam = function (options, param) {
						switch (param.type) {
							case syntax_1.Syntax.Identifier:
								this.validateParam(options, param, param.name);
								break;
							case syntax_1.Syntax.RestElement:
								this.checkPatternParam(options, param.argument);
								break;
							case syntax_1.Syntax.AssignmentPattern:
								this.checkPatternParam(options, param.left);
								break;
							case syntax_1.Syntax.ArrayPattern:
								for (var i = 0; i < param.elements.length; i++) {
									if (param.elements[i] !== null) {
										this.checkPatternParam(options, param.elements[i]);
									}
								}
								break;
							case syntax_1.Syntax.ObjectPattern:
								for (var i = 0; i < param.properties.length; i++) {
									this.checkPatternParam(options, param.properties[i].value);
								}
								break;
							default:
								break;
						}
						options.simple = options.simple && param instanceof Node.Identifier;
					};
					Parser.prototype.reinterpretAsCoverFormalsList = function (expr) {
						var params = [expr];
						var options;
						var asyncArrow = false;
						switch (expr.type) {
							case syntax_1.Syntax.Identifier:
								break;
							case ArrowParameterPlaceHolder:
								params = expr.params;
								asyncArrow = expr.async;
								break;
							default:
								return null;
						}
						options = {
							simple: true,
							paramSet: {}
						};
						for (var i = 0; i < params.length; ++i) {
							var param = params[i];
							if (param.type === syntax_1.Syntax.AssignmentPattern) {
								if (param.right.type === syntax_1.Syntax.YieldExpression) {
									if (param.right.argument) {
										this.throwUnexpectedToken(this.lookahead);
									}
									param.right.type = syntax_1.Syntax.Identifier;
									param.right.name = 'yield';
									delete param.right.argument;
									delete param.right.delegate;
								}
							} else if (asyncArrow && param.type === syntax_1.Syntax.Identifier && param.name === 'await') {
								this.throwUnexpectedToken(this.lookahead);
							}
							this.checkPatternParam(options, param);
							params[i] = param;
						}
						if (this.context.strict || !this.context.allowYield) {
							for (var i = 0; i < params.length; ++i) {
								var param = params[i];
								if (param.type === syntax_1.Syntax.YieldExpression) {
									this.throwUnexpectedToken(this.lookahead);
								}
							}
						}
						if (options.message === messages_1.Messages.StrictParamDupe) {
							var token = this.context.strict ? options.stricted : options.firstRestricted;
							this.throwUnexpectedToken(token, options.message);
						}
						return {
							simple: options.simple,
							params: params,
							stricted: options.stricted,
							firstRestricted: options.firstRestricted,
							message: options.message
						};
					};
					Parser.prototype.parseAssignmentExpression = function () {
						var expr;
						if (!this.context.allowYield && this.matchKeyword('yield')) {
							expr = this.parseYieldExpression();
						} else {
							var startToken = this.lookahead;
							var token = startToken;
							expr = this.parseConditionalExpression();
							if (token.type === 3 /* Identifier */ && token.lineNumber === this.lookahead.lineNumber && token.value === 'async') {
								if (this.lookahead.type === 3 /* Identifier */ || this.matchKeyword('yield')) {
									var arg = this.parsePrimaryExpression();
									this.reinterpretExpressionAsPattern(arg);
									expr = {
										type: ArrowParameterPlaceHolder,
										params: [arg],
										async: true
									};
								}
							}
							if (expr.type === ArrowParameterPlaceHolder || this.match('=>')) {
								// https://tc39.github.io/ecma262/#sec-arrow-function-definitions
								this.context.isAssignmentTarget = false;
								this.context.isBindingElement = false;
								var isAsync = expr.async;
								var list = this.reinterpretAsCoverFormalsList(expr);
								if (list) {
									if (this.hasLineTerminator) {
										this.tolerateUnexpectedToken(this.lookahead);
									}
									this.context.firstCoverInitializedNameError = null;
									var previousStrict = this.context.strict;
									var previousAllowStrictDirective = this.context.allowStrictDirective;
									this.context.allowStrictDirective = list.simple;
									var previousAllowYield = this.context.allowYield;
									var previousAwait = this.context.await;
									this.context.allowYield = true;
									this.context.await = isAsync;
									var node = this.startNode(startToken);
									this.expect('=>');
									var body = void 0;
									if (this.match('{')) {
										var previousAllowIn = this.context.allowIn;
										this.context.allowIn = true;
										body = this.parseFunctionSourceElements();
										this.context.allowIn = previousAllowIn;
									} else {
										body = this.isolateCoverGrammar(this.parseAssignmentExpression);
									}
									var expression = body.type !== syntax_1.Syntax.BlockStatement;
									if (this.context.strict && list.firstRestricted) {
										this.throwUnexpectedToken(list.firstRestricted, list.message);
									}
									if (this.context.strict && list.stricted) {
										this.tolerateUnexpectedToken(list.stricted, list.message);
									}
									expr = isAsync ? this.finalize(node, new Node.AsyncArrowFunctionExpression(list.params, body, expression)) : this.finalize(node, new Node.ArrowFunctionExpression(list.params, body, expression));
									this.context.strict = previousStrict;
									this.context.allowStrictDirective = previousAllowStrictDirective;
									this.context.allowYield = previousAllowYield;
									this.context.await = previousAwait;
								}
							} else {
								if (this.matchAssign()) {
									if (!this.context.isAssignmentTarget) {
										this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
									}
									if (this.context.strict && expr.type === syntax_1.Syntax.Identifier) {
										var id = expr;
										if (this.scanner.isRestrictedWord(id.name)) {
											this.tolerateUnexpectedToken(token, messages_1.Messages.StrictLHSAssignment);
										}
										if (this.scanner.isStrictModeReservedWord(id.name)) {
											this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
										}
									}
									if (!this.match('=')) {
										this.context.isAssignmentTarget = false;
										this.context.isBindingElement = false;
									} else {
										this.reinterpretExpressionAsPattern(expr);
									}
									token = this.nextToken();
									var operator = token.value;
									var right = this.isolateCoverGrammar(this.parseAssignmentExpression);
									expr = this.finalize(this.startNode(startToken), new Node.AssignmentExpression(operator, expr, right));
									this.context.firstCoverInitializedNameError = null;
								}
							}
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-comma-operator
					Parser.prototype.parseExpression = function () {
						var startToken = this.lookahead;
						var expr = this.isolateCoverGrammar(this.parseAssignmentExpression);
						if (this.match(',')) {
							var expressions = [];
							expressions.push(expr);
							while (this.lookahead.type !== 2 /* EOF */) {
								if (!this.match(',')) {
									break;
								}
								this.nextToken();
								expressions.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
							}
							expr = this.finalize(this.startNode(startToken), new Node.SequenceExpression(expressions));
						}
						return expr;
					};
					// https://tc39.github.io/ecma262/#sec-block
					Parser.prototype.parseStatementListItem = function () {
						var statement;
						this.context.isAssignmentTarget = true;
						this.context.isBindingElement = true;
						if (this.lookahead.type === 4 /* Keyword */) {
								switch (this.lookahead.value) {
									case 'export':
										if (!this.context.isModule) {
											this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.IllegalExportDeclaration);
										}
										statement = this.parseExportDeclaration();
										break;
									case 'import':
										if (!this.context.isModule) {
											this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.IllegalImportDeclaration);
										}
										statement = this.parseImportDeclaration();
										break;
									case 'const':
										statement = this.parseLexicalDeclaration({ inFor: false });
										break;
									case 'function':
										statement = this.parseFunctionDeclaration();
										break;
									case 'class':
										statement = this.parseClassDeclaration();
										break;
									case 'let':
										statement = this.isLexicalDeclaration() ? this.parseLexicalDeclaration({ inFor: false }) : this.parseStatement();
										break;
									default:
										statement = this.parseStatement();
										break;
								}
							} else {
							statement = this.parseStatement();
						}
						return statement;
					};
					Parser.prototype.parseBlock = function () {
						var node = this.createNode();
						this.expect('{');
						var block = [];
						while (true) {
							if (this.match('}')) {
								break;
							}
							block.push(this.parseStatementListItem());
						}
						this.expect('}');
						return this.finalize(node, new Node.BlockStatement(block));
					};
					// https://tc39.github.io/ecma262/#sec-let-and-const-declarations
					Parser.prototype.parseLexicalBinding = function (kind, options) {
						var node = this.createNode();
						var params = [];
						var id = this.parsePattern(params, kind);
						if (this.context.strict && id.type === syntax_1.Syntax.Identifier) {
							if (this.scanner.isRestrictedWord(id.name)) {
								this.tolerateError(messages_1.Messages.StrictVarName);
							}
						}
						var init = null;
						if (kind === 'const') {
							if (!this.matchKeyword('in') && !this.matchContextualKeyword('of')) {
								if (this.match('=')) {
									this.nextToken();
									init = this.isolateCoverGrammar(this.parseAssignmentExpression);
								} else {
									this.throwError(messages_1.Messages.DeclarationMissingInitializer, 'const');
								}
							}
						} else if (!options.inFor && id.type !== syntax_1.Syntax.Identifier || this.match('=')) {
							this.expect('=');
							init = this.isolateCoverGrammar(this.parseAssignmentExpression);
						}
						return this.finalize(node, new Node.VariableDeclarator(id, init));
					};
					Parser.prototype.parseBindingList = function (kind, options) {
						var list = [this.parseLexicalBinding(kind, options)];
						while (this.match(',')) {
							this.nextToken();
							list.push(this.parseLexicalBinding(kind, options));
						}
						return list;
					};
					Parser.prototype.isLexicalDeclaration = function () {
						var state = this.scanner.saveState();
						this.scanner.scanComments();
						var next = this.scanner.lex();
						this.scanner.restoreState(state);
						return next.type === 3 /* Identifier */ || next.type === 7 /* Punctuator */ && next.value === '[' || next.type === 7 /* Punctuator */ && next.value === '{' || next.type === 4 /* Keyword */ && next.value === 'let' || next.type === 4 /* Keyword */ && next.value === 'yield';
					};
					Parser.prototype.parseLexicalDeclaration = function (options) {
						var node = this.createNode();
						var kind = this.nextToken().value;
						assert_1.assert(kind === 'let' || kind === 'const', 'Lexical declaration must be either let or const');
						var declarations = this.parseBindingList(kind, options);
						this.consumeSemicolon();
						return this.finalize(node, new Node.VariableDeclaration(declarations, kind));
					};
					// https://tc39.github.io/ecma262/#sec-destructuring-binding-patterns
					Parser.prototype.parseBindingRestElement = function (params, kind) {
						var node = this.createNode();
						this.expect('...');
						var arg = this.parsePattern(params, kind);
						return this.finalize(node, new Node.RestElement(arg));
					};
					Parser.prototype.parseArrayPattern = function (params, kind) {
						var node = this.createNode();
						this.expect('[');
						var elements = [];
						while (!this.match(']')) {
							if (this.match(',')) {
								this.nextToken();
								elements.push(null);
							} else {
								if (this.match('...')) {
									elements.push(this.parseBindingRestElement(params, kind));
									break;
								} else {
									elements.push(this.parsePatternWithDefault(params, kind));
								}
								if (!this.match(']')) {
									this.expect(',');
								}
							}
						}
						this.expect(']');
						return this.finalize(node, new Node.ArrayPattern(elements));
					};
					Parser.prototype.parsePropertyPattern = function (params, kind) {
						var node = this.createNode();
						var computed = false;
						var shorthand = false;
						var method = false;
						var key;
						var value;
						if (this.lookahead.type === 3 /* Identifier */) {
								var keyToken = this.lookahead;
								key = this.parseVariableIdentifier();
								var init = this.finalize(node, new Node.Identifier(keyToken.value));
								if (this.match('=')) {
									params.push(keyToken);
									shorthand = true;
									this.nextToken();
									var expr = this.parseAssignmentExpression();
									value = this.finalize(this.startNode(keyToken), new Node.AssignmentPattern(init, expr));
								} else if (!this.match(':')) {
									params.push(keyToken);
									shorthand = true;
									value = init;
								} else {
									this.expect(':');
									value = this.parsePatternWithDefault(params, kind);
								}
							} else {
							computed = this.match('[');
							key = this.parseObjectPropertyKey();
							this.expect(':');
							value = this.parsePatternWithDefault(params, kind);
						}
						return this.finalize(node, new Node.Property('init', key, computed, value, method, shorthand));
					};
					Parser.prototype.parseObjectPattern = function (params, kind) {
						var node = this.createNode();
						var properties = [];
						this.expect('{');
						while (!this.match('}')) {
							properties.push(this.parsePropertyPattern(params, kind));
							if (!this.match('}')) {
								this.expect(',');
							}
						}
						this.expect('}');
						return this.finalize(node, new Node.ObjectPattern(properties));
					};
					Parser.prototype.parsePattern = function (params, kind) {
						var pattern;
						if (this.match('[')) {
							pattern = this.parseArrayPattern(params, kind);
						} else if (this.match('{')) {
							pattern = this.parseObjectPattern(params, kind);
						} else {
							if (this.matchKeyword('let') && (kind === 'const' || kind === 'let')) {
								this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.LetInLexicalBinding);
							}
							params.push(this.lookahead);
							pattern = this.parseVariableIdentifier(kind);
						}
						return pattern;
					};
					Parser.prototype.parsePatternWithDefault = function (params, kind) {
						var startToken = this.lookahead;
						var pattern = this.parsePattern(params, kind);
						if (this.match('=')) {
							this.nextToken();
							var previousAllowYield = this.context.allowYield;
							this.context.allowYield = true;
							var right = this.isolateCoverGrammar(this.parseAssignmentExpression);
							this.context.allowYield = previousAllowYield;
							pattern = this.finalize(this.startNode(startToken), new Node.AssignmentPattern(pattern, right));
						}
						return pattern;
					};
					// https://tc39.github.io/ecma262/#sec-variable-statement
					Parser.prototype.parseVariableIdentifier = function (kind) {
						var node = this.createNode();
						var token = this.nextToken();
						if (token.type === 4 /* Keyword */ && token.value === 'yield') {
							if (this.context.strict) {
								this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
							} else if (!this.context.allowYield) {
								this.throwUnexpectedToken(token);
							}
						} else if (token.type !== 3 /* Identifier */) {
								if (this.context.strict && token.type === 4 /* Keyword */ && this.scanner.isStrictModeReservedWord(token.value)) {
									this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
								} else {
									if (this.context.strict || token.value !== 'let' || kind !== 'var') {
										this.throwUnexpectedToken(token);
									}
								}
							} else if ((this.context.isModule || this.context.await) && token.type === 3 /* Identifier */ && token.value === 'await') {
							this.tolerateUnexpectedToken(token);
						}
						return this.finalize(node, new Node.Identifier(token.value));
					};
					Parser.prototype.parseVariableDeclaration = function (options) {
						var node = this.createNode();
						var params = [];
						var id = this.parsePattern(params, 'var');
						if (this.context.strict && id.type === syntax_1.Syntax.Identifier) {
							if (this.scanner.isRestrictedWord(id.name)) {
								this.tolerateError(messages_1.Messages.StrictVarName);
							}
						}
						var init = null;
						if (this.match('=')) {
							this.nextToken();
							init = this.isolateCoverGrammar(this.parseAssignmentExpression);
						} else if (id.type !== syntax_1.Syntax.Identifier && !options.inFor) {
							this.expect('=');
						}
						return this.finalize(node, new Node.VariableDeclarator(id, init));
					};
					Parser.prototype.parseVariableDeclarationList = function (options) {
						var opt = { inFor: options.inFor };
						var list = [];
						list.push(this.parseVariableDeclaration(opt));
						while (this.match(',')) {
							this.nextToken();
							list.push(this.parseVariableDeclaration(opt));
						}
						return list;
					};
					Parser.prototype.parseVariableStatement = function () {
						var node = this.createNode();
						this.expectKeyword('var');
						var declarations = this.parseVariableDeclarationList({ inFor: false });
						this.consumeSemicolon();
						return this.finalize(node, new Node.VariableDeclaration(declarations, 'var'));
					};
					// https://tc39.github.io/ecma262/#sec-empty-statement
					Parser.prototype.parseEmptyStatement = function () {
						var node = this.createNode();
						this.expect(';');
						return this.finalize(node, new Node.EmptyStatement());
					};
					// https://tc39.github.io/ecma262/#sec-expression-statement
					Parser.prototype.parseExpressionStatement = function () {
						var node = this.createNode();
						var expr = this.parseExpression();
						this.consumeSemicolon();
						return this.finalize(node, new Node.ExpressionStatement(expr));
					};
					// https://tc39.github.io/ecma262/#sec-if-statement
					Parser.prototype.parseIfClause = function () {
						if (this.context.strict && this.matchKeyword('function')) {
							this.tolerateError(messages_1.Messages.StrictFunction);
						}
						return this.parseStatement();
					};
					Parser.prototype.parseIfStatement = function () {
						var node = this.createNode();
						var consequent;
						var alternate = null;
						this.expectKeyword('if');
						this.expect('(');
						var test = this.parseExpression();
						if (!this.match(')') && this.config.tolerant) {
							this.tolerateUnexpectedToken(this.nextToken());
							consequent = this.finalize(this.createNode(), new Node.EmptyStatement());
						} else {
							this.expect(')');
							consequent = this.parseIfClause();
							if (this.matchKeyword('else')) {
								this.nextToken();
								alternate = this.parseIfClause();
							}
						}
						return this.finalize(node, new Node.IfStatement(test, consequent, alternate));
					};
					// https://tc39.github.io/ecma262/#sec-do-while-statement
					Parser.prototype.parseDoWhileStatement = function () {
						var node = this.createNode();
						this.expectKeyword('do');
						var previousInIteration = this.context.inIteration;
						this.context.inIteration = true;
						var body = this.parseStatement();
						this.context.inIteration = previousInIteration;
						this.expectKeyword('while');
						this.expect('(');
						var test = this.parseExpression();
						if (!this.match(')') && this.config.tolerant) {
							this.tolerateUnexpectedToken(this.nextToken());
						} else {
							this.expect(')');
							if (this.match(';')) {
								this.nextToken();
							}
						}
						return this.finalize(node, new Node.DoWhileStatement(body, test));
					};
					// https://tc39.github.io/ecma262/#sec-while-statement
					Parser.prototype.parseWhileStatement = function () {
						var node = this.createNode();
						var body;
						this.expectKeyword('while');
						this.expect('(');
						var test = this.parseExpression();
						if (!this.match(')') && this.config.tolerant) {
							this.tolerateUnexpectedToken(this.nextToken());
							body = this.finalize(this.createNode(), new Node.EmptyStatement());
						} else {
							this.expect(')');
							var previousInIteration = this.context.inIteration;
							this.context.inIteration = true;
							body = this.parseStatement();
							this.context.inIteration = previousInIteration;
						}
						return this.finalize(node, new Node.WhileStatement(test, body));
					};
					// https://tc39.github.io/ecma262/#sec-for-statement
					// https://tc39.github.io/ecma262/#sec-for-in-and-for-of-statements
					Parser.prototype.parseForStatement = function () {
						var init = null;
						var test = null;
						var update = null;
						var forIn = true;
						var left, right;
						var node = this.createNode();
						this.expectKeyword('for');
						this.expect('(');
						if (this.match(';')) {
							this.nextToken();
						} else {
							if (this.matchKeyword('var')) {
								init = this.createNode();
								this.nextToken();
								var previousAllowIn = this.context.allowIn;
								this.context.allowIn = false;
								var declarations = this.parseVariableDeclarationList({ inFor: true });
								this.context.allowIn = previousAllowIn;
								if (declarations.length === 1 && this.matchKeyword('in')) {
									var decl = declarations[0];
									if (decl.init && (decl.id.type === syntax_1.Syntax.ArrayPattern || decl.id.type === syntax_1.Syntax.ObjectPattern || this.context.strict)) {
										this.tolerateError(messages_1.Messages.ForInOfLoopInitializer, 'for-in');
									}
									init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
									this.nextToken();
									left = init;
									right = this.parseExpression();
									init = null;
								} else if (declarations.length === 1 && declarations[0].init === null && this.matchContextualKeyword('of')) {
									init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
									this.nextToken();
									left = init;
									right = this.parseAssignmentExpression();
									init = null;
									forIn = false;
								} else {
									init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
									this.expect(';');
								}
							} else if (this.matchKeyword('const') || this.matchKeyword('let')) {
								init = this.createNode();
								var kind = this.nextToken().value;
								if (!this.context.strict && this.lookahead.value === 'in') {
									init = this.finalize(init, new Node.Identifier(kind));
									this.nextToken();
									left = init;
									right = this.parseExpression();
									init = null;
								} else {
									var previousAllowIn = this.context.allowIn;
									this.context.allowIn = false;
									var declarations = this.parseBindingList(kind, { inFor: true });
									this.context.allowIn = previousAllowIn;
									if (declarations.length === 1 && declarations[0].init === null && this.matchKeyword('in')) {
										init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
										this.nextToken();
										left = init;
										right = this.parseExpression();
										init = null;
									} else if (declarations.length === 1 && declarations[0].init === null && this.matchContextualKeyword('of')) {
										init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
										this.nextToken();
										left = init;
										right = this.parseAssignmentExpression();
										init = null;
										forIn = false;
									} else {
										this.consumeSemicolon();
										init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
									}
								}
							} else {
								var initStartToken = this.lookahead;
								var previousAllowIn = this.context.allowIn;
								this.context.allowIn = false;
								init = this.inheritCoverGrammar(this.parseAssignmentExpression);
								this.context.allowIn = previousAllowIn;
								if (this.matchKeyword('in')) {
									if (!this.context.isAssignmentTarget || init.type === syntax_1.Syntax.AssignmentExpression) {
										this.tolerateError(messages_1.Messages.InvalidLHSInForIn);
									}
									this.nextToken();
									this.reinterpretExpressionAsPattern(init);
									left = init;
									right = this.parseExpression();
									init = null;
								} else if (this.matchContextualKeyword('of')) {
									if (!this.context.isAssignmentTarget || init.type === syntax_1.Syntax.AssignmentExpression) {
										this.tolerateError(messages_1.Messages.InvalidLHSInForLoop);
									}
									this.nextToken();
									this.reinterpretExpressionAsPattern(init);
									left = init;
									right = this.parseAssignmentExpression();
									init = null;
									forIn = false;
								} else {
									if (this.match(',')) {
										var initSeq = [init];
										while (this.match(',')) {
											this.nextToken();
											initSeq.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
										}
										init = this.finalize(this.startNode(initStartToken), new Node.SequenceExpression(initSeq));
									}
									this.expect(';');
								}
							}
						}
						if (typeof left === 'undefined') {
							if (!this.match(';')) {
								test = this.parseExpression();
							}
							this.expect(';');
							if (!this.match(')')) {
								update = this.parseExpression();
							}
						}
						var body;
						if (!this.match(')') && this.config.tolerant) {
							this.tolerateUnexpectedToken(this.nextToken());
							body = this.finalize(this.createNode(), new Node.EmptyStatement());
						} else {
							this.expect(')');
							var previousInIteration = this.context.inIteration;
							this.context.inIteration = true;
							body = this.isolateCoverGrammar(this.parseStatement);
							this.context.inIteration = previousInIteration;
						}
						return typeof left === 'undefined' ? this.finalize(node, new Node.ForStatement(init, test, update, body)) : forIn ? this.finalize(node, new Node.ForInStatement(left, right, body)) : this.finalize(node, new Node.ForOfStatement(left, right, body));
					};
					// https://tc39.github.io/ecma262/#sec-continue-statement
					Parser.prototype.parseContinueStatement = function () {
						var node = this.createNode();
						this.expectKeyword('continue');
						var label = null;
						if (this.lookahead.type === 3 /* Identifier */ && !this.hasLineTerminator) {
							var id = this.parseVariableIdentifier();
							label = id;
							var key = '$' + id.name;
							if (!Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
								this.throwError(messages_1.Messages.UnknownLabel, id.name);
							}
						}
						this.consumeSemicolon();
						if (label === null && !this.context.inIteration) {
							this.throwError(messages_1.Messages.IllegalContinue);
						}
						return this.finalize(node, new Node.ContinueStatement(label));
					};
					// https://tc39.github.io/ecma262/#sec-break-statement
					Parser.prototype.parseBreakStatement = function () {
						var node = this.createNode();
						this.expectKeyword('break');
						var label = null;
						if (this.lookahead.type === 3 /* Identifier */ && !this.hasLineTerminator) {
							var id = this.parseVariableIdentifier();
							var key = '$' + id.name;
							if (!Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
								this.throwError(messages_1.Messages.UnknownLabel, id.name);
							}
							label = id;
						}
						this.consumeSemicolon();
						if (label === null && !this.context.inIteration && !this.context.inSwitch) {
							this.throwError(messages_1.Messages.IllegalBreak);
						}
						return this.finalize(node, new Node.BreakStatement(label));
					};
					// https://tc39.github.io/ecma262/#sec-return-statement
					Parser.prototype.parseReturnStatement = function () {
						if (!this.context.inFunctionBody) {
							this.tolerateError(messages_1.Messages.IllegalReturn);
						}
						var node = this.createNode();
						this.expectKeyword('return');
						var hasArgument = !this.match(';') && !this.match('}') && !this.hasLineTerminator && this.lookahead.type !== 2 /* EOF */;
						var argument = hasArgument ? this.parseExpression() : null;
						this.consumeSemicolon();
						return this.finalize(node, new Node.ReturnStatement(argument));
					};
					// https://tc39.github.io/ecma262/#sec-with-statement
					Parser.prototype.parseWithStatement = function () {
						if (this.context.strict) {
							this.tolerateError(messages_1.Messages.StrictModeWith);
						}
						var node = this.createNode();
						var body;
						this.expectKeyword('with');
						this.expect('(');
						var object = this.parseExpression();
						if (!this.match(')') && this.config.tolerant) {
							this.tolerateUnexpectedToken(this.nextToken());
							body = this.finalize(this.createNode(), new Node.EmptyStatement());
						} else {
							this.expect(')');
							body = this.parseStatement();
						}
						return this.finalize(node, new Node.WithStatement(object, body));
					};
					// https://tc39.github.io/ecma262/#sec-switch-statement
					Parser.prototype.parseSwitchCase = function () {
						var node = this.createNode();
						var test;
						if (this.matchKeyword('default')) {
							this.nextToken();
							test = null;
						} else {
							this.expectKeyword('case');
							test = this.parseExpression();
						}
						this.expect(':');
						var consequent = [];
						while (true) {
							if (this.match('}') || this.matchKeyword('default') || this.matchKeyword('case')) {
								break;
							}
							consequent.push(this.parseStatementListItem());
						}
						return this.finalize(node, new Node.SwitchCase(test, consequent));
					};
					Parser.prototype.parseSwitchStatement = function () {
						var node = this.createNode();
						this.expectKeyword('switch');
						this.expect('(');
						var discriminant = this.parseExpression();
						this.expect(')');
						var previousInSwitch = this.context.inSwitch;
						this.context.inSwitch = true;
						var cases = [];
						var defaultFound = false;
						this.expect('{');
						while (true) {
							if (this.match('}')) {
								break;
							}
							var clause = this.parseSwitchCase();
							if (clause.test === null) {
								if (defaultFound) {
									this.throwError(messages_1.Messages.MultipleDefaultsInSwitch);
								}
								defaultFound = true;
							}
							cases.push(clause);
						}
						this.expect('}');
						this.context.inSwitch = previousInSwitch;
						return this.finalize(node, new Node.SwitchStatement(discriminant, cases));
					};
					// https://tc39.github.io/ecma262/#sec-labelled-statements
					Parser.prototype.parseLabelledStatement = function () {
						var node = this.createNode();
						var expr = this.parseExpression();
						var statement;
						if (expr.type === syntax_1.Syntax.Identifier && this.match(':')) {
							this.nextToken();
							var id = expr;
							var key = '$' + id.name;
							if (Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
								this.throwError(messages_1.Messages.Redeclaration, 'Label', id.name);
							}
							this.context.labelSet[key] = true;
							var body = void 0;
							if (this.matchKeyword('class')) {
								this.tolerateUnexpectedToken(this.lookahead);
								body = this.parseClassDeclaration();
							} else if (this.matchKeyword('function')) {
								var token = this.lookahead;
								var declaration = this.parseFunctionDeclaration();
								if (this.context.strict) {
									this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunction);
								} else if (declaration.generator) {
									this.tolerateUnexpectedToken(token, messages_1.Messages.GeneratorInLegacyContext);
								}
								body = declaration;
							} else {
								body = this.parseStatement();
							}
							delete this.context.labelSet[key];
							statement = new Node.LabeledStatement(id, body);
						} else {
							this.consumeSemicolon();
							statement = new Node.ExpressionStatement(expr);
						}
						return this.finalize(node, statement);
					};
					// https://tc39.github.io/ecma262/#sec-throw-statement
					Parser.prototype.parseThrowStatement = function () {
						var node = this.createNode();
						this.expectKeyword('throw');
						if (this.hasLineTerminator) {
							this.throwError(messages_1.Messages.NewlineAfterThrow);
						}
						var argument = this.parseExpression();
						this.consumeSemicolon();
						return this.finalize(node, new Node.ThrowStatement(argument));
					};
					// https://tc39.github.io/ecma262/#sec-try-statement
					Parser.prototype.parseCatchClause = function () {
						var node = this.createNode();
						this.expectKeyword('catch');
						this.expect('(');
						if (this.match(')')) {
							this.throwUnexpectedToken(this.lookahead);
						}
						var params = [];
						var param = this.parsePattern(params);
						var paramMap = {};
						for (var i = 0; i < params.length; i++) {
							var key = '$' + params[i].value;
							if (Object.prototype.hasOwnProperty.call(paramMap, key)) {
								this.tolerateError(messages_1.Messages.DuplicateBinding, params[i].value);
							}
							paramMap[key] = true;
						}
						if (this.context.strict && param.type === syntax_1.Syntax.Identifier) {
							if (this.scanner.isRestrictedWord(param.name)) {
								this.tolerateError(messages_1.Messages.StrictCatchVariable);
							}
						}
						this.expect(')');
						var body = this.parseBlock();
						return this.finalize(node, new Node.CatchClause(param, body));
					};
					Parser.prototype.parseFinallyClause = function () {
						this.expectKeyword('finally');
						return this.parseBlock();
					};
					Parser.prototype.parseTryStatement = function () {
						var node = this.createNode();
						this.expectKeyword('try');
						var block = this.parseBlock();
						var handler = this.matchKeyword('catch') ? this.parseCatchClause() : null;
						var finalizer = this.matchKeyword('finally') ? this.parseFinallyClause() : null;
						if (!handler && !finalizer) {
							this.throwError(messages_1.Messages.NoCatchOrFinally);
						}
						return this.finalize(node, new Node.TryStatement(block, handler, finalizer));
					};
					// https://tc39.github.io/ecma262/#sec-debugger-statement
					Parser.prototype.parseDebuggerStatement = function () {
						var node = this.createNode();
						this.expectKeyword('debugger');
						this.consumeSemicolon();
						return this.finalize(node, new Node.DebuggerStatement());
					};
					// https://tc39.github.io/ecma262/#sec-ecmascript-language-statements-and-declarations
					Parser.prototype.parseStatement = function () {
						var statement;
						switch (this.lookahead.type) {
							case 1 /* BooleanLiteral */:
							case 5 /* NullLiteral */:
							case 6 /* NumericLiteral */:
							case 8 /* StringLiteral */:
							case 10 /* Template */:
							case 9 /* RegularExpression */:
								statement = this.parseExpressionStatement();
								break;
							case 7 /* Punctuator */:
								var value = this.lookahead.value;
								if (value === '{') {
									statement = this.parseBlock();
								} else if (value === '(') {
									statement = this.parseExpressionStatement();
								} else if (value === ';') {
									statement = this.parseEmptyStatement();
								} else {
									statement = this.parseExpressionStatement();
								}
								break;
							case 3 /* Identifier */:
								statement = this.matchAsyncFunction() ? this.parseFunctionDeclaration() : this.parseLabelledStatement();
								break;
							case 4 /* Keyword */:
								switch (this.lookahead.value) {
									case 'break':
										statement = this.parseBreakStatement();
										break;
									case 'continue':
										statement = this.parseContinueStatement();
										break;
									case 'debugger':
										statement = this.parseDebuggerStatement();
										break;
									case 'do':
										statement = this.parseDoWhileStatement();
										break;
									case 'for':
										statement = this.parseForStatement();
										break;
									case 'function':
										statement = this.parseFunctionDeclaration();
										break;
									case 'if':
										statement = this.parseIfStatement();
										break;
									case 'return':
										statement = this.parseReturnStatement();
										break;
									case 'switch':
										statement = this.parseSwitchStatement();
										break;
									case 'throw':
										statement = this.parseThrowStatement();
										break;
									case 'try':
										statement = this.parseTryStatement();
										break;
									case 'var':
										statement = this.parseVariableStatement();
										break;
									case 'while':
										statement = this.parseWhileStatement();
										break;
									case 'with':
										statement = this.parseWithStatement();
										break;
									default:
										statement = this.parseExpressionStatement();
										break;
								}
								break;
							default:
								statement = this.throwUnexpectedToken(this.lookahead);
						}
						return statement;
					};
					// https://tc39.github.io/ecma262/#sec-function-definitions
					Parser.prototype.parseFunctionSourceElements = function () {
						var node = this.createNode();
						this.expect('{');
						var body = this.parseDirectivePrologues();
						var previousLabelSet = this.context.labelSet;
						var previousInIteration = this.context.inIteration;
						var previousInSwitch = this.context.inSwitch;
						var previousInFunctionBody = this.context.inFunctionBody;
						this.context.labelSet = {};
						this.context.inIteration = false;
						this.context.inSwitch = false;
						this.context.inFunctionBody = true;
						while (this.lookahead.type !== 2 /* EOF */) {
							if (this.match('}')) {
								break;
							}
							body.push(this.parseStatementListItem());
						}
						this.expect('}');
						this.context.labelSet = previousLabelSet;
						this.context.inIteration = previousInIteration;
						this.context.inSwitch = previousInSwitch;
						this.context.inFunctionBody = previousInFunctionBody;
						return this.finalize(node, new Node.BlockStatement(body));
					};
					Parser.prototype.validateParam = function (options, param, name) {
						var key = '$' + name;
						if (this.context.strict) {
							if (this.scanner.isRestrictedWord(name)) {
								options.stricted = param;
								options.message = messages_1.Messages.StrictParamName;
							}
							if (Object.prototype.hasOwnProperty.call(options.paramSet, key)) {
								options.stricted = param;
								options.message = messages_1.Messages.StrictParamDupe;
							}
						} else if (!options.firstRestricted) {
							if (this.scanner.isRestrictedWord(name)) {
								options.firstRestricted = param;
								options.message = messages_1.Messages.StrictParamName;
							} else if (this.scanner.isStrictModeReservedWord(name)) {
								options.firstRestricted = param;
								options.message = messages_1.Messages.StrictReservedWord;
							} else if (Object.prototype.hasOwnProperty.call(options.paramSet, key)) {
								options.stricted = param;
								options.message = messages_1.Messages.StrictParamDupe;
							}
						}
						/* istanbul ignore next */
						if (typeof Object.defineProperty === 'function') {
							Object.defineProperty(options.paramSet, key, { value: true, enumerable: true, writable: true, configurable: true });
						} else {
							options.paramSet[key] = true;
						}
					};
					Parser.prototype.parseRestElement = function (params) {
						var node = this.createNode();
						this.expect('...');
						var arg = this.parsePattern(params);
						if (this.match('=')) {
							this.throwError(messages_1.Messages.DefaultRestParameter);
						}
						if (!this.match(')')) {
							this.throwError(messages_1.Messages.ParameterAfterRestParameter);
						}
						return this.finalize(node, new Node.RestElement(arg));
					};
					Parser.prototype.parseFormalParameter = function (options) {
						var params = [];
						var param = this.match('...') ? this.parseRestElement(params) : this.parsePatternWithDefault(params);
						for (var i = 0; i < params.length; i++) {
							this.validateParam(options, params[i], params[i].value);
						}
						options.simple = options.simple && param instanceof Node.Identifier;
						options.params.push(param);
					};
					Parser.prototype.parseFormalParameters = function (firstRestricted) {
						var options;
						options = {
							simple: true,
							params: [],
							firstRestricted: firstRestricted
						};
						this.expect('(');
						if (!this.match(')')) {
							options.paramSet = {};
							while (this.lookahead.type !== 2 /* EOF */) {
								this.parseFormalParameter(options);
								if (this.match(')')) {
									break;
								}
								this.expect(',');
								if (this.match(')')) {
									break;
								}
							}
						}
						this.expect(')');
						return {
							simple: options.simple,
							params: options.params,
							stricted: options.stricted,
							firstRestricted: options.firstRestricted,
							message: options.message
						};
					};
					Parser.prototype.matchAsyncFunction = function () {
						var match = this.matchContextualKeyword('async');
						if (match) {
							var state = this.scanner.saveState();
							this.scanner.scanComments();
							var next = this.scanner.lex();
							this.scanner.restoreState(state);
							match = state.lineNumber === next.lineNumber && next.type === 4 /* Keyword */ && next.value === 'function';
						}
						return match;
					};
					Parser.prototype.parseFunctionDeclaration = function (identifierIsOptional) {
						var node = this.createNode();
						var isAsync = this.matchContextualKeyword('async');
						if (isAsync) {
							this.nextToken();
						}
						this.expectKeyword('function');
						var isGenerator = isAsync ? false : this.match('*');
						if (isGenerator) {
							this.nextToken();
						}
						var message;
						var id = null;
						var firstRestricted = null;
						if (!identifierIsOptional || !this.match('(')) {
							var token = this.lookahead;
							id = this.parseVariableIdentifier();
							if (this.context.strict) {
								if (this.scanner.isRestrictedWord(token.value)) {
									this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunctionName);
								}
							} else {
								if (this.scanner.isRestrictedWord(token.value)) {
									firstRestricted = token;
									message = messages_1.Messages.StrictFunctionName;
								} else if (this.scanner.isStrictModeReservedWord(token.value)) {
									firstRestricted = token;
									message = messages_1.Messages.StrictReservedWord;
								}
							}
						}
						var previousAllowAwait = this.context.await;
						var previousAllowYield = this.context.allowYield;
						this.context.await = isAsync;
						this.context.allowYield = !isGenerator;
						var formalParameters = this.parseFormalParameters(firstRestricted);
						var params = formalParameters.params;
						var stricted = formalParameters.stricted;
						firstRestricted = formalParameters.firstRestricted;
						if (formalParameters.message) {
							message = formalParameters.message;
						}
						var previousStrict = this.context.strict;
						var previousAllowStrictDirective = this.context.allowStrictDirective;
						this.context.allowStrictDirective = formalParameters.simple;
						var body = this.parseFunctionSourceElements();
						if (this.context.strict && firstRestricted) {
							this.throwUnexpectedToken(firstRestricted, message);
						}
						if (this.context.strict && stricted) {
							this.tolerateUnexpectedToken(stricted, message);
						}
						this.context.strict = previousStrict;
						this.context.allowStrictDirective = previousAllowStrictDirective;
						this.context.await = previousAllowAwait;
						this.context.allowYield = previousAllowYield;
						return isAsync ? this.finalize(node, new Node.AsyncFunctionDeclaration(id, params, body)) : this.finalize(node, new Node.FunctionDeclaration(id, params, body, isGenerator));
					};
					Parser.prototype.parseFunctionExpression = function () {
						var node = this.createNode();
						var isAsync = this.matchContextualKeyword('async');
						if (isAsync) {
							this.nextToken();
						}
						this.expectKeyword('function');
						var isGenerator = isAsync ? false : this.match('*');
						if (isGenerator) {
							this.nextToken();
						}
						var message;
						var id = null;
						var firstRestricted;
						var previousAllowAwait = this.context.await;
						var previousAllowYield = this.context.allowYield;
						this.context.await = isAsync;
						this.context.allowYield = !isGenerator;
						if (!this.match('(')) {
							var token = this.lookahead;
							id = !this.context.strict && !isGenerator && this.matchKeyword('yield') ? this.parseIdentifierName() : this.parseVariableIdentifier();
							if (this.context.strict) {
								if (this.scanner.isRestrictedWord(token.value)) {
									this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunctionName);
								}
							} else {
								if (this.scanner.isRestrictedWord(token.value)) {
									firstRestricted = token;
									message = messages_1.Messages.StrictFunctionName;
								} else if (this.scanner.isStrictModeReservedWord(token.value)) {
									firstRestricted = token;
									message = messages_1.Messages.StrictReservedWord;
								}
							}
						}
						var formalParameters = this.parseFormalParameters(firstRestricted);
						var params = formalParameters.params;
						var stricted = formalParameters.stricted;
						firstRestricted = formalParameters.firstRestricted;
						if (formalParameters.message) {
							message = formalParameters.message;
						}
						var previousStrict = this.context.strict;
						var previousAllowStrictDirective = this.context.allowStrictDirective;
						this.context.allowStrictDirective = formalParameters.simple;
						var body = this.parseFunctionSourceElements();
						if (this.context.strict && firstRestricted) {
							this.throwUnexpectedToken(firstRestricted, message);
						}
						if (this.context.strict && stricted) {
							this.tolerateUnexpectedToken(stricted, message);
						}
						this.context.strict = previousStrict;
						this.context.allowStrictDirective = previousAllowStrictDirective;
						this.context.await = previousAllowAwait;
						this.context.allowYield = previousAllowYield;
						return isAsync ? this.finalize(node, new Node.AsyncFunctionExpression(id, params, body)) : this.finalize(node, new Node.FunctionExpression(id, params, body, isGenerator));
					};
					// https://tc39.github.io/ecma262/#sec-directive-prologues-and-the-use-strict-directive
					Parser.prototype.parseDirective = function () {
						var token = this.lookahead;
						var node = this.createNode();
						var expr = this.parseExpression();
						var directive = expr.type === syntax_1.Syntax.Literal ? this.getTokenRaw(token).slice(1, -1) : null;
						this.consumeSemicolon();
						return this.finalize(node, directive ? new Node.Directive(expr, directive) : new Node.ExpressionStatement(expr));
					};
					Parser.prototype.parseDirectivePrologues = function () {
						var firstRestricted = null;
						var body = [];
						while (true) {
							var token = this.lookahead;
							if (token.type !== 8 /* StringLiteral */) {
									break;
								}
							var statement = this.parseDirective();
							body.push(statement);
							var directive = statement.directive;
							if (typeof directive !== 'string') {
								break;
							}
							if (directive === 'use strict') {
								this.context.strict = true;
								if (firstRestricted) {
									this.tolerateUnexpectedToken(firstRestricted, messages_1.Messages.StrictOctalLiteral);
								}
								if (!this.context.allowStrictDirective) {
									this.tolerateUnexpectedToken(token, messages_1.Messages.IllegalLanguageModeDirective);
								}
							} else {
								if (!firstRestricted && token.octal) {
									firstRestricted = token;
								}
							}
						}
						return body;
					};
					// https://tc39.github.io/ecma262/#sec-method-definitions
					Parser.prototype.qualifiedPropertyName = function (token) {
						switch (token.type) {
							case 3 /* Identifier */:
							case 8 /* StringLiteral */:
							case 1 /* BooleanLiteral */:
							case 5 /* NullLiteral */:
							case 6 /* NumericLiteral */:
							case 4 /* Keyword */:
								return true;
							case 7 /* Punctuator */:
								return token.value === '[';
							default:
								break;
						}
						return false;
					};
					Parser.prototype.parseGetterMethod = function () {
						var node = this.createNode();
						var isGenerator = false;
						var previousAllowYield = this.context.allowYield;
						this.context.allowYield = false;
						var formalParameters = this.parseFormalParameters();
						if (formalParameters.params.length > 0) {
							this.tolerateError(messages_1.Messages.BadGetterArity);
						}
						var method = this.parsePropertyMethod(formalParameters);
						this.context.allowYield = previousAllowYield;
						return this.finalize(node, new Node.FunctionExpression(null, formalParameters.params, method, isGenerator));
					};
					Parser.prototype.parseSetterMethod = function () {
						var node = this.createNode();
						var isGenerator = false;
						var previousAllowYield = this.context.allowYield;
						this.context.allowYield = false;
						var formalParameters = this.parseFormalParameters();
						if (formalParameters.params.length !== 1) {
							this.tolerateError(messages_1.Messages.BadSetterArity);
						} else if (formalParameters.params[0] instanceof Node.RestElement) {
							this.tolerateError(messages_1.Messages.BadSetterRestParameter);
						}
						var method = this.parsePropertyMethod(formalParameters);
						this.context.allowYield = previousAllowYield;
						return this.finalize(node, new Node.FunctionExpression(null, formalParameters.params, method, isGenerator));
					};
					Parser.prototype.parseGeneratorMethod = function () {
						var node = this.createNode();
						var isGenerator = true;
						var previousAllowYield = this.context.allowYield;
						this.context.allowYield = true;
						var params = this.parseFormalParameters();
						this.context.allowYield = false;
						var method = this.parsePropertyMethod(params);
						this.context.allowYield = previousAllowYield;
						return this.finalize(node, new Node.FunctionExpression(null, params.params, method, isGenerator));
					};
					// https://tc39.github.io/ecma262/#sec-generator-function-definitions
					Parser.prototype.isStartOfExpression = function () {
						var start = true;
						var value = this.lookahead.value;
						switch (this.lookahead.type) {
							case 7 /* Punctuator */:
								start = value === '[' || value === '(' || value === '{' || value === '+' || value === '-' || value === '!' || value === '~' || value === '++' || value === '--' || value === '/' || value === '/='; // regular expression literal
								break;
							case 4 /* Keyword */:
								start = value === 'class' || value === 'delete' || value === 'function' || value === 'let' || value === 'new' || value === 'super' || value === 'this' || value === 'typeof' || value === 'void' || value === 'yield';
								break;
							default:
								break;
						}
						return start;
					};
					Parser.prototype.parseYieldExpression = function () {
						var node = this.createNode();
						this.expectKeyword('yield');
						var argument = null;
						var delegate = false;
						if (!this.hasLineTerminator) {
							var previousAllowYield = this.context.allowYield;
							this.context.allowYield = false;
							delegate = this.match('*');
							if (delegate) {
								this.nextToken();
								argument = this.parseAssignmentExpression();
							} else if (this.isStartOfExpression()) {
								argument = this.parseAssignmentExpression();
							}
							this.context.allowYield = previousAllowYield;
						}
						return this.finalize(node, new Node.YieldExpression(argument, delegate));
					};
					// https://tc39.github.io/ecma262/#sec-class-definitions
					Parser.prototype.parseClassElement = function (hasConstructor) {
						var token = this.lookahead;
						var node = this.createNode();
						var kind = '';
						var key = null;
						var value = null;
						var computed = false;
						var method = false;
						var isStatic = false;
						var isAsync = false;
						if (this.match('*')) {
							this.nextToken();
						} else {
							computed = this.match('[');
							key = this.parseObjectPropertyKey();
							var id = key;
							if (id.name === 'static' && (this.qualifiedPropertyName(this.lookahead) || this.match('*'))) {
								token = this.lookahead;
								isStatic = true;
								computed = this.match('[');
								if (this.match('*')) {
									this.nextToken();
								} else {
									key = this.parseObjectPropertyKey();
								}
							}
							if (token.type === 3 /* Identifier */ && !this.hasLineTerminator && token.value === 'async') {
								var punctuator = this.lookahead.value;
								if (punctuator !== ':' && punctuator !== '(' && punctuator !== '*') {
									isAsync = true;
									token = this.lookahead;
									key = this.parseObjectPropertyKey();
									if (token.type === 3 /* Identifier */) {
											if (token.value === 'get' || token.value === 'set') {
												this.tolerateUnexpectedToken(token);
											} else if (token.value === 'constructor') {
												this.tolerateUnexpectedToken(token, messages_1.Messages.ConstructorIsAsync);
											}
										}
								}
							}
						}
						var lookaheadPropertyKey = this.qualifiedPropertyName(this.lookahead);
						if (token.type === 3 /* Identifier */) {
								if (token.value === 'get' && lookaheadPropertyKey) {
									kind = 'get';
									computed = this.match('[');
									key = this.parseObjectPropertyKey();
									this.context.allowYield = false;
									value = this.parseGetterMethod();
								} else if (token.value === 'set' && lookaheadPropertyKey) {
									kind = 'set';
									computed = this.match('[');
									key = this.parseObjectPropertyKey();
									value = this.parseSetterMethod();
								}
							} else if (token.type === 7 /* Punctuator */ && token.value === '*' && lookaheadPropertyKey) {
							kind = 'init';
							computed = this.match('[');
							key = this.parseObjectPropertyKey();
							value = this.parseGeneratorMethod();
							method = true;
						}
						if (!kind && key && this.match('(')) {
							kind = 'init';
							value = isAsync ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction();
							method = true;
						}
						if (!kind) {
							this.throwUnexpectedToken(this.lookahead);
						}
						if (kind === 'init') {
							kind = 'method';
						}
						if (!computed) {
							if (isStatic && this.isPropertyKey(key, 'prototype')) {
								this.throwUnexpectedToken(token, messages_1.Messages.StaticPrototype);
							}
							if (!isStatic && this.isPropertyKey(key, 'constructor')) {
								if (kind !== 'method' || !method || value && value.generator) {
									this.throwUnexpectedToken(token, messages_1.Messages.ConstructorSpecialMethod);
								}
								if (hasConstructor.value) {
									this.throwUnexpectedToken(token, messages_1.Messages.DuplicateConstructor);
								} else {
									hasConstructor.value = true;
								}
								kind = 'constructor';
							}
						}
						return this.finalize(node, new Node.MethodDefinition(key, computed, value, kind, isStatic));
					};
					Parser.prototype.parseClassElementList = function () {
						var body = [];
						var hasConstructor = { value: false };
						this.expect('{');
						while (!this.match('}')) {
							if (this.match(';')) {
								this.nextToken();
							} else {
								body.push(this.parseClassElement(hasConstructor));
							}
						}
						this.expect('}');
						return body;
					};
					Parser.prototype.parseClassBody = function () {
						var node = this.createNode();
						var elementList = this.parseClassElementList();
						return this.finalize(node, new Node.ClassBody(elementList));
					};
					Parser.prototype.parseClassDeclaration = function (identifierIsOptional) {
						var node = this.createNode();
						var previousStrict = this.context.strict;
						this.context.strict = true;
						this.expectKeyword('class');
						var id = identifierIsOptional && this.lookahead.type !== 3 /* Identifier */ ? null : this.parseVariableIdentifier();
						var superClass = null;
						if (this.matchKeyword('extends')) {
							this.nextToken();
							superClass = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
						}
						var classBody = this.parseClassBody();
						this.context.strict = previousStrict;
						return this.finalize(node, new Node.ClassDeclaration(id, superClass, classBody));
					};
					Parser.prototype.parseClassExpression = function () {
						var node = this.createNode();
						var previousStrict = this.context.strict;
						this.context.strict = true;
						this.expectKeyword('class');
						var id = this.lookahead.type === 3 /* Identifier */ ? this.parseVariableIdentifier() : null;
						var superClass = null;
						if (this.matchKeyword('extends')) {
							this.nextToken();
							superClass = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
						}
						var classBody = this.parseClassBody();
						this.context.strict = previousStrict;
						return this.finalize(node, new Node.ClassExpression(id, superClass, classBody));
					};
					// https://tc39.github.io/ecma262/#sec-scripts
					// https://tc39.github.io/ecma262/#sec-modules
					Parser.prototype.parseModule = function () {
						this.context.strict = true;
						this.context.isModule = true;
						var node = this.createNode();
						var body = this.parseDirectivePrologues();
						while (this.lookahead.type !== 2 /* EOF */) {
							body.push(this.parseStatementListItem());
						}
						return this.finalize(node, new Node.Module(body));
					};
					Parser.prototype.parseScript = function () {
						var node = this.createNode();
						var body = this.parseDirectivePrologues();
						while (this.lookahead.type !== 2 /* EOF */) {
							body.push(this.parseStatementListItem());
						}
						return this.finalize(node, new Node.Script(body));
					};
					// https://tc39.github.io/ecma262/#sec-imports
					Parser.prototype.parseModuleSpecifier = function () {
						var node = this.createNode();
						if (this.lookahead.type !== 8 /* StringLiteral */) {
								this.throwError(messages_1.Messages.InvalidModuleSpecifier);
							}
						var token = this.nextToken();
						var raw = this.getTokenRaw(token);
						return this.finalize(node, new Node.Literal(token.value, raw));
					};
					// import {<foo as bar>} ...;
					Parser.prototype.parseImportSpecifier = function () {
						var node = this.createNode();
						var imported;
						var local;
						if (this.lookahead.type === 3 /* Identifier */) {
								imported = this.parseVariableIdentifier();
								local = imported;
								if (this.matchContextualKeyword('as')) {
									this.nextToken();
									local = this.parseVariableIdentifier();
								}
							} else {
							imported = this.parseIdentifierName();
							local = imported;
							if (this.matchContextualKeyword('as')) {
								this.nextToken();
								local = this.parseVariableIdentifier();
							} else {
								this.throwUnexpectedToken(this.nextToken());
							}
						}
						return this.finalize(node, new Node.ImportSpecifier(local, imported));
					};
					// {foo, bar as bas}
					Parser.prototype.parseNamedImports = function () {
						this.expect('{');
						var specifiers = [];
						while (!this.match('}')) {
							specifiers.push(this.parseImportSpecifier());
							if (!this.match('}')) {
								this.expect(',');
							}
						}
						this.expect('}');
						return specifiers;
					};
					// import <foo> ...;
					Parser.prototype.parseImportDefaultSpecifier = function () {
						var node = this.createNode();
						var local = this.parseIdentifierName();
						return this.finalize(node, new Node.ImportDefaultSpecifier(local));
					};
					// import <* as foo> ...;
					Parser.prototype.parseImportNamespaceSpecifier = function () {
						var node = this.createNode();
						this.expect('*');
						if (!this.matchContextualKeyword('as')) {
							this.throwError(messages_1.Messages.NoAsAfterImportNamespace);
						}
						this.nextToken();
						var local = this.parseIdentifierName();
						return this.finalize(node, new Node.ImportNamespaceSpecifier(local));
					};
					Parser.prototype.parseImportDeclaration = function () {
						if (this.context.inFunctionBody) {
							this.throwError(messages_1.Messages.IllegalImportDeclaration);
						}
						var node = this.createNode();
						this.expectKeyword('import');
						var src;
						var specifiers = [];
						if (this.lookahead.type === 8 /* StringLiteral */) {
								// import 'foo';
								src = this.parseModuleSpecifier();
							} else {
							if (this.match('{')) {
								// import {bar}
								specifiers = specifiers.concat(this.parseNamedImports());
							} else if (this.match('*')) {
								// import * as foo
								specifiers.push(this.parseImportNamespaceSpecifier());
							} else if (this.isIdentifierName(this.lookahead) && !this.matchKeyword('default')) {
								// import foo
								specifiers.push(this.parseImportDefaultSpecifier());
								if (this.match(',')) {
									this.nextToken();
									if (this.match('*')) {
										// import foo, * as foo
										specifiers.push(this.parseImportNamespaceSpecifier());
									} else if (this.match('{')) {
										// import foo, {bar}
										specifiers = specifiers.concat(this.parseNamedImports());
									} else {
										this.throwUnexpectedToken(this.lookahead);
									}
								}
							} else {
								this.throwUnexpectedToken(this.nextToken());
							}
							if (!this.matchContextualKeyword('from')) {
								var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
								this.throwError(message, this.lookahead.value);
							}
							this.nextToken();
							src = this.parseModuleSpecifier();
						}
						this.consumeSemicolon();
						return this.finalize(node, new Node.ImportDeclaration(specifiers, src));
					};
					// https://tc39.github.io/ecma262/#sec-exports
					Parser.prototype.parseExportSpecifier = function () {
						var node = this.createNode();
						var local = this.parseIdentifierName();
						var exported = local;
						if (this.matchContextualKeyword('as')) {
							this.nextToken();
							exported = this.parseIdentifierName();
						}
						return this.finalize(node, new Node.ExportSpecifier(local, exported));
					};
					Parser.prototype.parseExportDeclaration = function () {
						if (this.context.inFunctionBody) {
							this.throwError(messages_1.Messages.IllegalExportDeclaration);
						}
						var node = this.createNode();
						this.expectKeyword('export');
						var exportDeclaration;
						if (this.matchKeyword('default')) {
							// export default ...
							this.nextToken();
							if (this.matchKeyword('function')) {
								// export default function foo () {}
								// export default function () {}
								var declaration = this.parseFunctionDeclaration(true);
								exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
							} else if (this.matchKeyword('class')) {
								// export default class foo {}
								var declaration = this.parseClassDeclaration(true);
								exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
							} else if (this.matchContextualKeyword('async')) {
								// export default async function f () {}
								// export default async function () {}
								// export default async x => x
								var declaration = this.matchAsyncFunction() ? this.parseFunctionDeclaration(true) : this.parseAssignmentExpression();
								exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
							} else {
								if (this.matchContextualKeyword('from')) {
									this.throwError(messages_1.Messages.UnexpectedToken, this.lookahead.value);
								}
								// export default {};
								// export default [];
								// export default (1 + 2);
								var declaration = this.match('{') ? this.parseObjectInitializer() : this.match('[') ? this.parseArrayInitializer() : this.parseAssignmentExpression();
								this.consumeSemicolon();
								exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
							}
						} else if (this.match('*')) {
							// export * from 'foo';
							this.nextToken();
							if (!this.matchContextualKeyword('from')) {
								var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
								this.throwError(message, this.lookahead.value);
							}
							this.nextToken();
							var src = this.parseModuleSpecifier();
							this.consumeSemicolon();
							exportDeclaration = this.finalize(node, new Node.ExportAllDeclaration(src));
						} else if (this.lookahead.type === 4 /* Keyword */) {
								// export var f = 1;
								var declaration = void 0;
								switch (this.lookahead.value) {
									case 'let':
									case 'const':
										declaration = this.parseLexicalDeclaration({ inFor: false });
										break;
									case 'var':
									case 'class':
									case 'function':
										declaration = this.parseStatementListItem();
										break;
									default:
										this.throwUnexpectedToken(this.lookahead);
								}
								exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(declaration, [], null));
							} else if (this.matchAsyncFunction()) {
							var declaration = this.parseFunctionDeclaration();
							exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(declaration, [], null));
						} else {
							var specifiers = [];
							var source = null;
							var isExportFromIdentifier = false;
							this.expect('{');
							while (!this.match('}')) {
								isExportFromIdentifier = isExportFromIdentifier || this.matchKeyword('default');
								specifiers.push(this.parseExportSpecifier());
								if (!this.match('}')) {
									this.expect(',');
								}
							}
							this.expect('}');
							if (this.matchContextualKeyword('from')) {
								// export {default} from 'foo';
								// export {foo} from 'foo';
								this.nextToken();
								source = this.parseModuleSpecifier();
								this.consumeSemicolon();
							} else if (isExportFromIdentifier) {
								// export {default}; // missing fromClause
								var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
								this.throwError(message, this.lookahead.value);
							} else {
								// export {foo};
								this.consumeSemicolon();
							}
							exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(null, specifiers, source));
						}
						return exportDeclaration;
					};
					return Parser;
				}();
				exports.Parser = Parser;
	
				/***/
			},
			/* 9 */
			/***/function (module, exports) {
	
				"use strict";
				// Ensure the condition is true, otherwise throw an error.
				// This is only to have a better contract semantic, i.e. another safety net
				// to catch a logic error. The condition shall be fulfilled in normal case.
				// Do NOT use this to enforce a certain condition on any user input.
	
				Object.defineProperty(exports, "__esModule", { value: true });
				function assert(condition, message) {
					/* istanbul ignore if */
					if (!condition) {
						throw new Error('ASSERT: ' + message);
					}
				}
				exports.assert = assert;
	
				/***/
			},
			/* 10 */
			/***/function (module, exports) {
	
				"use strict";
				/* tslint:disable:max-classes-per-file */
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var ErrorHandler = function () {
					function ErrorHandler() {
						this.errors = [];
						this.tolerant = false;
					}
					ErrorHandler.prototype.recordError = function (error) {
						this.errors.push(error);
					};
					ErrorHandler.prototype.tolerate = function (error) {
						if (this.tolerant) {
							this.recordError(error);
						} else {
							throw error;
						}
					};
					ErrorHandler.prototype.constructError = function (msg, column) {
						var error = new Error(msg);
						try {
							throw error;
						} catch (base) {
							/* istanbul ignore else */
							if (Object.create && Object.defineProperty) {
								error = Object.create(base);
								Object.defineProperty(error, 'column', { value: column });
							}
						}
						/* istanbul ignore next */
						return error;
					};
					ErrorHandler.prototype.createError = function (index, line, col, description) {
						var msg = 'Line ' + line + ': ' + description;
						var error = this.constructError(msg, col);
						error.index = index;
						error.lineNumber = line;
						error.description = description;
						return error;
					};
					ErrorHandler.prototype.throwError = function (index, line, col, description) {
						throw this.createError(index, line, col, description);
					};
					ErrorHandler.prototype.tolerateError = function (index, line, col, description) {
						var error = this.createError(index, line, col, description);
						if (this.tolerant) {
							this.recordError(error);
						} else {
							throw error;
						}
					};
					return ErrorHandler;
				}();
				exports.ErrorHandler = ErrorHandler;
	
				/***/
			},
			/* 11 */
			/***/function (module, exports) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				// Error messages should be identical to V8.
				exports.Messages = {
					BadGetterArity: 'Getter must not have any formal parameters',
					BadSetterArity: 'Setter must have exactly one formal parameter',
					BadSetterRestParameter: 'Setter function argument must not be a rest parameter',
					ConstructorIsAsync: 'Class constructor may not be an async method',
					ConstructorSpecialMethod: 'Class constructor may not be an accessor',
					DeclarationMissingInitializer: 'Missing initializer in %0 declaration',
					DefaultRestParameter: 'Unexpected token =',
					DuplicateBinding: 'Duplicate binding %0',
					DuplicateConstructor: 'A class may only have one constructor',
					DuplicateProtoProperty: 'Duplicate __proto__ fields are not allowed in object literals',
					ForInOfLoopInitializer: '%0 loop variable declaration may not have an initializer',
					GeneratorInLegacyContext: 'Generator declarations are not allowed in legacy contexts',
					IllegalBreak: 'Illegal break statement',
					IllegalContinue: 'Illegal continue statement',
					IllegalExportDeclaration: 'Unexpected token',
					IllegalImportDeclaration: 'Unexpected token',
					IllegalLanguageModeDirective: 'Illegal \'use strict\' directive in function with non-simple parameter list',
					IllegalReturn: 'Illegal return statement',
					InvalidEscapedReservedWord: 'Keyword must not contain escaped characters',
					InvalidHexEscapeSequence: 'Invalid hexadecimal escape sequence',
					InvalidLHSInAssignment: 'Invalid left-hand side in assignment',
					InvalidLHSInForIn: 'Invalid left-hand side in for-in',
					InvalidLHSInForLoop: 'Invalid left-hand side in for-loop',
					InvalidModuleSpecifier: 'Unexpected token',
					InvalidRegExp: 'Invalid regular expression',
					LetInLexicalBinding: 'let is disallowed as a lexically bound name',
					MissingFromClause: 'Unexpected token',
					MultipleDefaultsInSwitch: 'More than one default clause in switch statement',
					NewlineAfterThrow: 'Illegal newline after throw',
					NoAsAfterImportNamespace: 'Unexpected token',
					NoCatchOrFinally: 'Missing catch or finally after try',
					ParameterAfterRestParameter: 'Rest parameter must be last formal parameter',
					Redeclaration: '%0 \'%1\' has already been declared',
					StaticPrototype: 'Classes may not have static property named prototype',
					StrictCatchVariable: 'Catch variable may not be eval or arguments in strict mode',
					StrictDelete: 'Delete of an unqualified identifier in strict mode.',
					StrictFunction: 'In strict mode code, functions can only be declared at top level or inside a block',
					StrictFunctionName: 'Function name may not be eval or arguments in strict mode',
					StrictLHSAssignment: 'Assignment to eval or arguments is not allowed in strict mode',
					StrictLHSPostfix: 'Postfix increment/decrement may not have eval or arguments operand in strict mode',
					StrictLHSPrefix: 'Prefix increment/decrement may not have eval or arguments operand in strict mode',
					StrictModeWith: 'Strict mode code may not include a with statement',
					StrictOctalLiteral: 'Octal literals are not allowed in strict mode.',
					StrictParamDupe: 'Strict mode function may not have duplicate parameter names',
					StrictParamName: 'Parameter name eval or arguments is not allowed in strict mode',
					StrictReservedWord: 'Use of future reserved word in strict mode',
					StrictVarName: 'Variable name may not be eval or arguments in strict mode',
					TemplateOctalLiteral: 'Octal literals are not allowed in template strings.',
					UnexpectedEOS: 'Unexpected end of input',
					UnexpectedIdentifier: 'Unexpected identifier',
					UnexpectedNumber: 'Unexpected number',
					UnexpectedReserved: 'Unexpected reserved word',
					UnexpectedString: 'Unexpected string',
					UnexpectedTemplate: 'Unexpected quasi %0',
					UnexpectedToken: 'Unexpected token %0',
					UnexpectedTokenIllegal: 'Unexpected token ILLEGAL',
					UnknownLabel: 'Undefined label \'%0\'',
					UnterminatedRegExp: 'Invalid regular expression: missing /'
				};
	
				/***/
			},
			/* 12 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var assert_1 = __webpack_require__(9);
				var character_1 = __webpack_require__(4);
				var messages_1 = __webpack_require__(11);
				function hexValue(ch) {
					return '0123456789abcdef'.indexOf(ch.toLowerCase());
				}
				function octalValue(ch) {
					return '01234567'.indexOf(ch);
				}
				var Scanner = function () {
					function Scanner(code, handler) {
						this.source = code;
						this.errorHandler = handler;
						this.trackComment = false;
						this.length = code.length;
						this.index = 0;
						this.lineNumber = code.length > 0 ? 1 : 0;
						this.lineStart = 0;
						this.curlyStack = [];
					}
					Scanner.prototype.saveState = function () {
						return {
							index: this.index,
							lineNumber: this.lineNumber,
							lineStart: this.lineStart
						};
					};
					Scanner.prototype.restoreState = function (state) {
						this.index = state.index;
						this.lineNumber = state.lineNumber;
						this.lineStart = state.lineStart;
					};
					Scanner.prototype.eof = function () {
						return this.index >= this.length;
					};
					Scanner.prototype.throwUnexpectedToken = function (message) {
						if (message === void 0) {
							message = messages_1.Messages.UnexpectedTokenIllegal;
						}
						return this.errorHandler.throwError(this.index, this.lineNumber, this.index - this.lineStart + 1, message);
					};
					Scanner.prototype.tolerateUnexpectedToken = function (message) {
						if (message === void 0) {
							message = messages_1.Messages.UnexpectedTokenIllegal;
						}
						this.errorHandler.tolerateError(this.index, this.lineNumber, this.index - this.lineStart + 1, message);
					};
					// https://tc39.github.io/ecma262/#sec-comments
					Scanner.prototype.skipSingleLineComment = function (offset) {
						var comments = [];
						var start, loc;
						if (this.trackComment) {
							comments = [];
							start = this.index - offset;
							loc = {
								start: {
									line: this.lineNumber,
									column: this.index - this.lineStart - offset
								},
								end: {}
							};
						}
						while (!this.eof()) {
							var ch = this.source.charCodeAt(this.index);
							++this.index;
							if (character_1.Character.isLineTerminator(ch)) {
								if (this.trackComment) {
									loc.end = {
										line: this.lineNumber,
										column: this.index - this.lineStart - 1
									};
									var entry = {
										multiLine: false,
										slice: [start + offset, this.index - 1],
										range: [start, this.index - 1],
										loc: loc
									};
									comments.push(entry);
								}
								if (ch === 13 && this.source.charCodeAt(this.index) === 10) {
									++this.index;
								}
								++this.lineNumber;
								this.lineStart = this.index;
								return comments;
							}
						}
						if (this.trackComment) {
							loc.end = {
								line: this.lineNumber,
								column: this.index - this.lineStart
							};
							var entry = {
								multiLine: false,
								slice: [start + offset, this.index],
								range: [start, this.index],
								loc: loc
							};
							comments.push(entry);
						}
						return comments;
					};
					Scanner.prototype.skipMultiLineComment = function () {
						var comments = [];
						var start, loc;
						if (this.trackComment) {
							comments = [];
							start = this.index - 2;
							loc = {
								start: {
									line: this.lineNumber,
									column: this.index - this.lineStart - 2
								},
								end: {}
							};
						}
						while (!this.eof()) {
							var ch = this.source.charCodeAt(this.index);
							if (character_1.Character.isLineTerminator(ch)) {
								if (ch === 0x0D && this.source.charCodeAt(this.index + 1) === 0x0A) {
									++this.index;
								}
								++this.lineNumber;
								++this.index;
								this.lineStart = this.index;
							} else if (ch === 0x2A) {
								// Block comment ends with '*/'.
								if (this.source.charCodeAt(this.index + 1) === 0x2F) {
									this.index += 2;
									if (this.trackComment) {
										loc.end = {
											line: this.lineNumber,
											column: this.index - this.lineStart
										};
										var entry = {
											multiLine: true,
											slice: [start + 2, this.index - 2],
											range: [start, this.index],
											loc: loc
										};
										comments.push(entry);
									}
									return comments;
								}
								++this.index;
							} else {
								++this.index;
							}
						}
						// Ran off the end of the file - the whole thing is a comment
						if (this.trackComment) {
							loc.end = {
								line: this.lineNumber,
								column: this.index - this.lineStart
							};
							var entry = {
								multiLine: true,
								slice: [start + 2, this.index],
								range: [start, this.index],
								loc: loc
							};
							comments.push(entry);
						}
						this.tolerateUnexpectedToken();
						return comments;
					};
					Scanner.prototype.scanComments = function () {
						var comments;
						if (this.trackComment) {
							comments = [];
						}
						var start = this.index === 0;
						while (!this.eof()) {
							var ch = this.source.charCodeAt(this.index);
							if (character_1.Character.isWhiteSpace(ch)) {
								++this.index;
							} else if (character_1.Character.isLineTerminator(ch)) {
								++this.index;
								if (ch === 0x0D && this.source.charCodeAt(this.index) === 0x0A) {
									++this.index;
								}
								++this.lineNumber;
								this.lineStart = this.index;
								start = true;
							} else if (ch === 0x2F) {
								ch = this.source.charCodeAt(this.index + 1);
								if (ch === 0x2F) {
									this.index += 2;
									var comment = this.skipSingleLineComment(2);
									if (this.trackComment) {
										comments = comments.concat(comment);
									}
									start = true;
								} else if (ch === 0x2A) {
									this.index += 2;
									var comment = this.skipMultiLineComment();
									if (this.trackComment) {
										comments = comments.concat(comment);
									}
								} else {
									break;
								}
							} else if (start && ch === 0x2D) {
								// U+003E is '>'
								if (this.source.charCodeAt(this.index + 1) === 0x2D && this.source.charCodeAt(this.index + 2) === 0x3E) {
									// '-->' is a single-line comment
									this.index += 3;
									var comment = this.skipSingleLineComment(3);
									if (this.trackComment) {
										comments = comments.concat(comment);
									}
								} else {
									break;
								}
							} else if (ch === 0x3C) {
								if (this.source.slice(this.index + 1, this.index + 4) === '!--') {
									this.index += 4; // `<!--`
									var comment = this.skipSingleLineComment(4);
									if (this.trackComment) {
										comments = comments.concat(comment);
									}
								} else {
									break;
								}
							} else {
								break;
							}
						}
						return comments;
					};
					// https://tc39.github.io/ecma262/#sec-future-reserved-words
					Scanner.prototype.isFutureReservedWord = function (id) {
						switch (id) {
							case 'enum':
							case 'export':
							case 'import':
							case 'super':
								return true;
							default:
								return false;
						}
					};
					Scanner.prototype.isStrictModeReservedWord = function (id) {
						switch (id) {
							case 'implements':
							case 'interface':
							case 'package':
							case 'private':
							case 'protected':
							case 'public':
							case 'static':
							case 'yield':
							case 'let':
								return true;
							default:
								return false;
						}
					};
					Scanner.prototype.isRestrictedWord = function (id) {
						return id === 'eval' || id === 'arguments';
					};
					// https://tc39.github.io/ecma262/#sec-keywords
					Scanner.prototype.isKeyword = function (id) {
						switch (id.length) {
							case 2:
								return id === 'if' || id === 'in' || id === 'do';
							case 3:
								return id === 'var' || id === 'for' || id === 'new' || id === 'try' || id === 'let';
							case 4:
								return id === 'this' || id === 'else' || id === 'case' || id === 'void' || id === 'with' || id === 'enum';
							case 5:
								return id === 'while' || id === 'break' || id === 'catch' || id === 'throw' || id === 'const' || id === 'yield' || id === 'class' || id === 'super';
							case 6:
								return id === 'return' || id === 'typeof' || id === 'delete' || id === 'switch' || id === 'export' || id === 'import';
							case 7:
								return id === 'default' || id === 'finally' || id === 'extends';
							case 8:
								return id === 'function' || id === 'continue' || id === 'debugger';
							case 10:
								return id === 'instanceof';
							default:
								return false;
						}
					};
					Scanner.prototype.codePointAt = function (i) {
						var cp = this.source.charCodeAt(i);
						if (cp >= 0xD800 && cp <= 0xDBFF) {
							var second = this.source.charCodeAt(i + 1);
							if (second >= 0xDC00 && second <= 0xDFFF) {
								var first = cp;
								cp = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
							}
						}
						return cp;
					};
					Scanner.prototype.scanHexEscape = function (prefix) {
						var len = prefix === 'u' ? 4 : 2;
						var code = 0;
						for (var i = 0; i < len; ++i) {
							if (!this.eof() && character_1.Character.isHexDigit(this.source.charCodeAt(this.index))) {
								code = code * 16 + hexValue(this.source[this.index++]);
							} else {
								return null;
							}
						}
						return String.fromCharCode(code);
					};
					Scanner.prototype.scanUnicodeCodePointEscape = function () {
						var ch = this.source[this.index];
						var code = 0;
						// At least, one hex digit is required.
						if (ch === '}') {
							this.throwUnexpectedToken();
						}
						while (!this.eof()) {
							ch = this.source[this.index++];
							if (!character_1.Character.isHexDigit(ch.charCodeAt(0))) {
								break;
							}
							code = code * 16 + hexValue(ch);
						}
						if (code > 0x10FFFF || ch !== '}') {
							this.throwUnexpectedToken();
						}
						return character_1.Character.fromCodePoint(code);
					};
					Scanner.prototype.getIdentifier = function () {
						var start = this.index++;
						while (!this.eof()) {
							var ch = this.source.charCodeAt(this.index);
							if (ch === 0x5C) {
								// Blackslash (U+005C) marks Unicode escape sequence.
								this.index = start;
								return this.getComplexIdentifier();
							} else if (ch >= 0xD800 && ch < 0xDFFF) {
								// Need to handle surrogate pairs.
								this.index = start;
								return this.getComplexIdentifier();
							}
							if (character_1.Character.isIdentifierPart(ch)) {
								++this.index;
							} else {
								break;
							}
						}
						return this.source.slice(start, this.index);
					};
					Scanner.prototype.getComplexIdentifier = function () {
						var cp = this.codePointAt(this.index);
						var id = character_1.Character.fromCodePoint(cp);
						this.index += id.length;
						// '\u' (U+005C, U+0075) denotes an escaped character.
						var ch;
						if (cp === 0x5C) {
							if (this.source.charCodeAt(this.index) !== 0x75) {
								this.throwUnexpectedToken();
							}
							++this.index;
							if (this.source[this.index] === '{') {
								++this.index;
								ch = this.scanUnicodeCodePointEscape();
							} else {
								ch = this.scanHexEscape('u');
								if (ch === null || ch === '\\' || !character_1.Character.isIdentifierStart(ch.charCodeAt(0))) {
									this.throwUnexpectedToken();
								}
							}
							id = ch;
						}
						while (!this.eof()) {
							cp = this.codePointAt(this.index);
							if (!character_1.Character.isIdentifierPart(cp)) {
								break;
							}
							ch = character_1.Character.fromCodePoint(cp);
							id += ch;
							this.index += ch.length;
							// '\u' (U+005C, U+0075) denotes an escaped character.
							if (cp === 0x5C) {
								id = id.substr(0, id.length - 1);
								if (this.source.charCodeAt(this.index) !== 0x75) {
									this.throwUnexpectedToken();
								}
								++this.index;
								if (this.source[this.index] === '{') {
									++this.index;
									ch = this.scanUnicodeCodePointEscape();
								} else {
									ch = this.scanHexEscape('u');
									if (ch === null || ch === '\\' || !character_1.Character.isIdentifierPart(ch.charCodeAt(0))) {
										this.throwUnexpectedToken();
									}
								}
								id += ch;
							}
						}
						return id;
					};
					Scanner.prototype.octalToDecimal = function (ch) {
						// \0 is not octal escape sequence
						var octal = ch !== '0';
						var code = octalValue(ch);
						if (!this.eof() && character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
							octal = true;
							code = code * 8 + octalValue(this.source[this.index++]);
							// 3 digits are only allowed when string starts
							// with 0, 1, 2, 3
							if ('0123'.indexOf(ch) >= 0 && !this.eof() && character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
								code = code * 8 + octalValue(this.source[this.index++]);
							}
						}
						return {
							code: code,
							octal: octal
						};
					};
					// https://tc39.github.io/ecma262/#sec-names-and-keywords
					Scanner.prototype.scanIdentifier = function () {
						var type;
						var start = this.index;
						// Backslash (U+005C) starts an escaped character.
						var id = this.source.charCodeAt(start) === 0x5C ? this.getComplexIdentifier() : this.getIdentifier();
						// There is no keyword or literal with only one character.
						// Thus, it must be an identifier.
						if (id.length === 1) {
							type = 3 /* Identifier */;
						} else if (this.isKeyword(id)) {
							type = 4 /* Keyword */;
						} else if (id === 'null') {
							type = 5 /* NullLiteral */;
						} else if (id === 'true' || id === 'false') {
							type = 1 /* BooleanLiteral */;
						} else {
							type = 3 /* Identifier */;
						}
						if (type !== 3 /* Identifier */ && start + id.length !== this.index) {
							var restore = this.index;
							this.index = start;
							this.tolerateUnexpectedToken(messages_1.Messages.InvalidEscapedReservedWord);
							this.index = restore;
						}
						return {
							type: type,
							value: id,
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					// https://tc39.github.io/ecma262/#sec-punctuators
					Scanner.prototype.scanPunctuator = function () {
						var start = this.index;
						// Check for most common single-character punctuators.
						var str = this.source[this.index];
						switch (str) {
							case '(':
							case '{':
								if (str === '{') {
									this.curlyStack.push('{');
								}
								++this.index;
								break;
							case '.':
								++this.index;
								if (this.source[this.index] === '.' && this.source[this.index + 1] === '.') {
									// Spread operator: ...
									this.index += 2;
									str = '...';
								}
								break;
							case '}':
								++this.index;
								this.curlyStack.pop();
								break;
							case ')':
							case ';':
							case ',':
							case '[':
							case ']':
							case ':':
							case '?':
							case '~':
								++this.index;
								break;
							default:
								// 4-character punctuator.
								str = this.source.substr(this.index, 4);
								if (str === '>>>=') {
									this.index += 4;
								} else {
									// 3-character punctuators.
									str = str.substr(0, 3);
									if (str === '===' || str === '!==' || str === '>>>' || str === '<<=' || str === '>>=' || str === '**=') {
										this.index += 3;
									} else {
										// 2-character punctuators.
										str = str.substr(0, 2);
										if (str === '&&' || str === '||' || str === '==' || str === '!=' || str === '+=' || str === '-=' || str === '*=' || str === '/=' || str === '++' || str === '--' || str === '<<' || str === '>>' || str === '&=' || str === '|=' || str === '^=' || str === '%=' || str === '<=' || str === '>=' || str === '=>' || str === '**') {
											this.index += 2;
										} else {
											// 1-character punctuators.
											str = this.source[this.index];
											if ('<>=!+-*%&|^/'.indexOf(str) >= 0) {
												++this.index;
											}
										}
									}
								}
						}
						if (this.index === start) {
							this.throwUnexpectedToken();
						}
						return {
							type: 7 /* Punctuator */
							, value: str,
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					// https://tc39.github.io/ecma262/#sec-literals-numeric-literals
					Scanner.prototype.scanHexLiteral = function (start) {
						var num = '';
						while (!this.eof()) {
							if (!character_1.Character.isHexDigit(this.source.charCodeAt(this.index))) {
								break;
							}
							num += this.source[this.index++];
						}
						if (num.length === 0) {
							this.throwUnexpectedToken();
						}
						if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index))) {
							this.throwUnexpectedToken();
						}
						return {
							type: 6 /* NumericLiteral */
							, value: parseInt('0x' + num, 16),
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					Scanner.prototype.scanBinaryLiteral = function (start) {
						var num = '';
						var ch;
						while (!this.eof()) {
							ch = this.source[this.index];
							if (ch !== '0' && ch !== '1') {
								break;
							}
							num += this.source[this.index++];
						}
						if (num.length === 0) {
							// only 0b or 0B
							this.throwUnexpectedToken();
						}
						if (!this.eof()) {
							ch = this.source.charCodeAt(this.index);
							/* istanbul ignore else */
							if (character_1.Character.isIdentifierStart(ch) || character_1.Character.isDecimalDigit(ch)) {
								this.throwUnexpectedToken();
							}
						}
						return {
							type: 6 /* NumericLiteral */
							, value: parseInt(num, 2),
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					Scanner.prototype.scanOctalLiteral = function (prefix, start) {
						var num = '';
						var octal = false;
						if (character_1.Character.isOctalDigit(prefix.charCodeAt(0))) {
							octal = true;
							num = '0' + this.source[this.index++];
						} else {
							++this.index;
						}
						while (!this.eof()) {
							if (!character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
								break;
							}
							num += this.source[this.index++];
						}
						if (!octal && num.length === 0) {
							// only 0o or 0O
							this.throwUnexpectedToken();
						}
						if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index)) || character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
							this.throwUnexpectedToken();
						}
						return {
							type: 6 /* NumericLiteral */
							, value: parseInt(num, 8),
							octal: octal,
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					Scanner.prototype.isImplicitOctalLiteral = function () {
						// Implicit octal, unless there is a non-octal digit.
						// (Annex B.1.1 on Numeric Literals)
						for (var i = this.index + 1; i < this.length; ++i) {
							var ch = this.source[i];
							if (ch === '8' || ch === '9') {
								return false;
							}
							if (!character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
								return true;
							}
						}
						return true;
					};
					Scanner.prototype.scanNumericLiteral = function () {
						var start = this.index;
						var ch = this.source[start];
						assert_1.assert(character_1.Character.isDecimalDigit(ch.charCodeAt(0)) || ch === '.', 'Numeric literal must start with a decimal digit or a decimal point');
						var num = '';
						if (ch !== '.') {
							num = this.source[this.index++];
							ch = this.source[this.index];
							// Hex number starts with '0x'.
							// Octal number starts with '0'.
							// Octal number in ES6 starts with '0o'.
							// Binary number in ES6 starts with '0b'.
							if (num === '0') {
								if (ch === 'x' || ch === 'X') {
									++this.index;
									return this.scanHexLiteral(start);
								}
								if (ch === 'b' || ch === 'B') {
									++this.index;
									return this.scanBinaryLiteral(start);
								}
								if (ch === 'o' || ch === 'O') {
									return this.scanOctalLiteral(ch, start);
								}
								if (ch && character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
									if (this.isImplicitOctalLiteral()) {
										return this.scanOctalLiteral(ch, start);
									}
								}
							}
							while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
								num += this.source[this.index++];
							}
							ch = this.source[this.index];
						}
						if (ch === '.') {
							num += this.source[this.index++];
							while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
								num += this.source[this.index++];
							}
							ch = this.source[this.index];
						}
						if (ch === 'e' || ch === 'E') {
							num += this.source[this.index++];
							ch = this.source[this.index];
							if (ch === '+' || ch === '-') {
								num += this.source[this.index++];
							}
							if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
								while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
									num += this.source[this.index++];
								}
							} else {
								this.throwUnexpectedToken();
							}
						}
						if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index))) {
							this.throwUnexpectedToken();
						}
						return {
							type: 6 /* NumericLiteral */
							, value: parseFloat(num),
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					// https://tc39.github.io/ecma262/#sec-literals-string-literals
					Scanner.prototype.scanStringLiteral = function () {
						var start = this.index;
						var quote = this.source[start];
						assert_1.assert(quote === '\'' || quote === '"', 'String literal must starts with a quote');
						++this.index;
						var octal = false;
						var str = '';
						while (!this.eof()) {
							var ch = this.source[this.index++];
							if (ch === quote) {
								quote = '';
								break;
							} else if (ch === '\\') {
								ch = this.source[this.index++];
								if (!ch || !character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
									switch (ch) {
										case 'u':
											if (this.source[this.index] === '{') {
												++this.index;
												str += this.scanUnicodeCodePointEscape();
											} else {
												var unescaped_1 = this.scanHexEscape(ch);
												if (unescaped_1 === null) {
													this.throwUnexpectedToken();
												}
												str += unescaped_1;
											}
											break;
										case 'x':
											var unescaped = this.scanHexEscape(ch);
											if (unescaped === null) {
												this.throwUnexpectedToken(messages_1.Messages.InvalidHexEscapeSequence);
											}
											str += unescaped;
											break;
										case 'n':
											str += '\n';
											break;
										case 'r':
											str += '\r';
											break;
										case 't':
											str += '\t';
											break;
										case 'b':
											str += '\b';
											break;
										case 'f':
											str += '\f';
											break;
										case 'v':
											str += '\x0B';
											break;
										case '8':
										case '9':
											str += ch;
											this.tolerateUnexpectedToken();
											break;
										default:
											if (ch && character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
												var octToDec = this.octalToDecimal(ch);
												octal = octToDec.octal || octal;
												str += String.fromCharCode(octToDec.code);
											} else {
												str += ch;
											}
											break;
									}
								} else {
									++this.lineNumber;
									if (ch === '\r' && this.source[this.index] === '\n') {
										++this.index;
									}
									this.lineStart = this.index;
								}
							} else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
								break;
							} else {
								str += ch;
							}
						}
						if (quote !== '') {
							this.index = start;
							this.throwUnexpectedToken();
						}
						return {
							type: 8 /* StringLiteral */
							, value: str,
							octal: octal,
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					// https://tc39.github.io/ecma262/#sec-template-literal-lexical-components
					Scanner.prototype.scanTemplate = function () {
						var cooked = '';
						var terminated = false;
						var start = this.index;
						var head = this.source[start] === '`';
						var tail = false;
						var rawOffset = 2;
						++this.index;
						while (!this.eof()) {
							var ch = this.source[this.index++];
							if (ch === '`') {
								rawOffset = 1;
								tail = true;
								terminated = true;
								break;
							} else if (ch === '$') {
								if (this.source[this.index] === '{') {
									this.curlyStack.push('${');
									++this.index;
									terminated = true;
									break;
								}
								cooked += ch;
							} else if (ch === '\\') {
								ch = this.source[this.index++];
								if (!character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
									switch (ch) {
										case 'n':
											cooked += '\n';
											break;
										case 'r':
											cooked += '\r';
											break;
										case 't':
											cooked += '\t';
											break;
										case 'u':
											if (this.source[this.index] === '{') {
												++this.index;
												cooked += this.scanUnicodeCodePointEscape();
											} else {
												var restore = this.index;
												var unescaped_2 = this.scanHexEscape(ch);
												if (unescaped_2 !== null) {
													cooked += unescaped_2;
												} else {
													this.index = restore;
													cooked += ch;
												}
											}
											break;
										case 'x':
											var unescaped = this.scanHexEscape(ch);
											if (unescaped === null) {
												this.throwUnexpectedToken(messages_1.Messages.InvalidHexEscapeSequence);
											}
											cooked += unescaped;
											break;
										case 'b':
											cooked += '\b';
											break;
										case 'f':
											cooked += '\f';
											break;
										case 'v':
											cooked += '\v';
											break;
										default:
											if (ch === '0') {
												if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
													// Illegal: \01 \02 and so on
													this.throwUnexpectedToken(messages_1.Messages.TemplateOctalLiteral);
												}
												cooked += '\0';
											} else if (character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
												// Illegal: \1 \2
												this.throwUnexpectedToken(messages_1.Messages.TemplateOctalLiteral);
											} else {
												cooked += ch;
											}
											break;
									}
								} else {
									++this.lineNumber;
									if (ch === '\r' && this.source[this.index] === '\n') {
										++this.index;
									}
									this.lineStart = this.index;
								}
							} else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
								++this.lineNumber;
								if (ch === '\r' && this.source[this.index] === '\n') {
									++this.index;
								}
								this.lineStart = this.index;
								cooked += '\n';
							} else {
								cooked += ch;
							}
						}
						if (!terminated) {
							this.throwUnexpectedToken();
						}
						if (!head) {
							this.curlyStack.pop();
						}
						return {
							type: 10 /* Template */
							, value: this.source.slice(start + 1, this.index - rawOffset),
							cooked: cooked,
							head: head,
							tail: tail,
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					// https://tc39.github.io/ecma262/#sec-literals-regular-expression-literals
					Scanner.prototype.testRegExp = function (pattern, flags) {
						// The BMP character to use as a replacement for astral symbols when
						// translating an ES6 "u"-flagged pattern to an ES5-compatible
						// approximation.
						// Note: replacing with '\uFFFF' enables false positives in unlikely
						// scenarios. For example, `[\u{1044f}-\u{10440}]` is an invalid
						// pattern that would not be detected by this substitution.
						var astralSubstitute = '\uFFFF';
						var tmp = pattern;
						var self = this;
						if (flags.indexOf('u') >= 0) {
							tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}|\\u([a-fA-F0-9]{4})/g, function ($0, $1, $2) {
								var codePoint = parseInt($1 || $2, 16);
								if (codePoint > 0x10FFFF) {
									self.throwUnexpectedToken(messages_1.Messages.InvalidRegExp);
								}
								if (codePoint <= 0xFFFF) {
									return String.fromCharCode(codePoint);
								}
								return astralSubstitute;
							}).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, astralSubstitute);
						}
						// First, detect invalid regular expressions.
						try {
							RegExp(tmp);
						} catch (e) {
							this.throwUnexpectedToken(messages_1.Messages.InvalidRegExp);
						}
						// Return a regular expression object for this pattern-flag pair, or
						// `null` in case the current environment doesn't support the flags it
						// uses.
						try {
							return new RegExp(pattern, flags);
						} catch (exception) {
							/* istanbul ignore next */
							return null;
						}
					};
					Scanner.prototype.scanRegExpBody = function () {
						var ch = this.source[this.index];
						assert_1.assert(ch === '/', 'Regular expression literal must start with a slash');
						var str = this.source[this.index++];
						var classMarker = false;
						var terminated = false;
						while (!this.eof()) {
							ch = this.source[this.index++];
							str += ch;
							if (ch === '\\') {
								ch = this.source[this.index++];
								// https://tc39.github.io/ecma262/#sec-literals-regular-expression-literals
								if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
									this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
								}
								str += ch;
							} else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
								this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
							} else if (classMarker) {
								if (ch === ']') {
									classMarker = false;
								}
							} else {
								if (ch === '/') {
									terminated = true;
									break;
								} else if (ch === '[') {
									classMarker = true;
								}
							}
						}
						if (!terminated) {
							this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
						}
						// Exclude leading and trailing slash.
						return str.substr(1, str.length - 2);
					};
					Scanner.prototype.scanRegExpFlags = function () {
						var str = '';
						var flags = '';
						while (!this.eof()) {
							var ch = this.source[this.index];
							if (!character_1.Character.isIdentifierPart(ch.charCodeAt(0))) {
								break;
							}
							++this.index;
							if (ch === '\\' && !this.eof()) {
								ch = this.source[this.index];
								if (ch === 'u') {
									++this.index;
									var restore = this.index;
									var char = this.scanHexEscape('u');
									if (char !== null) {
										flags += char;
										for (str += '\\u'; restore < this.index; ++restore) {
											str += this.source[restore];
										}
									} else {
										this.index = restore;
										flags += 'u';
										str += '\\u';
									}
									this.tolerateUnexpectedToken();
								} else {
									str += '\\';
									this.tolerateUnexpectedToken();
								}
							} else {
								flags += ch;
								str += ch;
							}
						}
						return flags;
					};
					Scanner.prototype.scanRegExp = function () {
						var start = this.index;
						var pattern = this.scanRegExpBody();
						var flags = this.scanRegExpFlags();
						var value = this.testRegExp(pattern, flags);
						return {
							type: 9 /* RegularExpression */
							, value: '',
							pattern: pattern,
							flags: flags,
							regex: value,
							lineNumber: this.lineNumber,
							lineStart: this.lineStart,
							start: start,
							end: this.index
						};
					};
					Scanner.prototype.lex = function () {
						if (this.eof()) {
							return {
								type: 2 /* EOF */
								, value: '',
								lineNumber: this.lineNumber,
								lineStart: this.lineStart,
								start: this.index,
								end: this.index
							};
						}
						var cp = this.source.charCodeAt(this.index);
						if (character_1.Character.isIdentifierStart(cp)) {
							return this.scanIdentifier();
						}
						// Very common: ( and ) and ;
						if (cp === 0x28 || cp === 0x29 || cp === 0x3B) {
							return this.scanPunctuator();
						}
						// String literal starts with single quote (U+0027) or double quote (U+0022).
						if (cp === 0x27 || cp === 0x22) {
							return this.scanStringLiteral();
						}
						// Dot (.) U+002E can also start a floating-point number, hence the need
						// to check the next character.
						if (cp === 0x2E) {
							if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index + 1))) {
								return this.scanNumericLiteral();
							}
							return this.scanPunctuator();
						}
						if (character_1.Character.isDecimalDigit(cp)) {
							return this.scanNumericLiteral();
						}
						// Template literals start with ` (U+0060) for template head
						// or } (U+007D) for template middle or template tail.
						if (cp === 0x60 || cp === 0x7D && this.curlyStack[this.curlyStack.length - 1] === '${') {
							return this.scanTemplate();
						}
						// Possible identifier start in a surrogate pair.
						if (cp >= 0xD800 && cp < 0xDFFF) {
							if (character_1.Character.isIdentifierStart(this.codePointAt(this.index))) {
								return this.scanIdentifier();
							}
						}
						return this.scanPunctuator();
					};
					return Scanner;
				}();
				exports.Scanner = Scanner;
	
				/***/
			},
			/* 13 */
			/***/function (module, exports) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				exports.TokenName = {};
				exports.TokenName[1 /* BooleanLiteral */] = 'Boolean';
				exports.TokenName[2 /* EOF */] = '<end>';
				exports.TokenName[3 /* Identifier */] = 'Identifier';
				exports.TokenName[4 /* Keyword */] = 'Keyword';
				exports.TokenName[5 /* NullLiteral */] = 'Null';
				exports.TokenName[6 /* NumericLiteral */] = 'Numeric';
				exports.TokenName[7 /* Punctuator */] = 'Punctuator';
				exports.TokenName[8 /* StringLiteral */] = 'String';
				exports.TokenName[9 /* RegularExpression */] = 'RegularExpression';
				exports.TokenName[10 /* Template */] = 'Template';
	
				/***/
			},
			/* 14 */
			/***/function (module, exports) {
	
				"use strict";
				// Generated by generate-xhtml-entities.js. DO NOT MODIFY!
	
				Object.defineProperty(exports, "__esModule", { value: true });
				exports.XHTMLEntities = {
					quot: '"',
					amp: '&',
					apos: '\'',
					gt: '>',
					nbsp: '\xA0',
					iexcl: '\xA1',
					cent: '\xA2',
					pound: '\xA3',
					curren: '\xA4',
					yen: '\xA5',
					brvbar: '\xA6',
					sect: '\xA7',
					uml: '\xA8',
					copy: '\xA9',
					ordf: '\xAA',
					laquo: '\xAB',
					not: '\xAC',
					shy: '\xAD',
					reg: '\xAE',
					macr: '\xAF',
					deg: '\xB0',
					plusmn: '\xB1',
					sup2: '\xB2',
					sup3: '\xB3',
					acute: '\xB4',
					micro: '\xB5',
					para: '\xB6',
					middot: '\xB7',
					cedil: '\xB8',
					sup1: '\xB9',
					ordm: '\xBA',
					raquo: '\xBB',
					frac14: '\xBC',
					frac12: '\xBD',
					frac34: '\xBE',
					iquest: '\xBF',
					Agrave: '\xC0',
					Aacute: '\xC1',
					Acirc: '\xC2',
					Atilde: '\xC3',
					Auml: '\xC4',
					Aring: '\xC5',
					AElig: '\xC6',
					Ccedil: '\xC7',
					Egrave: '\xC8',
					Eacute: '\xC9',
					Ecirc: '\xCA',
					Euml: '\xCB',
					Igrave: '\xCC',
					Iacute: '\xCD',
					Icirc: '\xCE',
					Iuml: '\xCF',
					ETH: '\xD0',
					Ntilde: '\xD1',
					Ograve: '\xD2',
					Oacute: '\xD3',
					Ocirc: '\xD4',
					Otilde: '\xD5',
					Ouml: '\xD6',
					times: '\xD7',
					Oslash: '\xD8',
					Ugrave: '\xD9',
					Uacute: '\xDA',
					Ucirc: '\xDB',
					Uuml: '\xDC',
					Yacute: '\xDD',
					THORN: '\xDE',
					szlig: '\xDF',
					agrave: '\xE0',
					aacute: '\xE1',
					acirc: '\xE2',
					atilde: '\xE3',
					auml: '\xE4',
					aring: '\xE5',
					aelig: '\xE6',
					ccedil: '\xE7',
					egrave: '\xE8',
					eacute: '\xE9',
					ecirc: '\xEA',
					euml: '\xEB',
					igrave: '\xEC',
					iacute: '\xED',
					icirc: '\xEE',
					iuml: '\xEF',
					eth: '\xF0',
					ntilde: '\xF1',
					ograve: '\xF2',
					oacute: '\xF3',
					ocirc: '\xF4',
					otilde: '\xF5',
					ouml: '\xF6',
					divide: '\xF7',
					oslash: '\xF8',
					ugrave: '\xF9',
					uacute: '\xFA',
					ucirc: '\xFB',
					uuml: '\xFC',
					yacute: '\xFD',
					thorn: '\xFE',
					yuml: '\xFF',
					OElig: '\u0152',
					oelig: '\u0153',
					Scaron: '\u0160',
					scaron: '\u0161',
					Yuml: '\u0178',
					fnof: '\u0192',
					circ: '\u02C6',
					tilde: '\u02DC',
					Alpha: '\u0391',
					Beta: '\u0392',
					Gamma: '\u0393',
					Delta: '\u0394',
					Epsilon: '\u0395',
					Zeta: '\u0396',
					Eta: '\u0397',
					Theta: '\u0398',
					Iota: '\u0399',
					Kappa: '\u039A',
					Lambda: '\u039B',
					Mu: '\u039C',
					Nu: '\u039D',
					Xi: '\u039E',
					Omicron: '\u039F',
					Pi: '\u03A0',
					Rho: '\u03A1',
					Sigma: '\u03A3',
					Tau: '\u03A4',
					Upsilon: '\u03A5',
					Phi: '\u03A6',
					Chi: '\u03A7',
					Psi: '\u03A8',
					Omega: '\u03A9',
					alpha: '\u03B1',
					beta: '\u03B2',
					gamma: '\u03B3',
					delta: '\u03B4',
					epsilon: '\u03B5',
					zeta: '\u03B6',
					eta: '\u03B7',
					theta: '\u03B8',
					iota: '\u03B9',
					kappa: '\u03BA',
					lambda: '\u03BB',
					mu: '\u03BC',
					nu: '\u03BD',
					xi: '\u03BE',
					omicron: '\u03BF',
					pi: '\u03C0',
					rho: '\u03C1',
					sigmaf: '\u03C2',
					sigma: '\u03C3',
					tau: '\u03C4',
					upsilon: '\u03C5',
					phi: '\u03C6',
					chi: '\u03C7',
					psi: '\u03C8',
					omega: '\u03C9',
					thetasym: '\u03D1',
					upsih: '\u03D2',
					piv: '\u03D6',
					ensp: '\u2002',
					emsp: '\u2003',
					thinsp: '\u2009',
					zwnj: '\u200C',
					zwj: '\u200D',
					lrm: '\u200E',
					rlm: '\u200F',
					ndash: '\u2013',
					mdash: '\u2014',
					lsquo: '\u2018',
					rsquo: '\u2019',
					sbquo: '\u201A',
					ldquo: '\u201C',
					rdquo: '\u201D',
					bdquo: '\u201E',
					dagger: '\u2020',
					Dagger: '\u2021',
					bull: '\u2022',
					hellip: '\u2026',
					permil: '\u2030',
					prime: '\u2032',
					Prime: '\u2033',
					lsaquo: '\u2039',
					rsaquo: '\u203A',
					oline: '\u203E',
					frasl: '\u2044',
					euro: '\u20AC',
					image: '\u2111',
					weierp: '\u2118',
					real: '\u211C',
					trade: '\u2122',
					alefsym: '\u2135',
					larr: '\u2190',
					uarr: '\u2191',
					rarr: '\u2192',
					darr: '\u2193',
					harr: '\u2194',
					crarr: '\u21B5',
					lArr: '\u21D0',
					uArr: '\u21D1',
					rArr: '\u21D2',
					dArr: '\u21D3',
					hArr: '\u21D4',
					forall: '\u2200',
					part: '\u2202',
					exist: '\u2203',
					empty: '\u2205',
					nabla: '\u2207',
					isin: '\u2208',
					notin: '\u2209',
					ni: '\u220B',
					prod: '\u220F',
					sum: '\u2211',
					minus: '\u2212',
					lowast: '\u2217',
					radic: '\u221A',
					prop: '\u221D',
					infin: '\u221E',
					ang: '\u2220',
					and: '\u2227',
					or: '\u2228',
					cap: '\u2229',
					cup: '\u222A',
					int: '\u222B',
					there4: '\u2234',
					sim: '\u223C',
					cong: '\u2245',
					asymp: '\u2248',
					ne: '\u2260',
					equiv: '\u2261',
					le: '\u2264',
					ge: '\u2265',
					sub: '\u2282',
					sup: '\u2283',
					nsub: '\u2284',
					sube: '\u2286',
					supe: '\u2287',
					oplus: '\u2295',
					otimes: '\u2297',
					perp: '\u22A5',
					sdot: '\u22C5',
					lceil: '\u2308',
					rceil: '\u2309',
					lfloor: '\u230A',
					rfloor: '\u230B',
					loz: '\u25CA',
					spades: '\u2660',
					clubs: '\u2663',
					hearts: '\u2665',
					diams: '\u2666',
					lang: '\u27E8',
					rang: '\u27E9'
				};
	
				/***/
			},
			/* 15 */
			/***/function (module, exports, __webpack_require__) {
	
				"use strict";
	
				Object.defineProperty(exports, "__esModule", { value: true });
				var error_handler_1 = __webpack_require__(10);
				var scanner_1 = __webpack_require__(12);
				var token_1 = __webpack_require__(13);
				var Reader = function () {
					function Reader() {
						this.values = [];
						this.curly = this.paren = -1;
					}
					// A function following one of those tokens is an expression.
					Reader.prototype.beforeFunctionExpression = function (t) {
						return ['(', '{', '[', 'in', 'typeof', 'instanceof', 'new', 'return', 'case', 'delete', 'throw', 'void',
						// assignment operators
						'=', '+=', '-=', '*=', '**=', '/=', '%=', '<<=', '>>=', '>>>=', '&=', '|=', '^=', ',',
						// binary/unary operators
						'+', '-', '*', '**', '/', '%', '++', '--', '<<', '>>', '>>>', '&', '|', '^', '!', '~', '&&', '||', '?', ':', '===', '==', '>=', '<=', '<', '>', '!=', '!=='].indexOf(t) >= 0;
					};
					// Determine if forward slash (/) is an operator or part of a regular expression
					// https://github.com/mozilla/sweet.js/wiki/design
					Reader.prototype.isRegexStart = function () {
						var previous = this.values[this.values.length - 1];
						var regex = previous !== null;
						switch (previous) {
							case 'this':
							case ']':
								regex = false;
								break;
							case ')':
								var keyword = this.values[this.paren - 1];
								regex = keyword === 'if' || keyword === 'while' || keyword === 'for' || keyword === 'with';
								break;
							case '}':
								// Dividing a function by anything makes little sense,
								// but we have to check for that.
								regex = false;
								if (this.values[this.curly - 3] === 'function') {
									// Anonymous function, e.g. function(){} /42
									var check = this.values[this.curly - 4];
									regex = check ? !this.beforeFunctionExpression(check) : false;
								} else if (this.values[this.curly - 4] === 'function') {
									// Named function, e.g. function f(){} /42/
									var check = this.values[this.curly - 5];
									regex = check ? !this.beforeFunctionExpression(check) : true;
								}
								break;
							default:
								break;
						}
						return regex;
					};
					Reader.prototype.push = function (token) {
						if (token.type === 7 /* Punctuator */ || token.type === 4 /* Keyword */) {
								if (token.value === '{') {
									this.curly = this.values.length;
								} else if (token.value === '(') {
									this.paren = this.values.length;
								}
								this.values.push(token.value);
							} else {
							this.values.push(null);
						}
					};
					return Reader;
				}();
				var Tokenizer = function () {
					function Tokenizer(code, config) {
						this.errorHandler = new error_handler_1.ErrorHandler();
						this.errorHandler.tolerant = config ? typeof config.tolerant === 'boolean' && config.tolerant : false;
						this.scanner = new scanner_1.Scanner(code, this.errorHandler);
						this.scanner.trackComment = config ? typeof config.comment === 'boolean' && config.comment : false;
						this.trackRange = config ? typeof config.range === 'boolean' && config.range : false;
						this.trackLoc = config ? typeof config.loc === 'boolean' && config.loc : false;
						this.buffer = [];
						this.reader = new Reader();
					}
					Tokenizer.prototype.errors = function () {
						return this.errorHandler.errors;
					};
					Tokenizer.prototype.getNextToken = function () {
						if (this.buffer.length === 0) {
							var comments = this.scanner.scanComments();
							if (this.scanner.trackComment) {
								for (var i = 0; i < comments.length; ++i) {
									var e = comments[i];
									var value = this.scanner.source.slice(e.slice[0], e.slice[1]);
									var comment = {
										type: e.multiLine ? 'BlockComment' : 'LineComment',
										value: value
									};
									if (this.trackRange) {
										comment.range = e.range;
									}
									if (this.trackLoc) {
										comment.loc = e.loc;
									}
									this.buffer.push(comment);
								}
							}
							if (!this.scanner.eof()) {
								var loc = void 0;
								if (this.trackLoc) {
									loc = {
										start: {
											line: this.scanner.lineNumber,
											column: this.scanner.index - this.scanner.lineStart
										},
										end: {}
									};
								}
								var startRegex = this.scanner.source[this.scanner.index] === '/' && this.reader.isRegexStart();
								var token = startRegex ? this.scanner.scanRegExp() : this.scanner.lex();
								this.reader.push(token);
								var entry = {
									type: token_1.TokenName[token.type],
									value: this.scanner.source.slice(token.start, token.end)
								};
								if (this.trackRange) {
									entry.range = [token.start, token.end];
								}
								if (this.trackLoc) {
									loc.end = {
										line: this.scanner.lineNumber,
										column: this.scanner.index - this.scanner.lineStart
									};
									entry.loc = loc;
								}
								if (token.type === 9 /* RegularExpression */) {
										var pattern = token.pattern;
										var flags = token.flags;
										entry.regex = { pattern: pattern, flags: flags };
									}
								this.buffer.push(entry);
							}
						}
						return this.buffer.shift();
					};
					return Tokenizer;
				}();
				exports.Tokenizer = Tokenizer;
	
				/***/
			}
			/******/])
		);
	});
	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(240)(module)))

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if ("function" === 'function' && _typeof(__webpack_require__(40)) === 'object' && __webpack_require__(40)) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	})();

/***/ },
/* 615 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(622);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 617 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 618 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(618);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 621 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(621);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 623 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 624 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(125);
	
	var _PathUtils = __webpack_require__(52);
	
	var _createTransitionManager = __webpack_require__(126);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(221);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(125);
	
	var _PathUtils = __webpack_require__(52);
	
	var _createTransitionManager = __webpack_require__(126);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(221);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen,
	    previous: globalHistory
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(52);
	
	var _LocationUtils = __webpack_require__(125);
	
	var _createTransitionManager = __webpack_require__(126);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(78);
	
	var _PathUtils = __webpack_require__(53);
	
	var _createTransitionManager = __webpack_require__(127);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(15);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(78);
	
	var _PathUtils = __webpack_require__(53);
	
	var _createTransitionManager = __webpack_require__(127);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(53);
	
	var _LocationUtils = __webpack_require__(78);
	
	var _createTransitionManager = __webpack_require__(127);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(78);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(53);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(628);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(629);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(630);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.hoistNonReactStatics = factory();
	})(undefined, function () {
	    'use strict';
	
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') {
	            // don't hoist over string (html) components
	
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	
	            var keys = getOwnPropertyNames(sourceComponent);
	
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try {
	                        // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	
	            return targetComponent;
	        }
	
	        return targetComponent;
	    };
	});

/***/ },
/* 633 */
/***/ function(module, exports) {

	"use strict";
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? nBytes - 1 : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & (1 << -nBits) - 1;
	  s >>= -nBits;
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : (s ? -1 : 1) * Infinity;
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	};
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	  var i = isLE ? 0 : nBytes - 1;
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};

/***/ },
/* 634 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	        // closest thing possible to the ECMAScript 5
	        // internal IsCallable function
	        throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP = function fNOP() {},
	        fBound = function fBound() {
	        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
	    };
	
	    if (this.prototype) {
	        // native functions don't have a prototype
	        fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = function () {
	    try {
	        return !!Object.defineProperty({}, 'a', {});
	    } catch (e) {
	        return false;
	    }
	}();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind;
	exports.defineProperty = defineProperty;
	exports.objCreate = objCreate;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                              Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	                                                                                                                                                                                                                                                                              Copyrights licensed under the New BSD License.
	                                                                                                                                                                                                                                                                              See the accompanying LICENSE file for terms.
	                                                                                                                                                                                                                                                                              */
	
	/* jshint esnext: true */
	
	var _es = __webpack_require__(634);
	
	exports.default = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = (0, _es.objCreate)(null);
	
	    return function () {
	        var args = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (_es.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') {
	        return;
	    }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && (typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i] = prop;
	    }
	
	    return props;
	}

/***/ },
/* 636 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() {
	      this.constructor = child;
	    }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message = message;
	    this.expected = expected;
	    this.found = found;
	    this.location = location;
	    this.name = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser = this,
	        peg$FAILED = {},
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction = peg$parsestart,
	        peg$c0 = function peg$c0(elements) {
	      return {
	        type: 'messageFormatPattern',
	        elements: elements,
	        location: location()
	      };
	    },
	        peg$c1 = function peg$c1(text) {
	      var string = '',
	          i,
	          j,
	          outerLen,
	          inner,
	          innerLen;
	
	      for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	        inner = text[i];
	
	        for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	          string += inner[j];
	        }
	      }
	
	      return string;
	    },
	        peg$c2 = function peg$c2(messageText) {
	      return {
	        type: 'messageTextElement',
	        value: messageText,
	        location: location()
	      };
	    },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function peg$c11(id, format) {
	      return {
	        type: 'argumentElement',
	        id: id,
	        format: format && format[2],
	        location: location()
	      };
	    },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function peg$c18(type, style) {
	      return {
	        type: type + 'Format',
	        style: style && style[2],
	        location: location()
	      };
	    },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function peg$c21(pluralStyle) {
	      return {
	        type: pluralStyle.type,
	        ordinal: false,
	        offset: pluralStyle.offset || 0,
	        options: pluralStyle.options,
	        location: location()
	      };
	    },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function peg$c24(pluralStyle) {
	      return {
	        type: pluralStyle.type,
	        ordinal: true,
	        offset: pluralStyle.offset || 0,
	        options: pluralStyle.options,
	        location: location()
	      };
	    },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function peg$c27(options) {
	      return {
	        type: 'selectFormat',
	        options: options,
	        location: location()
	      };
	    },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function peg$c30(selector, pattern) {
	      return {
	        type: 'optionalFormatPattern',
	        selector: selector,
	        value: pattern,
	        location: location()
	      };
	    },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function peg$c33(number) {
	      return number;
	    },
	        peg$c34 = function peg$c34(offset, options) {
	      return {
	        type: 'pluralFormat',
	        offset: offset,
	        options: options,
	        location: location()
	      };
	    },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function peg$c47(digits) {
	      return parseInt(digits, 10);
	    },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function peg$c52() {
	      return '\\';
	    },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function peg$c55() {
	      return '\\#';
	    },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function peg$c58() {
	      return "{";
	    },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function peg$c61() {
	      return "}";
	    },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function peg$c64(digits) {
	      return String.fromCharCode(parseInt(digits, 16));
	    },
	        peg$c65 = function peg$c65(chars) {
	      return chars.join('');
	    },
	        peg$currPos = 0,
	        peg$savedPos = 0,
	        peg$posDetailsCache = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos = 0,
	        peg$maxFailExpected = [],
	        peg$silentFails = 0,
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(null, [{ type: "other", description: description }], input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p,
	          ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line: details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) {
	              details.line++;
	            }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line: startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line: endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) {
	        return;
	      }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function (a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) {
	            return ch.charCodeAt(0).toString(16).toUpperCase();
	          }
	
	          return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\x08/g, '\\b').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\f/g, '\\f').replace(/\r/g, '\\r').replace(/[\x00-\x07\x0B\x0E\x0F]/g, function (ch) {
	            return '\\x0' + hex(ch);
	          }).replace(/[\x10-\x1F\x80-\xFF]/g, function (ch) {
	            return '\\x' + hex(ch);
	          }).replace(/[\u0100-\u0FFF]/g, function (ch) {
	            return "\\u0" + hex(ch);
	          }).replace(/[\u1000-\uFFFF]/g, function (ch) {
	            return "\\u" + hex(ch);
	          });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc,
	            foundDesc,
	            i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1 ? expectedDescs.slice(0, -1).join(", ") + " or " + expectedDescs[expected.length - 1] : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(message !== null ? message : buildMessage(expected, found), expected, found, location);
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c4);
	          }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c4);
	              }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c6);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c8);
	                }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                      peg$fail(peg$c10);
	                    }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c13);
	        }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c15);
	          }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c17);
	            }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c8);
	            }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c20);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c8);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c23);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c8);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c26);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c8);
	            }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c29);
	        }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c6);
	              }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) {
	                        peg$fail(peg$c10);
	                      }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c32);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c37);
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c37);
	            }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c35);
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c38);
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c40);
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c42);
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c44);
	        }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c46);
	          }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) {
	          peg$fail(peg$c49);
	        }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) {
	            peg$fail(peg$c51);
	          }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	              peg$fail(peg$c54);
	            }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) {
	                peg$fail(peg$c57);
	              }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                  peg$fail(peg$c60);
	                }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) {
	                    peg$fail(peg$c63);
	                  }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse: peg$parse
	  };
	}();

/***/ },
/* 637 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	exports.default = Compiler;
	
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales = locales;
	    this.formats = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack = [];
	    this.currentPlural = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(this.currentPlural.id, this.currentPlural.format.offset, this.pluralNumberFormat, element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats = this.formats,
	        locales = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id: element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id: element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id: element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(element.id, format.ordinal, format.offset, options, pluralFn);
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format = element.format,
	        options = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id = id;
	    this.useOrdinal = useOrdinal;
	    this.offset = offset;
	    this.options = options;
	    this.pluralFn = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] || options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id = id;
	    this.offset = offset;
	    this.numberFormat = numberFormat;
	    this.string = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string.replace(/(^|[^\\])#/g, '$1' + number).replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(224);
	
	var _es = __webpack_require__(640);
	
	var _compiler = __webpack_require__(637);
	
	var _compiler2 = _interopRequireDefault(_compiler);
	
	var _intlMessageformatParser = __webpack_require__(636);
	
	var _intlMessageformatParser2 = _interopRequireDefault(_intlMessageformatParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	exports.default = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ? MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    (0, _es.defineProperty)(this, '_locale', { value: this._resolveLocale(locales) });
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        try {
	            return messageFormat._format(pattern, values);
	        } catch (e) {
	            if (e.variableId) {
	                throw new Error('The intl string context variable \'' + e.variableId + '\'' + ' was not provided to the string \'' + message + '\'');
	            } else {
	                throw e;
	            }
	        }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	(0, _es.defineProperty)(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day: 'numeric',
	                year: '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day: 'numeric',
	                year: 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour: 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium': {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	(0, _es.defineProperty)(MessageFormat, '__localeData__', { value: (0, _es.objCreate)(null) });
	(0, _es.defineProperty)(MessageFormat, '__addLocaleData', { value: function value(data) {
	        if (!(data && data.locale)) {
	            throw new Error('Locale data provided to IntlMessageFormat is missing a ' + '`locale` property');
	        }
	
	        MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	    } });
	
	// Defines `__parse()` static method as an exposed private.
	(0, _es.defineProperty)(MessageFormat, '__parse', { value: _intlMessageformatParser2.default.parse });
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	(0, _es.defineProperty)(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable: true,
	    value: undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new _compiler2.default(locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error('Locale data added to IntlMessageFormat is missing a ' + '`pluralRuleFunction` for :' + locale);
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i,
	        len,
	        part,
	        id,
	        value,
	        err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && _utils.hop.call(values, id))) {
	            err = new Error('A value must be provided for: ' + id);
	            err.variableId = id;
	            throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type,
	        mergedType;
	
	    for (type in defaults) {
	        if (!_utils.hop.call(defaults, type)) {
	            continue;
	        }
	
	        mergedFormats[type] = mergedType = (0, _es.objCreate)(defaults[type]);
	
	        if (formats && _utils.hop.call(formats, type)) {
	            (0, _utils.extend)(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error('No locale data has been added to IntlMessageFormat for: ' + locales.join(', ') + ', or the default locale: ' + defaultLocale);
	};

/***/ },
/* 639 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// GENERATED FILE
	exports.default = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  } };

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.objCreate = exports.defineProperty = undefined;
	
	var _utils = __webpack_require__(224);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = function () {
	    try {
	        return !!Object.defineProperty({}, 'a', {});
	    } catch (e) {
	        return false;
	    }
	}(); /*
	     Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	     Copyrights licensed under the New BSD License.
	     See the accompanying LICENSE file for terms.
	     */
	
	/* jslint esnext: true */
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!_utils.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (_utils.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty;
	exports.objCreate = objCreate;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _intlMessageformat = __webpack_require__(223);
	
	var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);
	
	var _diff = __webpack_require__(642);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	var _es = __webpack_require__(644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	var FIELDS = ['second', 'second-short', 'minute', 'minute-short', 'hour', 'hour-short', 'day', 'day-short', 'month', 'month-short', 'year', 'year-short'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if ((0, _es.isArray)(locales)) {
	        locales = locales.concat();
	    }
	
	    (0, _es.defineProperty)(this, '_locale', { value: this._resolveLocale(locales) });
	    (0, _es.defineProperty)(this, '_options', { value: {
	            style: this._resolveStyle(options.style),
	            units: this._isValidUnits(options.units) && options.units
	        } });
	
	    (0, _es.defineProperty)(this, '_locales', { value: locales });
	    (0, _es.defineProperty)(this, '_fields', { value: this._findFields(this._locale) });
	    (0, _es.defineProperty)(this, '_messages', { value: (0, _es.objCreate)(null) });
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	(0, _es.defineProperty)(RelativeFormat, '__localeData__', { value: (0, _es.objCreate)(null) });
	(0, _es.defineProperty)(RelativeFormat, '__addLocaleData', { value: function value(data) {
	        if (!(data && data.locale)) {
	            throw new Error('Locale data provided to IntlRelativeFormat is missing a ' + '`locale` property value');
	        }
	
	        RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	        // Add data to IntlMessageFormat.
	        _intlMessageformat2.default.__addLocaleData(data);
	    } });
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	(0, _es.defineProperty)(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable: true,
	    value: undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	(0, _es.defineProperty)(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45, 'second-short': 45, // seconds to minute
	        minute: 45, 'minute-short': 45, // minutes to hour
	        hour: 22, 'hour-short': 22, // hours to day
	        day: 26, 'day-short': 26, // days to month
	        month: 11, 'month-short': 11 // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style: this._options.style,
	        units: this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future = '';
	    var past = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' + relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' + relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' + 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new _intlMessageformat2.default(message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' + locale);
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : (0, _es.dateNow)();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' + 'in valid range.');
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' + 'in valid range.');
	    }
	
	    var diffReport = (0, _diff2.default)(now, date);
	    var units = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0': Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || _es.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && _es.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' + 'value, did you mean: ' + suggestion);
	        }
	    }
	
	    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' + 'must be one of: "' + FIELDS.join('", "') + '"');
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error('No locale data has been added to IntlRelativeFormat for: ' + locales.join(', ') + ', or the default locale: ' + defaultLocale);
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (_es.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' + 'must be one of: "' + STYLES.join('", "') + '"');
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	    var fields = FIELDS.filter(function (field) {
	        return field.indexOf('-short') < 1;
	    });
	
	    for (i = 0, l = fields.length; i < l; i += 1) {
	        units = fields[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};

/***/ },
/* 642 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to = +to;
	
	    var millisecond = round(to - from),
	        second = round(millisecond / 1000),
	        minute = round(second / 60),
	        hour = round(minute / 60),
	        day = round(hour / 24),
	        week = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month = round(rawYears * 12),
	        year = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second: second,
	        'second-short': second,
	        minute: minute,
	        'minute-short': minute,
	        hour: hour,
	        'hour-short': hour,
	        day: day,
	        'day-short': day,
	        week: week,
	        'week-short': week,
	        month: month,
	        'month-short': month,
	        year: year,
	        'year-short': year
	    };
	};
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}

/***/ },
/* 643 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// GENERATED FILE
	exports.default = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/***/ },
/* 644 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = function () {
	    try {
	        return !!Object.defineProperty({}, 'a', {});
	    } catch (e) {
	        return false;
	    }
	}();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	
	exports.defineProperty = defineProperty;
	exports.objCreate = objCreate;
	exports.arrIndexOf = arrIndexOf;
	exports.isArray = isArray;
	exports.dateNow = dateNow;

/***/ },
/* 645 */
[737, 641, 643],
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(647);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(735);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 647 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 648 */
/***/ function(module, exports) {

	'use strict';
	
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var yaml = __webpack_require__(650);
	
	module.exports = yaml;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var loader = __webpack_require__(652);
	var dumper = __webpack_require__(651);
	
	function deprecated(name) {
	  return function () {
	    throw new Error('Function ' + name + ' is deprecated and cannot be used.');
	  };
	}
	
	module.exports.Type = __webpack_require__(7);
	module.exports.Schema = __webpack_require__(39);
	module.exports.FAILSAFE_SCHEMA = __webpack_require__(128);
	module.exports.JSON_SCHEMA = __webpack_require__(226);
	module.exports.CORE_SCHEMA = __webpack_require__(225);
	module.exports.DEFAULT_SAFE_SCHEMA = __webpack_require__(55);
	module.exports.DEFAULT_FULL_SCHEMA = __webpack_require__(79);
	module.exports.load = loader.load;
	module.exports.loadAll = loader.loadAll;
	module.exports.safeLoad = loader.safeLoad;
	module.exports.safeLoadAll = loader.safeLoadAll;
	module.exports.dump = dumper.dump;
	module.exports.safeDump = dumper.safeDump;
	module.exports.YAMLException = __webpack_require__(54);
	
	// Deprecated schema names from JS-YAML 2.0.x
	module.exports.MINIMAL_SCHEMA = __webpack_require__(128);
	module.exports.SAFE_SCHEMA = __webpack_require__(55);
	module.exports.DEFAULT_SCHEMA = __webpack_require__(79);
	
	// Deprecated functions from JS-YAML 1.x.x
	module.exports.scan = deprecated('scan');
	module.exports.parse = deprecated('parse');
	module.exports.compose = deprecated('compose');
	module.exports.addConstructor = deprecated('addConstructor');

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint-disable no-use-before-define*/
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var common = __webpack_require__(38);
	var YAMLException = __webpack_require__(54);
	var DEFAULT_FULL_SCHEMA = __webpack_require__(79);
	var DEFAULT_SAFE_SCHEMA = __webpack_require__(55);
	
	var _toString = Object.prototype.toString;
	var _hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var CHAR_TAB = 0x09; /* Tab */
	var CHAR_LINE_FEED = 0x0A; /* LF */
	var CHAR_SPACE = 0x20; /* Space */
	var CHAR_EXCLAMATION = 0x21; /* ! */
	var CHAR_DOUBLE_QUOTE = 0x22; /* " */
	var CHAR_SHARP = 0x23; /* # */
	var CHAR_PERCENT = 0x25; /* % */
	var CHAR_AMPERSAND = 0x26; /* & */
	var CHAR_SINGLE_QUOTE = 0x27; /* ' */
	var CHAR_ASTERISK = 0x2A; /* * */
	var CHAR_COMMA = 0x2C; /* , */
	var CHAR_MINUS = 0x2D; /* - */
	var CHAR_COLON = 0x3A; /* : */
	var CHAR_GREATER_THAN = 0x3E; /* > */
	var CHAR_QUESTION = 0x3F; /* ? */
	var CHAR_COMMERCIAL_AT = 0x40; /* @ */
	var CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */
	var CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */
	var CHAR_GRAVE_ACCENT = 0x60; /* ` */
	var CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */
	var CHAR_VERTICAL_LINE = 0x7C; /* | */
	var CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */
	
	var ESCAPE_SEQUENCES = {};
	
	ESCAPE_SEQUENCES[0x00] = '\\0';
	ESCAPE_SEQUENCES[0x07] = '\\a';
	ESCAPE_SEQUENCES[0x08] = '\\b';
	ESCAPE_SEQUENCES[0x09] = '\\t';
	ESCAPE_SEQUENCES[0x0A] = '\\n';
	ESCAPE_SEQUENCES[0x0B] = '\\v';
	ESCAPE_SEQUENCES[0x0C] = '\\f';
	ESCAPE_SEQUENCES[0x0D] = '\\r';
	ESCAPE_SEQUENCES[0x1B] = '\\e';
	ESCAPE_SEQUENCES[0x22] = '\\"';
	ESCAPE_SEQUENCES[0x5C] = '\\\\';
	ESCAPE_SEQUENCES[0x85] = '\\N';
	ESCAPE_SEQUENCES[0xA0] = '\\_';
	ESCAPE_SEQUENCES[0x2028] = '\\L';
	ESCAPE_SEQUENCES[0x2029] = '\\P';
	
	var DEPRECATED_BOOLEANS_SYNTAX = ['y', 'Y', 'yes', 'Yes', 'YES', 'on', 'On', 'ON', 'n', 'N', 'no', 'No', 'NO', 'off', 'Off', 'OFF'];
	
	function compileStyleMap(schema, map) {
	  var result, keys, index, length, tag, style, type;
	
	  if (map === null) return {};
	
	  result = {};
	  keys = Object.keys(map);
	
	  for (index = 0, length = keys.length; index < length; index += 1) {
	    tag = keys[index];
	    style = String(map[tag]);
	
	    if (tag.slice(0, 2) === '!!') {
	      tag = 'tag:yaml.org,2002:' + tag.slice(2);
	    }
	    type = schema.compiledTypeMap['fallback'][tag];
	
	    if (type && _hasOwnProperty.call(type.styleAliases, style)) {
	      style = type.styleAliases[style];
	    }
	
	    result[tag] = style;
	  }
	
	  return result;
	}
	
	function encodeHex(character) {
	  var string, handle, length;
	
	  string = character.toString(16).toUpperCase();
	
	  if (character <= 0xFF) {
	    handle = 'x';
	    length = 2;
	  } else if (character <= 0xFFFF) {
	    handle = 'u';
	    length = 4;
	  } else if (character <= 0xFFFFFFFF) {
	    handle = 'U';
	    length = 8;
	  } else {
	    throw new YAMLException('code point within a string may not be greater than 0xFFFFFFFF');
	  }
	
	  return '\\' + handle + common.repeat('0', length - string.length) + string;
	}
	
	function State(options) {
	  this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
	  this.indent = Math.max(1, options['indent'] || 2);
	  this.skipInvalid = options['skipInvalid'] || false;
	  this.flowLevel = common.isNothing(options['flowLevel']) ? -1 : options['flowLevel'];
	  this.styleMap = compileStyleMap(this.schema, options['styles'] || null);
	  this.sortKeys = options['sortKeys'] || false;
	  this.lineWidth = options['lineWidth'] || 80;
	  this.noRefs = options['noRefs'] || false;
	  this.noCompatMode = options['noCompatMode'] || false;
	  this.condenseFlow = options['condenseFlow'] || false;
	
	  this.implicitTypes = this.schema.compiledImplicit;
	  this.explicitTypes = this.schema.compiledExplicit;
	
	  this.tag = null;
	  this.result = '';
	
	  this.duplicates = [];
	  this.usedDuplicates = null;
	}
	
	// Indents every line in a string. Empty lines (\n only) are not indented.
	function indentString(string, spaces) {
	  var ind = common.repeat(' ', spaces),
	      position = 0,
	      next = -1,
	      result = '',
	      line,
	      length = string.length;
	
	  while (position < length) {
	    next = string.indexOf('\n', position);
	    if (next === -1) {
	      line = string.slice(position);
	      position = length;
	    } else {
	      line = string.slice(position, next + 1);
	      position = next + 1;
	    }
	
	    if (line.length && line !== '\n') result += ind;
	
	    result += line;
	  }
	
	  return result;
	}
	
	function generateNextLine(state, level) {
	  return '\n' + common.repeat(' ', state.indent * level);
	}
	
	function testImplicitResolving(state, str) {
	  var index, length, type;
	
	  for (index = 0, length = state.implicitTypes.length; index < length; index += 1) {
	    type = state.implicitTypes[index];
	
	    if (type.resolve(str)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	// [33] s-white ::= s-space | s-tab
	function isWhitespace(c) {
	  return c === CHAR_SPACE || c === CHAR_TAB;
	}
	
	// Returns true if the character can be printed without escaping.
	// From YAML 1.2: "any allowed characters known to be non-printable
	// should also be escaped. [However,] This isn’t mandatory"
	// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
	function isPrintable(c) {
	  return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== 0xFEFF /* BOM */ || 0x10000 <= c && c <= 0x10FFFF;
	}
	
	// Simplified test for values allowed after the first character in plain style.
	function isPlainSafe(c) {
	  // Uses a subset of nb-char - c-flow-indicator - ":" - "#"
	  // where nb-char ::= c-printable - b-char - c-byte-order-mark.
	  return isPrintable(c) && c !== 0xFEFF
	  // - c-flow-indicator
	  && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET
	  // - ":" - "#"
	  && c !== CHAR_COLON && c !== CHAR_SHARP;
	}
	
	// Simplified test for values allowed as the first character in plain style.
	function isPlainSafeFirst(c) {
	  // Uses a subset of ns-char - c-indicator
	  // where ns-char = nb-char - s-white.
	  return isPrintable(c) && c !== 0xFEFF && !isWhitespace(c) // - s-white
	  // - (c-indicator ::=
	  // “-” | “?” | “:” | “,” | “[” | “]” | “{” | “}”
	  && c !== CHAR_MINUS && c !== CHAR_QUESTION && c !== CHAR_COLON && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET
	  // | “#” | “&” | “*” | “!” | “|” | “>” | “'” | “"”
	  && c !== CHAR_SHARP && c !== CHAR_AMPERSAND && c !== CHAR_ASTERISK && c !== CHAR_EXCLAMATION && c !== CHAR_VERTICAL_LINE && c !== CHAR_GREATER_THAN && c !== CHAR_SINGLE_QUOTE && c !== CHAR_DOUBLE_QUOTE
	  // | “%” | “@” | “`”)
	  && c !== CHAR_PERCENT && c !== CHAR_COMMERCIAL_AT && c !== CHAR_GRAVE_ACCENT;
	}
	
	var STYLE_PLAIN = 1,
	    STYLE_SINGLE = 2,
	    STYLE_LITERAL = 3,
	    STYLE_FOLDED = 4,
	    STYLE_DOUBLE = 5;
	
	// Determines which scalar styles are possible and returns the preferred style.
	// lineWidth = -1 => no limit.
	// Pre-conditions: str.length > 0.
	// Post-conditions:
	//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
	//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
	//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
	function chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType) {
	  var i;
	  var char;
	  var hasLineBreak = false;
	  var hasFoldableLine = false; // only checked if shouldTrackWidth
	  var shouldTrackWidth = lineWidth !== -1;
	  var previousLineBreak = -1; // count the first line correctly
	  var plain = isPlainSafeFirst(string.charCodeAt(0)) && !isWhitespace(string.charCodeAt(string.length - 1));
	
	  if (singleLineOnly) {
	    // Case: no block styles.
	    // Check for disallowed characters to rule out plain and single.
	    for (i = 0; i < string.length; i++) {
	      char = string.charCodeAt(i);
	      if (!isPrintable(char)) {
	        return STYLE_DOUBLE;
	      }
	      plain = plain && isPlainSafe(char);
	    }
	  } else {
	    // Case: block styles permitted.
	    for (i = 0; i < string.length; i++) {
	      char = string.charCodeAt(i);
	      if (char === CHAR_LINE_FEED) {
	        hasLineBreak = true;
	        // Check if any line can be folded.
	        if (shouldTrackWidth) {
	          hasFoldableLine = hasFoldableLine ||
	          // Foldable line = too long, and not more-indented.
	          i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
	          previousLineBreak = i;
	        }
	      } else if (!isPrintable(char)) {
	        return STYLE_DOUBLE;
	      }
	      plain = plain && isPlainSafe(char);
	    }
	    // in case the end is missing a \n
	    hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
	  }
	  // Although every style can represent \n without escaping, prefer block styles
	  // for multiline, since they're more readable and they don't add empty lines.
	  // Also prefer folding a super-long line.
	  if (!hasLineBreak && !hasFoldableLine) {
	    // Strings interpretable as another type have to be quoted;
	    // e.g. the string 'true' vs. the boolean true.
	    return plain && !testAmbiguousType(string) ? STYLE_PLAIN : STYLE_SINGLE;
	  }
	  // Edge case: block indentation indicator can only have one digit.
	  if (string[0] === ' ' && indentPerLevel > 9) {
	    return STYLE_DOUBLE;
	  }
	  // At this point we know block styles are valid.
	  // Prefer literal style unless we want to fold.
	  return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL;
	}
	
	// Note: line breaking/folding is implemented for only the folded style.
	// NB. We drop the last trailing newline (if any) of a returned block scalar
	//  since the dumper adds its own newline. This always works:
	//    • No ending newline => unaffected; already using strip "-" chomping.
	//    • Ending newline    => removed then restored.
	//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
	function writeScalar(state, string, level, iskey) {
	  state.dump = function () {
	    if (string.length === 0) {
	      return "''";
	    }
	    if (!state.noCompatMode && DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1) {
	      return "'" + string + "'";
	    }
	
	    var indent = state.indent * Math.max(1, level); // no 0-indent scalars
	    // As indentation gets deeper, let the width decrease monotonically
	    // to the lower bound min(state.lineWidth, 40).
	    // Note that this implies
	    //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
	    //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
	    // This behaves better than a constant minimum width which disallows narrower options,
	    // or an indent threshold which causes the width to suddenly increase.
	    var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
	
	    // Without knowing if keys are implicit/explicit, assume implicit for safety.
	    var singleLineOnly = iskey
	    // No block styles in flow mode.
	    || state.flowLevel > -1 && level >= state.flowLevel;
	    function testAmbiguity(string) {
	      return testImplicitResolving(state, string);
	    }
	
	    switch (chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity)) {
	      case STYLE_PLAIN:
	        return string;
	      case STYLE_SINGLE:
	        return "'" + string.replace(/'/g, "''") + "'";
	      case STYLE_LITERAL:
	        return '|' + blockHeader(string, state.indent) + dropEndingNewline(indentString(string, indent));
	      case STYLE_FOLDED:
	        return '>' + blockHeader(string, state.indent) + dropEndingNewline(indentString(foldString(string, lineWidth), indent));
	      case STYLE_DOUBLE:
	        return '"' + escapeString(string, lineWidth) + '"';
	      default:
	        throw new YAMLException('impossible error: invalid scalar style');
	    }
	  }();
	}
	
	// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
	function blockHeader(string, indentPerLevel) {
	  var indentIndicator = string[0] === ' ' ? String(indentPerLevel) : '';
	
	  // note the special case: the string '\n' counts as a "trailing" empty line.
	  var clip = string[string.length - 1] === '\n';
	  var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
	  var chomp = keep ? '+' : clip ? '' : '-';
	
	  return indentIndicator + chomp + '\n';
	}
	
	// (See the note for writeScalar.)
	function dropEndingNewline(string) {
	  return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
	}
	
	// Note: a long line without a suitable break point will exceed the width limit.
	// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
	function foldString(string, width) {
	  // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
	  // unless they're before or after a more-indented line, or at the very
	  // beginning or end, in which case $k$ maps to $k$.
	  // Therefore, parse each chunk as newline(s) followed by a content line.
	  var lineRe = /(\n+)([^\n]*)/g;
	
	  // first line (possibly an empty line)
	  var result = function () {
	    var nextLF = string.indexOf('\n');
	    nextLF = nextLF !== -1 ? nextLF : string.length;
	    lineRe.lastIndex = nextLF;
	    return foldLine(string.slice(0, nextLF), width);
	  }();
	  // If we haven't reached the first content line yet, don't add an extra \n.
	  var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
	  var moreIndented;
	
	  // rest of the lines
	  var match;
	  while (match = lineRe.exec(string)) {
	    var prefix = match[1],
	        line = match[2];
	    moreIndented = line[0] === ' ';
	    result += prefix + (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') + foldLine(line, width);
	    prevMoreIndented = moreIndented;
	  }
	
	  return result;
	}
	
	// Greedy line breaking.
	// Picks the longest line under the limit each time,
	// otherwise settles for the shortest line over the limit.
	// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
	function foldLine(line, width) {
	  if (line === '' || line[0] === ' ') return line;
	
	  // Since a more-indented line adds a \n, breaks can't be followed by a space.
	  var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
	  var match;
	  // start is an inclusive index. end, curr, and next are exclusive.
	  var start = 0,
	      end,
	      curr = 0,
	      next = 0;
	  var result = '';
	
	  // Invariants: 0 <= start <= length-1.
	  //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
	  // Inside the loop:
	  //   A match implies length >= 2, so curr and next are <= length-2.
	  while (match = breakRe.exec(line)) {
	    next = match.index;
	    // maintain invariant: curr - start <= width
	    if (next - start > width) {
	      end = curr > start ? curr : next; // derive end <= length-2
	      result += '\n' + line.slice(start, end);
	      // skip the space that was output as \n
	      start = end + 1; // derive start <= length-1
	    }
	    curr = next;
	  }
	
	  // By the invariants, start <= length-1, so there is something left over.
	  // It is either the whole string or a part starting from non-whitespace.
	  result += '\n';
	  // Insert a break if the remainder is too long and there is a break available.
	  if (line.length - start > width && curr > start) {
	    result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
	  } else {
	    result += line.slice(start);
	  }
	
	  return result.slice(1); // drop extra \n joiner
	}
	
	// Escapes a double-quoted string.
	function escapeString(string) {
	  var result = '';
	  var char, nextChar;
	  var escapeSeq;
	
	  for (var i = 0; i < string.length; i++) {
	    char = string.charCodeAt(i);
	    // Check for surrogate pairs (reference Unicode 3.0 section "3.7 Surrogates").
	    if (char >= 0xD800 && char <= 0xDBFF /* high surrogate */) {
	        nextChar = string.charCodeAt(i + 1);
	        if (nextChar >= 0xDC00 && nextChar <= 0xDFFF /* low surrogate */) {
	            // Combine the surrogate pair and store it escaped.
	            result += encodeHex((char - 0xD800) * 0x400 + nextChar - 0xDC00 + 0x10000);
	            // Advance index one extra since we already used that char here.
	            i++;continue;
	          }
	      }
	    escapeSeq = ESCAPE_SEQUENCES[char];
	    result += !escapeSeq && isPrintable(char) ? string[i] : escapeSeq || encodeHex(char);
	  }
	
	  return result;
	}
	
	function writeFlowSequence(state, level, object) {
	  var _result = '',
	      _tag = state.tag,
	      index,
	      length;
	
	  for (index = 0, length = object.length; index < length; index += 1) {
	    // Write only valid elements.
	    if (writeNode(state, level, object[index], false, false)) {
	      if (index !== 0) _result += ',' + (!state.condenseFlow ? ' ' : '');
	      _result += state.dump;
	    }
	  }
	
	  state.tag = _tag;
	  state.dump = '[' + _result + ']';
	}
	
	function writeBlockSequence(state, level, object, compact) {
	  var _result = '',
	      _tag = state.tag,
	      index,
	      length;
	
	  for (index = 0, length = object.length; index < length; index += 1) {
	    // Write only valid elements.
	    if (writeNode(state, level + 1, object[index], true, true)) {
	      if (!compact || index !== 0) {
	        _result += generateNextLine(state, level);
	      }
	
	      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
	        _result += '-';
	      } else {
	        _result += '- ';
	      }
	
	      _result += state.dump;
	    }
	  }
	
	  state.tag = _tag;
	  state.dump = _result || '[]'; // Empty sequence if no valid values.
	}
	
	function writeFlowMapping(state, level, object) {
	  var _result = '',
	      _tag = state.tag,
	      objectKeyList = Object.keys(object),
	      index,
	      length,
	      objectKey,
	      objectValue,
	      pairBuffer;
	
	  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
	    pairBuffer = state.condenseFlow ? '"' : '';
	
	    if (index !== 0) pairBuffer += ', ';
	
	    objectKey = objectKeyList[index];
	    objectValue = object[objectKey];
	
	    if (!writeNode(state, level, objectKey, false, false)) {
	      continue; // Skip this pair because of invalid key;
	    }
	
	    if (state.dump.length > 1024) pairBuffer += '? ';
	
	    pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');
	
	    if (!writeNode(state, level, objectValue, false, false)) {
	      continue; // Skip this pair because of invalid value.
	    }
	
	    pairBuffer += state.dump;
	
	    // Both key and value are valid.
	    _result += pairBuffer;
	  }
	
	  state.tag = _tag;
	  state.dump = '{' + _result + '}';
	}
	
	function writeBlockMapping(state, level, object, compact) {
	  var _result = '',
	      _tag = state.tag,
	      objectKeyList = Object.keys(object),
	      index,
	      length,
	      objectKey,
	      objectValue,
	      explicitPair,
	      pairBuffer;
	
	  // Allow sorting keys so that the output file is deterministic
	  if (state.sortKeys === true) {
	    // Default sorting
	    objectKeyList.sort();
	  } else if (typeof state.sortKeys === 'function') {
	    // Custom sort function
	    objectKeyList.sort(state.sortKeys);
	  } else if (state.sortKeys) {
	    // Something is wrong
	    throw new YAMLException('sortKeys must be a boolean or a function');
	  }
	
	  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
	    pairBuffer = '';
	
	    if (!compact || index !== 0) {
	      pairBuffer += generateNextLine(state, level);
	    }
	
	    objectKey = objectKeyList[index];
	    objectValue = object[objectKey];
	
	    if (!writeNode(state, level + 1, objectKey, true, true, true)) {
	      continue; // Skip this pair because of invalid key.
	    }
	
	    explicitPair = state.tag !== null && state.tag !== '?' || state.dump && state.dump.length > 1024;
	
	    if (explicitPair) {
	      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
	        pairBuffer += '?';
	      } else {
	        pairBuffer += '? ';
	      }
	    }
	
	    pairBuffer += state.dump;
	
	    if (explicitPair) {
	      pairBuffer += generateNextLine(state, level);
	    }
	
	    if (!writeNode(state, level + 1, objectValue, true, explicitPair)) {
	      continue; // Skip this pair because of invalid value.
	    }
	
	    if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
	      pairBuffer += ':';
	    } else {
	      pairBuffer += ': ';
	    }
	
	    pairBuffer += state.dump;
	
	    // Both key and value are valid.
	    _result += pairBuffer;
	  }
	
	  state.tag = _tag;
	  state.dump = _result || '{}'; // Empty mapping if no valid pairs.
	}
	
	function detectType(state, object, explicit) {
	  var _result, typeList, index, length, type, style;
	
	  typeList = explicit ? state.explicitTypes : state.implicitTypes;
	
	  for (index = 0, length = typeList.length; index < length; index += 1) {
	    type = typeList[index];
	
	    if ((type.instanceOf || type.predicate) && (!type.instanceOf || (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
	
	      state.tag = explicit ? type.tag : '?';
	
	      if (type.represent) {
	        style = state.styleMap[type.tag] || type.defaultStyle;
	
	        if (_toString.call(type.represent) === '[object Function]') {
	          _result = type.represent(object, style);
	        } else if (_hasOwnProperty.call(type.represent, style)) {
	          _result = type.represent[style](object, style);
	        } else {
	          throw new YAMLException('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
	        }
	
	        state.dump = _result;
	      }
	
	      return true;
	    }
	  }
	
	  return false;
	}
	
	// Serializes `object` and writes it to global `result`.
	// Returns true on success, or false on invalid object.
	//
	function writeNode(state, level, object, block, compact, iskey) {
	  state.tag = null;
	  state.dump = object;
	
	  if (!detectType(state, object, false)) {
	    detectType(state, object, true);
	  }
	
	  var type = _toString.call(state.dump);
	
	  if (block) {
	    block = state.flowLevel < 0 || state.flowLevel > level;
	  }
	
	  var objectOrArray = type === '[object Object]' || type === '[object Array]',
	      duplicateIndex,
	      duplicate;
	
	  if (objectOrArray) {
	    duplicateIndex = state.duplicates.indexOf(object);
	    duplicate = duplicateIndex !== -1;
	  }
	
	  if (state.tag !== null && state.tag !== '?' || duplicate || state.indent !== 2 && level > 0) {
	    compact = false;
	  }
	
	  if (duplicate && state.usedDuplicates[duplicateIndex]) {
	    state.dump = '*ref_' + duplicateIndex;
	  } else {
	    if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) {
	      state.usedDuplicates[duplicateIndex] = true;
	    }
	    if (type === '[object Object]') {
	      if (block && Object.keys(state.dump).length !== 0) {
	        writeBlockMapping(state, level, state.dump, compact);
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + state.dump;
	        }
	      } else {
	        writeFlowMapping(state, level, state.dump);
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
	        }
	      }
	    } else if (type === '[object Array]') {
	      if (block && state.dump.length !== 0) {
	        writeBlockSequence(state, level, state.dump, compact);
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + state.dump;
	        }
	      } else {
	        writeFlowSequence(state, level, state.dump);
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
	        }
	      }
	    } else if (type === '[object String]') {
	      if (state.tag !== '?') {
	        writeScalar(state, state.dump, level, iskey);
	      }
	    } else {
	      if (state.skipInvalid) return false;
	      throw new YAMLException('unacceptable kind of an object to dump ' + type);
	    }
	
	    if (state.tag !== null && state.tag !== '?') {
	      state.dump = '!<' + state.tag + '> ' + state.dump;
	    }
	  }
	
	  return true;
	}
	
	function getDuplicateReferences(object, state) {
	  var objects = [],
	      duplicatesIndexes = [],
	      index,
	      length;
	
	  inspectNode(object, objects, duplicatesIndexes);
	
	  for (index = 0, length = duplicatesIndexes.length; index < length; index += 1) {
	    state.duplicates.push(objects[duplicatesIndexes[index]]);
	  }
	  state.usedDuplicates = new Array(length);
	}
	
	function inspectNode(object, objects, duplicatesIndexes) {
	  var objectKeyList, index, length;
	
	  if (object !== null && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object') {
	    index = objects.indexOf(object);
	    if (index !== -1) {
	      if (duplicatesIndexes.indexOf(index) === -1) {
	        duplicatesIndexes.push(index);
	      }
	    } else {
	      objects.push(object);
	
	      if (Array.isArray(object)) {
	        for (index = 0, length = object.length; index < length; index += 1) {
	          inspectNode(object[index], objects, duplicatesIndexes);
	        }
	      } else {
	        objectKeyList = Object.keys(object);
	
	        for (index = 0, length = objectKeyList.length; index < length; index += 1) {
	          inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
	        }
	      }
	    }
	  }
	}
	
	function dump(input, options) {
	  options = options || {};
	
	  var state = new State(options);
	
	  if (!state.noRefs) getDuplicateReferences(input, state);
	
	  if (writeNode(state, 0, input, true, true)) return state.dump + '\n';
	
	  return '';
	}
	
	function safeDump(input, options) {
	  return dump(input, common.extend({ schema: DEFAULT_SAFE_SCHEMA }, options));
	}
	
	module.exports.dump = dump;
	module.exports.safeDump = safeDump;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint-disable max-len,no-use-before-define*/
	
	var common = __webpack_require__(38);
	var YAMLException = __webpack_require__(54);
	var Mark = __webpack_require__(653);
	var DEFAULT_SAFE_SCHEMA = __webpack_require__(55);
	var DEFAULT_FULL_SCHEMA = __webpack_require__(79);
	
	var _hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var CONTEXT_FLOW_IN = 1;
	var CONTEXT_FLOW_OUT = 2;
	var CONTEXT_BLOCK_IN = 3;
	var CONTEXT_BLOCK_OUT = 4;
	
	var CHOMPING_CLIP = 1;
	var CHOMPING_STRIP = 2;
	var CHOMPING_KEEP = 3;
	
	var PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
	var PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
	var PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
	var PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
	
	function is_EOL(c) {
	  return c === 0x0A /* LF */ || c === 0x0D /* CR */;
	}
	
	function is_WHITE_SPACE(c) {
	  return c === 0x09 /* Tab */ || c === 0x20 /* Space */;
	}
	
	function is_WS_OR_EOL(c) {
	  return c === 0x09 /* Tab */ || c === 0x20 /* Space */ || c === 0x0A /* LF */ || c === 0x0D /* CR */;
	}
	
	function is_FLOW_INDICATOR(c) {
	  return c === 0x2C /* , */ || c === 0x5B /* [ */ || c === 0x5D /* ] */ || c === 0x7B /* { */ || c === 0x7D /* } */;
	}
	
	function fromHexCode(c) {
	  var lc;
	
	  if (0x30 /* 0 */ <= c && c <= 0x39 /* 9 */) {
	    return c - 0x30;
	  }
	
	  /*eslint-disable no-bitwise*/
	  lc = c | 0x20;
	
	  if (0x61 /* a */ <= lc && lc <= 0x66 /* f */) {
	    return lc - 0x61 + 10;
	  }
	
	  return -1;
	}
	
	function escapedHexLen(c) {
	  if (c === 0x78 /* x */) {
	      return 2;
	    }
	  if (c === 0x75 /* u */) {
	      return 4;
	    }
	  if (c === 0x55 /* U */) {
	      return 8;
	    }
	  return 0;
	}
	
	function fromDecimalCode(c) {
	  if (0x30 /* 0 */ <= c && c <= 0x39 /* 9 */) {
	    return c - 0x30;
	  }
	
	  return -1;
	}
	
	function simpleEscapeSequence(c) {
	  /* eslint-disable indent */
	  return c === 0x30 /* 0 */ ? '\x00' : c === 0x61 /* a */ ? '\x07' : c === 0x62 /* b */ ? '\x08' : c === 0x74 /* t */ ? '\x09' : c === 0x09 /* Tab */ ? '\x09' : c === 0x6E /* n */ ? '\x0A' : c === 0x76 /* v */ ? '\x0B' : c === 0x66 /* f */ ? '\x0C' : c === 0x72 /* r */ ? '\x0D' : c === 0x65 /* e */ ? '\x1B' : c === 0x20 /* Space */ ? ' ' : c === 0x22 /* " */ ? '\x22' : c === 0x2F /* / */ ? '/' : c === 0x5C /* \ */ ? '\x5C' : c === 0x4E /* N */ ? '\x85' : c === 0x5F /* _ */ ? '\xA0' : c === 0x4C /* L */ ? '\u2028' : c === 0x50 /* P */ ? '\u2029' : '';
	}
	
	function charFromCodepoint(c) {
	  if (c <= 0xFFFF) {
	    return String.fromCharCode(c);
	  }
	  // Encode UTF-16 surrogate pair
	  // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
	  return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
	}
	
	var simpleEscapeCheck = new Array(256); // integer, for fast access
	var simpleEscapeMap = new Array(256);
	for (var i = 0; i < 256; i++) {
	  simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
	  simpleEscapeMap[i] = simpleEscapeSequence(i);
	}
	
	function State(input, options) {
	  this.input = input;
	
	  this.filename = options['filename'] || null;
	  this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
	  this.onWarning = options['onWarning'] || null;
	  this.legacy = options['legacy'] || false;
	  this.json = options['json'] || false;
	  this.listener = options['listener'] || null;
	
	  this.implicitTypes = this.schema.compiledImplicit;
	  this.typeMap = this.schema.compiledTypeMap;
	
	  this.length = input.length;
	  this.position = 0;
	  this.line = 0;
	  this.lineStart = 0;
	  this.lineIndent = 0;
	
	  this.documents = [];
	
	  /*
	  this.version;
	  this.checkLineBreaks;
	  this.tagMap;
	  this.anchorMap;
	  this.tag;
	  this.anchor;
	  this.kind;
	  this.result;*/
	}
	
	function generateError(state, message) {
	  return new YAMLException(message, new Mark(state.filename, state.input, state.position, state.line, state.position - state.lineStart));
	}
	
	function throwError(state, message) {
	  throw generateError(state, message);
	}
	
	function throwWarning(state, message) {
	  if (state.onWarning) {
	    state.onWarning.call(null, generateError(state, message));
	  }
	}
	
	var directiveHandlers = {
	
	  YAML: function handleYamlDirective(state, name, args) {
	
	    var match, major, minor;
	
	    if (state.version !== null) {
	      throwError(state, 'duplication of %YAML directive');
	    }
	
	    if (args.length !== 1) {
	      throwError(state, 'YAML directive accepts exactly one argument');
	    }
	
	    match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
	
	    if (match === null) {
	      throwError(state, 'ill-formed argument of the YAML directive');
	    }
	
	    major = parseInt(match[1], 10);
	    minor = parseInt(match[2], 10);
	
	    if (major !== 1) {
	      throwError(state, 'unacceptable YAML version of the document');
	    }
	
	    state.version = args[0];
	    state.checkLineBreaks = minor < 2;
	
	    if (minor !== 1 && minor !== 2) {
	      throwWarning(state, 'unsupported YAML version of the document');
	    }
	  },
	
	  TAG: function handleTagDirective(state, name, args) {
	
	    var handle, prefix;
	
	    if (args.length !== 2) {
	      throwError(state, 'TAG directive accepts exactly two arguments');
	    }
	
	    handle = args[0];
	    prefix = args[1];
	
	    if (!PATTERN_TAG_HANDLE.test(handle)) {
	      throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
	    }
	
	    if (_hasOwnProperty.call(state.tagMap, handle)) {
	      throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
	    }
	
	    if (!PATTERN_TAG_URI.test(prefix)) {
	      throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
	    }
	
	    state.tagMap[handle] = prefix;
	  }
	};
	
	function captureSegment(state, start, end, checkJson) {
	  var _position, _length, _character, _result;
	
	  if (start < end) {
	    _result = state.input.slice(start, end);
	
	    if (checkJson) {
	      for (_position = 0, _length = _result.length; _position < _length; _position += 1) {
	        _character = _result.charCodeAt(_position);
	        if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) {
	          throwError(state, 'expected valid JSON character');
	        }
	      }
	    } else if (PATTERN_NON_PRINTABLE.test(_result)) {
	      throwError(state, 'the stream contains non-printable characters');
	    }
	
	    state.result += _result;
	  }
	}
	
	function mergeMappings(state, destination, source, overridableKeys) {
	  var sourceKeys, key, index, quantity;
	
	  if (!common.isObject(source)) {
	    throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
	  }
	
	  sourceKeys = Object.keys(source);
	
	  for (index = 0, quantity = sourceKeys.length; index < quantity; index += 1) {
	    key = sourceKeys[index];
	
	    if (!_hasOwnProperty.call(destination, key)) {
	      destination[key] = source[key];
	      overridableKeys[key] = true;
	    }
	  }
	}
	
	function storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startPos) {
	  var index, quantity;
	
	  keyNode = String(keyNode);
	
	  if (_result === null) {
	    _result = {};
	  }
	
	  if (keyTag === 'tag:yaml.org,2002:merge') {
	    if (Array.isArray(valueNode)) {
	      for (index = 0, quantity = valueNode.length; index < quantity; index += 1) {
	        mergeMappings(state, _result, valueNode[index], overridableKeys);
	      }
	    } else {
	      mergeMappings(state, _result, valueNode, overridableKeys);
	    }
	  } else {
	    if (!state.json && !_hasOwnProperty.call(overridableKeys, keyNode) && _hasOwnProperty.call(_result, keyNode)) {
	      state.line = startLine || state.line;
	      state.position = startPos || state.position;
	      throwError(state, 'duplicated mapping key');
	    }
	    _result[keyNode] = valueNode;
	    delete overridableKeys[keyNode];
	  }
	
	  return _result;
	}
	
	function readLineBreak(state) {
	  var ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch === 0x0A /* LF */) {
	      state.position++;
	    } else if (ch === 0x0D /* CR */) {
	      state.position++;
	      if (state.input.charCodeAt(state.position) === 0x0A /* LF */) {
	          state.position++;
	        }
	    } else {
	    throwError(state, 'a line break is expected');
	  }
	
	  state.line += 1;
	  state.lineStart = state.position;
	}
	
	function skipSeparationSpace(state, allowComments, checkIndent) {
	  var lineBreaks = 0,
	      ch = state.input.charCodeAt(state.position);
	
	  while (ch !== 0) {
	    while (is_WHITE_SPACE(ch)) {
	      ch = state.input.charCodeAt(++state.position);
	    }
	
	    if (allowComments && ch === 0x23 /* # */) {
	        do {
	          ch = state.input.charCodeAt(++state.position);
	        } while (ch !== 0x0A /* LF */ && ch !== 0x0D /* CR */ && ch !== 0);
	      }
	
	    if (is_EOL(ch)) {
	      readLineBreak(state);
	
	      ch = state.input.charCodeAt(state.position);
	      lineBreaks++;
	      state.lineIndent = 0;
	
	      while (ch === 0x20 /* Space */) {
	        state.lineIndent++;
	        ch = state.input.charCodeAt(++state.position);
	      }
	    } else {
	      break;
	    }
	  }
	
	  if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) {
	    throwWarning(state, 'deficient indentation');
	  }
	
	  return lineBreaks;
	}
	
	function testDocumentSeparator(state) {
	  var _position = state.position,
	      ch;
	
	  ch = state.input.charCodeAt(_position);
	
	  // Condition state.position === state.lineStart is tested
	  // in parent on each call, for efficiency. No needs to test here again.
	  if ((ch === 0x2D /* - */ || ch === 0x2E /* . */) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
	
	    _position += 3;
	
	    ch = state.input.charCodeAt(_position);
	
	    if (ch === 0 || is_WS_OR_EOL(ch)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function writeFoldedLines(state, count) {
	  if (count === 1) {
	    state.result += ' ';
	  } else if (count > 1) {
	    state.result += common.repeat('\n', count - 1);
	  }
	}
	
	function readPlainScalar(state, nodeIndent, withinFlowCollection) {
	  var preceding,
	      following,
	      captureStart,
	      captureEnd,
	      hasPendingContent,
	      _line,
	      _lineStart,
	      _lineIndent,
	      _kind = state.kind,
	      _result = state.result,
	      ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (is_WS_OR_EOL(ch) || is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */ || ch === 0x26 /* & */ || ch === 0x2A /* * */ || ch === 0x21 /* ! */ || ch === 0x7C /* | */ || ch === 0x3E /* > */ || ch === 0x27 /* ' */ || ch === 0x22 /* " */ || ch === 0x25 /* % */ || ch === 0x40 /* @ */ || ch === 0x60 /* ` */) {
	      return false;
	    }
	
	  if (ch === 0x3F /* ? */ || ch === 0x2D /* - */) {
	      following = state.input.charCodeAt(state.position + 1);
	
	      if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) {
	        return false;
	      }
	    }
	
	  state.kind = 'scalar';
	  state.result = '';
	  captureStart = captureEnd = state.position;
	  hasPendingContent = false;
	
	  while (ch !== 0) {
	    if (ch === 0x3A /* : */) {
	        following = state.input.charCodeAt(state.position + 1);
	
	        if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) {
	          break;
	        }
	      } else if (ch === 0x23 /* # */) {
	        preceding = state.input.charCodeAt(state.position - 1);
	
	        if (is_WS_OR_EOL(preceding)) {
	          break;
	        }
	      } else if (state.position === state.lineStart && testDocumentSeparator(state) || withinFlowCollection && is_FLOW_INDICATOR(ch)) {
	      break;
	    } else if (is_EOL(ch)) {
	      _line = state.line;
	      _lineStart = state.lineStart;
	      _lineIndent = state.lineIndent;
	      skipSeparationSpace(state, false, -1);
	
	      if (state.lineIndent >= nodeIndent) {
	        hasPendingContent = true;
	        ch = state.input.charCodeAt(state.position);
	        continue;
	      } else {
	        state.position = captureEnd;
	        state.line = _line;
	        state.lineStart = _lineStart;
	        state.lineIndent = _lineIndent;
	        break;
	      }
	    }
	
	    if (hasPendingContent) {
	      captureSegment(state, captureStart, captureEnd, false);
	      writeFoldedLines(state, state.line - _line);
	      captureStart = captureEnd = state.position;
	      hasPendingContent = false;
	    }
	
	    if (!is_WHITE_SPACE(ch)) {
	      captureEnd = state.position + 1;
	    }
	
	    ch = state.input.charCodeAt(++state.position);
	  }
	
	  captureSegment(state, captureStart, captureEnd, false);
	
	  if (state.result) {
	    return true;
	  }
	
	  state.kind = _kind;
	  state.result = _result;
	  return false;
	}
	
	function readSingleQuotedScalar(state, nodeIndent) {
	  var ch, captureStart, captureEnd;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch !== 0x27 /* ' */) {
	      return false;
	    }
	
	  state.kind = 'scalar';
	  state.result = '';
	  state.position++;
	  captureStart = captureEnd = state.position;
	
	  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
	    if (ch === 0x27 /* ' */) {
	        captureSegment(state, captureStart, state.position, true);
	        ch = state.input.charCodeAt(++state.position);
	
	        if (ch === 0x27 /* ' */) {
	            captureStart = state.position;
	            state.position++;
	            captureEnd = state.position;
	          } else {
	          return true;
	        }
	      } else if (is_EOL(ch)) {
	      captureSegment(state, captureStart, captureEnd, true);
	      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
	      captureStart = captureEnd = state.position;
	    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
	      throwError(state, 'unexpected end of the document within a single quoted scalar');
	    } else {
	      state.position++;
	      captureEnd = state.position;
	    }
	  }
	
	  throwError(state, 'unexpected end of the stream within a single quoted scalar');
	}
	
	function readDoubleQuotedScalar(state, nodeIndent) {
	  var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch !== 0x22 /* " */) {
	      return false;
	    }
	
	  state.kind = 'scalar';
	  state.result = '';
	  state.position++;
	  captureStart = captureEnd = state.position;
	
	  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
	    if (ch === 0x22 /* " */) {
	        captureSegment(state, captureStart, state.position, true);
	        state.position++;
	        return true;
	      } else if (ch === 0x5C /* \ */) {
	        captureSegment(state, captureStart, state.position, true);
	        ch = state.input.charCodeAt(++state.position);
	
	        if (is_EOL(ch)) {
	          skipSeparationSpace(state, false, nodeIndent);
	
	          // TODO: rework to inline fn with no type cast?
	        } else if (ch < 256 && simpleEscapeCheck[ch]) {
	          state.result += simpleEscapeMap[ch];
	          state.position++;
	        } else if ((tmp = escapedHexLen(ch)) > 0) {
	          hexLength = tmp;
	          hexResult = 0;
	
	          for (; hexLength > 0; hexLength--) {
	            ch = state.input.charCodeAt(++state.position);
	
	            if ((tmp = fromHexCode(ch)) >= 0) {
	              hexResult = (hexResult << 4) + tmp;
	            } else {
	              throwError(state, 'expected hexadecimal character');
	            }
	          }
	
	          state.result += charFromCodepoint(hexResult);
	
	          state.position++;
	        } else {
	          throwError(state, 'unknown escape sequence');
	        }
	
	        captureStart = captureEnd = state.position;
	      } else if (is_EOL(ch)) {
	      captureSegment(state, captureStart, captureEnd, true);
	      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
	      captureStart = captureEnd = state.position;
	    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
	      throwError(state, 'unexpected end of the document within a double quoted scalar');
	    } else {
	      state.position++;
	      captureEnd = state.position;
	    }
	  }
	
	  throwError(state, 'unexpected end of the stream within a double quoted scalar');
	}
	
	function readFlowCollection(state, nodeIndent) {
	  var readNext = true,
	      _line,
	      _tag = state.tag,
	      _result,
	      _anchor = state.anchor,
	      following,
	      terminator,
	      isPair,
	      isExplicitPair,
	      isMapping,
	      overridableKeys = {},
	      keyNode,
	      keyTag,
	      valueNode,
	      ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch === 0x5B /* [ */) {
	      terminator = 0x5D; /* ] */
	      isMapping = false;
	      _result = [];
	    } else if (ch === 0x7B /* { */) {
	      terminator = 0x7D; /* } */
	      isMapping = true;
	      _result = {};
	    } else {
	    return false;
	  }
	
	  if (state.anchor !== null) {
	    state.anchorMap[state.anchor] = _result;
	  }
	
	  ch = state.input.charCodeAt(++state.position);
	
	  while (ch !== 0) {
	    skipSeparationSpace(state, true, nodeIndent);
	
	    ch = state.input.charCodeAt(state.position);
	
	    if (ch === terminator) {
	      state.position++;
	      state.tag = _tag;
	      state.anchor = _anchor;
	      state.kind = isMapping ? 'mapping' : 'sequence';
	      state.result = _result;
	      return true;
	    } else if (!readNext) {
	      throwError(state, 'missed comma between flow collection entries');
	    }
	
	    keyTag = keyNode = valueNode = null;
	    isPair = isExplicitPair = false;
	
	    if (ch === 0x3F /* ? */) {
	        following = state.input.charCodeAt(state.position + 1);
	
	        if (is_WS_OR_EOL(following)) {
	          isPair = isExplicitPair = true;
	          state.position++;
	          skipSeparationSpace(state, true, nodeIndent);
	        }
	      }
	
	    _line = state.line;
	    composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
	    keyTag = state.tag;
	    keyNode = state.result;
	    skipSeparationSpace(state, true, nodeIndent);
	
	    ch = state.input.charCodeAt(state.position);
	
	    if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */) {
	        isPair = true;
	        ch = state.input.charCodeAt(++state.position);
	        skipSeparationSpace(state, true, nodeIndent);
	        composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
	        valueNode = state.result;
	      }
	
	    if (isMapping) {
	      storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode);
	    } else if (isPair) {
	      _result.push(storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode));
	    } else {
	      _result.push(keyNode);
	    }
	
	    skipSeparationSpace(state, true, nodeIndent);
	
	    ch = state.input.charCodeAt(state.position);
	
	    if (ch === 0x2C /* , */) {
	        readNext = true;
	        ch = state.input.charCodeAt(++state.position);
	      } else {
	      readNext = false;
	    }
	  }
	
	  throwError(state, 'unexpected end of the stream within a flow collection');
	}
	
	function readBlockScalar(state, nodeIndent) {
	  var captureStart,
	      folding,
	      chomping = CHOMPING_CLIP,
	      didReadContent = false,
	      detectedIndent = false,
	      textIndent = nodeIndent,
	      emptyLines = 0,
	      atMoreIndented = false,
	      tmp,
	      ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch === 0x7C /* | */) {
	      folding = false;
	    } else if (ch === 0x3E /* > */) {
	      folding = true;
	    } else {
	    return false;
	  }
	
	  state.kind = 'scalar';
	  state.result = '';
	
	  while (ch !== 0) {
	    ch = state.input.charCodeAt(++state.position);
	
	    if (ch === 0x2B /* + */ || ch === 0x2D /* - */) {
	        if (CHOMPING_CLIP === chomping) {
	          chomping = ch === 0x2B /* + */ ? CHOMPING_KEEP : CHOMPING_STRIP;
	        } else {
	          throwError(state, 'repeat of a chomping mode identifier');
	        }
	      } else if ((tmp = fromDecimalCode(ch)) >= 0) {
	      if (tmp === 0) {
	        throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
	      } else if (!detectedIndent) {
	        textIndent = nodeIndent + tmp - 1;
	        detectedIndent = true;
	      } else {
	        throwError(state, 'repeat of an indentation width identifier');
	      }
	    } else {
	      break;
	    }
	  }
	
	  if (is_WHITE_SPACE(ch)) {
	    do {
	      ch = state.input.charCodeAt(++state.position);
	    } while (is_WHITE_SPACE(ch));
	
	    if (ch === 0x23 /* # */) {
	        do {
	          ch = state.input.charCodeAt(++state.position);
	        } while (!is_EOL(ch) && ch !== 0);
	      }
	  }
	
	  while (ch !== 0) {
	    readLineBreak(state);
	    state.lineIndent = 0;
	
	    ch = state.input.charCodeAt(state.position);
	
	    while ((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */) {
	      state.lineIndent++;
	      ch = state.input.charCodeAt(++state.position);
	    }
	
	    if (!detectedIndent && state.lineIndent > textIndent) {
	      textIndent = state.lineIndent;
	    }
	
	    if (is_EOL(ch)) {
	      emptyLines++;
	      continue;
	    }
	
	    // End of the scalar.
	    if (state.lineIndent < textIndent) {
	
	      // Perform the chomping.
	      if (chomping === CHOMPING_KEEP) {
	        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
	      } else if (chomping === CHOMPING_CLIP) {
	        if (didReadContent) {
	          // i.e. only if the scalar is not empty.
	          state.result += '\n';
	        }
	      }
	
	      // Break this `while` cycle and go to the funciton's epilogue.
	      break;
	    }
	
	    // Folded style: use fancy rules to handle line breaks.
	    if (folding) {
	
	      // Lines starting with white space characters (more-indented lines) are not folded.
	      if (is_WHITE_SPACE(ch)) {
	        atMoreIndented = true;
	        // except for the first content line (cf. Example 8.1)
	        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
	
	        // End of more-indented block.
	      } else if (atMoreIndented) {
	        atMoreIndented = false;
	        state.result += common.repeat('\n', emptyLines + 1);
	
	        // Just one line break - perceive as the same line.
	      } else if (emptyLines === 0) {
	        if (didReadContent) {
	          // i.e. only if we have already read some scalar content.
	          state.result += ' ';
	        }
	
	        // Several line breaks - perceive as different lines.
	      } else {
	        state.result += common.repeat('\n', emptyLines);
	      }
	
	      // Literal style: just add exact number of line breaks between content lines.
	    } else {
	      // Keep all line breaks except the header line break.
	      state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
	    }
	
	    didReadContent = true;
	    detectedIndent = true;
	    emptyLines = 0;
	    captureStart = state.position;
	
	    while (!is_EOL(ch) && ch !== 0) {
	      ch = state.input.charCodeAt(++state.position);
	    }
	
	    captureSegment(state, captureStart, state.position, false);
	  }
	
	  return true;
	}
	
	function readBlockSequence(state, nodeIndent) {
	  var _line,
	      _tag = state.tag,
	      _anchor = state.anchor,
	      _result = [],
	      following,
	      detected = false,
	      ch;
	
	  if (state.anchor !== null) {
	    state.anchorMap[state.anchor] = _result;
	  }
	
	  ch = state.input.charCodeAt(state.position);
	
	  while (ch !== 0) {
	
	    if (ch !== 0x2D /* - */) {
	        break;
	      }
	
	    following = state.input.charCodeAt(state.position + 1);
	
	    if (!is_WS_OR_EOL(following)) {
	      break;
	    }
	
	    detected = true;
	    state.position++;
	
	    if (skipSeparationSpace(state, true, -1)) {
	      if (state.lineIndent <= nodeIndent) {
	        _result.push(null);
	        ch = state.input.charCodeAt(state.position);
	        continue;
	      }
	    }
	
	    _line = state.line;
	    composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true);
	    _result.push(state.result);
	    skipSeparationSpace(state, true, -1);
	
	    ch = state.input.charCodeAt(state.position);
	
	    if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) {
	      throwError(state, 'bad indentation of a sequence entry');
	    } else if (state.lineIndent < nodeIndent) {
	      break;
	    }
	  }
	
	  if (detected) {
	    state.tag = _tag;
	    state.anchor = _anchor;
	    state.kind = 'sequence';
	    state.result = _result;
	    return true;
	  }
	  return false;
	}
	
	function readBlockMapping(state, nodeIndent, flowIndent) {
	  var following,
	      allowCompact,
	      _line,
	      _pos,
	      _tag = state.tag,
	      _anchor = state.anchor,
	      _result = {},
	      overridableKeys = {},
	      keyTag = null,
	      keyNode = null,
	      valueNode = null,
	      atExplicitKey = false,
	      detected = false,
	      ch;
	
	  if (state.anchor !== null) {
	    state.anchorMap[state.anchor] = _result;
	  }
	
	  ch = state.input.charCodeAt(state.position);
	
	  while (ch !== 0) {
	    following = state.input.charCodeAt(state.position + 1);
	    _line = state.line; // Save the current line.
	    _pos = state.position;
	
	    //
	    // Explicit notation case. There are two separate blocks:
	    // first for the key (denoted by "?") and second for the value (denoted by ":")
	    //
	    if ((ch === 0x3F /* ? */ || ch === 0x3A /* : */) && is_WS_OR_EOL(following)) {
	
	      if (ch === 0x3F /* ? */) {
	          if (atExplicitKey) {
	            storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
	            keyTag = keyNode = valueNode = null;
	          }
	
	          detected = true;
	          atExplicitKey = true;
	          allowCompact = true;
	        } else if (atExplicitKey) {
	        // i.e. 0x3A/* : */ === character after the explicit key.
	        atExplicitKey = false;
	        allowCompact = true;
	      } else {
	        throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
	      }
	
	      state.position += 1;
	      ch = following;
	
	      //
	      // Implicit notation case. Flow-style node as the key first, then ":", and the value.
	      //
	    } else if (composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
	
	      if (state.line === _line) {
	        ch = state.input.charCodeAt(state.position);
	
	        while (is_WHITE_SPACE(ch)) {
	          ch = state.input.charCodeAt(++state.position);
	        }
	
	        if (ch === 0x3A /* : */) {
	            ch = state.input.charCodeAt(++state.position);
	
	            if (!is_WS_OR_EOL(ch)) {
	              throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
	            }
	
	            if (atExplicitKey) {
	              storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
	              keyTag = keyNode = valueNode = null;
	            }
	
	            detected = true;
	            atExplicitKey = false;
	            allowCompact = false;
	            keyTag = state.tag;
	            keyNode = state.result;
	          } else if (detected) {
	          throwError(state, 'can not read an implicit mapping pair; a colon is missed');
	        } else {
	          state.tag = _tag;
	          state.anchor = _anchor;
	          return true; // Keep the result of `composeNode`.
	        }
	      } else if (detected) {
	        throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');
	      } else {
	        state.tag = _tag;
	        state.anchor = _anchor;
	        return true; // Keep the result of `composeNode`.
	      }
	    } else {
	        break; // Reading is done. Go to the epilogue.
	      }
	
	    //
	    // Common reading code for both explicit and implicit notations.
	    //
	    if (state.line === _line || state.lineIndent > nodeIndent) {
	      if (composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
	        if (atExplicitKey) {
	          keyNode = state.result;
	        } else {
	          valueNode = state.result;
	        }
	      }
	
	      if (!atExplicitKey) {
	        storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _pos);
	        keyTag = keyNode = valueNode = null;
	      }
	
	      skipSeparationSpace(state, true, -1);
	      ch = state.input.charCodeAt(state.position);
	    }
	
	    if (state.lineIndent > nodeIndent && ch !== 0) {
	      throwError(state, 'bad indentation of a mapping entry');
	    } else if (state.lineIndent < nodeIndent) {
	      break;
	    }
	  }
	
	  //
	  // Epilogue.
	  //
	
	  // Special case: last mapping's node contains only the key in explicit notation.
	  if (atExplicitKey) {
	    storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
	  }
	
	  // Expose the resulting mapping.
	  if (detected) {
	    state.tag = _tag;
	    state.anchor = _anchor;
	    state.kind = 'mapping';
	    state.result = _result;
	  }
	
	  return detected;
	}
	
	function readTagProperty(state) {
	  var _position,
	      isVerbatim = false,
	      isNamed = false,
	      tagHandle,
	      tagName,
	      ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch !== 0x21 /* ! */) return false;
	
	  if (state.tag !== null) {
	    throwError(state, 'duplication of a tag property');
	  }
	
	  ch = state.input.charCodeAt(++state.position);
	
	  if (ch === 0x3C /* < */) {
	      isVerbatim = true;
	      ch = state.input.charCodeAt(++state.position);
	    } else if (ch === 0x21 /* ! */) {
	      isNamed = true;
	      tagHandle = '!!';
	      ch = state.input.charCodeAt(++state.position);
	    } else {
	    tagHandle = '!';
	  }
	
	  _position = state.position;
	
	  if (isVerbatim) {
	    do {
	      ch = state.input.charCodeAt(++state.position);
	    } while (ch !== 0 && ch !== 0x3E /* > */);
	
	    if (state.position < state.length) {
	      tagName = state.input.slice(_position, state.position);
	      ch = state.input.charCodeAt(++state.position);
	    } else {
	      throwError(state, 'unexpected end of the stream within a verbatim tag');
	    }
	  } else {
	    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
	
	      if (ch === 0x21 /* ! */) {
	          if (!isNamed) {
	            tagHandle = state.input.slice(_position - 1, state.position + 1);
	
	            if (!PATTERN_TAG_HANDLE.test(tagHandle)) {
	              throwError(state, 'named tag handle cannot contain such characters');
	            }
	
	            isNamed = true;
	            _position = state.position + 1;
	          } else {
	            throwError(state, 'tag suffix cannot contain exclamation marks');
	          }
	        }
	
	      ch = state.input.charCodeAt(++state.position);
	    }
	
	    tagName = state.input.slice(_position, state.position);
	
	    if (PATTERN_FLOW_INDICATORS.test(tagName)) {
	      throwError(state, 'tag suffix cannot contain flow indicator characters');
	    }
	  }
	
	  if (tagName && !PATTERN_TAG_URI.test(tagName)) {
	    throwError(state, 'tag name cannot contain such characters: ' + tagName);
	  }
	
	  if (isVerbatim) {
	    state.tag = tagName;
	  } else if (_hasOwnProperty.call(state.tagMap, tagHandle)) {
	    state.tag = state.tagMap[tagHandle] + tagName;
	  } else if (tagHandle === '!') {
	    state.tag = '!' + tagName;
	  } else if (tagHandle === '!!') {
	    state.tag = 'tag:yaml.org,2002:' + tagName;
	  } else {
	    throwError(state, 'undeclared tag handle "' + tagHandle + '"');
	  }
	
	  return true;
	}
	
	function readAnchorProperty(state) {
	  var _position, ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch !== 0x26 /* & */) return false;
	
	  if (state.anchor !== null) {
	    throwError(state, 'duplication of an anchor property');
	  }
	
	  ch = state.input.charCodeAt(++state.position);
	  _position = state.position;
	
	  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
	    ch = state.input.charCodeAt(++state.position);
	  }
	
	  if (state.position === _position) {
	    throwError(state, 'name of an anchor node must contain at least one character');
	  }
	
	  state.anchor = state.input.slice(_position, state.position);
	  return true;
	}
	
	function readAlias(state) {
	  var _position, alias, ch;
	
	  ch = state.input.charCodeAt(state.position);
	
	  if (ch !== 0x2A /* * */) return false;
	
	  ch = state.input.charCodeAt(++state.position);
	  _position = state.position;
	
	  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
	    ch = state.input.charCodeAt(++state.position);
	  }
	
	  if (state.position === _position) {
	    throwError(state, 'name of an alias node must contain at least one character');
	  }
	
	  alias = state.input.slice(_position, state.position);
	
	  if (!state.anchorMap.hasOwnProperty(alias)) {
	    throwError(state, 'unidentified alias "' + alias + '"');
	  }
	
	  state.result = state.anchorMap[alias];
	  skipSeparationSpace(state, true, -1);
	  return true;
	}
	
	function composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
	  var allowBlockStyles,
	      allowBlockScalars,
	      allowBlockCollections,
	      indentStatus = 1,
	      // 1: this>parent, 0: this=parent, -1: this<parent
	  atNewLine = false,
	      hasContent = false,
	      typeIndex,
	      typeQuantity,
	      type,
	      flowIndent,
	      blockIndent;
	
	  if (state.listener !== null) {
	    state.listener('open', state);
	  }
	
	  state.tag = null;
	  state.anchor = null;
	  state.kind = null;
	  state.result = null;
	
	  allowBlockStyles = allowBlockScalars = allowBlockCollections = CONTEXT_BLOCK_OUT === nodeContext || CONTEXT_BLOCK_IN === nodeContext;
	
	  if (allowToSeek) {
	    if (skipSeparationSpace(state, true, -1)) {
	      atNewLine = true;
	
	      if (state.lineIndent > parentIndent) {
	        indentStatus = 1;
	      } else if (state.lineIndent === parentIndent) {
	        indentStatus = 0;
	      } else if (state.lineIndent < parentIndent) {
	        indentStatus = -1;
	      }
	    }
	  }
	
	  if (indentStatus === 1) {
	    while (readTagProperty(state) || readAnchorProperty(state)) {
	      if (skipSeparationSpace(state, true, -1)) {
	        atNewLine = true;
	        allowBlockCollections = allowBlockStyles;
	
	        if (state.lineIndent > parentIndent) {
	          indentStatus = 1;
	        } else if (state.lineIndent === parentIndent) {
	          indentStatus = 0;
	        } else if (state.lineIndent < parentIndent) {
	          indentStatus = -1;
	        }
	      } else {
	        allowBlockCollections = false;
	      }
	    }
	  }
	
	  if (allowBlockCollections) {
	    allowBlockCollections = atNewLine || allowCompact;
	  }
	
	  if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
	    if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) {
	      flowIndent = parentIndent;
	    } else {
	      flowIndent = parentIndent + 1;
	    }
	
	    blockIndent = state.position - state.lineStart;
	
	    if (indentStatus === 1) {
	      if (allowBlockCollections && (readBlockSequence(state, blockIndent) || readBlockMapping(state, blockIndent, flowIndent)) || readFlowCollection(state, flowIndent)) {
	        hasContent = true;
	      } else {
	        if (allowBlockScalars && readBlockScalar(state, flowIndent) || readSingleQuotedScalar(state, flowIndent) || readDoubleQuotedScalar(state, flowIndent)) {
	          hasContent = true;
	        } else if (readAlias(state)) {
	          hasContent = true;
	
	          if (state.tag !== null || state.anchor !== null) {
	            throwError(state, 'alias node should not have any properties');
	          }
	        } else if (readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
	          hasContent = true;
	
	          if (state.tag === null) {
	            state.tag = '?';
	          }
	        }
	
	        if (state.anchor !== null) {
	          state.anchorMap[state.anchor] = state.result;
	        }
	      }
	    } else if (indentStatus === 0) {
	      // Special case: block sequences are allowed to have same indentation level as the parent.
	      // http://www.yaml.org/spec/1.2/spec.html#id2799784
	      hasContent = allowBlockCollections && readBlockSequence(state, blockIndent);
	    }
	  }
	
	  if (state.tag !== null && state.tag !== '!') {
	    if (state.tag === '?') {
	      for (typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1) {
	        type = state.implicitTypes[typeIndex];
	
	        // Implicit resolving is not allowed for non-scalar types, and '?'
	        // non-specific tag is only assigned to plain scalars. So, it isn't
	        // needed to check for 'kind' conformity.
	
	        if (type.resolve(state.result)) {
	          // `state.result` updated in resolver if matched
	          state.result = type.construct(state.result);
	          state.tag = type.tag;
	          if (state.anchor !== null) {
	            state.anchorMap[state.anchor] = state.result;
	          }
	          break;
	        }
	      }
	    } else if (_hasOwnProperty.call(state.typeMap[state.kind || 'fallback'], state.tag)) {
	      type = state.typeMap[state.kind || 'fallback'][state.tag];
	
	      if (state.result !== null && type.kind !== state.kind) {
	        throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
	      }
	
	      if (!type.resolve(state.result)) {
	        // `state.result` updated in resolver if matched
	        throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
	      } else {
	        state.result = type.construct(state.result);
	        if (state.anchor !== null) {
	          state.anchorMap[state.anchor] = state.result;
	        }
	      }
	    } else {
	      throwError(state, 'unknown tag !<' + state.tag + '>');
	    }
	  }
	
	  if (state.listener !== null) {
	    state.listener('close', state);
	  }
	  return state.tag !== null || state.anchor !== null || hasContent;
	}
	
	function readDocument(state) {
	  var documentStart = state.position,
	      _position,
	      directiveName,
	      directiveArgs,
	      hasDirectives = false,
	      ch;
	
	  state.version = null;
	  state.checkLineBreaks = state.legacy;
	  state.tagMap = {};
	  state.anchorMap = {};
	
	  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
	    skipSeparationSpace(state, true, -1);
	
	    ch = state.input.charCodeAt(state.position);
	
	    if (state.lineIndent > 0 || ch !== 0x25 /* % */) {
	        break;
	      }
	
	    hasDirectives = true;
	    ch = state.input.charCodeAt(++state.position);
	    _position = state.position;
	
	    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
	      ch = state.input.charCodeAt(++state.position);
	    }
	
	    directiveName = state.input.slice(_position, state.position);
	    directiveArgs = [];
	
	    if (directiveName.length < 1) {
	      throwError(state, 'directive name must not be less than one character in length');
	    }
	
	    while (ch !== 0) {
	      while (is_WHITE_SPACE(ch)) {
	        ch = state.input.charCodeAt(++state.position);
	      }
	
	      if (ch === 0x23 /* # */) {
	          do {
	            ch = state.input.charCodeAt(++state.position);
	          } while (ch !== 0 && !is_EOL(ch));
	          break;
	        }
	
	      if (is_EOL(ch)) break;
	
	      _position = state.position;
	
	      while (ch !== 0 && !is_WS_OR_EOL(ch)) {
	        ch = state.input.charCodeAt(++state.position);
	      }
	
	      directiveArgs.push(state.input.slice(_position, state.position));
	    }
	
	    if (ch !== 0) readLineBreak(state);
	
	    if (_hasOwnProperty.call(directiveHandlers, directiveName)) {
	      directiveHandlers[directiveName](state, directiveName, directiveArgs);
	    } else {
	      throwWarning(state, 'unknown document directive "' + directiveName + '"');
	    }
	  }
	
	  skipSeparationSpace(state, true, -1);
	
	  if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */ && state.input.charCodeAt(state.position + 1) === 0x2D /* - */ && state.input.charCodeAt(state.position + 2) === 0x2D /* - */) {
	      state.position += 3;
	      skipSeparationSpace(state, true, -1);
	    } else if (hasDirectives) {
	    throwError(state, 'directives end mark is expected');
	  }
	
	  composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
	  skipSeparationSpace(state, true, -1);
	
	  if (state.checkLineBreaks && PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) {
	    throwWarning(state, 'non-ASCII line breaks are interpreted as content');
	  }
	
	  state.documents.push(state.result);
	
	  if (state.position === state.lineStart && testDocumentSeparator(state)) {
	
	    if (state.input.charCodeAt(state.position) === 0x2E /* . */) {
	        state.position += 3;
	        skipSeparationSpace(state, true, -1);
	      }
	    return;
	  }
	
	  if (state.position < state.length - 1) {
	    throwError(state, 'end of the stream or a document separator is expected');
	  } else {
	    return;
	  }
	}
	
	function loadDocuments(input, options) {
	  input = String(input);
	  options = options || {};
	
	  if (input.length !== 0) {
	
	    // Add tailing `\n` if not exists
	    if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */ && input.charCodeAt(input.length - 1) !== 0x0D /* CR */) {
	        input += '\n';
	      }
	
	    // Strip BOM
	    if (input.charCodeAt(0) === 0xFEFF) {
	      input = input.slice(1);
	    }
	  }
	
	  var state = new State(input, options);
	
	  // Use 0 as string terminator. That significantly simplifies bounds check.
	  state.input += '\0';
	
	  while (state.input.charCodeAt(state.position) === 0x20 /* Space */) {
	    state.lineIndent += 1;
	    state.position += 1;
	  }
	
	  while (state.position < state.length - 1) {
	    readDocument(state);
	  }
	
	  return state.documents;
	}
	
	function loadAll(input, iterator, options) {
	  var documents = loadDocuments(input, options),
	      index,
	      length;
	
	  if (typeof iterator !== 'function') {
	    return documents;
	  }
	
	  for (index = 0, length = documents.length; index < length; index += 1) {
	    iterator(documents[index]);
	  }
	}
	
	function load(input, options) {
	  var documents = loadDocuments(input, options);
	
	  if (documents.length === 0) {
	    /*eslint-disable no-undefined*/
	    return undefined;
	  } else if (documents.length === 1) {
	    return documents[0];
	  }
	  throw new YAMLException('expected a single document in the stream, but found more');
	}
	
	function safeLoadAll(input, output, options) {
	  if (typeof output === 'function') {
	    loadAll(input, output, common.extend({ schema: DEFAULT_SAFE_SCHEMA }, options));
	  } else {
	    return loadAll(input, common.extend({ schema: DEFAULT_SAFE_SCHEMA }, options));
	  }
	}
	
	function safeLoad(input, options) {
	  return load(input, common.extend({ schema: DEFAULT_SAFE_SCHEMA }, options));
	}
	
	module.exports.loadAll = loadAll;
	module.exports.load = load;
	module.exports.safeLoadAll = safeLoadAll;
	module.exports.safeLoad = safeLoad;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var common = __webpack_require__(38);
	
	function Mark(name, buffer, position, line, column) {
	  this.name = name;
	  this.buffer = buffer;
	  this.position = position;
	  this.line = line;
	  this.column = column;
	}
	
	Mark.prototype.getSnippet = function getSnippet(indent, maxLength) {
	  var head, start, tail, end, snippet;
	
	  if (!this.buffer) return null;
	
	  indent = indent || 4;
	  maxLength = maxLength || 75;
	
	  head = '';
	  start = this.position;
	
	  while (start > 0 && '\0\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(start - 1)) === -1) {
	    start -= 1;
	    if (this.position - start > maxLength / 2 - 1) {
	      head = ' ... ';
	      start += 5;
	      break;
	    }
	  }
	
	  tail = '';
	  end = this.position;
	
	  while (end < this.buffer.length && '\0\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(end)) === -1) {
	    end += 1;
	    if (end - this.position > maxLength / 2 - 1) {
	      tail = ' ... ';
	      end -= 5;
	      break;
	    }
	  }
	
	  snippet = this.buffer.slice(start, end);
	
	  return common.repeat(' ', indent) + head + snippet + tail + '\n' + common.repeat(' ', indent + this.position - start + head.length) + '^';
	};
	
	Mark.prototype.toString = function toString(compact) {
	  var snippet,
	      where = '';
	
	  if (this.name) {
	    where += 'in "' + this.name + '" ';
	  }
	
	  where += 'at line ' + (this.line + 1) + ', column ' + (this.column + 1);
	
	  if (!compact) {
	    snippet = this.getSnippet();
	
	    if (snippet) {
	      where += ':\n' + snippet;
	    }
	  }
	
	  return where;
	};
	
	module.exports = Mark;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	var require;'use strict';
	
	/*eslint-disable no-bitwise*/
	
	var NodeBuffer;
	
	try {
	  // A trick for browserified version, to not include `Buffer` shim
	  var _require = require;
	  NodeBuffer = __webpack_require__(245).Buffer;
	} catch (__) {}
	
	var Type = __webpack_require__(7);
	
	// [ 64, 65, 66 ] -> [ padding, CR, LF ]
	var BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';
	
	function resolveYamlBinary(data) {
	  if (data === null) return false;
	
	  var code,
	      idx,
	      bitlen = 0,
	      max = data.length,
	      map = BASE64_MAP;
	
	  // Convert one by one.
	  for (idx = 0; idx < max; idx++) {
	    code = map.indexOf(data.charAt(idx));
	
	    // Skip CR/LF
	    if (code > 64) continue;
	
	    // Fail on illegal characters
	    if (code < 0) return false;
	
	    bitlen += 6;
	  }
	
	  // If there are any bits left, source was corrupted
	  return bitlen % 8 === 0;
	}
	
	function constructYamlBinary(data) {
	  var idx,
	      tailbits,
	      input = data.replace(/[\r\n=]/g, ''),
	      // remove CR/LF & padding to simplify scan
	  max = input.length,
	      map = BASE64_MAP,
	      bits = 0,
	      result = [];
	
	  // Collect by 6*4 bits (3 bytes)
	
	  for (idx = 0; idx < max; idx++) {
	    if (idx % 4 === 0 && idx) {
	      result.push(bits >> 16 & 0xFF);
	      result.push(bits >> 8 & 0xFF);
	      result.push(bits & 0xFF);
	    }
	
	    bits = bits << 6 | map.indexOf(input.charAt(idx));
	  }
	
	  // Dump tail
	
	  tailbits = max % 4 * 6;
	
	  if (tailbits === 0) {
	    result.push(bits >> 16 & 0xFF);
	    result.push(bits >> 8 & 0xFF);
	    result.push(bits & 0xFF);
	  } else if (tailbits === 18) {
	    result.push(bits >> 10 & 0xFF);
	    result.push(bits >> 2 & 0xFF);
	  } else if (tailbits === 12) {
	    result.push(bits >> 4 & 0xFF);
	  }
	
	  // Wrap into Buffer for NodeJS and leave Array for browser
	  if (NodeBuffer) {
	    // Support node 6.+ Buffer API when available
	    return NodeBuffer.from ? NodeBuffer.from(result) : new NodeBuffer(result);
	  }
	
	  return result;
	}
	
	function representYamlBinary(object /*, style*/) {
	  var result = '',
	      bits = 0,
	      idx,
	      tail,
	      max = object.length,
	      map = BASE64_MAP;
	
	  // Convert every three bytes to 4 ASCII characters.
	
	  for (idx = 0; idx < max; idx++) {
	    if (idx % 3 === 0 && idx) {
	      result += map[bits >> 18 & 0x3F];
	      result += map[bits >> 12 & 0x3F];
	      result += map[bits >> 6 & 0x3F];
	      result += map[bits & 0x3F];
	    }
	
	    bits = (bits << 8) + object[idx];
	  }
	
	  // Dump tail
	
	  tail = max % 3;
	
	  if (tail === 0) {
	    result += map[bits >> 18 & 0x3F];
	    result += map[bits >> 12 & 0x3F];
	    result += map[bits >> 6 & 0x3F];
	    result += map[bits & 0x3F];
	  } else if (tail === 2) {
	    result += map[bits >> 10 & 0x3F];
	    result += map[bits >> 4 & 0x3F];
	    result += map[bits << 2 & 0x3F];
	    result += map[64];
	  } else if (tail === 1) {
	    result += map[bits >> 2 & 0x3F];
	    result += map[bits << 4 & 0x3F];
	    result += map[64];
	    result += map[64];
	  }
	
	  return result;
	}
	
	function isBinary(object) {
	  return NodeBuffer && NodeBuffer.isBuffer(object);
	}
	
	module.exports = new Type('tag:yaml.org,2002:binary', {
	  kind: 'scalar',
	  resolve: resolveYamlBinary,
	  construct: constructYamlBinary,
	  predicate: isBinary,
	  represent: representYamlBinary
	});

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	function resolveYamlBoolean(data) {
	  if (data === null) return false;
	
	  var max = data.length;
	
	  return max === 4 && (data === 'true' || data === 'True' || data === 'TRUE') || max === 5 && (data === 'false' || data === 'False' || data === 'FALSE');
	}
	
	function constructYamlBoolean(data) {
	  return data === 'true' || data === 'True' || data === 'TRUE';
	}
	
	function isBoolean(object) {
	  return Object.prototype.toString.call(object) === '[object Boolean]';
	}
	
	module.exports = new Type('tag:yaml.org,2002:bool', {
	  kind: 'scalar',
	  resolve: resolveYamlBoolean,
	  construct: constructYamlBoolean,
	  predicate: isBoolean,
	  represent: {
	    lowercase: function lowercase(object) {
	      return object ? 'true' : 'false';
	    },
	    uppercase: function uppercase(object) {
	      return object ? 'TRUE' : 'FALSE';
	    },
	    camelcase: function camelcase(object) {
	      return object ? 'True' : 'False';
	    }
	  },
	  defaultStyle: 'lowercase'
	});

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var common = __webpack_require__(38);
	var Type = __webpack_require__(7);
	
	var YAML_FLOAT_PATTERN = new RegExp(
	// 2.5e4, 2.5 and integers
	'^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?' +
	// .2e4, .2
	// special case, seems not from spec
	'|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?' +
	// 20:59
	'|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*' +
	// .inf
	'|[-+]?\\.(?:inf|Inf|INF)' +
	// .nan
	'|\\.(?:nan|NaN|NAN))$');
	
	function resolveYamlFloat(data) {
	  if (data === null) return false;
	
	  if (!YAML_FLOAT_PATTERN.test(data) ||
	  // Quick hack to not allow integers end with `_`
	  // Probably should update regexp & check speed
	  data[data.length - 1] === '_') {
	    return false;
	  }
	
	  return true;
	}
	
	function constructYamlFloat(data) {
	  var value, sign, base, digits;
	
	  value = data.replace(/_/g, '').toLowerCase();
	  sign = value[0] === '-' ? -1 : 1;
	  digits = [];
	
	  if ('+-'.indexOf(value[0]) >= 0) {
	    value = value.slice(1);
	  }
	
	  if (value === '.inf') {
	    return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
	  } else if (value === '.nan') {
	    return NaN;
	  } else if (value.indexOf(':') >= 0) {
	    value.split(':').forEach(function (v) {
	      digits.unshift(parseFloat(v, 10));
	    });
	
	    value = 0.0;
	    base = 1;
	
	    digits.forEach(function (d) {
	      value += d * base;
	      base *= 60;
	    });
	
	    return sign * value;
	  }
	  return sign * parseFloat(value, 10);
	}
	
	var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
	
	function representYamlFloat(object, style) {
	  var res;
	
	  if (isNaN(object)) {
	    switch (style) {
	      case 'lowercase':
	        return '.nan';
	      case 'uppercase':
	        return '.NAN';
	      case 'camelcase':
	        return '.NaN';
	    }
	  } else if (Number.POSITIVE_INFINITY === object) {
	    switch (style) {
	      case 'lowercase':
	        return '.inf';
	      case 'uppercase':
	        return '.INF';
	      case 'camelcase':
	        return '.Inf';
	    }
	  } else if (Number.NEGATIVE_INFINITY === object) {
	    switch (style) {
	      case 'lowercase':
	        return '-.inf';
	      case 'uppercase':
	        return '-.INF';
	      case 'camelcase':
	        return '-.Inf';
	    }
	  } else if (common.isNegativeZero(object)) {
	    return '-0.0';
	  }
	
	  res = object.toString(10);
	
	  // JS stringifier can build scientific format without dots: 5e-100,
	  // while YAML requres dot: 5.e-100. Fix it with simple hack
	
	  return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
	}
	
	function isFloat(object) {
	  return Object.prototype.toString.call(object) === '[object Number]' && (object % 1 !== 0 || common.isNegativeZero(object));
	}
	
	module.exports = new Type('tag:yaml.org,2002:float', {
	  kind: 'scalar',
	  resolve: resolveYamlFloat,
	  construct: constructYamlFloat,
	  predicate: isFloat,
	  represent: representYamlFloat,
	  defaultStyle: 'lowercase'
	});

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var common = __webpack_require__(38);
	var Type = __webpack_require__(7);
	
	function isHexCode(c) {
	  return 0x30 /* 0 */ <= c && c <= 0x39 /* 9 */ || 0x41 /* A */ <= c && c <= 0x46 /* F */ || 0x61 /* a */ <= c && c <= 0x66 /* f */;
	}
	
	function isOctCode(c) {
	  return 0x30 /* 0 */ <= c && c <= 0x37 /* 7 */;
	}
	
	function isDecCode(c) {
	  return 0x30 /* 0 */ <= c && c <= 0x39 /* 9 */;
	}
	
	function resolveYamlInteger(data) {
	  if (data === null) return false;
	
	  var max = data.length,
	      index = 0,
	      hasDigits = false,
	      ch;
	
	  if (!max) return false;
	
	  ch = data[index];
	
	  // sign
	  if (ch === '-' || ch === '+') {
	    ch = data[++index];
	  }
	
	  if (ch === '0') {
	    // 0
	    if (index + 1 === max) return true;
	    ch = data[++index];
	
	    // base 2, base 8, base 16
	
	    if (ch === 'b') {
	      // base 2
	      index++;
	
	      for (; index < max; index++) {
	        ch = data[index];
	        if (ch === '_') continue;
	        if (ch !== '0' && ch !== '1') return false;
	        hasDigits = true;
	      }
	      return hasDigits && ch !== '_';
	    }
	
	    if (ch === 'x') {
	      // base 16
	      index++;
	
	      for (; index < max; index++) {
	        ch = data[index];
	        if (ch === '_') continue;
	        if (!isHexCode(data.charCodeAt(index))) return false;
	        hasDigits = true;
	      }
	      return hasDigits && ch !== '_';
	    }
	
	    // base 8
	    for (; index < max; index++) {
	      ch = data[index];
	      if (ch === '_') continue;
	      if (!isOctCode(data.charCodeAt(index))) return false;
	      hasDigits = true;
	    }
	    return hasDigits && ch !== '_';
	  }
	
	  // base 10 (except 0) or base 60
	
	  // value should not start with `_`;
	  if (ch === '_') return false;
	
	  for (; index < max; index++) {
	    ch = data[index];
	    if (ch === '_') continue;
	    if (ch === ':') break;
	    if (!isDecCode(data.charCodeAt(index))) {
	      return false;
	    }
	    hasDigits = true;
	  }
	
	  // Should have digits and should not end with `_`
	  if (!hasDigits || ch === '_') return false;
	
	  // if !base60 - done;
	  if (ch !== ':') return true;
	
	  // base60 almost not used, no needs to optimize
	  return (/^(:[0-5]?[0-9])+$/.test(data.slice(index))
	  );
	}
	
	function constructYamlInteger(data) {
	  var value = data,
	      sign = 1,
	      ch,
	      base,
	      digits = [];
	
	  if (value.indexOf('_') !== -1) {
	    value = value.replace(/_/g, '');
	  }
	
	  ch = value[0];
	
	  if (ch === '-' || ch === '+') {
	    if (ch === '-') sign = -1;
	    value = value.slice(1);
	    ch = value[0];
	  }
	
	  if (value === '0') return 0;
	
	  if (ch === '0') {
	    if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
	    if (value[1] === 'x') return sign * parseInt(value, 16);
	    return sign * parseInt(value, 8);
	  }
	
	  if (value.indexOf(':') !== -1) {
	    value.split(':').forEach(function (v) {
	      digits.unshift(parseInt(v, 10));
	    });
	
	    value = 0;
	    base = 1;
	
	    digits.forEach(function (d) {
	      value += d * base;
	      base *= 60;
	    });
	
	    return sign * value;
	  }
	
	  return sign * parseInt(value, 10);
	}
	
	function isInteger(object) {
	  return Object.prototype.toString.call(object) === '[object Number]' && object % 1 === 0 && !common.isNegativeZero(object);
	}
	
	module.exports = new Type('tag:yaml.org,2002:int', {
	  kind: 'scalar',
	  resolve: resolveYamlInteger,
	  construct: constructYamlInteger,
	  predicate: isInteger,
	  represent: {
	    binary: function binary(obj) {
	      return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1);
	    },
	    octal: function octal(obj) {
	      return obj >= 0 ? '0' + obj.toString(8) : '-0' + obj.toString(8).slice(1);
	    },
	    decimal: function decimal(obj) {
	      return obj.toString(10);
	    },
	    /* eslint-disable max-len */
	    hexadecimal: function hexadecimal(obj) {
	      return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() : '-0x' + obj.toString(16).toUpperCase().slice(1);
	    }
	  },
	  defaultStyle: 'decimal',
	  styleAliases: {
	    binary: [2, 'bin'],
	    octal: [8, 'oct'],
	    decimal: [10, 'dec'],
	    hexadecimal: [16, 'hex']
	  }
	});

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var require;'use strict';
	
	var esprima;
	
	// Browserified version does not have esprima
	//
	// 1. For node.js just require module as deps
	// 2. For browser try to require mudule via external AMD system.
	//    If not found - try to fallback to window.esprima. If not
	//    found too - then fail to parse.
	//
	try {
	  // workaround to exclude package from browserify list.
	  var _require = require;
	  esprima = __webpack_require__(613);
	} catch (_) {
	  /*global window */
	  if (typeof window !== 'undefined') esprima = window.esprima;
	}
	
	var Type = __webpack_require__(7);
	
	function resolveJavascriptFunction(data) {
	  if (data === null) return false;
	
	  try {
	    var source = '(' + data + ')',
	        ast = esprima.parse(source, { range: true });
	
	    if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') {
	      return false;
	    }
	
	    return true;
	  } catch (err) {
	    return false;
	  }
	}
	
	function constructJavascriptFunction(data) {
	  /*jslint evil:true*/
	
	  var source = '(' + data + ')',
	      ast = esprima.parse(source, { range: true }),
	      params = [],
	      body;
	
	  if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') {
	    throw new Error('Failed to resolve function');
	  }
	
	  ast.body[0].expression.params.forEach(function (param) {
	    params.push(param.name);
	  });
	
	  body = ast.body[0].expression.body.range;
	
	  // Esprima's ranges include the first '{' and the last '}' characters on
	  // function expressions. So cut them out.
	  /*eslint-disable no-new-func*/
	  return new Function(params, source.slice(body[0] + 1, body[1] - 1));
	}
	
	function representJavascriptFunction(object /*, style*/) {
	  return object.toString();
	}
	
	function isFunction(object) {
	  return Object.prototype.toString.call(object) === '[object Function]';
	}
	
	module.exports = new Type('tag:yaml.org,2002:js/function', {
	  kind: 'scalar',
	  resolve: resolveJavascriptFunction,
	  construct: constructJavascriptFunction,
	  predicate: isFunction,
	  represent: representJavascriptFunction
	});

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	function resolveJavascriptRegExp(data) {
	  if (data === null) return false;
	  if (data.length === 0) return false;
	
	  var regexp = data,
	      tail = /\/([gim]*)$/.exec(data),
	      modifiers = '';
	
	  // if regexp starts with '/' it can have modifiers and must be properly closed
	  // `/foo/gim` - modifiers tail can be maximum 3 chars
	  if (regexp[0] === '/') {
	    if (tail) modifiers = tail[1];
	
	    if (modifiers.length > 3) return false;
	    // if expression starts with /, is should be properly terminated
	    if (regexp[regexp.length - modifiers.length - 1] !== '/') return false;
	  }
	
	  return true;
	}
	
	function constructJavascriptRegExp(data) {
	  var regexp = data,
	      tail = /\/([gim]*)$/.exec(data),
	      modifiers = '';
	
	  // `/foo/gim` - tail can be maximum 4 chars
	  if (regexp[0] === '/') {
	    if (tail) modifiers = tail[1];
	    regexp = regexp.slice(1, regexp.length - modifiers.length - 1);
	  }
	
	  return new RegExp(regexp, modifiers);
	}
	
	function representJavascriptRegExp(object /*, style*/) {
	  var result = '/' + object.source + '/';
	
	  if (object.global) result += 'g';
	  if (object.multiline) result += 'm';
	  if (object.ignoreCase) result += 'i';
	
	  return result;
	}
	
	function isRegExp(object) {
	  return Object.prototype.toString.call(object) === '[object RegExp]';
	}
	
	module.exports = new Type('tag:yaml.org,2002:js/regexp', {
	  kind: 'scalar',
	  resolve: resolveJavascriptRegExp,
	  construct: constructJavascriptRegExp,
	  predicate: isRegExp,
	  represent: representJavascriptRegExp
	});

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	function resolveJavascriptUndefined() {
	  return true;
	}
	
	function constructJavascriptUndefined() {
	  /*eslint-disable no-undefined*/
	  return undefined;
	}
	
	function representJavascriptUndefined() {
	  return '';
	}
	
	function isUndefined(object) {
	  return typeof object === 'undefined';
	}
	
	module.exports = new Type('tag:yaml.org,2002:js/undefined', {
	  kind: 'scalar',
	  resolve: resolveJavascriptUndefined,
	  construct: constructJavascriptUndefined,
	  predicate: isUndefined,
	  represent: representJavascriptUndefined
	});

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	module.exports = new Type('tag:yaml.org,2002:map', {
	  kind: 'mapping',
	  construct: function construct(data) {
	    return data !== null ? data : {};
	  }
	});

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	function resolveYamlMerge(data) {
	  return data === '<<' || data === null;
	}
	
	module.exports = new Type('tag:yaml.org,2002:merge', {
	  kind: 'scalar',
	  resolve: resolveYamlMerge
	});

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	function resolveYamlNull(data) {
	  if (data === null) return true;
	
	  var max = data.length;
	
	  return max === 1 && data === '~' || max === 4 && (data === 'null' || data === 'Null' || data === 'NULL');
	}
	
	function constructYamlNull() {
	  return null;
	}
	
	function isNull(object) {
	  return object === null;
	}
	
	module.exports = new Type('tag:yaml.org,2002:null', {
	  kind: 'scalar',
	  resolve: resolveYamlNull,
	  construct: constructYamlNull,
	  predicate: isNull,
	  represent: {
	    canonical: function canonical() {
	      return '~';
	    },
	    lowercase: function lowercase() {
	      return 'null';
	    },
	    uppercase: function uppercase() {
	      return 'NULL';
	    },
	    camelcase: function camelcase() {
	      return 'Null';
	    }
	  },
	  defaultStyle: 'lowercase'
	});

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	var _hasOwnProperty = Object.prototype.hasOwnProperty;
	var _toString = Object.prototype.toString;
	
	function resolveYamlOmap(data) {
	  if (data === null) return true;
	
	  var objectKeys = [],
	      index,
	      length,
	      pair,
	      pairKey,
	      pairHasKey,
	      object = data;
	
	  for (index = 0, length = object.length; index < length; index += 1) {
	    pair = object[index];
	    pairHasKey = false;
	
	    if (_toString.call(pair) !== '[object Object]') return false;
	
	    for (pairKey in pair) {
	      if (_hasOwnProperty.call(pair, pairKey)) {
	        if (!pairHasKey) pairHasKey = true;else return false;
	      }
	    }
	
	    if (!pairHasKey) return false;
	
	    if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);else return false;
	  }
	
	  return true;
	}
	
	function constructYamlOmap(data) {
	  return data !== null ? data : [];
	}
	
	module.exports = new Type('tag:yaml.org,2002:omap', {
	  kind: 'sequence',
	  resolve: resolveYamlOmap,
	  construct: constructYamlOmap
	});

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	var _toString = Object.prototype.toString;
	
	function resolveYamlPairs(data) {
	  if (data === null) return true;
	
	  var index,
	      length,
	      pair,
	      keys,
	      result,
	      object = data;
	
	  result = new Array(object.length);
	
	  for (index = 0, length = object.length; index < length; index += 1) {
	    pair = object[index];
	
	    if (_toString.call(pair) !== '[object Object]') return false;
	
	    keys = Object.keys(pair);
	
	    if (keys.length !== 1) return false;
	
	    result[index] = [keys[0], pair[keys[0]]];
	  }
	
	  return true;
	}
	
	function constructYamlPairs(data) {
	  if (data === null) return [];
	
	  var index,
	      length,
	      pair,
	      keys,
	      result,
	      object = data;
	
	  result = new Array(object.length);
	
	  for (index = 0, length = object.length; index < length; index += 1) {
	    pair = object[index];
	
	    keys = Object.keys(pair);
	
	    result[index] = [keys[0], pair[keys[0]]];
	  }
	
	  return result;
	}
	
	module.exports = new Type('tag:yaml.org,2002:pairs', {
	  kind: 'sequence',
	  resolve: resolveYamlPairs,
	  construct: constructYamlPairs
	});

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	module.exports = new Type('tag:yaml.org,2002:seq', {
	  kind: 'sequence',
	  construct: function construct(data) {
	    return data !== null ? data : [];
	  }
	});

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	var _hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function resolveYamlSet(data) {
	  if (data === null) return true;
	
	  var key,
	      object = data;
	
	  for (key in object) {
	    if (_hasOwnProperty.call(object, key)) {
	      if (object[key] !== null) return false;
	    }
	  }
	
	  return true;
	}
	
	function constructYamlSet(data) {
	  return data !== null ? data : {};
	}
	
	module.exports = new Type('tag:yaml.org,2002:set', {
	  kind: 'mapping',
	  resolve: resolveYamlSet,
	  construct: constructYamlSet
	});

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	module.exports = new Type('tag:yaml.org,2002:str', {
	  kind: 'scalar',
	  construct: function construct(data) {
	    return data !== null ? data : '';
	  }
	});

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Type = __webpack_require__(7);
	
	var YAML_DATE_REGEXP = new RegExp('^([0-9][0-9][0-9][0-9])' + // [1] year
	'-([0-9][0-9])' + // [2] month
	'-([0-9][0-9])$'); // [3] day
	
	var YAML_TIMESTAMP_REGEXP = new RegExp('^([0-9][0-9][0-9][0-9])' + // [1] year
	'-([0-9][0-9]?)' + // [2] month
	'-([0-9][0-9]?)' + // [3] day
	'(?:[Tt]|[ \\t]+)' + // ...
	'([0-9][0-9]?)' + // [4] hour
	':([0-9][0-9])' + // [5] minute
	':([0-9][0-9])' + // [6] second
	'(?:\\.([0-9]*))?' + // [7] fraction
	'(?:[ \\t]*(Z|([-+])([0-9][0-9]?)' + // [8] tz [9] tz_sign [10] tz_hour
	'(?::([0-9][0-9]))?))?$'); // [11] tz_minute
	
	function resolveYamlTimestamp(data) {
	  if (data === null) return false;
	  if (YAML_DATE_REGEXP.exec(data) !== null) return true;
	  if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
	  return false;
	}
	
	function constructYamlTimestamp(data) {
	  var match,
	      year,
	      month,
	      day,
	      hour,
	      minute,
	      second,
	      fraction = 0,
	      delta = null,
	      tz_hour,
	      tz_minute,
	      date;
	
	  match = YAML_DATE_REGEXP.exec(data);
	  if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data);
	
	  if (match === null) throw new Error('Date resolve error');
	
	  // match: [1] year [2] month [3] day
	
	  year = +match[1];
	  month = +match[2] - 1; // JS month starts with 0
	  day = +match[3];
	
	  if (!match[4]) {
	    // no hour
	    return new Date(Date.UTC(year, month, day));
	  }
	
	  // match: [4] hour [5] minute [6] second [7] fraction
	
	  hour = +match[4];
	  minute = +match[5];
	  second = +match[6];
	
	  if (match[7]) {
	    fraction = match[7].slice(0, 3);
	    while (fraction.length < 3) {
	      // milli-seconds
	      fraction += '0';
	    }
	    fraction = +fraction;
	  }
	
	  // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute
	
	  if (match[9]) {
	    tz_hour = +match[10];
	    tz_minute = +(match[11] || 0);
	    delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
	    if (match[9] === '-') delta = -delta;
	  }
	
	  date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
	
	  if (delta) date.setTime(date.getTime() - delta);
	
	  return date;
	}
	
	function representYamlTimestamp(object /*, style*/) {
	  return object.toISOString();
	}
	
	module.exports = new Type('tag:yaml.org,2002:timestamp', {
	  kind: 'scalar',
	  resolve: resolveYamlTimestamp,
	  construct: constructYamlTimestamp,
	  instanceOf: Date,
	  represent: representYamlTimestamp
	});

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var camel2hyphen = __webpack_require__(711);
	
	var isDimension = function isDimension(feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function obj2mq(obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length - 1) {
	      mq += ' and ';
	    }
	  });
	  return mq;
	};
	
	var json2mq = function json2mq(query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length - 1) {
	        mq += ', ';
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 671 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function now() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? other + '' : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
	}
	
	module.exports = debounce;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/markedjs/marked
	 */
	
	;(function (root) {
	  'use strict';
	
	  /**
	   * Block-Level Grammar
	   */
	
	  var block = {
	    newline: /^\n+/,
	    code: /^( {4}[^\n]+\n*)+/,
	    fences: noop,
	    hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
	    heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
	    nptable: noop,
	    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
	    list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
	    html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
	    def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
	    table: noop,
	    lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
	    paragraph: /^([^\n]+(?:\n?(?!hr|heading|lheading| {0,3}>|tag)[^\n]+)+)/,
	    text: /^[^\n]+/
	  };
	
	  block._label = /(?:\\[\[\]]|[^\[\]])+/;
	  block._title = /(?:"(?:\\"|[^"]|"[^"\n]*")*"|'\n?(?:[^'\n]+\n?)*'|\([^()]*\))/;
	  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
	
	  block.bullet = /(?:[*+-]|\d+\.)/;
	  block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
	  block.item = edit(block.item, 'gm').replace(/bull/g, block.bullet).getRegex();
	
	  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
	
	  block._tag = '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code' + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo' + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b';
	
	  block.html = edit(block.html).replace('comment', /<!--[\s\S]*?-->/).replace('closed', /<(tag)[\s\S]+?<\/\1>/).replace('closing', /<tag(?:"[^"]*"|'[^']*'|\s[^'"\/>\s]*)*?\/?>/).replace(/tag/g, block._tag).getRegex();
	
	  block.paragraph = edit(block.paragraph).replace('hr', block.hr).replace('heading', block.heading).replace('lheading', block.lheading).replace('tag', '<' + block._tag).getRegex();
	
	  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();
	
	  /**
	   * Normal Block Grammar
	   */
	
	  block.normal = merge({}, block);
	
	  /**
	   * GFM Block Grammar
	   */
	
	  block.gfm = merge({}, block.normal, {
	    fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,
	    paragraph: /^/,
	    heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
	  });
	
	  block.gfm.paragraph = edit(block.paragraph).replace('(?!', '(?!' + block.gfm.fences.source.replace('\\1', '\\2') + '|' + block.list.source.replace('\\1', '\\3') + '|').getRegex();
	
	  /**
	   * GFM + Tables Block Grammar
	   */
	
	  block.tables = merge({}, block.gfm, {
	    nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
	    table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
	  });
	
	  /**
	   * Block Lexer
	   */
	
	  function Lexer(options) {
	    this.tokens = [];
	    this.tokens.links = {};
	    this.options = options || marked.defaults;
	    this.rules = block.normal;
	
	    if (this.options.gfm) {
	      if (this.options.tables) {
	        this.rules = block.tables;
	      } else {
	        this.rules = block.gfm;
	      }
	    }
	  }
	
	  /**
	   * Expose Block Rules
	   */
	
	  Lexer.rules = block;
	
	  /**
	   * Static Lex Method
	   */
	
	  Lexer.lex = function (src, options) {
	    var lexer = new Lexer(options);
	    return lexer.lex(src);
	  };
	
	  /**
	   * Preprocessing
	   */
	
	  Lexer.prototype.lex = function (src) {
	    src = src.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ').replace(/\u00a0/g, ' ').replace(/\u2424/g, '\n');
	
	    return this.token(src, true);
	  };
	
	  /**
	   * Lexing
	   */
	
	  Lexer.prototype.token = function (src, top) {
	    src = src.replace(/^ +$/gm, '');
	    var next, loose, cap, bull, b, item, space, i, tag, l, isordered;
	
	    while (src) {
	      // newline
	      if (cap = this.rules.newline.exec(src)) {
	        src = src.substring(cap[0].length);
	        if (cap[0].length > 1) {
	          this.tokens.push({
	            type: 'space'
	          });
	        }
	      }
	
	      // code
	      if (cap = this.rules.code.exec(src)) {
	        src = src.substring(cap[0].length);
	        cap = cap[0].replace(/^ {4}/gm, '');
	        this.tokens.push({
	          type: 'code',
	          text: !this.options.pedantic ? cap.replace(/\n+$/, '') : cap
	        });
	        continue;
	      }
	
	      // fences (gfm)
	      if (cap = this.rules.fences.exec(src)) {
	        src = src.substring(cap[0].length);
	        this.tokens.push({
	          type: 'code',
	          lang: cap[2],
	          text: cap[3] || ''
	        });
	        continue;
	      }
	
	      // heading
	      if (cap = this.rules.heading.exec(src)) {
	        src = src.substring(cap[0].length);
	        this.tokens.push({
	          type: 'heading',
	          depth: cap[1].length,
	          text: cap[2]
	        });
	        continue;
	      }
	
	      // table no leading pipe (gfm)
	      if (top && (cap = this.rules.nptable.exec(src))) {
	        src = src.substring(cap[0].length);
	
	        item = {
	          type: 'table',
	          header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	          cells: cap[3].replace(/\n$/, '').split('\n')
	        };
	
	        for (i = 0; i < item.align.length; i++) {
	          if (/^ *-+: *$/.test(item.align[i])) {
	            item.align[i] = 'right';
	          } else if (/^ *:-+: *$/.test(item.align[i])) {
	            item.align[i] = 'center';
	          } else if (/^ *:-+ *$/.test(item.align[i])) {
	            item.align[i] = 'left';
	          } else {
	            item.align[i] = null;
	          }
	        }
	
	        for (i = 0; i < item.cells.length; i++) {
	          item.cells[i] = item.cells[i].split(/ *\| */);
	        }
	
	        this.tokens.push(item);
	
	        continue;
	      }
	
	      // hr
	      if (cap = this.rules.hr.exec(src)) {
	        src = src.substring(cap[0].length);
	        this.tokens.push({
	          type: 'hr'
	        });
	        continue;
	      }
	
	      // blockquote
	      if (cap = this.rules.blockquote.exec(src)) {
	        src = src.substring(cap[0].length);
	
	        this.tokens.push({
	          type: 'blockquote_start'
	        });
	
	        cap = cap[0].replace(/^ *> ?/gm, '');
	
	        // Pass `top` to keep the current
	        // "toplevel" state. This is exactly
	        // how markdown.pl works.
	        this.token(cap, top);
	
	        this.tokens.push({
	          type: 'blockquote_end'
	        });
	
	        continue;
	      }
	
	      // list
	      if (cap = this.rules.list.exec(src)) {
	        src = src.substring(cap[0].length);
	        bull = cap[2];
	        isordered = bull.length > 1;
	
	        this.tokens.push({
	          type: 'list_start',
	          ordered: isordered,
	          start: isordered ? +bull : ''
	        });
	
	        // Get each top-level item.
	        cap = cap[0].match(this.rules.item);
	
	        next = false;
	        l = cap.length;
	        i = 0;
	
	        for (; i < l; i++) {
	          item = cap[i];
	
	          // Remove the list item's bullet
	          // so it is seen as the next token.
	          space = item.length;
	          item = item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	          // Outdent whatever the
	          // list item contains. Hacky.
	          if (~item.indexOf('\n ')) {
	            space -= item.length;
	            item = !this.options.pedantic ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '') : item.replace(/^ {1,4}/gm, '');
	          }
	
	          // Determine whether the next list item belongs here.
	          // Backpedal if it does not belong in this list.
	          if (this.options.smartLists && i !== l - 1) {
	            b = block.bullet.exec(cap[i + 1])[0];
	            if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	              src = cap.slice(i + 1).join('\n') + src;
	              i = l - 1;
	            }
	          }
	
	          // Determine whether item is loose or not.
	          // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	          // for discount behavior.
	          loose = next || /\n\n(?!\s*$)/.test(item);
	          if (i !== l - 1) {
	            next = item.charAt(item.length - 1) === '\n';
	            if (!loose) loose = next;
	          }
	
	          this.tokens.push({
	            type: loose ? 'loose_item_start' : 'list_item_start'
	          });
	
	          // Recurse.
	          this.token(item, false);
	
	          this.tokens.push({
	            type: 'list_item_end'
	          });
	        }
	
	        this.tokens.push({
	          type: 'list_end'
	        });
	
	        continue;
	      }
	
	      // html
	      if (cap = this.rules.html.exec(src)) {
	        src = src.substring(cap[0].length);
	        this.tokens.push({
	          type: this.options.sanitize ? 'paragraph' : 'html',
	          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	          text: cap[0]
	        });
	        continue;
	      }
	
	      // def
	      if (top && (cap = this.rules.def.exec(src))) {
	        src = src.substring(cap[0].length);
	        if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
	        tag = cap[1].toLowerCase();
	        if (!this.tokens.links[tag]) {
	          this.tokens.links[tag] = {
	            href: cap[2],
	            title: cap[3]
	          };
	        }
	        continue;
	      }
	
	      // table (gfm)
	      if (top && (cap = this.rules.table.exec(src))) {
	        src = src.substring(cap[0].length);
	
	        item = {
	          type: 'table',
	          header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	          cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	        };
	
	        for (i = 0; i < item.align.length; i++) {
	          if (/^ *-+: *$/.test(item.align[i])) {
	            item.align[i] = 'right';
	          } else if (/^ *:-+: *$/.test(item.align[i])) {
	            item.align[i] = 'center';
	          } else if (/^ *:-+ *$/.test(item.align[i])) {
	            item.align[i] = 'left';
	          } else {
	            item.align[i] = null;
	          }
	        }
	
	        for (i = 0; i < item.cells.length; i++) {
	          item.cells[i] = item.cells[i].replace(/^ *\| *| *\| *$/g, '').split(/ *\| */);
	        }
	
	        this.tokens.push(item);
	
	        continue;
	      }
	
	      // lheading
	      if (cap = this.rules.lheading.exec(src)) {
	        src = src.substring(cap[0].length);
	        this.tokens.push({
	          type: 'heading',
	          depth: cap[2] === '=' ? 1 : 2,
	          text: cap[1]
	        });
	        continue;
	      }
	
	      // top-level paragraph
	      if (top && (cap = this.rules.paragraph.exec(src))) {
	        src = src.substring(cap[0].length);
	        this.tokens.push({
	          type: 'paragraph',
	          text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1]
	        });
	        continue;
	      }
	
	      // text
	      if (cap = this.rules.text.exec(src)) {
	        // Top-level should never reach here.
	        src = src.substring(cap[0].length);
	        this.tokens.push({
	          type: 'text',
	          text: cap[0]
	        });
	        continue;
	      }
	
	      if (src) {
	        throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	      }
	    }
	
	    return this.tokens;
	  };
	
	  /**
	   * Inline-Level Grammar
	   */
	
	  var inline = {
	    escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
	    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
	    url: noop,
	    tag: /^<!--[\s\S]*?-->|^<\/?[a-zA-Z0-9\-]+(?:"[^"]*"|'[^']*'|\s[^<'">\/\s]*)*?\/?>/,
	    link: /^!?\[(inside)\]\(href\)/,
	    reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
	    nolink: /^!?\[((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\]/,
	    strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
	    em: /^_([^\s_](?:[^_]|__)+?[^\s_])_\b|^\*((?:\*\*|[^*])+?)\*(?!\*)/,
	    code: /^(`+)\s*([\s\S]*?[^`]?)\s*\1(?!`)/,
	    br: /^ {2,}\n(?!\s*$)/,
	    del: noop,
	    text: /^[\s\S]+?(?=[\\<!\[`*]|\b_| {2,}\n|$)/
	  };
	
	  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
	  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
	
	  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
	
	  inline._inside = /(?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]]|\](?=[^\[]*\]))*/;
	  inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
	
	  inline.link = edit(inline.link).replace('inside', inline._inside).replace('href', inline._href).getRegex();
	
	  inline.reflink = edit(inline.reflink).replace('inside', inline._inside).getRegex();
	
	  /**
	   * Normal Inline Grammar
	   */
	
	  inline.normal = merge({}, inline);
	
	  /**
	   * Pedantic Inline Grammar
	   */
	
	  inline.pedantic = merge({}, inline.normal, {
	    strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	    em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
	  });
	
	  /**
	   * GFM Inline Grammar
	   */
	
	  inline.gfm = merge({}, inline.normal, {
	    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
	    url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace('email', inline._email).getRegex(),
	    _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
	    del: /^~~(?=\S)([\s\S]*?\S)~~/,
	    text: edit(inline.text).replace(']|', '~]|').replace('|', '|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&\'*+/=?^_`{\\|}~-]+@|').getRegex()
	  });
	
	  /**
	   * GFM + Line Breaks Inline Grammar
	   */
	
	  inline.breaks = merge({}, inline.gfm, {
	    br: edit(inline.br).replace('{2,}', '*').getRegex(),
	    text: edit(inline.gfm.text).replace('{2,}', '*').getRegex()
	  });
	
	  /**
	   * Inline Lexer & Compiler
	   */
	
	  function InlineLexer(links, options) {
	    this.options = options || marked.defaults;
	    this.links = links;
	    this.rules = inline.normal;
	    this.renderer = this.options.renderer || new Renderer();
	    this.renderer.options = this.options;
	
	    if (!this.links) {
	      throw new Error('Tokens array requires a `links` property.');
	    }
	
	    if (this.options.gfm) {
	      if (this.options.breaks) {
	        this.rules = inline.breaks;
	      } else {
	        this.rules = inline.gfm;
	      }
	    } else if (this.options.pedantic) {
	      this.rules = inline.pedantic;
	    }
	  }
	
	  /**
	   * Expose Inline Rules
	   */
	
	  InlineLexer.rules = inline;
	
	  /**
	   * Static Lexing/Compiling Method
	   */
	
	  InlineLexer.output = function (src, links, options) {
	    var inline = new InlineLexer(links, options);
	    return inline.output(src);
	  };
	
	  /**
	   * Lexing/Compiling
	   */
	
	  InlineLexer.prototype.output = function (src) {
	    var out = '',
	        link,
	        text,
	        href,
	        cap;
	
	    while (src) {
	      // escape
	      if (cap = this.rules.escape.exec(src)) {
	        src = src.substring(cap[0].length);
	        out += cap[1];
	        continue;
	      }
	
	      // autolink
	      if (cap = this.rules.autolink.exec(src)) {
	        src = src.substring(cap[0].length);
	        if (cap[2] === '@') {
	          text = escape(this.mangle(cap[1]));
	          href = 'mailto:' + text;
	        } else {
	          text = escape(cap[1]);
	          href = text;
	        }
	        out += this.renderer.link(href, null, text);
	        continue;
	      }
	
	      // url (gfm)
	      if (!this.inLink && (cap = this.rules.url.exec(src))) {
	        cap[0] = this.rules._backpedal.exec(cap[0])[0];
	        src = src.substring(cap[0].length);
	        if (cap[2] === '@') {
	          text = escape(cap[0]);
	          href = 'mailto:' + text;
	        } else {
	          text = escape(cap[0]);
	          if (cap[1] === 'www.') {
	            href = 'http://' + text;
	          } else {
	            href = text;
	          }
	        }
	        out += this.renderer.link(href, null, text);
	        continue;
	      }
	
	      // tag
	      if (cap = this.rules.tag.exec(src)) {
	        if (!this.inLink && /^<a /i.test(cap[0])) {
	          this.inLink = true;
	        } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
	          this.inLink = false;
	        }
	        src = src.substring(cap[0].length);
	        out += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
	        continue;
	      }
	
	      // link
	      if (cap = this.rules.link.exec(src)) {
	        src = src.substring(cap[0].length);
	        this.inLink = true;
	        out += this.outputLink(cap, {
	          href: cap[2],
	          title: cap[3]
	        });
	        this.inLink = false;
	        continue;
	      }
	
	      // reflink, nolink
	      if ((cap = this.rules.reflink.exec(src)) || (cap = this.rules.nolink.exec(src))) {
	        src = src.substring(cap[0].length);
	        link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	        link = this.links[link.toLowerCase()];
	        if (!link || !link.href) {
	          out += cap[0].charAt(0);
	          src = cap[0].substring(1) + src;
	          continue;
	        }
	        this.inLink = true;
	        out += this.outputLink(cap, link);
	        this.inLink = false;
	        continue;
	      }
	
	      // strong
	      if (cap = this.rules.strong.exec(src)) {
	        src = src.substring(cap[0].length);
	        out += this.renderer.strong(this.output(cap[2] || cap[1]));
	        continue;
	      }
	
	      // em
	      if (cap = this.rules.em.exec(src)) {
	        src = src.substring(cap[0].length);
	        out += this.renderer.em(this.output(cap[2] || cap[1]));
	        continue;
	      }
	
	      // code
	      if (cap = this.rules.code.exec(src)) {
	        src = src.substring(cap[0].length);
	        out += this.renderer.codespan(escape(cap[2].trim(), true));
	        continue;
	      }
	
	      // br
	      if (cap = this.rules.br.exec(src)) {
	        src = src.substring(cap[0].length);
	        out += this.renderer.br();
	        continue;
	      }
	
	      // del (gfm)
	      if (cap = this.rules.del.exec(src)) {
	        src = src.substring(cap[0].length);
	        out += this.renderer.del(this.output(cap[1]));
	        continue;
	      }
	
	      // text
	      if (cap = this.rules.text.exec(src)) {
	        src = src.substring(cap[0].length);
	        out += this.renderer.text(escape(this.smartypants(cap[0])));
	        continue;
	      }
	
	      if (src) {
	        throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	      }
	    }
	
	    return out;
	  };
	
	  /**
	   * Compile Link
	   */
	
	  InlineLexer.prototype.outputLink = function (cap, link) {
	    var href = escape(link.href),
	        title = link.title ? escape(link.title) : null;
	
	    return cap[0].charAt(0) !== '!' ? this.renderer.link(href, title, this.output(cap[1])) : this.renderer.image(href, title, escape(cap[1]));
	  };
	
	  /**
	   * Smartypants Transformations
	   */
	
	  InlineLexer.prototype.smartypants = function (text) {
	    if (!this.options.smartypants) return text;
	    return text
	    // em-dashes
	    .replace(/---/g, '\u2014')
	    // en-dashes
	    .replace(/--/g, '\u2013')
	    // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
	    // closing singles & apostrophes
	    .replace(/'/g, '\u2019')
	    // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201C')
	    // closing doubles
	    .replace(/"/g, '\u201D')
	    // ellipses
	    .replace(/\.{3}/g, '\u2026');
	  };
	
	  /**
	   * Mangle Links
	   */
	
	  InlineLexer.prototype.mangle = function (text) {
	    if (!this.options.mangle) return text;
	    var out = '',
	        l = text.length,
	        i = 0,
	        ch;
	
	    for (; i < l; i++) {
	      ch = text.charCodeAt(i);
	      if (Math.random() > 0.5) {
	        ch = 'x' + ch.toString(16);
	      }
	      out += '&#' + ch + ';';
	    }
	
	    return out;
	  };
	
	  /**
	   * Renderer
	   */
	
	  function Renderer(options) {
	    this.options = options || {};
	  }
	
	  Renderer.prototype.code = function (code, lang, escaped) {
	    if (this.options.highlight) {
	      var out = this.options.highlight(code, lang);
	      if (out != null && out !== code) {
	        escaped = true;
	        code = out;
	      }
	    }
	
	    if (!lang) {
	      return '<pre><code>' + (escaped ? code : escape(code, true)) + '\n</code></pre>';
	    }
	
	    return '<pre><code class="' + this.options.langPrefix + escape(lang, true) + '">' + (escaped ? code : escape(code, true)) + '\n</code></pre>\n';
	  };
	
	  Renderer.prototype.blockquote = function (quote) {
	    return '<blockquote>\n' + quote + '</blockquote>\n';
	  };
	
	  Renderer.prototype.html = function (html) {
	    return html;
	  };
	
	  Renderer.prototype.heading = function (text, level, raw) {
	    return '<h' + level + ' id="' + this.options.headerPrefix + raw.toLowerCase().replace(/[^\w]+/g, '-') + '">' + text + '</h' + level + '>\n';
	  };
	
	  Renderer.prototype.hr = function () {
	    return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	  };
	
	  Renderer.prototype.list = function (body, ordered, start) {
	    var type = ordered ? 'ol' : 'ul',
	        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
	    return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
	  };
	
	  Renderer.prototype.listitem = function (text) {
	    return '<li>' + text + '</li>\n';
	  };
	
	  Renderer.prototype.paragraph = function (text) {
	    return '<p>' + text + '</p>\n';
	  };
	
	  Renderer.prototype.table = function (header, body) {
	    return '<table>\n' + '<thead>\n' + header + '</thead>\n' + '<tbody>\n' + body + '</tbody>\n' + '</table>\n';
	  };
	
	  Renderer.prototype.tablerow = function (content) {
	    return '<tr>\n' + content + '</tr>\n';
	  };
	
	  Renderer.prototype.tablecell = function (content, flags) {
	    var type = flags.header ? 'th' : 'td';
	    var tag = flags.align ? '<' + type + ' style="text-align:' + flags.align + '">' : '<' + type + '>';
	    return tag + content + '</' + type + '>\n';
	  };
	
	  // span level renderer
	  Renderer.prototype.strong = function (text) {
	    return '<strong>' + text + '</strong>';
	  };
	
	  Renderer.prototype.em = function (text) {
	    return '<em>' + text + '</em>';
	  };
	
	  Renderer.prototype.codespan = function (text) {
	    return '<code>' + text + '</code>';
	  };
	
	  Renderer.prototype.br = function () {
	    return this.options.xhtml ? '<br/>' : '<br>';
	  };
	
	  Renderer.prototype.del = function (text) {
	    return '<del>' + text + '</del>';
	  };
	
	  Renderer.prototype.link = function (href, title, text) {
	    if (this.options.sanitize) {
	      try {
	        var prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
	      } catch (e) {
	        return text;
	      }
	      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
	        return text;
	      }
	    }
	    if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	      href = resolveUrl(this.options.baseUrl, href);
	    }
	    var out = '<a href="' + href + '"';
	    if (title) {
	      out += ' title="' + title + '"';
	    }
	    out += '>' + text + '</a>';
	    return out;
	  };
	
	  Renderer.prototype.image = function (href, title, text) {
	    if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	      href = resolveUrl(this.options.baseUrl, href);
	    }
	    var out = '<img src="' + href + '" alt="' + text + '"';
	    if (title) {
	      out += ' title="' + title + '"';
	    }
	    out += this.options.xhtml ? '/>' : '>';
	    return out;
	  };
	
	  Renderer.prototype.text = function (text) {
	    return text;
	  };
	
	  /**
	   * TextRenderer
	   * returns only the textual part of the token
	   */
	
	  function TextRenderer() {}
	
	  // no need for block level renderers
	
	  TextRenderer.prototype.strong = TextRenderer.prototype.em = TextRenderer.prototype.codespan = TextRenderer.prototype.del = TextRenderer.prototype.text = function (text) {
	    return text;
	  };
	
	  TextRenderer.prototype.link = TextRenderer.prototype.image = function (href, title, text) {
	    return '' + text;
	  };
	
	  TextRenderer.prototype.br = function () {
	    return '';
	  };
	
	  /**
	   * Parsing & Compiling
	   */
	
	  function Parser(options) {
	    this.tokens = [];
	    this.token = null;
	    this.options = options || marked.defaults;
	    this.options.renderer = this.options.renderer || new Renderer();
	    this.renderer = this.options.renderer;
	    this.renderer.options = this.options;
	  }
	
	  /**
	   * Static Parse Method
	   */
	
	  Parser.parse = function (src, options) {
	    var parser = new Parser(options);
	    return parser.parse(src);
	  };
	
	  /**
	   * Parse Loop
	   */
	
	  Parser.prototype.parse = function (src) {
	    this.inline = new InlineLexer(src.links, this.options);
	    // use an InlineLexer with a TextRenderer to extract pure text
	    this.inlineText = new InlineLexer(src.links, merge({}, this.options, { renderer: new TextRenderer() }));
	    this.tokens = src.reverse();
	
	    var out = '';
	    while (this.next()) {
	      out += this.tok();
	    }
	
	    return out;
	  };
	
	  /**
	   * Next Token
	   */
	
	  Parser.prototype.next = function () {
	    return this.token = this.tokens.pop();
	  };
	
	  /**
	   * Preview Next Token
	   */
	
	  Parser.prototype.peek = function () {
	    return this.tokens[this.tokens.length - 1] || 0;
	  };
	
	  /**
	   * Parse Text Tokens
	   */
	
	  Parser.prototype.parseText = function () {
	    var body = this.token.text;
	
	    while (this.peek().type === 'text') {
	      body += '\n' + this.next().text;
	    }
	
	    return this.inline.output(body);
	  };
	
	  /**
	   * Parse Current Token
	   */
	
	  Parser.prototype.tok = function () {
	    switch (this.token.type) {
	      case 'space':
	        {
	          return '';
	        }
	      case 'hr':
	        {
	          return this.renderer.hr();
	        }
	      case 'heading':
	        {
	          return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, unescape(this.inlineText.output(this.token.text)));
	        }
	      case 'code':
	        {
	          return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
	        }
	      case 'table':
	        {
	          var header = '',
	              body = '',
	              i,
	              row,
	              cell,
	              j;
	
	          // header
	          cell = '';
	          for (i = 0; i < this.token.header.length; i++) {
	            cell += this.renderer.tablecell(this.inline.output(this.token.header[i]), { header: true, align: this.token.align[i] });
	          }
	          header += this.renderer.tablerow(cell);
	
	          for (i = 0; i < this.token.cells.length; i++) {
	            row = this.token.cells[i];
	
	            cell = '';
	            for (j = 0; j < row.length; j++) {
	              cell += this.renderer.tablecell(this.inline.output(row[j]), { header: false, align: this.token.align[j] });
	            }
	
	            body += this.renderer.tablerow(cell);
	          }
	          return this.renderer.table(header, body);
	        }
	      case 'blockquote_start':
	        {
	          body = '';
	
	          while (this.next().type !== 'blockquote_end') {
	            body += this.tok();
	          }
	
	          return this.renderer.blockquote(body);
	        }
	      case 'list_start':
	        {
	          body = '';
	          var ordered = this.token.ordered,
	              start = this.token.start;
	
	          while (this.next().type !== 'list_end') {
	            body += this.tok();
	          }
	
	          return this.renderer.list(body, ordered, start);
	        }
	      case 'list_item_start':
	        {
	          body = '';
	
	          while (this.next().type !== 'list_item_end') {
	            body += this.token.type === 'text' ? this.parseText() : this.tok();
	          }
	
	          return this.renderer.listitem(body);
	        }
	      case 'loose_item_start':
	        {
	          body = '';
	
	          while (this.next().type !== 'list_item_end') {
	            body += this.tok();
	          }
	
	          return this.renderer.listitem(body);
	        }
	      case 'html':
	        {
	          var html = !this.token.pre && !this.options.pedantic ? this.inline.output(this.token.text) : this.token.text;
	          return this.renderer.html(html);
	        }
	      case 'paragraph':
	        {
	          return this.renderer.paragraph(this.inline.output(this.token.text));
	        }
	      case 'text':
	        {
	          return this.renderer.paragraph(this.parseText());
	        }
	    }
	  };
	
	  /**
	   * Helpers
	   */
	
	  function escape(html, encode) {
	    return html.replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	  }
	
	  function unescape(html) {
	    // explicitly match decimal, hex, and named HTML entities
	    return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function (_, n) {
	      n = n.toLowerCase();
	      if (n === 'colon') return ':';
	      if (n.charAt(0) === '#') {
	        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
	      }
	      return '';
	    });
	  }
	
	  function edit(regex, opt) {
	    regex = regex.source;
	    opt = opt || '';
	    return {
	      replace: function replace(name, val) {
	        val = val.source || val;
	        val = val.replace(/(^|[^\[])\^/g, '$1');
	        regex = regex.replace(name, val);
	        return this;
	      },
	      getRegex: function getRegex() {
	        return new RegExp(regex, opt);
	      }
	    };
	  }
	
	  function resolveUrl(base, href) {
	    if (!baseUrls[' ' + base]) {
	      // we can ignore everything in base after the last slash of its path component,
	      // but we might need to add _that_
	      // https://tools.ietf.org/html/rfc3986#section-3
	      if (/^[^:]+:\/*[^/]*$/.test(base)) {
	        baseUrls[' ' + base] = base + '/';
	      } else {
	        baseUrls[' ' + base] = base.replace(/[^/]*$/, '');
	      }
	    }
	    base = baseUrls[' ' + base];
	
	    if (href.slice(0, 2) === '//') {
	      return base.replace(/:[\s\S]*/, ':') + href;
	    } else if (href.charAt(0) === '/') {
	      return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
	    } else {
	      return base + href;
	    }
	  }
	  var baseUrls = {};
	  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
	
	  function noop() {}
	  noop.exec = noop;
	
	  function merge(obj) {
	    var i = 1,
	        target,
	        key;
	
	    for (; i < arguments.length; i++) {
	      target = arguments[i];
	      for (key in target) {
	        if (Object.prototype.hasOwnProperty.call(target, key)) {
	          obj[key] = target[key];
	        }
	      }
	    }
	
	    return obj;
	  }
	
	  /**
	   * Marked
	   */
	
	  function marked(src, opt, callback) {
	    // throw error in case of non string input
	    if (typeof src === 'undefined' || src === null) {
	      throw new Error('marked(): input parameter is undefined or null');
	    }
	    if (typeof src !== 'string') {
	      throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
	    }
	
	    if (callback || typeof opt === 'function') {
	      if (!callback) {
	        callback = opt;
	        opt = null;
	      }
	
	      opt = merge({}, marked.defaults, opt || {});
	
	      var highlight = opt.highlight,
	          tokens,
	          pending,
	          i = 0;
	
	      try {
	        tokens = Lexer.lex(src, opt);
	      } catch (e) {
	        return callback(e);
	      }
	
	      pending = tokens.length;
	
	      var done = function done(err) {
	        if (err) {
	          opt.highlight = highlight;
	          return callback(err);
	        }
	
	        var out;
	
	        try {
	          out = Parser.parse(tokens, opt);
	        } catch (e) {
	          err = e;
	        }
	
	        opt.highlight = highlight;
	
	        return err ? callback(err) : callback(null, out);
	      };
	
	      if (!highlight || highlight.length < 3) {
	        return done();
	      }
	
	      delete opt.highlight;
	
	      if (!pending) return done();
	
	      for (; i < tokens.length; i++) {
	        (function (token) {
	          if (token.type !== 'code') {
	            return --pending || done();
	          }
	          return highlight(token.text, token.lang, function (err, code) {
	            if (err) return done(err);
	            if (code == null || code === token.text) {
	              return --pending || done();
	            }
	            token.text = code;
	            token.escaped = true;
	            --pending || done();
	          });
	        })(tokens[i]);
	      }
	
	      return;
	    }
	    try {
	      if (opt) opt = merge({}, marked.defaults, opt);
	      return Parser.parse(Lexer.lex(src, opt), opt);
	    } catch (e) {
	      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
	      if ((opt || marked.defaults).silent) {
	        return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
	      }
	      throw e;
	    }
	  }
	
	  /**
	   * Options
	   */
	
	  marked.options = marked.setOptions = function (opt) {
	    merge(marked.defaults, opt);
	    return marked;
	  };
	
	  marked.defaults = {
	    gfm: true,
	    tables: true,
	    breaks: false,
	    pedantic: false,
	    sanitize: false,
	    sanitizer: null,
	    mangle: true,
	    smartLists: false,
	    silent: false,
	    highlight: null,
	    langPrefix: 'lang-',
	    smartypants: false,
	    headerPrefix: '',
	    renderer: new Renderer(),
	    xhtml: false,
	    baseUrl: null
	  };
	
	  /**
	   * Expose
	   */
	
	  marked.Parser = Parser;
	  marked.parser = Parser.parse;
	
	  marked.Renderer = Renderer;
	  marked.TextRenderer = TextRenderer;
	
	  marked.Lexer = Lexer;
	  marked.lexer = Lexer.lex;
	
	  marked.InlineLexer = InlineLexer;
	  marked.inlineLexer = InlineLexer.output;
	
	  marked.parse = marked;
	
	  if (typeof module !== 'undefined' && ( false ? 'undefined' : _typeof(exports)) === 'object') {
	    module.exports = marked;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return marked;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    root.marked = marked;
	  }
	})(undefined || (typeof window !== 'undefined' ? window : global));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	// Generated by CoffeeScript 1.12.2
	(function () {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if (typeof performance !== "undefined" && performance !== null && performance.now) {
	    module.exports = function () {
	      return performance.now();
	    };
	  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
	    module.exports = function () {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function getNanoSeconds() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function () {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function () {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	}).call(undefined);
	
	//# sourceMappingURL=performance-now.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(227)))

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var Promise = __webpack_require__(228);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function (value) {
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(228);
	
	var DEFAULT_WHITELIST = [ReferenceError, TypeError, RangeError];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (promise._81 === 2 && // IS REJECTED
	    rejections[promise._72]) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) {
	      // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(onUnhandled.bind(null, promise._72),
	        // For reference errors and type errors, this almost always
	        // means the programmer made a mistake, so log them after just
	        // 100ms
	        // otherwise, wait 2 seconds to see if they get handled
	        matchWhitelist(err, DEFAULT_WHITELIST) ? 100 : 2000),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (options.allRejections || matchWhitelist(rejections[id].error, options.whitelist || DEFAULT_WHITELIST)) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(rejections[id].displayId, rejections[id].error);
	      } else {
	        rejections[id].logged = true;
	        logError(rejections[id].displayId, rejections[id].error);
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn('Promise Rejection Handled (id: ' + rejections[id].displayId + '):');
	        console.warn('  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' + rejections[id].displayId + '.');
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(77);
	var invariant = __webpack_require__(620);
	var ReactPropTypesSecret = __webpack_require__(677);
	
	module.exports = function () {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};

/***/ },
/* 677 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var now = __webpack_require__(673),
	    root = typeof window === 'undefined' ? global : window,
	    vendors = ['moz', 'webkit'],
	    suffix = 'AnimationFrame',
	    raf = root['request' + suffix],
	    caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
	
	for (var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix];
	  caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
	}
	
	// Some versions of FF have rAF but not cAF
	if (!raf || !caf) {
	  var last = 0,
	      id = 0,
	      queue = [],
	      frameDuration = 1000 / 60;
	
	  raf = function raf(callback) {
	    if (queue.length === 0) {
	      var _now = now(),
	          next = Math.max(0, frameDuration - (_now - last));
	      last = next + _now;
	      setTimeout(function () {
	        var cp = queue.slice(0);
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0;
	        for (var i = 0; i < cp.length; i++) {
	          if (!cp[i].cancelled) {
	            try {
	              cp[i].callback(last);
	            } catch (e) {
	              setTimeout(function () {
	                throw e;
	              }, 0);
	            }
	          }
	        }
	      }, Math.round(next));
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    });
	    return id;
	  };
	
	  caf = function caf(handle) {
	    for (var i = 0; i < queue.length; i++) {
	      if (queue[i].handle === handle) {
	        queue[i].cancelled = true;
	      }
	    }
	  };
	}
	
	module.exports = function (fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn);
	};
	module.exports.cancel = function () {
	  caf.apply(root, arguments);
	};
	module.exports.polyfill = function (object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf;
	  object.cancelAnimationFrame = caf;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(678).polyfill();

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react-dom-server.browser.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var p = __webpack_require__(56),
	    q = __webpack_require__(1),
	    t = __webpack_require__(77),
	    w = __webpack_require__(124),
	    x = __webpack_require__(619),
	    y = __webpack_require__(623);
	function z(a) {
	  for (var b = arguments.length - 1, d = "Minified React error #" + a + "; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d" + a, c = 0; c < b; c++) {
	    d += "\x26args[]\x3d" + encodeURIComponent(arguments[c + 1]);
	  }b = Error(d + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name = "Invariant Violation";b.framesToPop = 1;throw b;
	}
	var A = "function" === typeof Symbol && Symbol["for"],
	    C = A ? Symbol["for"]("react.call") : 60104,
	    aa = A ? Symbol["for"]("react.return") : 60105,
	    ba = A ? Symbol["for"]("react.portal") : 60106,
	    E = A ? Symbol["for"]("react.fragment") : 60107,
	    ca = A ? Symbol["for"]("react.strict_mode") : 60108,
	    F = A ? Symbol["for"]("react.provider") : 60109,
	    da = A ? Symbol["for"]("react.context") : 60110,
	    ea = A ? Symbol["for"]("react.async_mode") : 60111,
	    fa = A ? Symbol["for"]("react.forward_ref") : 60112,
	    ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
	    G = {},
	    H = {};function ia(a) {
	  if (H.hasOwnProperty(a)) return !0;if (G.hasOwnProperty(a)) return !1;if (ha.test(a)) return H[a] = !0;G[a] = !0;return !1;
	}function ja(a, b, d, c) {
	  if (null !== d && 0 === d.type) return !1;switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {case "function":case "symbol":
	      return !0;case "boolean":
	      if (c) return !1;if (null !== d) return !d.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
	      return !1;}
	}
	function ka(a, b, d, c) {
	  if (null === b || "undefined" === typeof b || ja(a, b, d, c)) return !0;if (null !== d) switch (d.type) {case 3:
	      return !b;case 4:
	      return !1 === b;case 5:
	      return isNaN(b);case 6:
	      return isNaN(b) || 1 > b;}return !1;
	}function I(a, b, d, c, k) {
	  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = c;this.attributeNamespace = k;this.mustUseProperty = d;this.propertyName = a;this.type = b;
	}var J = {};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
	  J[a] = new I(a, 0, !1, a, null);
	});[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
	  var b = a[0];J[b] = new I(b, 1, !1, a[1], null);
	});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
	  J[a] = new I(a, 2, !1, a.toLowerCase(), null);
	});
	["autoReverse", "externalResourcesRequired", "preserveAlpha"].forEach(function (a) {
	  J[a] = new I(a, 2, !1, a, null);
	});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
	  J[a] = new I(a, 3, !1, a.toLowerCase(), null);
	});["checked", "multiple", "muted", "selected"].forEach(function (a) {
	  J[a] = new I(a, 3, !0, a.toLowerCase(), null);
	});
	["capture", "download"].forEach(function (a) {
	  J[a] = new I(a, 4, !1, a.toLowerCase(), null);
	});["cols", "rows", "size", "span"].forEach(function (a) {
	  J[a] = new I(a, 6, !1, a.toLowerCase(), null);
	});["rowSpan", "start"].forEach(function (a) {
	  J[a] = new I(a, 5, !1, a.toLowerCase(), null);
	});var K = /[\-\:]([a-z])/g;function L(a) {
	  return a[1].toUpperCase();
	}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
	  var b = a.replace(K, L);J[b] = new I(b, 1, !1, a, null);
	});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
	  var b = a.replace(K, L);J[b] = new I(b, 1, !1, a, "http://www.w3.org/1999/xlink");
	});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
	  var b = a.replace(K, L);J[b] = new I(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
	});J.tabIndex = new I("tabIndex", 1, !1, "tabindex", null);var la = /["'&<>]/;
	function M(a) {
	  if ("boolean" === typeof a || "number" === typeof a) return "" + a;a = "" + a;var b = la.exec(a);if (b) {
	    var d = "",
	        c,
	        k = 0;for (c = b.index; c < a.length; c++) {
	      switch (a.charCodeAt(c)) {case 34:
	          b = "\x26quot;";break;case 38:
	          b = "\x26amp;";break;case 39:
	          b = "\x26#x27;";break;case 60:
	          b = "\x26lt;";break;case 62:
	          b = "\x26gt;";break;default:
	          continue;}k !== c && (d += a.substring(k, c));k = c + 1;d += b;
	    }a = k !== c ? d + a.substring(k, c) : d;
	  }return a;
	}var N = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
	function O(a) {
	  switch (a) {case "svg":
	      return "http://www.w3.org/2000/svg";case "math":
	      return "http://www.w3.org/1998/Math/MathML";default:
	      return "http://www.w3.org/1999/xhtml";}
	}
	var P = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 },
	    ma = p({ menuitem: !0 }, P),
	    Q = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0,
	  fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0, floodOpacity: !0, stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
	    na = ["Webkit", "ms", "Moz", "O"];Object.keys(Q).forEach(function (a) {
	  na.forEach(function (b) {
	    b = b + a.charAt(0).toUpperCase() + a.substring(1);Q[b] = Q[a];
	  });
	});var R = q.Children.toArray,
	    S = t.thatReturns("");t.thatReturns("");var oa = { listing: !0, pre: !0, textarea: !0 };
	function T(a) {
	  return "string" === typeof a ? a : "function" === typeof a ? a.displayName || a.name : null;
	}var pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
	    U = {},
	    qa = y(function (a) {
	  return x(a);
	});function ra(a) {
	  var b = "";q.Children.forEach(a, function (a) {
	    null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
	  });return b;
	}function sa(a, b) {
	  if (a = a.contextTypes) {
	    var d = {},
	        c;for (c in a) {
	      d[c] = b[c];
	    }b = d;
	  } else b = w;return b;
	}var ta = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
	function V(a, b) {
	  void 0 === a && z("152", T(b) || "Component");
	}
	function ua(a, b) {
	  function d(c, k) {
	    var d = sa(k, b),
	        f = [],
	        h = !1,
	        g = { isMounted: function isMounted() {
	        return !1;
	      }, enqueueForceUpdate: function enqueueForceUpdate() {
	        if (null === f) return null;
	      }, enqueueReplaceState: function enqueueReplaceState(b, a) {
	        h = !0;f = [a];
	      }, enqueueSetState: function enqueueSetState(b, a) {
	        if (null === f) return null;f.push(a);
	      } },
	        e = void 0;if (k.prototype && k.prototype.isReactComponent) {
	      if (e = new k(c.props, d, g), "function" === typeof k.getDerivedStateFromProps) {
	        var v = k.getDerivedStateFromProps.call(null, c.props, e.state);null != v && (e.state = p({}, e.state, v));
	      }
	    } else if (e = k(c.props, d, g), null == e || null == e.render) {
	      a = e;V(a, k);return;
	    }e.props = c.props;e.context = d;e.updater = g;g = e.state;void 0 === g && (e.state = g = null);if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) if ("function" === typeof e.componentWillMount && "function" !== typeof k.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof k.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), f.length) {
	      g = f;var u = h;f = null;h = !1;if (u && 1 === g.length) e.state = g[0];else {
	        v = u ? g[0] : e.state;var m = !0;for (u = u ? 1 : 0; u < g.length; u++) {
	          var n = g[u];n = "function" === typeof n ? n.call(e, v, c.props, d) : n;null != n && (m ? (m = !1, v = p({}, v, n)) : p(v, n));
	        }e.state = v;
	      }
	    } else f = null;a = e.render();V(a, k);c = void 0;if ("function" === typeof e.getChildContext && (d = k.childContextTypes, "object" === (typeof d === "undefined" ? "undefined" : _typeof(d)))) {
	      c = e.getChildContext();for (var r in c) {
	        r in d ? void 0 : z("108", T(k) || "Unknown", r);
	      }
	    }c && (b = p({}, b, c));
	  }for (; q.isValidElement(a);) {
	    var c = a,
	        k = c.type;if ("function" !== typeof k) break;d(c, k);
	  }return { child: a,
	    context: b };
	}
	var W = function () {
	  function a(b, d) {
	    if (!(this instanceof a)) throw new TypeError("Cannot call a class as a function");q.isValidElement(b) ? b.type !== E ? b = [b] : (b = b.props.children, b = q.isValidElement(b) ? [b] : R(b)) : b = R(b);this.stack = [{ type: null, domNamespace: N.html, children: b, childIndex: 0, context: w, footer: "" }];this.exhausted = !1;this.currentSelectValue = null;this.previousWasTextNode = !1;this.makeStaticMarkup = d;this.providerStack = [];this.providerIndex = -1;
	  }a.prototype.pushProvider = function (a) {
	    this.providerIndex += 1;
	    this.providerStack[this.providerIndex] = a;a.type._context._currentValue = a.props.value;
	  };a.prototype.popProvider = function (a) {
	    this.providerStack[this.providerIndex] = null;--this.providerIndex;a = a.type._context;a._currentValue = 0 > this.providerIndex ? a._defaultValue : this.providerStack[this.providerIndex].props.value;
	  };a.prototype.read = function (a) {
	    if (this.exhausted) return null;for (var b = ""; b.length < a;) {
	      if (0 === this.stack.length) {
	        this.exhausted = !0;break;
	      }var c = this.stack[this.stack.length - 1];if (c.childIndex >= c.children.length) {
	        var k = c.footer;b += k;"" !== k && (this.previousWasTextNode = !1);this.stack.pop();"select" === c.type ? this.currentSelectValue = null : null != c.type && null != c.type.type && c.type.type.$$typeof === F && this.popProvider(c.type);
	      } else k = c.children[c.childIndex++], b += this.render(k, c.context, c.domNamespace);
	    }return b;
	  };a.prototype.render = function (a, d, c) {
	    if ("string" === typeof a || "number" === typeof a) {
	      c = "" + a;if ("" === c) return "";if (this.makeStaticMarkup) return M(c);if (this.previousWasTextNode) return "\x3c!-- --\x3e" + M(c);this.previousWasTextNode = !0;return M(c);
	    }d = ua(a, d);a = d.child;d = d.context;if (null === a || !1 === a) return "";if (!q.isValidElement(a)) {
	      if (null != a && null != a.$$typeof) {
	        var b = a.$$typeof;b === ba ? z("257") : void 0;z("258", b.toString());
	      }a = R(a);this.stack.push({ type: null, domNamespace: c, children: a, childIndex: 0, context: d, footer: "" });return "";
	    }b = a.type;if ("string" === typeof b) return this.renderDOM(a, d, c);switch (b) {case ca:case ea:case E:
	        return a = R(a.props.children), this.stack.push({ type: null, domNamespace: c, children: a, childIndex: 0, context: d, footer: "" }), "";case C:case aa:
	        z("259");}if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) switch (b.$$typeof) {case fa:
	        return a = R(b.render(a.props, a.ref)), this.stack.push({ type: null, domNamespace: c, children: a, childIndex: 0, context: d, footer: "" }), "";case F:
	        return b = R(a.props.children), c = { type: a, domNamespace: c, children: b, childIndex: 0, context: d, footer: "" }, this.pushProvider(a), this.stack.push(c), "";case da:
	        return b = R(a.props.children(a.type._currentValue)), this.stack.push({ type: a, domNamespace: c, children: b, childIndex: 0, context: d, footer: "" }), "";}z("130", null == b ? b : typeof b === "undefined" ? "undefined" : _typeof(b), "");
	  };a.prototype.renderDOM = function (a, d, c) {
	    var b = a.type.toLowerCase();c === N.html && O(b);U.hasOwnProperty(b) || (pa.test(b) ? void 0 : z("65", b), U[b] = !0);var f = a.props;if ("input" === b) f = p({ type: void 0 }, f, { defaultChecked: void 0, defaultValue: void 0, value: null != f.value ? f.value : f.defaultValue, checked: null != f.checked ? f.checked : f.defaultChecked });else if ("textarea" === b) {
	      var h = f.value;if (null == h) {
	        h = f.defaultValue;var l = f.children;null != l && (null != h ? z("92") : void 0, Array.isArray(l) && (1 >= l.length ? void 0 : z("93"), l = l[0]), h = "" + l);null == h && (h = "");
	      }f = p({}, f, { value: void 0, children: "" + h });
	    } else if ("select" === b) this.currentSelectValue = null != f.value ? f.value : f.defaultValue, f = p({}, f, { value: void 0 });else if ("option" === b) {
	      l = this.currentSelectValue;var D = ra(f.children);if (null != l) {
	        var B = null != f.value ? f.value + "" : D;h = !1;if (Array.isArray(l)) for (var g = 0; g < l.length; g++) {
	          if ("" + l[g] === B) {
	            h = !0;break;
	          }
	        } else h = "" + l === B;f = p({ selected: void 0, children: void 0 }, f, { selected: h, children: D });
	      }
	    }if (h = f) ma[b] && (null != h.children || null != h.dangerouslySetInnerHTML ? z("137", b, S()) : void 0), null != h.dangerouslySetInnerHTML && (null != h.children ? z("60") : void 0, "object" === _typeof(h.dangerouslySetInnerHTML) && "__html" in h.dangerouslySetInnerHTML ? void 0 : z("61")), null != h.style && "object" !== _typeof(h.style) ? z("62", S()) : void 0;h = f;l = this.makeStaticMarkup;D = 1 === this.stack.length;B = "\x3c" + a.type;for (r in h) {
	      if (h.hasOwnProperty(r)) {
	        var e = h[r];if (null != e) {
	          if ("style" === r) {
	            g = void 0;var v = "",
	                u = "";for (g in e) {
	              if (e.hasOwnProperty(g)) {
	                var m = 0 === g.indexOf("--"),
	                    n = e[g];null != n && (v += u + qa(g) + ":", u = g, m = null == n || "boolean" === typeof n || "" === n ? "" : m || "number" !== typeof n || 0 === n || Q.hasOwnProperty(u) && Q[u] ? ("" + n).trim() : n + "px", v += m, u = ";");
	              }
	            }e = v || null;
	          }g = null;b: if (m = b, n = h, -1 === m.indexOf("-")) m = "string" === typeof n.is;else switch (m) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
	              m = !1;break b;default:
	              m = !0;}if (m) ta.hasOwnProperty(r) || (g = r, g = ia(g) && null != e ? g + "\x3d" + ('"' + M(e) + '"') : "");else {
	            m = r;g = e;e = J.hasOwnProperty(m) ? J[m] : null;if (n = "style" !== m) n = null !== e ? 0 === e.type : !(2 < m.length) || "o" !== m[0] && "O" !== m[0] || "n" !== m[1] && "N" !== m[1] ? !1 : !0;n || ka(m, g, e, !1) ? g = "" : null !== e ? (m = e.attributeName, e = e.type, g = 3 === e || 4 === e && !0 === g ? m + '\x3d""' : m + "\x3d" + ('"' + M(g) + '"')) : g = m + "\x3d" + ('"' + M(g) + '"');
	          }g && (B += " " + g);
	        }
	      }
	    }l || D && (B += ' data-reactroot\x3d""');var r = B;h = "";P.hasOwnProperty(b) ? r += "/\x3e" : (r += "\x3e", h = "\x3c/" + a.type + "\x3e");a: {
	      l = f.dangerouslySetInnerHTML;if (null != l) {
	        if (null != l.__html) {
	          l = l.__html;break a;
	        }
	      } else if (l = f.children, "string" === typeof l || "number" === typeof l) {
	        l = M(l);break a;
	      }l = null;
	    }null != l ? (f = [], oa[b] && "\n" === l.charAt(0) && (r += "\n"), r += l) : f = R(f.children);a = a.type;c = null == c || "http://www.w3.org/1999/xhtml" === c ? O(a) : "http://www.w3.org/2000/svg" === c && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : c;this.stack.push({ domNamespace: c, type: b, children: f, childIndex: 0, context: d, footer: h });this.previousWasTextNode = !1;return r;
	  };return a;
	}(),
	    X = { renderToString: function renderToString(a) {
	    return new W(a, !1).read(Infinity);
	  }, renderToStaticMarkup: function renderToStaticMarkup(a) {
	    return new W(a, !0).read(Infinity);
	  }, renderToNodeStream: function renderToNodeStream() {
	    z("207");
	  }, renderToStaticNodeStream: function renderToStaticNodeStream() {
	    z("208");
	  }, version: "16.3.1" },
	    Y = Object.freeze({ default: X }),
	    Z = Y && X || Y;module.exports = Z["default"] ? Z["default"] : Z;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var ba = __webpack_require__(1),
	    m = __webpack_require__(615),
	    A = __webpack_require__(56),
	    C = __webpack_require__(77),
	    ea = __webpack_require__(617),
	    fa = __webpack_require__(624),
	    ha = __webpack_require__(616),
	    ja = __webpack_require__(124);
	function D(a) {
	  for (var b = arguments.length - 1, c = "Minified React error #" + a + "; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d" + a, d = 0; d < b; d++) {
	    c += "\x26args[]\x3d" + encodeURIComponent(arguments[d + 1]);
	  }b = Error(c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name = "Invariant Violation";b.framesToPop = 1;throw b;
	}ba ? void 0 : D("227");
	function ka(a, b, c, d, e, f, h, g, k) {
	  this._hasCaughtError = !1;this._caughtError = null;var v = Array.prototype.slice.call(arguments, 3);try {
	    b.apply(c, v);
	  } catch (l) {
	    this._caughtError = l, this._hasCaughtError = !0;
	  }
	}
	var E = { _caughtError: null, _hasCaughtError: !1, _rethrowError: null, _hasRethrowError: !1, invokeGuardedCallback: function invokeGuardedCallback(a, b, c, d, e, f, h, g, k) {
	    ka.apply(E, arguments);
	  }, invokeGuardedCallbackAndCatchFirstError: function invokeGuardedCallbackAndCatchFirstError(a, b, c, d, e, f, h, g, k) {
	    E.invokeGuardedCallback.apply(this, arguments);if (E.hasCaughtError()) {
	      var v = E.clearCaughtError();E._hasRethrowError || (E._hasRethrowError = !0, E._rethrowError = v);
	    }
	  }, rethrowCaughtError: function rethrowCaughtError() {
	    return ma.apply(E, arguments);
	  }, hasCaughtError: function hasCaughtError() {
	    return E._hasCaughtError;
	  }, clearCaughtError: function clearCaughtError() {
	    if (E._hasCaughtError) {
	      var a = E._caughtError;E._caughtError = null;E._hasCaughtError = !1;return a;
	    }D("198");
	  } };function ma() {
	  if (E._hasRethrowError) {
	    var a = E._rethrowError;E._rethrowError = null;E._hasRethrowError = !1;throw a;
	  }
	}var na = null,
	    oa = {};
	function pa() {
	  if (na) for (var a in oa) {
	    var b = oa[a],
	        c = na.indexOf(a);-1 < c ? void 0 : D("96", a);if (!qa[c]) {
	      b.extractEvents ? void 0 : D("97", a);qa[c] = b;c = b.eventTypes;for (var d in c) {
	        var e = void 0;var f = c[d],
	            h = b,
	            g = d;ra.hasOwnProperty(g) ? D("99", g) : void 0;ra[g] = f;var k = f.phasedRegistrationNames;if (k) {
	          for (e in k) {
	            k.hasOwnProperty(e) && sa(k[e], h, g);
	          }e = !0;
	        } else f.registrationName ? (sa(f.registrationName, h, g), e = !0) : e = !1;e ? void 0 : D("98", d, a);
	      }
	    }
	  }
	}
	function sa(a, b, c) {
	  ta[a] ? D("100", a) : void 0;ta[a] = b;ua[a] = b.eventTypes[c].dependencies;
	}var qa = [],
	    ra = {},
	    ta = {},
	    ua = {};function va(a) {
	  na ? D("101") : void 0;na = Array.prototype.slice.call(a);pa();
	}function wa(a) {
	  var b = !1,
	      c;for (c in a) {
	    if (a.hasOwnProperty(c)) {
	      var d = a[c];oa.hasOwnProperty(c) && oa[c] === d || (oa[c] ? D("102", c) : void 0, oa[c] = d, b = !0);
	    }
	  }b && pa();
	}
	var xa = Object.freeze({ plugins: qa, eventNameDispatchConfigs: ra, registrationNameModules: ta, registrationNameDependencies: ua, possibleRegistrationNames: null, injectEventPluginOrder: va, injectEventPluginsByName: wa }),
	    Ca = null,
	    Da = null,
	    Ea = null;function Fa(a, b, c, d) {
	  b = a.type || "unknown-event";a.currentTarget = Ea(d);E.invokeGuardedCallbackAndCatchFirstError(b, c, void 0, a);a.currentTarget = null;
	}
	function Ga(a, b) {
	  null == b ? D("30") : void 0;if (null == a) return b;if (Array.isArray(a)) {
	    if (Array.isArray(b)) return a.push.apply(a, b), a;a.push(b);return a;
	  }return Array.isArray(b) ? [a].concat(b) : [a, b];
	}function Ha(a, b, c) {
	  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
	}var Ia = null;
	function Ja(a, b) {
	  if (a) {
	    var c = a._dispatchListeners,
	        d = a._dispatchInstances;if (Array.isArray(c)) for (var e = 0; e < c.length && !a.isPropagationStopped(); e++) {
	      Fa(a, b, c[e], d[e]);
	    } else c && Fa(a, b, c, d);a._dispatchListeners = null;a._dispatchInstances = null;a.isPersistent() || a.constructor.release(a);
	  }
	}function Ka(a) {
	  return Ja(a, !0);
	}function La(a) {
	  return Ja(a, !1);
	}var Ma = { injectEventPluginOrder: va, injectEventPluginsByName: wa };
	function Na(a, b) {
	  var c = a.stateNode;if (!c) return null;var d = Ca(c);if (!d) return null;c = d[b];a: switch (b) {case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":
	      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));a = !d;break a;default:
	      a = !1;}if (a) return null;c && "function" !== typeof c ? D("231", b, typeof c === "undefined" ? "undefined" : _typeof(c)) : void 0;
	  return c;
	}function Oa(a, b) {
	  null !== a && (Ia = Ga(Ia, a));a = Ia;Ia = null;a && (b ? Ha(a, Ka) : Ha(a, La), Ia ? D("95") : void 0, E.rethrowCaughtError());
	}function Pa(a, b, c, d) {
	  for (var e = null, f = 0; f < qa.length; f++) {
	    var h = qa[f];h && (h = h.extractEvents(a, b, c, d)) && (e = Ga(e, h));
	  }Oa(e, !1);
	}var Qa = Object.freeze({ injection: Ma, getListener: Na, runEventsInBatch: Oa, runExtractedEventsInBatch: Pa }),
	    Ra = Math.random().toString(36).slice(2),
	    F = "__reactInternalInstance$" + Ra,
	    Sa = "__reactEventHandlers$" + Ra;
	function Ta(a) {
	  if (a[F]) return a[F];for (; !a[F];) {
	    if (a.parentNode) a = a.parentNode;else return null;
	  }a = a[F];return 5 === a.tag || 6 === a.tag ? a : null;
	}function Ua(a) {
	  if (5 === a.tag || 6 === a.tag) return a.stateNode;D("33");
	}function Va(a) {
	  return a[Sa] || null;
	}var Xa = Object.freeze({ precacheFiberNode: function precacheFiberNode(a, b) {
	    b[F] = a;
	  }, getClosestInstanceFromNode: Ta, getInstanceFromNode: function getInstanceFromNode(a) {
	    a = a[F];return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
	  }, getNodeFromInstance: Ua, getFiberCurrentPropsFromNode: Va, updateFiberProps: function updateFiberProps(a, b) {
	    a[Sa] = b;
	  } });
	function L(a) {
	  do {
	    a = a["return"];
	  } while (a && 5 !== a.tag);return a ? a : null;
	}function bb(a, b, c) {
	  for (var d = []; a;) {
	    d.push(a), a = L(a);
	  }for (a = d.length; 0 < a--;) {
	    b(d[a], "captured", c);
	  }for (a = 0; a < d.length; a++) {
	    b(d[a], "bubbled", c);
	  }
	}function cb(a, b, c) {
	  if (b = Na(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = Ga(c._dispatchListeners, b), c._dispatchInstances = Ga(c._dispatchInstances, a);
	}function db(a) {
	  a && a.dispatchConfig.phasedRegistrationNames && bb(a._targetInst, cb, a);
	}
	function eb(a) {
	  if (a && a.dispatchConfig.phasedRegistrationNames) {
	    var b = a._targetInst;b = b ? L(b) : null;bb(b, cb, a);
	  }
	}function fb(a, b, c) {
	  a && c && c.dispatchConfig.registrationName && (b = Na(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = Ga(c._dispatchListeners, b), c._dispatchInstances = Ga(c._dispatchInstances, a));
	}function gb(a) {
	  a && a.dispatchConfig.registrationName && fb(a._targetInst, null, a);
	}function hb(a) {
	  Ha(a, db);
	}
	function ib(a, b, c, d) {
	  if (c && d) a: {
	    var e = c;for (var f = d, h = 0, g = e; g; g = L(g)) {
	      h++;
	    }g = 0;for (var k = f; k; k = L(k)) {
	      g++;
	    }for (; 0 < h - g;) {
	      e = L(e), h--;
	    }for (; 0 < g - h;) {
	      f = L(f), g--;
	    }for (; h--;) {
	      if (e === f || e === f.alternate) break a;e = L(e);f = L(f);
	    }e = null;
	  } else e = null;f = e;for (e = []; c && c !== f;) {
	    h = c.alternate;if (null !== h && h === f) break;e.push(c);c = L(c);
	  }for (c = []; d && d !== f;) {
	    h = d.alternate;if (null !== h && h === f) break;c.push(d);d = L(d);
	  }for (d = 0; d < e.length; d++) {
	    fb(e[d], "bubbled", a);
	  }for (a = c.length; 0 < a--;) {
	    fb(c[a], "captured", b);
	  }
	}
	var jb = Object.freeze({ accumulateTwoPhaseDispatches: hb, accumulateTwoPhaseDispatchesSkipTarget: function accumulateTwoPhaseDispatchesSkipTarget(a) {
	    Ha(a, eb);
	  }, accumulateEnterLeaveDispatches: ib, accumulateDirectDispatches: function accumulateDirectDispatches(a) {
	    Ha(a, gb);
	  } }),
	    kb = null;function lb() {
	  !kb && m.canUseDOM && (kb = "textContent" in document.documentElement ? "textContent" : "innerText");return kb;
	}var M = { _root: null, _startText: null, _fallbackText: null };
	function mb() {
	  if (M._fallbackText) return M._fallbackText;var a,
	      b = M._startText,
	      c = b.length,
	      d,
	      e = nb(),
	      f = e.length;for (a = 0; a < c && b[a] === e[a]; a++) {}var h = c - a;for (d = 1; d <= h && b[c - d] === e[f - d]; d++) {}M._fallbackText = e.slice(a, 1 < d ? 1 - d : void 0);return M._fallbackText;
	}function nb() {
	  return "value" in M._root ? M._root.value : M._root[lb()];
	}
	var ob = "dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),
	    pb = { type: null, target: null, currentTarget: C.thatReturnsNull, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function timeStamp(a) {
	    return a.timeStamp || Date.now();
	  }, defaultPrevented: null, isTrusted: null };
	function N(a, b, c, d) {
	  this.dispatchConfig = a;this._targetInst = b;this.nativeEvent = c;a = this.constructor.Interface;for (var e in a) {
	    a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
	  }this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? C.thatReturnsTrue : C.thatReturnsFalse;this.isPropagationStopped = C.thatReturnsFalse;return this;
	}
	A(N.prototype, { preventDefault: function preventDefault() {
	    this.defaultPrevented = !0;var a = this.nativeEvent;a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = C.thatReturnsTrue);
	  }, stopPropagation: function stopPropagation() {
	    var a = this.nativeEvent;a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = C.thatReturnsTrue);
	  }, persist: function persist() {
	    this.isPersistent = C.thatReturnsTrue;
	  }, isPersistent: C.thatReturnsFalse,
	  destructor: function destructor() {
	    var a = this.constructor.Interface,
	        b;for (b in a) {
	      this[b] = null;
	    }for (a = 0; a < ob.length; a++) {
	      this[ob[a]] = null;
	    }
	  } });N.Interface = pb;N.extend = function (a) {
	  function b() {}function c() {
	    return d.apply(this, arguments);
	  }var d = this;b.prototype = d.prototype;var e = new b();A(e, c.prototype);c.prototype = e;c.prototype.constructor = c;c.Interface = A({}, d.Interface, a);c.extend = d.extend;qb(c);return c;
	};qb(N);
	function rb(a, b, c, d) {
	  if (this.eventPool.length) {
	    var e = this.eventPool.pop();this.call(e, a, b, c, d);return e;
	  }return new this(a, b, c, d);
	}function sb(a) {
	  a instanceof this ? void 0 : D("223");a.destructor();10 > this.eventPool.length && this.eventPool.push(a);
	}function qb(a) {
	  a.eventPool = [];a.getPooled = rb;a.release = sb;
	}var tb = N.extend({ data: null }),
	    ub = N.extend({ data: null }),
	    vb = [9, 13, 27, 32],
	    wb = m.canUseDOM && "CompositionEvent" in window,
	    xb = null;m.canUseDOM && "documentMode" in document && (xb = document.documentMode);
	var yb = m.canUseDOM && "TextEvent" in window && !xb,
	    zb = m.canUseDOM && (!wb || xb && 8 < xb && 11 >= xb),
	    Ab = String.fromCharCode(32),
	    Bb = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["topCompositionEnd", "topKeyPress", "topTextInput", "topPaste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart",
	      captured: "onCompositionStartCapture" }, dependencies: "topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") } },
	    Kb = !1;
	function Lb(a, b) {
	  switch (a) {case "topKeyUp":
	      return -1 !== vb.indexOf(b.keyCode);case "topKeyDown":
	      return 229 !== b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":
	      return !0;default:
	      return !1;}
	}function Mb(a) {
	  a = a.detail;return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && "data" in a ? a.data : null;
	}var Nb = !1;function Ob(a, b) {
	  switch (a) {case "topCompositionEnd":
	      return Mb(b);case "topKeyPress":
	      if (32 !== b.which) return null;Kb = !0;return Ab;case "topTextInput":
	      return a = b.data, a === Ab && Kb ? null : a;default:
	      return null;}
	}
	function Pb(a, b) {
	  if (Nb) return "topCompositionEnd" === a || !wb && Lb(a, b) ? (a = mb(), M._root = null, M._startText = null, M._fallbackText = null, Nb = !1, a) : null;switch (a) {case "topPaste":
	      return null;case "topKeyPress":
	      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
	        if (b.char && 1 < b.char.length) return b.char;if (b.which) return String.fromCharCode(b.which);
	      }return null;case "topCompositionEnd":
	      return zb ? null : b.data;default:
	      return null;}
	}
	var Qb = { eventTypes: Bb, extractEvents: function extractEvents(a, b, c, d) {
	    var e = void 0;var f = void 0;if (wb) b: {
	      switch (a) {case "topCompositionStart":
	          e = Bb.compositionStart;break b;case "topCompositionEnd":
	          e = Bb.compositionEnd;break b;case "topCompositionUpdate":
	          e = Bb.compositionUpdate;break b;}e = void 0;
	    } else Nb ? Lb(a, c) && (e = Bb.compositionEnd) : "topKeyDown" === a && 229 === c.keyCode && (e = Bb.compositionStart);e ? (zb && (Nb || e !== Bb.compositionStart ? e === Bb.compositionEnd && Nb && (f = mb()) : (M._root = d, M._startText = nb(), Nb = !0)), e = tb.getPooled(e, b, c, d), f ? e.data = f : (f = Mb(c), null !== f && (e.data = f)), hb(e), f = e) : f = null;(a = yb ? Ob(a, c) : Pb(a, c)) ? (b = ub.getPooled(Bb.beforeInput, b, c, d), b.data = a, hb(b)) : b = null;return null === f ? b : null === b ? f : [f, b];
	  } },
	    Rb = null,
	    Sb = null,
	    Tb = null;function Ub(a) {
	  if (a = Da(a)) {
	    Rb && "function" === typeof Rb.restoreControlledState ? void 0 : D("194");var b = Ca(a.stateNode);Rb.restoreControlledState(a.stateNode, a.type, b);
	  }
	}var Vb = { injectFiberControlledHostComponent: function injectFiberControlledHostComponent(a) {
	    Rb = a;
	  } };function Wb(a) {
	  Sb ? Tb ? Tb.push(a) : Tb = [a] : Sb = a;
	}
	function Xb() {
	  return null !== Sb || null !== Tb;
	}function Yb() {
	  if (Sb) {
	    var a = Sb,
	        b = Tb;Tb = Sb = null;Ub(a);if (b) for (a = 0; a < b.length; a++) {
	      Ub(b[a]);
	    }
	  }
	}var Zb = Object.freeze({ injection: Vb, enqueueStateRestore: Wb, needsStateRestore: Xb, restoreStateIfNeeded: Yb });function $b(a, b) {
	  return a(b);
	}function ac(a, b, c) {
	  return a(b, c);
	}function bc() {}var cc = !1;function dc(a, b) {
	  if (cc) return a(b);cc = !0;try {
	    return $b(a, b);
	  } finally {
	    cc = !1, Xb() && (bc(), Yb());
	  }
	}
	var ec = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };function fc(a) {
	  var b = a && a.nodeName && a.nodeName.toLowerCase();return "input" === b ? !!ec[a.type] : "textarea" === b ? !0 : !1;
	}function gc(a) {
	  a = a.target || window;a.correspondingUseElement && (a = a.correspondingUseElement);return 3 === a.nodeType ? a.parentNode : a;
	}
	function hc(a, b) {
	  if (!m.canUseDOM || b && !("addEventListener" in document)) return !1;a = "on" + a;b = a in document;b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);return b;
	}function ic(a) {
	  var b = a.type;return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
	}
	function jc(a) {
	  var b = ic(a) ? "checked" : "value",
	      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
	      d = "" + a[b];if (!a.hasOwnProperty(b) && "function" === typeof c.get && "function" === typeof c.set) return Object.defineProperty(a, b, { configurable: !0, get: function get() {
	      return c.get.call(this);
	    }, set: function set(a) {
	      d = "" + a;c.set.call(this, a);
	    } }), Object.defineProperty(a, b, { enumerable: c.enumerable }), { getValue: function getValue() {
	      return d;
	    }, setValue: function setValue(a) {
	      d = "" + a;
	    }, stopTracking: function stopTracking() {
	      a._valueTracker = null;delete a[b];
	    } };
	}
	function kc(a) {
	  a._valueTracker || (a._valueTracker = jc(a));
	}function lc(a) {
	  if (!a) return !1;var b = a._valueTracker;if (!b) return !0;var c = b.getValue();var d = "";a && (d = ic(a) ? a.checked ? "true" : "false" : a.value);a = d;return a !== c ? (b.setValue(a), !0) : !1;
	}
	var mc = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
	    O = "function" === typeof Symbol && Symbol["for"],
	    nc = O ? Symbol["for"]("react.element") : 60103,
	    oc = O ? Symbol["for"]("react.call") : 60104,
	    pc = O ? Symbol["for"]("react.return") : 60105,
	    qc = O ? Symbol["for"]("react.portal") : 60106,
	    rc = O ? Symbol["for"]("react.fragment") : 60107,
	    sc = O ? Symbol["for"]("react.strict_mode") : 60108,
	    tc = O ? Symbol["for"]("react.provider") : 60109,
	    uc = O ? Symbol["for"]("react.context") : 60110,
	    vc = O ? Symbol["for"]("react.async_mode") : 60111,
	    wc = O ? Symbol["for"]("react.forward_ref") : 60112,
	    xc = "function" === typeof Symbol && Symbol.iterator;function yc(a) {
	  if (null === a || "undefined" === typeof a) return null;a = xc && a[xc] || a["@@iterator"];return "function" === typeof a ? a : null;
	}function zc(a) {
	  a = a.type;if ("function" === typeof a) return a.displayName || a.name;if ("string" === typeof a) return a;switch (a) {case rc:
	      return "ReactFragment";case qc:
	      return "ReactPortal";case oc:
	      return "ReactCall";case pc:
	      return "ReactReturn";}return null;
	}
	function Ac(a) {
	  var b = "";do {
	    a: switch (a.tag) {case 0:case 1:case 2:case 5:
	        var c = a._debugOwner,
	            d = a._debugSource;var e = zc(a);var f = null;c && (f = zc(c));c = d;e = "\n    in " + (e || "Unknown") + (c ? " (at " + c.fileName.replace(/^.*[\\\/]/, "") + ":" + c.lineNumber + ")" : f ? " (created by " + f + ")" : "");break a;default:
	        e = "";}b += e;a = a["return"];
	  } while (a);return b;
	}
	var Bc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
	    Cc = {},
	    Dc = {};function Ec(a) {
	  if (Dc.hasOwnProperty(a)) return !0;if (Cc.hasOwnProperty(a)) return !1;if (Bc.test(a)) return Dc[a] = !0;Cc[a] = !0;return !1;
	}
	function Fc(a, b, c, d) {
	  if (null !== c && 0 === c.type) return !1;switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {case "function":case "symbol":
	      return !0;case "boolean":
	      if (d) return !1;if (null !== c) return !c.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
	      return !1;}
	}function Gc(a, b, c, d) {
	  if (null === b || "undefined" === typeof b || Fc(a, b, c, d)) return !0;if (null !== c) switch (c.type) {case 3:
	      return !b;case 4:
	      return !1 === b;case 5:
	      return isNaN(b);case 6:
	      return isNaN(b) || 1 > b;}return !1;
	}
	function U(a, b, c, d, e) {
	  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = d;this.attributeNamespace = e;this.mustUseProperty = c;this.propertyName = a;this.type = b;
	}var V = {};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
	  V[a] = new U(a, 0, !1, a, null);
	});
	[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
	  var b = a[0];V[b] = new U(b, 1, !1, a[1], null);
	});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
	  V[a] = new U(a, 2, !1, a.toLowerCase(), null);
	});["autoReverse", "externalResourcesRequired", "preserveAlpha"].forEach(function (a) {
	  V[a] = new U(a, 2, !1, a, null);
	});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
	  V[a] = new U(a, 3, !1, a.toLowerCase(), null);
	});["checked", "multiple", "muted", "selected"].forEach(function (a) {
	  V[a] = new U(a, 3, !0, a.toLowerCase(), null);
	});["capture", "download"].forEach(function (a) {
	  V[a] = new U(a, 4, !1, a.toLowerCase(), null);
	});
	["cols", "rows", "size", "span"].forEach(function (a) {
	  V[a] = new U(a, 6, !1, a.toLowerCase(), null);
	});["rowSpan", "start"].forEach(function (a) {
	  V[a] = new U(a, 5, !1, a.toLowerCase(), null);
	});var Hc = /[\-\:]([a-z])/g;function Sc(a) {
	  return a[1].toUpperCase();
	}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
	  var b = a.replace(Hc, Sc);V[b] = new U(b, 1, !1, a, null);
	});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
	  var b = a.replace(Hc, Sc);V[b] = new U(b, 1, !1, a, "http://www.w3.org/1999/xlink");
	});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
	  var b = a.replace(Hc, Sc);V[b] = new U(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
	});V.tabIndex = new U("tabIndex", 1, !1, "tabindex", null);
	function Tc(a, b, c, d) {
	  var e = V.hasOwnProperty(b) ? V[b] : null;var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;f || (Gc(b, c, e, d) && (c = null), d || null === e ? Ec(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
	}
	function Uc(a, b) {
	  var c = b.checked;return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
	}function Vc(a, b) {
	  var c = null == b.defaultValue ? "" : b.defaultValue,
	      d = null != b.checked ? b.checked : b.defaultChecked;c = Wc(null != b.value ? b.value : c);a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
	}function Xc(a, b) {
	  b = b.checked;null != b && Tc(a, "checked", b, !1);
	}
	function Yc(a, b) {
	  Xc(a, b);var c = Wc(b.value);if (null != c) if ("number" === b.type) {
	    if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
	  } else a.value !== "" + c && (a.value = "" + c);b.hasOwnProperty("value") ? Zc(a, b.type, c) : b.hasOwnProperty("defaultValue") && Zc(a, b.type, Wc(b.defaultValue));null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
	}
	function $c(a, b) {
	  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) "" === a.value && (a.value = "" + a._wrapperState.initialValue), a.defaultValue = "" + a._wrapperState.initialValue;b = a.name;"" !== b && (a.name = "");a.defaultChecked = !a.defaultChecked;a.defaultChecked = !a.defaultChecked;"" !== b && (a.name = b);
	}function Zc(a, b, c) {
	  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
	}
	function Wc(a) {
	  switch (typeof a === "undefined" ? "undefined" : _typeof(a)) {case "boolean":case "number":case "object":case "string":case "undefined":
	      return a;default:
	      return "";}
	}var ad = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ") } };function bd(a, b, c) {
	  a = N.getPooled(ad.change, a, b, c);a.type = "change";Wb(c);hb(a);return a;
	}var cd = null,
	    dd = null;function ed(a) {
	  Oa(a, !1);
	}
	function fd(a) {
	  var b = Ua(a);if (lc(b)) return a;
	}function gd(a, b) {
	  if ("topChange" === a) return b;
	}var hd = !1;m.canUseDOM && (hd = hc("input") && (!document.documentMode || 9 < document.documentMode));function id() {
	  cd && (cd.detachEvent("onpropertychange", jd), dd = cd = null);
	}function jd(a) {
	  "value" === a.propertyName && fd(dd) && (a = bd(dd, a, gc(a)), dc(ed, a));
	}function kd(a, b, c) {
	  "topFocus" === a ? (id(), cd = b, dd = c, cd.attachEvent("onpropertychange", jd)) : "topBlur" === a && id();
	}
	function ld(a) {
	  if ("topSelectionChange" === a || "topKeyUp" === a || "topKeyDown" === a) return fd(dd);
	}function md(a, b) {
	  if ("topClick" === a) return fd(b);
	}function nd(a, b) {
	  if ("topInput" === a || "topChange" === a) return fd(b);
	}
	var od = { eventTypes: ad, _isInputEventSupported: hd, extractEvents: function extractEvents(a, b, c, d) {
	    var e = b ? Ua(b) : window,
	        f = void 0,
	        h = void 0,
	        g = e.nodeName && e.nodeName.toLowerCase();"select" === g || "input" === g && "file" === e.type ? f = gd : fc(e) ? hd ? f = nd : (f = ld, h = kd) : (g = e.nodeName, !g || "input" !== g.toLowerCase() || "checkbox" !== e.type && "radio" !== e.type || (f = md));if (f && (f = f(a, b))) return bd(f, c, d);h && h(a, e, b);"topBlur" === a && null != b && (a = b._wrapperState || e._wrapperState) && a.controlled && "number" === e.type && Zc(e, "number", e.value);
	  } },
	    pd = N.extend({ view: null,
	  detail: null }),
	    qd = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };function rd(a) {
	  var b = this.nativeEvent;return b.getModifierState ? b.getModifierState(a) : (a = qd[a]) ? !!b[a] : !1;
	}function sd() {
	  return rd;
	}
	var td = pd.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: sd, button: null, buttons: null, relatedTarget: function relatedTarget(a) {
	    return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
	  } }),
	    ud = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["topMouseOut", "topMouseOver"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["topMouseOut", "topMouseOver"] } },
	    vd = { eventTypes: ud, extractEvents: function extractEvents(a, b, c, d) {
	    if ("topMouseOver" === a && (c.relatedTarget || c.fromElement) || "topMouseOut" !== a && "topMouseOver" !== a) return null;var e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;"topMouseOut" === a ? (a = b, b = (b = c.relatedTarget || c.toElement) ? Ta(b) : null) : a = null;if (a === b) return null;var f = null == a ? e : Ua(a);e = null == b ? e : Ua(b);var h = td.getPooled(ud.mouseLeave, a, c, d);h.type = "mouseleave";h.target = f;h.relatedTarget = e;c = td.getPooled(ud.mouseEnter, b, c, d);c.type = "mouseenter";c.target = e;c.relatedTarget = f;ib(h, c, a, b);return [h, c];
	  } };function wd(a) {
	  var b = a;if (a.alternate) for (; b["return"];) {
	    b = b["return"];
	  } else {
	    if (0 !== (b.effectTag & 2)) return 1;for (; b["return"];) {
	      if (b = b["return"], 0 !== (b.effectTag & 2)) return 1;
	    }
	  }return 3 === b.tag ? 2 : 3;
	}function xd(a) {
	  return (a = a._reactInternalFiber) ? 2 === wd(a) : !1;
	}function yd(a) {
	  2 !== wd(a) ? D("188") : void 0;
	}
	function zd(a) {
	  var b = a.alternate;if (!b) return b = wd(a), 3 === b ? D("188") : void 0, 1 === b ? null : a;for (var c = a, d = b;;) {
	    var e = c["return"],
	        f = e ? e.alternate : null;if (!e || !f) break;if (e.child === f.child) {
	      for (var h = e.child; h;) {
	        if (h === c) return yd(e), a;if (h === d) return yd(e), b;h = h.sibling;
	      }D("188");
	    }if (c["return"] !== d["return"]) c = e, d = f;else {
	      h = !1;for (var g = e.child; g;) {
	        if (g === c) {
	          h = !0;c = e;d = f;break;
	        }if (g === d) {
	          h = !0;d = e;c = f;break;
	        }g = g.sibling;
	      }if (!h) {
	        for (g = f.child; g;) {
	          if (g === c) {
	            h = !0;c = f;d = e;break;
	          }if (g === d) {
	            h = !0;d = f;c = e;break;
	          }g = g.sibling;
	        }h ? void 0 : D("189");
	      }
	    }c.alternate !== d ? D("190") : void 0;
	  }3 !== c.tag ? D("188") : void 0;return c.stateNode.current === c ? a : b;
	}function Ad(a) {
	  a = zd(a);if (!a) return null;for (var b = a;;) {
	    if (5 === b.tag || 6 === b.tag) return b;if (b.child) b.child["return"] = b, b = b.child;else {
	      if (b === a) break;for (; !b.sibling;) {
	        if (!b["return"] || b["return"] === a) return null;b = b["return"];
	      }b.sibling["return"] = b["return"];b = b.sibling;
	    }
	  }return null;
	}
	function Bd(a) {
	  a = zd(a);if (!a) return null;for (var b = a;;) {
	    if (5 === b.tag || 6 === b.tag) return b;if (b.child && 4 !== b.tag) b.child["return"] = b, b = b.child;else {
	      if (b === a) break;for (; !b.sibling;) {
	        if (!b["return"] || b["return"] === a) return null;b = b["return"];
	      }b.sibling["return"] = b["return"];b = b.sibling;
	    }
	  }return null;
	}var Cd = N.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),
	    Dd = N.extend({ clipboardData: function clipboardData(a) {
	    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
	  } }),
	    Ed = pd.extend({ relatedTarget: null });
	function Fd(a) {
	  var b = a.keyCode;"charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;10 === a && (a = 13);return 32 <= a || 13 === a ? a : 0;
	}
	var Gd = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" },
	    Hd = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4",
	  116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" },
	    Id = pd.extend({ key: function key(a) {
	    if (a.key) {
	      var b = Gd[a.key] || a.key;if ("Unidentified" !== b) return b;
	    }return "keypress" === a.type ? (a = Fd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Hd[a.keyCode] || "Unidentified" : "";
	  }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: sd, charCode: function charCode(a) {
	    return "keypress" === a.type ? Fd(a) : 0;
	  }, keyCode: function keyCode(a) {
	    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
	  }, which: function which(a) {
	    return "keypress" === a.type ? Fd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
	  } }),
	    Jd = td.extend({ dataTransfer: null }),
	    Kd = pd.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: sd }),
	    Ld = N.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),
	    Md = td.extend({ deltaX: function deltaX(a) {
	    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
	  }, deltaY: function deltaY(a) {
	    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
	  }, deltaZ: null, deltaMode: null }),
	    Nd = {},
	    Od = {};function Pd(a, b) {
	  var c = a[0].toUpperCase() + a.slice(1),
	      d = "on" + c;c = "top" + c;b = { phasedRegistrationNames: { bubbled: d, captured: d + "Capture" }, dependencies: [c], isInteractive: b };Nd[a] = b;Od[c] = b;
	}
	"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function (a) {
	  Pd(a, !0);
	});
	"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function (a) {
	  Pd(a, !1);
	});
	var Qd = { eventTypes: Nd, isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(a) {
	    a = Od[a];return void 0 !== a && !0 === a.isInteractive;
	  }, extractEvents: function extractEvents(a, b, c, d) {
	    var e = Od[a];if (!e) return null;switch (a) {case "topKeyPress":
	        if (0 === Fd(c)) return null;case "topKeyDown":case "topKeyUp":
	        a = Id;break;case "topBlur":case "topFocus":
	        a = Ed;break;case "topClick":
	        if (2 === c.button) return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":
	        a = td;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":
	        a = Jd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":
	        a = Kd;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":
	        a = Cd;break;case "topTransitionEnd":
	        a = Ld;break;case "topScroll":
	        a = pd;break;case "topWheel":
	        a = Md;break;case "topCopy":case "topCut":case "topPaste":
	        a = Dd;break;default:
	        a = N;}b = a.getPooled(e, b, c, d);hb(b);return b;
	  } },
	    Rd = Qd.isInteractiveTopLevelEventType,
	    Sd = [];function Td(a) {
	  var b = a.targetInst;do {
	    if (!b) {
	      a.ancestors.push(b);break;
	    }var c;for (c = b; c["return"];) {
	      c = c["return"];
	    }c = 3 !== c.tag ? null : c.stateNode.containerInfo;if (!c) break;a.ancestors.push(b);b = Ta(c);
	  } while (b);for (c = 0; c < a.ancestors.length; c++) {
	    b = a.ancestors[c], Pa(a.topLevelType, b, a.nativeEvent, gc(a.nativeEvent));
	  }
	}var Ud = !0;function Vd(a) {
	  Ud = !!a;
	}
	function W(a, b, c) {
	  if (!c) return null;a = (Rd(a) ? Wd : Xd).bind(null, a);c.addEventListener(b, a, !1);
	}function Yd(a, b, c) {
	  if (!c) return null;a = (Rd(a) ? Wd : Xd).bind(null, a);c.addEventListener(b, a, !0);
	}function Wd(a, b) {
	  ac(Xd, a, b);
	}
	function Xd(a, b) {
	  if (Ud) {
	    var c = gc(b);c = Ta(c);null !== c && "number" === typeof c.tag && 2 !== wd(c) && (c = null);if (Sd.length) {
	      var d = Sd.pop();d.topLevelType = a;d.nativeEvent = b;d.targetInst = c;a = d;
	    } else a = { topLevelType: a, nativeEvent: b, targetInst: c, ancestors: [] };try {
	      dc(Td, a);
	    } finally {
	      a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Sd.length && Sd.push(a);
	    }
	  }
	}
	var Zd = Object.freeze({ get _enabled() {
	    return Ud;
	  }, setEnabled: Vd, isEnabled: function isEnabled() {
	    return Ud;
	  }, trapBubbledEvent: W, trapCapturedEvent: Yd, dispatchEvent: Xd });function $d(a, b) {
	  var c = {};c[a.toLowerCase()] = b.toLowerCase();c["Webkit" + a] = "webkit" + b;c["Moz" + a] = "moz" + b;c["ms" + a] = "MS" + b;c["O" + a] = "o" + b.toLowerCase();return c;
	}
	var ae = { animationend: $d("Animation", "AnimationEnd"), animationiteration: $d("Animation", "AnimationIteration"), animationstart: $d("Animation", "AnimationStart"), transitionend: $d("Transition", "TransitionEnd") },
	    be = {},
	    ce = {};m.canUseDOM && (ce = document.createElement("div").style, "AnimationEvent" in window || (delete ae.animationend.animation, delete ae.animationiteration.animation, delete ae.animationstart.animation), "TransitionEvent" in window || delete ae.transitionend.transition);
	function de(a) {
	  if (be[a]) return be[a];if (!ae[a]) return a;var b = ae[a],
	      c;for (c in b) {
	    if (b.hasOwnProperty(c) && c in ce) return be[a] = b[c];
	  }return a;
	}
	var ee = { topAnimationEnd: de("animationend"), topAnimationIteration: de("animationiteration"), topAnimationStart: de("animationstart"), topBlur: "blur", topCancel: "cancel", topChange: "change", topClick: "click", topClose: "close", topCompositionEnd: "compositionend", topCompositionStart: "compositionstart", topCompositionUpdate: "compositionupdate", topContextMenu: "contextmenu", topCopy: "copy", topCut: "cut", topDoubleClick: "dblclick", topDrag: "drag", topDragEnd: "dragend", topDragEnter: "dragenter", topDragExit: "dragexit", topDragLeave: "dragleave",
	  topDragOver: "dragover", topDragStart: "dragstart", topDrop: "drop", topFocus: "focus", topInput: "input", topKeyDown: "keydown", topKeyPress: "keypress", topKeyUp: "keyup", topLoad: "load", topLoadStart: "loadstart", topMouseDown: "mousedown", topMouseMove: "mousemove", topMouseOut: "mouseout", topMouseOver: "mouseover", topMouseUp: "mouseup", topPaste: "paste", topScroll: "scroll", topSelectionChange: "selectionchange", topTextInput: "textInput", topToggle: "toggle", topTouchCancel: "touchcancel", topTouchEnd: "touchend", topTouchMove: "touchmove",
	  topTouchStart: "touchstart", topTransitionEnd: de("transitionend"), topWheel: "wheel" },
	    fe = { topAbort: "abort", topCanPlay: "canplay", topCanPlayThrough: "canplaythrough", topDurationChange: "durationchange", topEmptied: "emptied", topEncrypted: "encrypted", topEnded: "ended", topError: "error", topLoadedData: "loadeddata", topLoadedMetadata: "loadedmetadata", topLoadStart: "loadstart", topPause: "pause", topPlay: "play", topPlaying: "playing", topProgress: "progress", topRateChange: "ratechange", topSeeked: "seeked", topSeeking: "seeking",
	  topStalled: "stalled", topSuspend: "suspend", topTimeUpdate: "timeupdate", topVolumeChange: "volumechange", topWaiting: "waiting" },
	    ge = {},
	    he = 0,
	    ie = "_reactListenersID" + ("" + Math.random()).slice(2);function je(a) {
	  Object.prototype.hasOwnProperty.call(a, ie) || (a[ie] = he++, ge[a[ie]] = {});return ge[a[ie]];
	}function ke(a) {
	  for (; a && a.firstChild;) {
	    a = a.firstChild;
	  }return a;
	}
	function le(a, b) {
	  var c = ke(a);a = 0;for (var d; c;) {
	    if (3 === c.nodeType) {
	      d = a + c.textContent.length;if (a <= b && d >= b) return { node: c, offset: b - a };a = d;
	    }a: {
	      for (; c;) {
	        if (c.nextSibling) {
	          c = c.nextSibling;break a;
	        }c = c.parentNode;
	      }c = void 0;
	    }c = ke(c);
	  }
	}function me(a) {
	  var b = a && a.nodeName && a.nodeName.toLowerCase();return b && ("input" === b && "text" === a.type || "textarea" === b || "true" === a.contentEditable);
	}
	var ne = m.canUseDOM && "documentMode" in document && 11 >= document.documentMode,
	    oe = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ") } },
	    pe = null,
	    qe = null,
	    re = null,
	    se = !1;
	function ue(a, b) {
	  if (se || null == pe || pe !== ea()) return null;var c = pe;"selectionStart" in c && me(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : window.getSelection ? (c = window.getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset }) : c = void 0;return re && fa(re, c) ? null : (re = c, a = N.getPooled(oe.select, qe, a, b), a.type = "select", a.target = pe, hb(a), a);
	}
	var we = { eventTypes: oe, extractEvents: function extractEvents(a, b, c, d) {
	    var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,
	        f;if (!(f = !e)) {
	      a: {
	        e = je(e);f = ua.onSelect;for (var h = 0; h < f.length; h++) {
	          var g = f[h];if (!e.hasOwnProperty(g) || !e[g]) {
	            e = !1;break a;
	          }
	        }e = !0;
	      }f = !e;
	    }if (f) return null;e = b ? Ua(b) : window;switch (a) {case "topFocus":
	        if (fc(e) || "true" === e.contentEditable) pe = e, qe = b, re = null;break;case "topBlur":
	        re = qe = pe = null;break;case "topMouseDown":
	        se = !0;break;case "topContextMenu":case "topMouseUp":
	        return se = !1, ue(c, d);case "topSelectionChange":
	        if (ne) break;
	      case "topKeyDown":case "topKeyUp":
	        return ue(c, d);}return null;
	  } };Ma.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ca = Xa.getFiberCurrentPropsFromNode;Da = Xa.getInstanceFromNode;Ea = Xa.getNodeFromInstance;Ma.injectEventPluginsByName({ SimpleEventPlugin: Qd, EnterLeaveEventPlugin: vd, ChangeEventPlugin: od, SelectEventPlugin: we, BeforeInputEventPlugin: Qb });
	function xe(a, b, c, d) {
	  this.tag = a;this.key = c;this.stateNode = this.type = null;this.sibling = this.child = this["return"] = null;this.index = 0;this.ref = null;this.pendingProps = b;this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.expirationTime = 0;this.alternate = null;
	}
	function ye(a, b, c) {
	  var d = a.alternate;null === d ? (d = new xe(a.tag, b, a.key, a.mode), d.type = a.type, d.stateNode = a.stateNode, d.alternate = a, a.alternate = d) : (d.pendingProps = b, d.effectTag = 0, d.nextEffect = null, d.firstEffect = null, d.lastEffect = null);d.expirationTime = c;d.child = a.child;d.memoizedProps = a.memoizedProps;d.memoizedState = a.memoizedState;d.updateQueue = a.updateQueue;d.sibling = a.sibling;d.index = a.index;d.ref = a.ref;return d;
	}
	function ze(a, b, c) {
	  var d = a.type,
	      e = a.key;a = a.props;var f = void 0;if ("function" === typeof d) f = d.prototype && d.prototype.isReactComponent ? 2 : 0;else if ("string" === typeof d) f = 5;else switch (d) {case rc:
	      return Ae(a.children, b, c, e);case vc:
	      f = 11;b |= 3;break;case sc:
	      f = 11;b |= 2;break;case oc:
	      f = 7;break;case pc:
	      f = 9;break;default:
	      if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) switch (d.$$typeof) {case tc:
	          f = 13;break;case uc:
	          f = 12;break;case wc:
	          f = 14;break;default:
	          if ("number" === typeof d.tag) return b = d, b.pendingProps = a, b.expirationTime = c, b;D("130", null == d ? d : typeof d === "undefined" ? "undefined" : _typeof(d), "");} else D("130", null == d ? d : typeof d === "undefined" ? "undefined" : _typeof(d), "");}b = new xe(f, a, e, b);b.type = d;b.expirationTime = c;return b;
	}function Ae(a, b, c, d) {
	  a = new xe(10, a, d, b);a.expirationTime = c;return a;
	}function Be(a, b, c) {
	  a = new xe(6, a, null, b);a.expirationTime = c;return a;
	}function Ce(a, b, c) {
	  b = new xe(4, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;
	}var De = null,
	    Ee = null;
	function Fe(a) {
	  return function (b) {
	    try {
	      return a(b);
	    } catch (c) {}
	  };
	}function Ge(a) {
	  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {
	    var c = b.inject(a);De = Fe(function (a) {
	      return b.onCommitFiberRoot(c, a);
	    });Ee = Fe(function (a) {
	      return b.onCommitFiberUnmount(c, a);
	    });
	  } catch (d) {}return !0;
	}function He(a) {
	  "function" === typeof De && De(a);
	}function Ie(a) {
	  "function" === typeof Ee && Ee(a);
	}new Set();
	function Je(a) {
	  return { baseState: a, expirationTime: 0, first: null, last: null, callbackList: null, hasForceUpdate: !1, isInitialized: !1, capturedValues: null };
	}function Ke(a, b) {
	  null === a.last ? a.first = a.last = b : (a.last.next = b, a.last = b);if (0 === a.expirationTime || a.expirationTime > b.expirationTime) a.expirationTime = b.expirationTime;
	}var Le = void 0,
	    Me = void 0;
	function Ne(a) {
	  Le = Me = null;var b = a.alternate,
	      c = a.updateQueue;null === c && (c = a.updateQueue = Je(null));null !== b ? (a = b.updateQueue, null === a && (a = b.updateQueue = Je(null))) : a = null;Le = c;Me = a !== c ? a : null;
	}function Oe(a, b) {
	  Ne(a);a = Le;var c = Me;null === c ? Ke(a, b) : null === a.last || null === c.last ? (Ke(a, b), Ke(c, b)) : (Ke(a, b), c.last = b);
	}function Pe(a, b, c, d) {
	  a = a.partialState;return "function" === typeof a ? a.call(b, c, d) : a;
	}
	function Qe(a, b, c, d, e, f) {
	  null !== a && a.updateQueue === c && (c = b.updateQueue = { baseState: c.baseState, expirationTime: c.expirationTime, first: c.first, last: c.last, isInitialized: c.isInitialized, capturedValues: c.capturedValues, callbackList: null, hasForceUpdate: !1 });c.expirationTime = 0;c.isInitialized ? a = c.baseState : (a = c.baseState = b.memoizedState, c.isInitialized = !0);for (var h = !0, g = c.first, k = !1; null !== g;) {
	    var v = g.expirationTime;if (v > f) {
	      var l = c.expirationTime;if (0 === l || l > v) c.expirationTime = v;k || (k = !0, c.baseState = a);
	    } else {
	      k || (c.first = g.next, null === c.first && (c.last = null));if (g.isReplace) a = Pe(g, d, a, e), h = !0;else if (v = Pe(g, d, a, e)) a = h ? A({}, a, v) : A(a, v), h = !1;g.isForced && (c.hasForceUpdate = !0);null !== g.callback && (v = c.callbackList, null === v && (v = c.callbackList = []), v.push(g));null !== g.capturedValue && (v = c.capturedValues, null === v ? c.capturedValues = [g.capturedValue] : v.push(g.capturedValue));
	    }g = g.next;
	  }null !== c.callbackList ? b.effectTag |= 32 : null !== c.first || c.hasForceUpdate || null !== c.capturedValues || (b.updateQueue = null);k || (c.baseState = a);
	  return a;
	}function Re(a, b) {
	  var c = a.callbackList;if (null !== c) for (a.callbackList = null, a = 0; a < c.length; a++) {
	    var d = c[a],
	        e = d.callback;d.callback = null;"function" !== typeof e ? D("191", e) : void 0;e.call(b);
	  }
	}
	function Se(a, b, c, d, e) {
	  function f(a, b, c, d, e, f) {
	    if (null === b || null !== a.updateQueue && a.updateQueue.hasForceUpdate) return !0;var n = a.stateNode;a = a.type;return "function" === typeof n.shouldComponentUpdate ? n.shouldComponentUpdate(c, e, f) : a.prototype && a.prototype.isPureReactComponent ? !fa(b, c) || !fa(d, e) : !0;
	  }function h(a, b) {
	    b.updater = r;a.stateNode = b;b._reactInternalFiber = a;
	  }function g(a, b, c, d) {
	    a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && r.enqueueReplaceState(b, b.state, null);
	  }function k(a, b, c, d) {
	    a = a.type;if ("function" === typeof a.getDerivedStateFromProps) return a.getDerivedStateFromProps.call(null, c, d);
	  }var v = a.cacheContext,
	      l = a.getMaskedContext,
	      p = a.getUnmaskedContext,
	      z = a.isContextConsumer,
	      B = a.hasContextChanged,
	      r = { isMounted: xd, enqueueSetState: function enqueueSetState(a, d, e) {
	      a = a._reactInternalFiber;e = void 0 === e ? null : e;var f = c(a);Oe(a, { expirationTime: f, partialState: d, callback: e, isReplace: !1, isForced: !1,
	        capturedValue: null, next: null });b(a, f);
	    }, enqueueReplaceState: function enqueueReplaceState(a, d, e) {
	      a = a._reactInternalFiber;e = void 0 === e ? null : e;var f = c(a);Oe(a, { expirationTime: f, partialState: d, callback: e, isReplace: !0, isForced: !1, capturedValue: null, next: null });b(a, f);
	    }, enqueueForceUpdate: function enqueueForceUpdate(a, d) {
	      a = a._reactInternalFiber;d = void 0 === d ? null : d;var e = c(a);Oe(a, { expirationTime: e, partialState: null, callback: d, isReplace: !1, isForced: !0, capturedValue: null, next: null });b(a, e);
	    } };return { adoptClassInstance: h, callGetDerivedStateFromProps: k,
	    constructClassInstance: function constructClassInstance(a, b) {
	      var c = a.type,
	          d = p(a),
	          e = z(a),
	          f = e ? l(a, d) : ja;c = new c(b, f);var n = null !== c.state && void 0 !== c.state ? c.state : null;h(a, c);a.memoizedState = n;b = k(a, c, b, n);null !== b && void 0 !== b && (a.memoizedState = A({}, a.memoizedState, b));e && v(a, d, f);return c;
	    }, mountClassInstance: function mountClassInstance(a, b) {
	      var c = a.type,
	          d = a.alternate,
	          e = a.stateNode,
	          f = a.pendingProps,
	          n = p(a);e.props = f;e.state = a.memoizedState;e.refs = ja;e.context = l(a, n);"function" === typeof c.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (c = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), c !== e.state && r.enqueueReplaceState(e, e.state, null), c = a.updateQueue, null !== c && (e.state = Qe(d, a, c, e, f, b)));"function" === typeof e.componentDidMount && (a.effectTag |= 4);
	    }, resumeMountClassInstance: function resumeMountClassInstance(a, b) {
	      var c = a.type,
	          n = a.stateNode;n.props = a.memoizedProps;n.state = a.memoizedState;var h = a.memoizedProps,
	          r = a.pendingProps,
	          z = n.context,
	          q = p(a);q = l(a, q);(c = "function" === typeof c.getDerivedStateFromProps || "function" === typeof n.getSnapshotBeforeUpdate) || "function" !== typeof n.UNSAFE_componentWillReceiveProps && "function" !== typeof n.componentWillReceiveProps || (h !== r || z !== q) && g(a, n, r, q);z = a.memoizedState;b = null !== a.updateQueue ? Qe(null, a, a.updateQueue, n, r, b) : z;var u = void 0;h !== r && (u = k(a, n, r, b));if (null !== u && void 0 !== u) {
	        b = null === b || void 0 === b ? u : A({}, b, u);var t = a.updateQueue;
	        null !== t && (t.baseState = A({}, t.baseState, u));
	      }if (!(h !== r || z !== b || B() || null !== a.updateQueue && a.updateQueue.hasForceUpdate)) return "function" === typeof n.componentDidMount && (a.effectTag |= 4), !1;(h = f(a, h, r, z, b, q)) ? (c || "function" !== typeof n.UNSAFE_componentWillMount && "function" !== typeof n.componentWillMount || ("function" === typeof n.componentWillMount && n.componentWillMount(), "function" === typeof n.UNSAFE_componentWillMount && n.UNSAFE_componentWillMount()), "function" === typeof n.componentDidMount && (a.effectTag |= 4)) : ("function" === typeof n.componentDidMount && (a.effectTag |= 4), d(a, r), e(a, b));n.props = r;n.state = b;n.context = q;return h;
	    }, updateClassInstance: function updateClassInstance(a, b, c) {
	      var n = b.type,
	          x = b.stateNode;x.props = b.memoizedProps;x.state = b.memoizedState;var h = b.memoizedProps,
	          r = b.pendingProps,
	          q = x.context,
	          u = p(b);u = l(b, u);(n = "function" === typeof n.getDerivedStateFromProps || "function" === typeof x.getSnapshotBeforeUpdate) || "function" !== typeof x.UNSAFE_componentWillReceiveProps && "function" !== typeof x.componentWillReceiveProps || (h !== r || q !== u) && g(b, x, r, u);q = b.memoizedState;c = null !== b.updateQueue ? Qe(a, b, b.updateQueue, x, r, c) : q;var t = void 0;h !== r && (t = k(b, x, r, c));if (null !== t && void 0 !== t) {
	        c = null === c || void 0 === c ? t : A({}, c, t);var y = b.updateQueue;null !== y && (y.baseState = A({}, y.baseState, t));
	      }if (!(h !== r || q !== c || B() || null !== b.updateQueue && b.updateQueue.hasForceUpdate)) return "function" !== typeof x.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 4), "function" !== typeof x.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 2048), !1;(t = f(b, h, r, q, c, u)) ? (n || "function" !== typeof x.UNSAFE_componentWillUpdate && "function" !== typeof x.componentWillUpdate || ("function" === typeof x.componentWillUpdate && x.componentWillUpdate(r, c, u), "function" === typeof x.UNSAFE_componentWillUpdate && x.UNSAFE_componentWillUpdate(r, c, u)), "function" === typeof x.componentDidUpdate && (b.effectTag |= 4), "function" === typeof x.getSnapshotBeforeUpdate && (b.effectTag |= 2048)) : ("function" !== typeof x.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 4), "function" !== typeof x.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 2048), d(b, r), e(b, c));x.props = r;x.state = c;x.context = u;return t;
	    } };
	}var Te = Array.isArray;
	function Ue(a, b, c) {
	  a = c.ref;if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) {
	    if (c._owner) {
	      c = c._owner;var d = void 0;c && (2 !== c.tag ? D("110") : void 0, d = c.stateNode);d ? void 0 : D("147", a);var e = "" + a;if (null !== b && null !== b.ref && b.ref._stringRef === e) return b.ref;b = function b(a) {
	        var b = d.refs === ja ? d.refs = {} : d.refs;null === a ? delete b[e] : b[e] = a;
	      };b._stringRef = e;return b;
	    }"string" !== typeof a ? D("148") : void 0;c._owner ? void 0 : D("254", a);
	  }return a;
	}
	function Ve(a, b) {
	  "textarea" !== a.type && D("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
	}
	function We(a) {
	  function b(b, c) {
	    if (a) {
	      var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;
	    }
	  }function c(c, d) {
	    if (!a) return null;for (; null !== d;) {
	      b(c, d), d = d.sibling;
	    }return null;
	  }function d(a, b) {
	    for (a = new Map(); null !== b;) {
	      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
	    }return a;
	  }function e(a, b, c) {
	    a = ye(a, b, c);a.index = 0;a.sibling = null;return a;
	  }function f(b, c, d) {
	    b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;b.effectTag = 2;return c;
	  }function h(b) {
	    a && null === b.alternate && (b.effectTag = 2);return b;
	  }function g(a, b, c, d) {
	    if (null === b || 6 !== b.tag) return b = Be(c, a.mode, d), b["return"] = a, b;b = e(b, c, d);b["return"] = a;return b;
	  }function k(a, b, c, d) {
	    if (null !== b && b.type === c.type) return d = e(b, c.props, d), d.ref = Ue(a, b, c), d["return"] = a, d;d = ze(c, a.mode, d);d.ref = Ue(a, b, c);d["return"] = a;return d;
	  }function v(a, b, c, d) {
	    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Ce(c, a.mode, d), b["return"] = a, b;b = e(b, c.children || [], d);b["return"] = a;return b;
	  }function l(a, b, c, d, f) {
	    if (null === b || 10 !== b.tag) return b = Ae(c, a.mode, d, f), b["return"] = a, b;b = e(b, c, d);b["return"] = a;return b;
	  }function p(a, b, c) {
	    if ("string" === typeof b || "number" === typeof b) return b = Be("" + b, a.mode, c), b["return"] = a, b;if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) {
	      switch (b.$$typeof) {case nc:
	          return c = ze(b, a.mode, c), c.ref = Ue(a, null, b), c["return"] = a, c;case qc:
	          return b = Ce(b, a.mode, c), b["return"] = a, b;}if (Te(b) || yc(b)) return b = Ae(b, a.mode, c, null), b["return"] = a, b;Ve(a, b);
	    }return null;
	  }function z(a, b, c, d) {
	    var e = null !== b ? b.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : g(a, b, "" + c, d);if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c) {
	      switch (c.$$typeof) {case nc:
	          return c.key === e ? c.type === rc ? l(a, b, c.props.children, d, e) : k(a, b, c, d) : null;case qc:
	          return c.key === e ? v(a, b, c, d) : null;}if (Te(c) || yc(c)) return null !== e ? null : l(a, b, c, d, null);Ve(a, c);
	    }return null;
	  }function B(a, b, c, d, e) {
	    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, g(b, a, "" + d, e);if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) {
	      switch (d.$$typeof) {case nc:
	          return a = a.get(null === d.key ? c : d.key) || null, d.type === rc ? l(b, a, d.props.children, e, d.key) : k(b, a, d, e);case qc:
	          return a = a.get(null === d.key ? c : d.key) || null, v(b, a, d, e);}if (Te(d) || yc(d)) return a = a.get(c) || null, l(b, a, d, e, null);Ve(b, d);
	    }return null;
	  }function r(e, g, l, h) {
	    for (var r = null, k = null, q = g, u = g = 0, t = null; null !== q && u < l.length; u++) {
	      q.index > u ? (t = q, q = null) : t = q.sibling;var n = z(e, q, l[u], h);if (null === n) {
	        null === q && (q = t);break;
	      }a && q && null === n.alternate && b(e, q);g = f(n, g, u);null === k ? r = n : k.sibling = n;k = n;q = t;
	    }if (u === l.length) return c(e, q), r;if (null === q) {
	      for (; u < l.length; u++) {
	        if (q = p(e, l[u], h)) g = f(q, g, u), null === k ? r = q : k.sibling = q, k = q;
	      }return r;
	    }for (q = d(e, q); u < l.length; u++) {
	      if (t = B(q, e, u, l[u], h)) {
	        if (a && null !== t.alternate) q["delete"](null === t.key ? u : t.key);g = f(t, g, u);null === k ? r = t : k.sibling = t;k = t;
	      }
	    }a && q.forEach(function (a) {
	      return b(e, a);
	    });return r;
	  }function Q(e, g, l, h) {
	    var r = yc(l);"function" !== typeof r ? D("150") : void 0;l = r.call(l);null == l ? D("151") : void 0;for (var k = r = null, q = g, u = g = 0, t = null, n = l.next(); null !== q && !n.done; u++, n = l.next()) {
	      q.index > u ? (t = q, q = null) : t = q.sibling;var H = z(e, q, n.value, h);if (null === H) {
	        q || (q = t);break;
	      }a && q && null === H.alternate && b(e, q);g = f(H, g, u);null === k ? r = H : k.sibling = H;k = H;q = t;
	    }if (n.done) return c(e, q), r;if (null === q) {
	      for (; !n.done; u++, n = l.next()) {
	        n = p(e, n.value, h), null !== n && (g = f(n, g, u), null === k ? r = n : k.sibling = n, k = n);
	      }return r;
	    }for (q = d(e, q); !n.done; u++, n = l.next()) {
	      if (n = B(q, e, u, n.value, h), null !== n) {
	        if (a && null !== n.alternate) q["delete"](null === n.key ? u : n.key);
	        g = f(n, g, u);null === k ? r = n : k.sibling = n;k = n;
	      }
	    }a && q.forEach(function (a) {
	      return b(e, a);
	    });return r;
	  }return function (a, d, f, g) {
	    "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f && f.type === rc && null === f.key && (f = f.props.children);var l = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f;if (l) switch (f.$$typeof) {case nc:
	        a: {
	          var k = f.key;for (l = d; null !== l;) {
	            if (l.key === k) {
	              if (10 === l.tag ? f.type === rc : l.type === f.type) {
	                c(a, l.sibling);d = e(l, f.type === rc ? f.props.children : f.props, g);d.ref = Ue(a, l, f);d["return"] = a;a = d;break a;
	              } else {
	                c(a, l);break;
	              }
	            } else b(a, l);l = l.sibling;
	          }f.type === rc ? (d = Ae(f.props.children, a.mode, g, f.key), d["return"] = a, a = d) : (g = ze(f, a.mode, g), g.ref = Ue(a, d, f), g["return"] = a, a = g);
	        }return h(a);case qc:
	        a: {
	          for (l = f.key; null !== d;) {
	            if (d.key === l) {
	              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
	                c(a, d.sibling);d = e(d, f.children || [], g);d["return"] = a;a = d;break a;
	              } else {
	                c(a, d);break;
	              }
	            } else b(a, d);d = d.sibling;
	          }d = Ce(f, a.mode, g);d["return"] = a;a = d;
	        }return h(a);}if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, g)) : (c(a, d), d = Be(f, a.mode, g)), d["return"] = a, a = d, h(a);if (Te(f)) return r(a, d, f, g);if (yc(f)) return Q(a, d, f, g);l && Ve(a, f);if ("undefined" === typeof f) switch (a.tag) {case 2:case 1:
	        g = a.type, D("152", g.displayName || g.name || "Component");}return c(a, d);
	  };
	}var Xe = We(!0),
	    Ye = We(!1);
	function Ze(a, b, c, d, e, f, h) {
	  function g(a, b, c) {
	    k(a, b, c, b.expirationTime);
	  }function k(a, b, c, d) {
	    b.child = null === a ? Ye(b, null, c, d) : Xe(b, a.child, c, d);
	  }function v(a, b) {
	    var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
	  }function l(a, b, c, d, e, f) {
	    v(a, b);if (!c && !e) return d && y(b, !1), r(a, b);c = b.stateNode;mc.current = b;var g = e ? null : c.render();b.effectTag |= 1;e && (k(a, b, null, f), b.child = null);k(a, b, g, f);b.memoizedState = c.state;b.memoizedProps = c.props;d && y(b, !0);return b.child;
	  }function p(a) {
	    var b = a.stateNode;
	    b.pendingContext ? t(a, b.pendingContext, b.pendingContext !== b.context) : b.context && t(a, b.context, !1);Y(a, b.containerInfo);
	  }function z(a, b, c, d) {
	    var e = a.child;for (null !== e && (e["return"] = a); null !== e;) {
	      switch (e.tag) {case 12:
	          var f = e.stateNode | 0;if (e.type === b && 0 !== (f & c)) {
	            for (f = e; null !== f;) {
	              var g = f.alternate;if (0 === f.expirationTime || f.expirationTime > d) f.expirationTime = d, null !== g && (0 === g.expirationTime || g.expirationTime > d) && (g.expirationTime = d);else if (null !== g && (0 === g.expirationTime || g.expirationTime > d)) g.expirationTime = d;else break;f = f["return"];
	            }f = null;
	          } else f = e.child;break;case 13:
	          f = e.type === a.type ? null : e.child;break;default:
	          f = e.child;}if (null !== f) f["return"] = e;else for (f = e; null !== f;) {
	        if (f === a) {
	          f = null;break;
	        }e = f.sibling;if (null !== e) {
	          f = e;break;
	        }f = f["return"];
	      }e = f;
	    }
	  }function B(a, b, c) {
	    var d = b.type._context,
	        e = b.pendingProps,
	        f = b.memoizedProps;if (!q() && f === e) return b.stateNode = 0, G(b), r(a, b);var l = e.value;b.memoizedProps = e;if (null === f) l = 1073741823;else if (f.value === e.value) {
	      if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);l = 0;
	    } else {
	      var u = f.value;if (u === l && (0 !== u || 1 / u === 1 / l) || u !== u && l !== l) {
	        if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);l = 0;
	      } else if (l = "function" === typeof d._calculateChangedBits ? d._calculateChangedBits(u, l) : 1073741823, l |= 0, 0 === l) {
	        if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);
	      } else z(b, d, l, c);
	    }b.stateNode = l;G(b);g(a, b, e.children);return b.child;
	  }function r(a, b) {
	    null !== a && b.child !== a.child ? D("153") : void 0;if (null !== b.child) {
	      a = b.child;var c = ye(a, a.pendingProps, a.expirationTime);
	      b.child = c;for (c["return"] = b; null !== a.sibling;) {
	        a = a.sibling, c = c.sibling = ye(a, a.pendingProps, a.expirationTime), c["return"] = b;
	      }c.sibling = null;
	    }return b.child;
	  }var Q = a.shouldSetTextContent,
	      n = a.shouldDeprioritizeSubtree,
	      x = b.pushHostContext,
	      Y = b.pushHostContainer,
	      G = d.pushProvider,
	      R = c.getMaskedContext,
	      S = c.getUnmaskedContext,
	      q = c.hasContextChanged,
	      u = c.pushContextProvider,
	      t = c.pushTopLevelContextObject,
	      y = c.invalidateContextProvider,
	      H = e.enterHydrationState,
	      Wa = e.resetHydrationState,
	      Cb = e.tryToClaimNextHydratableInstance;
	  a = Se(c, f, h, function (a, b) {
	    a.memoizedProps = b;
	  }, function (a, b) {
	    a.memoizedState = b;
	  });var Jc = a.adoptClassInstance,
	      Kc = a.callGetDerivedStateFromProps,
	      Lc = a.constructClassInstance,
	      Db = a.mountClassInstance,
	      Mc = a.resumeMountClassInstance,
	      Eb = a.updateClassInstance;return { beginWork: function beginWork(a, b, c) {
	      if (0 === b.expirationTime || b.expirationTime > c) {
	        switch (b.tag) {case 3:
	            p(b);break;case 2:
	            u(b);break;case 4:
	            Y(b, b.stateNode.containerInfo);break;case 13:
	            G(b);}return null;
	      }switch (b.tag) {case 0:
	          null !== a ? D("155") : void 0;var d = b.type,
	              e = b.pendingProps,
	              f = S(b);f = R(b, f);d = d(e, f);b.effectTag |= 1;"object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d && "function" === typeof d.render && void 0 === d.$$typeof ? (f = b.type, b.tag = 2, b.memoizedState = null !== d.state && void 0 !== d.state ? d.state : null, "function" === typeof f.getDerivedStateFromProps && (e = Kc(b, d, e, b.memoizedState), null !== e && void 0 !== e && (b.memoizedState = A({}, b.memoizedState, e))), e = u(b), Jc(b, d), Db(b, c), a = l(a, b, !0, e, !1, c)) : (b.tag = 1, g(a, b, d), b.memoizedProps = e, a = b.child);return a;case 1:
	          return e = b.type, c = b.pendingProps, q() || b.memoizedProps !== c ? (d = S(b), d = R(b, d), e = e(c, d), b.effectTag |= 1, g(a, b, e), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 2:
	          e = u(b);null === a ? null === b.stateNode ? (Lc(b, b.pendingProps), Db(b, c), d = !0) : d = Mc(b, c) : d = Eb(a, b, c);f = !1;var h = b.updateQueue;null !== h && null !== h.capturedValues && (f = d = !0);return l(a, b, d, e, f, c);case 3:
	          a: if (p(b), d = b.updateQueue, null !== d) {
	            f = b.memoizedState;e = Qe(a, b, d, null, null, c);b.memoizedState = e;d = b.updateQueue;if (null !== d && null !== d.capturedValues) d = null;else if (f === e) {
	              Wa();a = r(a, b);break a;
	            } else d = e.element;f = b.stateNode;(null === a || null === a.child) && f.hydrate && H(b) ? (b.effectTag |= 2, b.child = Ye(b, null, d, c)) : (Wa(), g(a, b, d));b.memoizedState = e;a = b.child;
	          } else Wa(), a = r(a, b);return a;case 5:
	          a: {
	            x(b);null === a && Cb(b);e = b.type;h = b.memoizedProps;d = b.pendingProps;f = null !== a ? a.memoizedProps : null;if (!q() && h === d) {
	              if (h = b.mode & 1 && n(e, d)) b.expirationTime = 1073741823;if (!h || 1073741823 !== c) {
	                a = r(a, b);break a;
	              }
	            }h = d.children;Q(e, d) ? h = null : f && Q(e, f) && (b.effectTag |= 16);v(a, b);1073741823 !== c && b.mode & 1 && n(e, d) ? (b.expirationTime = 1073741823, b.memoizedProps = d, a = null) : (g(a, b, h), b.memoizedProps = d, a = b.child);
	          }return a;case 6:
	          return null === a && Cb(b), b.memoizedProps = b.pendingProps, null;case 8:
	          b.tag = 7;case 7:
	          return e = b.pendingProps, q() || b.memoizedProps !== e || (e = b.memoizedProps), d = e.children, b.stateNode = null === a ? Ye(b, b.stateNode, d, c) : Xe(b, a.stateNode, d, c), b.memoizedProps = e, b.stateNode;case 9:
	          return null;case 4:
	          return Y(b, b.stateNode.containerInfo), e = b.pendingProps, q() || b.memoizedProps !== e ? (null === a ? b.child = Xe(b, null, e, c) : g(a, b, e), b.memoizedProps = e, a = b.child) : a = r(a, b), a;case 14:
	          return c = b.type.render, c = c(b.pendingProps, b.ref), g(a, b, c), b.memoizedProps = c, b.child;case 10:
	          return c = b.pendingProps, q() || b.memoizedProps !== c ? (g(a, b, c), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 11:
	          return c = b.pendingProps.children, q() || null !== c && b.memoizedProps !== c ? (g(a, b, c), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 13:
	          return B(a, b, c);case 12:
	          d = b.type;f = b.pendingProps;var t = b.memoizedProps;e = d._currentValue;h = d._changedBits;if (q() || 0 !== h || t !== f) {
	            b.memoizedProps = f;t = f.unstable_observedBits;if (void 0 === t || null === t) t = 1073741823;b.stateNode = t;0 !== (h & t) && z(b, d, h, c);c = f.children;c = c(e);g(a, b, c);a = b.child;
	          } else a = r(a, b);return a;default:
	          D("156");}
	    } };
	}
	function $e(a, b, c, d, e) {
	  function f(a) {
	    a.effectTag |= 4;
	  }var h = a.createInstance,
	      g = a.createTextInstance,
	      k = a.appendInitialChild,
	      v = a.finalizeInitialChildren,
	      l = a.prepareUpdate,
	      p = a.persistence,
	      z = b.getRootHostContainer,
	      B = b.popHostContext,
	      r = b.getHostContext,
	      Q = b.popHostContainer,
	      n = c.popContextProvider,
	      x = c.popTopLevelContextObject,
	      Y = d.popProvider,
	      G = e.prepareToHydrateHostInstance,
	      R = e.prepareToHydrateHostTextInstance,
	      S = e.popHydrationState,
	      q = void 0,
	      u = void 0,
	      t = void 0;a.mutation ? (q = function q() {}, u = function u(a, b, c) {
	    (b.updateQueue = c) && f(b);
	  }, t = function t(a, b, c, d) {
	    c !== d && f(b);
	  }) : p ? D("235") : D("236");return { completeWork: function completeWork(a, b, c) {
	      var d = b.pendingProps;switch (b.tag) {case 1:
	          return null;case 2:
	          return n(b), a = b.stateNode, d = b.updateQueue, null !== d && null !== d.capturedValues && (b.effectTag &= -65, "function" === typeof a.componentDidCatch ? b.effectTag |= 256 : d.capturedValues = null), null;case 3:
	          Q(b);x(b);d = b.stateNode;d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);if (null === a || null === a.child) S(b), b.effectTag &= -3;q(b);a = b.updateQueue;
	          null !== a && null !== a.capturedValues && (b.effectTag |= 256);return null;case 5:
	          B(b);c = z();var e = b.type;if (null !== a && null != b.stateNode) {
	            var p = a.memoizedProps,
	                H = b.stateNode,
	                y = r();H = l(H, e, p, d, c, y);u(a, b, H, e, p, d, c, y);a.ref !== b.ref && (b.effectTag |= 128);
	          } else {
	            if (!d) return null === b.stateNode ? D("166") : void 0, null;a = r();if (S(b)) G(b, c, a) && f(b);else {
	              p = h(e, d, c, a, b);a: for (y = b.child; null !== y;) {
	                if (5 === y.tag || 6 === y.tag) k(p, y.stateNode);else if (4 !== y.tag && null !== y.child) {
	                  y.child["return"] = y;y = y.child;continue;
	                }if (y === b) break;
	                for (; null === y.sibling;) {
	                  if (null === y["return"] || y["return"] === b) break a;y = y["return"];
	                }y.sibling["return"] = y["return"];y = y.sibling;
	              }v(p, e, d, c, a) && f(b);b.stateNode = p;
	            }null !== b.ref && (b.effectTag |= 128);
	          }return null;case 6:
	          if (a && null != b.stateNode) t(a, b, a.memoizedProps, d);else {
	            if ("string" !== typeof d) return null === b.stateNode ? D("166") : void 0, null;a = z();c = r();S(b) ? R(b) && f(b) : b.stateNode = g(d, a, c, b);
	          }return null;case 7:
	          (d = b.memoizedProps) ? void 0 : D("165");b.tag = 8;e = [];a: for ((p = b.stateNode) && (p["return"] = b); null !== p;) {
	            if (5 === p.tag || 6 === p.tag || 4 === p.tag) D("247");else if (9 === p.tag) e.push(p.pendingProps.value);else if (null !== p.child) {
	              p.child["return"] = p;p = p.child;continue;
	            }for (; null === p.sibling;) {
	              if (null === p["return"] || p["return"] === b) break a;p = p["return"];
	            }p.sibling["return"] = p["return"];p = p.sibling;
	          }p = d.handler;d = p(d.props, e);b.child = Xe(b, null !== a ? a.child : null, d, c);return b.child;case 8:
	          return b.tag = 7, null;case 9:
	          return null;case 14:
	          return null;case 10:
	          return null;case 11:
	          return null;case 4:
	          return Q(b), q(b), null;
	        case 13:
	          return Y(b), null;case 12:
	          return null;case 0:
	          D("167");default:
	          D("156");}
	    } };
	}
	function af(a, b, c, d, e) {
	  var f = a.popHostContainer,
	      h = a.popHostContext,
	      g = b.popContextProvider,
	      k = b.popTopLevelContextObject,
	      v = c.popProvider;return { throwException: function throwException(a, b, c) {
	      b.effectTag |= 512;b.firstEffect = b.lastEffect = null;b = { value: c, source: b, stack: Ac(b) };do {
	        switch (a.tag) {case 3:
	            Ne(a);a.updateQueue.capturedValues = [b];a.effectTag |= 1024;return;case 2:
	            if (c = a.stateNode, 0 === (a.effectTag & 64) && null !== c && "function" === typeof c.componentDidCatch && !e(c)) {
	              Ne(a);c = a.updateQueue;var d = c.capturedValues;null === d ? c.capturedValues = [b] : d.push(b);a.effectTag |= 1024;return;
	            }}a = a["return"];
	      } while (null !== a);
	    }, unwindWork: function unwindWork(a) {
	      switch (a.tag) {case 2:
	          g(a);var b = a.effectTag;return b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 3:
	          return f(a), k(a), b = a.effectTag, b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 5:
	          return h(a), null;case 4:
	          return f(a), null;case 13:
	          return v(a), null;default:
	          return null;}
	    }, unwindInterruptedWork: function unwindInterruptedWork(a) {
	      switch (a.tag) {case 2:
	          g(a);break;case 3:
	          f(a);k(a);break;case 5:
	          h(a);break;case 4:
	          f(a);break;case 13:
	          v(a);}
	    } };
	}
	function bf(a, b) {
	  var c = b.source;null === b.stack && Ac(c);null !== c && zc(c);b = b.value;null !== a && 2 === a.tag && zc(a);try {
	    b && b.suppressReactErrorLogging || console.error(b);
	  } catch (d) {
	    d && d.suppressReactErrorLogging || console.error(d);
	  }
	}
	function cf(a, b, c, d, e) {
	  function f(a) {
	    var c = a.ref;if (null !== c) if ("function" === typeof c) try {
	      c(null);
	    } catch (t) {
	      b(a, t);
	    } else c.current = null;
	  }function h(a) {
	    "function" === typeof Ie && Ie(a);switch (a.tag) {case 2:
	        f(a);var c = a.stateNode;if ("function" === typeof c.componentWillUnmount) try {
	          c.props = a.memoizedProps, c.state = a.memoizedState, c.componentWillUnmount();
	        } catch (t) {
	          b(a, t);
	        }break;case 5:
	        f(a);break;case 7:
	        g(a.stateNode);break;case 4:
	        p && v(a);}
	  }function g(a) {
	    for (var b = a;;) {
	      if (h(b), null === b.child || p && 4 === b.tag) {
	        if (b === a) break;for (; null === b.sibling;) {
	          if (null === b["return"] || b["return"] === a) return;b = b["return"];
	        }b.sibling["return"] = b["return"];b = b.sibling;
	      } else b.child["return"] = b, b = b.child;
	    }
	  }function k(a) {
	    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
	  }function v(a) {
	    for (var b = a, c = !1, d = void 0, e = void 0;;) {
	      if (!c) {
	        c = b["return"];a: for (;;) {
	          null === c ? D("160") : void 0;switch (c.tag) {case 5:
	              d = c.stateNode;e = !1;break a;case 3:
	              d = c.stateNode.containerInfo;e = !0;break a;case 4:
	              d = c.stateNode.containerInfo;e = !0;break a;}c = c["return"];
	        }c = !0;
	      }if (5 === b.tag || 6 === b.tag) g(b), e ? S(d, b.stateNode) : R(d, b.stateNode);else if (4 === b.tag ? d = b.stateNode.containerInfo : h(b), null !== b.child) {
	        b.child["return"] = b;b = b.child;continue;
	      }if (b === a) break;for (; null === b.sibling;) {
	        if (null === b["return"] || b["return"] === a) return;b = b["return"];4 === b.tag && (c = !1);
	      }b.sibling["return"] = b["return"];b = b.sibling;
	    }
	  }var l = a.getPublicInstance,
	      p = a.mutation;a = a.persistence;p || (a ? D("235") : D("236"));var z = p.commitMount,
	      B = p.commitUpdate,
	      r = p.resetTextContent,
	      Q = p.commitTextUpdate,
	      n = p.appendChild,
	      x = p.appendChildToContainer,
	      Y = p.insertBefore,
	      G = p.insertInContainerBefore,
	      R = p.removeChild,
	      S = p.removeChildFromContainer;return { commitBeforeMutationLifeCycles: function commitBeforeMutationLifeCycles(a, b) {
	      switch (b.tag) {case 2:
	          if (b.effectTag & 2048 && null !== a) {
	            var c = a.memoizedProps,
	                d = a.memoizedState;a = b.stateNode;a.props = b.memoizedProps;a.state = b.memoizedState;b = a.getSnapshotBeforeUpdate(c, d);a.__reactInternalSnapshotBeforeUpdate = b;
	          }break;case 3:case 5:case 6:case 4:
	          break;default:
	          D("163");}
	    }, commitResetTextContent: function commitResetTextContent(a) {
	      r(a.stateNode);
	    },
	    commitPlacement: function commitPlacement(a) {
	      a: {
	        for (var b = a["return"]; null !== b;) {
	          if (k(b)) {
	            var c = b;break a;
	          }b = b["return"];
	        }D("160");c = void 0;
	      }var d = b = void 0;switch (c.tag) {case 5:
	          b = c.stateNode;d = !1;break;case 3:
	          b = c.stateNode.containerInfo;d = !0;break;case 4:
	          b = c.stateNode.containerInfo;d = !0;break;default:
	          D("161");}c.effectTag & 16 && (r(b), c.effectTag &= -17);a: b: for (c = a;;) {
	        for (; null === c.sibling;) {
	          if (null === c["return"] || k(c["return"])) {
	            c = null;break a;
	          }c = c["return"];
	        }c.sibling["return"] = c["return"];for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {
	          if (c.effectTag & 2) continue b;if (null === c.child || 4 === c.tag) continue b;else c.child["return"] = c, c = c.child;
	        }if (!(c.effectTag & 2)) {
	          c = c.stateNode;break a;
	        }
	      }for (var e = a;;) {
	        if (5 === e.tag || 6 === e.tag) c ? d ? G(b, e.stateNode, c) : Y(b, e.stateNode, c) : d ? x(b, e.stateNode) : n(b, e.stateNode);else if (4 !== e.tag && null !== e.child) {
	          e.child["return"] = e;e = e.child;continue;
	        }if (e === a) break;for (; null === e.sibling;) {
	          if (null === e["return"] || e["return"] === a) return;e = e["return"];
	        }e.sibling["return"] = e["return"];e = e.sibling;
	      }
	    }, commitDeletion: function commitDeletion(a) {
	      v(a);
	      a["return"] = null;a.child = null;a.alternate && (a.alternate.child = null, a.alternate["return"] = null);
	    }, commitWork: function commitWork(a, b) {
	      switch (b.tag) {case 2:
	          break;case 5:
	          var c = b.stateNode;if (null != c) {
	            var d = b.memoizedProps;a = null !== a ? a.memoizedProps : d;var e = b.type,
	                f = b.updateQueue;b.updateQueue = null;null !== f && B(c, f, e, a, d, b);
	          }break;case 6:
	          null === b.stateNode ? D("162") : void 0;c = b.memoizedProps;Q(b.stateNode, null !== a ? a.memoizedProps : c, c);break;case 3:
	          break;default:
	          D("163");}
	    }, commitLifeCycles: function commitLifeCycles(a, b, c) {
	      switch (c.tag) {case 2:
	          a = c.stateNode;if (c.effectTag & 4) if (null === b) a.props = c.memoizedProps, a.state = c.memoizedState, a.componentDidMount();else {
	            var d = b.memoizedProps;b = b.memoizedState;a.props = c.memoizedProps;a.state = c.memoizedState;a.componentDidUpdate(d, b, a.__reactInternalSnapshotBeforeUpdate);
	          }c = c.updateQueue;null !== c && Re(c, a);break;case 3:
	          b = c.updateQueue;if (null !== b) {
	            a = null;if (null !== c.child) switch (c.child.tag) {case 5:
	                a = l(c.child.stateNode);break;case 2:
	                a = c.child.stateNode;}Re(b, a);
	          }break;case 5:
	          a = c.stateNode;null === b && c.effectTag & 4 && z(a, c.type, c.memoizedProps, c);break;case 6:
	          break;case 4:
	          break;default:
	          D("163");}
	    }, commitErrorLogging: function commitErrorLogging(a, b) {
	      switch (a.tag) {case 2:
	          var c = a.type;b = a.stateNode;var d = a.updateQueue;null === d || null === d.capturedValues ? D("264") : void 0;var f = d.capturedValues;d.capturedValues = null;"function" !== typeof c.getDerivedStateFromCatch && e(b);b.props = a.memoizedProps;b.state = a.memoizedState;for (c = 0; c < f.length; c++) {
	            d = f[c];var g = d.value,
	                h = d.stack;bf(a, d);b.componentDidCatch(g, { componentStack: null !== h ? h : "" });
	          }break;
	        case 3:
	          c = a.updateQueue;null === c || null === c.capturedValues ? D("264") : void 0;f = c.capturedValues;c.capturedValues = null;for (c = 0; c < f.length; c++) {
	            d = f[c], bf(a, d), b(d.value);
	          }break;default:
	          D("265");}
	    }, commitAttachRef: function commitAttachRef(a) {
	      var b = a.ref;if (null !== b) {
	        var c = a.stateNode;switch (a.tag) {case 5:
	            a = l(c);break;default:
	            a = c;}"function" === typeof b ? b(a) : b.current = a;
	      }
	    }, commitDetachRef: function commitDetachRef(a) {
	      a = a.ref;null !== a && ("function" === typeof a ? a(null) : a.current = null);
	    } };
	}var df = {};
	function ef(a, b) {
	  function c(a) {
	    a === df ? D("174") : void 0;return a;
	  }var d = a.getChildHostContext,
	      e = a.getRootHostContext;a = b.createCursor;var f = b.push,
	      h = b.pop,
	      g = a(df),
	      k = a(df),
	      v = a(df);return { getHostContext: function getHostContext() {
	      return c(g.current);
	    }, getRootHostContainer: function getRootHostContainer() {
	      return c(v.current);
	    }, popHostContainer: function popHostContainer(a) {
	      h(g, a);h(k, a);h(v, a);
	    }, popHostContext: function popHostContext(a) {
	      k.current === a && (h(g, a), h(k, a));
	    }, pushHostContainer: function pushHostContainer(a, b) {
	      f(v, b, a);f(k, a, a);f(g, df, a);b = e(b);h(g, a);f(g, b, a);
	    }, pushHostContext: function pushHostContext(a) {
	      var b = c(v.current),
	          e = c(g.current);b = d(e, a.type, b);e !== b && (f(k, a, a), f(g, b, a));
	    } };
	}
	function ff(a) {
	  function b(a, b) {
	    var c = new xe(5, null, null, 0);c.type = "DELETED";c.stateNode = b;c["return"] = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
	  }function c(a, b) {
	    switch (a.tag) {case 5:
	        return b = f(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;case 6:
	        return b = h(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;default:
	        return !1;}
	  }function d(a) {
	    for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag;) {
	      a = a["return"];
	    }p = a;
	  }var e = a.shouldSetTextContent;
	  a = a.hydration;if (!a) return { enterHydrationState: function enterHydrationState() {
	      return !1;
	    }, resetHydrationState: function resetHydrationState() {}, tryToClaimNextHydratableInstance: function tryToClaimNextHydratableInstance() {}, prepareToHydrateHostInstance: function prepareToHydrateHostInstance() {
	      D("175");
	    }, prepareToHydrateHostTextInstance: function prepareToHydrateHostTextInstance() {
	      D("176");
	    }, popHydrationState: function popHydrationState() {
	      return !1;
	    } };var f = a.canHydrateInstance,
	      h = a.canHydrateTextInstance,
	      g = a.getNextHydratableSibling,
	      k = a.getFirstHydratableChild,
	      v = a.hydrateInstance,
	      l = a.hydrateTextInstance,
	      p = null,
	      z = null,
	      B = !1;return { enterHydrationState: function enterHydrationState(a) {
	      z = k(a.stateNode.containerInfo);p = a;return B = !0;
	    }, resetHydrationState: function resetHydrationState() {
	      z = p = null;B = !1;
	    }, tryToClaimNextHydratableInstance: function tryToClaimNextHydratableInstance(a) {
	      if (B) {
	        var d = z;if (d) {
	          if (!c(a, d)) {
	            d = g(d);if (!d || !c(a, d)) {
	              a.effectTag |= 2;B = !1;p = a;return;
	            }b(p, z);
	          }p = a;z = k(d);
	        } else a.effectTag |= 2, B = !1, p = a;
	      }
	    }, prepareToHydrateHostInstance: function prepareToHydrateHostInstance(a, b, c) {
	      b = v(a.stateNode, a.type, a.memoizedProps, b, c, a);a.updateQueue = b;return null !== b ? !0 : !1;
	    }, prepareToHydrateHostTextInstance: function prepareToHydrateHostTextInstance(a) {
	      return l(a.stateNode, a.memoizedProps, a);
	    }, popHydrationState: function popHydrationState(a) {
	      if (a !== p) return !1;if (!B) return d(a), B = !0, !1;var c = a.type;if (5 !== a.tag || "head" !== c && "body" !== c && !e(c, a.memoizedProps)) for (c = z; c;) {
	        b(a, c), c = g(c);
	      }d(a);z = p ? g(a.stateNode) : null;return !0;
	    } };
	}
	function gf(a) {
	  function b(a, b, c) {
	    a = a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext = b;a.__reactInternalMemoizedMaskedChildContext = c;
	  }function c(a) {
	    return 2 === a.tag && null != a.type.childContextTypes;
	  }function d(a, b) {
	    var c = a.stateNode,
	        d = a.type.childContextTypes;if ("function" !== typeof c.getChildContext) return b;c = c.getChildContext();for (var e in c) {
	      e in d ? void 0 : D("108", zc(a) || "Unknown", e);
	    }return A({}, b, c);
	  }var e = a.createCursor,
	      f = a.push,
	      h = a.pop,
	      g = e(ja),
	      k = e(!1),
	      v = ja;return { getUnmaskedContext: function getUnmaskedContext(a) {
	      return c(a) ? v : g.current;
	    }, cacheContext: b, getMaskedContext: function getMaskedContext(a, c) {
	      var d = a.type.contextTypes;if (!d) return ja;var e = a.stateNode;if (e && e.__reactInternalMemoizedUnmaskedChildContext === c) return e.__reactInternalMemoizedMaskedChildContext;var f = {},
	          g;for (g in d) {
	        f[g] = c[g];
	      }e && b(a, c, f);return f;
	    }, hasContextChanged: function hasContextChanged() {
	      return k.current;
	    }, isContextConsumer: function isContextConsumer(a) {
	      return 2 === a.tag && null != a.type.contextTypes;
	    }, isContextProvider: c, popContextProvider: function popContextProvider(a) {
	      c(a) && (h(k, a), h(g, a));
	    }, popTopLevelContextObject: function popTopLevelContextObject(a) {
	      h(k, a);h(g, a);
	    }, pushTopLevelContextObject: function pushTopLevelContextObject(a, b, c) {
	      null != g.cursor ? D("168") : void 0;f(g, b, a);f(k, c, a);
	    }, processChildContext: d, pushContextProvider: function pushContextProvider(a) {
	      if (!c(a)) return !1;var b = a.stateNode;b = b && b.__reactInternalMemoizedMergedChildContext || ja;v = g.current;f(g, b, a);f(k, k.current, a);return !0;
	    }, invalidateContextProvider: function invalidateContextProvider(a, b) {
	      var c = a.stateNode;c ? void 0 : D("169");if (b) {
	        var e = d(a, v);c.__reactInternalMemoizedMergedChildContext = e;h(k, a);h(g, a);f(g, e, a);
	      } else h(k, a);f(k, b, a);
	    }, findCurrentUnmaskedContext: function findCurrentUnmaskedContext(a) {
	      for (2 !== wd(a) || 2 !== a.tag ? D("170") : void 0; 3 !== a.tag;) {
	        if (c(a)) return a.stateNode.__reactInternalMemoizedMergedChildContext;(a = a["return"]) ? void 0 : D("171");
	      }return a.stateNode.context;
	    } };
	}
	function hf(a) {
	  var b = a.createCursor,
	      c = a.push,
	      d = a.pop,
	      e = b(null),
	      f = b(null),
	      h = b(0);return { pushProvider: function pushProvider(a) {
	      var b = a.type._context;c(h, b._changedBits, a);c(f, b._currentValue, a);c(e, a, a);b._currentValue = a.pendingProps.value;b._changedBits = a.stateNode;
	    }, popProvider: function popProvider(a) {
	      var b = h.current,
	          c = f.current;d(e, a);d(f, a);d(h, a);a = a.type._context;a._currentValue = c;a._changedBits = b;
	    } };
	}
	function jf() {
	  var a = [],
	      b = -1;return { createCursor: function createCursor(a) {
	      return { current: a };
	    }, isEmpty: function isEmpty() {
	      return -1 === b;
	    }, pop: function pop(c) {
	      0 > b || (c.current = a[b], a[b] = null, b--);
	    }, push: function push(c, d) {
	      b++;a[b] = c.current;c.current = d;
	    }, checkThatStackIsEmpty: function checkThatStackIsEmpty() {}, resetStackAfterFatalErrorInDev: function resetStackAfterFatalErrorInDev() {} };
	}
	function kf(a) {
	  function b() {
	    if (null !== I) for (var a = I["return"]; null !== a;) {
	      Lc(a), a = a["return"];
	    }Ya = null;Z = 0;I = null;Nc = !1;
	  }function c(a) {
	    return null !== ya && ya.has(a);
	  }function d(a) {
	    for (;;) {
	      var b = a.alternate,
	          c = a["return"],
	          d = a.sibling;if (0 === (a.effectTag & 512)) {
	        b = Cb(b, a, Z);var e = a;if (1073741823 === Z || 1073741823 !== e.expirationTime) {
	          b: switch (e.tag) {case 3:case 2:
	              var f = e.updateQueue;f = null === f ? 0 : f.expirationTime;break b;default:
	              f = 0;}for (var g = e.child; null !== g;) {
	            0 !== g.expirationTime && (0 === f || f > g.expirationTime) && (f = g.expirationTime), g = g.sibling;
	          }e.expirationTime = f;
	        }if (null !== b) return b;null !== c && 0 === (c.effectTag & 512) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));if (null !== d) return d;if (null !== c) a = c;else {
	          Nc = !0;break;
	        }
	      } else {
	        a = Kc(a);if (null !== a) return a.effectTag &= 2559, a;null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 512);if (null !== d) return d;if (null !== c) a = c;else break;
	      }
	    }return null;
	  }function e(a) {
	    var b = Wa(a.alternate, a, Z);null === b && (b = d(a));mc.current = null;return b;
	  }function f(a, c, f) {
	    ca ? D("243") : void 0;ca = !0;if (c !== Z || a !== Ya || null === I) b(), Ya = a, Z = c, I = ye(Ya.current, null, Z), a.pendingCommitExpirationTime = 0;var g = !1;do {
	      try {
	        if (f) for (; null !== I && !S();) {
	          I = e(I);
	        } else for (; null !== I;) {
	          I = e(I);
	        }
	      } catch (Oc) {
	        if (null === I) {
	          g = !0;q(Oc);break;
	        }f = I;var h = f["return"];if (null === h) {
	          g = !0;q(Oc);break;
	        }Jc(h, f, Oc);I = d(f);
	      }break;
	    } while (1);
	    ca = !1;if (g || null !== I) return null;if (Nc) return a.pendingCommitExpirationTime = c, a.current.alternate;D("262");
	  }function h(a, b, c, d) {
	    a = { value: c, source: a, stack: Ac(a) };Oe(b, { expirationTime: d, partialState: null, callback: null, isReplace: !1, isForced: !1, capturedValue: a, next: null });v(b, d);
	  }function g(a, b) {
	    a: {
	      ca && !Za ? D("263") : void 0;for (var d = a["return"]; null !== d;) {
	        switch (d.tag) {case 2:
	            var e = d.stateNode;if ("function" === typeof d.type.getDerivedStateFromCatch || "function" === typeof e.componentDidCatch && !c(e)) {
	              h(a, d, b, 1);a = void 0;break a;
	            }break;case 3:
	            h(a, d, b, 1);a = void 0;break a;}d = d["return"];
	      }3 === a.tag && h(a, a, b, 1);a = void 0;
	    }return a;
	  }function k(a) {
	    a = 0 !== ia ? ia : ca ? Za ? 1 : Z : a.mode & 1 ? za ? 10 * (((l() + 50) / 10 | 0) + 1) : 25 * (((l() + 500) / 25 | 0) + 1) : 1;za && (0 === da || a > da) && (da = a);return a;
	  }function v(a, c) {
	    a: {
	      for (; null !== a;) {
	        if (0 === a.expirationTime || a.expirationTime > c) a.expirationTime = c;null !== a.alternate && (0 === a.alternate.expirationTime || a.alternate.expirationTime > c) && (a.alternate.expirationTime = c);if (null === a["return"]) if (3 === a.tag) {
	          var d = a.stateNode;!ca && 0 !== Z && c < Z && b();ca && !Za && Ya === d || B(d, c);Fb > wg && D("185");
	        } else {
	          c = void 0;break a;
	        }a = a["return"];
	      }c = void 0;
	    }return c;
	  }function l() {
	    ve = Ic() - Pc;return xg = (ve / 10 | 0) + 2;
	  }function p(a, b, c, d, e) {
	    var f = ia;ia = 1;try {
	      return a(b, c, d, e);
	    } finally {
	      ia = f;
	    }
	  }function z(a) {
	    if (0 !== Gb) {
	      if (a > Gb) return;yg(Qc);
	    }var b = Ic() - Pc;Gb = a;Qc = lg(Q, { timeout: 10 * (a - 2) - b });
	  }function B(a, b) {
	    if (null === a.nextScheduledRoot) a.remainingExpirationTime = b, null === K ? (la = K = a, a.nextScheduledRoot = a) : (K = K.nextScheduledRoot = a, K.nextScheduledRoot = la);else {
	      var c = a.remainingExpirationTime;if (0 === c || b < c) a.remainingExpirationTime = b;
	    }T || (J ? Hb && (aa = a, P = 1, G(a, 1, !1)) : 1 === b ? n() : z(b));
	  }function r() {
	    var a = 0,
	        b = null;if (null !== K) for (var c = K, d = la; null !== d;) {
	      var e = d.remainingExpirationTime;if (0 === e) {
	        null === c || null === K ? D("244") : void 0;if (d === d.nextScheduledRoot) {
	          la = K = d.nextScheduledRoot = null;break;
	        } else if (d === la) la = e = d.nextScheduledRoot, K.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === K) {
	          K = c;K.nextScheduledRoot = la;d.nextScheduledRoot = null;break;
	        } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;d = c.nextScheduledRoot;
	      } else {
	        if (0 === a || e < a) a = e, b = d;if (d === K) break;c = d;d = d.nextScheduledRoot;
	      }
	    }c = aa;null !== c && c === b && 1 === a ? Fb++ : Fb = 0;aa = b;P = a;
	  }function Q(a) {
	    x(0, !0, a);
	  }function n() {
	    x(1, !1, null);
	  }function x(a, b, c) {
	    $a = c;r();if (b) for (; null !== aa && 0 !== P && (0 === a || a >= P) && (!Ib || l() >= P);) {
	      G(aa, P, !Ib), r();
	    } else for (; null !== aa && 0 !== P && (0 === a || a >= P);) {
	      G(aa, P, !1), r();
	    }null !== $a && (Gb = 0, Qc = -1);0 !== P && z(P);$a = null;Ib = !1;Y();
	  }function Y() {
	    Fb = 0;if (null !== Aa) {
	      var a = Aa;Aa = null;for (var b = 0; b < a.length; b++) {
	        var c = a[b];try {
	          c._onComplete();
	        } catch (vg) {
	          Ba || (Ba = !0, Jb = vg);
	        }
	      }
	    }if (Ba) throw a = Jb, Jb = null, Ba = !1, a;
	  }function G(a, b, c) {
	    T ? D("245") : void 0;T = !0;c ? (c = a.finishedWork, null !== c ? R(a, c, b) : (a.finishedWork = null, c = f(a, b, !0), null !== c && (S() ? a.finishedWork = c : R(a, c, b)))) : (c = a.finishedWork, null !== c ? R(a, c, b) : (a.finishedWork = null, c = f(a, b, !1), null !== c && R(a, c, b)));T = !1;
	  }function R(a, b, c) {
	    var d = a.firstBatch;if (null !== d && d._expirationTime <= c && (null === Aa ? Aa = [d] : Aa.push(d), d._defer)) {
	      a.finishedWork = b;a.remainingExpirationTime = 0;return;
	    }a.finishedWork = null;Za = ca = !0;c = b.stateNode;c.current === b ? D("177") : void 0;d = c.pendingCommitExpirationTime;0 === d ? D("261") : void 0;c.pendingCommitExpirationTime = 0;var e = l();mc.current = null;if (1 < b.effectTag) {
	      if (null !== b.lastEffect) {
	        b.lastEffect.nextEffect = b;var f = b.firstEffect;
	      } else f = b;
	    } else f = b.firstEffect;zg(c.containerInfo);for (w = f; null !== w;) {
	      var h = !1,
	          k = void 0;try {
	        for (; null !== w;) {
	          w.effectTag & 2048 && Db(w.alternate, w), w = w.nextEffect;
	        }
	      } catch (ab) {
	        h = !0, k = ab;
	      }h && (null === w ? D("178") : void 0, g(w, k), null !== w && (w = w.nextEffect));
	    }for (w = f; null !== w;) {
	      h = !1;k = void 0;try {
	        for (; null !== w;) {
	          var p = w.effectTag;p & 16 && Mc(w);if (p & 128) {
	            var n = w.alternate;null !== n && kg(n);
	          }switch (p & 14) {case 2:
	              Eb(w);w.effectTag &= -3;break;case 6:
	              Eb(w);w.effectTag &= -3;te(w.alternate, w);break;case 4:
	              te(w.alternate, w);break;case 8:
	              gg(w);}w = w.nextEffect;
	        }
	      } catch (ab) {
	        h = !0, k = ab;
	      }h && (null === w ? D("178") : void 0, g(w, k), null !== w && (w = w.nextEffect));
	    }Ag(c.containerInfo);c.current = b;for (w = f; null !== w;) {
	      p = !1;n = void 0;try {
	        for (f = c, h = e, k = d; null !== w;) {
	          var r = w.effectTag;
	          r & 36 && hg(f, w.alternate, w, h, k);r & 256 && ig(w, q);r & 128 && jg(w);var t = w.nextEffect;w.nextEffect = null;w = t;
	        }
	      } catch (ab) {
	        p = !0, n = ab;
	      }p && (null === w ? D("178") : void 0, g(w, n), null !== w && (w = w.nextEffect));
	    }ca = Za = !1;"function" === typeof He && He(b.stateNode);b = c.current.expirationTime;0 === b && (ya = null);a.remainingExpirationTime = b;
	  }function S() {
	    return null === $a || $a.timeRemaining() > Bg ? !1 : Ib = !0;
	  }function q(a) {
	    null === aa ? D("246") : void 0;aa.remainingExpirationTime = 0;Ba || (Ba = !0, Jb = a);
	  }var u = jf(),
	      t = ef(a, u),
	      y = gf(u);u = hf(u);var H = ff(a),
	      Wa = Ze(a, t, y, u, H, v, k).beginWork,
	      Cb = $e(a, t, y, u, H).completeWork;t = af(t, y, u, v, c);var Jc = t.throwException,
	      Kc = t.unwindWork,
	      Lc = t.unwindInterruptedWork;t = cf(a, g, v, k, function (a) {
	    null === ya ? ya = new Set([a]) : ya.add(a);
	  }, l);var Db = t.commitBeforeMutationLifeCycles,
	      Mc = t.commitResetTextContent,
	      Eb = t.commitPlacement,
	      gg = t.commitDeletion,
	      te = t.commitWork,
	      hg = t.commitLifeCycles,
	      ig = t.commitErrorLogging,
	      jg = t.commitAttachRef,
	      kg = t.commitDetachRef,
	      Ic = a.now,
	      lg = a.scheduleDeferredCallback,
	      yg = a.cancelDeferredCallback,
	      zg = a.prepareForCommit,
	      Ag = a.resetAfterCommit,
	      Pc = Ic(),
	      xg = 2,
	      ve = Pc,
	      Rc = 0,
	      ia = 0,
	      ca = !1,
	      I = null,
	      Ya = null,
	      Z = 0,
	      w = null,
	      Za = !1,
	      Nc = !1,
	      ya = null,
	      la = null,
	      K = null,
	      Gb = 0,
	      Qc = -1,
	      T = !1,
	      aa = null,
	      P = 0,
	      da = 0,
	      Ib = !1,
	      Ba = !1,
	      Jb = null,
	      $a = null,
	      J = !1,
	      Hb = !1,
	      za = !1,
	      Aa = null,
	      wg = 1E3,
	      Fb = 0,
	      Bg = 1;return { recalculateCurrentTime: l, computeExpirationForFiber: k, scheduleWork: v, requestWork: B, flushRoot: function flushRoot(a, b) {
	      T ? D("253") : void 0;aa = a;P = b;G(a, b, !1);n();Y();
	    }, batchedUpdates: function batchedUpdates(a, b) {
	      var c = J;J = !0;try {
	        return a(b);
	      } finally {
	        (J = c) || T || n();
	      }
	    }, unbatchedUpdates: function unbatchedUpdates(a, b) {
	      if (J && !Hb) {
	        Hb = !0;try {
	          return a(b);
	        } finally {
	          Hb = !1;
	        }
	      }return a(b);
	    }, flushSync: function flushSync(a, b) {
	      T ? D("187") : void 0;var c = J;J = !0;try {
	        return p(a, b);
	      } finally {
	        J = c, n();
	      }
	    }, flushControlled: function flushControlled(a) {
	      var b = J;J = !0;try {
	        p(a);
	      } finally {
	        (J = b) || T || x(1, !1, null);
	      }
	    }, deferredUpdates: function deferredUpdates(a) {
	      var b = ia;ia = 25 * (((l() + 500) / 25 | 0) + 1);try {
	        return a();
	      } finally {
	        ia = b;
	      }
	    }, syncUpdates: p, interactiveUpdates: function interactiveUpdates(a, b, c) {
	      if (za) return a(b, c);J || T || 0 === da || (x(da, !1, null), da = 0);var d = za,
	          e = J;J = za = !0;try {
	        return a(b, c);
	      } finally {
	        za = d, (J = e) || T || n();
	      }
	    }, flushInteractiveUpdates: function flushInteractiveUpdates() {
	      T || 0 === da || (x(da, !1, null), da = 0);
	    }, computeUniqueAsyncExpiration: function computeUniqueAsyncExpiration() {
	      var a = 25 * (((l() + 500) / 25 | 0) + 1);a <= Rc && (a = Rc + 1);return Rc = a;
	    }, legacyContext: y };
	}
	function lf(a) {
	  function b(a, b, c, d, e, f) {
	    d = b.current;if (c) {
	      c = c._reactInternalFiber;var g = k(c);c = v(c) ? l(c, g) : g;
	    } else c = ja;null === b.context ? b.context = c : b.pendingContext = c;b = f;Oe(d, { expirationTime: e, partialState: { element: a }, callback: void 0 === b ? null : b, isReplace: !1, isForced: !1, capturedValue: null, next: null });h(d, e);return e;
	  }function c(a) {
	    a = Ad(a);return null === a ? null : a.stateNode;
	  }var d = a.getPublicInstance;a = kf(a);var e = a.recalculateCurrentTime,
	      f = a.computeExpirationForFiber,
	      h = a.scheduleWork,
	      g = a.legacyContext,
	      k = g.findCurrentUnmaskedContext,
	      v = g.isContextProvider,
	      l = g.processChildContext;return { createContainer: function createContainer(a, b, c) {
	      b = new xe(3, null, null, b ? 3 : 0);a = { current: b, containerInfo: a, pendingChildren: null, pendingCommitExpirationTime: 0, finishedWork: null, context: null, pendingContext: null, hydrate: c, remainingExpirationTime: 0, firstBatch: null, nextScheduledRoot: null };return b.stateNode = a;
	    }, updateContainer: function updateContainer(a, c, d, g) {
	      var h = c.current,
	          k = e();h = f(h);return b(a, c, d, k, h, g);
	    }, updateContainerAtExpirationTime: function updateContainerAtExpirationTime(a, c, d, f, g) {
	      var h = e();return b(a, c, d, h, f, g);
	    }, flushRoot: a.flushRoot, requestWork: a.requestWork, computeUniqueAsyncExpiration: a.computeUniqueAsyncExpiration, batchedUpdates: a.batchedUpdates, unbatchedUpdates: a.unbatchedUpdates, deferredUpdates: a.deferredUpdates, syncUpdates: a.syncUpdates, interactiveUpdates: a.interactiveUpdates, flushInteractiveUpdates: a.flushInteractiveUpdates, flushControlled: a.flushControlled, flushSync: a.flushSync, getPublicRootInstance: function getPublicRootInstance(a) {
	      a = a.current;if (!a.child) return null;switch (a.child.tag) {case 5:
	          return d(a.child.stateNode);
	        default:
	          return a.child.stateNode;}
	    }, findHostInstance: c, findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
	      a = Bd(a);return null === a ? null : a.stateNode;
	    }, injectIntoDevTools: function injectIntoDevTools(a) {
	      var b = a.findFiberByHostInstance;return Ge(A({}, a, { findHostInstanceByFiber: function findHostInstanceByFiber(a) {
	          return c(a);
	        }, findFiberByHostInstance: function findFiberByHostInstance(a) {
	          return b ? b(a) : null;
	        } }));
	    } };
	}var mf = Object.freeze({ default: lf }),
	    nf = mf && lf || mf,
	    of = nf["default"] ? nf["default"] : nf;
	function pf(a, b, c) {
	  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;return { $$typeof: qc, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
	}var qf = "object" === (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && "function" === typeof performance.now,
	    rf = void 0;rf = qf ? function () {
	  return performance.now();
	} : function () {
	  return Date.now();
	};var sf = void 0,
	    tf = void 0;
	if (m.canUseDOM) {
	  if ("function" !== typeof requestIdleCallback || "function" !== typeof cancelIdleCallback) {
	    var uf = null,
	        vf = !1,
	        wf = -1,
	        xf = !1,
	        yf = 0,
	        zf = 33,
	        Af = 33,
	        Bf = void 0;Bf = qf ? { didTimeout: !1, timeRemaining: function timeRemaining() {
	        var a = yf - performance.now();return 0 < a ? a : 0;
	      } } : { didTimeout: !1, timeRemaining: function timeRemaining() {
	        var a = yf - Date.now();return 0 < a ? a : 0;
	      } };var Cf = "__reactIdleCallback$" + Math.random().toString(36).slice(2);window.addEventListener("message", function (a) {
	      if (a.source === window && a.data === Cf) {
	        vf = !1;a = rf();if (0 >= yf - a) {
	          if (-1 !== wf && wf <= a) Bf.didTimeout = !0;else {
	            xf || (xf = !0, requestAnimationFrame(Df));return;
	          }
	        } else Bf.didTimeout = !1;wf = -1;a = uf;uf = null;null !== a && a(Bf);
	      }
	    }, !1);var Df = function Df(a) {
	      xf = !1;var b = a - yf + Af;b < Af && zf < Af ? (8 > b && (b = 8), Af = b < zf ? zf : b) : zf = b;yf = a + Af;vf || (vf = !0, window.postMessage(Cf, "*"));
	    };sf = function sf(a, b) {
	      uf = a;null != b && "number" === typeof b.timeout && (wf = rf() + b.timeout);xf || (xf = !0, requestAnimationFrame(Df));return 0;
	    };tf = function tf() {
	      uf = null;vf = !1;wf = -1;
	    };
	  } else sf = window.requestIdleCallback, tf = window.cancelIdleCallback;
	} else sf = function sf(a) {
	  return setTimeout(function () {
	    a({ timeRemaining: function timeRemaining() {
	        return Infinity;
	      }, didTimeout: !1 });
	  });
	}, tf = function tf(a) {
	  clearTimeout(a);
	};function Ef(a) {
	  var b = "";ba.Children.forEach(a, function (a) {
	    null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
	  });return b;
	}function Ff(a, b) {
	  a = A({ children: void 0 }, b);if (b = Ef(b.children)) a.children = b;return a;
	}
	function Gf(a, b, c, d) {
	  a = a.options;if (b) {
	    b = {};for (var e = 0; e < c.length; e++) {
	      b["$" + c[e]] = !0;
	    }for (c = 0; c < a.length; c++) {
	      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
	    }
	  } else {
	    c = "" + c;b = null;for (e = 0; e < a.length; e++) {
	      if (a[e].value === c) {
	        a[e].selected = !0;d && (a[e].defaultSelected = !0);return;
	      }null !== b || a[e].disabled || (b = a[e]);
	    }null !== b && (b.selected = !0);
	  }
	}
	function Hf(a, b) {
	  var c = b.value;a._wrapperState = { initialValue: null != c ? c : b.defaultValue, wasMultiple: !!b.multiple };
	}function If(a, b) {
	  null != b.dangerouslySetInnerHTML ? D("91") : void 0;return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
	}function Jf(a, b) {
	  var c = b.value;null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? D("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : D("93"), b = b[0]), c = "" + b), null == c && (c = ""));a._wrapperState = { initialValue: "" + c };
	}
	function Kf(a, b) {
	  var c = b.value;null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && (a.defaultValue = c));null != b.defaultValue && (a.defaultValue = b.defaultValue);
	}function Lf(a) {
	  var b = a.textContent;b === a._wrapperState.initialValue && (a.value = b);
	}var Mf = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
	function Nf(a) {
	  switch (a) {case "svg":
	      return "http://www.w3.org/2000/svg";case "math":
	      return "http://www.w3.org/1998/Math/MathML";default:
	      return "http://www.w3.org/1999/xhtml";}
	}function Of(a, b) {
	  return null == a || "http://www.w3.org/1999/xhtml" === a ? Nf(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
	}
	var Pf = void 0,
	    Qf = function (a) {
	  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
	    MSApp.execUnsafeLocalFunction(function () {
	      return a(b, c, d, e);
	    });
	  } : a;
	}(function (a, b) {
	  if (a.namespaceURI !== Mf.svg || "innerHTML" in a) a.innerHTML = b;else {
	    Pf = Pf || document.createElement("div");Pf.innerHTML = "\x3csvg\x3e" + b + "\x3c/svg\x3e";for (b = Pf.firstChild; a.firstChild;) {
	      a.removeChild(a.firstChild);
	    }for (; b.firstChild;) {
	      a.appendChild(b.firstChild);
	    }
	  }
	});
	function Rf(a, b) {
	  if (b) {
	    var c = a.firstChild;if (c && c === a.lastChild && 3 === c.nodeType) {
	      c.nodeValue = b;return;
	    }
	  }a.textContent = b;
	}
	var Sf = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0, floodOpacity: !0,
	  stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
	    Tf = ["Webkit", "ms", "Moz", "O"];Object.keys(Sf).forEach(function (a) {
	  Tf.forEach(function (b) {
	    b = b + a.charAt(0).toUpperCase() + a.substring(1);Sf[b] = Sf[a];
	  });
	});
	function Uf(a, b) {
	  a = a.style;for (var c in b) {
	    if (b.hasOwnProperty(c)) {
	      var d = 0 === c.indexOf("--");var e = c;var f = b[c];e = null == f || "boolean" === typeof f || "" === f ? "" : d || "number" !== typeof f || 0 === f || Sf.hasOwnProperty(e) && Sf[e] ? ("" + f).trim() : f + "px";"float" === c && (c = "cssFloat");d ? a.setProperty(c, e) : a[c] = e;
	    }
	  }
	}var Vf = A({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
	function Wf(a, b, c) {
	  b && (Vf[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? D("137", a, c()) : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? D("60") : void 0, "object" === _typeof(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML ? void 0 : D("61")), null != b.style && "object" !== _typeof(b.style) ? D("62", c()) : void 0);
	}
	function Xf(a, b) {
	  if (-1 === a.indexOf("-")) return "string" === typeof b.is;switch (a) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
	      return !1;default:
	      return !0;}
	}var Yf = Mf.html,
	    Zf = C.thatReturns("");
	function $f(a, b) {
	  a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;var c = je(a);b = ua[b];for (var d = 0; d < b.length; d++) {
	    var e = b[d];c.hasOwnProperty(e) && c[e] || ("topScroll" === e ? Yd("topScroll", "scroll", a) : "topFocus" === e || "topBlur" === e ? (Yd("topFocus", "focus", a), Yd("topBlur", "blur", a), c.topBlur = !0, c.topFocus = !0) : "topCancel" === e ? (hc("cancel", !0) && Yd("topCancel", "cancel", a), c.topCancel = !0) : "topClose" === e ? (hc("close", !0) && Yd("topClose", "close", a), c.topClose = !0) : ee.hasOwnProperty(e) && W(e, ee[e], a), c[e] = !0);
	  }
	}
	function ag(a, b, c, d) {
	  c = 9 === c.nodeType ? c : c.ownerDocument;d === Yf && (d = Nf(a));d === Yf ? "script" === a ? (a = c.createElement("div"), a.innerHTML = "\x3cscript\x3e\x3c/script\x3e", a = a.removeChild(a.firstChild)) : a = "string" === typeof b.is ? c.createElement(a, { is: b.is }) : c.createElement(a) : a = c.createElementNS(d, a);return a;
	}function bg(a, b) {
	  return (9 === b.nodeType ? b : b.ownerDocument).createTextNode(a);
	}
	function cg(a, b, c, d) {
	  var e = Xf(b, c);switch (b) {case "iframe":case "object":
	      W("topLoad", "load", a);var f = c;break;case "video":case "audio":
	      for (f in fe) {
	        fe.hasOwnProperty(f) && W(f, fe[f], a);
	      }f = c;break;case "source":
	      W("topError", "error", a);f = c;break;case "img":case "image":case "link":
	      W("topError", "error", a);W("topLoad", "load", a);f = c;break;case "form":
	      W("topReset", "reset", a);W("topSubmit", "submit", a);f = c;break;case "details":
	      W("topToggle", "toggle", a);f = c;break;case "input":
	      Vc(a, c);f = Uc(a, c);W("topInvalid", "invalid", a);$f(d, "onChange");break;case "option":
	      f = Ff(a, c);break;case "select":
	      Hf(a, c);f = A({}, c, { value: void 0 });W("topInvalid", "invalid", a);$f(d, "onChange");break;case "textarea":
	      Jf(a, c);f = If(a, c);W("topInvalid", "invalid", a);$f(d, "onChange");break;default:
	      f = c;}Wf(b, f, Zf);var h = f,
	      g;for (g in h) {
	    if (h.hasOwnProperty(g)) {
	      var k = h[g];"style" === g ? Uf(a, k, Zf) : "dangerouslySetInnerHTML" === g ? (k = k ? k.__html : void 0, null != k && Qf(a, k)) : "children" === g ? "string" === typeof k ? ("textarea" !== b || "" !== k) && Rf(a, k) : "number" === typeof k && Rf(a, "" + k) : "suppressContentEditableWarning" !== g && "suppressHydrationWarning" !== g && "autoFocus" !== g && (ta.hasOwnProperty(g) ? null != k && $f(d, g) : null != k && Tc(a, g, k, e));
	    }
	  }switch (b) {case "input":
	      kc(a);$c(a, c);break;case "textarea":
	      kc(a);Lf(a, c);break;case "option":
	      null != c.value && a.setAttribute("value", c.value);break;case "select":
	      a.multiple = !!c.multiple;b = c.value;null != b ? Gf(a, !!c.multiple, b, !1) : null != c.defaultValue && Gf(a, !!c.multiple, c.defaultValue, !0);break;default:
	      "function" === typeof f.onClick && (a.onclick = C);}
	}
	function dg(a, b, c, d, e) {
	  var f = null;switch (b) {case "input":
	      c = Uc(a, c);d = Uc(a, d);f = [];break;case "option":
	      c = Ff(a, c);d = Ff(a, d);f = [];break;case "select":
	      c = A({}, c, { value: void 0 });d = A({}, d, { value: void 0 });f = [];break;case "textarea":
	      c = If(a, c);d = If(a, d);f = [];break;default:
	      "function" !== typeof c.onClick && "function" === typeof d.onClick && (a.onclick = C);}Wf(b, d, Zf);b = a = void 0;var h = null;for (a in c) {
	    if (!d.hasOwnProperty(a) && c.hasOwnProperty(a) && null != c[a]) if ("style" === a) {
	      var g = c[a];for (b in g) {
	        g.hasOwnProperty(b) && (h || (h = {}), h[b] = "");
	      }
	    } else "dangerouslySetInnerHTML" !== a && "children" !== a && "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && "autoFocus" !== a && (ta.hasOwnProperty(a) ? f || (f = []) : (f = f || []).push(a, null));
	  }for (a in d) {
	    var k = d[a];g = null != c ? c[a] : void 0;if (d.hasOwnProperty(a) && k !== g && (null != k || null != g)) if ("style" === a) {
	      if (g) {
	        for (b in g) {
	          !g.hasOwnProperty(b) || k && k.hasOwnProperty(b) || (h || (h = {}), h[b] = "");
	        }for (b in k) {
	          k.hasOwnProperty(b) && g[b] !== k[b] && (h || (h = {}), h[b] = k[b]);
	        }
	      } else h || (f || (f = []), f.push(a, h)), h = k;
	    } else "dangerouslySetInnerHTML" === a ? (k = k ? k.__html : void 0, g = g ? g.__html : void 0, null != k && g !== k && (f = f || []).push(a, "" + k)) : "children" === a ? g === k || "string" !== typeof k && "number" !== typeof k || (f = f || []).push(a, "" + k) : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && (ta.hasOwnProperty(a) ? (null != k && $f(e, a), f || g === k || (f = [])) : (f = f || []).push(a, k));
	  }h && (f = f || []).push("style", h);return f;
	}
	function eg(a, b, c, d, e) {
	  "input" === c && "radio" === e.type && null != e.name && Xc(a, e);Xf(c, d);d = Xf(c, e);for (var f = 0; f < b.length; f += 2) {
	    var h = b[f],
	        g = b[f + 1];"style" === h ? Uf(a, g, Zf) : "dangerouslySetInnerHTML" === h ? Qf(a, g) : "children" === h ? Rf(a, g) : Tc(a, h, g, d);
	  }switch (c) {case "input":
	      Yc(a, e);break;case "textarea":
	      Kf(a, e);break;case "select":
	      a._wrapperState.initialValue = void 0, b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? Gf(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? Gf(a, !!e.multiple, e.defaultValue, !0) : Gf(a, !!e.multiple, e.multiple ? [] : "", !1));}
	}
	function fg(a, b, c, d, e) {
	  switch (b) {case "iframe":case "object":
	      W("topLoad", "load", a);break;case "video":case "audio":
	      for (var f in fe) {
	        fe.hasOwnProperty(f) && W(f, fe[f], a);
	      }break;case "source":
	      W("topError", "error", a);break;case "img":case "image":case "link":
	      W("topError", "error", a);W("topLoad", "load", a);break;case "form":
	      W("topReset", "reset", a);W("topSubmit", "submit", a);break;case "details":
	      W("topToggle", "toggle", a);break;case "input":
	      Vc(a, c);W("topInvalid", "invalid", a);$f(e, "onChange");break;case "select":
	      Hf(a, c);W("topInvalid", "invalid", a);$f(e, "onChange");break;case "textarea":
	      Jf(a, c), W("topInvalid", "invalid", a), $f(e, "onChange");}Wf(b, c, Zf);d = null;for (var h in c) {
	    c.hasOwnProperty(h) && (f = c[h], "children" === h ? "string" === typeof f ? a.textContent !== f && (d = ["children", f]) : "number" === typeof f && a.textContent !== "" + f && (d = ["children", "" + f]) : ta.hasOwnProperty(h) && null != f && $f(e, h));
	  }switch (b) {case "input":
	      kc(a);$c(a, c);break;case "textarea":
	      kc(a);Lf(a, c);break;case "select":case "option":
	      break;default:
	      "function" === typeof c.onClick && (a.onclick = C);}return d;
	}function mg(a, b) {
	  return a.nodeValue !== b;
	}
	var ng = Object.freeze({ createElement: ag, createTextNode: bg, setInitialProperties: cg, diffProperties: dg, updateProperties: eg, diffHydratedProperties: fg, diffHydratedText: mg, warnForUnmatchedText: function warnForUnmatchedText() {}, warnForDeletedHydratableElement: function warnForDeletedHydratableElement() {}, warnForDeletedHydratableText: function warnForDeletedHydratableText() {}, warnForInsertedHydratedElement: function warnForInsertedHydratedElement() {}, warnForInsertedHydratedText: function warnForInsertedHydratedText() {}, restoreControlledState: function restoreControlledState(a, b, c) {
	    switch (b) {case "input":
	        Yc(a, c);b = c.name;if ("radio" === c.type && null != b) {
	          for (c = a; c.parentNode;) {
	            c = c.parentNode;
	          }c = c.querySelectorAll("input[name\x3d" + JSON.stringify("" + b) + '][type\x3d"radio"]');for (b = 0; b < c.length; b++) {
	            var d = c[b];if (d !== a && d.form === a.form) {
	              var e = Va(d);e ? void 0 : D("90");lc(d);Yc(d, e);
	            }
	          }
	        }break;case "textarea":
	        Kf(a, c);break;case "select":
	        b = c.value, null != b && Gf(a, !!c.multiple, b, !1);}
	  } });Vb.injectFiberControlledHostComponent(ng);var og = null,
	    pg = null;
	function qg(a) {
	  this._expirationTime = X.computeUniqueAsyncExpiration();this._root = a;this._callbacks = this._next = null;this._hasChildren = this._didComplete = !1;this._children = null;this._defer = !0;
	}qg.prototype.render = function (a) {
	  this._defer ? void 0 : D("250");this._hasChildren = !0;this._children = a;var b = this._root._internalRoot,
	      c = this._expirationTime,
	      d = new rg();X.updateContainerAtExpirationTime(a, b, null, c, d._onCommit);return d;
	};
	qg.prototype.then = function (a) {
	  if (this._didComplete) a();else {
	    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
	  }
	};
	qg.prototype.commit = function () {
	  var a = this._root._internalRoot,
	      b = a.firstBatch;this._defer && null !== b ? void 0 : D("251");if (this._hasChildren) {
	    var c = this._expirationTime;if (b !== this) {
	      this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));for (var d = null, e = b; e !== this;) {
	        d = e, e = e._next;
	      }null === d ? D("251") : void 0;d._next = e._next;this._next = b;a.firstBatch = this;
	    }this._defer = !1;X.flushRoot(a, c);b = this._next;this._next = null;b = a.firstBatch = b;null !== b && b._hasChildren && b.render(b._children);
	  } else this._next = null, this._defer = !1;
	};qg.prototype._onComplete = function () {
	  if (!this._didComplete) {
	    this._didComplete = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
	      (0, a[b])();
	    }
	  }
	};function rg() {
	  this._callbacks = null;this._didCommit = !1;this._onCommit = this._onCommit.bind(this);
	}rg.prototype.then = function (a) {
	  if (this._didCommit) a();else {
	    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
	  }
	};
	rg.prototype._onCommit = function () {
	  if (!this._didCommit) {
	    this._didCommit = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
	      var c = a[b];"function" !== typeof c ? D("191", c) : void 0;c();
	    }
	  }
	};function sg(a, b, c) {
	  this._internalRoot = X.createContainer(a, b, c);
	}sg.prototype.render = function (a, b) {
	  var c = this._internalRoot,
	      d = new rg();b = void 0 === b ? null : b;null !== b && d.then(b);X.updateContainer(a, c, null, d._onCommit);return d;
	};
	sg.prototype.unmount = function (a) {
	  var b = this._internalRoot,
	      c = new rg();a = void 0 === a ? null : a;null !== a && c.then(a);X.updateContainer(null, b, null, c._onCommit);return c;
	};sg.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {
	  var d = this._internalRoot,
	      e = new rg();c = void 0 === c ? null : c;null !== c && e.then(c);X.updateContainer(b, d, a, e._onCommit);return e;
	};
	sg.prototype.createBatch = function () {
	  var a = new qg(this),
	      b = a._expirationTime,
	      c = this._internalRoot,
	      d = c.firstBatch;if (null === d) c.firstBatch = a, a._next = null;else {
	    for (c = null; null !== d && d._expirationTime <= b;) {
	      c = d, d = d._next;
	    }a._next = d;null !== c && (c._next = a);
	  }return a;
	};function tg(a) {
	  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
	}
	function ug(a, b) {
	  switch (a) {case "button":case "input":case "select":case "textarea":
	      return !!b.autoFocus;}return !1;
	}
	var X = of({ getRootHostContext: function getRootHostContext(a) {
	    var b = a.nodeType;switch (b) {case 9:case 11:
	        a = (a = a.documentElement) ? a.namespaceURI : Of(null, "");break;default:
	        b = 8 === b ? a.parentNode : a, a = b.namespaceURI || null, b = b.tagName, a = Of(a, b);}return a;
	  }, getChildHostContext: function getChildHostContext(a, b) {
	    return Of(a, b);
	  }, getPublicInstance: function getPublicInstance(a) {
	    return a;
	  }, prepareForCommit: function prepareForCommit() {
	    og = Ud;var a = ea();if (me(a)) {
	      if ("selectionStart" in a) var b = { start: a.selectionStart, end: a.selectionEnd };else a: {
	        var c = window.getSelection && window.getSelection();
	        if (c && 0 !== c.rangeCount) {
	          b = c.anchorNode;var d = c.anchorOffset,
	              e = c.focusNode;c = c.focusOffset;try {
	            b.nodeType, e.nodeType;
	          } catch (B) {
	            b = null;break a;
	          }var f = 0,
	              h = -1,
	              g = -1,
	              k = 0,
	              v = 0,
	              l = a,
	              p = null;b: for (;;) {
	            for (var z;;) {
	              l !== b || 0 !== d && 3 !== l.nodeType || (h = f + d);l !== e || 0 !== c && 3 !== l.nodeType || (g = f + c);3 === l.nodeType && (f += l.nodeValue.length);if (null === (z = l.firstChild)) break;p = l;l = z;
	            }for (;;) {
	              if (l === a) break b;p === b && ++k === d && (h = f);p === e && ++v === c && (g = f);if (null !== (z = l.nextSibling)) break;l = p;p = l.parentNode;
	            }l = z;
	          }b = -1 === h || -1 === g ? null : { start: h, end: g };
	        } else b = null;
	      }b = b || { start: 0, end: 0 };
	    } else b = null;pg = { focusedElem: a, selectionRange: b };Vd(!1);
	  }, resetAfterCommit: function resetAfterCommit() {
	    var a = pg,
	        b = ea(),
	        c = a.focusedElem,
	        d = a.selectionRange;if (b !== c && ha(document.documentElement, c)) {
	      if (me(c)) if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);else if (window.getSelection) {
	        b = window.getSelection();var e = c[lb()].length;a = Math.min(d.start, e);d = void 0 === d.end ? a : Math.min(d.end, e);!b.extend && a > d && (e = d, d = a, a = e);e = le(c, a);var f = le(c, d);if (e && f && (1 !== b.rangeCount || b.anchorNode !== e.node || b.anchorOffset !== e.offset || b.focusNode !== f.node || b.focusOffset !== f.offset)) {
	          var h = document.createRange();h.setStart(e.node, e.offset);b.removeAllRanges();a > d ? (b.addRange(h), b.extend(f.node, f.offset)) : (h.setEnd(f.node, f.offset), b.addRange(h));
	        }
	      }b = [];for (a = c; a = a.parentNode;) {
	        1 === a.nodeType && b.push({ element: a, left: a.scrollLeft, top: a.scrollTop });
	      }c.focus();for (c = 0; c < b.length; c++) {
	        a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
	      }
	    }pg = null;Vd(og);og = null;
	  }, createInstance: function createInstance(a, b, c, d, e) {
	    a = ag(a, b, c, d);a[F] = e;a[Sa] = b;return a;
	  }, appendInitialChild: function appendInitialChild(a, b) {
	    a.appendChild(b);
	  }, finalizeInitialChildren: function finalizeInitialChildren(a, b, c, d) {
	    cg(a, b, c, d);return ug(b, c);
	  }, prepareUpdate: function prepareUpdate(a, b, c, d, e) {
	    return dg(a, b, c, d, e);
	  }, shouldSetTextContent: function shouldSetTextContent(a, b) {
	    return "textarea" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === _typeof(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && "string" === typeof b.dangerouslySetInnerHTML.__html;
	  }, shouldDeprioritizeSubtree: function shouldDeprioritizeSubtree(a, b) {
	    return !!b.hidden;
	  }, createTextInstance: function createTextInstance(a, b, c, d) {
	    a = bg(a, b);a[F] = d;return a;
	  }, now: rf, mutation: { commitMount: function commitMount(a, b, c) {
	      ug(b, c) && a.focus();
	    }, commitUpdate: function commitUpdate(a, b, c, d, e) {
	      a[Sa] = e;eg(a, b, c, d, e);
	    }, resetTextContent: function resetTextContent(a) {
	      Rf(a, "");
	    }, commitTextUpdate: function commitTextUpdate(a, b, c) {
	      a.nodeValue = c;
	    }, appendChild: function appendChild(a, b) {
	      a.appendChild(b);
	    }, appendChildToContainer: function appendChildToContainer(a, b) {
	      8 === a.nodeType ? a.parentNode.insertBefore(b, a) : a.appendChild(b);
	    },
	    insertBefore: function insertBefore(a, b, c) {
	      a.insertBefore(b, c);
	    }, insertInContainerBefore: function insertInContainerBefore(a, b, c) {
	      8 === a.nodeType ? a.parentNode.insertBefore(b, c) : a.insertBefore(b, c);
	    }, removeChild: function removeChild(a, b) {
	      a.removeChild(b);
	    }, removeChildFromContainer: function removeChildFromContainer(a, b) {
	      8 === a.nodeType ? a.parentNode.removeChild(b) : a.removeChild(b);
	    } }, hydration: { canHydrateInstance: function canHydrateInstance(a, b) {
	      return 1 !== a.nodeType || b.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
	    }, canHydrateTextInstance: function canHydrateTextInstance(a, b) {
	      return "" === b || 3 !== a.nodeType ? null : a;
	    }, getNextHydratableSibling: function getNextHydratableSibling(a) {
	      for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
	        a = a.nextSibling;
	      }return a;
	    }, getFirstHydratableChild: function getFirstHydratableChild(a) {
	      for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
	        a = a.nextSibling;
	      }return a;
	    }, hydrateInstance: function hydrateInstance(a, b, c, d, e, f) {
	      a[F] = f;a[Sa] = c;return fg(a, b, c, e, d);
	    }, hydrateTextInstance: function hydrateTextInstance(a, b, c) {
	      a[F] = c;return mg(a, b);
	    }, didNotMatchHydratedContainerTextInstance: function didNotMatchHydratedContainerTextInstance() {}, didNotMatchHydratedTextInstance: function didNotMatchHydratedTextInstance() {}, didNotHydrateContainerInstance: function didNotHydrateContainerInstance() {}, didNotHydrateInstance: function didNotHydrateInstance() {},
	    didNotFindHydratableContainerInstance: function didNotFindHydratableContainerInstance() {}, didNotFindHydratableContainerTextInstance: function didNotFindHydratableContainerTextInstance() {}, didNotFindHydratableInstance: function didNotFindHydratableInstance() {}, didNotFindHydratableTextInstance: function didNotFindHydratableTextInstance() {} }, scheduleDeferredCallback: sf, cancelDeferredCallback: tf }),
	    Cg = X;$b = Cg.batchedUpdates;ac = Cg.interactiveUpdates;bc = Cg.flushInteractiveUpdates;
	function Dg(a, b) {
	  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));if (!b) for (var c; c = a.lastChild;) {
	    a.removeChild(c);
	  }return new sg(a, !1, b);
	}
	function Eg(a, b, c, d, e) {
	  tg(c) ? void 0 : D("200");var f = c._reactRootContainer;if (f) {
	    if ("function" === typeof e) {
	      var h = e;e = function e() {
	        var a = X.getPublicRootInstance(f._internalRoot);h.call(a);
	      };
	    }null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
	  } else {
	    f = c._reactRootContainer = Dg(c, d);if ("function" === typeof e) {
	      var g = e;e = function e() {
	        var a = X.getPublicRootInstance(f._internalRoot);g.call(a);
	      };
	    }X.unbatchedUpdates(function () {
	      null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
	    });
	  }return X.getPublicRootInstance(f._internalRoot);
	}
	function Fg(a, b) {
	  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;tg(b) ? void 0 : D("200");return pf(a, b, null, c);
	}
	var Gg = { createPortal: Fg, findDOMNode: function findDOMNode(a) {
	    if (null == a) return null;if (1 === a.nodeType) return a;var b = a._reactInternalFiber;if (b) return X.findHostInstance(b);"function" === typeof a.render ? D("188") : D("213", Object.keys(a));
	  }, hydrate: function hydrate(a, b, c) {
	    return Eg(null, a, b, !0, c);
	  }, render: function render(a, b, c) {
	    return Eg(null, a, b, !1, c);
	  }, unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {
	    null == a || void 0 === a._reactInternalFiber ? D("38") : void 0;return Eg(a, b, c, !1, d);
	  }, unmountComponentAtNode: function unmountComponentAtNode(a) {
	    tg(a) ? void 0 : D("40");return a._reactRootContainer ? (X.unbatchedUpdates(function () {
	      Eg(null, null, a, !1, function () {
	        a._reactRootContainer = null;
	      });
	    }), !0) : !1;
	  }, unstable_createPortal: function unstable_createPortal() {
	    return Fg.apply(void 0, arguments);
	  }, unstable_batchedUpdates: X.batchedUpdates, unstable_deferredUpdates: X.deferredUpdates, flushSync: X.flushSync, unstable_flushControlled: X.flushControlled, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { EventPluginHub: Qa, EventPluginRegistry: xa, EventPropagators: jb, ReactControlledComponent: Zb, ReactDOMComponentTree: Xa,
	    ReactDOMEventListener: Zd }, unstable_createRoot: function unstable_createRoot(a, b) {
	    return new sg(a, !0, null != b && !0 === b.hydrate);
	  } };X.injectIntoDevTools({ findFiberByHostInstance: Ta, bundleType: 0, version: "16.3.1", rendererPackageName: "react-dom" });var Hg = Object.freeze({ default: Gg }),
	    Ig = Hg && Gg || Hg;module.exports = Ig["default"] ? Ig["default"] : Ig;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(680);
	} else {
	  module.exports = require('./cjs/react-dom-server.browser.development.js');
	}

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(699);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(576);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(684);
	
	var _HelmetConstants = __webpack_require__(229);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	    var target = {};for (var i in obj) {
	        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	    }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _possibleConstructorReturn(self, call) {
	    if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(56);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(229);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (e, a) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = a() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.en = a());
	}(undefined, function () {
	  "use strict";
	  return [{ locale: "en", pluralRuleFunction: function pluralRuleFunction(e, a) {
	      var n = String(e).split("."),
	          l = !n[1],
	          o = Number(n[0]) == e,
	          t = o && n[0].slice(-1),
	          r = o && n[0].slice(-2);return a ? 1 == t && 11 != r ? "one" : 2 == t && 12 != r ? "two" : 3 == t && 13 != r ? "few" : "other" : 1 == e && l ? "one" : "other";
	    }, fields: { year: { displayName: "year", relative: { 0: "this year", 1: "next year", "-1": "last year" }, relativeTime: { future: { one: "in {0} year", other: "in {0} years" }, past: { one: "{0} year ago", other: "{0} years ago" } } }, month: { displayName: "month", relative: { 0: "this month", 1: "next month", "-1": "last month" }, relativeTime: { future: { one: "in {0} month", other: "in {0} months" }, past: { one: "{0} month ago", other: "{0} months ago" } } }, day: { displayName: "day", relative: { 0: "today", 1: "tomorrow", "-1": "yesterday" }, relativeTime: { future: { one: "in {0} day", other: "in {0} days" }, past: { one: "{0} day ago", other: "{0} days ago" } } }, hour: { displayName: "hour", relative: { 0: "this hour" }, relativeTime: { future: { one: "in {0} hour", other: "in {0} hours" }, past: { one: "{0} hour ago", other: "{0} hours ago" } } }, minute: { displayName: "minute", relative: { 0: "this minute" }, relativeTime: { future: { one: "in {0} minute", other: "in {0} minutes" }, past: { one: "{0} minute ago", other: "{0} minutes ago" } } }, second: { displayName: "second", relative: { 0: "now" }, relativeTime: { future: { one: "in {0} second", other: "in {0} seconds" }, past: { one: "{0} second ago", other: "{0} seconds ago" } } } } }, { locale: "en-001", parentLocale: "en" }, { locale: "en-150", parentLocale: "en-001" }, { locale: "en-AG", parentLocale: "en-001" }, { locale: "en-AI", parentLocale: "en-001" }, { locale: "en-AS", parentLocale: "en" }, { locale: "en-AT", parentLocale: "en-150" }, { locale: "en-AU", parentLocale: "en-001" }, { locale: "en-BB", parentLocale: "en-001" }, { locale: "en-BE", parentLocale: "en-001" }, { locale: "en-BI", parentLocale: "en" }, { locale: "en-BM", parentLocale: "en-001" }, { locale: "en-BS", parentLocale: "en-001" }, { locale: "en-BW", parentLocale: "en-001" }, { locale: "en-BZ", parentLocale: "en-001" }, { locale: "en-CA", parentLocale: "en-001" }, { locale: "en-CC", parentLocale: "en-001" }, { locale: "en-CH", parentLocale: "en-150" }, { locale: "en-CK", parentLocale: "en-001" }, { locale: "en-CM", parentLocale: "en-001" }, { locale: "en-CX", parentLocale: "en-001" }, { locale: "en-CY", parentLocale: "en-001" }, { locale: "en-DE", parentLocale: "en-150" }, { locale: "en-DG", parentLocale: "en-001" }, { locale: "en-DK", parentLocale: "en-150" }, { locale: "en-DM", parentLocale: "en-001" }, { locale: "en-Dsrt", pluralRuleFunction: function pluralRuleFunction(e, a) {
	      return "other";
	    }, fields: { year: { displayName: "Year", relative: { 0: "this year", 1: "next year", "-1": "last year" }, relativeTime: { future: { other: "+{0} y" }, past: { other: "-{0} y" } } }, month: { displayName: "Month", relative: { 0: "this month", 1: "next month", "-1": "last month" }, relativeTime: { future: { other: "+{0} m" }, past: { other: "-{0} m" } } }, day: { displayName: "Day", relative: { 0: "today", 1: "tomorrow", "-1": "yesterday" }, relativeTime: { future: { other: "+{0} d" }, past: { other: "-{0} d" } } }, hour: { displayName: "Hour", relative: { 0: "this hour" }, relativeTime: { future: { other: "+{0} h" }, past: { other: "-{0} h" } } }, minute: { displayName: "Minute", relative: { 0: "this minute" }, relativeTime: { future: { other: "+{0} min" }, past: { other: "-{0} min" } } }, second: { displayName: "Second", relative: { 0: "now" }, relativeTime: { future: { other: "+{0} s" }, past: { other: "-{0} s" } } } } }, { locale: "en-ER", parentLocale: "en-001" }, { locale: "en-FI", parentLocale: "en-150" }, { locale: "en-FJ", parentLocale: "en-001" }, { locale: "en-FK", parentLocale: "en-001" }, { locale: "en-FM", parentLocale: "en-001" }, { locale: "en-GB", parentLocale: "en-001" }, { locale: "en-GD", parentLocale: "en-001" }, { locale: "en-GG", parentLocale: "en-001" }, { locale: "en-GH", parentLocale: "en-001" }, { locale: "en-GI", parentLocale: "en-001" }, { locale: "en-GM", parentLocale: "en-001" }, { locale: "en-GU", parentLocale: "en" }, { locale: "en-GY", parentLocale: "en-001" }, { locale: "en-HK", parentLocale: "en-001" }, { locale: "en-IE", parentLocale: "en-001" }, { locale: "en-IL", parentLocale: "en-001" }, { locale: "en-IM", parentLocale: "en-001" }, { locale: "en-IN", parentLocale: "en-001" }, { locale: "en-IO", parentLocale: "en-001" }, { locale: "en-JE", parentLocale: "en-001" }, { locale: "en-JM", parentLocale: "en-001" }, { locale: "en-KE", parentLocale: "en-001" }, { locale: "en-KI", parentLocale: "en-001" }, { locale: "en-KN", parentLocale: "en-001" }, { locale: "en-KY", parentLocale: "en-001" }, { locale: "en-LC", parentLocale: "en-001" }, { locale: "en-LR", parentLocale: "en-001" }, { locale: "en-LS", parentLocale: "en-001" }, { locale: "en-MG", parentLocale: "en-001" }, { locale: "en-MH", parentLocale: "en" }, { locale: "en-MO", parentLocale: "en-001" }, { locale: "en-MP", parentLocale: "en" }, { locale: "en-MS", parentLocale: "en-001" }, { locale: "en-MT", parentLocale: "en-001" }, { locale: "en-MU", parentLocale: "en-001" }, { locale: "en-MW", parentLocale: "en-001" }, { locale: "en-MY", parentLocale: "en-001" }, { locale: "en-NA", parentLocale: "en-001" }, { locale: "en-NF", parentLocale: "en-001" }, { locale: "en-NG", parentLocale: "en-001" }, { locale: "en-NL", parentLocale: "en-150" }, { locale: "en-NR", parentLocale: "en-001" }, { locale: "en-NU", parentLocale: "en-001" }, { locale: "en-NZ", parentLocale: "en-001" }, { locale: "en-PG", parentLocale: "en-001" }, { locale: "en-PH", parentLocale: "en-001" }, { locale: "en-PK", parentLocale: "en-001" }, { locale: "en-PN", parentLocale: "en-001" }, { locale: "en-PR", parentLocale: "en" }, { locale: "en-PW", parentLocale: "en-001" }, { locale: "en-RW", parentLocale: "en-001" }, { locale: "en-SB", parentLocale: "en-001" }, { locale: "en-SC", parentLocale: "en-001" }, { locale: "en-SD", parentLocale: "en-001" }, { locale: "en-SE", parentLocale: "en-150" }, { locale: "en-SG", parentLocale: "en-001" }, { locale: "en-SH", parentLocale: "en-001" }, { locale: "en-SI", parentLocale: "en-150" }, { locale: "en-SL", parentLocale: "en-001" }, { locale: "en-SS", parentLocale: "en-001" }, { locale: "en-SX", parentLocale: "en-001" }, { locale: "en-SZ", parentLocale: "en-001" }, { locale: "en-Shaw", pluralRuleFunction: function pluralRuleFunction(e, a) {
	      return "other";
	    }, fields: { year: { displayName: "Year", relative: { 0: "this year", 1: "next year", "-1": "last year" }, relativeTime: { future: { other: "+{0} y" }, past: { other: "-{0} y" } } }, month: { displayName: "Month", relative: { 0: "this month", 1: "next month", "-1": "last month" }, relativeTime: { future: { other: "+{0} m" }, past: { other: "-{0} m" } } }, day: { displayName: "Day", relative: { 0: "today", 1: "tomorrow", "-1": "yesterday" }, relativeTime: { future: { other: "+{0} d" }, past: { other: "-{0} d" } } }, hour: { displayName: "Hour", relative: { 0: "this hour" }, relativeTime: { future: { other: "+{0} h" }, past: { other: "-{0} h" } } }, minute: { displayName: "Minute", relative: { 0: "this minute" }, relativeTime: { future: { other: "+{0} min" }, past: { other: "-{0} min" } } }, second: { displayName: "Second", relative: { 0: "now" }, relativeTime: { future: { other: "+{0} s" }, past: { other: "-{0} s" } } } } }, { locale: "en-TC", parentLocale: "en-001" }, { locale: "en-TK", parentLocale: "en-001" }, { locale: "en-TO", parentLocale: "en-001" }, { locale: "en-TT", parentLocale: "en-001" }, { locale: "en-TV", parentLocale: "en-001" }, { locale: "en-TZ", parentLocale: "en-001" }, { locale: "en-UG", parentLocale: "en-001" }, { locale: "en-UM", parentLocale: "en" }, { locale: "en-US", parentLocale: "en" }, { locale: "en-VC", parentLocale: "en-001" }, { locale: "en-VG", parentLocale: "en-001" }, { locale: "en-VI", parentLocale: "en" }, { locale: "en-VU", parentLocale: "en-001" }, { locale: "en-WS", parentLocale: "en-001" }, { locale: "en-ZA", parentLocale: "en-001" }, { locale: "en-ZM", parentLocale: "en-001" }, { locale: "en-ZW", parentLocale: "en-001" }];
	});

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (e, a) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = a() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.es = a());
	}(undefined, function () {
	  "use strict";
	  return [{ locale: "es", pluralRuleFunction: function pluralRuleFunction(e, a) {
	      return a ? "other" : 1 == e ? "one" : "other";
	    }, fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "anteayer", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-419", parentLocale: "es" }, { locale: "es-AR", parentLocale: "es-419" }, { locale: "es-BO", parentLocale: "es-419" }, { locale: "es-BR", parentLocale: "es-419" }, { locale: "es-BZ", parentLocale: "es-419" }, { locale: "es-CL", parentLocale: "es-419" }, { locale: "es-CO", parentLocale: "es-419" }, { locale: "es-CR", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antier", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-CU", parentLocale: "es-419" }, { locale: "es-DO", parentLocale: "es-419", fields: { year: { displayName: "Año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "Mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "Día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "anteayer", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "Minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "Segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-EA", parentLocale: "es" }, { locale: "es-EC", parentLocale: "es-419" }, { locale: "es-GQ", parentLocale: "es" }, { locale: "es-GT", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antier", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-HN", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antier", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-IC", parentLocale: "es" }, { locale: "es-MX", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el año próximo", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el mes próximo", "-1": "el mes pasado" }, relativeTime: { future: { one: "en {0} mes", other: "en {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antier", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-NI", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antier", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-PA", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antier", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-PE", parentLocale: "es-419" }, { locale: "es-PH", parentLocale: "es" }, { locale: "es-PR", parentLocale: "es-419" }, { locale: "es-PY", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antes de ayer", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-SV", parentLocale: "es-419", fields: { year: { displayName: "año", relative: { 0: "este año", 1: "el próximo año", "-1": "el año pasado" }, relativeTime: { future: { one: "dentro de {0} año", other: "dentro de {0} años" }, past: { one: "hace {0} año", other: "hace {0} años" } } }, month: { displayName: "mes", relative: { 0: "este mes", 1: "el próximo mes", "-1": "el mes pasado" }, relativeTime: { future: { one: "dentro de {0} mes", other: "dentro de {0} meses" }, past: { one: "hace {0} mes", other: "hace {0} meses" } } }, day: { displayName: "día", relative: { 0: "hoy", 1: "mañana", 2: "pasado mañana", "-2": "antier", "-1": "ayer" }, relativeTime: { future: { one: "dentro de {0} día", other: "dentro de {0} días" }, past: { one: "hace {0} día", other: "hace {0} días" } } }, hour: { displayName: "hora", relative: { 0: "esta hora" }, relativeTime: { future: { one: "dentro de {0} hora", other: "dentro de {0} horas" }, past: { one: "hace {0} hora", other: "hace {0} horas" } } }, minute: { displayName: "minuto", relative: { 0: "este minuto" }, relativeTime: { future: { one: "dentro de {0} minuto", other: "dentro de {0} minutos" }, past: { one: "hace {0} minuto", other: "hace {0} minutos" } } }, second: { displayName: "segundo", relative: { 0: "ahora" }, relativeTime: { future: { one: "dentro de {0} segundo", other: "dentro de {0} segundos" }, past: { one: "hace {0} segundo", other: "hace {0} segundos" } } } } }, { locale: "es-US", parentLocale: "es-419" }, { locale: "es-UY", parentLocale: "es-419" }, { locale: "es-VE", parentLocale: "es-419" }];
	});

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(625);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(129);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	
	exports.default = BrowserRouter;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(626);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(129);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	
	exports.default = HashRouter;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MemoryRouter = __webpack_require__(232);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(231);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(230);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Prompt = __webpack_require__(233);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Redirect = __webpack_require__(234);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StaticRouter = __webpack_require__(235);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Switch = __webpack_require__(236);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchPath = __webpack_require__(83);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withRouter = __webpack_require__(237);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 697 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isarray = __webpack_require__(697);
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp;
	module.exports.parse = parse;
	module.exports.compile = compile;
	module.exports.tokensToFunction = tokensToFunction;
	module.exports.tokensToRegExp = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	// Match escaped characters that would otherwise appear in future matches.
	// This allows the user to escape special characters that won't transform.
	'(\\\\.)',
	// Match Express-style parameters and un-named parameters with a prefix
	// and optional suffixes. Matches appear as:
	//
	// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse(str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue;
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens;
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile(str, options) {
	  return tokensToFunction(parse(str, options));
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty(str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	  });
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk(str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	  });
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction(tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (_typeof(tokens[i]) === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue;
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue;
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined');
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue;
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty');
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue;
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path;
	  };
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString(str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup(group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1');
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys(re, keys) {
	  re.keys = keys;
	  return re;
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags(options) {
	  return options.sensitive ? '' : 'i';
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp(path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys);
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp(path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys);
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp(path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options);
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp(tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */keys || options;
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys);
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp(path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */keys || options;
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */keys);
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
	  }
	
	  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
	}

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(614));
	var shallowEqual = _interopDefault(__webpack_require__(710));
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(58);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement("button", _extends({ key: "0", type: "button" }, prevArrowProps), " ", "Previous");
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement("button", _extends({ key: "1", type: "button" }, nextArrowProps), " ", "Next");
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement("ul", { style: { display: "block" } }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(58);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement("li", { key: i, className: className }, _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick }));
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(706);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _slider2.default;

/***/ },
/* 704 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(81);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(704);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(671);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(58);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(84);
	
	var _track = __webpack_require__(707);
	
	var _dots = __webpack_require__(702);
	
	var _arrows = __webpack_require__(700);
	
	var _resizeObserverPolyfill = __webpack_require__(709);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          currentSlide = _this$props.currentSlide,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react2.default.createElement("div", _extends({ ref: _this.listRefHandler }, listProps), _react2.default.createElement(_track.Track, _extends({ ref: _this.trackRefHandler }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(705);
	
	var _json2mq = __webpack_require__(670);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(701);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(582);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement("div", { key: 10 * i + j }, row));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement("div", { key: i, style: { width: currentWidth } }, newSlide));
	      } else {
	        newChildren.push(_react2.default.createElement("div", { key: i }, newSlide));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement("div", { className: className }, newChildren);
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(_innerSlider.InnerSlider, _extends({ ref: this.innerSliderRefHandler }, settings), newChildren);
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(58);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement("div", _extends({
	      className: "slick-track",
	      style: this.props.trackStyle
	    }, mouseEvents), slides);
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var m = __webpack_require__(56),
	    n = __webpack_require__(124),
	    p = __webpack_require__(77),
	    q = "function" === typeof Symbol && Symbol["for"],
	    r = q ? Symbol["for"]("react.element") : 60103,
	    t = q ? Symbol["for"]("react.portal") : 60106,
	    u = q ? Symbol["for"]("react.fragment") : 60107,
	    v = q ? Symbol["for"]("react.strict_mode") : 60108,
	    w = q ? Symbol["for"]("react.provider") : 60109,
	    x = q ? Symbol["for"]("react.context") : 60110,
	    y = q ? Symbol["for"]("react.async_mode") : 60111,
	    z = q ? Symbol["for"]("react.forward_ref") : 60112,
	    A = "function" === typeof Symbol && Symbol.iterator;function B(a) {
	  for (var b = arguments.length - 1, e = "Minified React error #" + a + "; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d" + a, c = 0; c < b; c++) {
	    e += "\x26args[]\x3d" + encodeURIComponent(arguments[c + 1]);
	  }b = Error(e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name = "Invariant Violation";b.framesToPop = 1;throw b;
	}
	var C = { isMounted: function isMounted() {
	    return !1;
	  }, enqueueForceUpdate: function enqueueForceUpdate() {}, enqueueReplaceState: function enqueueReplaceState() {}, enqueueSetState: function enqueueSetState() {} };function D(a, b, e) {
	  this.props = a;this.context = b;this.refs = n;this.updater = e || C;
	}D.prototype.isReactComponent = {};D.prototype.setState = function (a, b) {
	  "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) && "function" !== typeof a && null != a ? B("85") : void 0;this.updater.enqueueSetState(this, a, b, "setState");
	};D.prototype.forceUpdate = function (a) {
	  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
	};function E() {}
	E.prototype = D.prototype;function F(a, b, e) {
	  this.props = a;this.context = b;this.refs = n;this.updater = e || C;
	}var G = F.prototype = new E();G.constructor = F;m(G, D.prototype);G.isPureReactComponent = !0;var H = { current: null },
	    I = Object.prototype.hasOwnProperty,
	    J = { key: !0, ref: !0, __self: !0, __source: !0 };
	function K(a, b, e) {
	  var c = void 0,
	      d = {},
	      g = null,
	      h = null;if (null != b) for (c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b) {
	    I.call(b, c) && !J.hasOwnProperty(c) && (d[c] = b[c]);
	  }var f = arguments.length - 2;if (1 === f) d.children = e;else if (1 < f) {
	    for (var k = Array(f), l = 0; l < f; l++) {
	      k[l] = arguments[l + 2];
	    }d.children = k;
	  }if (a && a.defaultProps) for (c in f = a.defaultProps, f) {
	    void 0 === d[c] && (d[c] = f[c]);
	  }return { $$typeof: r, type: a, key: g, ref: h, props: d, _owner: H.current };
	}
	function L(a) {
	  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === r;
	}function escape(a) {
	  var b = { "\x3d": "\x3d0", ":": "\x3d2" };return "$" + ("" + a).replace(/[=:]/g, function (a) {
	    return b[a];
	  });
	}var M = /\/+/g,
	    N = [];function O(a, b, e, c) {
	  if (N.length) {
	    var d = N.pop();d.result = a;d.keyPrefix = b;d.func = e;d.context = c;d.count = 0;return d;
	  }return { result: a, keyPrefix: b, func: e, context: c, count: 0 };
	}function P(a) {
	  a.result = null;a.keyPrefix = null;a.func = null;a.context = null;a.count = 0;10 > N.length && N.push(a);
	}
	function Q(a, b, e, c) {
	  var d = typeof a === "undefined" ? "undefined" : _typeof(a);if ("undefined" === d || "boolean" === d) a = null;var g = !1;if (null === a) g = !0;else switch (d) {case "string":case "number":
	      g = !0;break;case "object":
	      switch (a.$$typeof) {case r:case t:
	          g = !0;}}if (g) return e(c, a, "" === b ? "." + R(a, 0) : b), 1;g = 0;b = "" === b ? "." : b + ":";if (Array.isArray(a)) for (var h = 0; h < a.length; h++) {
	    d = a[h];var f = b + R(d, h);g += Q(d, f, e, c);
	  } else if (null === a || "undefined" === typeof a ? f = null : (f = A && a[A] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), h = 0; !(d = a.next()).done;) {
	    d = d.value, f = b + R(d, h++), g += Q(d, f, e, c);
	  } else "object" === d && (e = "" + a, B("31", "[object Object]" === e ? "object with keys {" + Object.keys(a).join(", ") + "}" : e, ""));return g;
	}function R(a, b) {
	  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && null != a.key ? escape(a.key) : b.toString(36);
	}function S(a, b) {
	  a.func.call(a.context, b, a.count++);
	}
	function T(a, b, e) {
	  var c = a.result,
	      d = a.keyPrefix;a = a.func.call(a.context, b, a.count++);Array.isArray(a) ? U(a, c, e, p.thatReturnsArgument) : null != a && (L(a) && (b = d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(M, "$\x26/") + "/") + e, a = { $$typeof: r, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner }), c.push(a));
	}function U(a, b, e, c, d) {
	  var g = "";null != e && (g = ("" + e).replace(M, "$\x26/") + "/");b = O(b, g, c, d);null == a || Q(a, "", T, b);P(b);
	}
	var V = { Children: { map: function map(a, b, e) {
	      if (null == a) return a;var c = [];U(a, c, null, b, e);return c;
	    }, forEach: function forEach(a, b, e) {
	      if (null == a) return a;b = O(null, null, b, e);null == a || Q(a, "", S, b);P(b);
	    }, count: function count(a) {
	      return null == a ? 0 : Q(a, "", p.thatReturnsNull, null);
	    }, toArray: function toArray(a) {
	      var b = [];U(a, b, null, p.thatReturnsArgument);return b;
	    }, only: function only(a) {
	      L(a) ? void 0 : B("143");return a;
	    } }, createRef: function createRef() {
	    return { current: null };
	  }, Component: D, PureComponent: F, createContext: function createContext(a, b) {
	    void 0 === b && (b = null);a = { $$typeof: x,
	      _calculateChangedBits: b, _defaultValue: a, _currentValue: a, _changedBits: 0, Provider: null, Consumer: null };a.Provider = { $$typeof: w, _context: a };return a.Consumer = a;
	  }, forwardRef: function forwardRef(a) {
	    return { $$typeof: z, render: a };
	  }, Fragment: u, StrictMode: v, unstable_AsyncMode: y, createElement: K, cloneElement: function cloneElement(a, b, e) {
	    var c = void 0,
	        d = m({}, a.props),
	        g = a.key,
	        h = a.ref,
	        f = a._owner;if (null != b) {
	      void 0 !== b.ref && (h = b.ref, f = H.current);void 0 !== b.key && (g = "" + b.key);var k = void 0;a.type && a.type.defaultProps && (k = a.type.defaultProps);for (c in b) {
	        I.call(b, c) && !J.hasOwnProperty(c) && (d[c] = void 0 === b[c] && void 0 !== k ? k[c] : b[c]);
	      }
	    }c = arguments.length - 2;if (1 === c) d.children = e;else if (1 < c) {
	      k = Array(c);for (var l = 0; l < c; l++) {
	        k[l] = arguments[l + 2];
	      }d.children = k;
	    }return { $$typeof: r, type: a.type, key: g, ref: h, props: d, _owner: f };
	  }, createFactory: function createFactory(a) {
	    var b = K.bind(null, a);b.type = a;return b;
	  }, isValidElement: L, version: "16.3.1", __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { ReactCurrentOwner: H, assign: m } },
	    W = Object.freeze({ default: V }),
	    X = W && V || W;
	module.exports = X["default"] ? X["default"] : X;

/***/ },
/* 709 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if (ctx === void 0) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties(anonymous.prototype, prototypeAccessors);
	
	        return anonymous;
	    }();
	}();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	}();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) {
	        return setTimeout(function () {
	            return callback(Date.now());
	        }, 1000 / 60);
	    };
	}();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function throttle(callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function ResizeObserverController() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) {
	        return observer.broadcastActive();
	    });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	    var propertyName = ref.propertyName;if (propertyName === void 0) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = function defineConfigurable(target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	};
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = function getWindowOf(target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	};
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [],
	        len = arguments.length - 1;
	    while (len-- > 0) {
	        positions[len] = arguments[len + 1];
	    }return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) {
	            return target instanceof getWindowOf(target).SVGGraphicsElement;
	        };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) {
	        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
	    };
	}();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function ResizeObservation(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function ResizeObserverEntry(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function ResizeObserverSPI(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	    var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function ResizeObserver(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	}();
	
	exports.default = index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 710 */
/***/ function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || !objA || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || ret === void 0 && valueA !== valueB) {
	      return false;
	    }
	  }
	
	  return true;
	};

/***/ },
/* 711 */
/***/ function(module, exports) {

	'use strict';
	
	var camel2hyphen = function camel2hyphen(str) {
	  return str.replace(/[A-Z]/g, function (match) {
	    return '-' + match.toLowerCase();
	  }).toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 712 */
/***/ function(module, exports) {

	'use strict';
	
	(function (self) {
	  'use strict';
	
	  if (self.fetch) {
	    return;
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && function () {
	      try {
	        new Blob();
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  if (support.arrayBuffer) {
	    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];
	
	    var isDataView = function isDataView(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj);
	    };
	
	    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
	    };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name');
	    }
	    return name.toLowerCase();
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value;
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function next() {
	        var value = items.shift();
	        return { done: value === undefined, value: value };
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function () {
	        return iterator;
	      };
	    }
	
	    return iterator;
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function (value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function (name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function (name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ',' + value : value;
	  };
	
	  Headers.prototype['delete'] = function (name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function (name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null;
	  };
	
	  Headers.prototype.has = function (name) {
	    return this.map.hasOwnProperty(normalizeName(name));
	  };
	
	  Headers.prototype.set = function (name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function (callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.values = function () {
	    var items = [];
	    this.forEach(function (value) {
	      items.push(value);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.entries = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items);
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'));
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function (resolve, reject) {
	      reader.onload = function () {
	        resolve(reader.result);
	      };
	      reader.onerror = function () {
	        reject(reader.error);
	      };
	    });
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise;
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise;
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('');
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0);
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer;
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function (body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        throw new Error('unsupported BodyInit type');
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function () {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected;
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob);
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob');
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]));
	        }
	      };
	
	      this.arrayBuffer = function () {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer);
	        }
	      };
	    }
	
	    this.text = function () {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected;
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob);
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text');
	      } else {
	        return Promise.resolve(this._bodyText);
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function () {
	        return this.text().then(decode);
	      };
	    }
	
	    this.json = function () {
	      return this.text().then(JSON.parse);
	    };
	
	    return this;
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method;
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read');
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests');
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function () {
	    return new Request(this, { body: this._bodyInit });
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body.trim().split('&').forEach(function (bytes) {
	      if (bytes) {
	        var split = bytes.split('=');
	        var name = split.shift().replace(/\+/g, ' ');
	        var value = split.join('=').replace(/\+/g, ' ');
	        form.append(decodeURIComponent(name), decodeURIComponent(value));
	      }
	    });
	    return form;
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    rawHeaders.split(/\r?\n/).forEach(function (line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers;
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = 'status' in options ? options.status : 200;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function () {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    });
	  };
	
	  Response.error = function () {
	    var response = new Response(null, { status: 0, statusText: '' });
	    response.type = 'error';
	    return response;
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function (url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code');
	    }
	
	    return new Response(null, { status: status, headers: { location: url } });
	  };
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function (input, init) {
	    return new Promise(function (resolve, reject) {
	      var request = new Request(input, init);
	      var xhr = new XMLHttpRequest();
	
	      xhr.onload = function () {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function (value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    });
	  };
	  self.fetch.polyfill = true;
	})(typeof self !== 'undefined' ? self : undefined);

/***/ },
/* 713 */
241,
/* 714 */
241,
/* 715 */
241,
/* 716 */
241,
/* 717 */
241,
/* 718 */
241,
/* 719 */
241,
/* 720 */
241,
/* 721 */
241,
/* 722 */
241,
/* 723 */
241,
/* 724 */
241,
/* 725 */
241,
/* 726 */
241,
/* 727 */
241,
/* 728 */
241,
/* 729 */
241,
/* 730 */
241,
/* 731 */
/***/ function(module, exports) {

	module.exports = {
		"app.consent.header": "Consent",
		"app.login.content": "Enter your access code to receive your results.",
		"app.login.header": "Login",
		"app.login.submit": "Submit",
		"app.login.failed": "Incorrect access code.  Please try again.",
		"app.login.thankyou": "Thank you!",
		"app.conclusion.thankyou": "Thank you! Message sent.",
		"app.conclusion.error": "Error. Message not sent.",
		"app.survey.thankyou": "Thank you! Survey responses sent.",
		"app.survey.error": "Error. Survey responses not sent.",
		"app.pages.avatar.contents": "The face will represent you in the report!",
		"app.pages.avatar.instructions": "Choose your face",
		"app.pages.summary.header": "You were tested for six types of chemicals:",
		"app.pages.summary.title": "Summary of your personal results",
		"app.pages.toc.title": "Things to know",
		"app.pages.water_summary.header": "Your water was tested for two types of chemicals.",
		"app.pages.water_summary.title": "Summary of your water results",
		"app.title": "My <strong>IKIDS</strong><br>Report",
		"app.pages.summary.desc": "Click each chemical group to see your complete results. When you’re done, continue to the rest of the report.",
		"chemicals.text.actions": "What can I do?",
		"chemicals.text.description": "What are they?",
		"chemicals.text.health": "Health",
		"chemicals.text.results": "Your Results",
		"print": "Print",
		"download": "Download",
		"back_to_summary": "Back to Summary",
		"close": "Close",
		"desc_more_info": "Learn more",
		"desc_photos": "Photos",
		"get_started": "Get started",
		"learn_more": "Learn more",
		"loading": "Loading...",
		"menu": "Menu",
		"menu.faq": "Common Questions",
		"menu.close": "Close Menu",
		"menu.logout": "Logout",
		"more": "More",
		"next": "Next",
		"show_more": "Show More",
		"show_less": "Show Less",
		"non_detects": "{value} samples ({percent}%) did not have a detectable level of {chemical}.",
		"non_detect_values": "Non-detect values",
		"non_detects_less_than_1": "less than 1",
		"not_detected": "Not detected",
		"in_urine": "in urine",
		"in_water": "in water",
		"nodetecttext_yaxis": "Not detected",
		"other_participants": "Other participants",
		"other_participants_content": "{samples} women were tested for {chemical}.",
		"page.about.title": "About IKIDS",
		"page.conclusion.header": "Conclusion",
		"page.healthandchemicals.title": "Chemicals and Health",
		"page.moreinfo.header": "More Info",
		"page.overallstudyresults.header": "Overall Study Results",
		"personal_results": "Personal Results",
		"overview": "Overview",
		"switch_language": "Cambiar al Español",
		"previous": "Previous",
		"us_median": "XXX Media de Estados Unidos",
		"us_median_content": "XXX La mitad de las mujeres entre 18-40 años en los Estados Unidos tienen menos que {value} μg/L de {chemical}.",
		"learn_more_and_improve": "Learn more and find ways to improve",
		"no_results_for": "You did not have results for:",
		"also_higher_levels_for": "You also had <span class='higher-levels'>higher levels</span> than other women for:",
		"same_or_lower_levels": "Your levels were <span class='same-or-lower'>similar or lower</span> than other women for:",
		"what_you_can_do": "Jump to tips to lower your exposure",
		"your_level": "Your level of {chemical} was {value} {units}",
		"your_level_in_visit": "in visit",
		"your_level_visit": "Visit",
		"your_level_not_detected": "You did not have a detectable level of {chemical} in your sample.",
		"your_results": "Your result:",
		"your_results.chemical": "Chemical",
		"your_results.measurement": "Measurement",
		"your_results.visit": "Visit",
		"your_results.group": "Group",
		"learn_more_about_this_chemical": "Learn more about this chemical",
		"click_to_expand_graph": "Click on any graph to see an expanded version with more details.",
		"click_to_learn_more": "Tap each part of the graph to learn more",
		"more_ways_to_help": "More ways to help",
		"page.graphreading.title": "How to read your graphs",
		"graphreading.title": "How to read your graphs",
		"graphreading.description": "<p>You’re about to see your personal results!</p><p>First let’s practice with one chemical. This 5 minute tour will help you read your results.</p>",
		"graphreading.skip_tour": "Skip tour",
		"graphreading.page0.youre_about_to_find_out": "You’re about to find out your level of <strong>{chemical}</strong>.",
		"graphreading.page0.chemical_is_a_type_of": "{chemical} is a type of {icon} {group} chemical. ",
		"graphreading.page0.how_much_chemical_was_in_your_sample": "How much {chemical} do you guess was in your sample compared to others in the study?",
		"graphreading.page0.you_guessed_more": "You guessed: <strong>more</strong> {chemical} than others in the study. You’ll find out soon if you were right!",
		"graphreading.page0.you_guessed_similar": "You guessed: <strong>similar</strong> {chemical} to others in the study. You’ll find out soon if you were right!",
		"graphreading.page0.you_guessed_less": "You guessed: <strong>less</strong> {chemical} than others in the study. You’ll find out soon if you were right!",
		"graphreading.page0.pfas.description": "These chemicals are found in stain- and water-resistant textiles, grease-repellent food packaging, and some cosmetics.",
		"graphreading.page0.pbdes.description": "These chemicals are found in stain- and water-resistant textiles, grease-repellent food packaging, and some cosmetics.",
		"graphreading.page0.bisphenols.description": "These chemicals are found in some plastics, the linings of food and drink cans, and thermal receipt paper.",
		"graphreading.page0.antimicrobials.description": "These chemicals kill bacteria and other microbes. They can be found in products that are advertised as “antimicrobial,” and they used to be in some soaps.",
		"graphreading.page0.chlorinated_phenols.description": "These chemicals can come from mothballs and certain herbicides. Scientists are still learning about other ways that people get exposed to these chemicals.",
		"graphreading.page0.parabens.description": "Parabens are sometimes added to personal care products (like creams and makeup) to stop fungus, bacteria, and other microbes from growing.",
		"graphreading.page0.uv_filters.description": "UV filters are found in many sunscreens and other cosmetic products, as well as in some plastics and protective coatings. These chemicals absorb damaging UV radiation.",
		"graphreading.page1.graph_shows_other_women": "This graph shows the {chemical} results of all the <strong>other women</strong> in IKIDS.",
		"graphreading.page1.each_blue_circle": "Each blue circle {icon} is one woman’s result.",
		"graphreading.page1.which_woman_had_the_most_chemical": "A, B, and C are three different women. Which woman had the <strong>most</strong> {chemical}?",
		"graphreading.page1.other_women_correct": "<span class='bold-blue'>Good job!</span> The answer is <strong>C</strong> because results are higher to the right side of the graph.",
		"graphreading.page1.other_women_try_again": "Try again. {answer} didn’t have the most.",
		"graphreading.page1.other_women_tip": "<i>Tip:</i> The numbers at the bottom show that results are higher to the right side of the graph.",
		"graphreading.page1.other_women_incorrect": "<strong>C</strong> has the most {chemical}. You can tell because her dot is the farthest right. The numbers at the bottom show that the right side is higher.",
		"graphreading.page2.each_grey_circle": "Each gray circle {icon} is one woman in IKIDS who didn’t have {chemical} or whose level of {chemical} was so low that the lab couldn’t detect it.",
		"graphreading.page2.each_grey_circle2": "Each gray circle <span class='nondetect-icon'></span> is one woman in IKIDS who didn’t have {chemical} or whose level of {chemical} was so low that the lab couldn’t detect it.",
		"graphreading.page2.which_woman_was_nondetected": "A, B, and C are three different women. Which woman did <strong>not</strong> have {chemical} detected in her?",
		"graphreading.page2.nondetects_correct": "<span class='bold-blue'>Good job!</span> People who didn’t have {chemical} detected are gray circles to the left of the graph.",
		"graphreading.page2.nondetects_try_again": "Try again. {answer} does have {chemical} detected. ",
		"graphreading.page2.nondetects_tip": "<i>Tip:</i> Women who didn’t have {chemical} detected are gray circles to the left of the graph.",
		"graphreading.page2.nondetects_incorrect": "<strong>A</strong> did not have {chemical} detected. You can tell because her dot is to the left of the graph in the area labeled “Not detected.” Other women who did not have {chemical} detected are gray circles.",
		"graphreading.page3.getting_your_result": "Now you’re getting your result for {chemical}.",
		"graphreading.page3.tips_to_lower_exposure": " You’ll find tips to lower your exposure to {chemical} with your other {icon} {group} results.",
		"graphreading.page3.face_is_your_personal_result": "The face {icon} is your personal result",
		"graphreading.page3.your_result_compared_to_others": "Now that you see your result, how much {chemical} do you think was in your sample compared to others in the study?",
		"graphreading.page3.your_result_correct.more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was <strong>higher</strong> than most others in the study.",
		"graphreading.page3.your_result_correct.similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was <strong>similar</strong> to most others in the study.",
		"graphreading.page3.your_result_correct.less": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was <strong>less</strong> than most others in the study.",
		"graphreading.page3.your_result_correct.less,similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat lower but still similar to many people in the study.",
		"graphreading.page3.your_result_correct.similar,more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat higher but still similar to many people in the study.",
		"graphreading.page3.your_result_not_quite": "Not quite.",
		"graphreading.page3.your_result_tip": "<i>Tip:</i> Look to see if your result is to the left, right, or in the middle of most of the blue circles. The blue area is thicker where there are more people.",
		"graphreading.page3.your_result_incorrect.more": "You had <strong>more</strong> {chemical} than most others in the study. Your result is to the right of most of the blue and gray circles, so your level was higher than most others.",
		"graphreading.page3.your_result_incorrect.similar": "You had a <strong>similar</strong> amount of {chemical} as most others in the study. Your result is towards the middle where the blue circles are thicker, so your level was similar to most others.",
		"graphreading.page3.your_result_incorrect.less": "You had <strong>less</strong> {chemical} than most others in the study. Your result is to the left of most of the blue circles, so your level was lower than most others.",
		"graphreading.page4.the_flag_icon_shows": "The flag {icon} shows the median (“middle” level) for the United States. Half of Americans have levels below the median and half have levels above the median.",
		"graphreading.page4.your_result_compared_to_median": "How did your level of {chemical} compare to the <strong>U.S. median</strong>?",
		"graphreading.page4.my_level_is": "My level is:",
		"graphreading.page4.us_median_correct.more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} is more than the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} is similar to the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.less": "<span class='bold-blue'>That's right.</span> Your level of {chemical} is less than the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.less,similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat lower but still similar to the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.similar,more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat higher but still similar to the typical level found in other Americans.",
		"graphreading.page4.us_median_not_quite": "Not quite.",
		"graphreading.page4.us_median_tip": "<i>Tip:</i> Compare your face to the blue line with the flag.",
		"graphreading.page4.us_median_incorrect.more": "Your level of {chemical} is <strong>more</strong> than the typical level in other Americans. You can tell because the face is to the right of the U.S. flag.",
		"graphreading.page4.us_median_incorrect.similar": "Your level of {chemical} is <strong>similar</strong> to the typical level in other Americans. You can tell because the face is on top of the U.S. flag.",
		"graphreading.page4.us_median_incorrect.less": "Your level of {chemical} is <strong>less</strong> than the typical level in other Americans. You can tell because the face is to the left of the U.S. flag.",
		"graphreading.page5.click_to_expand": "Click the {chemical} to see a bigger version of the graph and get your exact level.",
		"graphreading.page5.tap_each_part": "Tap the icons and each part of the graph to learn more",
		"graphreading.page5.ug/mL": "The units <strong>μg/L</strong> are “micrograms of the chemical in a liter of urine.” A microgram is one millionth of a gram.",
		"graphreading.page5.ng/mL": "The units <strong>ng/mL</strong> are “nanograms of the chemical in a milliliter of urine”. A nanogram is one billionth of a gram, and a milliliter is one thousandth of a liter. Although this may seem like a very small amount, reactions in the body, such as hormone activity, can take place at similarly low levels.",
		"graphreading.page6.initial_guess.more": "Before you saw your result, you guessed that you had <strong>more</strong> {chemical} than others in the study.",
		"graphreading.page6.initial_guess.similar": "Before you saw your result, you guessed that you had <strong>similar</strong> {chemical} to others in the study.",
		"graphreading.page6.initial_guess.less": "Before you saw your result, you guessed that you had <strong>less</strong> {chemical} than others in the study.",
		"graphreading.page6.graph_showed.more": " Your graph showed that you had <strong>more</strong> {chemical}.",
		"graphreading.page6.graph_showed.similar": " Your graph showed that you had <strong>similar</strong> levels of {chemical}.",
		"graphreading.page6.graph_showed.less": " Your graph showed that you had <strong>less</strong> {chemical}.",
		"graphreading.page6.graph_showed.similar,more": " Your graph showed that level was <strong>somewhat higher but still similar</strong> to many people in the study.",
		"graphreading.page6.graph_showed.less,similar": " Your graph showed that level was <strong>somewhat lower but still similar</strong> to many people in the study.",
		"graphreading.page6.many_people_are_surprised": "That’s ok, lots of people are surprised to learn their level!",
		"graphreading.page6.you_guessed_correctly": "You guessed correctly!",
		"graphreading.page6.initial_guess_corrent.more": "Before you saw your result, you guessed that you had <strong>more</strong> {chemical} than others in the study. You guessed correctly!",
		"graphreading.page6.initial_guess_corrent.similar": "Before you saw your result, you guessed that you had <strong>similar</strong> {chemical} to others in the study. You guessed correctly!",
		"graphreading.page6.initial_guess_corrent.less": "Before you saw your result, you guessed that you had <strong>less</strong> {chemical} than others in the study. You guessed correctly!",
		"graphreading.page6.ways_people_get_exposed": "Here are some ways that people get exposed to {group}. Which ones apply to you?",
		"graphreading.page6.pfas.source0": "I own stain-resistant carpet or furniture or use stain-resistant spray-treatments.",
		"graphreading.page6.pfas.source1": "I wear stain-resistant clothing.",
		"graphreading.page6.pfas.source2": "I eat food from grease-repellant packaging, like microwave popcorn or fast-food.",
		"graphreading.page6.pfas.source3": "I use lotions or cosmetics.",
		"graphreading.page6.pfas.source4": "My water company told me they found PFAS in my drinking water.",
		"graphreading.page6.pfas.source5": "I live near an airport, military base, or fire-training area.",
		"graphreading.page6.pbdes.source0": "I own stain-resistant carpet or furniture or use stain-resistant spray-treatments.",
		"graphreading.page6.pbdes.source1": "I wear stain-resistant clothing.",
		"graphreading.page6.pbdes.source2": "I eat food from grease-repellant packaging, like microwave popcorn or fast-food.",
		"graphreading.page6.pbdes.source3": "I use lotions or cosmetics.",
		"graphreading.page6.pbdes.source4": "My water company told me they found PFAS in my drinking water.",
		"graphreading.page6.pbdes.source5": "I live near an airport, military base, or fire-training area.",
		"graphreading.page6.bisphenols.numSources": 4,
		"graphreading.page6.bisphenols.source0": "I eat food or drinks from metal cans.",
		"graphreading.page6.bisphenols.source1": "I use a coffee maker that has a plastic reservoir or dripper.",
		"graphreading.page6.bisphenols.source2": "I use a hard plastic or aluminum water bottle.",
		"graphreading.page6.bisphenols.source3": "I choose products labeled “BPA-free” when I can.",
		"graphreading.page6.antimicrobials.numSources": 2,
		"graphreading.page6.antimicrobials.source0": "I have household products that are advertised as “antimicrobial” (like kitchenware, toys, or athletic clothing).",
		"graphreading.page6.antimicrobials.source1": "I wear makeup or deodorant.",
		"graphreading.page6.chlorinated_phenols.numSources": 3,
		"graphreading.page6.chlorinated_phenols.source0": "I use mothballs to protect my clothes.",
		"graphreading.page6.chlorinated_phenols.source1": "I don’t usually eat organic food.",
		"graphreading.page6.chlorinated_phenols.source2": "I use herbicides to control weeds in my lawn or garden.",
		"graphreading.page6.parabens.numSources": 1,
		"graphreading.page6.parabens.source0": "I use personal care products, such as shampoo, lotion, styling gel, or cosmetics.",
		"graphreading.page6.uv_filters.numSources": 2,
		"graphreading.page6.uv_filters.source0": "I wear sunscreen, lotions, or makeup that have a chemical UV filter.",
		"graphreading.page6.uv_filters.source1": "I use plastic containers for food and drinks.",
		"graphreading.page6.noneOfTheAbove": "None of the above",
		"graphreading.page6.anotherIdea": "I have another idea:",
		"graphreading.page7.these_actions_lower_exposure": "These actions can help lower your exposure to {group}. Which ones do you want to do?",
		"graphreading.page7.thanks_for_taking_action": "Thank you for choosing to take action! You’ll find more tips with your other {icon} {group} results.",
		"graphreading.page7.i_do_this": "I do this",
		"graphreading.page7.i_want_to": "I want to",
		"graphreading.page7.not_now": "Not now",
		"graphreading.page7.pfas.action_default0": "Vacuum with a HEPA filter or wet mop to keep dust levels low in my home.",
		"graphreading.page7.pfas.action_default1": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.pfas.action_0": "Stop using stain-resistant or waterproof spray treatments.",
		"graphreading.page7.pfas.action_1": "Avoid buying new clothing labeled stain-resistant.",
		"graphreading.page7.pfas.action_2": "Choose fresh foods instead of packaged foods when I can.",
		"graphreading.page7.pfas.action_3": "Avoid personal care products that have PTFE or other “fluoro” ingredients on the label.",
		"graphreading.page7.pfas.action_4": "Call my state or congressional representative and ask them to support stricter limits for PFAS in drinking water.",
		"graphreading.page7.pfas.action_5": "Ask my water company to test for PFAS.",
		"graphreading.page7.pfas.action_none0": "Connect with an organization working to reduce harmful chemical exposures like xxx.",
		"graphreading.page7.pfas.action_none1": "Sign a petition, call an elected representative, go to a march or rally, etc.",
		"graphreading.page7.pbdes.action_default0": "Vacuum with a HEPA filter or wet mop to keep dust levels low in my home.",
		"graphreading.page7.pbdes.action_default1": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.pbdes.action_0": "Stop using stain-resistant or waterproof spray treatments.",
		"graphreading.page7.pbdes.action_1": "Avoid buying new clothing labeled stain-resistant.",
		"graphreading.page7.pbdes.action_2": "Choose fresh foods instead of packaged foods when I can.",
		"graphreading.page7.pbdes.action_3": "Avoid personal care products that have PTFE or other “fluoro” ingredients on the label.",
		"graphreading.page7.pbdes.action_4": "Call my state or congressional representative and ask them to support stricter limits for PFAS in drinking water.",
		"graphreading.page7.pbdes.action_5": "Ask my water company to test for PFAS.",
		"graphreading.page7.pbdes.action_none0": "Connect with an organization working to reduce harmful chemical exposures like xxx.",
		"graphreading.page7.pbdes.action_none1": "Sign a petition, call an elected representative, go to a march or rally, etc.",
		"graphreading.page7.bisphenols.default_numActions": 2,
		"graphreading.page7.bisphenols.action_defaultA": "Decline sales receipts when I can, and choose email receipts when available.",
		"graphreading.page7.bisphenols.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.bisphenols.action_0": "Eat more fresh or frozen foods, and opt for drinks in glass bottles instead of cans.",
		"graphreading.page7.bisphenols.action_1": "Bew coffee “pour-over” style with a stainless steel, glass, or ceramic dripper (the funnel where your filter goes).",
		"graphreading.page7.bisphenols.action_2": "Use a water bottle made from stainless steel or glass.",
		"graphreading.page7.bisphenols.action_3": "Be aware that plastics and food cans labeled “BPA-free” may contain BPS, BPF, or other chemical substitutes.",
		"graphreading.page7.bisphenols.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.antimicrobials.default_numActions": 2,
		"graphreading.page7.antimicrobials.action_defaultA": "Wash my hands with regular soap and water, which is just as effective at removing germs as “antibacterial” soap.",
		"graphreading.page7.antimicrobials.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.antimicrobials.action_0": "Avoid household products that are advertised as “antimicrobial” (like kitchenware, toys, or athletic clothing).",
		"graphreading.page7.antimicrobials.action_1": "Avoid personal care products that have triclosan or triclocarban in the ingredients.",
		"graphreading.page7.antimicrobials.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.chlorinated_phenols.default_numActions": 2,
		"graphreading.page7.chlorinated_phenols.action_defaultA": "Take off my shoes at the door so that outdoor pollutants stay outside the home.",
		"graphreading.page7.chlorinated_phenols.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.chlorinated_phenols.action_0": "Get rid of mothballs and air out clothing that was stored with them. Instead, clean woolens at the end of the season and store them in sealed containers or bags.",
		"graphreading.page7.chlorinated_phenols.action_1": "Eat more organic foods when possible.",
		"graphreading.page7.chlorinated_phenols.action_2": "Try using organic practices to care for my lawn or garden.",
		"graphreading.page7.chlorinated_phenols.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.parabens.source0_numActions": 4,
		"graphreading.page7.parabens.action_default": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.parabens.action_0A": "Check the label and avoid personal care products that list parabens as ingredients.",
		"graphreading.page7.parabens.action_0B": "Try moisturizing with natural oils, such as sunflower seed oil or shea butter.",
		"graphreading.page7.parabens.action_0C": "Simplify my hygiene and beauty routine to use fewer products.",
		"graphreading.page7.parabens.action_0D": "Ask my favorite brands to choose safer chemicals for their products.",
		"graphreading.page7.parabens.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.uv_filters.default_numActions": 2,
		"graphreading.page7.uv_filters.source0_numActions": 2,
		"graphreading.page7.uv_filters.action_defaultA": "Choose shade, hats, and tightly woven fabric cover-ups for sun protection when I can.",
		"graphreading.page7.uv_filters.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.uv_filters.action_0A": "Try sunscreen or lotion with a mineral-based active ingredient like zinc oxide or titanium dioxide.",
		"graphreading.page7.uv_filters.action_0B": "Wash off sunscreen once you are out of the sun.",
		"graphreading.page7.uv_filters.action_1": "Use stainless steel or glass containers for food and drinks.",
		"graphreading.page7.uv_filters.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page8.end_tutorial_all_correct_try1": "Great job! The rest of the report will have graphs and information for all the chemicals measured in your sample.",
		"graphreading.page8.end_tutorial_not_correct_try1": "Still have questions? Try doing the tour again with another chemical.",
		"graphreading.page8.end_tutorial_most_correct_try2": "Great job! The rest of the report will have graphs and information for all the chemicals measured in your sample.",
		"graphreading.page8.end_tutorial_not_correct_try2": "You completed the tour. If you still have questions about how to read your graph, you can call us at <strong><a style='white-space:nowrap;color:black' href='tel:217-333-5814'>(217) 333-5814</a></strong> or email us at <strong><a style='white-space:nowrap;color:black' href='mailto:ikids-research@illinois.edu'>ikids-research@illinois.edu</a></strong>.",
		"graphreading.page8.view_all_results": "View all results",
		"graphreading.page8.view_all_results_detail": "No thanks, show me all of my results",
		"graphreading.page8.take_the_tour_again": "Take the tour again",
		"graphreading.page8.take_the_tour_again_detail": "Take the tour again with another chemical",
		"graphreading.answers.less": "less",
		"graphreading.answers.similar": "similar",
		"graphreading.answers.more": "more",
		"graphreading.answers.a": "A",
		"graphreading.answers.b": "B",
		"graphreading.answers.c": "C",
		"graphreading.answers.next": "Next",
		"unused_final_item": "no comma"
	};

/***/ },
/* 732 */
/***/ function(module, exports) {

	module.exports = {
		"app.consent.header": "Consent",
		"app.login.content": "Enter your access code to receive your results.",
		"app.login.header": "Login",
		"app.login.submit": "Submit",
		"app.login.failed": "Incorrect access code.  Please try again.",
		"app.login.thankyou": "Thank you!",
		"app.conclusion.thankyou": "Thank you! Message sent.",
		"app.conclusion.error": "Error. Message not sent.",
		"app.survey.thankyou": "Thank you! Survey responses sent.",
		"app.survey.error": "Error. Survey responses not sent.",
		"app.pages.avatar.contents": "The face will represent you in the report!",
		"app.pages.avatar.instructions": "Choose your face",
		"app.pages.summary.header": "You were tested for six types of chemicals:",
		"app.pages.summary.title": "Summary of your personal results",
		"app.pages.toc.title": "Things to know",
		"app.pages.water_summary.header": "Your water was tested for two types of chemicals.",
		"app.pages.water_summary.title": "Summary of your water results",
		"app.title": "My <strong>IKIDS</strong><br>Report",
		"app.pages.summary.desc": "Click each chemical group to see your complete results. When you’re done, continue to the rest of the report.",
		"chemicals.text.actions": "What can I do?",
		"chemicals.text.description": "What are they?",
		"chemicals.text.health": "Health",
		"chemicals.text.results": "Your Results",
		"print": "Print",
		"download": "Download",
		"back_to_summary": "Back to Summary",
		"close": "Close",
		"desc_more_info": "Learn more",
		"desc_photos": "Photos",
		"get_started": "Get started",
		"learn_more": "Learn more",
		"loading": "Loading...",
		"menu": "Menu",
		"menu.faq": "Common Questions",
		"menu.close": "Close Menu",
		"menu.logout": "Logout",
		"more": "More",
		"next": "Next",
		"show_more": "Show More",
		"show_less": "Show Less",
		"non_detects": "{value} samples ({percent}%) did not have a detectable level of {chemical}.",
		"non_detect_values": "Non-detect values",
		"non_detects_less_than_1": "less than 1",
		"not_detected": "Not detected",
		"in_urine": "in urine",
		"in_water": "in water",
		"nodetecttext_yaxis": "Not detected",
		"other_participants": "Other participants",
		"other_participants_content": "{samples} women were tested for {chemical}.",
		"page.about.title": "About IKIDS",
		"page.conclusion.header": "Conclusion",
		"page.healthandchemicals.title": "Chemicals and Health",
		"page.moreinfo.header": "More Info",
		"page.overallstudyresults.header": "Overall Study Results",
		"personal_results": "Personal Results",
		"overview": "Overview",
		"switch_language": "Cambiar al Español",
		"previous": "Previous",
		"us_median": "XXX Media de Estados Unidos",
		"us_median_content": "XXX La mitad de las mujeres entre 18-40 años en los Estados Unidos tienen menos que {value} μg/L de {chemical}.",
		"learn_more_and_improve": "Learn more and find ways to improve",
		"no_results_for": "You did not have results for:",
		"also_higher_levels_for": "You also had <span class='higher-levels'>higher levels</span> than other women for:",
		"same_or_lower_levels": "Your levels were <span class='same-or-lower'>similar or lower</span> than other women for:",
		"what_you_can_do": "Jump to tips to lower your exposure",
		"your_level": "Your level of {chemical} was {value} {units}",
		"your_level_in_visit": "in visit",
		"your_level_visit": "Visit",
		"your_level_not_detected": "You did not have a detectable level of {chemical} in your sample.",
		"your_results": "Your result:",
		"your_results.chemical": "Chemical",
		"your_results.measurement": "Measurement",
		"your_results.visit": "Visit",
		"your_results.group": "Group",
		"learn_more_about_this_chemical": "Learn more about this chemical",
		"click_to_expand_graph": "Click on any graph to see an expanded version with more details.",
		"click_to_learn_more": "Tap each part of the graph to learn more",
		"more_ways_to_help": "More ways to help",
		"page.graphreading.title": "How to read your graphs",
		"graphreading.title": "How to read your graphs",
		"graphreading.description": "<p>You’re about to see your personal results!</p><p>First let’s practice with one chemical. This 5 minute tour will help you read your results.</p>",
		"graphreading.skip_tour": "Skip tour",
		"graphreading.page0.youre_about_to_find_out": "You’re about to find out your level of <strong>{chemical}</strong>.",
		"graphreading.page0.chemical_is_a_type_of": "{chemical} is a type of {icon} {group} chemical. ",
		"graphreading.page0.how_much_chemical_was_in_your_sample": "How much {chemical} do you guess was in your sample compared to others in the study?",
		"graphreading.page0.you_guessed_more": "You guessed: <strong>more</strong> {chemical} than others in the study. You’ll find out soon if you were right!",
		"graphreading.page0.you_guessed_similar": "You guessed: <strong>similar</strong> {chemical} to others in the study. You’ll find out soon if you were right!",
		"graphreading.page0.you_guessed_less": "You guessed: <strong>less</strong> {chemical} than others in the study. You’ll find out soon if you were right!",
		"graphreading.page0.pfas.description": "These chemicals are found in stain- and water-resistant textiles, grease-repellent food packaging, and some cosmetics.",
		"graphreading.page0.pbdes.description": "These chemicals are found in stain- and water-resistant textiles, grease-repellent food packaging, and some cosmetics.",
		"graphreading.page0.bisphenols.description": "These chemicals are found in some plastics, the linings of food and drink cans, and thermal receipt paper.",
		"graphreading.page0.antimicrobials.description": "These chemicals kill bacteria and other microbes. They can be found in products that are advertised as “antimicrobial,” and they used to be in some soaps.",
		"graphreading.page0.chlorinated_phenols.description": "These chemicals can come from mothballs and certain herbicides. Scientists are still learning about other ways that people get exposed to these chemicals.",
		"graphreading.page0.parabens.description": "Parabens are sometimes added to personal care products (like creams and makeup) to stop fungus, bacteria, and other microbes from growing.",
		"graphreading.page0.uv_filters.description": "UV filters are found in many sunscreens and other cosmetic products, as well as in some plastics and protective coatings. These chemicals absorb damaging UV radiation.",
		"graphreading.page1.graph_shows_other_women": "This graph shows the {chemical} results of all the <strong>other women</strong> in IKIDS.",
		"graphreading.page1.each_blue_circle": "Each blue circle {icon} is one woman’s result.",
		"graphreading.page1.which_woman_had_the_most_chemical": "A, B, and C are three different women. Which woman had the <strong>most</strong> {chemical}?",
		"graphreading.page1.other_women_correct": "<span class='bold-blue'>Good job!</span> The answer is <strong>C</strong> because results are higher to the right side of the graph.",
		"graphreading.page1.other_women_try_again": "Try again. {answer} didn’t have the most.",
		"graphreading.page1.other_women_tip": "<i>Tip:</i> The numbers at the bottom show that results are higher to the right side of the graph.",
		"graphreading.page1.other_women_incorrect": "<strong>C</strong> has the most {chemical}. You can tell because her dot is the farthest right. The numbers at the bottom show that the right side is higher.",
		"graphreading.page2.each_grey_circle": "Each gray circle {icon} is one woman in IKIDS who didn’t have {chemical} or whose level of {chemical} was so low that the lab couldn’t detect it.",
		"graphreading.page2.each_grey_circle2": "Each gray circle <span class='nondetect-icon'></span> is one woman in IKIDS who didn’t have {chemical} or whose level of {chemical} was so low that the lab couldn’t detect it.",
		"graphreading.page2.which_woman_was_nondetected": "A, B, and C are three different women. Which woman did <strong>not</strong> have {chemical} detected in her?",
		"graphreading.page2.nondetects_correct": "<span class='bold-blue'>Good job!</span> People who didn’t have {chemical} detected are gray circles to the left of the graph.",
		"graphreading.page2.nondetects_try_again": "Try again. {answer} does have {chemical} detected. ",
		"graphreading.page2.nondetects_tip": "<i>Tip:</i> Women who didn’t have {chemical} detected are gray circles to the left of the graph.",
		"graphreading.page2.nondetects_incorrect": "<strong>A</strong> did not have {chemical} detected. You can tell because her dot is to the left of the graph in the area labeled “Not detected.” Other women who did not have {chemical} detected are gray circles.",
		"graphreading.page3.getting_your_result": "Now you’re getting your result for {chemical}.",
		"graphreading.page3.tips_to_lower_exposure": " You’ll find tips to lower your exposure to {chemical} with your other {icon} {group} results.",
		"graphreading.page3.face_is_your_personal_result": "The face {icon} is your personal result",
		"graphreading.page3.your_result_compared_to_others": "Now that you see your result, how much {chemical} do you think was in your sample compared to others in the study?",
		"graphreading.page3.your_result_correct.more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was <strong>higher</strong> than most others in the study.",
		"graphreading.page3.your_result_correct.similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was <strong>similar</strong> to most others in the study.",
		"graphreading.page3.your_result_correct.less": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was <strong>less</strong> than most others in the study.",
		"graphreading.page3.your_result_correct.less,similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat lower but still similar to many people in the study.",
		"graphreading.page3.your_result_correct.similar,more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat higher but still similar to many people in the study.",
		"graphreading.page3.your_result_not_quite": "Not quite.",
		"graphreading.page3.your_result_tip": "<i>Tip:</i> Look to see if your result is to the left, right, or in the middle of most of the blue circles. The blue area is thicker where there are more people.",
		"graphreading.page3.your_result_incorrect.more": "You had <strong>more</strong> {chemical} than most others in the study. Your result is to the right of most of the blue and gray circles, so your level was higher than most others.",
		"graphreading.page3.your_result_incorrect.similar": "You had a <strong>similar</strong> amount of {chemical} as most others in the study. Your result is towards the middle where the blue circles are thicker, so your level was similar to most others.",
		"graphreading.page3.your_result_incorrect.less": "You had <strong>less</strong> {chemical} than most others in the study. Your result is to the left of most of the blue circles, so your level was lower than most others.",
		"graphreading.page4.the_flag_icon_shows": "The flag {icon} shows the median (“middle” level) for the United States. Half of Americans have levels below the median and half have levels above the median.",
		"graphreading.page4.your_result_compared_to_median": "How did your level of {chemical} compare to the <strong>U.S. median</strong>?",
		"graphreading.page4.my_level_is": "My level is:",
		"graphreading.page4.us_median_correct.more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} is more than the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} is similar to the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.less": "<span class='bold-blue'>That's right.</span> Your level of {chemical} is less than the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.less,similar": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat lower but still similar to the typical level found in other Americans.",
		"graphreading.page4.us_median_correct.similar,more": "<span class='bold-blue'>That's right.</span> Your level of {chemical} was somewhat higher but still similar to the typical level found in other Americans.",
		"graphreading.page4.us_median_not_quite": "Not quite.",
		"graphreading.page4.us_median_tip": "<i>Tip:</i> Compare your face to the blue line with the flag.",
		"graphreading.page4.us_median_incorrect.more": "Your level of {chemical} is <strong>more</strong> than the typical level in other Americans. You can tell because the face is to the right of the U.S. flag.",
		"graphreading.page4.us_median_incorrect.similar": "Your level of {chemical} is <strong>similar</strong> to the typical level in other Americans. You can tell because the face is on top of the U.S. flag.",
		"graphreading.page4.us_median_incorrect.less": "Your level of {chemical} is <strong>less</strong> than the typical level in other Americans. You can tell because the face is to the left of the U.S. flag.",
		"graphreading.page5.click_to_expand": "Click the {chemical} to see a bigger version of the graph and get your exact level.",
		"graphreading.page5.tap_each_part": "Tap the icons and each part of the graph to learn more",
		"graphreading.page5.ug/mL": "The units <strong>μg/L</strong> are “micrograms of the chemical in a liter of urine.” A microgram is one millionth of a gram.",
		"graphreading.page5.ng/mL": "The units <strong>ng/mL</strong> are “nanograms of the chemical in a milliliter of urine”. A nanogram is one billionth of a gram, and a milliliter is one thousandth of a liter. Although this may seem like a very small amount, reactions in the body, such as hormone activity, can take place at similarly low levels.",
		"graphreading.page6.initial_guess.more": "Before you saw your result, you guessed that you had <strong>more</strong> {chemical} than others in the study.",
		"graphreading.page6.initial_guess.similar": "Before you saw your result, you guessed that you had <strong>similar</strong> {chemical} to others in the study.",
		"graphreading.page6.initial_guess.less": "Before you saw your result, you guessed that you had <strong>less</strong> {chemical} than others in the study.",
		"graphreading.page6.graph_showed.more": " Your graph showed that you had <strong>more</strong> {chemical}.",
		"graphreading.page6.graph_showed.similar": " Your graph showed that you had <strong>similar</strong> levels of {chemical}.",
		"graphreading.page6.graph_showed.less": " Your graph showed that you had <strong>less</strong> {chemical}.",
		"graphreading.page6.graph_showed.similar,more": " Your graph showed that level was <strong>somewhat higher but still similar</strong> to many people in the study.",
		"graphreading.page6.graph_showed.less,similar": " Your graph showed that level was <strong>somewhat lower but still similar</strong> to many people in the study.",
		"graphreading.page6.many_people_are_surprised": "That’s ok, lots of people are surprised to learn their level!",
		"graphreading.page6.you_guessed_correctly": "You guessed correctly!",
		"graphreading.page6.initial_guess_corrent.more": "Before you saw your result, you guessed that you had <strong>more</strong> {chemical} than others in the study. You guessed correctly!",
		"graphreading.page6.initial_guess_corrent.similar": "Before you saw your result, you guessed that you had <strong>similar</strong> {chemical} to others in the study. You guessed correctly!",
		"graphreading.page6.initial_guess_corrent.less": "Before you saw your result, you guessed that you had <strong>less</strong> {chemical} than others in the study. You guessed correctly!",
		"graphreading.page6.ways_people_get_exposed": "Here are some ways that people get exposed to {group}. Which ones apply to you?",
		"graphreading.page6.pfas.source0": "I own stain-resistant carpet or furniture or use stain-resistant spray-treatments.",
		"graphreading.page6.pfas.source1": "I wear stain-resistant clothing.",
		"graphreading.page6.pfas.source2": "I eat food from grease-repellant packaging, like microwave popcorn or fast-food.",
		"graphreading.page6.pfas.source3": "I use lotions or cosmetics.",
		"graphreading.page6.pfas.source4": "My water company told me they found PFAS in my drinking water.",
		"graphreading.page6.pfas.source5": "I live near an airport, military base, or fire-training area.",
		"graphreading.page6.pbdes.source0": "I own stain-resistant carpet or furniture or use stain-resistant spray-treatments.",
		"graphreading.page6.pbdes.source1": "I wear stain-resistant clothing.",
		"graphreading.page6.pbdes.source2": "I eat food from grease-repellant packaging, like microwave popcorn or fast-food.",
		"graphreading.page6.pbdes.source3": "I use lotions or cosmetics.",
		"graphreading.page6.pbdes.source4": "My water company told me they found PFAS in my drinking water.",
		"graphreading.page6.pbdes.source5": "I live near an airport, military base, or fire-training area.",
		"graphreading.page6.bisphenols.numSources": 4,
		"graphreading.page6.bisphenols.source0": "I eat food or drinks from metal cans.",
		"graphreading.page6.bisphenols.source1": "I use a coffee maker that has a plastic reservoir or dripper.",
		"graphreading.page6.bisphenols.source2": "I use a hard plastic or aluminum water bottle.",
		"graphreading.page6.bisphenols.source3": "I choose products labeled “BPA-free” when I can.",
		"graphreading.page6.antimicrobials.numSources": 2,
		"graphreading.page6.antimicrobials.source0": "I have household products that are advertised as “antimicrobial” (like kitchenware, toys, or athletic clothing).",
		"graphreading.page6.antimicrobials.source1": "I wear makeup or deodorant.",
		"graphreading.page6.chlorinated_phenols.numSources": 3,
		"graphreading.page6.chlorinated_phenols.source0": "I use mothballs to protect my clothes.",
		"graphreading.page6.chlorinated_phenols.source1": "I don’t usually eat organic food.",
		"graphreading.page6.chlorinated_phenols.source2": "I use herbicides to control weeds in my lawn or garden.",
		"graphreading.page6.parabens.numSources": 1,
		"graphreading.page6.parabens.source0": "I use personal care products, such as shampoo, lotion, styling gel, or cosmetics.",
		"graphreading.page6.uv_filters.numSources": 2,
		"graphreading.page6.uv_filters.source0": "I wear sunscreen, lotions, or makeup that have a chemical UV filter.",
		"graphreading.page6.uv_filters.source1": "I use plastic containers for food and drinks.",
		"graphreading.page6.noneOfTheAbove": "None of the above",
		"graphreading.page6.anotherIdea": "I have another idea:",
		"graphreading.page7.these_actions_lower_exposure": "These actions can help lower your exposure to {group}. Which ones do you want to do?",
		"graphreading.page7.thanks_for_taking_action": "Thank you for choosing to take action! You’ll find more tips with your other {icon} {group} results.",
		"graphreading.page7.i_do_this": "I do this",
		"graphreading.page7.i_want_to": "I want to",
		"graphreading.page7.not_now": "Not now",
		"graphreading.page7.pfas.action_default0": "Vacuum with a HEPA filter or wet mop to keep dust levels low in my home.",
		"graphreading.page7.pfas.action_default1": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.pfas.action_0": "Stop using stain-resistant or waterproof spray treatments.",
		"graphreading.page7.pfas.action_1": "Avoid buying new clothing labeled stain-resistant.",
		"graphreading.page7.pfas.action_2": "Choose fresh foods instead of packaged foods when I can.",
		"graphreading.page7.pfas.action_3": "Avoid personal care products that have PTFE or other “fluoro” ingredients on the label.",
		"graphreading.page7.pfas.action_4": "Call my state or congressional representative and ask them to support stricter limits for PFAS in drinking water.",
		"graphreading.page7.pfas.action_5": "Ask my water company to test for PFAS.",
		"graphreading.page7.pfas.action_none0": "Connect with an organization working to reduce harmful chemical exposures like xxx.",
		"graphreading.page7.pfas.action_none1": "Sign a petition, call an elected representative, go to a march or rally, etc.",
		"graphreading.page7.pbdes.action_default0": "Vacuum with a HEPA filter or wet mop to keep dust levels low in my home.",
		"graphreading.page7.pbdes.action_default1": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.pbdes.action_0": "Stop using stain-resistant or waterproof spray treatments.",
		"graphreading.page7.pbdes.action_1": "Avoid buying new clothing labeled stain-resistant.",
		"graphreading.page7.pbdes.action_2": "Choose fresh foods instead of packaged foods when I can.",
		"graphreading.page7.pbdes.action_3": "Avoid personal care products that have PTFE or other “fluoro” ingredients on the label.",
		"graphreading.page7.pbdes.action_4": "Call my state or congressional representative and ask them to support stricter limits for PFAS in drinking water.",
		"graphreading.page7.pbdes.action_5": "Ask my water company to test for PFAS.",
		"graphreading.page7.pbdes.action_none0": "Connect with an organization working to reduce harmful chemical exposures like xxx.",
		"graphreading.page7.pbdes.action_none1": "Sign a petition, call an elected representative, go to a march or rally, etc.",
		"graphreading.page7.bisphenols.default_numActions": 2,
		"graphreading.page7.bisphenols.action_defaultA": "Decline sales receipts when I can, and choose email receipts when available.",
		"graphreading.page7.bisphenols.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.bisphenols.action_0": "Eat more fresh or frozen foods, and opt for drinks in glass bottles instead of cans.",
		"graphreading.page7.bisphenols.action_1": "Bew coffee “pour-over” style with a stainless steel, glass, or ceramic dripper (the funnel where your filter goes).",
		"graphreading.page7.bisphenols.action_2": "Use a water bottle made from stainless steel or glass.",
		"graphreading.page7.bisphenols.action_3": "Be aware that plastics and food cans labeled “BPA-free” may contain BPS, BPF, or other chemical substitutes.",
		"graphreading.page7.bisphenols.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.antimicrobials.default_numActions": 2,
		"graphreading.page7.antimicrobials.action_defaultA": "Wash my hands with regular soap and water, which is just as effective at removing germs as “antibacterial” soap.",
		"graphreading.page7.antimicrobials.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.antimicrobials.action_0": "Avoid household products that are advertised as “antimicrobial” (like kitchenware, toys, or athletic clothing).",
		"graphreading.page7.antimicrobials.action_1": "Avoid personal care products that have triclosan or triclocarban in the ingredients.",
		"graphreading.page7.antimicrobials.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.chlorinated_phenols.default_numActions": 2,
		"graphreading.page7.chlorinated_phenols.action_defaultA": "Take off my shoes at the door so that outdoor pollutants stay outside the home.",
		"graphreading.page7.chlorinated_phenols.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.chlorinated_phenols.action_0": "Get rid of mothballs and air out clothing that was stored with them. Instead, clean woolens at the end of the season and store them in sealed containers or bags.",
		"graphreading.page7.chlorinated_phenols.action_1": "Eat more organic foods when possible.",
		"graphreading.page7.chlorinated_phenols.action_2": "Try using organic practices to care for my lawn or garden.",
		"graphreading.page7.chlorinated_phenols.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.parabens.source0_numActions": 2,
		"graphreading.page7.parabens.action_default": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.parabens.action_0A": "Check the label and avoid personal care products that list parabens as ingredients.",
		"graphreading.page7.parabens.action_0B": "Simplify my hygiene and beauty routine to use fewer products.",
		"graphreading.page7.parabens.action_0D": "Ask my favorite brands to choose safer chemicals for their products.",
		"graphreading.page7.parabens.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page7.uv_filters.default_numActions": 2,
		"graphreading.page7.uv_filters.source0_numActions": 2,
		"graphreading.page7.uv_filters.action_defaultA": "Choose shade, hats, and tightly woven fabric cover-ups for sun protection when I can.",
		"graphreading.page7.uv_filters.action_defaultB": "Vote for candidates who support more protective laws on toxic chemicals.",
		"graphreading.page7.uv_filters.action_0A": "Try sunscreen or lotion with a mineral-based active ingredient like zinc oxide or titanium dioxide.",
		"graphreading.page7.uv_filters.action_0B": "Wash off sunscreen once you are out of the sun.",
		"graphreading.page7.uv_filters.action_1": "Use stainless steel or glass containers for food and drinks.",
		"graphreading.page7.uv_filters.action_none": "Connect with an organization working to reduce harmful chemical exposures.",
		"graphreading.page8.end_tutorial_all_correct_try1": "Great job! The rest of the report will have graphs and information for all the chemicals measured in your sample.",
		"graphreading.page8.end_tutorial_not_correct_try1": "Still have questions? Try doing the tour again with another chemical.",
		"graphreading.page8.end_tutorial_most_correct_try2": "Great job! The rest of the report will have graphs and information for all the chemicals measured in your sample.",
		"graphreading.page8.end_tutorial_not_correct_try2": "You completed the tour. If you still have questions about how to read your graph, you can call us at <strong><a style='white-space:nowrap;color:black' href='tel:217-333-5814'>(217) 333-5814</a></strong> or email us at <strong><a style='white-space:nowrap;color:black' href='mailto:ikids-research@illinois.edu'>ikids-research@illinois.edu</a></strong>.",
		"graphreading.page8.view_all_results": "View all results",
		"graphreading.page8.view_all_results_detail": "No thanks, show me all of my results",
		"graphreading.page8.take_the_tour_again": "Take the tour again",
		"graphreading.page8.take_the_tour_again_detail": "Take the tour again with another chemical",
		"graphreading.answers.less": "less",
		"graphreading.answers.similar": "similar",
		"graphreading.answers.more": "more",
		"graphreading.answers.a": "A",
		"graphreading.answers.b": "B",
		"graphreading.answers.c": "C",
		"graphreading.answers.next": "Next",
		"unused_final_item": "no comma"
	};

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/content_en.1fe9a6ef.yaml";

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/content_es.bddca3f1.yaml";

/***/ },
/* 735 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 736 */
735,
/* 737 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _en = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* jslint esnext: true */
	
	_core2.default.__addLocaleData(_en2.default);
	_core2.default.defaultLocale = 'en';
	
	exports.default = _core2.default;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.d1bb15ce.js